import _toArray from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _defineProperty from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _construct from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import _assertThisInitialized from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _wrapNativeSuper from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _slicedToArray from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/usr/home/bus-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var _siPrefixes, _modifiers2;
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(typeof e + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
var _marked = /*#__PURE__*/_regenerator().m(iterate),
  _marked2 = /*#__PURE__*/_regenerator().m(iterateReverseArray),
  _marked3 = /*#__PURE__*/_regenerator().m(_mapIterable),
  _marked4 = /*#__PURE__*/_regenerator().m(_childrenIter);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n3 = 0, F = function F() {}; return { s: F, n: function n() { return _n3 >= r.length ? { done: !0 } : { done: !1, value: r[_n3++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __knownSymbol = function __knownSymbol(name, symbol) {
  return (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
};
var __pow = Math.pow;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __superGet = function __superGet(cls, obj, key) {
  return __reflectGet(__getProtoOf(cls), key, obj);
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var __await = function __await(promise, isYieldStar) {
  this[0] = promise;
  this[1] = isYieldStar;
};
var __yieldStar = function __yieldStar(value) {
  var obj = value[__knownSymbol("asyncIterator")];
  var isAwait = false;
  var method;
  var it = {};
  if (obj == null) {
    obj = value[__knownSymbol("iterator")]();
    method = function method(k) {
      return it[k] = function (x) {
        return obj[k](x);
      };
    };
  } else {
    obj = obj.call(value);
    method = function method(k) {
      return it[k] = function (v) {
        if (isAwait) {
          isAwait = false;
          if (k === "throw") throw v;
          return v;
        }
        isAwait = true;
        return {
          done: false,
          value: new __await(new Promise(function (resolve) {
            var x = obj[k](v);
            if (!(x instanceof Object)) throw TypeError("Object expected");
            resolve(x);
          }), 1)
        };
      };
    };
  }
  return it[__knownSymbol("iterator")] = function () {
    return it;
  }, method("next"), "throw" in obj ? method("throw") : it.throw = function (x) {
    throw x;
  }, "return" in obj && method("return"), it;
};

// packages/ag-charts-community/src/options/chart/errorBarOptions.ts
var AgErrorBarSupportedSeriesTypes = ["bar", "line", "scatter"];

// packages/ag-charts-community/src/options/chart/navigatorOptions.ts
var __MINI_CHART_SERIES_OPTIONS = {};
var __VERIFY_MINI_CHART_SERIES_OPTIONS = void 0;
__VERIFY_MINI_CHART_SERIES_OPTIONS = __MINI_CHART_SERIES_OPTIONS;

// packages/ag-charts-community/src/options/chart/tooltipOptions.ts
var AgTooltipPositionType = /* @__PURE__ */function (AgTooltipPositionType2) {
  AgTooltipPositionType2["POINTER"] = "pointer";
  AgTooltipPositionType2["NODE"] = "node";
  AgTooltipPositionType2["TOP"] = "top";
  AgTooltipPositionType2["RIGHT"] = "right";
  AgTooltipPositionType2["BOTTOM"] = "bottom";
  AgTooltipPositionType2["LEFT"] = "left";
  AgTooltipPositionType2["TOP_LEFT"] = "top-left";
  AgTooltipPositionType2["TOP_RIGHT"] = "top-right";
  AgTooltipPositionType2["BOTTOM_RIGHT"] = "bottom-right";
  AgTooltipPositionType2["BOTTOM_LEFT"] = "bottom-left";
  return AgTooltipPositionType2;
}(AgTooltipPositionType || {});

// packages/ag-charts-community/src/options/chart/themeOptions.ts
var __THEME_OVERRIDES = {};
var __VERIFY_THEME_OVERRIDES = void 0;
__VERIFY_THEME_OVERRIDES = __THEME_OVERRIDES;

// packages/ag-charts-community/src/options/agChartOptions.ts
var __FORCE_MODULE_DETECTION = 0;

// packages/ag-charts-community/src/util/time/index.ts
var time_exports = {};
__export(time_exports, {
  day: function day() {
    return _day;
  },
  friday: function friday() {
    return _friday;
  },
  hour: function hour() {
    return _hour;
  },
  millisecond: function millisecond() {
    return _millisecond;
  },
  minute: function minute() {
    return _minute;
  },
  monday: function monday() {
    return _monday;
  },
  month: function month() {
    return _month;
  },
  saturday: function saturday() {
    return _saturday;
  },
  second: function second() {
    return _second;
  },
  sunday: function sunday() {
    return _sunday;
  },
  thursday: function thursday() {
    return _thursday;
  },
  tuesday: function tuesday() {
    return _tuesday;
  },
  utcDay: function utcDay() {
    return _utcDay;
  },
  utcHour: function utcHour() {
    return _utcHour;
  },
  utcMinute: function utcMinute() {
    return _utcMinute;
  },
  utcMonth: function utcMonth() {
    return _utcMonth;
  },
  utcYear: function utcYear() {
    return _utcYear;
  },
  wednesday: function wednesday() {
    return _wednesday;
  },
  year: function year() {
    return _year;
  }
});

// packages/ag-charts-community/src/util/function.ts
var doOnceState = /* @__PURE__ */new Map();
function doOnce(func, key) {
  if (doOnceState.has(key)) return;
  doOnceState.set(key, true);
  func();
}
doOnce.clear = function () {
  return doOnceState.clear();
};
function identity(x) {
  return x;
}
function iterate() {
  var _len,
    iterators,
    _key,
    _i2,
    _iterators,
    iterator,
    _args = arguments;
  return _regenerator().w(function (_context) {
    while (1) switch (_context.n) {
      case 0:
        for (_len = _args.length, iterators = new Array(_len), _key = 0; _key < _len; _key++) {
          iterators[_key] = _args[_key];
        }
        _i2 = 0, _iterators = iterators;
      case 1:
        if (!(_i2 < _iterators.length)) {
          _context.n = 3;
          break;
        }
        iterator = _iterators[_i2];
        return _context.d(_regeneratorValues(__yieldStar(iterator)), 2);
      case 2:
        _i2++;
        _context.n = 1;
        break;
      case 3:
        return _context.a(2);
    }
  }, _marked);
}
function iterateReverseArray(array) {
  var j;
  return _regenerator().w(function (_context2) {
    while (1) switch (_context2.n) {
      case 0:
        j = array.length - 1;
      case 1:
        if (!(j >= 0)) {
          _context2.n = 3;
          break;
        }
        _context2.n = 2;
        return array[j];
      case 2:
        j--;
        _context2.n = 1;
        break;
      case 3:
        return _context2.a(2);
    }
  }, _marked2);
}
function throttle(callback) {
  var waitMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var _ref = options != null ? options : {},
    _ref$leading = _ref.leading,
    leading = _ref$leading === void 0 ? true : _ref$leading,
    _ref$trailing = _ref.trailing,
    trailing = _ref$trailing === void 0 ? true : _ref$trailing;
  var timerId;
  var lastArgs;
  var shouldWait = false;
  function timeoutHandler() {
    if (trailing && lastArgs) {
      timerId = setTimeout(timeoutHandler, waitMs);
      callback.apply(void 0, _toConsumableArray(lastArgs));
    } else {
      shouldWait = false;
    }
    lastArgs = null;
  }
  function throttleCallback() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (shouldWait) {
      lastArgs = args;
    } else {
      shouldWait = true;
      timerId = setTimeout(timeoutHandler, waitMs);
      if (leading) {
        callback.apply(void 0, args);
      } else {
        lastArgs = args;
      }
    }
  }
  return Object.assign(throttleCallback, {
    cancel: function cancel() {
      clearTimeout(timerId);
      shouldWait = false;
      lastArgs = null;
    }
  });
}
function joinFunctions() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }
  return function () {
    for (var _i3 = 0, _fns = fns; _i3 < _fns.length; _i3++) {
      var fn = _fns[_i3];
      fn();
    }
  };
}

// packages/ag-charts-community/src/util/logger.ts
var _Logger = {
  log: function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
  },
  warn: function warn(message) {
    var _console2;
    for (var _len4 = arguments.length, logContent = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      logContent[_key4 - 1] = arguments[_key4];
    }
    (_console2 = console).warn.apply(_console2, ["AG Charts - ".concat(message)].concat(logContent));
  },
  error: function error(message) {
    for (var _len5 = arguments.length, logContent = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      logContent[_key5 - 1] = arguments[_key5];
    }
    if (typeof message === "object") {
      var _console3;
      (_console3 = console).error.apply(_console3, ["AG Charts error", message].concat(logContent));
    } else {
      var _console4;
      (_console4 = console).error.apply(_console4, ["AG Charts - ".concat(message)].concat(logContent));
    }
  },
  table: function table() {
    var _console5;
    (_console5 = console).table.apply(_console5, arguments);
  },
  warnOnce: function warnOnce(message) {
    for (var _len6 = arguments.length, logContent = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      logContent[_key6 - 1] = arguments[_key6];
    }
    doOnce(function () {
      return _Logger.warn.apply(_Logger, [message].concat(logContent));
    }, "Logger.warn: ".concat(message));
  },
  errorOnce: function errorOnce(message) {
    for (var _len7 = arguments.length, logContent = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
      logContent[_key7 - 1] = arguments[_key7];
    }
    doOnce(function () {
      return _Logger.error.apply(_Logger, [message].concat(logContent));
    }, "Logger.error: ".concat(message));
  }
};

// packages/ag-charts-community/src/util/time/interval.ts
var TimeInterval = /*#__PURE__*/function () {
  function TimeInterval(_encode, _decode, _rangeCallback) {
    _classCallCheck(this, TimeInterval);
    this._encode = _encode;
    this._decode = _decode;
    this._rangeCallback = _rangeCallback;
  }
  /**
   * Returns a new date representing the latest interval boundary date before or equal to date.
   * For example, `day.floor(date)` typically returns 12:00 AM local time on the given date.
   * @param date
   */
  _createClass(TimeInterval, [{
    key: "floor",
    value: function floor(date) {
      var d = new Date(date);
      var e = this._encode(d);
      return this._decode(e);
    }
    /**
     * Returns a new date representing the earliest interval boundary date after or equal to date.
     * @param date
     */
  }, {
    key: "ceil",
    value: function ceil(date) {
      var d = new Date(Number(date) - 1);
      var e = this._encode(d);
      return this._decode(e + 1);
    }
    /**
     * Returns an array of dates representing every interval boundary after or equal to start (inclusive) and before stop (exclusive).
     * @param start Range start.
     * @param stop Range end.
     * @param extend If specified, the requested range will be extended to the closest "nice" values.
     */
  }, {
    key: "range",
    value: function range(start, stop, extend) {
      var _a;
      var rangeCallback = (_a = this._rangeCallback) == null ? void 0 : _a.call(this, start, stop);
      var e0 = this._encode(extend ? this.floor(start) : this.ceil(start));
      var e1 = this._encode(extend ? this.ceil(stop) : this.floor(stop));
      if (e1 < e0) {
        return [];
      }
      var range3 = [];
      for (var e = e0; e <= e1; e++) {
        var d = this._decode(e);
        range3.push(d);
      }
      rangeCallback == null ? void 0 : rangeCallback();
      return range3;
    }
  }]);
  return TimeInterval;
}();
var CountableTimeInterval = /*#__PURE__*/function (_TimeInterval) {
  _inherits(CountableTimeInterval, _TimeInterval);
  function CountableTimeInterval() {
    _classCallCheck(this, CountableTimeInterval);
    return _possibleConstructorReturn(this, _getPrototypeOf(CountableTimeInterval).apply(this, arguments));
  }
  _createClass(CountableTimeInterval, [{
    key: "getOffset",
    value: function getOffset(snapTo, step) {
      var s = typeof snapTo === "number" || snapTo instanceof Date ? this._encode(new Date(snapTo)) : 0;
      return Math.floor(s) % step;
    }
    /**
     * Returns a filtered view of this interval representing every step'th date.
     * It can be a number of minutes, hours, days etc.
     * Must be a positive integer.
     * @param step
     */
  }, {
    key: "every",
    value: function every(step, options) {
      var _this = this;
      var offset4 = 0;
      var rangeCallback;
      var unsafeStep = step;
      step = Math.max(1, Math.round(step));
      if (unsafeStep !== step) {
        _Logger.warnOnce("interval step of [".concat(unsafeStep, "] rounded to [").concat(step, "]."));
      }
      var _ref2 = options != null ? options : {},
        _ref2$snapTo = _ref2.snapTo,
        snapTo = _ref2$snapTo === void 0 ? "start" : _ref2$snapTo;
      if (typeof snapTo === "string") {
        var initialOffset = offset4;
        rangeCallback = function rangeCallback(start, stop) {
          var s = snapTo === "start" ? start : stop;
          offset4 = _this.getOffset(s, step);
          return function () {
            return offset4 = initialOffset;
          };
        };
      } else if (typeof snapTo === "number") {
        offset4 = this.getOffset(new Date(snapTo), step);
      } else if (snapTo instanceof Date) {
        offset4 = this.getOffset(snapTo, step);
      }
      var encode13 = function encode13(date) {
        var e = _this._encode(date);
        return Math.floor((e - offset4) / step);
      };
      var decode13 = function decode13(encoded) {
        return _this._decode(encoded * step + offset4);
      };
      return new TimeInterval(encode13, decode13, rangeCallback);
    }
  }]);
  return CountableTimeInterval;
}(TimeInterval);

// packages/ag-charts-community/src/util/time/millisecond.ts
function encode(date) {
  return date.getTime();
}
function decode(encoded) {
  return new Date(encoded);
}
var _millisecond = new CountableTimeInterval(encode, decode);
var millisecond_default = _millisecond;

// packages/ag-charts-community/src/util/time/duration.ts
var epochYear = (/* @__PURE__ */new Date(0)).getFullYear();
var durationSecond = 1e3;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

// packages/ag-charts-community/src/util/time/second.ts
var offset = (/* @__PURE__ */new Date()).getTimezoneOffset() * durationMinute;
function encode2(date) {
  return Math.floor((date.getTime() - offset) / durationSecond);
}
function decode2(encoded) {
  return new Date(offset + encoded * durationSecond);
}
var _second = new CountableTimeInterval(encode2, decode2);
var second_default = _second;

// packages/ag-charts-community/src/util/time/minute.ts
var offset2 = (/* @__PURE__ */new Date()).getTimezoneOffset() * durationMinute;
function encode3(date) {
  return Math.floor((date.getTime() - offset2) / durationMinute);
}
function decode3(encoded) {
  return new Date(offset2 + encoded * durationMinute);
}
var _minute = new CountableTimeInterval(encode3, decode3);
var minute_default = _minute;

// packages/ag-charts-community/src/util/time/hour.ts
var offset3 = (/* @__PURE__ */new Date()).getTimezoneOffset() * durationMinute;
function encode4(date) {
  return Math.floor((date.getTime() - offset3) / durationHour);
}
function decode4(encoded) {
  return new Date(offset3 + encoded * durationHour);
}
var _hour = new CountableTimeInterval(encode4, decode4);
var hour_default = _hour;

// packages/ag-charts-community/src/util/time/day.ts
function encode5(date) {
  var tzOffsetMs = date.getTimezoneOffset() * durationMinute;
  return Math.floor((date.getTime() - tzOffsetMs) / durationDay);
}
function decode5(encoded) {
  var d = new Date(1970, 0, 1);
  d.setDate(d.getDate() + encoded);
  return d;
}
var _day = new CountableTimeInterval(encode5, decode5);
var day_default = _day;

// packages/ag-charts-community/src/util/time/week.ts
function weekday(weekStart) {
  var thursday2 = 4;
  var dayShift = (7 + weekStart - thursday2) % 7;
  function encode13(date) {
    var tzOffsetMs = date.getTimezoneOffset() * durationMinute;
    return Math.floor((date.getTime() - tzOffsetMs) / durationWeek - dayShift / 7);
  }
  function decode13(encoded) {
    var d = new Date(1970, 0, 1);
    d.setDate(d.getDate() + encoded * 7 + dayShift);
    return d;
  }
  return new CountableTimeInterval(encode13, decode13);
}
var _sunday = weekday(0);
var _monday = weekday(1);
var _tuesday = weekday(2);
var _wednesday = weekday(3);
var _thursday = weekday(4);
var _friday = weekday(5);
var _saturday = weekday(6);
var week_default = _sunday;

// packages/ag-charts-community/src/util/time/month.ts
function encode6(date) {
  return date.getFullYear() * 12 + date.getMonth();
}
function decode6(encoded) {
  var year2 = Math.floor(encoded / 12);
  var month2 = encoded - year2 * 12;
  return new Date(year2, month2, 1);
}
var _month = new CountableTimeInterval(encode6, decode6);
var month_default = _month;

// packages/ag-charts-community/src/util/time/year.ts
function encode7(date) {
  return date.getFullYear();
}
function decode7(encoded) {
  var d = /* @__PURE__ */new Date();
  d.setFullYear(encoded);
  d.setMonth(0, 1);
  d.setHours(0, 0, 0, 0);
  return d;
}
var _year = new CountableTimeInterval(encode7, decode7);
var year_default = _year;

// packages/ag-charts-community/src/util/time/utcMinute.ts
function encode8(date) {
  return Math.floor(date.getTime() / durationMinute);
}
function decode8(encoded) {
  return new Date(encoded * durationMinute);
}
var _utcMinute = new CountableTimeInterval(encode8, decode8);

// packages/ag-charts-community/src/util/time/utcHour.ts
function encode9(date) {
  return Math.floor(date.getTime() / durationHour);
}
function decode9(encoded) {
  return new Date(encoded * durationHour);
}
var _utcHour = new CountableTimeInterval(encode9, decode9);

// packages/ag-charts-community/src/util/time/utcDay.ts
function encode10(date) {
  return Math.floor(date.getTime() / durationDay);
}
function decode10(encoded) {
  var d = /* @__PURE__ */new Date(0);
  d.setUTCDate(d.getUTCDate() + encoded);
  d.setUTCHours(0, 0, 0, 0);
  return d;
}
var _utcDay = new CountableTimeInterval(encode10, decode10);

// packages/ag-charts-community/src/util/time/utcMonth.ts
function encode11(date) {
  return date.getUTCFullYear() * 12 + date.getUTCMonth();
}
function decode11(encoded) {
  var year2 = Math.floor(encoded / 12);
  var month2 = encoded - year2 * 12;
  return new Date(Date.UTC(year2, month2, 1));
}
var _utcMonth = new CountableTimeInterval(encode11, decode11);

// packages/ag-charts-community/src/util/time/utcYear.ts
function encode12(date) {
  return date.getUTCFullYear();
}
function decode12(encoded) {
  var d = /* @__PURE__ */new Date();
  d.setUTCFullYear(encoded);
  d.setUTCMonth(0, 1);
  d.setUTCHours(0, 0, 0, 0);
  return d;
}
var _utcYear = new CountableTimeInterval(encode12, decode12);

// packages/ag-charts-community/src/module/enterpriseModule.ts
var _enterpriseModule = {
  isEnterprise: false
};

// packages/ag-charts-community/src/module/module.ts
var _BaseModuleInstance4 = /*#__PURE__*/function () {
  function BaseModuleInstance() {
    _classCallCheck(this, BaseModuleInstance);
    this.destroyFns = [];
  }
  _createClass(BaseModuleInstance, [{
    key: "destroy",
    value: function destroy() {
      var _iterator3 = _createForOfIteratorHelper(this.destroyFns),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var destroyFn = _step3.value;
          destroyFn();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
  return BaseModuleInstance;
}();
var ModuleRegistry = /*#__PURE__*/function () {
  function ModuleRegistry() {
    _classCallCheck(this, ModuleRegistry);
    this.modules = [];
    this.dependencies = /* @__PURE__ */new Set();
    this.dependents = /* @__PURE__ */new Set();
  }
  _createClass(ModuleRegistry, [{
    key: "register",
    value: function register() {
      var _this2 = this;
      for (var _len8 = arguments.length, modules = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        modules[_key8] = arguments[_key8];
      }
      var _loop = function _loop() {
        var module = _modules[_i4];
        _this2.registerDependencies(module);
        var otherModule = _this2.modules.find(function (other) {
          return module.type === other.type && module.optionsKey === other.optionsKey && module.identifier === other.identifier;
        });
        if (otherModule) {
          if (module.packageType === "enterprise" && otherModule.packageType === "community") {
            var index = _this2.modules.indexOf(otherModule);
            _this2.modules.splice(index, 1, module);
          }
        } else {
          _this2.modules.push(module);
        }
      };
      for (var _i4 = 0, _modules = modules; _i4 < _modules.length; _i4++) {
        _loop();
      }
    }
  }, {
    key: "hasEnterpriseModules",
    value: function hasEnterpriseModules() {
      return this.modules.some(function (m) {
        return m.packageType === "enterprise";
      });
    }
  }, {
    key: "byType",
    value: /*#__PURE__*/_regenerator().m(function byType() {
      var _len9,
        types,
        _key9,
        _iterator4,
        _step4,
        module,
        _iterator5,
        _step5,
        _module,
        _iterator6,
        _step6,
        _module2,
        _args3 = arguments,
        _t,
        _t2,
        _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            for (_len9 = _args3.length, types = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
              types[_key9] = _args3[_key9];
            }
            _iterator4 = _createForOfIteratorHelper(this.modules);
            _context3.p = 1;
            _iterator4.s();
          case 2:
            if ((_step4 = _iterator4.n()).done) {
              _context3.n = 4;
              break;
            }
            module = _step4.value;
            if (!(types.includes(module.type) && this.dependencies.has(module.optionsKey))) {
              _context3.n = 3;
              break;
            }
            _context3.n = 3;
            return module;
          case 3:
            _context3.n = 2;
            break;
          case 4:
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t = _context3.v;
            _iterator4.e(_t);
          case 6:
            _context3.p = 6;
            _iterator4.f();
            return _context3.f(6);
          case 7:
            _iterator5 = _createForOfIteratorHelper(this.modules);
            _context3.p = 8;
            _iterator5.s();
          case 9:
            if ((_step5 = _iterator5.n()).done) {
              _context3.n = 11;
              break;
            }
            _module = _step5.value;
            if (!(types.includes(_module.type) && !this.dependencies.has(_module.optionsKey) && !this.dependents.has(_module.optionsKey))) {
              _context3.n = 10;
              break;
            }
            _context3.n = 10;
            return _module;
          case 10:
            _context3.n = 9;
            break;
          case 11:
            _context3.n = 13;
            break;
          case 12:
            _context3.p = 12;
            _t2 = _context3.v;
            _iterator5.e(_t2);
          case 13:
            _context3.p = 13;
            _iterator5.f();
            return _context3.f(13);
          case 14:
            _iterator6 = _createForOfIteratorHelper(this.modules);
            _context3.p = 15;
            _iterator6.s();
          case 16:
            if ((_step6 = _iterator6.n()).done) {
              _context3.n = 18;
              break;
            }
            _module2 = _step6.value;
            if (!(types.includes(_module2.type) && this.dependents.has(_module2.optionsKey))) {
              _context3.n = 17;
              break;
            }
            _context3.n = 17;
            return _module2;
          case 17:
            _context3.n = 16;
            break;
          case 18:
            _context3.n = 20;
            break;
          case 19:
            _context3.p = 19;
            _t3 = _context3.v;
            _iterator6.e(_t3);
          case 20:
            _context3.p = 20;
            _iterator6.f();
            return _context3.f(20);
          case 21:
            return _context3.a(2);
        }
      }, byType, this, [[15, 19, 20, 21], [8, 12, 13, 14], [1, 5, 6, 7]]);
    })
  }, {
    key: "registerDependencies",
    value: function registerDependencies(module) {
      if (module.dependencies == null || module.dependencies.length === 0) return;
      if (this.dependencies.has(module.optionsKey)) {
        throw new Error("Module [".concat(module.optionsKey, "] can not both be depended upon by any module and have dependencies of [").concat(module.dependencies, "]."));
      }
      var _iterator7 = _createForOfIteratorHelper(module.dependencies),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var dep = _step7.value;
          if (this.dependents.has(dep)) {
            throw new Error("Module [".concat(dep, "] can not both be depended upon by any module and have dependencies of [").concat(module.optionsKey, "]."));
          }
          this.dependencies.add(dep);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      this.dependents.add(module.optionsKey);
    }
  }]);
  return ModuleRegistry;
}();
var _moduleRegistry = new ModuleRegistry();

// packages/ag-charts-community/src/chart/factory/axisRegistry.ts
var AxisRegistry = /*#__PURE__*/function () {
  function AxisRegistry() {
    _classCallCheck(this, AxisRegistry);
    this.axesMap = /* @__PURE__ */new Map();
    this.hidden = /* @__PURE__ */new Set();
    this.themeTemplates = /* @__PURE__ */new Map();
  }
  _createClass(AxisRegistry, [{
    key: "register",
    value: function register(axisType, module) {
      this.axesMap.set(axisType, module.instanceConstructor);
      if (module.themeTemplate) {
        this.setThemeTemplate(axisType, module.themeTemplate);
      }
      if (module.hidden) {
        this.hidden.add(axisType);
      }
    }
  }, {
    key: "create",
    value: function create(axisType, moduleContext) {
      var AxisConstructor = this.axesMap.get(axisType);
      if (AxisConstructor) {
        return new AxisConstructor(moduleContext);
      }
      throw new Error("AG Charts - unknown axis type: ".concat(axisType));
    }
  }, {
    key: "has",
    value: function has(axisType) {
      return this.axesMap.has(axisType);
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.axesMap.keys();
    }
  }, {
    key: "publicKeys",
    value: function publicKeys() {
      var _this3 = this;
      return _toConsumableArray(this.keys()).filter(function (k) {
        return !_this3.hidden.has(k);
      });
    }
  }, {
    key: "setThemeTemplate",
    value: function setThemeTemplate(axisType, themeTemplate) {
      this.themeTemplates.set(axisType, themeTemplate);
      return this;
    }
  }, {
    key: "getThemeTemplate",
    value: function getThemeTemplate(axisType) {
      return this.themeTemplates.get(axisType);
    }
  }]);
  return AxisRegistry;
}();
var axisRegistry = new AxisRegistry();

// packages/ag-charts-community/src/util/decorator.ts
var BREAK_TRANSFORM_CHAIN = Symbol("BREAK");
var CONFIG_KEY = "__decorator_config";
function initialiseConfig(target, propertyKeyOrSymbol) {
  if (Object.getOwnPropertyDescriptor(target, CONFIG_KEY) == null) {
    Object.defineProperty(target, CONFIG_KEY, {
      value: {}
    });
  }
  var config = target[CONFIG_KEY];
  var propertyKey = propertyKeyOrSymbol.toString();
  if (typeof config[propertyKey] !== "undefined") {
    return config[propertyKey];
  }
  var valuesMap = /* @__PURE__ */new WeakMap();
  config[propertyKey] = {
    setters: [],
    getters: [],
    observers: [],
    valuesMap: valuesMap
  };
  var descriptor = Object.getOwnPropertyDescriptor(target, propertyKeyOrSymbol);
  var prevSet = descriptor == null ? void 0 : descriptor.set;
  var prevGet = descriptor == null ? void 0 : descriptor.get;
  var getter = function getter() {
    var value = prevGet ? prevGet.call(this) : valuesMap.get(this);
    var _iterator8 = _createForOfIteratorHelper(config[propertyKey].getters),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var transformFn = _step8.value;
        value = transformFn(this, propertyKeyOrSymbol, value);
        if (value === BREAK_TRANSFORM_CHAIN) {
          return;
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    return value;
  };
  var setter = function setter(value) {
    var _config$propertyKey = config[propertyKey],
      setters = _config$propertyKey.setters,
      observers = _config$propertyKey.observers;
    var oldValue;
    if (setters.some(function (f) {
      return f.length > 2;
    })) {
      oldValue = prevGet ? prevGet.call(this) : valuesMap.get(this);
    }
    var _iterator9 = _createForOfIteratorHelper(setters),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var transformFn = _step9.value;
        value = transformFn(this, propertyKeyOrSymbol, value, oldValue);
        if (value === BREAK_TRANSFORM_CHAIN) {
          return;
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
    if (prevSet) {
      prevSet.call(this, value);
    } else {
      valuesMap.set(this, value);
    }
    var _iterator0 = _createForOfIteratorHelper(observers),
      _step0;
    try {
      for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
        var observerFn = _step0.value;
        observerFn(this, value, oldValue);
      }
    } catch (err) {
      _iterator0.e(err);
    } finally {
      _iterator0.f();
    }
  };
  Object.defineProperty(target, propertyKeyOrSymbol, {
    set: setter,
    get: getter,
    enumerable: true,
    configurable: false
  });
  return config[propertyKey];
}
function addTransformToInstanceProperty(setTransform, getTransform, configMetadata) {
  return function (target, propertyKeyOrSymbol) {
    var config = initialiseConfig(target, propertyKeyOrSymbol);
    config.setters.push(setTransform);
    if (getTransform) {
      config.getters.unshift(getTransform);
    }
    if (configMetadata) {
      Object.assign(config, configMetadata);
    }
  };
}
function addObserverToInstanceProperty(setObserver) {
  return function (target, propertyKeyOrSymbol) {
    initialiseConfig(target, propertyKeyOrSymbol).observers.push(setObserver);
  };
}
function _isDecoratedObject(target) {
  return typeof target !== "undefined" && CONFIG_KEY in target;
}
function _listDecoratedProperties(target) {
  var targets = /* @__PURE__ */new Set();
  while (_isDecoratedObject(target)) {
    targets.add(target == null ? void 0 : target[CONFIG_KEY]);
    target = Object.getPrototypeOf(target);
  }
  return Array.from(targets).flatMap(function (configMap) {
    return Object.keys(configMap);
  });
}
function _extractDecoratedProperties(target) {
  return _listDecoratedProperties(target).reduce(function (result, key) {
    var _a;
    result[key] = (_a = target[key]) != null ? _a : null;
    return result;
  }, {});
}
function extractDecoratedPropertyMetadata(target, propertyKeyOrSymbol) {
  var propertyKey = propertyKeyOrSymbol.toString();
  while (_isDecoratedObject(target)) {
    var config = target[CONFIG_KEY];
    if (Object.hasOwn(config, propertyKey)) {
      return config[propertyKey];
    }
    target = Object.getPrototypeOf(target);
  }
}

// packages/ag-charts-community/src/util/type-guards.ts
function _isDefined(val) {
  return val != null;
}
function _isArray(value) {
  return Array.isArray(value);
}
function _isBoolean(value) {
  return typeof value === "boolean";
}
function _isDate(value) {
  return value instanceof Date;
}
function _isValidDate(value) {
  return _isDate(value) && !isNaN(Number(value));
}
function _isRegExp(value) {
  return value instanceof RegExp;
}
function _isFunction(value) {
  return typeof value === "function";
}
function _isObject(value) {
  return typeof value === "object" && value !== null && !_isArray(value);
}
function _isObjectLike(value) {
  return _isArray(value) || _isPlainObject(value);
}
function _isPlainObject(value) {
  return typeof value === "object" && value !== null && value.constructor === Object;
}
function _isString(value) {
  return typeof value === "string";
}
function _isNumber(value) {
  return typeof value === "number";
}
function _isFiniteNumber(value) {
  return _isNumber(value) && Number.isFinite(value);
}
function _isHtmlElement(value) {
  return typeof window !== "undefined" && value instanceof HTMLElement;
}
function _isEnumKey(enumObject, enumKey) {
  return _isString(enumKey) && Object.keys(enumObject).includes(enumKey);
}
function _isEnumValue(enumObject, enumValue) {
  return Object.values(enumObject).includes(enumValue);
}
function _isSymbol(value) {
  return typeof value === "symbol";
}

// packages/ag-charts-community/src/util/object.ts
function _deepMerge() {
  for (var _len0 = arguments.length, sources = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
    sources[_key0] = arguments[_key0];
  }
  return _mergeDefaults4.apply(void 0, _toConsumableArray(sources.reverse()));
}
function _mergeDefaults4() {
  var _a;
  var target = {};
  for (var _len1 = arguments.length, sources = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
    sources[_key1] = arguments[_key1];
  }
  for (var _i5 = 0, _sources = sources; _i5 < _sources.length; _i5++) {
    var source = _sources[_i5];
    if (!_isObject(source)) continue;
    var keys = _isDecoratedObject(source) ? _listDecoratedProperties(source) : Object.keys(source);
    var _iterator1 = _createForOfIteratorHelper(keys),
      _step1;
    try {
      for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
        var key = _step1.value;
        if (_isPlainObject(target[key]) && _isPlainObject(source[key])) {
          target[key] = _mergeDefaults4(target[key], source[key]);
        } else {
          (_a = target[key]) != null ? _a : target[key] = source[key];
        }
      }
    } catch (err) {
      _iterator1.e(err);
    } finally {
      _iterator1.f();
    }
  }
  return target;
}
function _mergeArrayDefaults(dataArray) {
  for (var _len10 = arguments.length, itemDefaults = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    itemDefaults[_key10 - 1] = arguments[_key10];
  }
  if (itemDefaults && _isArray(dataArray)) {
    return dataArray.map(function (item) {
      return _mergeDefaults4.apply(void 0, [item].concat(itemDefaults));
    });
  }
  return dataArray;
}
function _mapValues(object, mapper) {
  return Object.entries(object).reduce(function (result, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    result[key] = mapper(value, key, object);
    return result;
  }, {});
}
function _without(object, keys) {
  var clone = __spreadValues({}, object);
  var _iterator10 = _createForOfIteratorHelper(keys),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var key = _step10.value;
      delete clone[key];
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  return clone;
}
function _getPath(object, path) {
  var pathArray = _isArray(path) ? path : path.split(".");
  return pathArray.reduce(function (value, pathKey) {
    return value[pathKey];
  }, object);
}
var _SKIP_JS_BUILTINS = /* @__PURE__ */new Set(["__proto__", "constructor", "prototype"]);
function _setPath(object, path, newValue) {
  var pathArray = _isArray(path) ? path.slice() : path.split(".");
  var lastKey = pathArray.pop();
  if (pathArray.some(function (p) {
    return _SKIP_JS_BUILTINS.has(p);
  })) return;
  var lastObject = pathArray.reduce(function (value, pathKey) {
    return value[pathKey];
  }, object);
  lastObject[lastKey] = newValue;
}
function _partialAssign(keysToCopy, target, source) {
  if (source === void 0) {
    return target;
  }
  var _iterator11 = _createForOfIteratorHelper(keysToCopy),
    _step11;
  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var key = _step11.value;
      var value = source[key];
      if (value !== void 0) {
        target[key] = value;
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }
  return target;
}

// packages/ag-charts-community/src/chart/factory/chartTypes.ts
var ChartTypes = /*#__PURE__*/function (_Map) {
  _inherits(ChartTypes, _Map);
  function ChartTypes() {
    _classCallCheck(this, ChartTypes);
    return _possibleConstructorReturn(this, _getPrototypeOf(ChartTypes).apply(this, arguments));
  }
  _createClass(ChartTypes, [{
    key: "get",
    value: function get(seriesType) {
      var _a;
      return (_a = _superPropGet(ChartTypes, "get", this, 3)([seriesType])) != null ? _a : "unknown";
    }
  }, {
    key: "isCartesian",
    value: function isCartesian(seriesType) {
      return this.get(seriesType) === "cartesian";
    }
  }, {
    key: "isPolar",
    value: function isPolar(seriesType) {
      return this.get(seriesType) === "polar";
    }
  }, {
    key: "isHierarchy",
    value: function isHierarchy(seriesType) {
      return this.get(seriesType) === "hierarchy";
    }
  }, {
    key: "isTopology",
    value: function isTopology(seriesType) {
      return this.get(seriesType) === "topology";
    }
  }, {
    key: "seriesTypes",
    get: function get() {
      return Array.from(this.keys());
    }
  }, {
    key: "cartesianTypes",
    get: function get() {
      var _this4 = this;
      return this.seriesTypes.filter(function (t) {
        return _this4.isCartesian(t);
      });
    }
  }, {
    key: "polarTypes",
    get: function get() {
      var _this5 = this;
      return this.seriesTypes.filter(function (t) {
        return _this5.isPolar(t);
      });
    }
  }, {
    key: "hierarchyTypes",
    get: function get() {
      var _this6 = this;
      return this.seriesTypes.filter(function (t) {
        return _this6.isHierarchy(t);
      });
    }
  }, {
    key: "topologyTypes",
    get: function get() {
      var _this7 = this;
      return this.seriesTypes.filter(function (t) {
        return _this7.isTopology(t);
      });
    }
  }]);
  return ChartTypes;
}(_wrapNativeSuper(Map));
var ChartDefaults = /*#__PURE__*/function (_Map2) {
  _inherits(ChartDefaults, _Map2);
  function ChartDefaults() {
    _classCallCheck(this, ChartDefaults);
    return _possibleConstructorReturn(this, _getPrototypeOf(ChartDefaults).apply(this, arguments));
  }
  _createClass(ChartDefaults, [{
    key: "set",
    value: function set(chartType2, defaults) {
      return _superPropGet(ChartDefaults, "set", this, 3)([chartType2, _mergeDefaults4(defaults, this.get(chartType2))]);
    }
  }]);
  return ChartDefaults;
}(_wrapNativeSuper(Map));
var chartTypes = new ChartTypes();
var publicChartTypes = new ChartTypes();
var chartDefaults = new ChartDefaults();

// packages/ag-charts-community/src/chart/factory/expectedEnterpriseModules.ts
var EXPECTED_ENTERPRISE_MODULES = [{
  type: "root",
  optionsKey: "animation",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"]
}, {
  type: "root",
  optionsKey: "annotations",
  chartTypes: ["cartesian"]
}, {
  type: "root",
  optionsKey: "background",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"],
  optionsInnerKey: "image"
}, {
  type: "root",
  optionsKey: "contextMenu",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"]
}, {
  type: "root",
  optionsKey: "dataSource",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"]
}, {
  type: "root",
  optionsKey: "sync",
  chartTypes: ["cartesian"]
}, {
  type: "root",
  optionsKey: "zoom",
  chartTypes: ["cartesian", "topology"]
}, {
  type: "legend",
  optionsKey: "gradientLegend",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"],
  identifier: "gradient"
}, {
  type: "root",
  optionsKey: "navigator",
  chartTypes: ["cartesian"],
  optionsInnerKey: "miniChart"
}, {
  type: "axis",
  optionsKey: "axes[]",
  chartTypes: ["polar"],
  identifier: "angle-category"
}, {
  type: "axis",
  optionsKey: "axes[]",
  chartTypes: ["polar"],
  identifier: "angle-number"
}, {
  type: "axis",
  optionsKey: "axes[]",
  chartTypes: ["polar"],
  identifier: "radius-category"
}, {
  type: "axis",
  optionsKey: "axes[]",
  chartTypes: ["polar"],
  identifier: "radius-number"
}, {
  type: "axis",
  optionsKey: "axes[]",
  chartTypes: ["cartesian"],
  identifier: "ordinal-time"
}, {
  type: "axis-option",
  optionsKey: "crosshair",
  chartTypes: ["cartesian"]
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "box-plot"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "candlestick"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "ohlc"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "bullet"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "heatmap"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "range-area"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "range-bar"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["cartesian"],
  identifier: "waterfall"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["polar"],
  identifier: "nightingale"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["polar"],
  identifier: "radar-area"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["polar"],
  identifier: "radar-line"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["polar"],
  identifier: "radial-bar"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["polar"],
  identifier: "radial-column"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["hierarchy"],
  identifier: "sunburst"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["hierarchy"],
  identifier: "treemap"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["topology"],
  identifier: "map-shape"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["topology"],
  identifier: "map-line"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["topology"],
  identifier: "map-marker"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["topology"],
  identifier: "map-shape-background"
}, {
  type: "series",
  optionsKey: "series[]",
  chartTypes: ["topology"],
  identifier: "map-line-background"
}, {
  type: "series-option",
  optionsKey: "errorBar",
  chartTypes: ["cartesian"],
  identifier: "error-bars"
}];
function isEnterpriseSeriesType(type) {
  return EXPECTED_ENTERPRISE_MODULES.some(function (s) {
    return s.type === "series" && s.identifier === type;
  });
}
function getEnterpriseSeriesChartTypes(type) {
  var _a;
  return (_a = EXPECTED_ENTERPRISE_MODULES.find(function (s) {
    return s.type === "series" && s.identifier === type;
  })) == null ? void 0 : _a.chartTypes;
}
function isEnterpriseCartesian(seriesType) {
  var _a;
  var type = (_a = getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find(function (v) {
    return v === "cartesian";
  });
  return type === "cartesian";
}
function isEnterprisePolar(seriesType) {
  var _a;
  var type = (_a = getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find(function (v) {
    return v === "polar";
  });
  return type === "polar";
}
function isEnterpriseHierarchy(seriesType) {
  var _a;
  var type = (_a = getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find(function (v) {
    return v === "hierarchy";
  });
  return type === "hierarchy";
}
function isEnterpriseTopology(seriesType) {
  var _a;
  var type = (_a = getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find(function (v) {
    return v === "topology";
  });
  return type === "topology";
}
function isEnterpriseModule(module) {
  return module.packageType === "enterprise";
}
function verifyIfModuleExpected(module) {
  var _a;
  if (!isEnterpriseModule(module)) {
    throw new Error("AG Charts - internal configuration error, only enterprise modules need verification.");
  }
  var stub = EXPECTED_ENTERPRISE_MODULES.find(function (s) {
    return s.type === module.type && s.optionsKey === module.optionsKey && s.identifier === module.identifier && module.chartTypes.every(function (t) {
      return s.chartTypes.includes(t);
    });
  });
  if (stub) {
    (_a = stub.useCount) != null ? _a : stub.useCount = 0;
    stub.useCount++;
  }
  return stub != null;
}
function getUnusedExpectedModules() {
  return EXPECTED_ENTERPRISE_MODULES.filter(function (_ref5) {
    var useCount = _ref5.useCount;
    return useCount == null || useCount === 0;
  });
}

// packages/ag-charts-community/src/chart/mapping/types.ts
function optionsType(input) {
  var _a, _b, _c;
  return (_c = (_b = (_a = input.series) == null ? void 0 : _a[0]) == null ? void 0 : _b.type) != null ? _c : "line";
}
function isAgCartesianChartOptions(input) {
  var specifiedType = optionsType(input);
  if (specifiedType == null) {
    return true;
  }
  if (specifiedType === "cartesian") {
    _Logger.warnOnce("type '".concat(specifiedType, "' is deprecated, use a series type instead"));
    return true;
  }
  return chartTypes.isCartesian(specifiedType) || isEnterpriseCartesian(specifiedType);
}
function isAgPolarChartOptions(input) {
  var specifiedType = optionsType(input);
  if (specifiedType == null) {
    return false;
  }
  if (specifiedType === "polar") {
    _Logger.warnOnce("type '".concat(specifiedType, "' is deprecated, use a series type instead"));
    return true;
  }
  return chartTypes.isPolar(specifiedType) || isEnterprisePolar(specifiedType);
}
function isAgHierarchyChartOptions(input) {
  var specifiedType = optionsType(input);
  if (specifiedType == null) {
    return false;
  }
  if (specifiedType === "hierarchy") {
    _Logger.warnOnce("type '".concat(specifiedType, "' is deprecated, use a series type instead"));
    return true;
  }
  return chartTypes.isHierarchy(specifiedType) || isEnterpriseHierarchy(specifiedType);
}
function isAgTopologyChartOptions(input) {
  var specifiedType = optionsType(input);
  if (specifiedType == null) {
    return false;
  }
  if (specifiedType === "topology") {
    _Logger.warnOnce("type '".concat(specifiedType, "' is deprecated, use a series type instead"));
    return true;
  }
  return chartTypes.isTopology(specifiedType) || isEnterpriseTopology(specifiedType);
}
function isAgPolarChartOptionsWithSeriesBasedLegend(input) {
  var specifiedType = optionsType(input);
  return isAgPolarChartOptions(input) && specifiedType !== "pie" && specifiedType !== "donut";
}
function isSeriesOptionType(input) {
  if (input == null) {
    return false;
  }
  return chartTypes.has(input);
}
function isAxisOptionType(input) {
  if (input == null) {
    return false;
  }
  return axisRegistry.has(input);
}

// packages/ag-charts-community/src/chart/factory/processEnterpriseOptions.ts
function removeUsedEnterpriseOptions(options) {
  var _a, _b, _c, _d;
  var usedOptions = [];
  var optionsChartType = chartTypes.get(optionsType(options));
  var _loop2 = function _loop2() {
      var _EXPECTED_ENTERPRISE_2 = _EXPECTED_ENTERPRISE_[_i6],
        type = _EXPECTED_ENTERPRISE_2.type,
        moduleChartTypes = _EXPECTED_ENTERPRISE_2.chartTypes,
        optionsKey = _EXPECTED_ENTERPRISE_2.optionsKey,
        optionsInnerKey = _EXPECTED_ENTERPRISE_2.optionsInnerKey,
        identifier = _EXPECTED_ENTERPRISE_2.identifier;
      if (optionsChartType !== "unknown" && !moduleChartTypes.includes(optionsChartType)) return 0; // continue
      if (type === "root" || type === "legend") {
        var optionValue = options[optionsKey];
        if (optionValue == null) return 0; // continue
        if (!optionsInnerKey) {
          usedOptions.push(optionsKey);
          delete options[optionsKey];
        } else if (optionValue[optionsInnerKey]) {
          usedOptions.push("".concat(optionsKey, ".").concat(optionsInnerKey));
          delete optionValue[optionsInnerKey];
        }
      } else if (type === "axis") {
        if (!("axes" in options) || !((_a = options.axes) == null ? void 0 : _a.some(function (axis) {
          return axis.type === identifier;
        }))) return 0; // continue
        usedOptions.push("axis[type=".concat(identifier, "]"));
        options.axes = options.axes.filter(function (axis) {
          return axis.type !== identifier;
        });
      } else if (type === "axis-option") {
        if (!("axes" in options) || !((_b = options.axes) == null ? void 0 : _b.some(function (axis) {
          return axis[optionsKey];
        }))) return 0; // continue
        usedOptions.push("axis.".concat(optionsKey));
        options.axes.forEach(function (axis) {
          if (axis[optionsKey]) {
            delete axis[optionsKey];
          }
        });
      } else if (type === "series") {
        if (!((_c = options.series) == null ? void 0 : _c.some(function (series) {
          return series.type === identifier;
        }))) return 0; // continue
        usedOptions.push("series[type=".concat(identifier, "]"));
        options.series = options.series.filter(function (series) {
          return series.type !== identifier;
        });
      } else if (type === "series-option") {
        if (!((_d = options.series) == null ? void 0 : _d.some(function (series) {
          return series[optionsKey];
        }))) return 0; // continue
        usedOptions.push("series.".concat(optionsKey));
        options.series.forEach(function (series) {
          if (series[optionsKey]) {
            delete series[optionsKey];
          }
        });
      }
    },
    _ret;
  for (var _i6 = 0, _EXPECTED_ENTERPRISE_ = EXPECTED_ENTERPRISE_MODULES; _i6 < _EXPECTED_ENTERPRISE_.length; _i6++) {
    _ret = _loop2();
    if (_ret === 0) continue;
  }
  if (usedOptions.length) {
    var enterprisePackageName = "ag-charts-enterprise";
    var enterpriseReferenceUrl = "https://charts.ag-grid.com/javascript/installation/";
    if (options.mode === "integrated") {
      enterprisePackageName = "ag-grid-charts-enterprise' or 'ag-grid-enterprise/charts-enterprise";
      enterpriseReferenceUrl = "https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/";
    }
    _Logger.warnOnce(["unable to use these enterprise features as '".concat(enterprisePackageName, "' has not been loaded:"), ""].concat(usedOptions, ["", "See: ".concat(enterpriseReferenceUrl)]).join("\n"));
  }
}

// packages/ag-charts-community/src/util/properties.ts
var _BaseProperties35 = /*#__PURE__*/function () {
  function BaseProperties() {
    _classCallCheck(this, BaseProperties);
  }
  _createClass(BaseProperties, [{
    key: "set",
    value: function set(properties) {
      var _this$constructor$cla = this.constructor.className,
        className = _this$constructor$cla === void 0 ? this.constructor.name : _this$constructor$cla;
      if (typeof properties !== "object") {
        _Logger.warn("unable to set ".concat(className, " - expecting a properties object"));
        return this;
      }
      var keys = new Set(Object.keys(properties));
      var _iterator12 = _createForOfIteratorHelper(_listDecoratedProperties(this)),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var propertyKey = _step12.value;
          if (keys.has(propertyKey)) {
            var value = properties[propertyKey];
            var self = this;
            if (_isProperties(self[propertyKey])) {
              self[propertyKey] = self[propertyKey] instanceof _PropertiesArray2 ? self[propertyKey].reset(value) : self[propertyKey].set(value);
            } else {
              self[propertyKey] = value;
            }
            keys.delete(propertyKey);
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      var _iterator13 = _createForOfIteratorHelper(keys),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var unknownKey = _step13.value;
          _Logger.warn("unable to set [".concat(unknownKey, "] in ").concat(className, " - property is unknown"));
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      return this;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var _this8 = this;
      return _listDecoratedProperties(this).every(function (propertyKey) {
        var _extractDecoratedProp = extractDecoratedPropertyMetadata(_this8, propertyKey),
          optional = _extractDecoratedProp.optional;
        var valid = optional || typeof _this8[propertyKey] !== "undefined";
        if (!valid) {
          _Logger.warnOnce("[".concat(propertyKey, "] is required."));
        }
        return valid;
      });
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var _this9 = this;
      return _listDecoratedProperties(this).reduce(function (object, propertyKey) {
        var propertyValue = _this9[propertyKey];
        object[propertyKey] = _isProperties(propertyValue) ? propertyValue.toJson() : propertyValue;
        return object;
      }, {});
    }
  }]);
  return BaseProperties;
}();
var _PropertiesArray2 = /*#__PURE__*/function (_Array) {
  _inherits(_PropertiesArray, _Array);
  function _PropertiesArray(itemFactory) {
    var _this0;
    _classCallCheck(this, _PropertiesArray);
    for (var _len11 = arguments.length, properties = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
      properties[_key11 - 1] = arguments[_key11];
    }
    _this0 = _possibleConstructorReturn(this, _getPrototypeOf(_PropertiesArray).call(this, properties.length));
    Object.defineProperty(_assertThisInitialized(_this0), "itemFactory", {
      value: itemFactory,
      enumerable: false,
      configurable: false
    });
    _this0.set(properties);
    return _this0;
  }
  _createClass(_PropertiesArray, [{
    key: "set",
    value: function set(properties) {
      if (_isArray(properties)) {
        this.length = properties.length;
        for (var i = 0; i < properties.length; i++) {
          this[i] = new this.itemFactory().set(properties[i]);
        }
      }
      return this;
    }
  }, {
    key: "reset",
    value: function reset(properties) {
      return _construct(_PropertiesArray, [this.itemFactory].concat(_toConsumableArray(properties)));
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return this.map(function (value) {
        var _a, _b;
        return (_b = (_a = value == null ? void 0 : value.toJson) == null ? void 0 : _a.call(value)) != null ? _b : value;
      });
    }
  }]);
  return _PropertiesArray;
}(_wrapNativeSuper(Array));
function _isProperties(value) {
  return value instanceof _BaseProperties35 || value instanceof _PropertiesArray2;
}

// packages/ag-charts-community/src/util/json.ts
var CLASS_INSTANCE_TYPE = "class-instance";
function _jsonDiff(source, target, skip) {
  if (_isArray(target)) {
    if (!_isArray(source) || source.length !== target.length || target.some(function (v, i) {
      return _jsonDiff(source[i], v) != null;
    })) {
      return target;
    }
  } else if (_isPlainObject(target)) {
    if (!_isPlainObject(source)) {
      return target;
    }
    var result = {};
    var allKeys = /* @__PURE__ */new Set([].concat(_toConsumableArray(Object.keys(source)), _toConsumableArray(Object.keys(target))));
    var _iterator14 = _createForOfIteratorHelper(allKeys),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var key = _step14.value;
        if (source[key] === target[key] || (skip == null ? void 0 : skip.includes(key))) {
          continue;
        }
        if (typeof source[key] === typeof target[key]) {
          var diff2 = _jsonDiff(source[key], target[key]);
          if (diff2 !== null) {
            result[key] = diff2;
          }
        } else {
          result[key] = target[key];
        }
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
    return Object.keys(result).length ? result : null;
  } else if (source !== target) {
    return target;
  }
  return null;
}
function _deepClone2(source, options) {
  if (_isArray(source)) {
    return source.map(function (item) {
      return _deepClone2(item, options);
    });
  }
  if (_isPlainObject(source)) {
    return _mapValues(source, function (value, key) {
      var _a;
      return ((_a = options == null ? void 0 : options.shallow) == null ? void 0 : _a.includes(key)) ? _shallowClone(value) : _deepClone2(value, options);
    });
  }
  return _shallowClone(source);
}
function _shallowClone(source) {
  if (_isArray(source)) {
    return _toConsumableArray(source);
  }
  if (_isPlainObject(source)) {
    return __spreadValues({}, source);
  }
  if (_isDate(source)) {
    return new Date(source);
  }
  if (_isRegExp(source)) {
    return new RegExp(source.source, source.flags);
  }
  return source;
}
function _jsonWalk(json, visit, opts) {
  for (var _len12 = arguments.length, jsons = new Array(_len12 > 3 ? _len12 - 3 : 0), _key12 = 3; _key12 < _len12; _key12++) {
    jsons[_key12 - 3] = arguments[_key12];
  }
  var _a;
  if (_isArray(json)) {
    visit.apply(void 0, [json].concat(jsons));
    json.forEach(function (node, index) {
      _jsonWalk.apply(void 0, [node, visit, opts].concat(_toConsumableArray(keyMapper(jsons, index))));
    });
  } else if (_isPlainObject(json)) {
    visit.apply(void 0, [json].concat(jsons));
    for (var _i7 = 0, _Object$keys = Object.keys(json); _i7 < _Object$keys.length; _i7++) {
      var key = _Object$keys[_i7];
      if ((_a = opts == null ? void 0 : opts.skip) == null ? void 0 : _a.includes(key)) {
        continue;
      }
      var value = json[key];
      if (_isArray(value) || _isPlainObject(value)) {
        _jsonWalk.apply(void 0, [value, visit, opts].concat(_toConsumableArray(keyMapper(jsons, key))));
      }
    }
  }
}
function _jsonApply(target, source) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = params.path,
    constructedArrays = params.constructedArrays,
    _params$matcherPath = params.matcherPath,
    matcherPath = _params$matcherPath === void 0 ? path == null ? void 0 : path.replace(/(\[[0-9+]+])/i, "[]") : _params$matcherPath,
    _params$skip = params.skip,
    skip = _params$skip === void 0 ? [] : _params$skip;
  if (target == null) {
    throw new Error("AG Charts - target is uninitialised: ".concat(path != null ? path : "<root>"));
  }
  if (source == null) {
    return target;
  }
  if (_isProperties(target)) {
    return target.set(source);
  }
  var targetAny = target;
  var targetType = classify(target);
  var _loop3 = function _loop3() {
      if (_SKIP_JS_BUILTINS.has(property)) return 0; // continue
      var propertyMatcherPath = "".concat(matcherPath ? matcherPath + "." : "").concat(property);
      if (skip.includes(propertyMatcherPath)) return 0; // continue
      var newValue = source[property];
      var propertyPath = "".concat(path ? path + "." : "").concat(property);
      var targetClass = targetAny.constructor;
      var currentValue = targetAny[property];
      var ctr;
      try {
        var currentValueType = classify(currentValue);
        var newValueType = classify(newValue);
        if (targetType === CLASS_INSTANCE_TYPE && !(property in target)) {
          _Logger.warn("unable to set [".concat(propertyPath, "] in ").concat(targetClass == null ? void 0 : targetClass.name, " - property is unknown"));
          return 0; // continue
        }
        if (currentValueType != null && newValueType != null && newValueType !== currentValueType && (currentValueType !== CLASS_INSTANCE_TYPE || newValueType !== "object")) {
          _Logger.warn("unable to set [".concat(propertyPath, "] in ").concat(targetClass == null ? void 0 : targetClass.name, " - can't apply type of [").concat(newValueType, "], allowed types are: [").concat(currentValueType, "]"));
          return 0; // continue
        }
        if (_isProperties(currentValue)) {
          targetAny[property].set(newValue);
        } else if (newValueType === "array") {
          ctr != null ? ctr : ctr = constructedArrays == null ? void 0 : constructedArrays.get(currentValue);
          if (ctr == null) {
            targetAny[property] = newValue;
          } else {
            var newValueArray = newValue;
            targetAny[property] = newValueArray.map(function (v) {
              return _jsonApply(new ctr(), v, __spreadProps(__spreadValues({}, params), {
                path: propertyPath,
                matcherPath: propertyMatcherPath + "[]"
              }));
            });
          }
        } else if (newValueType === CLASS_INSTANCE_TYPE) {
          targetAny[property] = newValue;
        } else if (newValueType === "object") {
          if (currentValue != null) {
            _jsonApply(currentValue, newValue, __spreadProps(__spreadValues({}, params), {
              path: propertyPath,
              matcherPath: propertyMatcherPath
            }));
          } else if (ctr == null) {
            targetAny[property] = {};
            _jsonApply(targetAny[property], newValue, __spreadProps(__spreadValues({}, params), {
              path: propertyPath,
              matcherPath: propertyMatcherPath
            }));
          } else {
            targetAny[property] = _jsonApply(new ctr(), newValue, __spreadProps(__spreadValues({}, params), {
              path: propertyPath,
              matcherPath: propertyMatcherPath
            }));
          }
        } else {
          targetAny[property] = newValue;
        }
      } catch (error) {
        _Logger.warn("unable to set [".concat(propertyPath, "] in [").concat(targetClass == null ? void 0 : targetClass.name, "]; nested error is: ").concat(error.message));
      }
    },
    _ret2;
  for (var property in source) {
    _ret2 = _loop3();
    if (_ret2 === 0) continue;
  }
  return target;
}
function keyMapper(data, key) {
  return data.map(function (dataObject) {
    return dataObject == null ? void 0 : dataObject[key];
  });
}
function classify(value) {
  if (value == null) {
    return null;
  }
  if (_isHtmlElement(value) || _isDate(value)) {
    return "primitive";
  }
  if (_isArray(value)) {
    return "array";
  }
  if (_isObject(value)) {
    return _isPlainObject(value) ? "object" : CLASS_INSTANCE_TYPE;
  }
  if (_isFunction(value)) {
    return "function";
  }
  return "primitive";
}

// packages/ag-charts-community/src/chart/factory/seriesRegistry.ts
var SeriesRegistry = /*#__PURE__*/function () {
  function SeriesRegistry() {
    _classCallCheck(this, SeriesRegistry);
    this.seriesMap = /* @__PURE__ */new Map();
    this.themeTemplates = /* @__PURE__ */new Map();
  }
  _createClass(SeriesRegistry, [{
    key: "register",
    value: function register(seriesType, _ref6) {
      var _ref6$chartTypes = _slicedToArray(_ref6.chartTypes, 1),
        chartType2 = _ref6$chartTypes[0],
        instanceConstructor = _ref6.instanceConstructor,
        defaultAxes = _ref6.defaultAxes,
        themeTemplate = _ref6.themeTemplate,
        enterpriseThemeTemplate = _ref6.enterpriseThemeTemplate,
        paletteFactory = _ref6.paletteFactory,
        solo = _ref6.solo,
        stackable = _ref6.stackable,
        groupable = _ref6.groupable,
        stackedByDefault = _ref6.stackedByDefault,
        swapDefaultAxesCondition = _ref6.swapDefaultAxesCondition,
        hidden = _ref6.hidden;
      this.setThemeTemplate(seriesType, themeTemplate, enterpriseThemeTemplate);
      this.seriesMap.set(seriesType, {
        instanceConstructor: instanceConstructor,
        defaultAxes: defaultAxes,
        paletteFactory: paletteFactory,
        solo: solo,
        stackable: stackable,
        groupable: groupable,
        stackedByDefault: stackedByDefault,
        swapDefaultAxesCondition: swapDefaultAxesCondition
      });
      chartTypes.set(seriesType, chartType2);
      if (!hidden) {
        publicChartTypes.set(seriesType, chartType2);
      }
    }
  }, {
    key: "create",
    value: function create(seriesType, moduleContext) {
      var _a;
      var SeriesConstructor = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.instanceConstructor;
      if (SeriesConstructor) {
        return new SeriesConstructor(moduleContext);
      }
      throw new Error("AG Charts - unknown series type: ".concat(seriesType));
    }
  }, {
    key: "cloneDefaultAxes",
    value: function cloneDefaultAxes(seriesType) {
      var _a;
      var defaultAxes = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.defaultAxes;
      return defaultAxes ? {
        axes: _deepClone2(defaultAxes)
      } : null;
    }
  }, {
    key: "setThemeTemplate",
    value: function setThemeTemplate(seriesType, themeTemplate) {
      var enterpriseThemeTemplate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var currentTemplate = this.themeTemplates.get(seriesType);
      this.themeTemplates.set(seriesType, {
        community: _mergeDefaults4(themeTemplate, currentTemplate == null ? void 0 : currentTemplate.community),
        enterprise: _mergeDefaults4(enterpriseThemeTemplate, themeTemplate, currentTemplate == null ? void 0 : currentTemplate.community)
      });
    }
  }, {
    key: "getThemeTemplate",
    value: function getThemeTemplate(seriesType) {
      var themeTemplate = this.themeTemplates.get(seriesType);
      return _enterpriseModule.isEnterprise ? themeTemplate == null ? void 0 : themeTemplate.enterprise : themeTemplate == null ? void 0 : themeTemplate.community;
    }
  }, {
    key: "getPaletteFactory",
    value: function getPaletteFactory(seriesType) {
      var _a;
      return (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.paletteFactory;
    }
  }, {
    key: "isSolo",
    value: function isSolo(seriesType) {
      var _a, _b;
      return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.solo) != null ? _b : false;
    }
  }, {
    key: "isGroupable",
    value: function isGroupable(seriesType) {
      var _a, _b;
      return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.groupable) != null ? _b : false;
    }
  }, {
    key: "isStackable",
    value: function isStackable(seriesType) {
      var _a, _b;
      return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.stackable) != null ? _b : false;
    }
  }, {
    key: "isStackedByDefault",
    value: function isStackedByDefault(seriesType) {
      var _a, _b;
      return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.stackedByDefault) != null ? _b : false;
    }
  }, {
    key: "isDefaultAxisSwapNeeded",
    value: function isDefaultAxisSwapNeeded(options) {
      var _a, _b, _c;
      var result;
      var _iterator15 = _createForOfIteratorHelper((_a = options.series) != null ? _a : []),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var series = _step15.value;
          var _series$type = series.type,
            type = _series$type === void 0 ? "line" : _series$type;
          var isDefaultAxisSwapped = (_c = (_b = this.seriesMap.get(type)) == null ? void 0 : _b.swapDefaultAxesCondition) == null ? void 0 : _c.call(_b, series);
          if (isDefaultAxisSwapped != null) {
            if (result != null && result != isDefaultAxisSwapped) {
              throw new Error("AG Charts - The provided series have incompatible directions");
            }
            result = isDefaultAxisSwapped;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return result;
    }
  }]);
  return SeriesRegistry;
}();
var seriesRegistry = new SeriesRegistry();

// packages/ag-charts-community/src/chart/factory/legendRegistry.ts
var LegendRegistry = /*#__PURE__*/function () {
  function LegendRegistry() {
    _classCallCheck(this, LegendRegistry);
    this.legendMap = /* @__PURE__ */new Map();
    this.themeTemplates = /* @__PURE__ */new Map();
  }
  _createClass(LegendRegistry, [{
    key: "register",
    value: function register(legendType, _ref7) {
      var optionsKey = _ref7.optionsKey,
        instanceConstructor = _ref7.instanceConstructor,
        themeTemplate = _ref7.themeTemplate;
      this.legendMap.set(legendType, {
        optionsKey: optionsKey,
        instanceConstructor: instanceConstructor
      });
      this.themeTemplates.set(optionsKey, themeTemplate);
    }
  }, {
    key: "create",
    value: function create(legendType, moduleContext) {
      var _a;
      var LegendConstructor = (_a = this.legendMap.get(legendType)) == null ? void 0 : _a.instanceConstructor;
      if (LegendConstructor) {
        return new LegendConstructor(moduleContext);
      }
      throw new Error("AG Charts - unknown legend type: ".concat(legendType));
    }
  }, {
    key: "getThemeTemplates",
    value: function getThemeTemplates() {
      return Object.fromEntries(this.themeTemplates);
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return Array.from(this.legendMap.entries()).reduce(function (result, _ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          legendType = _ref9[0],
          record = _ref9[1];
        result[legendType] = record.optionsKey;
        return result;
      }, {});
    }
  }]);
  return LegendRegistry;
}();
var legendRegistry = new LegendRegistry();

// packages/ag-charts-community/src/chart/themes/constants.ts
var _FONT_SIZE = /* @__PURE__ */function (FONT_SIZE2) {
  FONT_SIZE2[FONT_SIZE2["SMALL"] = 12] = "SMALL";
  FONT_SIZE2[FONT_SIZE2["MEDIUM"] = 13] = "MEDIUM";
  FONT_SIZE2[FONT_SIZE2["LARGE"] = 17] = "LARGE";
  return FONT_SIZE2;
}(_FONT_SIZE || {});
var _FONT_WEIGHT = /* @__PURE__ */function (FONT_WEIGHT3) {
  FONT_WEIGHT3["NORMAL"] = "normal";
  FONT_WEIGHT3["BOLD"] = "bold";
  FONT_WEIGHT3["BOLDER"] = "bolder";
  FONT_WEIGHT3["LIGHTER"] = "lighter";
  return FONT_WEIGHT3;
}(_FONT_WEIGHT || {});
var _POSITION = /* @__PURE__ */function (POSITION3) {
  POSITION3["TOP"] = "top";
  POSITION3["RIGHT"] = "right";
  POSITION3["BOTTOM"] = "bottom";
  POSITION3["LEFT"] = "left";
  return POSITION3;
}(_POSITION || {});
var _CARTESIAN_AXIS_TYPE = /* @__PURE__ */function (CARTESIAN_AXIS_TYPE2) {
  CARTESIAN_AXIS_TYPE2["CATEGORY"] = "category";
  CARTESIAN_AXIS_TYPE2["ORDINAL_TIME"] = "ordinal-time";
  CARTESIAN_AXIS_TYPE2["NUMBER"] = "number";
  CARTESIAN_AXIS_TYPE2["TIME"] = "time";
  CARTESIAN_AXIS_TYPE2["LOG"] = "log";
  return CARTESIAN_AXIS_TYPE2;
}(_CARTESIAN_AXIS_TYPE || {});
var _POLAR_AXIS_TYPE = /* @__PURE__ */function (POLAR_AXIS_TYPE2) {
  POLAR_AXIS_TYPE2["ANGLE_CATEGORY"] = "angle-category";
  POLAR_AXIS_TYPE2["ANGLE_NUMBER"] = "angle-number";
  POLAR_AXIS_TYPE2["RADIUS_CATEGORY"] = "radius-category";
  POLAR_AXIS_TYPE2["RADIUS_NUMBER"] = "radius-number";
  return POLAR_AXIS_TYPE2;
}(_POLAR_AXIS_TYPE || {});
var _POLAR_AXIS_SHAPE = /* @__PURE__ */function (POLAR_AXIS_SHAPE2) {
  POLAR_AXIS_SHAPE2["CIRCLE"] = "circle";
  POLAR_AXIS_SHAPE2["POLYGON"] = "polygon";
  return POLAR_AXIS_SHAPE2;
}(_POLAR_AXIS_SHAPE || {});

// packages/ag-charts-community/src/chart/themes/defaultColors.ts
var DEFAULT_FILLS = {
  BLUE: "#5090dc",
  ORANGE: "#ffa03a",
  GREEN: "#459d55",
  CYAN: "#34bfe1",
  YELLOW: "#e1cc00",
  VIOLET: "#9669cb",
  GRAY: "#b5b5b5",
  MAGENTA: "#bd5aa7",
  BROWN: "#8a6224",
  RED: "#ef5452"
};
var DEFAULT_STROKES = {
  BLUE: "#2b5c95",
  ORANGE: "#cc6f10",
  GREEN: "#1e652e",
  CYAN: "#18859e",
  YELLOW: "#a69400",
  VIOLET: "#603c88",
  GRAY: "#575757",
  MAGENTA: "#7d2f6d",
  BROWN: "#4f3508",
  RED: "#a82529"
};

// packages/ag-charts-community/src/chart/themes/symbols.ts
var _IS_DARK_THEME = Symbol("is-dark-theme");
var _EXTENDS_AXES_DEFAULTS = Symbol("extends-axes-defaults");
var _EXTENDS_AXES_LINE_DEFAULTS = Symbol("extends-axes-line-defaults");
var _EXTENDS_AXES_TICK_DEFAULTS = Symbol("extends-axes-tick-defaults");
var _EXTENDS_AXES_GRID_LINE_DEFAULTS = Symbol("extends-axes-grid-line-defaults");
var _EXTENDS_SERIES_DEFAULTS = Symbol("extends-series-defaults");
var _EXTENDS_CARTESIAN_MARKER_DEFAULTS = Symbol("extends-cartesian-marker-defaults");
var _DEFAULT_FONT_FAMILY = Symbol("default-font");
var _DEFAULT_LABEL_COLOUR = Symbol("default-label-colour");
var _DEFAULT_INVERTED_LABEL_COLOUR = Symbol("default-inverted-label-colour");
var _DEFAULT_INSIDE_SERIES_LABEL_COLOUR = Symbol("default-inside-series-label-colour");
var _DEFAULT_MUTED_LABEL_COLOUR = Symbol("default-muted-label-colour");
var _DEFAULT_AXIS_GRID_COLOUR = Symbol("default-axis-grid-colour");
var _DEFAULT_AXIS_LINE_COLOUR = Symbol("default-axis-line-colour");
var _DEFAULT_CROSS_LINES_COLOUR = Symbol("default-cross-lines-colour");
var _DEFAULT_BACKGROUND_COLOUR = Symbol("default-background-colour");
var _DEFAULT_SHADOW_COLOUR = Symbol("default-shadow-colour");
var _DEFAULT_COLOURS = Symbol("default-colours");
var _DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS = Symbol("default-waterfall-series-positive-colors");
var _DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS = Symbol("default-waterfall-series-negative-colors");
var _DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS = Symbol("default-waterfall-series-total-colors");
var _DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE = Symbol("default-waterfall-series-connector-line-stroke");
var _DEFAULT_POLAR_SERIES_STROKE = Symbol("default-polar-series-stroke");
var _DEFAULT_DIVERGING_SERIES_COLOUR_RANGE = Symbol("default-diverging-series-colour-range");
var _DEFAULT_HIERARCHY_FILLS = Symbol("default-hierarchy-fills");
var _DEFAULT_HIERARCHY_STROKES = Symbol("default-hierarchy-strokes");
var _DEFAULT_ANNOTATION_STROKE = Symbol("default-annotation-stroke");
var _DEFAULT_ANNOTATION_BACKGROUND_FILL = Symbol("default-annotation-background-fill");
var _DEFAULT_ANNOTATION_HANDLE_FILL = Symbol("default-annotation-handle-fill");

// packages/ag-charts-community/src/chart/themes/chartTheme.ts
var DEFAULT_BACKGROUND_FILL = "white";
var DEFAULT_PALETTE = {
  fills: Object.values(DEFAULT_FILLS),
  strokes: Object.values(DEFAULT_STROKES)
};
var CHART_TYPE_CONFIG = {
  get cartesian() {
    return {
      seriesTypes: chartTypes.cartesianTypes,
      commonOptions: ["zoom", "navigator"]
    };
  },
  get polar() {
    return {
      seriesTypes: chartTypes.polarTypes,
      commonOptions: []
    };
  },
  get hierarchy() {
    return {
      seriesTypes: chartTypes.hierarchyTypes,
      commonOptions: []
    };
  },
  get topology() {
    return {
      seriesTypes: chartTypes.topologyTypes,
      commonOptions: []
    };
  }
};
var CHART_TYPE_SPECIFIC_COMMON_OPTIONS = Object.values(CHART_TYPE_CONFIG).reduce(function (r, _ref0) {
  var commonOptions = _ref0.commonOptions;
  return r.concat(commonOptions);
}, []);
var _ChartTheme = /*#__PURE__*/function () {
  _createClass(_ChartTheme, [{
    key: "getPalette",
    value: function getPalette() {
      return DEFAULT_PALETTE;
    }
  }], [{
    key: "getAxisDefaults",
    value: function getAxisDefaults(overrideDefaults) {
      return _mergeDefaults4(overrideDefaults, {
        title: {
          enabled: false,
          text: "Axis Title",
          spacing: 25,
          fontWeight: "normal" /* NORMAL */,
          fontSize: 13 /* MEDIUM */,
          fontFamily: _DEFAULT_FONT_FAMILY,
          color: _DEFAULT_LABEL_COLOUR
        },
        label: {
          fontSize: 12 /* SMALL */,
          fontFamily: _DEFAULT_FONT_FAMILY,
          padding: 5,
          color: _DEFAULT_LABEL_COLOUR,
          avoidCollisions: true
        },
        line: {
          enabled: true,
          width: 1,
          color: _DEFAULT_AXIS_LINE_COLOUR
        },
        tick: {
          enabled: false,
          width: 1,
          color: _DEFAULT_AXIS_LINE_COLOUR
        },
        gridLine: {
          enabled: true,
          style: [{
            stroke: _DEFAULT_AXIS_GRID_COLOUR,
            lineDash: []
          }]
        },
        crossLines: {
          enabled: false,
          fill: _DEFAULT_CROSS_LINES_COLOUR,
          stroke: _DEFAULT_CROSS_LINES_COLOUR,
          fillOpacity: 0.1,
          strokeWidth: 1,
          label: {
            enabled: false,
            fontSize: 12 /* SMALL */,
            fontFamily: _DEFAULT_FONT_FAMILY,
            padding: 5,
            color: _DEFAULT_LABEL_COLOUR
          }
        }
      });
    }
  }, {
    key: "getSeriesDefaults",
    value: function getSeriesDefaults() {
      return {
        visible: true,
        showInLegend: true,
        highlightStyle: {
          item: {
            fill: "#ffffff54",
            stroke: "#0006",
            strokeWidth: 2
          },
          series: {
            dimOpacity: 1
          }
        },
        nodeClickRange: "exact",
        tooltip: {
          enabled: true
        }
      };
    }
  }, {
    key: "getCartesianSeriesMarkerDefaults",
    value: function getCartesianSeriesMarkerDefaults() {
      return {
        enabled: true,
        shape: "circle",
        size: 7,
        strokeWidth: 1
      };
    }
  }, {
    key: "getChartDefaults",
    value: function getChartDefaults() {
      return {
        background: {
          visible: true,
          fill: _DEFAULT_BACKGROUND_COLOUR
        },
        padding: {
          top: 20,
          right: 20,
          bottom: 20,
          left: 20
        },
        keyboard: {
          enabled: true
        },
        title: {
          enabled: false,
          text: "Title",
          fontWeight: "normal" /* NORMAL */,
          fontSize: 17 /* LARGE */,
          fontFamily: _DEFAULT_FONT_FAMILY,
          color: _DEFAULT_LABEL_COLOUR,
          wrapping: "hyphenate"
        },
        subtitle: {
          enabled: false,
          text: "Subtitle",
          spacing: 20,
          fontSize: 13 /* MEDIUM */,
          fontFamily: _DEFAULT_FONT_FAMILY,
          color: _DEFAULT_MUTED_LABEL_COLOUR,
          wrapping: "hyphenate"
        },
        footnote: {
          enabled: false,
          text: "Footnote",
          spacing: 20,
          fontSize: 13 /* MEDIUM */,
          fontFamily: _DEFAULT_FONT_FAMILY,
          color: "rgb(140, 140, 140)",
          wrapping: "hyphenate"
        },
        legend: {
          position: "bottom" /* BOTTOM */,
          spacing: 30,
          listeners: {},
          item: {
            paddingX: 16,
            paddingY: 8,
            marker: {
              size: 15,
              padding: 8
            },
            toggleSeriesVisible: true,
            label: {
              color: _DEFAULT_LABEL_COLOUR,
              fontSize: 12 /* SMALL */,
              fontFamily: _DEFAULT_FONT_FAMILY
            }
          },
          reverseOrder: false,
          pagination: {
            marker: {
              size: 12
            },
            activeStyle: {
              fill: _DEFAULT_LABEL_COLOUR
            },
            inactiveStyle: {
              fill: _DEFAULT_MUTED_LABEL_COLOUR
            },
            highlightStyle: {
              fill: _DEFAULT_LABEL_COLOUR
            },
            label: {
              color: _DEFAULT_LABEL_COLOUR
            }
          }
        },
        tooltip: {
          enabled: true,
          darkTheme: _IS_DARK_THEME,
          range: "nearest",
          delay: 0
        },
        overlays: {
          loading: {
            darkTheme: _IS_DARK_THEME
          },
          noData: {
            darkTheme: _IS_DARK_THEME
          },
          noVisibleSeries: {
            darkTheme: _IS_DARK_THEME
          }
        },
        listeners: {}
      };
    }
  }]);
  function _ChartTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, _ChartTheme);
    var _deepClone = _deepClone2(options),
      overrides = _deepClone.overrides,
      palette10 = _deepClone.palette;
    var defaults = this.createChartConfigPerChartType(this.getDefaults());
    if (overrides) {
      this.mergeOverrides(defaults, overrides);
    }
    this.config = Object.freeze(this.templateTheme(defaults));
    this.palette = _mergeDefaults4(palette10, this.getPalette());
  }
  _createClass(_ChartTheme, [{
    key: "mergeOverrides",
    value: function mergeOverrides(defaults, overrides) {
      for (var _i8 = 0, _Object$values = Object.values(CHART_TYPE_CONFIG); _i8 < _Object$values.length; _i8++) {
        var _Object$values$_i = _Object$values[_i8],
          seriesTypes = _Object$values$_i.seriesTypes,
          commonOptions = _Object$values$_i.commonOptions;
        var cleanedCommon = __spreadValues({}, overrides.common);
        var _iterator16 = _createForOfIteratorHelper(CHART_TYPE_SPECIFIC_COMMON_OPTIONS),
          _step16;
        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var commonKey = _step16.value;
            if (!commonOptions.includes(commonKey)) {
              delete cleanedCommon[commonKey];
            }
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
        if (!cleanedCommon) continue;
        var _iterator17 = _createForOfIteratorHelper(seriesTypes),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var s = _step17.value;
            var seriesType = s;
            defaults[seriesType] = _mergeDefaults4(cleanedCommon, defaults[seriesType]);
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
      }
      chartTypes.seriesTypes.forEach(function (s) {
        var seriesType = s;
        if (overrides[seriesType]) {
          defaults[seriesType] = _mergeDefaults4(overrides[seriesType], defaults[seriesType]);
        }
      });
    }
  }, {
    key: "createChartConfigPerChartType",
    value: function createChartConfigPerChartType(config) {
      for (var _i9 = 0, _Object$entries = Object.entries(CHART_TYPE_CONFIG); _i9 < _Object$entries.length; _i9++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i9], 2),
          nextType = _Object$entries$_i[0],
          seriesTypes = _Object$entries$_i[1].seriesTypes;
        var typeDefaults = chartDefaults.get(nextType);
        var _iterator18 = _createForOfIteratorHelper(seriesTypes),
          _step18;
        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var seriesType = _step18.value;
            config[seriesType] || (config[seriesType] = _deepClone2(typeDefaults));
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }
      return config;
    }
  }, {
    key: "getDefaults",
    value: function getDefaults() {
      var getOverridesByType = function getOverridesByType(chartType2, seriesTypes) {
        var _a;
        var result = {};
        var chartTypeDefaults = __spreadValues(__spreadValues(__spreadValues({
          axes: {}
        }, legendRegistry.getThemeTemplates()), _ChartTheme.getChartDefaults()), chartDefaults.get(chartType2));
        var _iterator19 = _createForOfIteratorHelper(seriesTypes),
          _step19;
        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var seriesType = _step19.value;
            result[seriesType] = _mergeDefaults4(seriesRegistry.getThemeTemplate(seriesType), (_a = result[seriesType]) != null ? _a : _deepClone2(chartTypeDefaults));
            var axes = result[seriesType].axes;
            var _iterator20 = _createForOfIteratorHelper(axisRegistry.keys()),
              _step20;
            try {
              for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                var axisType = _step20.value;
                axes[axisType] = _mergeDefaults4(axes[axisType], axisRegistry.getThemeTemplate(axisType), chartType2 === "cartesian" && _ChartTheme.cartesianAxisDefault[axisType]);
              }
            } catch (err) {
              _iterator20.e(err);
            } finally {
              _iterator20.f();
            }
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
        return result;
      };
      return _mergeDefaults4(getOverridesByType("cartesian", chartTypes.cartesianTypes), getOverridesByType("polar", chartTypes.polarTypes), getOverridesByType("hierarchy", chartTypes.hierarchyTypes), getOverridesByType("topology", chartTypes.topologyTypes));
    }
  }, {
    key: "templateTheme",
    value: function templateTheme(themeTemplate) {
      var themeInstance = _deepClone2(themeTemplate);
      var _this$getTemplatePara = this.getTemplateParameters(),
        extensions = _this$getTemplatePara.extensions,
        properties = _this$getTemplatePara.properties;
      _jsonWalk(themeInstance, function (node) {
        if (node["__extends__"]) {
          var extendsValue = node["__extends__"];
          var source = extensions.get(extendsValue);
          if (source == null) {
            throw new Error("AG Charts - no template variable provided for: ".concat(extendsValue));
          }
          Object.keys(source).forEach(function (key) {
            if (!(key in node)) {
              node[key] = source[key];
            } else if (_isObject(node[key])) {
              node[key] = _mergeDefaults4(node[key], source[key]);
            }
          });
          delete node["__extends__"];
        }
        if (_isArray(node)) {
          for (var i = 0; i < node.length; i++) {
            var symbol = node[i];
            if (properties.has(symbol)) {
              node[i] = properties.get(symbol);
            }
          }
        } else {
          for (var _i0 = 0, _Object$entries2 = Object.entries(node); _i0 < _Object$entries2.length; _i0++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i0], 2),
              name = _Object$entries2$_i[0],
              value = _Object$entries2$_i[1];
            if (properties.has(value)) {
              node[name] = properties.get(value);
            }
          }
        }
      });
      return _deepClone2(themeInstance);
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var extensions = /* @__PURE__ */new Map();
      extensions.set(_EXTENDS_AXES_DEFAULTS, _ChartTheme.getAxisDefaults());
      extensions.set(_EXTENDS_AXES_LINE_DEFAULTS, _ChartTheme.getAxisDefaults().line);
      extensions.set(_EXTENDS_AXES_TICK_DEFAULTS, _ChartTheme.getAxisDefaults().tick);
      extensions.set(_EXTENDS_AXES_GRID_LINE_DEFAULTS, _ChartTheme.getAxisDefaults().gridLine);
      extensions.set(_EXTENDS_SERIES_DEFAULTS, _ChartTheme.getSeriesDefaults());
      extensions.set(_EXTENDS_CARTESIAN_MARKER_DEFAULTS, _ChartTheme.getCartesianSeriesMarkerDefaults());
      var properties = /* @__PURE__ */new Map();
      properties.set(_IS_DARK_THEME, false);
      properties.set(_DEFAULT_FONT_FAMILY, "Verdana, sans-serif");
      properties.set(_DEFAULT_LABEL_COLOUR, "rgb(70, 70, 70)");
      properties.set(_DEFAULT_INVERTED_LABEL_COLOUR, "white");
      properties.set(_DEFAULT_MUTED_LABEL_COLOUR, "rgb(140, 140, 140)");
      properties.set(_DEFAULT_AXIS_GRID_COLOUR, "rgb(224,234,241)");
      properties.set(_DEFAULT_AXIS_LINE_COLOUR, "rgb(195, 195, 195)");
      properties.set(_DEFAULT_CROSS_LINES_COLOUR, "rgb(70, 70, 70)");
      properties.set(_DEFAULT_INSIDE_SERIES_LABEL_COLOUR, DEFAULT_BACKGROUND_FILL);
      properties.set(_DEFAULT_BACKGROUND_COLOUR, DEFAULT_BACKGROUND_FILL);
      properties.set(_DEFAULT_SHADOW_COLOUR, "rgba(0, 0, 0, 0.5)");
      properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [DEFAULT_FILLS.ORANGE, DEFAULT_FILLS.YELLOW, DEFAULT_FILLS.GREEN]);
      properties.set(_DEFAULT_HIERARCHY_FILLS, ["#ffffff", "#e0e5ea", "#c1ccd5", "#a3b4c1", "#859cad"]);
      properties.set(_DEFAULT_HIERARCHY_STROKES, ["#ffffff", "#c5cbd1", "#a4b1bd", "#8498a9", "#648096"]);
      properties.set(_DEFAULT_POLAR_SERIES_STROKE, DEFAULT_BACKGROUND_FILL);
      properties.set(_DEFAULT_COLOURS, _ChartTheme.getDefaultColors());
      properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _ChartTheme.getWaterfallSeriesDefaultPositiveColors());
      properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _ChartTheme.getWaterfallSeriesDefaultNegativeColors());
      properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _ChartTheme.getWaterfallSeriesDefaultTotalColors());
      properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _ChartTheme.getWaterfallSeriesDefaultTotalColors().stroke);
      properties.set(_DEFAULT_ANNOTATION_STROKE, DEFAULT_STROKES.BLUE);
      properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, DEFAULT_FILLS.BLUE);
      properties.set(_DEFAULT_ANNOTATION_HANDLE_FILL, DEFAULT_BACKGROUND_FILL);
      return {
        extensions: extensions,
        properties: properties
      };
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: DEFAULT_FILLS,
        strokes: DEFAULT_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: DEFAULT_FILLS.BLUE,
        stroke: DEFAULT_STROKES.BLUE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: DEFAULT_FILLS.ORANGE,
        stroke: DEFAULT_STROKES.ORANGE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: DEFAULT_FILLS.GRAY,
        stroke: DEFAULT_STROKES.GRAY,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }]);
  return _ChartTheme;
}();
_ChartTheme.cartesianAxisDefault = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "number" /* NUMBER */, _ChartTheme.getAxisDefaults({
  line: {
    enabled: false
  }
})), "log" /* LOG */, _ChartTheme.getAxisDefaults({
  base: 10,
  line: {
    enabled: false
  }
})), "category" /* CATEGORY */, _ChartTheme.getAxisDefaults({
  groupPaddingInner: 0.1,
  label: {
    autoRotate: true
  },
  gridLine: {
    enabled: false
  }
})), "time" /* TIME */, _ChartTheme.getAxisDefaults({
  gridLine: {
    enabled: false
  }
})), "grouped-category", _ChartTheme.getAxisDefaults());
var _ChartTheme7 = _ChartTheme;

// packages/ag-charts-community/src/chart/themes/darkTheme.ts
var DEFAULT_DARK_BACKGROUND_FILL = "#192232";
var DEFAULT_DARK_FILLS = {
  BLUE: "#5090dc",
  ORANGE: "#ffa03a",
  GREEN: "#459d55",
  CYAN: "#34bfe1",
  YELLOW: "#e1cc00",
  VIOLET: "#9669cb",
  GRAY: "#b5b5b5",
  MAGENTA: "#bd5aa7",
  BROWN: "#8a6224",
  RED: "#ef5452"
};
var DEFAULT_DARK_STROKES = {
  BLUE: "#74a8e6",
  ORANGE: "#ffbe70",
  GREEN: "#6cb176",
  CYAN: "#75d4ef",
  YELLOW: "#f6e559",
  VIOLET: "#aa86d8",
  GRAY: "#a1a1a1",
  MAGENTA: "#ce7ab9",
  BROWN: "#997b52",
  RED: "#ff7872"
};
var palette = {
  fills: Object.values(DEFAULT_DARK_FILLS),
  strokes: Object.values(DEFAULT_DARK_STROKES)
};
var DarkTheme = /*#__PURE__*/function (_ChartTheme2) {
  _inherits(_DarkTheme, _ChartTheme2);
  _createClass(_DarkTheme, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_DarkTheme, "getTemplateParameters", this, 3)([]);
      result.properties.set(_IS_DARK_THEME, true);
      result.properties.set(_DEFAULT_COLOURS, _DarkTheme.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _DarkTheme.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _DarkTheme.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _DarkTheme.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _DarkTheme.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_POLAR_SERIES_STROKE, DEFAULT_DARK_BACKGROUND_FILL);
      result.properties.set(_DEFAULT_LABEL_COLOUR, "white");
      result.properties.set(_DEFAULT_MUTED_LABEL_COLOUR, "#7D91A0");
      result.properties.set(_DEFAULT_AXIS_GRID_COLOUR, "#545A6E");
      result.properties.set(_DEFAULT_CROSS_LINES_COLOUR, "white");
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [DEFAULT_DARK_FILLS.ORANGE, DEFAULT_DARK_FILLS.YELLOW, DEFAULT_DARK_FILLS.GREEN]);
      result.properties.set(_DEFAULT_HIERARCHY_FILLS, ["#192834", "#253746", "#324859", "#3f596c", "#4d6a80"]);
      result.properties.set(_DEFAULT_HIERARCHY_STROKES, ["#192834", "#3b5164", "#496275", "#577287", "#668399"]);
      result.properties.set(_DEFAULT_BACKGROUND_COLOUR, DEFAULT_DARK_BACKGROUND_FILL);
      result.properties.set(_DEFAULT_INSIDE_SERIES_LABEL_COLOUR, DEFAULT_DARK_BACKGROUND_FILL);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, DEFAULT_DARK_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, DEFAULT_DARK_FILLS.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_HANDLE_FILL, DEFAULT_DARK_BACKGROUND_FILL);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: DEFAULT_DARK_FILLS,
        strokes: DEFAULT_DARK_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: DEFAULT_DARK_FILLS.BLUE,
        stroke: DEFAULT_DARK_STROKES.BLUE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: DEFAULT_DARK_FILLS.ORANGE,
        stroke: DEFAULT_DARK_STROKES.ORANGE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: DEFAULT_DARK_FILLS.GRAY,
        stroke: DEFAULT_DARK_STROKES.GRAY,
        label: {
          color: "white"
        }
      };
    }
  }]);
  function _DarkTheme(options) {
    _classCallCheck(this, _DarkTheme);
    return _possibleConstructorReturn(this, _getPrototypeOf(_DarkTheme).call(this, options));
  }
  return _DarkTheme;
}(_ChartTheme7);

// packages/ag-charts-community/src/chart/themes/materialDark.ts
var MATERIAL_DARK_FILLS = {
  BLUE: "#2196F3",
  ORANGE: "#FF9800",
  GREEN: "#4CAF50",
  CYAN: "#00BCD4",
  YELLOW: "#FFEB3B",
  VIOLET: "#7E57C2",
  GRAY: "#9E9E9E",
  MAGENTA: "#F06292",
  BROWN: "#795548",
  RED: "#F44336"
};
var MATERIAL_DARK_STROKES = {
  BLUE: "#90CAF9",
  ORANGE: "#FFCC80",
  GREEN: "#A5D6A7",
  CYAN: "#80DEEA",
  YELLOW: "#FFF9C4",
  VIOLET: "#B39DDB",
  GRAY: "#E0E0E0",
  MAGENTA: "#F48FB1",
  BROWN: "#A1887F",
  RED: "#EF9A9A"
};
var palette2 = {
  fills: Object.values(MATERIAL_DARK_FILLS),
  strokes: Object.values(MATERIAL_DARK_STROKES)
};
var MaterialDark = /*#__PURE__*/function (_DarkTheme2) {
  _inherits(_MaterialDark, _DarkTheme2);
  function _MaterialDark() {
    _classCallCheck(this, _MaterialDark);
    return _possibleConstructorReturn(this, _getPrototypeOf(_MaterialDark).apply(this, arguments));
  }
  _createClass(_MaterialDark, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_MaterialDark, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _MaterialDark.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _MaterialDark.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _MaterialDark.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _MaterialDark.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [MATERIAL_DARK_FILLS.ORANGE, MATERIAL_DARK_FILLS.YELLOW, MATERIAL_DARK_FILLS.GREEN]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _MaterialDark.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, MATERIAL_DARK_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, MATERIAL_DARK_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette2;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: MATERIAL_DARK_FILLS,
        strokes: MATERIAL_DARK_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: MATERIAL_DARK_FILLS.BLUE,
        stroke: MATERIAL_DARK_STROKES.BLUE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: MATERIAL_DARK_FILLS.RED,
        stroke: MATERIAL_DARK_STROKES.RED,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: MATERIAL_DARK_FILLS.GRAY,
        stroke: MATERIAL_DARK_STROKES.GRAY,
        label: {
          color: "white"
        }
      };
    }
  }]);
  return _MaterialDark;
}(DarkTheme);

// packages/ag-charts-community/src/chart/themes/materialLight.ts
var MATERIAL_LIGHT_FILLS = {
  BLUE: "#2196F3",
  ORANGE: "#FF9800",
  GREEN: "#4CAF50",
  CYAN: "#00BCD4",
  YELLOW: "#FFEB3B",
  VIOLET: "#7E57C2",
  GRAY: "#9E9E9E",
  MAGENTA: "#F06292",
  BROWN: "#795548",
  RED: "#F44336"
};
var MATERIAL_LIGHT_STROKES = {
  BLUE: "#1565C0",
  ORANGE: "#E65100",
  GREEN: "#2E7D32",
  CYAN: "#00838F",
  YELLOW: "#F9A825",
  VIOLET: "#4527A0",
  GRAY: "#616161",
  MAGENTA: "#C2185B",
  BROWN: "#4E342E",
  RED: "#B71C1C"
};
var palette3 = {
  fills: Object.values(MATERIAL_LIGHT_FILLS),
  strokes: Object.values(MATERIAL_LIGHT_STROKES)
};
var MaterialLight = /*#__PURE__*/function (_ChartTheme3) {
  _inherits(_MaterialLight, _ChartTheme3);
  function _MaterialLight() {
    _classCallCheck(this, _MaterialLight);
    return _possibleConstructorReturn(this, _getPrototypeOf(_MaterialLight).apply(this, arguments));
  }
  _createClass(_MaterialLight, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_MaterialLight, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _MaterialLight.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _MaterialLight.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _MaterialLight.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _MaterialLight.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [MATERIAL_LIGHT_FILLS.ORANGE, MATERIAL_LIGHT_FILLS.YELLOW, MATERIAL_LIGHT_FILLS.GREEN]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _MaterialLight.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, MATERIAL_LIGHT_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, MATERIAL_LIGHT_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette3;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: MATERIAL_LIGHT_FILLS,
        strokes: MATERIAL_LIGHT_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: MATERIAL_LIGHT_FILLS.BLUE,
        stroke: MATERIAL_LIGHT_STROKES.BLUE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: MATERIAL_LIGHT_FILLS.RED,
        stroke: MATERIAL_LIGHT_STROKES.RED,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: MATERIAL_LIGHT_FILLS.GRAY,
        stroke: MATERIAL_LIGHT_STROKES.GRAY,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }]);
  return _MaterialLight;
}(_ChartTheme7);

// packages/ag-charts-community/src/chart/themes/polychromaDark.ts
var POLYCHROMA_DARK_FILLS = {
  BLUE: "#436ff4",
  PURPLE: "#9a7bff",
  MAGENTA: "#d165d2",
  PINK: "#f0598b",
  RED: "#f47348",
  ORANGE: "#f2a602",
  YELLOW: "#e9e201",
  GREEN: "#21b448",
  CYAN: "#00b9a2",
  MODERATE_BLUE: "#00aee4"
};
var POLYCHROMA_DARK_STROKES = {
  BLUE: "#6698ff",
  PURPLE: "#c0a3ff",
  MAGENTA: "#fc8dfc",
  PINK: "#ff82b1",
  RED: "#ff9b70",
  ORANGE: "#ffcf4e",
  YELLOW: "#ffff58",
  GREEN: "#58dd70",
  CYAN: "#51e2c9",
  MODERATE_BLUE: "#4fd7ff"
};
var POLYCHROMA_DARK_FILL_GRAY = "#bbbbbb";
var POLYCHROMA_DARK_STROKE_GRAY = "#eeeeee";
var palette4 = {
  fills: Object.values(POLYCHROMA_DARK_FILLS),
  strokes: Object.values(POLYCHROMA_DARK_STROKES)
};
var PolychromaDark = /*#__PURE__*/function (_DarkTheme3) {
  _inherits(_PolychromaDark, _DarkTheme3);
  function _PolychromaDark() {
    _classCallCheck(this, _PolychromaDark);
    return _possibleConstructorReturn(this, _getPrototypeOf(_PolychromaDark).apply(this, arguments));
  }
  _createClass(_PolychromaDark, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_PolychromaDark, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _PolychromaDark.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _PolychromaDark.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _PolychromaDark.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _PolychromaDark.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [POLYCHROMA_DARK_FILLS.BLUE, POLYCHROMA_DARK_FILLS.RED]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _PolychromaDark.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, POLYCHROMA_DARK_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, POLYCHROMA_DARK_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette4;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: POLYCHROMA_DARK_FILLS,
        strokes: POLYCHROMA_DARK_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: POLYCHROMA_DARK_FILLS.BLUE,
        stroke: POLYCHROMA_DARK_STROKES.BLUE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: POLYCHROMA_DARK_FILLS.RED,
        stroke: POLYCHROMA_DARK_STROKES.RED,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: POLYCHROMA_DARK_FILL_GRAY,
        stroke: POLYCHROMA_DARK_STROKE_GRAY,
        label: {
          color: "white"
        }
      };
    }
  }]);
  return _PolychromaDark;
}(DarkTheme);

// packages/ag-charts-community/src/chart/themes/polychromaLight.ts
var POLYCHROMA_LIGHT_FILLS = {
  BLUE: "#436ff4",
  PURPLE: "#9a7bff",
  MAGENTA: "#d165d2",
  PINK: "#f0598b",
  RED: "#f47348",
  ORANGE: "#f2a602",
  YELLOW: "#e9e201",
  GREEN: "#21b448",
  CYAN: "#00b9a2",
  MODERATE_BLUE: "#00aee4"
};
var POLYCHROMA_LIGHT_STROKES = {
  BLUE: "#2346c9",
  PURPLE: "#7653d4",
  MAGENTA: "#a73da9",
  PINK: "#c32d66",
  RED: "#c84b1c",
  ORANGE: "#c87f00",
  YELLOW: "#c1b900",
  GREEN: "#008c1c",
  CYAN: "#00927c",
  MODERATE_BLUE: "#0087bb"
};
var POLYCHROMA_LIGHT_FILL_GRAY = "#bbbbbb";
var POLYCHROMA_LIGHT_STROKE_GRAY = "#888888";
var palette5 = {
  fills: Object.values(POLYCHROMA_LIGHT_FILLS),
  strokes: Object.values(POLYCHROMA_LIGHT_STROKES)
};
var PolychromaLight = /*#__PURE__*/function (_ChartTheme4) {
  _inherits(_PolychromaLight, _ChartTheme4);
  function _PolychromaLight() {
    _classCallCheck(this, _PolychromaLight);
    return _possibleConstructorReturn(this, _getPrototypeOf(_PolychromaLight).apply(this, arguments));
  }
  _createClass(_PolychromaLight, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_PolychromaLight, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _PolychromaLight.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _PolychromaLight.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _PolychromaLight.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _PolychromaLight.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [POLYCHROMA_LIGHT_FILLS.BLUE, POLYCHROMA_LIGHT_FILLS.RED]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _PolychromaLight.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, POLYCHROMA_LIGHT_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, POLYCHROMA_LIGHT_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette5;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: POLYCHROMA_LIGHT_FILLS,
        strokes: POLYCHROMA_LIGHT_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: POLYCHROMA_LIGHT_FILLS.BLUE,
        stroke: POLYCHROMA_LIGHT_STROKES.BLUE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: POLYCHROMA_LIGHT_FILLS.RED,
        stroke: POLYCHROMA_LIGHT_STROKES.RED,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: POLYCHROMA_LIGHT_FILL_GRAY,
        stroke: POLYCHROMA_LIGHT_STROKE_GRAY,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }]);
  return _PolychromaLight;
}(_ChartTheme7);

// packages/ag-charts-community/src/chart/themes/sheetsDark.ts
var SHEETS_DARK_FILLS = {
  BLUE: "#4472C4",
  ORANGE: "#ED7D31",
  GRAY: "#A5A5A5",
  YELLOW: "#FFC000",
  MODERATE_BLUE: "#5B9BD5",
  GREEN: "#70AD47",
  DARK_GRAY: "#7B7B7B",
  DARK_BLUE: "#264478",
  VERY_DARK_GRAY: "#636363",
  DARK_YELLOW: "#997300"
};
var SHEETS_DARK_STROKES = {
  BLUE: "#6899ee",
  ORANGE: "#ffa55d",
  GRAY: "#cdcdcd",
  YELLOW: "#ffea53",
  MODERATE_BLUE: "#82c3ff",
  GREEN: "#96d56f",
  DARK_GRAY: "#a1a1a1",
  DARK_BLUE: "#47689f",
  VERY_DARK_GRAY: "#878787",
  DARK_YELLOW: "#c0993d"
};
var palette6 = {
  fills: Object.values(SHEETS_DARK_FILLS),
  strokes: Object.values(SHEETS_DARK_STROKES)
};
var SheetsDark = /*#__PURE__*/function (_DarkTheme4) {
  _inherits(_SheetsDark, _DarkTheme4);
  function _SheetsDark() {
    _classCallCheck(this, _SheetsDark);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SheetsDark).apply(this, arguments));
  }
  _createClass(_SheetsDark, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_SheetsDark, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _SheetsDark.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _SheetsDark.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _SheetsDark.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _SheetsDark.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [SHEETS_DARK_FILLS.ORANGE, SHEETS_DARK_FILLS.YELLOW, SHEETS_DARK_FILLS.GREEN]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _SheetsDark.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, SHEETS_DARK_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, SHEETS_DARK_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette6;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: __spreadProps(__spreadValues({}, SHEETS_DARK_FILLS), {
          RED: SHEETS_DARK_FILLS.ORANGE
        }),
        strokes: __spreadProps(__spreadValues({}, SHEETS_DARK_STROKES), {
          RED: SHEETS_DARK_STROKES.ORANGE
        })
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: SHEETS_DARK_FILLS.BLUE,
        stroke: SHEETS_DARK_STROKES.BLUE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: SHEETS_DARK_FILLS.ORANGE,
        stroke: SHEETS_DARK_STROKES.ORANGE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: SHEETS_DARK_FILLS.GRAY,
        stroke: SHEETS_DARK_STROKES.GRAY,
        label: {
          color: "white"
        }
      };
    }
  }]);
  return _SheetsDark;
}(DarkTheme);

// packages/ag-charts-community/src/chart/themes/sheetsLight.ts
var SHEETS_LIGHT_FILLS = {
  BLUE: "#5281d5",
  ORANGE: "#ff8d44",
  GRAY: "#b5b5b5",
  YELLOW: "#ffd02f",
  MODERATE_BLUE: "#6aabe6",
  GREEN: "#7fbd57",
  DARK_GRAY: "#8a8a8a",
  DARK_BLUE: "#335287",
  VERY_DARK_GRAY: "#717171",
  DARK_YELLOW: "#a98220"
};
var SHEETS_LIGHT_STROKES = {
  BLUE: "#214d9b",
  ORANGE: "#c25600",
  GRAY: "#7f7f7f",
  YELLOW: "#d59800",
  MODERATE_BLUE: "#3575ac",
  GREEN: "#4b861a",
  DARK_GRAY: "#575757",
  DARK_BLUE: "#062253",
  VERY_DARK_GRAY: "#414141",
  DARK_YELLOW: "#734f00"
};
var palette7 = {
  fills: Object.values(SHEETS_LIGHT_FILLS),
  strokes: Object.values(SHEETS_LIGHT_STROKES)
};
var SheetsLight = /*#__PURE__*/function (_ChartTheme5) {
  _inherits(_SheetsLight, _ChartTheme5);
  function _SheetsLight() {
    _classCallCheck(this, _SheetsLight);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SheetsLight).apply(this, arguments));
  }
  _createClass(_SheetsLight, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_SheetsLight, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _SheetsLight.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _SheetsLight.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _SheetsLight.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _SheetsLight.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [SHEETS_LIGHT_FILLS.ORANGE, SHEETS_LIGHT_FILLS.YELLOW, SHEETS_LIGHT_FILLS.GREEN]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _SheetsLight.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, SHEETS_LIGHT_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, SHEETS_LIGHT_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette7;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: __spreadProps(__spreadValues({}, SHEETS_LIGHT_FILLS), {
          RED: SHEETS_LIGHT_FILLS.ORANGE
        }),
        strokes: __spreadProps(__spreadValues({}, SHEETS_LIGHT_STROKES), {
          RED: SHEETS_LIGHT_STROKES.ORANGE
        })
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: SHEETS_LIGHT_FILLS.BLUE,
        stroke: SHEETS_LIGHT_STROKES.BLUE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: SHEETS_LIGHT_FILLS.ORANGE,
        stroke: SHEETS_LIGHT_STROKES.ORANGE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: SHEETS_LIGHT_FILLS.GRAY,
        stroke: SHEETS_LIGHT_STROKES.GRAY,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }]);
  return _SheetsLight;
}(_ChartTheme7);

// packages/ag-charts-community/src/chart/themes/vividDark.ts
var VIVID_DARK_FILLS = {
  BLUE: "#0083ff",
  ORANGE: "#ff6600",
  GREEN: "#00af00",
  CYAN: "#00ccff",
  YELLOW: "#f7c700",
  VIOLET: "#ac26ff",
  GRAY: "#a7a7b7",
  MAGENTA: "#e800c5",
  BROWN: "#b54300",
  RED: "#ff0000"
};
var VIVID_DARK_STROKES = {
  BLUE: "#67b7ff",
  ORANGE: "#ffc24d",
  GREEN: "#5cc86f",
  CYAN: "#54ebff",
  VIOLET: "#c18aff",
  YELLOW: "#fff653",
  GRAY: "#aeaeae",
  MAGENTA: "#f078d4",
  BROWN: "#ba8438",
  RED: "#ff726e"
};
var palette8 = {
  fills: Object.values(VIVID_DARK_FILLS),
  strokes: Object.values(VIVID_DARK_STROKES)
};
var VividDark = /*#__PURE__*/function (_DarkTheme5) {
  _inherits(_VividDark, _DarkTheme5);
  function _VividDark() {
    _classCallCheck(this, _VividDark);
    return _possibleConstructorReturn(this, _getPrototypeOf(_VividDark).apply(this, arguments));
  }
  _createClass(_VividDark, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_VividDark, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _VividDark.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _VividDark.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _VividDark.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _VividDark.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [VIVID_DARK_FILLS.ORANGE, VIVID_DARK_FILLS.YELLOW, VIVID_DARK_FILLS.GREEN]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _VividDark.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, VIVID_DARK_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, VIVID_DARK_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette8;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: VIVID_DARK_FILLS,
        strokes: VIVID_DARK_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: VIVID_DARK_FILLS.BLUE,
        stroke: VIVID_DARK_STROKES.BLUE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: VIVID_DARK_FILLS.ORANGE,
        stroke: VIVID_DARK_STROKES.ORANGE,
        label: {
          color: "white"
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: VIVID_DARK_FILLS.GRAY,
        stroke: VIVID_DARK_STROKES.GRAY,
        label: {
          color: "white"
        }
      };
    }
  }]);
  return _VividDark;
}(DarkTheme);

// packages/ag-charts-community/src/chart/themes/vividLight.ts
var VIVID_FILLS = {
  BLUE: "#0083ff",
  ORANGE: "#ff6600",
  GREEN: "#00af00",
  CYAN: "#00ccff",
  YELLOW: "#f7c700",
  VIOLET: "#ac26ff",
  GRAY: "#a7a7b7",
  MAGENTA: "#e800c5",
  BROWN: "#b54300",
  RED: "#ff0000"
};
var VIVID_STROKES = {
  BLUE: "#0f68c0",
  ORANGE: "#d47100",
  GREEN: "#007922",
  CYAN: "#009ac2",
  VIOLET: "#bca400",
  YELLOW: "#753cac",
  GRAY: "#646464",
  MAGENTA: "#9b2685",
  BROWN: "#6c3b00",
  RED: "#cb0021"
};
var palette9 = {
  fills: Object.values(VIVID_FILLS),
  strokes: Object.values(VIVID_STROKES)
};
var VividLight = /*#__PURE__*/function (_ChartTheme6) {
  _inherits(_VividLight, _ChartTheme6);
  function _VividLight() {
    _classCallCheck(this, _VividLight);
    return _possibleConstructorReturn(this, _getPrototypeOf(_VividLight).apply(this, arguments));
  }
  _createClass(_VividLight, [{
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var result = _superPropGet(_VividLight, "getTemplateParameters", this, 3)([]);
      result.properties.set(_DEFAULT_COLOURS, _VividLight.getDefaultColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _VividLight.getWaterfallSeriesDefaultPositiveColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _VividLight.getWaterfallSeriesDefaultNegativeColors());
      result.properties.set(_DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _VividLight.getWaterfallSeriesDefaultTotalColors());
      result.properties.set(_DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [VIVID_FILLS.ORANGE, VIVID_FILLS.YELLOW, VIVID_FILLS.GREEN]);
      result.properties.set(_DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _VividLight.getWaterfallSeriesDefaultTotalColors().stroke);
      result.properties.set(_DEFAULT_ANNOTATION_STROKE, VIVID_STROKES.BLUE);
      result.properties.set(_DEFAULT_ANNOTATION_BACKGROUND_FILL, VIVID_FILLS.BLUE);
      return result;
    }
  }, {
    key: "getPalette",
    value: function getPalette() {
      return palette9;
    }
  }], [{
    key: "getDefaultColors",
    value: function getDefaultColors() {
      return {
        fills: VIVID_FILLS,
        strokes: VIVID_STROKES
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultPositiveColors",
    value: function getWaterfallSeriesDefaultPositiveColors() {
      return {
        fill: VIVID_FILLS.BLUE,
        stroke: VIVID_STROKES.BLUE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultNegativeColors",
    value: function getWaterfallSeriesDefaultNegativeColors() {
      return {
        fill: VIVID_FILLS.ORANGE,
        stroke: VIVID_STROKES.ORANGE,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }, {
    key: "getWaterfallSeriesDefaultTotalColors",
    value: function getWaterfallSeriesDefaultTotalColors() {
      return {
        fill: VIVID_FILLS.GRAY,
        stroke: VIVID_STROKES.GRAY,
        label: {
          color: _DEFAULT_LABEL_COLOUR
        }
      };
    }
  }]);
  return _VividLight;
}(_ChartTheme7);

// packages/ag-charts-community/src/chart/mapping/themes.ts
var lightTheme = function lightTheme() {
  return new _ChartTheme7();
};
var darkTheme = function darkTheme() {
  return new DarkTheme();
};
var lightThemes = {
  undefined: lightTheme,
  null: lightTheme,
  "ag-default": lightTheme,
  "ag-sheets": function agSheets() {
    return new SheetsLight();
  },
  "ag-polychroma": function agPolychroma() {
    return new PolychromaLight();
  },
  "ag-vivid": function agVivid() {
    return new VividLight();
  },
  "ag-material": function agMaterial() {
    return new MaterialLight();
  }
};
var darkThemes = {
  undefined: darkTheme,
  null: darkTheme,
  "ag-default-dark": darkTheme,
  "ag-sheets-dark": function agSheetsDark() {
    return new SheetsDark();
  },
  "ag-polychroma-dark": function agPolychromaDark() {
    return new PolychromaDark();
  },
  "ag-vivid-dark": function agVividDark() {
    return new VividDark();
  },
  "ag-material-dark": function agMaterialDark() {
    return new MaterialDark();
  }
};
var themes = __spreadValues(__spreadValues({}, darkThemes), lightThemes);
function validateChartThemeObject(unknownObject) {
  if (unknownObject === null) {
    return;
  }
  var valid = true;
  var baseTheme = unknownObject.baseTheme,
    palette10 = unknownObject.palette,
    overrides = unknownObject.overrides;
  if (baseTheme !== void 0 && typeof baseTheme !== "string" && typeof baseTheme !== "object") {
    _Logger.warn("invalid theme.baseTheme type ".concat(typeof baseTheme, ", expected (string | object)."));
    valid = false;
  }
  if (overrides !== void 0 && typeof overrides !== "object") {
    _Logger.warn("invalid theme.overrides type ".concat(typeof overrides, ", expected object."));
    valid = false;
  }
  if (typeof palette10 === "object") {
    if (palette10 !== null) {
      var fills = palette10.fills,
        strokes = palette10.strokes;
      if (fills !== void 0 && !Array.isArray(fills)) {
        _Logger.warn("theme.overrides.fills must be undefined or an array");
        valid = false;
      }
      if (strokes !== void 0 && !Array.isArray(strokes)) {
        _Logger.warn("theme.overrides.strokes must be undefined or an array");
        valid = false;
      }
    }
  } else if (palette10 !== void 0) {
    _Logger.warn("invalid theme.palette type ".concat(typeof palette10, ", expected object."));
    valid = false;
  }
  if (valid) {
    return unknownObject;
  }
}
function validateChartTheme(value) {
  if (value === void 0 || typeof value === "string" || value instanceof _ChartTheme7) {
    return value;
  }
  if (typeof value === "object") {
    return validateChartThemeObject(value);
  }
  _Logger.warn("invalid theme value type ".concat(typeof value, ", expected object or string."));
}
function _getChartTheme(unvalidatedValue) {
  var value = validateChartTheme(unvalidatedValue);
  if (value instanceof _ChartTheme7) {
    return value;
  }
  if (value == null || typeof value === "string") {
    var stockTheme = themes[value];
    if (stockTheme) {
      return stockTheme();
    }
    _Logger.warnOnce("the theme [".concat(value, "] is invalid, using [ag-default] instead."));
    return lightTheme();
  }
  var overrides = [];
  var palette10;
  while (typeof value === "object") {
    overrides.push(value.overrides);
    palette10 != null ? palette10 : palette10 = value.palette;
    value = value.baseTheme;
  }
  var flattenedTheme = {
    baseTheme: value,
    overrides: _mergeDefaults4.apply(void 0, overrides),
    palette: palette10
  };
  var baseTheme = flattenedTheme.baseTheme ? _getChartTheme(flattenedTheme.baseTheme) : lightTheme();
  return new baseTheme.constructor(flattenedTheme);
}

// packages/ag-charts-community/src/util/array.ts
function _extent(values) {
  if (values.length === 0) {
    return;
  }
  var min = Infinity;
  var max = -Infinity;
  var _iterator21 = _createForOfIteratorHelper(values),
    _step21;
  try {
    for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
      var n = _step21.value;
      if (n instanceof Date) {
        n = n.getTime();
      }
      if (typeof n !== "number") {
        continue;
      }
      if (n < min) {
        min = n;
      }
      if (n > max) {
        max = n;
      }
    }
  } catch (err) {
    _iterator21.e(err);
  } finally {
    _iterator21.f();
  }
  var result = [min, max];
  if (result.every(isFinite)) {
    return result;
  }
}
function _normalisedExtent(d, min, max) {
  return _normalisedExtentWithMetadata(d, min, max).extent;
}
function _normalisedExtentWithMetadata(d, min, max) {
  var _a;
  var clipped = false;
  if (d.length > 2) {
    d = (_a = _extent(d)) != null ? _a : [NaN, NaN];
  }
  if (!isNaN(min)) {
    clipped || (clipped = min > d[0]);
    d = [min, d[1]];
  }
  if (!isNaN(max)) {
    clipped || (clipped = max < d[1]);
    d = [d[0], max];
  }
  if (d[0] > d[1]) {
    d = [];
  }
  return {
    extent: d,
    clipped: clipped
  };
}
function _arraysEqual(a, b) {
  if (a == null || b == null || a.length !== b.length) {
    return false;
  }
  for (var i = 0; i < a.length; i++) {
    if (Array.isArray(a[i]) && Array.isArray(b[i])) {
      if (!_arraysEqual(a[i], b[i])) {
        return false;
      }
    } else if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
function _toArray2(value) {
  if (typeof value === "undefined") {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function _unique(array) {
  return Array.from(new Set(array));
}
function _groupBy2(array, iteratee) {
  return array.reduce(function (result, item) {
    var _a;
    var groupKey = iteratee(item);
    (_a = result[groupKey]) != null ? _a : result[groupKey] = [];
    result[groupKey].push(item);
    return result;
  }, {});
}
function _circularSliceArray(data, size) {
  var offset4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (data.length === 0) {
    return [];
  }
  var result = [];
  for (var i = 0; i < size; i++) {
    result.push(data.at((i + offset4) % data.length));
  }
  return result;
}
function _bifurcate(isLeft, array) {
  return array.reduce(function (_ref1, value) {
    var _ref10 = _slicedToArray(_ref1, 2),
      left = _ref10[0],
      right = _ref10[1];
    return isLeft(value) ? [[].concat(_toConsumableArray(left), [value]), right] : [left, [].concat(_toConsumableArray(right), [value])];
  }, [[], []]);
}
function _mapIterable(src, predicate) {
  var _iterator22, _step22, e, _t4;
  return _regenerator().w(function (_context4) {
    while (1) switch (_context4.p = _context4.n) {
      case 0:
        _iterator22 = _createForOfIteratorHelper(src);
        _context4.p = 1;
        _iterator22.s();
      case 2:
        if ((_step22 = _iterator22.n()).done) {
          _context4.n = 4;
          break;
        }
        e = _step22.value;
        _context4.n = 3;
        return predicate(e);
      case 3:
        _context4.n = 2;
        break;
      case 4:
        _context4.n = 6;
        break;
      case 5:
        _context4.p = 5;
        _t4 = _context4.v;
        _iterator22.e(_t4);
      case 6:
        _context4.p = 6;
        _iterator22.f();
        return _context4.f(6);
      case 7:
        return _context4.a(2);
    }
  }, _marked3, null, [[1, 5, 6, 7]]);
}
function constStringsIncludes(array, value) {
  var casting = array;
  return casting.includes(value);
}
function isInStringUnion(unionValues, value) {
  return constStringsIncludes(unionValues, value);
}
function _allInStringUnion(unionValues, values) {
  return !values.some(function (v) {
    return !isInStringUnion(unionValues, v);
  });
}

// packages/ag-charts-community/src/util/dom.ts
var verifiedGlobals = {};
var injectCache = /* @__PURE__ */new WeakMap();
if (typeof window !== "undefined") {
  verifiedGlobals.window = window;
} else if (typeof global !== "undefined") {
  verifiedGlobals.window = global.window;
}
if (typeof document !== "undefined") {
  verifiedGlobals.document = document;
} else if (typeof global !== "undefined") {
  verifiedGlobals.document = global.document;
}
function _getDocument2(propertyName) {
  var _a;
  return propertyName ? (_a = verifiedGlobals.document) == null ? void 0 : _a[propertyName] : verifiedGlobals.document;
}
function _getWindow2(propertyName) {
  var _a;
  return propertyName ? (_a = verifiedGlobals.window) == null ? void 0 : _a[propertyName] : verifiedGlobals.window;
}
function _createElement(tagName, className, style) {
  var element2 = _getDocument2().createElement(tagName);
  if (typeof className === "object") {
    style = className;
    className = void 0;
  }
  if (className) {
    element2.classList.add(className);
  }
  if (style) {
    Object.assign(element2.style, style);
  }
  return element2;
}
function _downloadUrl(dataUrl, fileName) {
  var _getDocument = _getDocument2(),
    body = _getDocument.body;
  var element2 = _createElement("a", {
    display: "none"
  });
  element2.href = dataUrl;
  element2.download = fileName;
  body.appendChild(element2);
  element2.click();
  setTimeout(function () {
    return body.removeChild(element2);
  });
}
function _injectStyle(cssStyle, uniqueId) {
  var _a, _b;
  var document2 = _getDocument2();
  if (uniqueId && ((_a = injectCache.get(document2)) == null ? void 0 : _a.has(uniqueId))) return;
  var styleElement = _createElement("style");
  styleElement.innerHTML = cssStyle;
  document2.head.insertBefore(styleElement, document2.head.querySelector("style"));
  if (uniqueId && !injectCache.has(document2)) {
    injectCache.set(document2, /* @__PURE__ */new Set([uniqueId]));
  } else if (uniqueId) {
    (_b = injectCache.get(document2)) == null ? void 0 : _b.add(uniqueId);
  }
}
function _setDocument(document2) {
  verifiedGlobals.document = document2;
}
function _setWindow(window2) {
  verifiedGlobals.window = window2;
}

// packages/ag-charts-community/src/util/debug.ts
var LONG_TIME_PERIOD_THRESHOLD = 2e3;
var timeOfLastLog = Date.now();
var logTimeGap = function logTimeGap() {
  var timeSinceLastLog = Date.now() - timeOfLastLog;
  if (timeSinceLastLog > LONG_TIME_PERIOD_THRESHOLD) {
    var prettyDuration = (Math.floor(timeSinceLastLog / 100) / 10).toFixed(1);
    _Logger.log("**** ".concat(prettyDuration, "s since last log message ****"));
  }
  timeOfLastLog = Date.now();
};
var Debug = {
  create: function create() {
    for (var _len13 = arguments.length, debugSelectors = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      debugSelectors[_key13] = arguments[_key13];
    }
    var resultFn = function resultFn() {
      for (var _len14 = arguments.length, logContent = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        logContent[_key14] = arguments[_key14];
      }
      if (Debug.check.apply(Debug, debugSelectors)) {
        if (typeof logContent[0] === "function") {
          logContent = _toArray2(logContent[0]());
        }
        logTimeGap();
        _Logger.log.apply(_Logger, _toConsumableArray(logContent));
      }
    };
    return Object.assign(resultFn, {
      check: function check() {
        return Debug.check.apply(Debug, debugSelectors);
      }
    });
  },
  check: function check() {
    for (var _len15 = arguments.length, debugSelectors = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      debugSelectors[_key15] = arguments[_key15];
    }
    if (debugSelectors.length === 0) {
      debugSelectors.push(true);
    }
    var chartDebug = _toArray2(_getWindow2("agChartsDebug"));
    return chartDebug.some(function (selector) {
      return debugSelectors.includes(selector);
    });
  }
};

// packages/ag-charts-community/src/module/optionsModule.ts
var unthemedSeries = /* @__PURE__ */new Set(["map-shape-background", "map-line-background"]);
var _ChartOptions = /*#__PURE__*/function () {
  function ChartOptions(userOptions, specialOverrides) {
    _classCallCheck(this, ChartOptions);
    var _b, _c, _d;
    var cloneOptions = {
      shallow: ["data"]
    };
    var options = _deepClone2(userOptions, cloneOptions);
    var chartType2 = this.optionsType(options);
    this.sanityCheckAndCleanup(options);
    this.userOptions = options;
    this.activeTheme = _getChartTheme(options.theme);
    this.defaultAxes = this.getDefaultAxes(options);
    this.specialOverrides = this.specialOverridesDefaults(__spreadValues({}, specialOverrides));
    var _a = this.getSeriesThemeConfig(chartType2),
      _a$axes = _a.axes,
      axesThemes = _a$axes === void 0 ? {} : _a$axes,
      _a$annotations = _a.annotations,
      annotationsThemes = _a$annotations === void 0 ? {} : _a$annotations,
      _ = _a.series,
      themeDefaults = __objRest(_a, ["axes", "annotations", "series"]);
    this.processedOptions = _deepClone2(_mergeDefaults4(this.userOptions, themeDefaults, this.defaultAxes), cloneOptions);
    this.processAxesOptions(this.processedOptions, axesThemes);
    this.processSeriesOptions(this.processedOptions);
    this.processMiniChartSeriesOptions(this.processedOptions);
    this.processAnnotationsOptions(this.processedOptions, annotationsThemes);
    if ((isAgCartesianChartOptions(this.processedOptions) || isAgPolarChartOptionsWithSeriesBasedLegend(this.processedOptions)) && ((_b = this.processedOptions.legend) == null ? void 0 : _b.enabled) == null) {
      (_d = (_c = this.processedOptions).legend) != null ? _d : _c.legend = {};
      this.processedOptions.legend.enabled = this.processedOptions.series.length > 1;
    }
    this.enableConfiguredOptions(this.processedOptions);
    if (!_enterpriseModule.isEnterprise) {
      removeUsedEnterpriseOptions(this.processedOptions);
    }
  }
  _createClass(ChartOptions, [{
    key: "getOptions",
    value: function getOptions() {
      var _a;
      return (_a = this.processedOptions) != null ? _a : {};
    }
  }, {
    key: "diffOptions",
    value: function diffOptions(options) {
      return _jsonDiff(options, this.processedOptions);
    }
  }, {
    key: "getSeriesThemeConfig",
    value: function getSeriesThemeConfig(seriesType) {
      var _a, _b;
      return _deepClone2((_b = (_a = this.activeTheme) == null ? void 0 : _a.config[seriesType]) != null ? _b : {});
    }
  }, {
    key: "getDefaultAxes",
    value: function getDefaultAxes(options) {
      var optionsType2 = this.optionsType(options);
      var axesDefaults = seriesRegistry.cloneDefaultAxes(optionsType2);
      if (seriesRegistry.isDefaultAxisSwapNeeded(options)) {
        this.swapAxesPosition(axesDefaults);
      }
      return axesDefaults;
    }
  }, {
    key: "optionsType",
    value: function optionsType(options) {
      var _a, _b, _c;
      return (_c = (_b = (_a = options.series) == null ? void 0 : _a[0]) == null ? void 0 : _b.type) != null ? _c : "line";
    }
  }, {
    key: "sanityCheckAndCleanup",
    value: function sanityCheckAndCleanup(options) {
      var _a;
      this.deprecationWarnings(options);
      this.axesTypeIntegrity(options);
      this.seriesTypeIntegrity(options);
      this.soloSeriesIntegrity(options);
      this.removeDisabledOptions(options);
      this.removeLeftoverSymbols(options);
      if (((_a = options.series) == null ? void 0 : _a.some(function (s) {
        return s.type === "bullet";
      })) && options.sync != null && options.sync.enabled !== false) {
        _Logger.warnOnce("bullet series cannot be synced, disabling synchronization.");
        delete options.sync;
      }
    }
  }, {
    key: "swapAxesPosition",
    value: function swapAxesPosition(options) {
      var _a;
      if (isAgCartesianChartOptions(options)) {
        var _ref11 = (_a = options.axes) != null ? _a : [],
          _ref12 = _slicedToArray(_ref11, 2),
          axis0 = _ref12[0],
          axis1 = _ref12[1];
        options.axes = [__spreadProps(__spreadValues({}, axis0), {
          position: axis1.position
        }), __spreadProps(__spreadValues({}, axis1), {
          position: axis0.position
        })];
      }
    }
  }, {
    key: "processAxesOptions",
    value: function processAxesOptions(options, axesThemes) {
      if (!("axes" in options)) return;
      options.axes = options.axes.map(function (axis) {
        var _a, _c, _d;
        var _b = _mergeDefaults4((_a = axesThemes[axis.type]) == null ? void 0 : _a[axis.position], axesThemes[axis.type]),
          crossLinesTheme = _b.crossLines,
          axisTheme = __objRest(_b, ["crossLines"]);
        if (axis.crossLines) {
          axis.crossLines = _mergeArrayDefaults(axis.crossLines, crossLinesTheme);
        }
        var gridLineStyle = (_c = axisTheme.gridLine) == null ? void 0 : _c.style;
        if (((_d = axis.gridLine) == null ? void 0 : _d.style) && (gridLineStyle == null ? void 0 : gridLineStyle.length)) {
          axis.gridLine.style = axis.gridLine.style.map(function (style, index) {
            return style.stroke != null || style.lineDash != null ? _mergeDefaults4(style, gridLineStyle.at(index % gridLineStyle.length)) : style;
          });
        }
        var _e = _mergeDefaults4(axis, axisTheme),
          _1 = _e.top,
          _2 = _e.right,
          _3 = _e.bottom,
          _4 = _e.left,
          axisOptions = __objRest(_e, ["top", "right", "bottom", "left"]);
        return axisOptions;
      });
    }
  }, {
    key: "processSeriesOptions",
    value: function processSeriesOptions(options) {
      var _this1 = this;
      var defaultSeriesType = this.getDefaultSeriesType(options);
      var defaultTooltipPosition = this.getTooltipPositionDefaults(options);
      var userPalette = Boolean(_isObject(options.theme) && options.theme.palette);
      var paletteOptions = {
        colourIndex: 0,
        userPalette: userPalette
      };
      var processedSeries = options.series.map(function (series) {
        var _a, _b;
        (_a = series.type) != null ? _a : series.type = defaultSeriesType;
        var _c = (_b = _this1.getSeriesThemeConfig(series.type).series) != null ? _b : {},
          innerLabelsTheme = _c.innerLabels,
          seriesTheme = __objRest(_c, ["innerLabels"]);
        var seriesPaletteOptions = unthemedSeries.has(series.type) ? {
          colourIndex: 0,
          userPalette: userPalette
        } : paletteOptions;
        var palette10 = _this1.getSeriesPalette(series.type, seriesPaletteOptions);
        var seriesOptions = _mergeDefaults4(_this1.getSeriesGroupingOptions(series), series, defaultTooltipPosition, seriesTheme, palette10);
        if (seriesOptions.innerLabels) {
          seriesOptions.innerLabels = _mergeArrayDefaults(seriesOptions.innerLabels, innerLabelsTheme);
        }
        return _this1.activeTheme.templateTheme(seriesOptions);
      });
      options.series = this.setSeriesGroupingOptions(processedSeries);
    }
  }, {
    key: "processMiniChartSeriesOptions",
    value: function processMiniChartSeriesOptions(options) {
      var _this10 = this;
      var _a, _b;
      var miniChartSeries = (_b = (_a = options.navigator) == null ? void 0 : _a.miniChart) == null ? void 0 : _b.series;
      if (miniChartSeries == null) return;
      var paletteOptions = {
        colourIndex: 0,
        userPalette: Boolean(_isObject(options.theme) && options.theme.palette)
      };
      miniChartSeries = miniChartSeries.map(function (series) {
        var _a2, _b2;
        (_a2 = series.type) != null ? _a2 : series.type = "line";
        var _c = (_b2 = _this10.getSeriesThemeConfig(series.type).series) != null ? _b2 : {},
          _ = _c.innerLabels,
          seriesTheme = __objRest(_c, ["innerLabels"]);
        var seriesOptions = _mergeDefaults4(_this10.getSeriesGroupingOptions(series), series, seriesTheme, _this10.getSeriesPalette(series.type, paletteOptions));
        return _this10.activeTheme.templateTheme(seriesOptions);
      });
      options.navigator.miniChart.series = this.setSeriesGroupingOptions(miniChartSeries);
    }
  }, {
    key: "processAnnotationsOptions",
    value: function processAnnotationsOptions(options, _annotationsThemes) {
      if (!isAgCartesianChartOptions(options)) return;
    }
  }, {
    key: "getSeriesPalette",
    value: function getSeriesPalette(seriesType, options) {
      var paletteFactory = seriesRegistry.getPaletteFactory(seriesType);
      var colourOffset = options.colourIndex,
        userPalette = options.userPalette;
      var _this$activeTheme$pal = this.activeTheme.palette,
        _this$activeTheme$pal2 = _this$activeTheme$pal.fills,
        fills = _this$activeTheme$pal2 === void 0 ? [] : _this$activeTheme$pal2,
        _this$activeTheme$pal3 = _this$activeTheme$pal.strokes,
        strokes = _this$activeTheme$pal3 === void 0 ? [] : _this$activeTheme$pal3;
      return paletteFactory == null ? void 0 : paletteFactory({
        userPalette: userPalette,
        colorsCount: Math.max(fills.length, strokes.length),
        themeTemplateParameters: this.activeTheme.getTemplateParameters(),
        takeColors: function takeColors(count) {
          options.colourIndex += count;
          return {
            fills: _circularSliceArray(fills, count, colourOffset),
            strokes: _circularSliceArray(strokes, count, colourOffset)
          };
        }
      });
    }
  }, {
    key: "getSeriesGroupingOptions",
    value: function getSeriesGroupingOptions(series) {
      var groupable = seriesRegistry.isGroupable(series.type);
      var stackable = seriesRegistry.isStackable(series.type);
      var stackedByDefault = seriesRegistry.isStackedByDefault(series.type);
      if (series.grouped && !groupable) {
        _Logger.warnOnce("unsupported grouping of series type \"".concat(series.type, "\"."));
      }
      if ((series.stacked || series.stackGroup) && !stackable) {
        _Logger.warnOnce("unsupported stacking of series type \"".concat(series.type, "\"."));
      }
      var grouped = series.grouped,
        stacked = series.stacked;
      stacked != null ? stacked : stacked = (stackedByDefault || series.stackGroup != null) && !(groupable && grouped);
      grouped != null ? grouped : grouped = true;
      return {
        stacked: stackable && stacked,
        grouped: groupable && grouped && !(stackable && stacked)
      };
    }
  }, {
    key: "setSeriesGroupingOptions",
    value: function setSeriesGroupingOptions(allSeries) {
      var seriesGroups = this.getSeriesGrouping(allSeries);
      Debug.create(true, "opts")("setSeriesGroupingOptions() - series grouping: ", seriesGroups);
      var groupIdx = {};
      var groupCount2 = seriesGroups.reduce(function (countMap, seriesGroup) {
        var _a, _b;
        if (seriesGroup.groupType === "default" /* DEFAULT */) {
          return countMap;
        }
        (_b = countMap[_a = seriesGroup.seriesType]) != null ? _b : countMap[_a] = 0;
        countMap[seriesGroup.seriesType] += seriesGroup.groupType === "stack" /* STACK */ ? 1 : seriesGroup.series.length;
        return countMap;
      }, {});
      return seriesGroups.flatMap(function (seriesGroup) {
        var _a, _b;
        (_b = groupIdx[_a = seriesGroup.seriesType]) != null ? _b : groupIdx[_a] = 0;
        switch (seriesGroup.groupType) {
          case "stack" /* STACK */:
            var groupIndex = groupIdx[seriesGroup.seriesType]++;
            return seriesGroup.series.map(function (series, stackIndex) {
              return Object.assign(series, {
                seriesGrouping: {
                  groupIndex: groupIndex,
                  groupCount: groupCount2[seriesGroup.seriesType],
                  stackIndex: stackIndex,
                  stackCount: seriesGroup.series.length
                }
              });
            });
          case "group" /* GROUP */:
            return seriesGroup.series.map(function (series) {
              return Object.assign(series, {
                seriesGrouping: {
                  groupIndex: groupIdx[seriesGroup.seriesType]++,
                  groupCount: groupCount2[seriesGroup.seriesType],
                  stackIndex: 0,
                  stackCount: 0
                }
              });
            });
        }
        return seriesGroup.series;
      }).map(function (_a) {
        var _b = _a,
          _ = _b.stacked,
          __ = _b.grouped,
          seriesOptions = __objRest(_b, ["stacked", "grouped"]);
        return seriesOptions;
      });
    }
  }, {
    key: "getSeriesGroupId",
    value: function getSeriesGroupId(series) {
      var _a;
      return [series.type, series.xKey, series.stacked ? (_a = series.stackGroup) != null ? _a : "stacked" : "grouped"].filter(Boolean).join("-");
    }
  }, {
    key: "getSeriesGrouping",
    value: function getSeriesGrouping(allSeries) {
      var _this11 = this;
      var groupMap = /* @__PURE__ */new Map();
      return allSeries.reduce(function (result, series) {
        var seriesType = series.type;
        if (!series.stacked && !series.grouped) {
          result.push({
            groupType: "default" /* DEFAULT */,
            seriesType: seriesType,
            series: [series]
          });
        } else {
          var groupId = _this11.getSeriesGroupId(series);
          if (!groupMap.has(groupId)) {
            var groupType = series.stacked ? "stack" /* STACK */ : "group" /* GROUP */;
            var record = {
              groupType: groupType,
              seriesType: seriesType,
              series: []
            };
            groupMap.set(groupId, record);
            result.push(record);
          }
          groupMap.get(groupId).series.push(series);
        }
        return result;
      }, []);
    }
  }, {
    key: "getDefaultSeriesType",
    value: function getDefaultSeriesType(options) {
      if (isAgCartesianChartOptions(options)) {
        return "line";
      } else if (isAgPolarChartOptions(options)) {
        return "pie";
      } else if (isAgHierarchyChartOptions(options)) {
        return "treemap";
      } else if (isAgTopologyChartOptions(options)) {
        return "map-shape";
      }
      throw new Error("Invalid chart options type detected.");
    }
  }, {
    key: "getTooltipPositionDefaults",
    value: function getTooltipPositionDefaults(options) {
      var _a;
      var position = (_a = options.tooltip) == null ? void 0 : _a.position;
      if (!_isPlainObject(position)) {
        return;
      }
      var type = position.type,
        xOffset = position.xOffset,
        yOffset = position.yOffset;
      var result = {};
      if (_isString(type) && _isEnumValue(AgTooltipPositionType, type)) {
        result.type = type;
      }
      if (_isFiniteNumber(xOffset)) {
        result.xOffset = xOffset;
      }
      if (_isFiniteNumber(yOffset)) {
        result.yOffset = yOffset;
      }
      return {
        tooltip: {
          position: result
        }
      };
    }
  }, {
    key: "deprecationWarnings",
    value: function deprecationWarnings(options) {
      var deprecatedArrayProps = {
        yKeys: "yKey",
        yNames: "yName"
      };
      Object.entries(deprecatedArrayProps).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
          oldProp = _ref14[0],
          newProp = _ref14[1];
        var _a;
        if ((_a = options.series) == null ? void 0 : _a.some(function (s) {
          return s[oldProp] != null;
        })) {
          _Logger.warnOnce("Property [series.".concat(oldProp, "] is deprecated, please use [series.").concat(newProp, "] and multiple series instead."));
        }
      });
    }
  }, {
    key: "axesTypeIntegrity",
    value: function axesTypeIntegrity(options) {
      var _a;
      if ("axes" in options) {
        var axes = (_a = options.axes) != null ? _a : [];
        var _iterator23 = _createForOfIteratorHelper(axes),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var type = _step23.value.type;
            if (!isAxisOptionType(type)) {
              delete options.axes;
              var expectedTypes = Array.from(axisRegistry.publicKeys()).join(", ");
              _Logger.warnOnce("unknown axis type: ".concat(type, "; expected one of: ").concat(expectedTypes));
            }
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      }
    }
  }, {
    key: "seriesTypeIntegrity",
    value: function seriesTypeIntegrity(options) {
      var _a;
      var series = (_a = options.series) != null ? _a : [];
      options.series = series.filter(function (_ref15) {
        var type = _ref15.type;
        if (type == null || isSeriesOptionType(type) || isEnterpriseSeriesType(type)) {
          return true;
        }
        _Logger.warnOnce("unknown series type: ".concat(type, "; expected one of: ").concat(publicChartTypes.seriesTypes.join(", ")));
      });
    }
  }, {
    key: "soloSeriesIntegrity",
    value: function soloSeriesIntegrity(options) {
      var allSeries = options.series;
      if (allSeries && allSeries.length > 1 && allSeries.some(function (series) {
        return seriesRegistry.isSolo(series.type);
      })) {
        var mainSeriesType = this.optionsType(options);
        if (seriesRegistry.isSolo(mainSeriesType)) {
          _Logger.warn("series[0] of type '".concat(mainSeriesType, "' is incompatible with other series types. Only processing series[0]"));
          options.series = allSeries.slice(0, 1);
        } else {
          var _groupBy = _groupBy2(allSeries, function (s) {
              return seriesRegistry.isSolo(s.type) ? "solo" : "nonSolo";
            }),
            solo = _groupBy.solo,
            nonSolo = _groupBy.nonSolo;
          var rejects = _unique(solo.map(function (s) {
            return s.type;
          })).join(", ");
          _Logger.warn("Unable to mix these series types with the lead series type: ".concat(rejects));
          options.series = nonSolo;
        }
      }
    }
  }, {
    key: "enableConfiguredOptions",
    value: function enableConfiguredOptions(options) {
      _jsonWalk(this.userOptions, function (visitingUserOpts, visitingMergedOpts) {
        if (visitingMergedOpts && "enabled" in visitingMergedOpts && !visitingMergedOpts._enabledFromTheme && visitingUserOpts.enabled == null) {
          visitingMergedOpts.enabled = true;
        }
      }, {
        skip: ["data", "theme"]
      }, options);
      _jsonWalk(options, function (visitingMergedOpts) {
        if (visitingMergedOpts._enabledFromTheme != null) {
          delete visitingMergedOpts._enabledFromTheme;
        }
      }, {
        skip: ["data", "theme"]
      });
    }
  }, {
    key: "removeDisabledOptions",
    value: function removeDisabledOptions(options) {
      _jsonWalk(options, function (optionsNode) {
        if ("enabled" in optionsNode && optionsNode.enabled === false) {
          Object.keys(optionsNode).forEach(function (key) {
            if (key === "enabled") return;
            delete optionsNode[key];
          });
        }
      }, {
        skip: ["data", "theme"]
      });
    }
  }, {
    key: "removeLeftoverSymbols",
    value: function removeLeftoverSymbols(options) {
      _jsonWalk(options, function (optionsNode) {
        if (!optionsNode || !_isObject(optionsNode)) return;
        for (var _i1 = 0, _Object$entries3 = Object.entries(optionsNode); _i1 < _Object$entries3.length; _i1++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i1], 2),
            key = _Object$entries3$_i[0],
            value = _Object$entries3$_i[1];
          if (_isSymbol(value)) {
            delete optionsNode[key];
          }
        }
      }, {
        skip: ["data"]
      });
    }
  }, {
    key: "specialOverridesDefaults",
    value: function specialOverridesDefaults(options) {
      if (options.window != null) {
        _setWindow(options.window);
      } else if (typeof window !== "undefined") {
        options.window = window;
      } else if (typeof global !== "undefined") {
        options.window = global.window;
      }
      if (options.document != null) {
        _setDocument(options.document);
      } else if (typeof document !== "undefined") {
        options.document = document;
      } else if (typeof global !== "undefined") {
        options.document = global.document;
      }
      if (options.window == null) {
        throw new Error("AG Charts - unable to resolve global window");
      }
      if (options.document == null) {
        throw new Error("AG Charts - unable to resolve global document");
      }
      return options;
    }
  }]);
  return ChartOptions;
}();

// packages/ag-charts-community/src/util/deprecation.ts
function _createDeprecationWarning() {
  return function (key, message) {
    var msg = ["Property [".concat(key, "] is deprecated."), message].filter(Boolean).join(" ");
    _Logger.warnOnce(msg);
  };
}
function _Deprecated(message, opts) {
  var warnDeprecated = _createDeprecationWarning();
  var def = opts == null ? void 0 : opts.default;
  return addTransformToInstanceProperty(function (_, key, value) {
    if (value !== def) {
      warnDeprecated(key.toString(), message);
    }
    return value;
  });
}
function _DeprecatedAndRenamedTo(newPropName, mapValue) {
  var warnDeprecated = _createDeprecationWarning();
  return addTransformToInstanceProperty(function (target, key, value) {
    if (value !== target[newPropName]) {
      warnDeprecated(key.toString(), "Use [".concat(newPropName, "] instead."));
      _setPath(target, newPropName, mapValue ? mapValue(value) : value);
    }
    return BREAK_TRANSFORM_CHAIN;
  }, function (target, key) {
    warnDeprecated(key.toString(), "Use [".concat(newPropName, "] instead."));
    return _getPath(target, newPropName);
  });
}

// packages/ag-charts-community/src/motion/fromToMotion.ts
var fromToMotion_exports = {};
__export(fromToMotion_exports, {
  NODE_UPDATE_STATE_TO_PHASE_MAPPING: function NODE_UPDATE_STATE_TO_PHASE_MAPPING() {
    return _NODE_UPDATE_STATE_TO_PHASE_MAPPING;
  },
  fromToMotion: function fromToMotion() {
    return _fromToMotion;
  },
  staticFromToMotion: function staticFromToMotion() {
    return _staticFromToMotion;
  }
});

// packages/ag-charts-community/src/util/id.ts
var ID_MAP = /* @__PURE__ */new Map();
function _resetIds() {
  ID_MAP.clear();
}
function _createId(instance) {
  var _a;
  var constructor = instance.constructor;
  var className = Object.hasOwn(constructor, "className") ? constructor.className : constructor.name;
  if (!className) {
    throw new Error("The ".concat(constructor, " is missing the 'className' property."));
  }
  var nextId = ((_a = ID_MAP.get(className)) != null ? _a : 0) + 1;
  ID_MAP.set(className, nextId);
  return "".concat(className, "-").concat(nextId);
}

// packages/ag-charts-community/src/util/interpolating.ts
var interpolate = "$interpolate";
var isInterpolating = function isInterpolating(x) {
  return x[interpolate] != null;
};

// packages/ag-charts-community/src/util/number.ts
function _clamp(min, value, max) {
  return Math.min(max, Math.max(min, value));
}
function _clampArray(value, array) {
  var _findMinMax = _findMinMax17(array),
    _findMinMax2 = _slicedToArray(_findMinMax, 2),
    min = _findMinMax2[0],
    max = _findMinMax2[1];
  return _clamp(min, value, max);
}
function _findMinMax17(array) {
  return array.length ? [Math.min.apply(Math, _toConsumableArray(array)), Math.max.apply(Math, _toConsumableArray(array))] : [];
}
function _findRangeExtent(array) {
  var _findMinMax3 = _findMinMax17(array),
    _findMinMax4 = _slicedToArray(_findMinMax3, 2),
    min = _findMinMax4[0],
    max = _findMinMax4[1];
  return max - min;
}
function _isEqual(a, b) {
  var epsilon2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-10;
  return Math.abs(a - b) < epsilon2;
}
function _isNegative(value) {
  return Math.sign(value) === -1 || Object.is(value, -0);
}
function _round(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var base = __pow(10, decimals);
  return Math.round(value * base) / base;
}
function _toFixed(value) {
  var fractionOrSignificantDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var power = Math.floor(Math.log(Math.abs(value)) / Math.LN10);
  if (power >= 0 || !isFinite(power)) {
    return value.toFixed(fractionOrSignificantDigits);
  }
  return value.toFixed(Math.abs(power) - 1 + fractionOrSignificantDigits);
}
function _mod(n, m) {
  return Math.floor(n % m + (n < 0 ? m : 0));
}
function _countFractionDigits(value) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var _toLocaleString$split = (Math.abs(value) % 1).toLocaleString("en-GB", {
      minimumFractionDigits: 0,
      maximumFractionDigits: maximumFractionDigits
    }).split("."),
    _toLocaleString$split2 = _slicedToArray(_toLocaleString$split, 2),
    _toLocaleString$split3 = _toLocaleString$split2[1],
    decimal = _toLocaleString$split3 === void 0 ? "" : _toLocaleString$split3;
  return decimal.length;
}

// packages/ag-charts-community/src/scene/nearest.ts
function _nearestSquared(x, y, objects) {
  var maxDistanceSquared = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  var result = {
    nearest: void 0,
    distanceSquared: maxDistanceSquared
  };
  var _iterator24 = _createForOfIteratorHelper(objects),
    _step24;
  try {
    for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
      var obj = _step24.value;
      var thisDistance = obj.distanceSquared(x, y);
      if (thisDistance === 0) {
        return {
          nearest: obj,
          distanceSquared: 0
        };
      } else if (thisDistance < result.distanceSquared) {
        result.nearest = obj;
        result.distanceSquared = thisDistance;
      }
    }
  } catch (err) {
    _iterator24.e(err);
  } finally {
    _iterator24.f();
  }
  return result;
}
function _nearestSquaredInContainer(x, y, container) {
  var maxDistanceSquared = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  var _container$transformP = container.transformPoint(x, y),
    tx = _container$transformP.x,
    ty = _container$transformP.y;
  var result = {
    nearest: void 0,
    distanceSquared: maxDistanceSquared
  };
  var _iterator25 = _createForOfIteratorHelper(container.children),
    _step25;
  try {
    for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
      var child = _step25.value;
      var _child$nearestSquared = child.nearestSquared(tx, ty, result.distanceSquared),
        nearest = _child$nearestSquared.nearest,
        distanceSquared2 = _child$nearestSquared.distanceSquared;
      if (distanceSquared2 === 0) {
        return {
          nearest: nearest,
          distanceSquared: distanceSquared2
        };
      } else if (distanceSquared2 < result.distanceSquared) {
        result.nearest = nearest;
        result.distanceSquared = distanceSquared2;
      }
    }
  } catch (err) {
    _iterator25.e(err);
  } finally {
    _iterator25.f();
  }
  return result;
}

// packages/ag-charts-community/src/scene/bbox.ts
var _BBox = /*#__PURE__*/function () {
  function _BBox(x, y, width, height) {
    _classCallCheck(this, _BBox);
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }
  _createClass(_BBox, [{
    key: "clone",
    value: function clone() {
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height;
      return new _BBox(x, y, width, height);
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.x === other.x && this.y === other.y && this.width === other.width && this.height === other.height;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(x, y) {
      return x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height;
    }
  }, {
    key: "collidesBBox",
    value: function collidesBBox(other) {
      return this.x < other.x + other.width && this.x + this.width > other.x && this.y < other.y + other.height && this.y + this.height > other.y;
    }
  }, {
    key: "computeCenter",
    value: function computeCenter() {
      return {
        x: this.x + this.width / 2,
        y: this.y + this.height / 2
      };
    }
  }, {
    key: "isFinite",
    value: function isFinite() {
      return Number.isFinite(this.x) && Number.isFinite(this.y) && Number.isFinite(this.width) && Number.isFinite(this.height);
    }
  }, {
    key: "distanceSquared",
    value: function distanceSquared(x, y) {
      if (this.containsPoint(x, y)) {
        return 0;
      }
      var dx = x - _clamp(this.x, x, this.x + this.width);
      var dy = y - _clamp(this.y, y, this.y + this.height);
      return dx * dx + dy * dy;
    }
  }, {
    key: "clip",
    value: function clip(clipRect) {
      if (clipRect === void 0) return this;
      var x1 = Math.max(this.x, clipRect.x);
      var y1 = Math.max(this.y, clipRect.y);
      var x2 = Math.min(this.x + this.width, clipRect.x + clipRect.width);
      var y2 = Math.min(this.y + this.height, clipRect.y + clipRect.height);
      this.x = x1;
      this.y = y1;
      this.width = Math.max(0, x2 - x1);
      this.height = Math.max(0, y2 - y1);
      return this;
    }
  }, {
    key: "shrink",
    value: function shrink(amount, position) {
      var _this12 = this;
      var apply = function apply(pos, amt) {
        switch (pos) {
          case "top":
            _this12.y += amt;
          case "bottom":
            _this12.height -= amt;
            break;
          case "left":
            _this12.x += amt;
          case "right":
            _this12.width -= amt;
            break;
          case "vertical":
            _this12.y += amt;
            _this12.height -= amt * 2;
            break;
          case "horizontal":
            _this12.x += amt;
            _this12.width -= amt * 2;
            break;
          case void 0:
            _this12.x += amt;
            _this12.width -= amt * 2;
            _this12.y += amt;
            _this12.height -= amt * 2;
            break;
          default:
        }
      };
      if (typeof amount === "number") {
        apply(position, amount);
      } else if (typeof amount === "object") {
        Object.entries(amount).forEach(function (_ref16) {
          var _ref17 = _slicedToArray(_ref16, 2),
            pos = _ref17[0],
            amt = _ref17[1];
          return apply(pos, amt);
        });
      }
      return this;
    }
  }, {
    key: "grow",
    value: function grow(amount, position) {
      if (typeof amount === "number") {
        this.shrink(-amount, position);
      } else {
        var paddingCopy = __spreadValues({}, amount);
        for (var key in paddingCopy) {
          paddingCopy[key] *= -1;
        }
        this.shrink(paddingCopy);
      }
      return this;
    }
  }, {
    key: "combine",
    value: function combine(other) {
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height;
      this.x = Math.min(x, other.x);
      this.y = Math.min(y, other.y);
      this.width = Math.max(x + width, other.x + other.width) - this.x;
      this.height = Math.max(y + height, other.y + other.height) - this.y;
    }
  }, {
    key: interpolate,
    value: function value(other, d) {
      return new _BBox(this.x * (1 - d) + other.x * d, this.y * (1 - d) + other.y * d, this.width * (1 - d) + other.width * d, this.height * (1 - d) + other.height * d);
    }
  }], [{
    key: "nearestBox",
    value: function nearestBox(x, y, boxes) {
      return _nearestSquared(x, y, boxes);
    }
  }, {
    key: "merge",
    value: function merge(boxes) {
      var left = Infinity;
      var top = Infinity;
      var right = -Infinity;
      var bottom = -Infinity;
      var _iterator26 = _createForOfIteratorHelper(boxes),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var box = _step26.value;
          if (box.x < left) {
            left = box.x;
          }
          if (box.y < top) {
            top = box.y;
          }
          if (box.x + box.width > right) {
            right = box.x + box.width;
          }
          if (box.y + box.height > bottom) {
            bottom = box.y + box.height;
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      return new _BBox(left, top, right - left, bottom - top);
    }
  }]);
  return _BBox;
}();
_BBox.zero = new _BBox(0, 0, 0, 0);
_BBox.NaN = new _BBox(NaN, NaN, NaN, NaN);
var _BBox2 = _BBox;

// packages/ag-charts-community/src/scene/changeDetectable.ts
var _RedrawType = /* @__PURE__ */function (RedrawType2) {
  RedrawType2[RedrawType2["NONE"] = 0] = "NONE";
  RedrawType2[RedrawType2["TRIVIAL"] = 1] = "TRIVIAL";
  RedrawType2[RedrawType2["MINOR"] = 2] = "MINOR";
  RedrawType2[RedrawType2["MAJOR"] = 3] = "MAJOR";
  return RedrawType2;
}(_RedrawType || {});
function functionConstructorAvailable() {
  try {
    new Function("return true");
    return true;
  } catch (e) {
    return false;
  }
}
var STRING_FUNCTION_USEABLE = functionConstructorAvailable();
function _SceneChangeDetection(opts) {
  var _ref18 = opts != null ? opts : {},
    changeCb = _ref18.changeCb,
    convertor = _ref18.convertor;
  return function (target, key) {
    var privateKey = "__".concat(key);
    if (target[key]) {
      return;
    }
    if (STRING_FUNCTION_USEABLE && changeCb == null && convertor == null) {
      prepareFastGetSet(target, key, privateKey, opts);
    } else {
      prepareSlowGetSet(target, key, privateKey, opts);
    }
  };
}
function prepareFastGetSet(target, key, privateKey, opts) {
  var _ref19 = opts != null ? opts : {},
    _ref19$redraw = _ref19.redraw,
    redraw = _ref19$redraw === void 0 ? 1 : _ref19$redraw,
    _ref19$type = _ref19.type,
    type = _ref19$type === void 0 ? "normal" : _ref19$type,
    _ref19$checkDirtyOnAs = _ref19.checkDirtyOnAssignment,
    checkDirtyOnAssignment = _ref19$checkDirtyOnAs === void 0 ? false : _ref19$checkDirtyOnAs;
  var setterJs = new Function("value", "\n        const oldValue = this.".concat(privateKey, ";\n        if (value !== oldValue) {\n            this.").concat(privateKey, " = value;\n            ").concat(type === "normal" ? "this.markDirty(this, ".concat(redraw, ");") : "", "\n            ").concat(type === "transform" ? "this.markDirtyTransform(".concat(redraw, ");") : "", "\n            ").concat(type === "path" ? "if (!this._dirtyPath) { this._dirtyPath = true; this.markDirty(this, ".concat(redraw, "); }") : "", "\n            ").concat(type === "font" ? "if (!this._dirtyFont) { this._dirtyFont = true; this.markDirty(this, ".concat(redraw, "); }") : "", "\n        }\n        ").concat(checkDirtyOnAssignment ? "if (value != null && value._dirty > ".concat(0 /* NONE */, ") { this.markDirty(value, value._dirty); }") : "", "\n"));
  var getterJs = new Function("return this.".concat(privateKey, ";"));
  Object.defineProperty(target, key, {
    set: setterJs,
    get: getterJs,
    enumerable: true,
    configurable: true
  });
}
function prepareSlowGetSet(target, key, privateKey, opts) {
  var _ref20 = opts != null ? opts : {},
    _ref20$redraw = _ref20.redraw,
    redraw = _ref20$redraw === void 0 ? 1 : _ref20$redraw,
    _ref20$type = _ref20.type,
    type = _ref20$type === void 0 ? "normal" : _ref20$type,
    changeCb = _ref20.changeCb,
    convertor = _ref20.convertor,
    _ref20$checkDirtyOnAs = _ref20.checkDirtyOnAssignment,
    checkDirtyOnAssignment = _ref20$checkDirtyOnAs === void 0 ? false : _ref20$checkDirtyOnAs;
  var setter = function setter(value) {
    var oldValue = this[privateKey];
    value = convertor ? convertor(value) : value;
    if (value !== oldValue) {
      this[privateKey] = value;
      if (type === "normal") this.markDirty(this, redraw);
      if (type === "transform") this.markDirtyTransform(redraw);
      if (type === "path" && !this._dirtyPath) {
        this._dirtyPath = true;
        this.markDirty(this, redraw);
      }
      if (type === "font" && !this._dirtyFont) {
        this._dirtyFont = true;
        this.markDirty(this, redraw);
      }
      changeCb == null ? void 0 : changeCb(this);
    }
    if (checkDirtyOnAssignment && value != null && value._dirty > 0 /* NONE */) this.markDirty(value, value._dirty);
  };
  var getter = function getter() {
    return this[privateKey];
  };
  Object.defineProperty(target, key, {
    set: setter,
    get: getter,
    enumerable: true,
    configurable: true
  });
}
var ChangeDetectable = /*#__PURE__*/function () {
  function ChangeDetectable() {
    _classCallCheck(this, ChangeDetectable);
    this._dirty = 3 /* MAJOR */;
  }
  _createClass(ChangeDetectable, [{
    key: "markDirty",
    value: function markDirty(_source) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (this._dirty < type) {
        this._dirty = type;
      }
    }
  }, {
    key: "markClean",
    value: function markClean(_opts) {
      this._dirty = 0 /* NONE */;
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      return this._dirty > 0 /* NONE */;
    }
  }]);
  return ChangeDetectable;
}();

// packages/ag-charts-community/src/scene/matrix.ts
var _Matrix = /*#__PURE__*/function () {
  _createClass(_Matrix, [{
    key: "e",
    get: function get() {
      return _toConsumableArray(this.elements);
    }
  }]);
  function _Matrix() {
    var elements3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [1, 0, 0, 1, 0, 0];
    _classCallCheck(this, _Matrix);
    this.elements = elements3;
  }
  _createClass(_Matrix, [{
    key: "setElements",
    value: function setElements(elements3) {
      var e = this.elements;
      e[0] = elements3[0];
      e[1] = elements3[1];
      e[2] = elements3[2];
      e[3] = elements3[3];
      e[4] = elements3[4];
      e[5] = elements3[5];
      return this;
    }
  }, {
    key: "AxB",
    /**
     * Performs the AxB matrix multiplication and saves the result
     * to `C`, if given, or to `A` otherwise.
     */
    value: function AxB(A, B, C) {
      var a = A[0] * B[0] + A[2] * B[1],
        b = A[1] * B[0] + A[3] * B[1],
        c = A[0] * B[2] + A[2] * B[3],
        d = A[1] * B[2] + A[3] * B[3],
        e = A[0] * B[4] + A[2] * B[5] + A[4],
        f = A[1] * B[4] + A[3] * B[5] + A[5];
      C = C != null ? C : A;
      C[0] = a;
      C[1] = b;
      C[2] = c;
      C[3] = d;
      C[4] = e;
      C[5] = f;
    }
    /**
     * The `other` matrix gets post-multiplied to the current matrix.
     * Returns the current matrix.
     * @param other
     */
  }, {
    key: "multiplySelf",
    value: function multiplySelf(other) {
      this.AxB(this.elements, other.elements);
      return this;
    }
    /**
     * The `other` matrix gets post-multiplied to the current matrix.
     * Returns a new matrix.
     * @param other
     */
  }, {
    key: "multiply",
    value: function multiply(other) {
      var elements3 = new Array(6);
      this.AxB(this.elements, other.elements, elements3);
      return new _Matrix(elements3);
    }
  }, {
    key: "preMultiplySelf",
    value: function preMultiplySelf(other) {
      this.AxB(other.elements, this.elements, this.elements);
      return this;
    }
    /**
     * Returns the inverse of this matrix as a new matrix.
     */
  }, {
    key: "inverse",
    value: function inverse() {
      var el = this.elements;
      var a = el[0],
        b = el[1],
        c = el[2],
        d = el[3];
      var e = el[4],
        f = el[5];
      var rD = 1 / (a * d - b * c);
      a *= rD;
      b *= rD;
      c *= rD;
      d *= rD;
      return new _Matrix([d, -b, -c, a, c * f - d * e, b * e - a * f]);
    }
    /**
     * Save the inverse of this matrix to the given matrix.
     */
  }, {
    key: "inverseTo",
    value: function inverseTo(other) {
      var el = this.elements;
      var a = el[0],
        b = el[1],
        c = el[2],
        d = el[3];
      var e = el[4],
        f = el[5];
      var rD = 1 / (a * d - b * c);
      a *= rD;
      b *= rD;
      c *= rD;
      d *= rD;
      other.setElements([d, -b, -c, a, c * f - d * e, b * e - a * f]);
      return this;
    }
  }, {
    key: "invertSelf",
    value: function invertSelf() {
      var el = this.elements;
      var a = el[0],
        b = el[1],
        c = el[2],
        d = el[3];
      var e = el[4],
        f = el[5];
      var rD = 1 / (a * d - b * c);
      a *= rD;
      b *= rD;
      c *= rD;
      d *= rD;
      el[0] = d;
      el[1] = -b;
      el[2] = -c;
      el[3] = a;
      el[4] = c * f - d * e;
      el[5] = b * e - a * f;
      return this;
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(x, y) {
      var e = this.elements;
      return {
        x: x * e[0] + y * e[2] + e[4],
        y: x * e[1] + y * e[3] + e[5]
      };
    }
  }, {
    key: "transformBBox",
    value: function transformBBox(bbox, target) {
      var elements3 = this.elements;
      var xx = elements3[0];
      var xy = elements3[1];
      var yx = elements3[2];
      var yy = elements3[3];
      var h_w = bbox.width * 0.5;
      var h_h = bbox.height * 0.5;
      var cx = bbox.x + h_w;
      var cy = bbox.y + h_h;
      var w = Math.abs(h_w * xx) + Math.abs(h_h * yx);
      var h = Math.abs(h_w * xy) + Math.abs(h_h * yy);
      if (!target) {
        target = new _BBox2(0, 0, 0, 0);
      }
      target.x = cx * xx + cy * yx + elements3[4] - w;
      target.y = cx * xy + cy * yy + elements3[5] - h;
      target.width = w + w;
      target.height = h + h;
      return target;
    }
  }, {
    key: "toContext",
    value: function toContext(ctx) {
      if (this.identity) {
        return;
      }
      var e = this.elements;
      ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
    }
  }, {
    key: "identity",
    get: function get() {
      var e = this.elements;
      return e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 1 && e[4] === 0 && e[5] === 0;
    }
  }], [{
    key: "flyweight",
    value: function flyweight(sourceMatrix) {
      return _Matrix.instance.setElements(sourceMatrix.elements);
    }
  }, {
    key: "updateTransformMatrix",
    value: function updateTransformMatrix(matrix, scalingX, scalingY, rotation, translationX, translationY, opts) {
      var bbcx = 0,
        bbcy = 0;
      var sx = scalingX;
      var sy = scalingY;
      var scx;
      var scy;
      if (sx === 1 && sy === 1) {
        scx = 0;
        scy = 0;
      } else {
        scx = (opts == null ? void 0 : opts.scalingCenterX) == null ? bbcx : opts == null ? void 0 : opts.scalingCenterX;
        scy = (opts == null ? void 0 : opts.scalingCenterY) == null ? bbcy : opts == null ? void 0 : opts.scalingCenterY;
      }
      var r = rotation;
      var cos = Math.cos(r);
      var sin = Math.sin(r);
      var rcx;
      var rcy;
      if (r === 0) {
        rcx = 0;
        rcy = 0;
      } else {
        rcx = (opts == null ? void 0 : opts.rotationCenterX) == null ? bbcx : opts == null ? void 0 : opts.rotationCenterX;
        rcy = (opts == null ? void 0 : opts.rotationCenterY) == null ? bbcy : opts == null ? void 0 : opts.rotationCenterY;
      }
      var tx = translationX;
      var ty = translationY;
      var tx4 = scx * (1 - sx) - rcx;
      var ty4 = scy * (1 - sy) - rcy;
      matrix.setElements([cos * sx, sin * sx, -sin * sy, cos * sy, cos * tx4 - sin * ty4 + rcx + tx, sin * tx4 + cos * ty4 + rcy + ty]);
      return matrix;
    }
  }, {
    key: "fromContext",
    value: function fromContext(ctx) {
      var domMatrix = ctx.getTransform();
      return new _Matrix([domMatrix.a, domMatrix.b, domMatrix.c, domMatrix.d, domMatrix.e, domMatrix.f]);
    }
  }]);
  return _Matrix;
}();
_Matrix.instance = new _Matrix();
var Matrix = _Matrix;

// packages/ag-charts-community/src/scene/node.ts
var _PointerEvents = /* @__PURE__ */function (PointerEvents2) {
  PointerEvents2[PointerEvents2["All"] = 0] = "All";
  PointerEvents2[PointerEvents2["None"] = 1] = "None";
  return PointerEvents2;
}(_PointerEvents || {});
var _Node = /*#__PURE__*/function (_ChangeDetectable) {
  _inherits(_Node, _ChangeDetectable);
  function _Node() {
    var _this13;
    var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isVirtual = _ref21.isVirtual,
      tag = _ref21.tag,
      zIndex = _ref21.zIndex;
    _classCallCheck(this, _Node);
    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(_Node).call(this));
    /** Unique number to allow creation order to be easily determined. */
    _this13.serialNumber = _Node._nextSerialNumber++;
    /**
     * Unique node ID in the form `ClassName-NaturalNumber`.
     */
    _this13.id = _createId(_assertThisInitialized(_this13));
    /**
     * To simplify the type system (especially in Selections) we don't have the `Parent` node
     * (one that has children). Instead, we mimic HTML DOM, where any node can have children.
     * But we still need to distinguish regular leaf nodes from container leafs somehow.
     */
    _this13.isContainerNode = false;
    _this13._virtualChildren = [];
    _this13._children = [];
    // Used to check for duplicate nodes.
    _this13.childSet = {};
    // These matrices may need to have package level visibility
    // for performance optimization purposes.
    _this13.matrix = new Matrix();
    _this13.dirtyTransform = false;
    _this13.scalingX = 1;
    _this13.scalingY = 1;
    _this13.scalingCenterX = null;
    _this13.scalingCenterY = null;
    _this13.rotationCenterX = null;
    _this13.rotationCenterY = null;
    _this13.rotation = 0;
    _this13.translationX = 0;
    _this13.translationY = 0;
    _this13._childNodeCounts = {
      groups: 0,
      nonGroups: 0
    };
    _this13.visible = true;
    _this13.dirtyZIndex = false;
    _this13.zIndex = 0;
    /** Discriminators for render order within a zIndex. */
    _this13.zIndexSubOrder = void 0;
    _this13.pointerEvents = 0 /* All */;
    _this13.isVirtual = isVirtual != null ? isVirtual : false;
    _this13.tag = tag != null ? tag : NaN;
    _this13.zIndex = zIndex != null ? zIndex : 0;
    return _this13;
  }
  /**
   * Some arbitrary data bound to the node.
   */
  _createClass(_Node, [{
    key: "_setLayerManager",
    value: function _setLayerManager(value) {
      this._layerManager = value;
      this._debug = value == null ? void 0 : value.debug;
      var _iterator27 = _createForOfIteratorHelper(this._children),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var child = _step27.value;
          child._setLayerManager(value);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      var _iterator28 = _createForOfIteratorHelper(this._virtualChildren),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var _child = _step28.value;
          _child._setLayerManager(value);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    }
  }, {
    key: "ancestors",
    value: /*#__PURE__*/_regenerator().m(function ancestors() {
      var node;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            node = this;
          case 1:
            if (!(node = node.parent)) {
              _context5.n = 3;
              break;
            }
            _context5.n = 2;
            return node;
          case 2:
            _context5.n = 1;
            break;
          case 3:
            return _context5.a(2);
        }
      }, ancestors, this);
    })
  }, {
    key: "traverseUp",
    value: /*#__PURE__*/_regenerator().m(function traverseUp() {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _context6.n = 1;
            return this;
          case 1:
            return _context6.d(_regeneratorValues(__yieldStar(this.ancestors())), 2);
          case 2:
            return _context6.a(2);
        }
      }, traverseUp, this);
    })
  }, {
    key: "hasVirtualChildren",
    value: function hasVirtualChildren() {
      return this._virtualChildren.length > 0;
    } // new Set<Node>()
  }, {
    key: "setProperties",
    value: function setProperties(styles, pickKeys) {
      var keys = pickKeys != null ? pickKeys : Object.keys(styles);
      var _iterator29 = _createForOfIteratorHelper(keys),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var key = _step29.value;
          this[key] = styles[key];
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
      return this;
    }
    /**
     * Appends one or more new node instances to this parent.
     * If one needs to:
     * - move a child to the end of the list of children
     * - move a child from one parent to another (including parents in other scenes)
     * one should use the {@link insertBefore} method instead.
     * @param nodes A node or nodes to append.
     */
  }, {
    key: "append",
    value: function append(nodes) {
      if (!Array.isArray(nodes)) {
        nodes = [nodes];
      }
      var _iterator30 = _createForOfIteratorHelper(nodes),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var node = _step30.value;
          if (node.parent) {
            throw new Error("".concat(node, " already belongs to another parent: ").concat(node.parent, "."));
          }
          if (node.layerManager) {
            throw new Error("".concat(node, " already belongs to a scene: ").concat(node.layerManager, "."));
          }
          if (this.childSet[node.id]) {
            throw new Error("Duplicate ".concat(node.constructor.name, " node: ").concat(node));
          }
          if (node.isVirtual) {
            this._virtualChildren.push(node);
          } else {
            this._children.push(node);
          }
          this.childSet[node.id] = true;
          node._parent = this;
          node._setLayerManager(this.layerManager);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      this.dirtyZIndex = true;
      this.markDirty(this, 3 /* MAJOR */);
    }
  }, {
    key: "appendChild",
    value: function appendChild(node) {
      this.append(node);
      return node;
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      var error = function error() {
        throw new Error("The node to be removed is not a child of this node.");
      };
      if (node.parent !== this) {
        error();
      }
      if (node.isVirtual) {
        var i = this._virtualChildren.indexOf(node);
        if (i < 0) error();
        this._virtualChildren.splice(i, 1);
      } else {
        var _i10 = this._children.indexOf(node);
        if (_i10 < 0) error();
        this._children.splice(_i10, 1);
      }
      delete this.childSet[node.id];
      node._parent = void 0;
      node._setLayerManager();
      this.dirtyZIndex = true;
      this.markDirty(node, 3 /* MAJOR */);
      return node;
    }
  }, {
    key: "calculateCumulativeMatrix",
    value: function calculateCumulativeMatrix() {
      this.computeTransformMatrix();
      var matrix = Matrix.flyweight(this.matrix);
      var _iterator31 = _createForOfIteratorHelper(this.ancestors()),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var parent = _step31.value;
          parent.computeTransformMatrix();
          matrix.preMultiplySelf(parent.matrix);
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return matrix;
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(x, y) {
      var matrix = this.calculateCumulativeMatrix();
      return matrix.invertSelf().transformPoint(x, y);
    }
  }, {
    key: "inverseTransformPoint",
    value: function inverseTransformPoint(x, y) {
      var matrix = this.calculateCumulativeMatrix();
      return matrix.transformPoint(x, y);
    }
  }, {
    key: "transformBBox",
    value: function transformBBox(bbox) {
      var matrix = this.calculateCumulativeMatrix();
      return matrix.invertSelf().transformBBox(bbox);
    }
  }, {
    key: "inverseTransformBBox",
    value: function inverseTransformBBox(bbox) {
      var matrix = this.calculateCumulativeMatrix();
      return matrix.transformBBox(bbox);
    }
  }, {
    key: "markDirtyTransform",
    value: function markDirtyTransform() {
      this.dirtyTransform = true;
      this.markDirty(this, 3 /* MAJOR */);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(_x, _y) {
      return false;
    }
    /**
     * Hit testing method.
     * Recursively checks if the given point is inside this node or any of its children.
     * Returns the first matching node or `undefined`.
     * Nodes that render later (show on top) are hit tested first.
     */
  }, {
    key: "pickNode",
    value: function pickNode(x, y) {
      var _a;
      if (!this.visible || this.pointerEvents === 1 /* None */ || !this.containsPoint(x, y)) {
        return;
      }
      var children = this.children;
      if (children.length > 1e3) {
        for (var i = children.length - 1; i >= 0; i--) {
          var child = children[i];
          var containsPoint = (_a = child.computeTransformedBBox()) == null ? void 0 : _a.containsPoint(x, y);
          var hit = containsPoint ? child.pickNode(x, y) : void 0;
          if (hit) {
            return hit;
          }
        }
      } else if (children.length) {
        for (var _i11 = children.length - 1; _i11 >= 0; _i11--) {
          var _hit = children[_i11].pickNode(x, y);
          if (_hit) {
            return _hit;
          }
        }
      } else if (!this.isContainerNode) {
        return this;
      }
    }
  }, {
    key: "getCachedBBox",
    value: function getCachedBBox() {
      var _a;
      return (_a = this.cachedBBox) != null ? _a : _BBox2.zero;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      return;
    }
  }, {
    key: "computeTransformedBBox",
    value: function computeTransformedBBox() {
      var bbox = this.computeBBox();
      if (!bbox) {
        return;
      }
      this.computeTransformMatrix();
      var matrix = Matrix.flyweight(this.matrix);
      var _iterator32 = _createForOfIteratorHelper(this.ancestors()),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var parent = _step32.value;
          parent.computeTransformMatrix();
          matrix.preMultiplySelf(parent.matrix);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      matrix.transformBBox(bbox, bbox);
      return bbox;
    }
  }, {
    key: "computeTransformMatrix",
    value: function computeTransformMatrix() {
      if (!this.dirtyTransform) {
        return;
      }
      var matrix = this.matrix,
        scalingX = this.scalingX,
        scalingY = this.scalingY,
        rotation = this.rotation,
        translationX = this.translationX,
        translationY = this.translationY,
        scalingCenterX = this.scalingCenterX,
        scalingCenterY = this.scalingCenterY,
        rotationCenterX = this.rotationCenterX,
        rotationCenterY = this.rotationCenterY;
      Matrix.updateTransformMatrix(matrix, scalingX, scalingY, rotation, translationX, translationY, {
        scalingCenterX: scalingCenterX,
        scalingCenterY: scalingCenterY,
        rotationCenterX: rotationCenterX,
        rotationCenterY: rotationCenterY
      });
      this.dirtyTransform = false;
    } /** Perform any pre-rendering initialization. */
  }, {
    key: "preRender",
    value: function preRender() {
      this._childNodeCounts.groups = 0;
      this._childNodeCounts.nonGroups = 1;
      var _iterator33 = _createForOfIteratorHelper(this.children),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var child = _step33.value;
          var childCounts = child.preRender();
          this._childNodeCounts.groups += childCounts.groups;
          this._childNodeCounts.nonGroups += childCounts.nonGroups;
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      return this._childNodeCounts;
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      var stats = renderCtx.stats;
      this._dirty = 0 /* NONE */;
      this.cachedBBox = this.computeBBox();
      if (stats) {
        stats.nodesRendered++;
      }
    }
  }, {
    key: "markDirty",
    value: function markDirty(_source) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var parentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : type;
      if (this._dirty > type || this._dirty === type && type === parentType) {
        return;
      }
      this._dirty = type;
      if (this.parent) {
        this.parent.markDirty(this, parentType);
      } else if (this.layerManager) {
        this.layerManager.markDirty();
      }
    }
  }, {
    key: "markClean",
    value: function markClean(opts) {
      var _ref22 = opts != null ? opts : {},
        _ref22$force = _ref22.force,
        force = _ref22$force === void 0 ? false : _ref22$force,
        _ref22$recursive = _ref22.recursive,
        recursive = _ref22$recursive === void 0 ? true : _ref22$recursive;
      if (this._dirty === 0 /* NONE */ && !force) {
        return;
      }
      this._dirty = 0 /* NONE */;
      if (recursive !== false) {
        var _iterator34 = _createForOfIteratorHelper(this._virtualChildren),
          _step34;
        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var child = _step34.value;
            child.markClean({
              force: force
            });
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
      }
      if (recursive === true) {
        var _iterator35 = _createForOfIteratorHelper(this._children),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var _child2 = _step35.value;
            _child2.markClean({
              force: force
            });
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
      }
    }
  }, {
    key: "onVisibleChange",
    value: function onVisibleChange() {}
  }, {
    key: "onZIndexChange",
    value: function onZIndexChange() {
      if (this.parent) {
        this.parent.dirtyZIndex = true;
      }
    }
  }, {
    key: "datum",
    get: function get() {
      var _a, _b;
      return (_b = this._datum) != null ? _b : (_a = this._parent) == null ? void 0 : _a.datum;
    },
    set: function set(datum) {
      if (this._datum !== datum) {
        this._previousDatum = this._datum;
      }
      this._datum = datum;
    }
  }, {
    key: "previousDatum",
    get: function get() {
      return this._previousDatum;
    }
  }, {
    key: "layerManager",
    get: function get() {
      return this._layerManager;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "children",
    get: function get() {
      return this._virtualChildren.length ? this._children.concat(this._virtualChildren.flatMap(function (next) {
        return next.children;
      })) : this._children;
    }
  }, {
    key: "virtualChildren",
    get: function get() {
      return this._virtualChildren;
    }
  }, {
    key: "dirty",
    get: function get() {
      return this._dirty;
    }
  }, {
    key: "nodeCount",
    get: function get() {
      var count = 1;
      var dirtyCount = this._dirty >= 0 /* NONE */ || this.dirtyTransform ? 1 : 0;
      var visibleCount = this.visible ? 1 : 0;
      var countChild = function countChild(child) {
        var _child$nodeCount = child.nodeCount,
          childCount = _child$nodeCount.count,
          childVisibleCount = _child$nodeCount.visibleCount,
          childDirtyCount = _child$nodeCount.dirtyCount;
        count += childCount;
        visibleCount += childVisibleCount;
        dirtyCount += childDirtyCount;
      };
      var _iterator36 = _createForOfIteratorHelper(this._children),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var child = _step36.value;
          countChild(child);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      var _iterator37 = _createForOfIteratorHelper(this._virtualChildren),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var _child3 = _step37.value;
          countChild(_child3);
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      return {
        count: count,
        visibleCount: visibleCount,
        dirtyCount: dirtyCount
      };
    }
  }]);
  return _Node;
}(ChangeDetectable);
_Node._nextSerialNumber = 0;
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "scalingX", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "scalingY", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "scalingCenterX", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "scalingCenterY", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "rotationCenterX", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "rotationCenterY", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "rotation", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "translationX", 2);
__decorateClass([_SceneChangeDetection({
  type: "transform"
})], _Node.prototype, "translationY", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */,
  changeCb: function changeCb(target) {
    return target.onVisibleChange();
  }
})], _Node.prototype, "visible", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 1 /* TRIVIAL */,
  changeCb: function changeCb(target) {
    return target.onZIndexChange();
  }
})], _Node.prototype, "zIndex", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 1 /* TRIVIAL */,
  changeCb: function changeCb(target) {
    return target.onZIndexChange();
  }
})], _Node.prototype, "zIndexSubOrder", 2);
var _Node4 = _Node;

// packages/ag-charts-community/src/util/color.ts
var srgbToLinear = function srgbToLinear(value) {
  var sign = value < 0 ? -1 : 1;
  var abs = Math.abs(value);
  if (abs <= 0.04045) return value / 12.92;
  return sign * __pow((abs + 0.055) / 1.055, 2.4);
};
var srgbFromLinear = function srgbFromLinear(value) {
  var sign = value < 0 ? -1 : 1;
  var abs = Math.abs(value);
  if (abs > 31308e-7) {
    return sign * (1.055 * __pow(abs, 1 / 2.4) - 0.055);
  }
  return 12.92 * value;
};
var _Color = /*#__PURE__*/function () {
  /**
   * Every color component should be in the [0, 1] range.
   * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
   * So, when animating colors, if the source or target color components are already near
   * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
   * component value to end up outside of that range mid-animation. For this reason the constructor
   * performs range checking/constraining.
   * @param r Red component.
   * @param g Green component.
   * @param b Blue component.
   * @param a Alpha (opacity) component.
   */
  function _Color(r, g, b) {
    var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    _classCallCheck(this, _Color);
    this.r = _clamp(0, r || 0, 1);
    this.g = _clamp(0, g || 0, 1);
    this.b = _clamp(0, b || 0, 1);
    this.a = _clamp(0, a || 0, 1);
  }
  /**
   * A color string can be in one of the following formats to be valid:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   */
  _createClass(_Color, [{
    key: "toHexString",
    value: function toHexString() {
      var hex = "#" + _Color.padHex(Math.round(this.r * 255).toString(16)) + _Color.padHex(Math.round(this.g * 255).toString(16)) + _Color.padHex(Math.round(this.b * 255).toString(16));
      if (this.a < 1) {
        hex += _Color.padHex(Math.round(this.a * 255).toString(16));
      }
      return hex;
    }
  }, {
    key: "toRgbaString",
    value: function toRgbaString() {
      var fractionDigits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var components = [Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255)];
      var k = Math.pow(10, fractionDigits);
      if (this.a !== 1) {
        components.push(Math.round(this.a * k) / k);
        return "rgba(".concat(components.join(", "), ")");
      }
      return "rgb(".concat(components.join(", "), ")");
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this.a === 1) {
        return this.toHexString();
      }
      return this.toRgbaString();
    }
  }, {
    key: "toHSB",
    value: function toHSB() {
      return _Color.RGBtoHSB(this.r, this.g, this.b);
    }
  }, {
    key: "derive",
    value: function derive(hueShift, saturationFactor, brightnessFactor, opacityFactor) {
      var hsb = _Color.RGBtoHSB(this.r, this.g, this.b);
      var b = hsb[2];
      if (b == 0 && brightnessFactor > 1) {
        b = 0.05;
      }
      var h = ((hsb[0] + hueShift) % 360 + 360) % 360;
      var s = _clamp(0, hsb[1] * saturationFactor, 1);
      b = _clamp(0, b * brightnessFactor, 1);
      var a = _clamp(0, this.a * opacityFactor, 1);
      var rgba = _Color.HSBtoRGB(h, s, b);
      rgba.push(a);
      return _Color.fromArray(rgba);
    }
  }, {
    key: "brighter",
    value: function brighter() {
      return this.derive(0, 1, 1 / 0.7, 1);
    }
  }, {
    key: "darker",
    value: function darker() {
      return this.derive(0, 1, 0.7, 1);
    }
  }], [{
    key: "validColorString",
    value: function validColorString(str) {
      if (str.indexOf("#") >= 0) {
        return !!_Color.parseHex(str);
      }
      if (str.indexOf("rgb") >= 0) {
        return !!_Color.stringToRgba(str);
      }
      return !!_Color.nameToHex[str.toLowerCase()];
    }
    /**
     * The given string can be in one of the following formats:
     * - #rgb
     * - #rrggbb
     * - rgb(r, g, b)
     * - rgba(r, g, b, a)
     * - CSS color name such as 'white', 'orange', 'cyan', etc.
     * @param str
     */
  }, {
    key: "fromString",
    value: function fromString(str) {
      if (str.indexOf("#") >= 0) {
        return _Color.fromHexString(str);
      }
      var hex = _Color.nameToHex[str.toLowerCase()];
      if (hex) {
        return _Color.fromHexString(hex);
      }
      if (str.indexOf("rgb") >= 0) {
        return _Color.fromRgbaString(str);
      }
      throw new Error("Invalid color string: '".concat(str, "'"));
    }
  }, {
    key: "tryParseFromString",
    value: function tryParseFromString(str) {
      try {
        return _Color.fromString(str);
      } catch (e) {
        _Logger.warnOnce("invalid color string: '".concat(str, "'."));
        return _Color.fromArray([0, 0, 0]);
      }
    } // See https://drafts.csswg.org/css-color/#hex-notation
  }, {
    key: "parseHex",
    value: function parseHex(input) {
      input = input.replace(/ /g, "").slice(1);
      var parts;
      switch (input.length) {
        case 6:
        case 8:
          parts = [];
          for (var i = 0; i < input.length; i += 2) {
            parts.push(parseInt("".concat(input[i]).concat(input[i + 1]), 16));
          }
          break;
        case 3:
        case 4:
          parts = input.split("").map(function (p) {
            return parseInt(p, 16);
          }).map(function (p) {
            return p + p * 16;
          });
          break;
      }
      if ((parts == null ? void 0 : parts.length) >= 3 && parts.every(function (p) {
        return p >= 0;
      })) {
        if (parts.length === 3) {
          parts.push(255);
        }
        return parts;
      }
    }
  }, {
    key: "fromHexString",
    value: function fromHexString(str) {
      var values = _Color.parseHex(str);
      if (values) {
        var _values = _slicedToArray(values, 4),
          r = _values[0],
          g = _values[1],
          b = _values[2],
          a = _values[3];
        return new _Color(r / 255, g / 255, b / 255, a / 255);
      }
      throw new Error("Malformed hexadecimal color string: '".concat(str, "'"));
    }
  }, {
    key: "stringToRgba",
    value: function stringToRgba(str) {
      var po = NaN,
        pc = NaN;
      for (var i = 0; i < str.length; i++) {
        var c = str[i];
        if (!po && c === "(") {
          po = i;
        } else if (c === ")") {
          pc = i;
          break;
        }
      }
      var contents = po && pc && str.substring(po + 1, pc);
      if (!contents) {
        return;
      }
      var parts = contents.split(",");
      var rgba = [];
      for (var _i12 = 0; _i12 < parts.length; _i12++) {
        var part = parts[_i12];
        var value = parseFloat(part);
        if (isNaN(value)) {
          return;
        }
        if (part.indexOf("%") >= 0) {
          value = _clamp(0, value, 100);
          value /= 100;
        } else if (_i12 === 3) {
          value = _clamp(0, value, 1);
        } else {
          value = _clamp(0, value, 255);
          value /= 255;
        }
        rgba.push(value);
      }
      return rgba;
    }
  }, {
    key: "fromRgbaString",
    value: function fromRgbaString(str) {
      var rgba = _Color.stringToRgba(str);
      if (rgba) {
        if (rgba.length === 3) {
          return new _Color(rgba[0], rgba[1], rgba[2]);
        } else if (rgba.length === 4) {
          return new _Color(rgba[0], rgba[1], rgba[2], rgba[3]);
        }
      }
      throw new Error("Malformed rgb/rgba color string: '".concat(str, "'"));
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      if (arr.length === 4) {
        return new _Color(arr[0], arr[1], arr[2], arr[3]);
      }
      if (arr.length === 3) {
        return new _Color(arr[0], arr[1], arr[2]);
      }
      throw new Error("The given array should contain 3 or 4 color components (numbers).");
    }
  }, {
    key: "fromHSB",
    value: function fromHSB(h, s, b) {
      var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var rgb = _Color.HSBtoRGB(h, s, b);
      return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
  }, {
    key: "fromHSL",
    value: function fromHSL(h, s, l) {
      var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var rgb = _Color.HSLtoRGB(h, s, l);
      return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
  }, {
    key: "fromOKLCH",
    value: function fromOKLCH(l, c, h) {
      var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var rgb = _Color.OKLCHtoRGB(l, c, h);
      return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
  }, {
    key: "padHex",
    value: function padHex(str) {
      return str.length === 1 ? "0" + str : str;
    }
  }, {
    key: "RGBtoOKLCH",
    value: function RGBtoOKLCH(r, g, b) {
      var LSRGB0 = srgbToLinear(r);
      var LSRGB1 = srgbToLinear(g);
      var LSRGB2 = srgbToLinear(b);
      var LMS0 = Math.cbrt(0.4122214708 * LSRGB0 + 0.5363325363 * LSRGB1 + 0.0514459929 * LSRGB2);
      var LMS1 = Math.cbrt(0.2119034982 * LSRGB0 + 0.6806995451 * LSRGB1 + 0.1073969566 * LSRGB2);
      var LMS2 = Math.cbrt(0.0883024619 * LSRGB0 + 0.2817188376 * LSRGB1 + 0.6299787005 * LSRGB2);
      var OKLAB0 = 0.2104542553 * LMS0 + 0.793617785 * LMS1 - 0.0040720468 * LMS2;
      var OKLAB1 = 1.9779984951 * LMS0 - 2.428592205 * LMS1 + 0.4505937099 * LMS2;
      var OKLAB2 = 0.0259040371 * LMS0 + 0.7827717662 * LMS1 - 0.808675766 * LMS2;
      var hue = Math.atan2(OKLAB2, OKLAB1) * 180 / Math.PI;
      var OKLCH0 = OKLAB0;
      var OKLCH1 = Math.hypot(OKLAB1, OKLAB2);
      var OKLCH2 = hue >= 0 ? hue : hue + 360;
      return [OKLCH0, OKLCH1, OKLCH2];
    }
  }, {
    key: "OKLCHtoRGB",
    value: function OKLCHtoRGB(l, c, h) {
      var OKLAB0 = l;
      var OKLAB1 = c * Math.cos(h * Math.PI / 180);
      var OKLAB2 = c * Math.sin(h * Math.PI / 180);
      var LMS0 = __pow(OKLAB0 + 0.3963377774 * OKLAB1 + 0.2158037573 * OKLAB2, 3);
      var LMS1 = __pow(OKLAB0 - 0.1055613458 * OKLAB1 - 0.0638541728 * OKLAB2, 3);
      var LMS2 = __pow(OKLAB0 - 0.0894841775 * OKLAB1 - 1.291485548 * OKLAB2, 3);
      var LSRGB0 = 4.0767416621 * LMS0 - 3.3077115913 * LMS1 + 0.2309699292 * LMS2;
      var LSRGB1 = -1.2684380046 * LMS0 + 2.6097574011 * LMS1 - 0.3413193965 * LMS2;
      var LSRGB2 = -0.0041960863 * LMS0 - 0.7034186147 * LMS1 + 1.707614701 * LMS2;
      var SRGB0 = srgbFromLinear(LSRGB0);
      var SRGB1 = srgbFromLinear(LSRGB1);
      var SRGB2 = srgbFromLinear(LSRGB2);
      return [SRGB0, SRGB1, SRGB2];
    }
  }, {
    key: "RGBtoHSL",
    value: function RGBtoHSL(r, g, b) {
      var min = Math.min(r, g, b);
      var max = Math.max(r, g, b);
      var l = (max + min) / 2;
      var h;
      var s;
      if (max === min) {
        h = NaN;
        s = 0;
      } else {
        var delta2 = max - min;
        s = l > 0.5 ? delta2 / (2 - max - min) : delta2 / (max + min);
        if (max === r) {
          h = (g - b) / delta2 + (g < b ? 6 : 0);
        } else if (max === g) {
          h = (b - r) / delta2 + 2;
        } else {
          h = (r - g) / delta2 + 4;
        }
        h *= 360 / 6;
      }
      return [h, s, l];
    }
  }, {
    key: "HSLtoRGB",
    value: function HSLtoRGB(h, s, l) {
      if (s === 0) {
        return [l, l, l];
      }
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      function hueToRgb(t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }
      var r = hueToRgb(h / 360 + 1 / 3);
      var g = hueToRgb(h / 360);
      var b = hueToRgb(h / 360 - 1 / 3);
      return [r, g, b];
    }
    /**
     * Converts the given RGB triple to an array of HSB (HSV) components.
     * The hue component will be `NaN` for achromatic colors.
     */
  }, {
    key: "RGBtoHSB",
    value: function RGBtoHSB(r, g, b) {
      var min = Math.min(r, g, b);
      var max = Math.max(r, g, b);
      var S = max === 0 ? 0 : (max - min) / max;
      var H = NaN;
      if (min !== max) {
        var delta2 = max - min;
        var rc = (max - r) / delta2;
        var gc = (max - g) / delta2;
        var bc = (max - b) / delta2;
        if (r === max) {
          H = bc - gc;
        } else if (g === max) {
          H = 2 + rc - bc;
        } else {
          H = 4 + gc - rc;
        }
        H /= 6;
        if (H < 0) {
          H = H + 1;
        }
      }
      return [H * 360, S, max];
    }
    /**
     * Converts the given HSB (HSV) triple to an array of RGB components.
     */
  }, {
    key: "HSBtoRGB",
    value: function HSBtoRGB(H, S, B) {
      if (isNaN(H)) {
        H = 0;
      }
      H = (H % 360 + 360) % 360 / 360;
      var r = 0;
      var g = 0;
      var b = 0;
      if (S === 0) {
        r = g = b = B;
      } else {
        var h = (H - Math.floor(H)) * 6;
        var f = h - Math.floor(h);
        var p = B * (1 - S);
        var q = B * (1 - S * f);
        var t = B * (1 - S * (1 - f));
        switch (h >> 0) {
          case 0:
            r = B;
            g = t;
            b = p;
            break;
          case 1:
            r = q;
            g = B;
            b = p;
            break;
          case 2:
            r = p;
            g = B;
            b = t;
            break;
          case 3:
            r = p;
            g = q;
            b = B;
            break;
          case 4:
            r = t;
            g = p;
            b = B;
            break;
          case 5:
            r = B;
            g = p;
            b = q;
            break;
        }
      }
      return [r, g, b];
    }
  }, {
    key: "interpolate",
    value: function interpolate(color, other) {
      var c0 = _Color.tryParseFromString(color);
      var c1 = _Color.tryParseFromString(other);
      return function (t) {
        var i = function i(x, y) {
          return x * (1 - t) + y * t;
        };
        var c = new _Color(i(c0.r, c1.r), i(c0.g, c1.g), i(c0.b, c1.b), i(c0.a, c1.a));
        return c.toString();
      };
    }
  }]);
  return _Color;
}();
_Color.didDebug = false;
/**
 * CSS Color Module Level 4:
 * https://drafts.csswg.org/css-color/#named-colors
 */
_Color.nameToHex = Object.freeze({
  aliceblue: "#F0F8FF",
  antiquewhite: "#FAEBD7",
  aqua: "#00FFFF",
  aquamarine: "#7FFFD4",
  azure: "#F0FFFF",
  beige: "#F5F5DC",
  bisque: "#FFE4C4",
  black: "#000000",
  blanchedalmond: "#FFEBCD",
  blue: "#0000FF",
  blueviolet: "#8A2BE2",
  brown: "#A52A2A",
  burlywood: "#DEB887",
  cadetblue: "#5F9EA0",
  chartreuse: "#7FFF00",
  chocolate: "#D2691E",
  coral: "#FF7F50",
  cornflowerblue: "#6495ED",
  cornsilk: "#FFF8DC",
  crimson: "#DC143C",
  cyan: "#00FFFF",
  darkblue: "#00008B",
  darkcyan: "#008B8B",
  darkgoldenrod: "#B8860B",
  darkgray: "#A9A9A9",
  darkgreen: "#006400",
  darkgrey: "#A9A9A9",
  darkkhaki: "#BDB76B",
  darkmagenta: "#8B008B",
  darkolivegreen: "#556B2F",
  darkorange: "#FF8C00",
  darkorchid: "#9932CC",
  darkred: "#8B0000",
  darksalmon: "#E9967A",
  darkseagreen: "#8FBC8F",
  darkslateblue: "#483D8B",
  darkslategray: "#2F4F4F",
  darkslategrey: "#2F4F4F",
  darkturquoise: "#00CED1",
  darkviolet: "#9400D3",
  deeppink: "#FF1493",
  deepskyblue: "#00BFFF",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1E90FF",
  firebrick: "#B22222",
  floralwhite: "#FFFAF0",
  forestgreen: "#228B22",
  fuchsia: "#FF00FF",
  gainsboro: "#DCDCDC",
  ghostwhite: "#F8F8FF",
  gold: "#FFD700",
  goldenrod: "#DAA520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#ADFF2F",
  grey: "#808080",
  honeydew: "#F0FFF0",
  hotpink: "#FF69B4",
  indianred: "#CD5C5C",
  indigo: "#4B0082",
  ivory: "#FFFFF0",
  khaki: "#F0E68C",
  lavender: "#E6E6FA",
  lavenderblush: "#FFF0F5",
  lawngreen: "#7CFC00",
  lemonchiffon: "#FFFACD",
  lightblue: "#ADD8E6",
  lightcoral: "#F08080",
  lightcyan: "#E0FFFF",
  lightgoldenrodyellow: "#FAFAD2",
  lightgray: "#D3D3D3",
  lightgreen: "#90EE90",
  lightgrey: "#D3D3D3",
  lightpink: "#FFB6C1",
  lightsalmon: "#FFA07A",
  lightseagreen: "#20B2AA",
  lightskyblue: "#87CEFA",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#B0C4DE",
  lightyellow: "#FFFFE0",
  lime: "#00FF00",
  limegreen: "#32CD32",
  linen: "#FAF0E6",
  magenta: "#FF00FF",
  maroon: "#800000",
  mediumaquamarine: "#66CDAA",
  mediumblue: "#0000CD",
  mediumorchid: "#BA55D3",
  mediumpurple: "#9370DB",
  mediumseagreen: "#3CB371",
  mediumslateblue: "#7B68EE",
  mediumspringgreen: "#00FA9A",
  mediumturquoise: "#48D1CC",
  mediumvioletred: "#C71585",
  midnightblue: "#191970",
  mintcream: "#F5FFFA",
  mistyrose: "#FFE4E1",
  moccasin: "#FFE4B5",
  navajowhite: "#FFDEAD",
  navy: "#000080",
  oldlace: "#FDF5E6",
  olive: "#808000",
  olivedrab: "#6B8E23",
  orange: "#FFA500",
  orangered: "#FF4500",
  orchid: "#DA70D6",
  palegoldenrod: "#EEE8AA",
  palegreen: "#98FB98",
  paleturquoise: "#AFEEEE",
  palevioletred: "#DB7093",
  papayawhip: "#FFEFD5",
  peachpuff: "#FFDAB9",
  peru: "#CD853F",
  pink: "#FFC0CB",
  plum: "#DDA0DD",
  powderblue: "#B0E0E6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#FF0000",
  rosybrown: "#BC8F8F",
  royalblue: "#4169E1",
  saddlebrown: "#8B4513",
  salmon: "#FA8072",
  sandybrown: "#F4A460",
  seagreen: "#2E8B57",
  seashell: "#FFF5EE",
  sienna: "#A0522D",
  silver: "#C0C0C0",
  skyblue: "#87CEEB",
  slateblue: "#6A5ACD",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#FFFAFA",
  springgreen: "#00FF7F",
  steelblue: "#4682B4",
  tan: "#D2B48C",
  teal: "#008080",
  thistle: "#D8BFD8",
  tomato: "#FF6347",
  transparent: "#00000000",
  turquoise: "#40E0D0",
  violet: "#EE82EE",
  wheat: "#F5DEB3",
  white: "#FFFFFF",
  whitesmoke: "#F5F5F5",
  yellow: "#FFFF00",
  yellowgreen: "#9ACD32"
});
var _Color2 = _Color;

// packages/ag-charts-community/src/util/interpolate.ts
function interpolateNumber(a, b) {
  return function (d) {
    return Number(a) * (1 - d) + Number(b) * d;
  };
}
function interpolateColor(a, b) {
  if (typeof a === "string") {
    try {
      a = _Color2.fromString(a);
    } catch (e) {
      a = _Color2.fromArray([0, 0, 0]);
    }
  }
  if (typeof b === "string") {
    try {
      b = _Color2.fromString(b);
    } catch (e) {
      b = _Color2.fromArray([0, 0, 0]);
    }
  }
  var red = interpolateNumber(a.r, b.r);
  var green = interpolateNumber(a.g, b.g);
  var blue = interpolateNumber(a.b, b.b);
  var alpha = interpolateNumber(a.a, b.a);
  return function (d) {
    return _Color2.fromArray([red(d), green(d), blue(d), alpha(d)]).toRgbaString();
  };
}

// packages/ag-charts-community/src/motion/easing.ts
var easing_exports = {};
__export(easing_exports, {
  easeIn: function easeIn() {
    return _easeIn;
  },
  easeInOut: function easeInOut() {
    return _easeInOut;
  },
  easeInOutQuad: function easeInOutQuad() {
    return _easeInOutQuad;
  },
  easeInQuad: function easeInQuad() {
    return _easeInQuad;
  },
  easeOut: function easeOut() {
    return _easeOut;
  },
  easeOutQuad: function easeOutQuad() {
    return _easeOutQuad;
  },
  inverseEaseOut: function inverseEaseOut() {
    return _inverseEaseOut;
  },
  linear: function linear() {
    return _linear;
  }
});
var _linear = function _linear(n) {
  return n;
};
var _easeIn = function _easeIn(n) {
  return 1 - Math.cos(n * Math.PI / 2);
};
var _easeOut = function _easeOut(n) {
  return Math.sin(n * Math.PI / 2);
};
var _easeInOut = function _easeInOut(n) {
  return -(Math.cos(n * Math.PI) - 1) / 2;
};
var _easeInQuad = function _easeInQuad(n) {
  return n * n;
};
var _easeOutQuad = function _easeOutQuad(n) {
  return 1 - __pow(1 - n, 2);
};
var _easeInOutQuad = function _easeInOutQuad(n) {
  return n < 0.5 ? 2 * n * n : 1 - __pow(-2 * n + 2, 2) / 2;
};
var _inverseEaseOut = function _inverseEaseOut(x) {
  return 2 * Math.asin(x) / Math.PI;
};

// packages/ag-charts-community/src/motion/animation.ts
var _QUICK_TRANSITION = 0.2;
var _PHASE_ORDER = ["initial", "remove", "update", "add", "trailing", "end", "none"];
var _PHASE_METADATA = {
  initial: {
    animationDuration: 1,
    animationDelay: 0
  },
  add: {
    animationDuration: 0.25,
    animationDelay: 0.75
  },
  remove: {
    animationDuration: 0.25,
    animationDelay: 0
  },
  update: {
    animationDuration: 0.5,
    animationDelay: 0.25
  },
  trailing: {
    animationDuration: _QUICK_TRANSITION,
    animationDelay: 1,
    skipIfNoEarlierAnimations: true
  },
  end: {
    animationDelay: 1 + _QUICK_TRANSITION,
    animationDuration: 0,
    skipIfNoEarlierAnimations: true
  },
  none: {
    animationDuration: 0,
    animationDelay: 0
  }
};
var _RepeatType = /* @__PURE__ */function (RepeatType2) {
  RepeatType2["Loop"] = "loop";
  RepeatType2["Reverse"] = "reverse";
  return RepeatType2;
}(_RepeatType || {});
function isNodeArray(array) {
  return array.every(function (n) {
    return n instanceof _Node4;
  });
}
function _deconstructSelectionsOrNodes(selectionsOrNodes) {
  return isNodeArray(selectionsOrNodes) ? {
    nodes: selectionsOrNodes,
    selections: []
  } : {
    nodes: [],
    selections: selectionsOrNodes
  };
}
var _Animation = /*#__PURE__*/function () {
  function Animation(opts) {
    _classCallCheck(this, Animation);
    this.isComplete = false;
    this.elapsed = 0;
    this.iteration = 0;
    this.isPlaying = false;
    this.isReverse = false;
    var _a, _b, _c, _d, _e, _f, _g;
    this.id = opts.id;
    this.groupId = opts.groupId;
    this.autoplay = (_a = opts.autoplay) != null ? _a : true;
    this.ease = (_b = opts.ease) != null ? _b : _linear;
    this.phase = opts.phase;
    var durationProportion = (_c = opts.duration) != null ? _c : _PHASE_METADATA[this.phase].animationDuration;
    this.duration = durationProportion * opts.defaultDuration;
    this.delay = ((_d = opts.delay) != null ? _d : 0) * opts.defaultDuration;
    this.onComplete = opts.onComplete;
    this.onPlay = opts.onPlay;
    this.onStop = opts.onStop;
    this.onUpdate = opts.onUpdate;
    this.interpolate = this.createInterpolator(opts.from, opts.to);
    this.from = opts.from;
    if (opts.skip === true) {
      (_e = this.onUpdate) == null ? void 0 : _e.call(this, opts.to, false, this);
      (_f = this.onStop) == null ? void 0 : _f.call(this, this);
      (_g = this.onComplete) == null ? void 0 : _g.call(this, this);
      this.isComplete = true;
    }
    if (opts.collapsable !== false) {
      this.duration = this.checkCollapse(opts, this.duration);
    }
  }
  _createClass(Animation, [{
    key: "checkCollapse",
    value: function checkCollapse(opts, calculatedDuration) {
      if (opts.from === opts.to) return 0;
      var diff2 = typeof opts.from === "object" ? _jsonDiff(opts.from, opts.to) : null;
      if (diff2) {
        return calculatedDuration;
      }
      return 0;
    }
  }, {
    key: "play",
    value: function play() {
      var initialUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _a, _b;
      if (this.isPlaying || this.isComplete) return;
      this.isPlaying = true;
      (_a = this.onPlay) == null ? void 0 : _a.call(this, this);
      if (!this.autoplay) return;
      this.autoplay = false;
      if (!initialUpdate) return;
      (_b = this.onUpdate) == null ? void 0 : _b.call(this, this.from, true, this);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.isPlaying = false;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _a;
      this.isPlaying = false;
      if (!this.isComplete) {
        this.isComplete = true;
        (_a = this.onStop) == null ? void 0 : _a.call(this, this);
      }
    }
  }, {
    key: "update",
    value: function update(time2) {
      var _a, _b;
      if (this.isComplete) return time2;
      if (!this.isPlaying && this.autoplay) {
        this.play(true);
      }
      var previousElapsed = this.elapsed;
      this.elapsed += time2;
      if (this.delay > this.elapsed) return 0;
      var value = this.interpolate(this.isReverse ? 1 - this.delta : this.delta);
      (_a = this.onUpdate) == null ? void 0 : _a.call(this, value, false, this);
      var totalDuration = this.delay + this.duration;
      if (this.elapsed >= totalDuration) {
        this.stop();
        this.isComplete = true;
        (_b = this.onComplete) == null ? void 0 : _b.call(this, this);
        return time2 - (totalDuration - previousElapsed);
      }
      return 0;
    }
  }, {
    key: "createInterpolator",
    value: function createInterpolator(from, to) {
      if (typeof to !== "object" || isInterpolating(to)) {
        return this.interpolateValue(from, to);
      }
      var interpolatorEntries = [];
      for (var key in to) {
        var interpolator = this.interpolateValue(from[key], to[key]);
        if (interpolator != null) {
          interpolatorEntries.push([key, interpolator]);
        }
      }
      return function (d) {
        var result = {};
        for (var _i13 = 0, _interpolatorEntries = interpolatorEntries; _i13 < _interpolatorEntries.length; _i13++) {
          var _interpolatorEntries$ = _slicedToArray(_interpolatorEntries[_i13], 2),
            _key16 = _interpolatorEntries$[0],
            _interpolator = _interpolatorEntries$[1];
          result[_key16] = _interpolator(d);
        }
        return result;
      };
    }
  }, {
    key: "interpolateValue",
    value: function interpolateValue(a, b) {
      if (a === void 0 || b === void 0) {
        return;
      } else if (isInterpolating(a)) {
        return function (d) {
          return a[interpolate](b, d);
        };
      }
      try {
        switch (typeof a) {
          case "number":
            return interpolateNumber(a, b);
          case "string":
            return interpolateColor(a, b);
          case "boolean":
            if (a === b) return function () {
              return a;
            };
            break;
        }
      } catch (e) {}
      throw new Error("Unable to interpolate values: ".concat(a, ", ").concat(b));
    }
  }, {
    key: "delta",
    get: function get() {
      return this.ease(_clamp(0, (this.elapsed - this.delay) / this.duration, 1));
    }
  }]);
  return Animation;
}();

// packages/ag-charts-community/src/motion/fromToMotion.ts
var _NODE_UPDATE_STATE_TO_PHASE_MAPPING = {
  added: "add",
  updated: "update",
  removed: "remove",
  unknown: "initial",
  "no-op": "none"
};
function _fromToMotion(groupId, subId, animationManager, selectionsOrNodes, fns, getDatumId, diff2) {
  var fromFn = fns.fromFn,
    toFn = fns.toFn,
    intermediateFn = fns.intermediateFn;
  var _deconstructSelection = _deconstructSelectionsOrNodes(selectionsOrNodes),
    nodes = _deconstructSelection.nodes,
    selections = _deconstructSelection.selections;
  var processNodes = function processNodes(liveNodes, subNodes) {
    var _c;
    var prevFromProps;
    var liveNodeIndex = 0;
    var nodeIndex = 0;
    var _iterator38 = _createForOfIteratorHelper(subNodes),
      _step38;
    try {
      var _loop4 = function _loop4() {
        var node = _step38.value;
        var isLive = liveNodes[liveNodeIndex] === node;
        var ctx = {
          last: nodeIndex >= subNodes.length - 1,
          lastLive: liveNodeIndex >= liveNodes.length - 1,
          prev: subNodes[nodeIndex - 1],
          prevFromProps: prevFromProps,
          prevLive: liveNodes[liveNodeIndex - 1],
          next: subNodes[nodeIndex + 1],
          nextLive: liveNodes[liveNodeIndex + (isLive ? 1 : 0)]
        };
        var animationId = "".concat(groupId, "_").concat(subId, "_").concat(node.id);
        animationManager.stopByAnimationId(animationId);
        var status = "unknown";
        if (!isLive) {
          status = "removed";
        } else if (getDatumId && diff2) {
          status = calculateStatus(node, node.datum, getDatumId, diff2);
        }
        var _a = fromFn(node, node.datum, status, ctx),
          phase = _a.phase,
          start = _a.start,
          finish = _a.finish,
          delay = _a.delay,
          duration = _a.duration,
          from = __objRest(_a, ["phase", "start", "finish", "delay", "duration"]);
        var _b = toFn(node, node.datum, status, ctx),
          toPhase = _b.phase,
          toStart = _b.start,
          toFinish = _b.finish,
          toDelay = _b.delay,
          toDuration = _b.duration,
          to = __objRest(_b, ["phase", "start", "finish", "delay", "duration"]);
        var collapsable = finish == null && toFinish == null;
        animationManager.animate({
          id: animationId,
          groupId: groupId,
          phase: (_c = phase != null ? phase : toPhase) != null ? _c : "update",
          duration: duration != null ? duration : toDuration,
          delay: delay != null ? delay : toDelay,
          from: from,
          to: to,
          ease: _easeOut,
          collapsable: collapsable,
          onPlay: function onPlay() {
            node.setProperties(__spreadValues(__spreadValues({}, start), toStart));
          },
          onUpdate: function onUpdate(props) {
            node.setProperties(props);
            if (intermediateFn) {
              node.setProperties(intermediateFn(node, node.datum, status, ctx));
            }
          },
          onStop: function onStop() {
            node.setProperties(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, start), toStart), from), to), finish), toFinish));
          }
        });
        if (isLive) {
          liveNodeIndex++;
        }
        nodeIndex++;
        prevFromProps = from;
      };
      for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
        _loop4();
      }
    } catch (err) {
      _iterator38.e(err);
    } finally {
      _iterator38.f();
    }
  };
  var selectionIndex = 0;
  var _iterator39 = _createForOfIteratorHelper(selections),
    _step39;
  try {
    var _loop5 = function _loop5() {
      var selection = _step39.value;
      var selectionNodes = selection.nodes();
      var liveNodes = selectionNodes.filter(function (n) {
        return !selection.isGarbage(n);
      });
      processNodes(liveNodes, selectionNodes);
      animationManager.animate({
        id: "".concat(groupId, "_").concat(subId, "_selection_").concat(selectionIndex),
        groupId: groupId,
        phase: "end",
        from: 0,
        to: 1,
        ease: _easeOut,
        onStop: function onStop() {
          selection.cleanup();
        }
      });
      selectionIndex++;
    };
    for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
      _loop5();
    }
  } catch (err) {
    _iterator39.e(err);
  } finally {
    _iterator39.f();
  }
  processNodes(nodes, nodes);
}
function _staticFromToMotion(groupId, subId, animationManager, selectionsOrNodes, from, to, extraOpts) {
  var _deconstructSelection2 = _deconstructSelectionsOrNodes(selectionsOrNodes),
    nodes = _deconstructSelection2.nodes,
    selections = _deconstructSelection2.selections;
  var start = extraOpts.start,
    finish = extraOpts.finish,
    phase = extraOpts.phase;
  var collapsable = finish == null;
  animationManager.animate({
    id: "".concat(groupId, "_").concat(subId),
    groupId: groupId,
    phase: phase != null ? phase : "update",
    from: from,
    to: to,
    ease: _easeOut,
    collapsable: collapsable,
    onPlay: function onPlay() {
      if (!start) return;
      var _iterator40 = _createForOfIteratorHelper(nodes),
        _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var node = _step40.value;
          node.setProperties(start);
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      var _iterator41 = _createForOfIteratorHelper(selections),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var selection = _step41.value;
          var _iterator42 = _createForOfIteratorHelper(selection.nodes()),
            _step42;
          try {
            for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
              var _node2 = _step42.value;
              _node2.setProperties(start);
            }
          } catch (err) {
            _iterator42.e(err);
          } finally {
            _iterator42.f();
          }
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
    },
    onUpdate: function onUpdate(props) {
      var _iterator43 = _createForOfIteratorHelper(nodes),
        _step43;
      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var node = _step43.value;
          node.setProperties(props);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
      var _iterator44 = _createForOfIteratorHelper(selections),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var selection = _step44.value;
          var _iterator45 = _createForOfIteratorHelper(selection.nodes()),
            _step45;
          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var _node3 = _step45.value;
              _node3.setProperties(props);
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
    },
    onStop: function onStop() {
      var _iterator46 = _createForOfIteratorHelper(nodes),
        _step46;
      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var node = _step46.value;
          node.setProperties(__spreadValues(__spreadValues({}, to), finish));
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
      var _iterator47 = _createForOfIteratorHelper(selections),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var selection = _step47.value;
          var _iterator48 = _createForOfIteratorHelper(selection.nodes()),
            _step48;
          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _node4 = _step48.value;
              _node4.setProperties(__spreadValues(__spreadValues({}, to), finish));
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
    }
  });
}
function calculateStatus(node, datum, getDatumId, diff2) {
  var id = getDatumId(node, datum);
  if (diff2.added.has(id)) {
    return "added";
  }
  if (diff2.removed.has(id)) {
    return "removed";
  }
  return "updated";
}

// packages/ag-charts-community/src/util/angle.ts
var twoPi = Math.PI * 2;
function _normalizeAngle2(radians) {
  radians %= twoPi;
  radians += twoPi;
  radians %= twoPi;
  return radians;
}
function _normalizeAngle360Inclusive(radians) {
  radians %= twoPi;
  radians += twoPi;
  if (radians !== twoPi) {
    radians %= twoPi;
  }
  return radians;
}
function _normalizeAngle(radians) {
  radians %= twoPi;
  if (radians < -Math.PI) {
    radians += twoPi;
  } else if (radians >= Math.PI) {
    radians -= twoPi;
  }
  return radians;
}
function _isBetweenAngles(targetAngle, startAngle, endAngle) {
  var t = _normalizeAngle2(targetAngle);
  var a0 = _normalizeAngle2(startAngle);
  var a1 = _normalizeAngle360Inclusive(endAngle);
  if (a0 <= a1) {
    return a0 <= t && t <= a1;
  } else {
    return a0 <= t || t <= a1;
  }
}
function _toRadians(degrees) {
  return degrees / 180 * Math.PI;
}
function _toDegrees(radians) {
  return radians / Math.PI * 180;
}
function _angleBetween(angle0, angle1) {
  angle0 = _normalizeAngle2(angle0);
  angle1 = _normalizeAngle2(angle1);
  return angle1 - angle0 + (angle0 > angle1 ? 2 * Math.PI : 0);
}
function _displacePointFromVector(centerX, centerY, radius, angle) {
  var x = centerX + radius * Math.cos(angle);
  var y = centerY + radius * Math.sin(angle);
  return {
    x: x,
    y: y
  };
}

// packages/ag-charts-community/src/scale/invalidating.ts
var _Invalidating = function Invalidating(target, propertyKey) {
  var mappedProperty = Symbol(String(propertyKey));
  target[mappedProperty] = void 0;
  Object.defineProperty(target, propertyKey, {
    get: function get() {
      return this[mappedProperty];
    },
    set: function set(newValue) {
      var oldValue = this[mappedProperty];
      if (oldValue !== newValue) {
        this[mappedProperty] = newValue;
        this.invalid = true;
      }
    },
    enumerable: true,
    configurable: false
  });
};

// packages/ag-charts-community/src/scale/bandScale.ts
var _BandScale = /*#__PURE__*/function () {
  function _BandScale() {
    _classCallCheck(this, _BandScale);
    this.type = "band";
    this.invalid = true;
    this.interval = void 0;
    /**
     * Maps datum to its index in the {@link domain} array.
     * Used to check for duplicate datums (not allowed).
     */
    this.index = /* @__PURE__ */new Map();
    /**
     * The output range values for datum at each index.
     */
    this.ordinalRange = [];
    /**
     * Contains unique datums only. Since `{}` is used in place of `Map`
     * for IE11 compatibility, the datums are converted `toString` before
     * the uniqueness check.
     */
    this._domain = [];
    this.range = [0, 1];
    this._bandwidth = 1;
    this._step = 1;
    this._rawBandwidth = 1;
    /**
     * The ratio of the range that is reserved for space between bands.
     */
    this._paddingInner = 0;
    /**
     * The ratio of the range that is reserved for space before the first
     * and after the last band.
     */
    this._paddingOuter = 0;
    this.round = false;
  }
  _createClass(_BandScale, [{
    key: "refresh",
    value: function refresh() {
      if (!this.invalid) return;
      this.invalid = false;
      this.update();
      if (this.invalid) {
        _Logger.warnOnce("Expected update to not invalidate scale");
      }
    }
  }, {
    key: "ticks",
    value: function ticks() {
      this.refresh();
      var _this$interval = this.interval,
        interval = _this$interval === void 0 ? 1 : _this$interval;
      if (typeof interval !== "number") {
        interval = Number(interval);
      }
      var step = Math.abs(Math.round(interval));
      return this._domain.filter(function (_, i) {
        return i % step === 0;
      });
    }
  }, {
    key: "convert",
    value: function convert(d) {
      this.refresh();
      var i = this.getIndex(d);
      if (i === void 0) {
        return NaN;
      }
      var r = this.ordinalRange[i];
      if (r === void 0) {
        return NaN;
      }
      return r;
    }
  }, {
    key: "invert",
    value: function invert(position) {
      this.refresh();
      var index = this.ordinalRange.findIndex(function (p) {
        return p === position;
      });
      return this.domain[index];
    }
  }, {
    key: "invertNearest",
    value: function invertNearest(position) {
      var _a;
      this.refresh();
      var nearest = -1;
      var minDistance = Infinity;
      var index = this.ordinalRange.findIndex(function (p, i) {
        if (p === position) return true;
        var distance2 = Math.abs(position - p);
        if (distance2 < minDistance) {
          minDistance = distance2;
          nearest = i;
        }
        return false;
      });
      return (_a = this.domain[index]) != null ? _a : this.domain[nearest];
    }
  }, {
    key: "update",
    value: function update() {
      var count = this._domain.length;
      if (count === 0) {
        return;
      }
      var round3 = this.round;
      var paddingInner = this._paddingInner;
      var paddingOuter = this._paddingOuter;
      var _this$range = _slicedToArray(this.range, 2),
        r0 = _this$range[0],
        r1 = _this$range[1];
      var width = r1 - r0;
      var rawStep = width / Math.max(1, count + 2 * paddingOuter - paddingInner);
      var step = round3 ? Math.floor(rawStep) : rawStep;
      var fullBandWidth = step * (count - paddingInner);
      var x0 = r0 + (width - fullBandWidth) / 2;
      var start = round3 ? Math.round(x0) : x0;
      var bw = step * (1 - paddingInner);
      var bandwidth = round3 ? Math.round(bw) : bw;
      var rawBandwidth = rawStep * (1 - paddingInner);
      var values = [];
      for (var i = 0; i < count; i++) {
        values.push(start + step * i);
      }
      this._bandwidth = bandwidth;
      this._rawBandwidth = rawBandwidth;
      this._step = step;
      this.ordinalRange = values;
    }
  }, {
    key: "getIndex",
    value: function getIndex(value) {
      if (!(value instanceof Date)) {
        return this.index.get(value);
      }
      var valueOf = value.valueOf();
      var index = 0;
      var _iterator49 = _createForOfIteratorHelper(this.index.keys()),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var key = _step49.value;
          if (key instanceof Date && key.valueOf() === valueOf) {
            return index;
          }
          index++;
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
    }
  }, {
    key: "domain",
    set: function set(values) {
      var _this14 = this;
      this.invalid = true;
      var domain = [];
      this.index = /* @__PURE__ */new Map();
      var index = this.index;
      values.forEach(function (value) {
        if (_this14.getIndex(value) === void 0) {
          index.set(value, domain.push(value) - 1);
        }
      });
      this._domain = domain;
    },
    get: function get() {
      return this._domain;
    }
  }, {
    key: "bandwidth",
    get: function get() {
      this.refresh();
      return this._bandwidth;
    }
  }, {
    key: "step",
    get: function get() {
      this.refresh();
      return this._step;
    }
  }, {
    key: "rawBandwidth",
    get: function get() {
      this.refresh();
      return this._rawBandwidth;
    }
  }, {
    key: "padding",
    set: function set(value) {
      value = _clamp(0, value, 1);
      this._paddingInner = value;
      this._paddingOuter = value;
    },
    get: function get() {
      return this._paddingInner;
    }
  }, {
    key: "paddingInner",
    set: function set(value) {
      this._paddingInner = _clamp(0, value, 1);
    },
    get: function get() {
      return this._paddingInner;
    }
  }, {
    key: "paddingOuter",
    set: function set(value) {
      this._paddingOuter = _clamp(0, value, 1);
    },
    get: function get() {
      return this._paddingOuter;
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _BandScale;
    }
  }]);
  return _BandScale;
}();
__decorateClass([_Invalidating], _BandScale.prototype, "interval", 2);
__decorateClass([_Invalidating], _BandScale.prototype, "range", 2);
__decorateClass([_Invalidating], _BandScale.prototype, "round", 2);
var _BandScale3 = _BandScale;

// packages/ag-charts-community/src/util/default.ts
function _Default(defaultValue) {
  var replaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [void 0];
  return addTransformToInstanceProperty(function (_, __, v) {
    if (replaces.includes(v)) {
      return _isFunction(defaultValue) ? defaultValue(v) : defaultValue;
    }
    return v;
  });
}

// packages/ag-charts-community/src/util/validation.ts
function _Validate(predicate) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$optional = options.optional,
    optional = _options$optional === void 0 ? false : _options$optional,
    overrideProperty = options.property;
  return addTransformToInstanceProperty(function (target, property, value) {
    var _a;
    var context = __spreadProps(__spreadValues({}, options), {
      target: target,
      property: property
    });
    if (optional && typeof value === "undefined" || predicate(value, context)) {
      if (_isProperties(target[property]) && !_isProperties(value)) {
        target[property].set(value);
        return target[property];
      }
      return value;
    }
    var cleanKey = overrideProperty != null ? overrideProperty : String(property).replace(/^_*/, "");
    var targetName = (_a = target.constructor.className) != null ? _a : target.constructor.name.replace(/Properties$/, "");
    var valueString = _stringify(value);
    var maxLength = 50;
    if (valueString != null && valueString.length > maxLength) {
      var excessCharacters = valueString.length - maxLength;
      valueString = valueString.slice(0, maxLength) + "... (+".concat(excessCharacters, " characters)");
    }
    _Logger.warn("Property [".concat(cleanKey, "] of [").concat(targetName, "] cannot be set to [").concat(valueString, "]").concat(predicate.message ? "; expecting ".concat(getPredicateMessage(predicate, context)) : "", ", ignoring."));
    return BREAK_TRANSFORM_CHAIN;
  }, void 0, {
    optional: optional
  });
}
var _AND = function AND() {
  for (var _len16 = arguments.length, predicates = new Array(_len16), _key17 = 0; _key17 < _len16; _key17++) {
    predicates[_key17] = arguments[_key17];
  }
  var messages = [];
  return _predicateWithMessage(function (value, ctx) {
    messages.length = 0;
    return predicates.every(function (predicate) {
      var isValid = predicate(value, ctx);
      if (!isValid) {
        messages.push(getPredicateMessage(predicate, ctx));
      }
      return isValid;
    });
  }, function () {
    return messages.filter(Boolean).join(" AND ");
  });
};
var _OR = function OR() {
  for (var _len17 = arguments.length, predicates = new Array(_len17), _key18 = 0; _key18 < _len17; _key18++) {
    predicates[_key18] = arguments[_key18];
  }
  return _predicateWithMessage(function (value, ctx) {
    return predicates.some(function (predicate) {
      return predicate(value, ctx);
    });
  }, function (ctx) {
    return predicates.map(getPredicateMessageMapper(ctx)).filter(Boolean).join(" OR ");
  });
};
var _OBJECT = attachObjectRestrictions(_predicateWithMessage(function (value, ctx) {
  return _isProperties(value) || _isObject(value) && _isProperties(ctx.target[ctx.property]);
}, "a properties object"));
var _PLAIN_OBJECT = attachObjectRestrictions(_predicateWithMessage(function (value) {
  return _isObject(value);
}, "an object"));
var _BOOLEAN = _predicateWithMessage(_isBoolean, "a boolean");
var _FUNCTION = _predicateWithMessage(_isFunction, "a function");
var _STRING = _predicateWithMessage(_isString, "a string");
var _NUMBER = attachNumberRestrictions(_predicateWithMessage(_isFiniteNumber, "a number"));
var _NAN = _predicateWithMessage(function (value) {
  return _isNumber(value) && isNaN(value);
}, "NaN");
var _POSITIVE_NUMBER = _NUMBER.restrict({
  min: 0
});
var _RATIO = _NUMBER.restrict({
  min: 0,
  max: 1
});
var _DEGREE = _NUMBER.restrict({
  min: -360,
  max: 360
});
var _NUMBER_OR_NAN = _OR(_NUMBER, _NAN);
var _ARRAY = attachArrayRestrictions(_predicateWithMessage(_isArray, "an array"));
var _ARRAY_OF = function ARRAY_OF(predicate, message) {
  return _predicateWithMessage(function (value, ctx) {
    return _isArray(value) && value.every(function (item) {
      return predicate(item, ctx);
    });
  }, function (ctx) {
    var _a;
    var arrayMessage = (_a = getPredicateMessage(_ARRAY, ctx)) != null ? _a : "";
    return message ? "".concat(arrayMessage, " of ").concat(message) : arrayMessage;
  });
};
var isComparable = function isComparable(value) {
  return _isFiniteNumber(value) || _isValidDate(value);
};
var _LESS_THAN = function LESS_THAN(otherField) {
  return _predicateWithMessage(function (v, ctx) {
    return !isComparable(v) || !isComparable(ctx.target[otherField]) || v < ctx.target[otherField];
  }, "to be less than ".concat(otherField));
};
var _GREATER_THAN = function GREATER_THAN(otherField) {
  return _predicateWithMessage(function (v, ctx) {
    return !isComparable(v) || !isComparable(ctx.target[otherField]) || v > ctx.target[otherField];
  }, "to be greater than ".concat(otherField));
};
var _DATE = _predicateWithMessage(_isValidDate, "Date object");
var _DATE_OR_DATETIME_MS = _OR(_DATE, _POSITIVE_NUMBER);
var colorMessage = "A color string can be in one of the following formats to be valid: #rgb, #rrggbb, rgb(r, g, b), rgba(r, g, b, a) or a CSS color name such as 'white', 'orange', 'cyan', etc";
var _COLOR_STRING = _predicateWithMessage(function (v) {
  return _isString(v) && _Color2.validColorString(v);
}, "color String. ".concat(colorMessage));
var _COLOR_STRING_ARRAY = _predicateWithMessage(_ARRAY_OF(_COLOR_STRING), "color strings. ".concat(colorMessage));
var _BOOLEAN_ARRAY = _ARRAY_OF(_BOOLEAN, "boolean values");
var _NUMBER_ARRAY = _ARRAY_OF(_NUMBER, "numbers");
var _STRING_ARRAY = _ARRAY_OF(_STRING, "strings");
var _DATE_ARRAY = _predicateWithMessage(_ARRAY_OF(_DATE), "Date objects");
var _OBJECT_ARRAY = _predicateWithMessage(_ARRAY_OF(_OBJECT), "objects");
var _LINE_CAP = _UNION(["butt", "round", "square"], "a line cap");
var _LINE_JOIN = _UNION(["round", "bevel", "miter"], "a line join");
var _LINE_DASH = _predicateWithMessage(_ARRAY_OF(_POSITIVE_NUMBER), "numbers specifying the length in pixels of alternating dashes and gaps, for example, [6, 3] means dashes with a length of 6 pixels with gaps between of 3 pixels.");
var POSITION2 = _UNION(["top", "right", "bottom", "left"], "a position");
var _FONT_STYLE = _UNION(["normal", "italic", "oblique"], "a font style");
var FONT_WEIGHT2 = _OR(_UNION(["normal", "bold", "bolder", "lighter"], "a font weight"), _NUMBER.restrict({
  min: 1,
  max: 1e3
}));
var _TEXT_WRAP = _UNION(["never", "always", "hyphenate", "on-space"], "a text wrap strategy");
var _TEXT_ALIGN = _UNION(["left", "center", "right"], "a text align");
var _VERTICAL_ALIGN = _UNION(["top", "middle", "bottom"], "a vertical align");
var _OVERFLOW_STRATEGY = _UNION(["ellipsis", "hide"], "an overflow strategy");
var _DIRECTION = _UNION(["horizontal", "vertical"], "a direction");
var _PLACEMENT = _UNION(["inside", "outside"], "a placement");
var _INTERACTION_RANGE = _OR(_UNION(["exact", "nearest"], "interaction range"), _NUMBER);
var _LABEL_PLACEMENT = _UNION(["top", "bottom", "left", "right"]);
function _UNION(options) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "a";
  return _predicateWithMessage(function (v) {
    return options.includes(v);
  }, "".concat(message, " keyword such as ").concat(joinUnionOptions(options)));
}
var _MIN_SPACING = _OR(_AND(_NUMBER.restrict({
  min: 1
}), _LESS_THAN("maxSpacing")), _NAN);
var _MAX_SPACING = _OR(_AND(_NUMBER.restrict({
  min: 1
}), _GREATER_THAN("minSpacing")), _NAN);
function _predicateWithMessage(predicate, message) {
  predicate.message = message;
  return predicate;
}
function joinUnionOptions(options) {
  var values = options.map(function (option) {
    return "'".concat(option, "'");
  });
  if (values.length === 1) {
    return values[0];
  }
  var lastValue = values.pop();
  return "".concat(values.join(", "), " or ").concat(lastValue);
}
function getPredicateMessage(predicate, ctx) {
  return _isFunction(predicate.message) ? predicate.message(ctx) : predicate.message;
}
function getPredicateMessageMapper(ctx) {
  return function (predicate) {
    return getPredicateMessage(predicate, ctx);
  };
}
function attachArrayRestrictions(predicate) {
  return Object.assign(predicate, {
    restrict: function restrict() {
      var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        length = _ref23.length,
        minLength = _ref23.minLength;
      var message = "an array";
      if (_isNumber(minLength) && minLength > 0) {
        message = "a non-empty array";
      } else if (_isNumber(length)) {
        message = "an array of length ".concat(length);
      }
      return _predicateWithMessage(function (value) {
        return _isArray(value) && (_isNumber(length) ? value.length === length : true) && (_isNumber(minLength) ? value.length >= minLength : true);
      }, message);
    }
  });
}
function attachNumberRestrictions(predicate) {
  return Object.assign(predicate, {
    restrict: function restrict() {
      var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        min = _ref24.min,
        max = _ref24.max;
      var message = ["a number"];
      var hasMin = _isNumber(min);
      var hasMax = _isNumber(max);
      if (hasMin && hasMax) {
        message.push("between ".concat(min, " and ").concat(max, " inclusive"));
      } else if (hasMin) {
        message.push("greater than or equal to ".concat(min));
      } else if (hasMax) {
        message.push("less than or equal to ".concat(max));
      }
      return _predicateWithMessage(function (value) {
        return _isFiniteNumber(value) && (hasMin ? value >= min : true) && (hasMax ? value <= max : true);
      }, message.join(" "));
    }
  });
}
function attachObjectRestrictions(predicate) {
  return Object.assign(predicate, {
    restrict: function restrict(objectType) {
      return _predicateWithMessage(function (value) {
        return value instanceof objectType;
      }, function (ctx) {
        var _a;
        return (_a = getPredicateMessage(predicate, ctx)) != null ? _a : "an instance of ".concat(objectType.name);
      });
    }
  });
}
function _stringify(value) {
  if (typeof value === "number") {
    if (isNaN(value)) return "NaN";
    if (value === Infinity) return "Infinity";
    if (value === -Infinity) return "-Infinity";
  }
  return JSON.stringify(value);
}

// packages/ag-charts-community/src/chart/axis/axisTick.ts
var TICK_INTERVAL = _predicateWithMessage(function (value) {
  return _isFiniteNumber(value) && value > 0 || value instanceof TimeInterval;
}, "a non-zero positive Number value or, for a time axis, a Time Interval such as 'agCharts.time.month'");
var _AxisTick4 = /*#__PURE__*/function (_BaseProperties) {
  _inherits(AxisTick, _BaseProperties);
  function AxisTick() {
    var _this15;
    _classCallCheck(this, AxisTick);
    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(AxisTick).apply(this, arguments));
    _this15.enabled = true;
    _this15.width = 1;
    _this15.size = 6;
    _this15.color = void 0;
    _this15.interval = void 0;
    _this15.values = void 0;
    return _this15;
  }
  return AxisTick;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], _AxisTick4.prototype, "enabled", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _AxisTick4.prototype, "width", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _AxisTick4.prototype, "size", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _AxisTick4.prototype, "color", 2);
__decorateClass([_Validate(TICK_INTERVAL, {
  optional: true
})], _AxisTick4.prototype, "interval", 2);
__decorateClass([_Validate(_ARRAY, {
  optional: true
})], _AxisTick4.prototype, "values", 2);

// packages/ag-charts-community/src/chart/chartAxisDirection.ts
var _ChartAxisDirection = /* @__PURE__ */function (ChartAxisDirection2) {
  ChartAxisDirection2["X"] = "x";
  ChartAxisDirection2["Y"] = "y";
  return ChartAxisDirection2;
}(_ChartAxisDirection || {});

// packages/ag-charts-community/src/chart/chartOptions.ts
var JSON_APPLY_PLUGINS = {
  constructedArrays: /* @__PURE__ */new WeakMap()
};
function _assignJsonApplyConstructedArray(array, ctor) {
  var _a;
  (_a = JSON_APPLY_PLUGINS.constructedArrays) == null ? void 0 : _a.set(array, ctor);
}

// packages/ag-charts-community/src/scale/continuousScale.ts
var _ContinuousScale = /*#__PURE__*/function () {
  function _ContinuousScale(domain, range3) {
    _classCallCheck(this, _ContinuousScale);
    this.invalid = true;
    this.nice = false;
    this.interval = void 0;
    this.tickCount = _ContinuousScale.defaultTickCount;
    this.minTickCount = 0;
    this.maxTickCount = Infinity;
    this.niceDomain = [];
    this.defaultClampMode = "raw";
    this.domain = domain;
    this.range = range3;
  }
  _createClass(_ContinuousScale, [{
    key: "transform",
    value: function transform(x) {
      return x;
    }
  }, {
    key: "transformInvert",
    value: function transformInvert(x) {
      return x;
    }
  }, {
    key: "calcBandwidth",
    value: function calcBandwidth() {
      var smallestInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var range3 = this.range;
      var domain = this.getDomain();
      var rangeDistance = Math.abs(range3[1] - range3[0]);
      var intervals = Math.abs(domain[1] - domain[0]) / smallestInterval + 1;
      var maxBands = Math.floor(rangeDistance);
      var bands = Math.min(intervals, maxBands);
      return rangeDistance / Math.max(1, bands);
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      if (this.nice) {
        this.refresh();
        if (this.niceDomain.length) {
          return this.niceDomain;
        }
      }
      return this.domain;
    }
  }, {
    key: "convert",
    value: function convert(x, opts) {
      var _this16 = this;
      var _a;
      var clampMode = (_a = opts == null ? void 0 : opts.clampMode) != null ? _a : this.defaultClampMode;
      if (!this.domain || this.domain.length < 2) {
        return NaN;
      }
      this.refresh();
      var domain = this.getDomain().map(function (d) {
        return _this16.transform(d);
      });
      var _domain2 = _slicedToArray(domain, 2),
        d0 = _domain2[0],
        d1 = _domain2[1];
      var range3 = this.range;
      var _range = _slicedToArray(range3, 2),
        r0 = _range[0],
        r1 = _range[1];
      x = this.transform(x);
      if (clampMode === "clamped") {
        var _findMinMax5 = _findMinMax17(domain.map(Number)),
          _findMinMax6 = _slicedToArray(_findMinMax5, 2),
          start = _findMinMax6[0],
          stop = _findMinMax6[1];
        if (Number(x) < start) {
          return r0;
        } else if (Number(x) > stop) {
          return r1;
        }
      }
      if (d0 === d1) {
        return (r0 + r1) / 2;
      } else if (x === d0) {
        return r0;
      } else if (x === d1) {
        return r1;
      }
      return r0 + (Number(x) - Number(d0)) / (Number(d1) - Number(d0)) * (r1 - r0);
    }
  }, {
    key: "invert",
    value: function invert(x) {
      var _this17 = this;
      this.refresh();
      var domain = this.getDomain().map(function (d2) {
        return _this17.transform(d2);
      });
      var _domain3 = _slicedToArray(domain, 2),
        d0 = _domain3[0],
        d1 = _domain3[1];
      var range3 = this.range;
      var _range2 = _slicedToArray(range3, 2),
        r0 = _range2[0],
        r1 = _range2[1];
      var isReversed = r0 > r1;
      var rMin = isReversed ? r1 : r0;
      var rMax = isReversed ? r0 : r1;
      var d;
      if (x < rMin) {
        return isReversed ? d1 : d0;
      } else if (x > rMax) {
        return isReversed ? d0 : d1;
      } else if (r0 === r1) {
        d = this.toDomain((Number(d0) + Number(d1)) / 2);
      } else {
        d = this.toDomain(Number(d0) + (x - r0) / (r1 - r0) * (Number(d1) - Number(d0)));
      }
      return this.transformInvert(d);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (!this.invalid) return;
      this.invalid = false;
      this.update();
      if (this.invalid) {
        _Logger.warnOnce("Expected update to not invalidate scale");
      }
    }
  }, {
    key: "getPixelRange",
    value: function getPixelRange() {
      var _this$range2 = _slicedToArray(this.range, 2),
        a = _this$range2[0],
        b = _this$range2[1];
      return Math.abs(b - a);
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _ContinuousScale;
    }
  }]);
  return _ContinuousScale;
}();
_ContinuousScale.defaultTickCount = 5;
_ContinuousScale.defaultMaxTickCount = 6;
__decorateClass([_Invalidating], _ContinuousScale.prototype, "domain", 2);
__decorateClass([_Invalidating], _ContinuousScale.prototype, "range", 2);
__decorateClass([_Invalidating], _ContinuousScale.prototype, "nice", 2);
__decorateClass([_Invalidating], _ContinuousScale.prototype, "interval", 2);
__decorateClass([_Invalidating], _ContinuousScale.prototype, "tickCount", 2);
__decorateClass([_Invalidating], _ContinuousScale.prototype, "minTickCount", 2);
__decorateClass([_Invalidating], _ContinuousScale.prototype, "maxTickCount", 2);
var _ContinuousScale5 = _ContinuousScale;

// packages/ag-charts-community/src/util/timeFormat.ts
var CONSTANTS = {
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
};
function dayOfYear(date) {
  var startOfYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date(date.getFullYear(), 0, 1);
  var startOffset = date.getTimezoneOffset() - startOfYear.getTimezoneOffset();
  var timeDiff = date.getTime() - startOfYear.getTime() + startOffset * 6e4;
  var timeOneDay = 36e5 * 24;
  return Math.floor(timeDiff / timeOneDay);
}
function weekOfYear(date, startDay) {
  var startOfYear = new Date(date.getFullYear(), 0, 1);
  var startOfYearDay = startOfYear.getDay();
  var firstWeekStartOffset = (startDay - startOfYearDay + 7) % 7;
  var startOffset = new Date(date.getFullYear(), 0, firstWeekStartOffset + 1);
  if (startOffset <= date) {
    return Math.floor(dayOfYear(date, startOffset) / 7) + 1;
  }
  return 0;
}
var SUNDAY = 0;
var MONDAY = 1;
var THURSDAY = 4;
function isoWeekOfYear(date) {
  var year2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.getFullYear();
  var firstOfYear = new Date(year2, 0, 1);
  var firstOfYearDay = firstOfYear.getDay();
  var firstThursdayOffset = (THURSDAY - firstOfYearDay + 7) % 7;
  var startOffset = new Date(year2, 0, firstThursdayOffset - (THURSDAY - MONDAY) + 1);
  if (startOffset <= date) {
    return Math.floor(dayOfYear(date, startOffset) / 7) + 1;
  }
  return isoWeekOfYear(date, year2 - 1);
}
function timezone(date) {
  var offset4 = date.getTimezoneOffset();
  var unsignedOffset = Math.abs(offset4);
  var sign = offset4 > 0 ? "-" : "+";
  return "".concat(sign).concat(pad(Math.floor(unsignedOffset / 60), 2, "0")).concat(pad(Math.floor(unsignedOffset % 60), 2, "0"));
}
var FORMATTERS = {
  a: function a(d) {
    return CONSTANTS.shortDays[d.getDay()];
  },
  A: function A(d) {
    return CONSTANTS.days[d.getDay()];
  },
  b: function b(d) {
    return CONSTANTS.shortMonths[d.getMonth()];
  },
  B: function B(d) {
    return CONSTANTS.months[d.getMonth()];
  },
  c: "%x, %X",
  d: function d(_d2, p) {
    return pad(_d2.getDate(), 2, p != null ? p : "0");
  },
  e: "%_d",
  f: function f(d, p) {
    return pad(d.getMilliseconds() * 1e3, 6, p != null ? p : "0");
  },
  H: function H(d, p) {
    return pad(d.getHours(), 2, p != null ? p : "0");
  },
  I: function I(d, p) {
    var hours = d.getHours() % 12;
    return hours === 0 ? "12" : pad(hours, 2, p != null ? p : "0");
  },
  j: function j(d, p) {
    return pad(dayOfYear(d) + 1, 3, p != null ? p : "0");
  },
  m: function m(d, p) {
    return pad(d.getMonth() + 1, 2, p != null ? p : "0");
  },
  M: function M(d, p) {
    return pad(d.getMinutes(), 2, p != null ? p : "0");
  },
  L: function L(d, p) {
    return pad(d.getMilliseconds(), 3, p != null ? p : "0");
  },
  p: function p(d) {
    return d.getHours() < 12 ? "AM" : "PM";
  },
  Q: function Q(d) {
    return String(d.getTime());
  },
  s: function s(d) {
    return String(Math.floor(d.getTime() / 1e3));
  },
  S: function S(d, p) {
    return pad(d.getSeconds(), 2, p != null ? p : "0");
  },
  u: function u(d) {
    var day2 = d.getDay();
    if (day2 < 1) day2 += 7;
    return String(day2 % 7);
  },
  U: function U(d, p) {
    return pad(weekOfYear(d, SUNDAY), 2, p != null ? p : "0");
  },
  V: function V(d, p) {
    return pad(isoWeekOfYear(d), 2, p != null ? p : "0");
  },
  w: function w(d, p) {
    return pad(d.getDay(), 2, p != null ? p : "0");
  },
  W: function W(d, p) {
    return pad(weekOfYear(d, MONDAY), 2, p != null ? p : "0");
  },
  x: "%-m/%-d/%Y",
  X: "%-I:%M:%S %p",
  y: function y(d, p) {
    return pad(d.getFullYear() % 100, 2, p != null ? p : "0");
  },
  Y: function Y(d, p) {
    return pad(d.getFullYear(), 4, p != null ? p : "0");
  },
  Z: function Z(d) {
    return timezone(d);
  },
  "%": function _() {
    return "%";
  }
};
var PADS = {
  _: " ",
  "0": "0",
  "-": ""
};
function pad(value, size, padChar) {
  var output = String(Math.floor(value));
  if (output.length >= size) {
    return output;
  }
  return "".concat(padChar.repeat(size - output.length)).concat(output);
}
function _buildFormatter(formatString) {
  var formatParts = [];
  while (formatString.length > 0) {
    var nextEscapeIdx = formatString.indexOf("%");
    if (nextEscapeIdx !== 0) {
      var literalPart = nextEscapeIdx > 0 ? formatString.substring(0, nextEscapeIdx) : formatString;
      formatParts.push(literalPart);
    }
    if (nextEscapeIdx < 0) break;
    var maybePadSpecifier = formatString[nextEscapeIdx + 1];
    var maybePad = PADS[maybePadSpecifier];
    if (maybePad != null) {
      nextEscapeIdx++;
    }
    var maybeFormatterSpecifier = formatString[nextEscapeIdx + 1];
    var maybeFormatter = FORMATTERS[maybeFormatterSpecifier];
    if (typeof maybeFormatter === "function") {
      formatParts.push([maybeFormatter, maybePad]);
    } else if (typeof maybeFormatter === "string") {
      var formatter = _buildFormatter(maybeFormatter);
      formatParts.push([formatter, maybePad]);
    } else {
      formatParts.push("".concat(maybePad != null ? maybePad : "").concat(maybeFormatterSpecifier));
    }
    formatString = formatString.substring(nextEscapeIdx + 2);
  }
  return function (dateTime) {
    var dateTimeAsDate = typeof dateTime === "number" ? new Date(dateTime) : dateTime;
    return formatParts.map(function (c) {
      return typeof c === "string" ? c : c[0](dateTimeAsDate, c[1]);
    }).join("");
  };
}

// packages/ag-charts-community/src/util/timeFormatDefaults.ts
function _dateToNumber(x) {
  return x instanceof Date ? x.getTime() : x;
}
function _defaultTimeTickFormat(ticks, domain) {
  var formatString = _calculateDefaultTimeTickFormat(ticks, domain);
  return function (date) {
    return _buildFormatter(formatString)(date);
  };
}
function _calculateDefaultTimeTickFormat() {
  var ticks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ticks;
  var defaultTimeFormat = 8 /* YEAR */;
  var updateFormat = function updateFormat(format2) {
    if (format2 < defaultTimeFormat) {
      defaultTimeFormat = format2;
    }
  };
  var _iterator50 = _createForOfIteratorHelper(ticks),
    _step50;
  try {
    for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
      var value = _step50.value;
      var format2 = getLowestGranularityFormat(value);
      updateFormat(format2);
    }
  } catch (err) {
    _iterator50.e(err);
  } finally {
    _iterator50.f();
  }
  var startDomain = _dateToNumber(domain[0]);
  var endDomain = _dateToNumber(domain.at(-1));
  var startYear = new Date(startDomain).getFullYear();
  var stopYear = new Date(endDomain).getFullYear();
  var yearChange = stopYear - startYear > 0;
  return formatStringBuilder(defaultTimeFormat, yearChange, ticks);
}
function getLowestGranularityFormat(value) {
  if (second_default.floor(value) < value) {
    return 0 /* MILLISECOND */;
  } else if (minute_default.floor(value) < value) {
    return 1 /* SECOND */;
  } else if (hour_default.floor(value) < value) {
    return 2 /* MINUTE */;
  } else if (day_default.floor(value) < value) {
    return 3 /* HOUR */;
  } else if (month_default.floor(value) < value) {
    if (week_default.floor(value) < value) {
      return 4 /* WEEK_DAY */;
    }
    return 5 /* SHORT_MONTH */;
  } else if (year_default.floor(value) < value) {
    return 6 /* MONTH */;
  }
  return 8 /* YEAR */;
}
function formatStringBuilder(defaultTimeFormat, yearChange, ticks) {
  var firstTick = _dateToNumber(ticks[0]);
  var lastTick = _dateToNumber(ticks.at(-1));
  var extent2 = Math.abs(lastTick - firstTick);
  var activeYear = yearChange || defaultTimeFormat === 8 /* YEAR */;
  var activeDate = extent2 === 0;
  var parts = [["hour", 6 * durationHour, 14 * durationDay, 3 /* HOUR */, "%I %p"], ["hour", durationMinute, 6 * durationHour, 3 /* HOUR */, "%I:%M"], ["second", 1e3, 6 * durationHour, 1 /* SECOND */, ":%S"], ["ms", 0, 6 * durationHour, 0 /* MILLISECOND */, ".%L"], ["am/pm", durationMinute, 6 * durationHour, 3 /* HOUR */, "%p"], " ", ["day", durationDay, 1 * durationWeek, 4 /* WEEK_DAY */, "%a"], ["month", activeDate ? 0 : durationWeek, 52 * durationWeek, 5 /* SHORT_MONTH */, "%b %d"], ["month", 5 * durationWeek, 10 * durationYear, 6 /* MONTH */, "%B"], " ", ["year", activeYear ? 0 : durationYear, Infinity, 8 /* YEAR */, "%Y"]];
  var formatParts = parts.filter(function (v) {
    if (typeof v === "string") return true;
    var _v = _slicedToArray(v, 4),
      _ = _v[0],
      min = _v[1],
      max = _v[2],
      format2 = _v[3];
    return format2 >= defaultTimeFormat && min <= extent2 && extent2 < max;
  }).reduce(function (r, next) {
    if (typeof next === "string") {
      r.result.push(next);
    } else if (!r.used.has(next[0])) {
      r.result.push(next);
      r.used.add(next[0]);
    }
    return r;
  }, {
    result: [],
    used: /* @__PURE__ */new Set()
  }).result;
  var firstFormat = formatParts.findIndex(function (v) {
    return typeof v !== "string";
  });
  var lastFormat = formatParts.length - _toConsumableArray(formatParts).reverse().findIndex(function (v) {
    return typeof v !== "string";
  });
  return formatParts.slice(firstFormat, lastFormat).map(function (v) {
    return typeof v === "string" ? v : v[4];
  }).join("").replaceAll(/\s+/g, " ").trim();
}

// packages/ag-charts-community/src/util/ticks.ts
var createNumericTicks = function createNumericTicks(fractionDigits) {
  var takingValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.assign(takingValues, {
    fractionDigits: fractionDigits
  });
};
function ticks_default(start, stop, count, minCount, maxCount) {
  if (count < 2) {
    return _range4(start, stop, stop - start);
  }
  var step = _tickStep(start, stop, count, minCount, maxCount);
  if (isNaN(step)) {
    return createNumericTicks(0);
  }
  start = Math.ceil(start / step) * step;
  stop = Math.floor(stop / step) * step;
  return _range4(start, stop, step);
}
var tickMultipliers = [1, 2, 5, 10];
function _tickStep(a, b, count) {
  var minCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var maxCount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
  var extent2 = Math.abs(b - a);
  var rawStep = extent2 / count;
  var power = Math.floor(Math.log10(rawStep));
  var step = Math.pow(10, power);
  var m = tickMultipliers.map(function (multiplier) {
    var s = multiplier * step;
    var c = Math.ceil(extent2 / s);
    var isWithinBounds = c >= minCount && c <= maxCount;
    var diffCount = Math.abs(c - count);
    return {
      multiplier: multiplier,
      isWithinBounds: isWithinBounds,
      diffCount: diffCount
    };
  }).sort(function (a2, b2) {
    if (a2.isWithinBounds !== b2.isWithinBounds) {
      return a2.isWithinBounds ? -1 : 1;
    }
    return a2.diffCount - b2.diffCount;
  })[0].multiplier;
  if (!m || isNaN(m)) {
    return NaN;
  }
  return m * step;
}
function singleTickDomain(a, b) {
  var extent2 = Math.abs(b - a);
  var power = Math.floor(Math.log10(extent2));
  var step = Math.pow(10, power);
  var roundStart = a > b ? Math.ceil : Math.floor;
  var roundStop = b < a ? Math.floor : Math.ceil;
  return tickMultipliers.map(function (multiplier) {
    var s = multiplier * step;
    var start = roundStart(a / s) * s;
    var end = roundStop(b / s) * s;
    var error = 1 - extent2 / Math.abs(end - start);
    var domain = [start, end];
    return {
      error: error,
      domain: domain
    };
  }).sort(function (a2, b2) {
    return a2.error - b2.error;
  })[0].domain;
}
function _range4(start, stop, step) {
  var d0 = Math.min(start, stop);
  var d1 = Math.max(start, stop);
  var fractionalDigits = _countFractionDigits(step);
  var f = Math.pow(10, fractionalDigits);
  var n = Math.ceil((d1 - d0) / step);
  var values = createNumericTicks(fractionalDigits);
  for (var i = 0; i <= n; i++) {
    var value = d0 + step * i;
    values.push(Math.round(value * f) / f);
  }
  return values;
}
function _isDenseInterval(_ref25) {
  var start = _ref25.start,
    stop = _ref25.stop,
    interval = _ref25.interval,
    count = _ref25.count,
    availableRange = _ref25.availableRange;
  var domain = stop - start;
  var step = typeof interval === "number" ? interval : 1;
  count != null ? count : count = domain / step;
  if (count >= availableRange) {
    _Logger.warnOnce("the configured interval results in more than 1 item per pixel, ignoring. Supply a larger interval or omit this configuration");
    return true;
  }
  return false;
}

// packages/ag-charts-community/src/scale/timeScale.ts
var _TimeScale = /*#__PURE__*/function (_ContinuousScale2) {
  _inherits(_TimeScale, _ContinuousScale2);
  function _TimeScale() {
    var _this18;
    _classCallCheck(this, _TimeScale);
    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(_TimeScale).call(this, [], [0, 1]));
    _this18.type = "time";
    return _this18;
  }
  _createClass(_TimeScale, [{
    key: "toDomain",
    value: function toDomain(d) {
      return new Date(d);
    }
    /**
     * @param options Tick interval options.
     * @param options.start The start time (timestamp).
     * @param options.stop The end time (timestamp).
     * @param options.count Number of intervals between ticks.
     */
  }, {
    key: "invert",
    value: function invert(y) {
      return new Date(_superPropGet(_TimeScale, "invert", this, 3)([y]));
    }
    /**
     * Returns uniformly-spaced dates that represent the scale's domain.
     */
  }, {
    key: "ticks",
    value: function ticks() {
      if (!this.domain || this.domain.length < 2) {
        return [];
      }
      this.refresh();
      var _this$getDomain$map = this.getDomain().map(_dateToNumber),
        _this$getDomain$map2 = _slicedToArray(_this$getDomain$map, 2),
        t0 = _this$getDomain$map2[0],
        t1 = _this$getDomain$map2[1];
      var start = Math.min(t0, t1);
      var stop = Math.max(t0, t1);
      var interval = this.interval,
        nice = this.nice,
        tickCount = this.tickCount,
        minTickCount = this.minTickCount,
        maxTickCount = this.maxTickCount;
      if (interval !== void 0) {
        var availableRange = this.getPixelRange();
        var ticks = _TimeScale.getTicksForInterval({
          start: start,
          stop: stop,
          interval: interval,
          availableRange: availableRange
        });
        return ticks != null ? ticks : _TimeScale.getDefaultTicks({
          start: start,
          stop: stop,
          tickCount: tickCount,
          minTickCount: minTickCount,
          maxTickCount: maxTickCount
        });
      }
      if (nice) {
        if (tickCount === 2) {
          return this.niceDomain;
        }
        if (tickCount === 1) {
          return this.niceDomain.slice(0, 1);
        }
      }
      return _TimeScale.getDefaultTicks({
        start: start,
        stop: stop,
        tickCount: tickCount,
        minTickCount: minTickCount,
        maxTickCount: maxTickCount
      });
    }
  }, {
    key: "tickFormat",
    /**
     * Returns a time format function suitable for displaying tick values.
     * @param specifier If the specifier string is provided, this method is equivalent to
     * the {@link TimeLocaleObject.format} method.
     * If no specifier is provided, this method returns the default time format function.
     */
    value: function tickFormat(_ref26) {
      var ticks = _ref26.ticks,
        domain = _ref26.domain,
        specifier = _ref26.specifier;
      return specifier == null ? _defaultTimeTickFormat(ticks, domain) : _buildFormatter(specifier);
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.domain || this.domain.length < 2) {
        return;
      }
      if (this.nice) {
        this.updateNiceDomain();
      }
    }
    /**
     * Extends the domain so that it starts and ends on nice round values.
     * This method typically modifies the scale’s domain, and may only extend the bounds to the nearest round value.
     */
  }, {
    key: "updateNiceDomain",
    value: function updateNiceDomain() {
      var maxAttempts = 4;
      var _this$domain = _slicedToArray(this.domain, 2),
        d0 = _this$domain[0],
        d1 = _this$domain[1];
      for (var i = 0; i < maxAttempts; i++) {
        this.updateNiceDomainIteration(d0, d1);
        var _this$niceDomain = _slicedToArray(this.niceDomain, 2),
          n0 = _this$niceDomain[0],
          n1 = _this$niceDomain[1];
        if (_dateToNumber(d0) === _dateToNumber(n0) && _dateToNumber(d1) === _dateToNumber(n1)) {
          break;
        }
        d0 = n0;
        d1 = n1;
      }
    }
  }, {
    key: "updateNiceDomainIteration",
    value: function updateNiceDomainIteration(d0, d1) {
      var start = Math.min(_dateToNumber(d0), _dateToNumber(d1));
      var stop = Math.max(_dateToNumber(d0), _dateToNumber(d1));
      var isReversed = d0 > d1;
      var interval = this.interval;
      var i;
      if (interval instanceof TimeInterval) {
        i = interval;
      } else {
        var tickCount = typeof interval === "number" ? (stop - start) / Math.max(interval, 1) : this.tickCount;
        i = _TimeScale.getTickInterval({
          start: start,
          stop: stop,
          count: tickCount,
          minCount: this.minTickCount,
          maxCount: this.maxTickCount
        });
      }
      if (i) {
        var intervalRange = i.range(new Date(start), new Date(stop), true);
        var domain = isReversed ? _toConsumableArray(intervalRange).reverse() : intervalRange;
        var n0 = domain[0];
        var n1 = domain.at(-1);
        this.niceDomain = [n0, n1];
      }
    }
  }], [{
    key: "getTickInterval",
    value: function getTickInterval(_ref27) {
      var start = _ref27.start,
        stop = _ref27.stop,
        count = _ref27.count,
        minCount = _ref27.minCount,
        maxCount = _ref27.maxCount,
        target = _ref27.target;
      var countableTimeInterval;
      var step;
      var tickCount = count != null ? count : _ContinuousScale5.defaultTickCount;
      var targetInterval = target != null ? target : Math.abs(stop - start) / Math.max(tickCount, 1);
      var i = _TimeScale.getIntervalIndex(targetInterval);
      if (i === 0) {
        step = Math.max(_tickStep(start, stop, tickCount, minCount, maxCount), 1);
        countableTimeInterval = millisecond_default;
      } else if (i === _TimeScale.tickIntervals.length) {
        var y0 = start / durationYear;
        var y1 = stop / durationYear;
        step = target === void 0 ? _tickStep(y0, y1, tickCount, minCount, maxCount) : 1;
        countableTimeInterval = year_default;
      } else {
        var diff0 = targetInterval - _TimeScale.tickIntervals[i - 1][2];
        var diff1 = _TimeScale.tickIntervals[i][2] - targetInterval;
        var index = diff0 < diff1 ? i - 1 : i;
        var _TimeScale$tickInterv = _slicedToArray(_TimeScale.tickIntervals[index], 2);
        countableTimeInterval = _TimeScale$tickInterv[0];
        step = _TimeScale$tickInterv[1];
      }
      return countableTimeInterval.every(step);
    }
  }, {
    key: "getIntervalIndex",
    value: function getIntervalIndex(target) {
      var i = 0;
      while (i < _TimeScale.tickIntervals.length && target > _TimeScale.tickIntervals[i][2]) {
        i++;
      }
      return i;
    }
  }, {
    key: "getDefaultTicks",
    value: function getDefaultTicks(_ref28) {
      var start = _ref28.start,
        stop = _ref28.stop,
        tickCount = _ref28.tickCount,
        minTickCount = _ref28.minTickCount,
        maxTickCount = _ref28.maxTickCount;
      var t = _TimeScale.getTickInterval({
        start: start,
        stop: stop,
        count: tickCount,
        minCount: minTickCount,
        maxCount: maxTickCount
      });
      return t ? t.range(new Date(start), new Date(stop)) : [];
    }
  }, {
    key: "getTicksForInterval",
    value: function getTicksForInterval(_ref29) {
      var start = _ref29.start,
        stop = _ref29.stop,
        interval = _ref29.interval,
        availableRange = _ref29.availableRange;
      if (!interval) {
        return [];
      }
      if (interval instanceof TimeInterval) {
        var ticks2 = interval.range(new Date(start), new Date(stop));
        if (_isDenseInterval({
          start: start,
          stop: stop,
          interval: interval,
          count: ticks2.length,
          availableRange: availableRange
        })) {
          return;
        }
        return ticks2;
      }
      var absInterval = Math.abs(interval);
      if (_isDenseInterval({
        start: start,
        stop: stop,
        interval: absInterval,
        availableRange: availableRange
      })) {
        return;
      }
      var reversedInterval = _toConsumableArray(_TimeScale.tickIntervals);
      reversedInterval.reverse();
      var timeInterval = reversedInterval.find(function (tickInterval) {
        return absInterval % tickInterval[2] === 0;
      });
      if (timeInterval) {
        var i = timeInterval[0].every(absInterval / (timeInterval[2] / timeInterval[1]));
        return i.range(new Date(start), new Date(stop));
      }
      var date = new Date(start);
      var stopDate = new Date(stop);
      var ticks = [];
      while (date <= stopDate) {
        ticks.push(date);
        date = new Date(date);
        date.setMilliseconds(date.getMilliseconds() + absInterval);
      }
      return ticks;
    }
  }]);
  return _TimeScale;
}(_ContinuousScale5);
/**
 * Array of default tick intervals in the following format:
 *
 *     [
 *         interval (unit of time),
 *         number of units (step),
 *         the length of that number of units in milliseconds
 *     ]
 */
_TimeScale.tickIntervals = [[second_default, 1, durationSecond], [second_default, 5, 5 * durationSecond], [second_default, 15, 15 * durationSecond], [second_default, 30, 30 * durationSecond], [minute_default, 1, durationMinute], [minute_default, 5, 5 * durationMinute], [minute_default, 15, 15 * durationMinute], [minute_default, 30, 30 * durationMinute], [hour_default, 1, durationHour], [hour_default, 3, 3 * durationHour], [hour_default, 6, 6 * durationHour], [hour_default, 12, 12 * durationHour], [day_default, 1, durationDay], [day_default, 2, 2 * durationDay], [week_default, 1, durationWeek], [week_default, 2, 2 * durationWeek], [week_default, 3, 3 * durationWeek], [month_default, 1, durationMonth], [month_default, 2, 2 * durationMonth], [month_default, 3, 3 * durationMonth], [month_default, 4, 4 * durationMonth], [month_default, 6, 6 * durationMonth], [year_default, 1, durationYear]];
var _TimeScale2 = _TimeScale;

// packages/ag-charts-community/src/scale/ordinalTimeScale.ts
var _OrdinalTimeScale = /*#__PURE__*/function (_BandScale2) {
  _inherits(_OrdinalTimeScale, _BandScale2);
  function _OrdinalTimeScale() {
    var _this19;
    _classCallCheck(this, _OrdinalTimeScale);
    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(_OrdinalTimeScale).apply(this, arguments));
    _this19.type = "ordinal-time";
    _this19.tickCount = _ContinuousScale5.defaultTickCount;
    _this19.minTickCount = 0;
    _this19.maxTickCount = Infinity;
    _this19.interval = void 0;
    _this19.index = /* @__PURE__ */new Map();
    /**
     * Contains unique datums only. Since `{}` is used in place of `Map`
     * for IE11 compatibility, the datums are converted `toString` before
     * the uniqueness check.
     */
    _this19._domain = [];
    return _this19;
  }
  _createClass(_OrdinalTimeScale, [{
    key: "toDomain",
    value: function toDomain(d) {
      return new Date(d);
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(values) {
      var _this20 = this;
      this.index = /* @__PURE__ */new Map();
      var index = this.index;
      var domain = [];
      var extents = [];
      var isReversed = values[0] > values.at(-1);
      var indexShift = isReversed ? 0 : 1;
      values.forEach(function (value, i2) {
        var nextValue = values[i2 + 1];
        var e02 = isReversed ? value : _this20.toDomain(_dateToNumber(value) + 1);
        var e12 = isReversed ? _this20.toDomain(_dateToNumber(nextValue) + 1) : nextValue;
        var dateRange2 = isReversed ? [e12, e02] : [e02, e12];
        domain.push(value);
        if (nextValue !== void 0 && index.get(dateRange2) === void 0) {
          extents.push(Math.abs(_dateToNumber(e12) - _dateToNumber(e02)));
          index.set(dateRange2, i2 + indexShift);
        }
      });
      extents.sort(function (a, b) {
        return a - b;
      });
      var bands = extents.length;
      var middleIndex = Math.floor(bands / 2);
      this.medianInterval = bands > 2 && bands % 2 === 0 ? (extents[middleIndex - 1] + extents[middleIndex + 1]) / 2 : extents[middleIndex];
      var intervalIndex = Math.max(0, _TimeScale2.getIntervalIndex(this.medianInterval) - 1);
      var _TimeScale$tickInterv2 = _slicedToArray(_TimeScale2.tickIntervals[intervalIndex], 2),
        countableTimeInterval = _TimeScale$tickInterv2[0],
        step = _TimeScale$tickInterv2[1];
      var interval = countableTimeInterval.every(step);
      var i = isReversed ? values.length - 1 : 0;
      var e1 = values[i];
      var e0 = interval.floor(values[i]);
      var dateRange = [e0, e1];
      index.set(dateRange, i);
      return domain;
    }
  }, {
    key: "ticks",
    value: function ticks() {
      var _this21 = this;
      if (!this.domain) {
        return [];
      }
      this.refresh();
      var _ref30 = [_dateToNumber(this.domain[0]), _dateToNumber(this.domain.at(-1))],
        t0 = _ref30[0],
        t1 = _ref30[1];
      var start = Math.min(t0, t1);
      var stop = Math.max(t0, t1);
      var isReversed = t0 > t1;
      var ticks;
      if (this.interval !== void 0) {
        ticks = this.getTicksForInterval({
          start: start,
          stop: stop,
          interval: this.interval
        });
      }
      var n = this.domain.length;
      var maxTickCount = this.maxTickCount,
        tickCount = this.tickCount;
      var minTickCount = this.minTickCount;
      var medianInterval;
      if (isFinite(maxTickCount) && n <= maxTickCount) {
        minTickCount = Math.max(1, n);
        medianInterval = this.medianInterval;
      }
      ticks != null ? ticks : ticks = this.getDefaultTicks({
        start: start,
        stop: stop,
        tickCount: tickCount,
        minTickCount: minTickCount,
        maxTickCount: maxTickCount,
        isReversed: isReversed,
        interval: medianInterval
      });
      var tickPositions = /* @__PURE__ */new Set();
      return ticks.filter(function (tick) {
        var position = _this21.convert(tick);
        if (isNaN(position) || tickPositions.has(position)) {
          return false;
        }
        tickPositions.add(position);
        return true;
      });
    }
  }, {
    key: "getDefaultTicks",
    value: function getDefaultTicks(_ref31) {
      var start = _ref31.start,
        stop = _ref31.stop,
        tickCount = _ref31.tickCount,
        minTickCount = _ref31.minTickCount,
        maxTickCount = _ref31.maxTickCount,
        isReversed = _ref31.isReversed,
        interval = _ref31.interval;
      var tickInterval = _TimeScale2.getTickInterval({
        start: start,
        stop: stop,
        count: tickCount,
        minCount: minTickCount,
        maxCount: maxTickCount,
        target: interval
      });
      if (!tickInterval) {
        return [];
      }
      var tickEvery = Math.ceil(this.domain.length / maxTickCount);
      var ticks = [];
      var _iterator51 = _createForOfIteratorHelper(this.index.entries()),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var _step51$value = _slicedToArray(_step51.value, 2),
            dateRange = _step51$value[0],
            index = _step51$value[1];
          if (index % tickEvery > 0) {
            continue;
          }
          var tick = isReversed ? tickInterval.ceil(dateRange[0]) : tickInterval.floor(dateRange[1]);
          ticks.splice(index, 0, tick);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
      return ticks;
    }
  }, {
    key: "getTicksForInterval",
    value: function getTicksForInterval(_ref32) {
      var start = _ref32.start,
        stop = _ref32.stop,
        interval = _ref32.interval;
      var _a;
      var _this$range3 = _slicedToArray(this.range, 2),
        r0 = _this$range3[0],
        r1 = _this$range3[1];
      var availableRange = Math.abs(r1 - r0);
      return (_a = _TimeScale2.getTicksForInterval({
        start: start,
        stop: stop,
        interval: interval,
        availableRange: availableRange
      })) != null ? _a : [];
    }
  }, {
    key: "convert",
    value: function convert(d) {
      if (typeof d === "number") {
        d = new Date(d);
      }
      if (!(d instanceof Date)) {
        return NaN;
      }
      this.refresh();
      var i;
      var _iterator52 = _createForOfIteratorHelper(this.index.entries()),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var _step52$value = _slicedToArray(_step52.value, 2),
            dateRange = _step52$value[0],
            index = _step52$value[1];
          if (d >= dateRange[0] && d <= dateRange[1]) {
            i = index;
            break;
          }
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      if (i === void 0) {
        return NaN;
      }
      var r = this.ordinalRange[i];
      if (r === void 0) {
        return NaN;
      }
      return r;
    }
    /**
     * Returns a time format function suitable for displaying tick values.
     * @param specifier If the specifier string is provided, this method is equivalent to
     * the {@link TimeLocaleObject.format} method.
     * If no specifier is provided, this method returns the default time format function.
     */
  }, {
    key: "tickFormat",
    value: function tickFormat(_ref33) {
      var ticks = _ref33.ticks,
        domain = _ref33.domain,
        specifier = _ref33.specifier;
      return specifier == null ? _defaultTimeTickFormat(ticks, domain) : _buildFormatter(specifier);
    }
  }, {
    key: "invert",
    value: function invert(y) {
      return new Date(_superPropGet(_OrdinalTimeScale, "invert", this, 3)([y]));
    }
  }, {
    key: "invertNearest",
    value: function invertNearest(y) {
      return new Date(_superPropGet(_OrdinalTimeScale, "invertNearest", this, 3)([y]));
    }
  }, {
    key: "domain",
    set: function set(values) {
      this.invalid = true;
      if (values.length === 0) {
        this._domain = [];
        return;
      }
      var domain = this.updateIndex(values);
      this._domain = domain;
    },
    get: function get() {
      return this._domain;
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _OrdinalTimeScale;
    }
  }]);
  return _OrdinalTimeScale;
}(_BandScale3);
__decorateClass([_Invalidating], _OrdinalTimeScale.prototype, "tickCount", 2);
__decorateClass([_Invalidating], _OrdinalTimeScale.prototype, "minTickCount", 2);
__decorateClass([_Invalidating], _OrdinalTimeScale.prototype, "maxTickCount", 2);
__decorateClass([_Invalidating], _OrdinalTimeScale.prototype, "interval", 2);
var _OrdinalTimeScale2 = _OrdinalTimeScale;

// packages/ag-charts-community/src/util/compare.ts
function ascendingStringNumberUndefined(a, b) {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  } else if (typeof a === "string" && typeof b === "string") {
    return a.localeCompare(b);
  } else if (a == null && b == null) {
    return 0;
  } else if (a == null) {
    return -1;
  } else if (b == null) {
    return 1;
  }
  return String(a).localeCompare(String(b));
}
function toLiteral(v) {
  return typeof v === "function" ? v() : v;
}
function compoundAscending(a, b, comparator) {
  for (var idx in a) {
    var diff2 = comparator(toLiteral(a[idx]), toLiteral(b[idx]));
    if (diff2 !== 0) {
      return diff2;
    }
  }
  return 0;
}

// packages/ag-charts-community/src/scene/group.ts
var _Group = /*#__PURE__*/function (_Node2) {
  _inherits(_Group, _Node2);
  function _Group(opts) {
    var _this22;
    _classCallCheck(this, _Group);
    var _a;
    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(_Group).call(this, {
      isVirtual: opts == null ? void 0 : opts.isVirtual
    }));
    _this22.opts = opts;
    _this22.opacity = 1;
    _this22.lastBBox = void 0;
    var _ref34 = opts != null ? opts : {},
      zIndex = _ref34.zIndex,
      zIndexSubOrder = _ref34.zIndexSubOrder;
    _this22.isContainerNode = true;
    if (zIndex !== void 0) {
      _this22.zIndex = zIndex;
    }
    if (zIndexSubOrder !== void 0) {
      _this22.zIndexSubOrder = zIndexSubOrder;
    }
    _this22.name = (_a = _this22.opts) == null ? void 0 : _a.name;
    return _this22;
  }
  _createClass(_Group, [{
    key: "onZIndexChange",
    value: function onZIndexChange() {
      var _a;
      _superPropGet(_Group, "onZIndexChange", this, 3)([]);
      if (this.layer) {
        (_a = this._layerManager) == null ? void 0 : _a.moveLayer(this.layer, this.zIndex, this.zIndexSubOrder);
      }
    }
  }, {
    key: "isLayer",
    value: function isLayer() {
      return this.layer != null;
    }
  }, {
    key: "_setLayerManager",
    value: function _setLayerManager(layersManager) {
      if (this._layerManager && this.layer) {
        this._layerManager.removeLayer(this.layer);
        this.layer = void 0;
      }
      if (this.layer) {
        throw new Error("AG Charts - unable to deregister scene rendering layer!");
      }
      _superPropGet(_Group, "_setLayerManager", this, 3)([layersManager]);
    }
  }, {
    key: "initialiseLayer",
    value: function initialiseLayer() {
      var _this23 = this;
      var _a;
      if (this.layer) return;
      if (!this._layerManager || ((_a = this.opts) == null ? void 0 : _a.layer) !== true) return;
      this.layer = this._layerManager.addLayer({
        name: this.name,
        zIndex: this.zIndex,
        zIndexSubOrder: this.zIndexSubOrder,
        getComputedOpacity: function getComputedOpacity() {
          return _this23.getComputedOpacity();
        },
        getVisibility: function getVisibility() {
          return _this23.getVisibility();
        }
      });
    }
  }, {
    key: "getComputedOpacity",
    value: function getComputedOpacity() {
      var opacity = 1;
      var _iterator53 = _createForOfIteratorHelper(this.traverseUp()),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var node = _step53.value;
          if (node instanceof _Group) {
            opacity *= node.opacity;
          }
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
      return opacity;
    }
  }, {
    key: "getVisibility",
    value: function getVisibility() {
      var _iterator54 = _createForOfIteratorHelper(this.traverseUp()),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var node = _step54.value;
          if (!node.visible) {
            return false;
          }
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return true;
    }
  }, {
    key: "onVisibleChange",
    value: function onVisibleChange() {
      if (this.layer) {
        this.layer.enabled = this.visible;
      }
    }
  }, {
    key: "markDirty",
    value: function markDirty(source) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (this.isVirtual) {
        _superPropGet(_Group, "markDirty", this, 3)([source, type]);
        return;
      }
      var parentType = type;
      if (type < 2 /* MINOR */ || this.layer != null) {
        parentType = 1 /* TRIVIAL */;
      }
      _superPropGet(_Group, "markDirty", this, 3)([source, type, parentType]);
    } // We consider a group to be boundless, thus any point belongs to it.
  }, {
    key: "containsPoint",
    value: function containsPoint(_x, _y) {
      return true;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      this.computeTransformMatrix();
      return _Group.computeBBox(this.children);
    }
  }, {
    key: "computeTransformedBBox",
    value: function computeTransformedBBox() {
      return this.computeBBox();
    }
  }, {
    key: "preRender",
    value: function preRender() {
      var _a, _b;
      var counts = _superPropGet(_Group, "preRender", this, 3)([]);
      counts.groups += 1;
      counts.nonGroups -= 1;
      if (((_a = this.opts) == null ? void 0 : _a.layer) !== true || this.layer != null) return counts;
      if (counts.nonGroups > 0) {
        this.initialiseLayer();
      }
      if (((_b = this.opts) == null ? void 0 : _b.nonEmptyChildDerivedZIndex) && counts.nonGroups > 0) {
        this.deriveZIndexFromChildren();
      }
      return counts;
    }
  }, {
    key: "deriveZIndexFromChildren",
    value: function deriveZIndexFromChildren() {
      var _a;
      var children = this.children.filter(function (c) {
        return c._childNodeCounts.nonGroups > 0;
      });
      this.sortChildren(children);
      var lastChild = children.at(-1);
      this.zIndex = (_a = lastChild == null ? void 0 : lastChild.zIndex) != null ? _a : -Infinity;
      this.zIndexSubOrder = lastChild == null ? void 0 : lastChild.zIndexSubOrder;
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      var _this24 = this;
      var _a, _b;
      var _this$opts = this.opts,
        _this$opts2 = _this$opts === void 0 ? {} : _this$opts,
        _this$opts2$name = _this$opts2.name,
        name = _this$opts2$name === void 0 ? void 0 : _this$opts2$name,
        debug3 = this._debug;
      var dirty = this.dirty,
        dirtyZIndex = this.dirtyZIndex,
        layer = this.layer,
        children = this.children,
        clipRect = this.clipRect,
        dirtyTransform = this.dirtyTransform;
      var ctx = renderCtx.ctx,
        forceRender = renderCtx.forceRender,
        clipBBox = renderCtx.clipBBox;
      var resized = renderCtx.resized,
        stats = renderCtx.stats;
      var canvasCtxTransform = ctx.getTransform();
      var isDirty = dirty >= 2 /* MINOR */ || dirtyZIndex || resized;
      var isChildDirty = isDirty;
      var isChildLayerDirty = false;
      var _iterator55 = _createForOfIteratorHelper(children),
        _step55;
      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var _child4 = _step55.value;
          isChildDirty || (isChildDirty = _child4.layerManager == null && _child4.dirty >= 1 /* TRIVIAL */);
          isChildLayerDirty || (isChildLayerDirty = _child4.layerManager != null && _child4.dirty >= 1 /* TRIVIAL */);
          if (isChildDirty) {
            break;
          }
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }
      if (name) {
        debug3 == null ? void 0 : debug3({
          name: name,
          group: this,
          isDirty: isDirty,
          isChildDirty: isChildDirty,
          dirtyTransform: dirtyTransform,
          renderCtx: renderCtx,
          forceRender: forceRender
        });
      }
      if (dirtyTransform) {
        forceRender = "dirtyTransform";
      } else if (layer) {
        var currentBBox = this.computeBBox();
        if (this.lastBBox === void 0 || !this.lastBBox.equals(currentBBox)) {
          forceRender = "dirtyTransform";
          this.lastBBox = currentBBox;
        }
      }
      if (!isDirty && !isChildDirty && !isChildLayerDirty && !forceRender) {
        if (name && stats) {
          debug3 == null ? void 0 : debug3({
            name: name,
            result: "skipping",
            renderCtx: renderCtx,
            counts: this.nodeCount,
            group: this
          });
        }
        if (layer && stats) {
          stats.layersSkipped++;
          stats.nodesSkipped += this.nodeCount.count;
        }
        this.markClean({
          recursive: false
        });
        return;
      }
      var groupVisible = this.visible;
      if (layer) {
        ctx = layer.context;
        ctx.save();
        ctx.setTransform(layer.pixelRatio, 0, 0, layer.pixelRatio, 0, 0);
        if (forceRender !== "dirtyTransform") {
          forceRender = isChildDirty || dirtyZIndex;
        }
        if (forceRender) layer.clear();
        if (clipBBox) {
          var _clipBBox = clipBBox,
            width = _clipBBox.width,
            height = _clipBBox.height,
            x = _clipBBox.x,
            y = _clipBBox.y;
          debug3 == null ? void 0 : debug3(function () {
            return {
              name: name,
              clipBBox: clipBBox,
              ctxTransform: ctx.getTransform(),
              renderCtx: renderCtx,
              group: _this24
            };
          });
          ctx.beginPath();
          ctx.rect(x, y, width, height);
          ctx.clip();
        }
        ctx.setTransform(canvasCtxTransform);
      } else {
        ctx.globalAlpha *= this.opacity;
      }
      this.computeTransformMatrix();
      this.matrix.toContext(ctx);
      if (clipRect) {
        var _x2 = clipRect.x,
          _y2 = clipRect.y,
          _width2 = clipRect.width,
          _height2 = clipRect.height;
        ctx.save();
        debug3 == null ? void 0 : debug3(function () {
          return {
            name: name,
            clipRect: clipRect,
            ctxTransform: ctx.getTransform(),
            renderCtx: renderCtx,
            group: _this24
          };
        });
        ctx.beginPath();
        ctx.rect(_x2, _y2, _width2, _height2);
        ctx.clip();
        clipBBox = this.matrix.transformBBox(clipRect);
      }
      var hasVirtualChildren = this.hasVirtualChildren();
      if (dirtyZIndex) {
        this.sortChildren(children);
        if (forceRender !== "dirtyTransform") forceRender = true;
      } else if (hasVirtualChildren) {
        this.sortChildren(children);
      }
      var renderContextChanged = forceRender !== renderCtx.forceRender || clipBBox !== renderCtx.clipBBox || ctx !== renderCtx.ctx;
      var childRenderContext = renderContextChanged ? __spreadProps(__spreadValues({}, renderCtx), {
        ctx: ctx,
        forceRender: forceRender,
        clipBBox: clipBBox
      }) : renderCtx;
      var skipped = 0;
      var _iterator56 = _createForOfIteratorHelper(children),
        _step56;
      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var _child5 = _step56.value;
          if (!_child5.visible || !groupVisible) {
            _child5.markClean();
            if (stats) skipped += _child5.nodeCount.count;
            continue;
          }
          if (!forceRender && _child5.dirty === 0 /* NONE */) {
            if (stats) skipped += _child5.nodeCount.count;
            continue;
          }
          ctx.save();
          _child5.render(childRenderContext);
          ctx.restore();
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
      if (stats) stats.nodesSkipped += skipped;
      _superPropGet(_Group, "render", this, 3)([renderCtx]);
      if (clipRect) {
        ctx.restore();
      }
      if (hasVirtualChildren) {
        var _iterator57 = _createForOfIteratorHelper(this.virtualChildren),
          _step57;
        try {
          for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
            var child = _step57.value;
            child.markClean({
              recursive: "virtual"
            });
          }
        } catch (err) {
          _iterator57.e(err);
        } finally {
          _iterator57.f();
        }
      }
      if (layer) {
        if (stats) stats.layersRendered++;
        ctx.restore();
        if (forceRender) layer.snapshot();
        (_b = (_a = layer.context).verifyDepthZero) == null ? void 0 : _b.call(_a);
      }
      if (name && stats) {
        debug3 == null ? void 0 : debug3({
          name: name,
          result: "rendered",
          skipped: skipped,
          renderCtx: renderCtx,
          counts: this.nodeCount,
          group: this
        });
      }
    }
  }, {
    key: "sortChildren",
    value: function sortChildren(children) {
      this.dirtyZIndex = false;
      children.sort(function (a, b) {
        var _a, _b;
        return compoundAscending([a.zIndex].concat(_toConsumableArray((_a = a.zIndexSubOrder) != null ? _a : [void 0, void 0]), [a.serialNumber]), [b.zIndex].concat(_toConsumableArray((_b = b.zIndexSubOrder) != null ? _b : [void 0, void 0]), [b.serialNumber]), ascendingStringNumberUndefined);
      });
    }
  }, {
    key: "setClipRectInGroupCoordinateSpace",
    /**
     * Transforms bbox given in the canvas coordinate space to bbox in this group's coordinate space and
     * sets this group's clipRect to the transformed bbox.
     * @param bbox clipRect bbox in the canvas coordinate space.
     */
    value: function setClipRectInGroupCoordinateSpace(bbox) {
      this.clipRect = bbox ? this.transformBBox(bbox) : void 0;
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _Group;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox(nodes) {
      var left = Infinity;
      var right = -Infinity;
      var top = Infinity;
      var bottom = -Infinity;
      var _iterator58 = _createForOfIteratorHelper(nodes),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var n = _step58.value;
          if (!n.visible) continue;
          var bbox = n.computeTransformedBBox();
          if (!bbox) continue;
          var x = bbox.x,
            y = bbox.y,
            width = bbox.width,
            height = bbox.height;
          if (x < left) {
            left = x;
          }
          if (y < top) {
            top = y;
          }
          if (x + width > right) {
            right = x + width;
          }
          if (y + height > bottom) {
            bottom = y + height;
          }
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
      return new _BBox2(left, top, right - left, bottom - top);
    }
  }]);
  return _Group;
}(_Node4);
_Group.className = "Group";
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */,
  convertor: function convertor(v) {
    return _clamp(0, v, 1);
  }
})], _Group.prototype, "opacity", 2);
var _Group4 = _Group;

// packages/ag-charts-community/src/scene/gradient/gradient.ts
var Gradient = function Gradient() {
  var stops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  _classCallCheck(this, Gradient);
  this.stops = stops;
};

// packages/ag-charts-community/src/scene/gradient/linearGradient.ts
var LinearGradient = /*#__PURE__*/function (_Gradient) {
  _inherits(LinearGradient, _Gradient);
  function LinearGradient(stops) {
    var _this25;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, LinearGradient);
    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(LinearGradient).call(this, stops));
    _this25.angle = angle;
    return _this25;
  }
  _createClass(LinearGradient, [{
    key: "createGradient",
    value: function createGradient(ctx, bbox) {
      var angleOffset = 90;
      var stops = this.stops,
        angle = this.angle;
      var radians = _normalizeAngle2(_toRadians(angle + angleOffset));
      var cos = Math.cos(radians);
      var sin = Math.sin(radians);
      var w = bbox.width;
      var h = bbox.height;
      var cx = bbox.x + w * 0.5;
      var cy = bbox.y + h * 0.5;
      if (w > 0 && h > 0) {
        var diagonal = Math.sqrt(h * h + w * w) / 2;
        var diagonalAngle = Math.atan2(h, w);
        var quarteredAngle;
        if (radians < Math.PI / 2) {
          quarteredAngle = radians;
        } else if (radians < Math.PI) {
          quarteredAngle = Math.PI - radians;
        } else if (radians < 1.5 * Math.PI) {
          quarteredAngle = radians - Math.PI;
        } else {
          quarteredAngle = 2 * Math.PI - radians;
        }
        var l = diagonal * Math.abs(Math.cos(quarteredAngle - diagonalAngle));
        var gradient = ctx.createLinearGradient(cx + cos * l, cy + sin * l, cx - cos * l, cy - sin * l);
        var _iterator59 = _createForOfIteratorHelper(stops),
          _step59;
        try {
          for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
            var stop = _step59.value;
            gradient.addColorStop(stop.offset, stop.color);
          }
        } catch (err) {
          _iterator59.e(err);
        } finally {
          _iterator59.f();
        }
        return gradient;
      }
      return "black";
    }
  }]);
  return LinearGradient;
}(Gradient);

// packages/ag-charts-community/src/scene/shape/shape.ts
var LINEAR_GRADIENT_REGEXP = /^linear-gradient\((.*?)deg,\s*(.*?)\s*\)$/i;
var _Shape = /*#__PURE__*/function (_Node3) {
  _inherits(_Shape, _Node3);
  function _Shape() {
    var _this26;
    _classCallCheck(this, _Shape);
    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(_Shape).apply(this, arguments));
    _this26.fillOpacity = 1;
    _this26.strokeOpacity = 1;
    _this26.fill = _Shape.defaultStyles.fill;
    _this26.stroke = _Shape.defaultStyles.stroke;
    _this26.strokeWidth = _Shape.defaultStyles.strokeWidth;
    _this26.lineDash = _Shape.defaultStyles.lineDash;
    _this26.lineDashOffset = _Shape.defaultStyles.lineDashOffset;
    _this26.lineCap = _Shape.defaultStyles.lineCap;
    _this26.lineJoin = _Shape.defaultStyles.lineJoin;
    _this26.opacity = _Shape.defaultStyles.opacity;
    _this26.fillShadow = _Shape.defaultStyles.fillShadow;
    return _this26;
  }
  /**
   * Restores the default styles introduced by this subclass.
   */
  _createClass(_Shape, [{
    key: "restoreOwnStyles",
    value: function restoreOwnStyles() {
      var defaultStyles = this.constructor.defaultStyles;
      Object.assign(this, defaultStyles);
    }
  }, {
    key: "onFillChange",
    value: function onFillChange() {
      var fill = this.fill;
      var linearGradientMatch;
      if ((fill == null ? void 0 : fill.startsWith("linear-gradient")) && (linearGradientMatch = LINEAR_GRADIENT_REGEXP.exec(fill))) {
        var angle = parseFloat(linearGradientMatch[1]);
        var colors = [];
        var colorsPart = linearGradientMatch[2];
        var colorRegex = /(#[0-9a-f]+)|(rgba?\(.+?\))|([a-z]+)/gi;
        var c;
        while (c = colorRegex.exec(colorsPart)) {
          colors.push(c[0]);
        }
        this.gradient = new LinearGradient(colors.map(function (color, index) {
          return {
            color: color,
            offset: index / (colors.length - 1)
          };
        }), angle);
      } else {
        this.gradient = void 0;
      }
    }
    /**
     * Returns a device-pixel aligned coordinate (or length if length is supplied).
     *
     * NOTE: Not suitable for strokes, since the stroke needs to be offset to the middle
     * of a device pixel.
     */
  }, {
    key: "align",
    value: function align(start, length) {
      var _a, _b, _c;
      var pixelRatio = (_c = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas) == null ? void 0 : _b.pixelRatio) != null ? _c : 1;
      var alignedStart = Math.round(start * pixelRatio) / pixelRatio;
      if (length == null) {
        return alignedStart;
      } else if (length === 0) {
        return 0;
      } else if (length < 1) {
        return Math.ceil(length * pixelRatio) / pixelRatio;
      }
      return Math.round((length + start) * pixelRatio) / pixelRatio - alignedStart;
    }
  }, {
    key: "fillStroke",
    value: function fillStroke(ctx, path) {
      this.renderFill(ctx, path);
      this.renderStroke(ctx, path);
    }
  }, {
    key: "renderFill",
    value: function renderFill(ctx, path) {
      if (this.fill) {
        var globalAlpha = ctx.globalAlpha;
        this.applyFill(ctx);
        this.applyFillAlpha(ctx);
        this.applyShadow(ctx);
        this.executeFill(ctx, path);
        ctx.globalAlpha = globalAlpha;
      }
      ctx.shadowColor = "rgba(0, 0, 0, 0)";
    }
  }, {
    key: "executeFill",
    value: function executeFill(ctx, path) {
      path ? ctx.fill(path) : ctx.fill();
    }
  }, {
    key: "applyFill",
    value: function applyFill(ctx) {
      var _a, _b;
      ctx.fillStyle = (_b = (_a = this.gradient) == null ? void 0 : _a.createGradient(ctx, this.computeBBox())) != null ? _b : this.fill;
    }
  }, {
    key: "applyFillAlpha",
    value: function applyFillAlpha(ctx) {
      ctx.globalAlpha *= this.opacity * this.fillOpacity;
    }
  }, {
    key: "applyShadow",
    value: function applyShadow(ctx) {
      var _a, _b;
      var pixelRatio = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas.pixelRatio) != null ? _b : 1;
      var fillShadow = this.fillShadow;
      if (fillShadow == null ? void 0 : fillShadow.enabled) {
        ctx.shadowColor = fillShadow.color;
        ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
        ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
        ctx.shadowBlur = fillShadow.blur * pixelRatio;
      }
    }
  }, {
    key: "renderStroke",
    value: function renderStroke(ctx, path) {
      if (this.stroke && this.strokeWidth) {
        var globalAlpha = ctx.globalAlpha;
        ctx.strokeStyle = this.stroke;
        ctx.globalAlpha *= this.opacity * this.strokeOpacity;
        ctx.lineWidth = this.strokeWidth;
        if (this.lineDash) {
          ctx.setLineDash(this.lineDash);
        }
        if (this.lineDashOffset) {
          ctx.lineDashOffset = this.lineDashOffset;
        }
        if (this.lineCap) {
          ctx.lineCap = this.lineCap;
        }
        if (this.lineJoin) {
          ctx.lineJoin = this.lineJoin;
        }
        this.executeStroke(ctx, path);
        ctx.globalAlpha = globalAlpha;
      }
    }
  }, {
    key: "executeStroke",
    value: function executeStroke(ctx, path) {
      path ? ctx.stroke(path) : ctx.stroke();
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(x, y) {
      return this.isPointInPath(x, y);
    }
  }]);
  return _Shape;
}(_Node4);
/**
 * Defaults for style properties. Note that properties that affect the position
 * and shape of the node are not considered style properties, for example:
 * `x`, `y`, `width`, `height`, `radius`, `rotation`, etc.
 * Can be used to reset to the original styling after some custom styling
 * has been applied (using the `restoreOwnStyles` method).
 * These static defaults are meant to be inherited by subclasses.
 */
_Shape.defaultStyles = {
  fill: "black",
  stroke: void 0,
  strokeWidth: 0,
  lineDash: void 0,
  lineDashOffset: 0,
  lineCap: void 0,
  lineJoin: void 0,
  opacity: 1,
  fillShadow: void 0
};
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "fillOpacity", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "strokeOpacity", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */,
  changeCb: function changeCb(s) {
    return s.onFillChange();
  }
})], _Shape.prototype, "fill", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "stroke", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "strokeWidth", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "lineDash", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "lineDashOffset", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "lineCap", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], _Shape.prototype, "lineJoin", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */,
  convertor: function convertor(v) {
    return _clamp(0, v, 1);
  }
})], _Shape.prototype, "opacity", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */,
  checkDirtyOnAssignment: true
})], _Shape.prototype, "fillShadow", 2);
var _Shape6 = _Shape;

// packages/ag-charts-community/src/scene/shape/range.ts
var Range = /*#__PURE__*/function (_Shape2) {
  _inherits(Range, _Shape2);
  function Range() {
    var _this27;
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Range);
    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Range).call(this, opts));
    _this27.x1 = 0;
    _this27.y1 = 0;
    _this27.x2 = 0;
    _this27.y2 = 0;
    _this27.startLine = false;
    _this27.endLine = false;
    _this27.isRange = false;
    _this27.restoreOwnStyles();
    return _this27;
  }
  _createClass(Range, [{
    key: "computeBBox",
    value: function computeBBox() {
      return new _BBox2(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(_x, _y) {
      return false;
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      var _a;
      var ctx = renderCtx.ctx,
        forceRender = renderCtx.forceRender,
        stats = renderCtx.stats;
      if (this.dirty === 0 /* NONE */ && !forceRender) {
        if (stats) stats.nodesSkipped += this.nodeCount.count;
        return;
      }
      this.computeTransformMatrix();
      this.matrix.toContext(ctx);
      var x1 = this.x1,
        y1 = this.y1,
        x2 = this.x2,
        y2 = this.y2;
      x1 = this.align(x1);
      y1 = this.align(y1);
      x2 = this.align(x2);
      y2 = this.align(y2);
      var fill = this.fill,
        opacity = this.opacity,
        isRange = this.isRange;
      var fillActive = !!(isRange && fill);
      if (fillActive) {
        var fillOpacity = this.fillOpacity;
        ctx.fillStyle = fill;
        ctx.globalAlpha = opacity * fillOpacity;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y1);
        ctx.lineTo(x2, y2);
        ctx.lineTo(x1, y2);
        ctx.closePath();
        ctx.fill();
      }
      var stroke = this.stroke,
        strokeWidth = this.strokeWidth,
        startLine = this.startLine,
        endLine = this.endLine;
      var strokeActive = !!((startLine || endLine) && stroke && strokeWidth);
      if (strokeActive) {
        var strokeOpacity = this.strokeOpacity,
          lineDash = this.lineDash,
          lineDashOffset = this.lineDashOffset,
          lineCap = this.lineCap,
          lineJoin = this.lineJoin;
        ctx.strokeStyle = stroke;
        ctx.globalAlpha = opacity * strokeOpacity;
        ctx.lineWidth = strokeWidth;
        if (lineDash) {
          ctx.setLineDash(lineDash);
        }
        if (lineDashOffset) {
          ctx.lineDashOffset = lineDashOffset;
        }
        if (lineCap) {
          ctx.lineCap = lineCap;
        }
        if (lineJoin) {
          ctx.lineJoin = lineJoin;
        }
        ctx.beginPath();
        if (startLine) {
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y1);
        }
        if (endLine) {
          ctx.moveTo(x2, y2);
          ctx.lineTo(x1, y2);
        }
        ctx.stroke();
      }
      (_a = this.fillShadow) == null ? void 0 : _a.markClean();
      _superPropGet(Range, "render", this, 3)([renderCtx]);
    }
  }]);
  return Range;
}(_Shape6);
Range.className = "Range";
Range.defaultStyles = __spreadProps(__spreadValues({}, _Shape6.defaultStyles), {
  strokeWidth: 1
});
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "x1", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "y1", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "x2", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "y2", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "startLine", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "endLine", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 2 /* MINOR */
})], Range.prototype, "isRange", 2);

// packages/ag-charts-community/src/util/memo.ts
var memorizedFns = /* @__PURE__ */new WeakMap();
var memorizedMap = /* @__PURE__ */new WeakMap();
function memo(params, fnGenerator) {
  var _a, _b, _c;
  var serialisedParams = JSON.stringify(params, null, 0);
  if (!memorizedFns.has(fnGenerator)) {
    memorizedFns.set(fnGenerator, /* @__PURE__ */new Map());
  }
  if (!((_a = memorizedFns.get(fnGenerator)) == null ? void 0 : _a.has(serialisedParams))) {
    (_b = memorizedFns.get(fnGenerator)) == null ? void 0 : _b.set(serialisedParams, fnGenerator(params));
  }
  return (_c = memorizedFns.get(fnGenerator)) == null ? void 0 : _c.get(serialisedParams);
}
function memoizeFunction(baseFn) {
  return function (params) {
    var _a, _b, _c;
    var serialisedParams = JSON.stringify(params, null, 0);
    if (!memorizedMap.has(baseFn)) {
      memorizedMap.set(baseFn, /* @__PURE__ */new Map());
    }
    if (!((_a = memorizedMap.get(baseFn)) == null ? void 0 : _a.has(serialisedParams))) {
      for (var _len18 = arguments.length, rest = new Array(_len18 > 1 ? _len18 - 1 : 0), _key19 = 1; _key19 < _len18; _key19++) {
        rest[_key19 - 1] = arguments[_key19];
      }
      (_b = memorizedMap.get(baseFn)) == null ? void 0 : _b.set(serialisedParams, baseFn.apply(void 0, [params].concat(rest)));
    }
    return (_c = memorizedMap.get(baseFn)) == null ? void 0 : _c.get(serialisedParams);
  };
}

// packages/ag-charts-community/src/scene/shape/text.ts
var ellipsis = "\u2026";
function SceneFontChangeDetection(opts) {
  var _ref35 = opts != null ? opts : {},
    _ref35$redraw = _ref35.redraw,
    redraw = _ref35$redraw === void 0 ? 3 : _ref35$redraw,
    changeCb = _ref35.changeCb;
  return _SceneChangeDetection({
    redraw: redraw,
    type: "font",
    changeCb: changeCb
  });
}
var _Text = /*#__PURE__*/function (_Shape3) {
  _inherits(_Text, _Shape3);
  function _Text() {
    var _this28;
    _classCallCheck(this, _Text);
    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(_Text).apply(this, arguments));
    _this28.x = 0;
    _this28.y = 0;
    _this28.lines = [];
    _this28.text = void 0;
    _this28._dirtyFont = true;
    _this28.fontSize = 10;
    _this28.fontFamily = "sans-serif";
    _this28.textAlign = _Text.defaultStyles.textAlign;
    _this28.textBaseline = _Text.defaultStyles.textBaseline;
    return _this28;
  }
  _createClass(_Text, [{
    key: "onTextChange",
    value: function onTextChange() {
      var _a, _b;
      this.lines = (_b = (_a = this.text) == null ? void 0 : _a.split("\n").map(function (s) {
        return s.trim();
      })) != null ? _b : [];
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      var x = this.x,
        y = this.y,
        lines = this.lines,
        lineHeight = this.lineHeight,
        textBaseline = this.textBaseline,
        textAlign = this.textAlign;
      var _Text$getTextSizeMult = _Text.getTextSizeMultiline(lines, _getFont(this), textBaseline, textAlign, lineHeight),
        top = _Text$getTextSizeMult.top,
        left = _Text$getTextSizeMult.left,
        width = _Text$getTextSizeMult.width,
        height = _Text$getTextSizeMult.height;
      return new _BBox2(x - left, y - top, width, height);
    }
  }, {
    key: "getLineHeight",
    value: function getLineHeight(line) {
      var _a, _b;
      if (this.lineHeight) {
        return this.lineHeight;
      }
      var metrics = _Text.measureText(line, this.font, this.textBaseline, this.textAlign);
      return (
        // Fallback to emHeightAscent + emHeightDescent is needed for server-side rendering.
        ((_a = metrics.fontBoundingBoxAscent) != null ? _a : metrics.emHeightAscent) + ((_b = metrics.fontBoundingBoxDescent) != null ? _b : metrics.emHeightDescent)
      );
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var point = this.transformPoint(x, y);
      var bbox = this.computeBBox();
      return bbox ? bbox.containsPoint(point.x, point.y) : false;
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      var ctx = renderCtx.ctx,
        forceRender = renderCtx.forceRender,
        stats = renderCtx.stats;
      if (this.dirty === 0 /* NONE */ && !forceRender) {
        if (stats) stats.nodesSkipped += this.nodeCount.count;
        return;
      }
      if (!this.lines.length || !this.layerManager) {
        if (stats) stats.nodesSkipped += this.nodeCount.count;
        return;
      }
      this.computeTransformMatrix();
      this.matrix.toContext(ctx);
      var fill = this.fill,
        stroke = this.stroke,
        strokeWidth = this.strokeWidth;
      ctx.font = this.font;
      ctx.textAlign = this.textAlign;
      ctx.textBaseline = this.textBaseline;
      var pixelRatio = this.layerManager.canvas.pixelRatio || 1;
      var globalAlpha = ctx.globalAlpha;
      if (fill) {
        ctx.fillStyle = fill;
        ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
        var fillShadow = this.fillShadow;
        if (fillShadow == null ? void 0 : fillShadow.enabled) {
          ctx.shadowColor = fillShadow.color;
          ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
          ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
          ctx.shadowBlur = fillShadow.blur * pixelRatio;
        }
        this.renderLines(function (line, x, y) {
          return ctx.fillText(line, x, y);
        });
      }
      if (stroke && strokeWidth) {
        ctx.strokeStyle = stroke;
        ctx.lineWidth = strokeWidth;
        ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
        var lineDash = this.lineDash,
          lineDashOffset = this.lineDashOffset,
          lineCap = this.lineCap,
          lineJoin = this.lineJoin;
        if (lineDash) {
          ctx.setLineDash(lineDash);
        }
        if (lineDashOffset) {
          ctx.lineDashOffset = lineDashOffset;
        }
        if (lineCap) {
          ctx.lineCap = lineCap;
        }
        if (lineJoin) {
          ctx.lineJoin = lineJoin;
        }
        this.renderLines(function (line, x, y) {
          return ctx.strokeText(line, x, y);
        });
      }
      _superPropGet(_Text, "render", this, 3)([renderCtx]);
    }
  }, {
    key: "renderLines",
    value: function renderLines(renderCallback) {
      var _this29 = this;
      var lines = this.lines,
        x = this.x,
        y = this.y;
      var lineHeights = lines.map(function (line) {
        return _this29.getLineHeight(line);
      });
      var totalHeight = lineHeights.reduce(function (a, b) {
        return a + b;
      }, 0);
      var offsetY = (lineHeights[0] - totalHeight) * _Text.getVerticalModifier(this.textBaseline);
      for (var i = 0; i < lines.length; i++) {
        renderCallback(lines[i], x, y + offsetY);
        offsetY += lineHeights[i];
      }
    }
  }, {
    key: "setFont",
    value: function setFont(props) {
      this.fontFamily = props.fontFamily;
      this.fontSize = props.fontSize;
      this.fontStyle = props.fontStyle;
      this.fontWeight = props.fontWeight;
    }
  }, {
    key: "setAlign",
    value: function setAlign(props) {
      this.textAlign = props.textAlign;
      this.textBaseline = props.textBaseline;
    }
  }, {
    key: "font",
    get: function get() {
      if (this._font == null || this._dirtyFont) {
        this._dirtyFont = false;
        this._font = _getFont(this);
      }
      return this._font;
    }
  }], [{
    key: "wrapLines",
    value: function wrapLines(text, maxWidth, maxHeight, textProps, wrapping, overflow) {
      var canOverflow = overflow !== "hide";
      var measurer = new TextMeasurer(textProps);
      var lines = text.split(/\r?\n/g);
      if (lines.length === 0) {
        return {
          lines: void 0,
          truncated: false
        };
      }
      if (wrapping === "never") {
        var _Text$truncateLine = _Text.truncateLine(lines[0], maxWidth, measurer, canOverflow ? "auto" : "never"),
          truncText = _Text$truncateLine.text,
          truncated2 = _Text$truncateLine.truncated;
        return {
          lines: truncText != null ? [truncText] : void 0,
          truncated: truncated2
        };
      }
      var wrappedLines = [];
      var cumulativeHeight = 0;
      var truncated = false;
      var _iterator60 = _createForOfIteratorHelper(lines),
        _step60;
      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var line = _step60.value;
          var wrappedLine = _Text.wrapLine(line, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow);
          if (wrappedLine == null) {
            return {
              lines: void 0,
              truncated: false
            };
          }
          wrappedLines.push.apply(wrappedLines, _toConsumableArray(wrappedLine.result));
          cumulativeHeight = wrappedLine.cumulativeHeight;
          if (wrappedLine.truncated) {
            truncated = true;
            break;
          }
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
      return {
        lines: wrappedLines,
        truncated: truncated
      };
    }
  }, {
    key: "wrap",
    value: function wrap(text, maxWidth, maxHeight, textProps, wrapping) {
      var overflow = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "ellipsis";
      var _a;
      var _Text$wrapLines = _Text.wrapLines(text, maxWidth, maxHeight, textProps, wrapping, overflow),
        lines = _Text$wrapLines.lines,
        truncated = _Text$wrapLines.truncated;
      return {
        text: (_a = lines == null ? void 0 : lines.join("\n").trim()) != null ? _a : "",
        truncated: truncated
      };
    }
  }, {
    key: "wrapLine",
    value: function wrapLine(text, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow) {
      text = text.trim();
      if (!text) {
        return {
          result: [],
          truncated: false,
          cumulativeHeight: cumulativeHeight
        };
      }
      var initialSize = measurer.size(text);
      if (initialSize.width <= maxWidth) {
        return {
          result: [text],
          truncated: false,
          cumulativeHeight: cumulativeHeight + initialSize.height
        };
      }
      if (initialSize.height > maxHeight || measurer.width("W") > maxWidth) {
        return canOverflow ? {
          result: [],
          truncated: true,
          cumulativeHeight: cumulativeHeight
        } : void 0;
      }
      var words = text.split(/\s+/g);
      var wrapResult = _Text.wrapLineSequentially(words, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow);
      if (wrapResult == null) {
        return;
      }
      cumulativeHeight = wrapResult.cumulativeHeight;
      var lines = wrapResult.lines;
      if (!(wrapResult.wordsBrokenOrTruncated || wrapResult.linesTruncated)) {
        var linesCount = wrapResult.lines.length;
        var balanced = _Text.wrapLineBalanced(words, maxWidth, measurer, linesCount);
        if (balanced.length === lines.length) {
          lines = balanced;
        }
      }
      var wrappedText = lines.map(function (ln) {
        return ln.join(" ");
      });
      return {
        result: wrappedText,
        truncated: wrapResult.linesTruncated,
        cumulativeHeight: cumulativeHeight
      };
    }
  }, {
    key: "breakWord",
    value: function breakWord(word, firstLineWidth, maxWidth, hyphens, measurer) {
      var isPunctuationAt = function isPunctuationAt(index) {
        return _Text.punctuationMarks.includes(word[index]);
      };
      var h = hyphens ? measurer.width("-") : 0;
      var breaks = [];
      var partWidth = 0;
      var p = 0;
      for (var i = 0; i < word.length; i++) {
        var c = word[i];
        var w = measurer.width(c);
        var limit = p === 0 ? firstLineWidth : maxWidth;
        if (partWidth + w + h > limit) {
          breaks.push(i);
          partWidth = 0;
          p++;
        }
        partWidth += w;
      }
      var parts = [];
      var start = 0;
      for (var _i14 = 0, _breaks = breaks; _i14 < _breaks.length; _i14++) {
        var index = _breaks[_i14];
        var part = word.substring(start, index);
        if (hyphens && part.length > 0 && !isPunctuationAt(index - 1) && !isPunctuationAt(index)) {
          part += "-";
        }
        parts.push(part);
        start = index;
      }
      parts.push(word.substring(start));
      return parts;
    }
  }, {
    key: "truncateLine",
    value: function truncateLine(text, maxWidth, measurer, ellipsisMode) {
      text = text.trimEnd();
      var lineWidth = measurer.width(text);
      if (lineWidth > maxWidth && ellipsisMode === "never") {
        return {
          text: void 0,
          truncated: false
        };
      } else if (lineWidth <= maxWidth && ellipsisMode !== "force") {
        return {
          text: text,
          truncated: false
        };
      }
      var ellipsisWidth = measurer.width(ellipsis);
      var trunc = text;
      var truncWidth = lineWidth;
      while (trunc.length > 0 && truncWidth + ellipsisWidth > maxWidth) {
        trunc = trunc.slice(0, -1).trimEnd();
        truncWidth = measurer.width(trunc);
      }
      if (truncWidth + ellipsisWidth <= maxWidth) {
        return {
          text: "".concat(trunc).concat(ellipsis),
          truncated: true
        };
      } else {
        return {
          text: void 0,
          truncated: false
        };
      }
    }
  }, {
    key: "wrapLineSequentially",
    value: function wrapLineSequentially(words, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow) {
      var _textProps$fontSize = textProps.fontSize,
        fontSize = _textProps$fontSize === void 0 ? 0 : _textProps$fontSize,
        _textProps$lineHeight = textProps.lineHeight,
        lineHeight = _textProps$lineHeight === void 0 ? fontSize * _Text.defaultLineHeightRatio : _textProps$lineHeight;
      var breakWord = wrapping === "always" || wrapping === "hyphenate";
      var hyphenate = wrapping === "hyphenate";
      var spaceWidth = measurer.width(" ");
      var wordsBrokenOrTruncated = false;
      var linesTruncated = false;
      var lines = [];
      var currentLine = [];
      var lineWidth = 0;
      var getReturnValue = function getReturnValue() {
        return {
          lines: lines,
          linesTruncated: linesTruncated,
          wordsBrokenOrTruncated: wordsBrokenOrTruncated,
          cumulativeHeight: cumulativeHeight
        };
      };
      var truncateLastLine = function truncateLastLine() {
        if (!canOverflow) {
          return;
        }
        var lastLine = currentLine.join(" ");
        var _Text$truncateLine2 = _Text.truncateLine(lastLine, maxWidth, measurer, "force"),
          text = _Text$truncateLine2.text;
        if (text == null) {
          return;
        }
        currentLine.splice(0, currentLine.length, text);
        linesTruncated = true;
        return getReturnValue();
      };
      var addNewLine = function addNewLine() {
        var expectedHeight = cumulativeHeight + lineHeight;
        if (expectedHeight >= maxHeight) {
          return false;
        }
        currentLine = [];
        lineWidth = 0;
        cumulativeHeight = expectedHeight;
        lines.push(currentLine);
        return true;
      };
      if (!addNewLine()) {
        return truncateLastLine();
      }
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        var wordWidth = measurer.width(word);
        var expectedSpaceWidth = currentLine.length === 0 ? 0 : spaceWidth;
        var expectedLineWidth = lineWidth + expectedSpaceWidth + wordWidth;
        if (expectedLineWidth <= maxWidth) {
          currentLine.push(word);
          lineWidth = expectedLineWidth;
          continue;
        }
        if (wordWidth <= maxWidth) {
          if (!addNewLine()) {
            return truncateLastLine();
          }
          currentLine.push(word);
          lineWidth = wordWidth;
          continue;
        }
        wordsBrokenOrTruncated = true;
        if (breakWord) {
          var availWidth = maxWidth - lineWidth - expectedSpaceWidth;
          var parts = _Text.breakWord(word, availWidth, maxWidth, hyphenate, measurer);
          for (var p = 0; p < parts.length; p++) {
            var part = parts[p];
            part && currentLine.push(part);
            if (p === parts.length - 1) {
              lineWidth = measurer.width(part);
            } else if (!addNewLine()) {
              return truncateLastLine();
            }
          }
        } else if (canOverflow) {
          if (!addNewLine()) {
            return truncateLastLine();
          }
          var _Text$truncateLine3 = _Text.truncateLine(word, maxWidth, measurer, "force"),
            text = _Text$truncateLine3.text;
          if (text == null) {
            return;
          }
          currentLine.push(text);
          if (i < words.length - 1) {
            linesTruncated = true;
          }
          break;
        } else {
          return;
        }
      }
      return getReturnValue();
    }
  }, {
    key: "wrapLineBalanced",
    value: function wrapLineBalanced(words, maxWidth, measurer, linesCount) {
      var totalWordsWidth = words.reduce(function (sum2, w) {
        return sum2 + measurer.width(w);
      }, 0);
      var spaceWidth = measurer.width(" ");
      var totalSpaceWidth = spaceWidth * (words.length - linesCount - 2);
      var averageLineWidth = (totalWordsWidth + totalSpaceWidth) / linesCount;
      var lines = [];
      var currentLine = [];
      var lineWidth = measurer.width(words[0]);
      var newLine = true;
      var _iterator61 = _createForOfIteratorHelper(words),
        _step61;
      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var word = _step61.value;
          var width = measurer.width(word);
          if (newLine) {
            currentLine = [];
            currentLine.push(word);
            lineWidth = width;
            newLine = false;
            lines.push(currentLine);
            continue;
          }
          var expectedLineWidth = lineWidth + spaceWidth + width;
          if (expectedLineWidth <= averageLineWidth) {
            currentLine.push(word);
            lineWidth = expectedLineWidth;
          } else if (expectedLineWidth <= maxWidth) {
            currentLine.push(word);
            newLine = true;
          } else {
            currentLine = [word];
            lineWidth = width;
            lines.push(currentLine);
          }
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
      return lines;
    }
  }, {
    key: "getVerticalModifier",
    value: function getVerticalModifier(textBaseline) {
      switch (textBaseline) {
        case "top":
        case "hanging":
          return 0;
        case "bottom":
        case "alphabetic":
        case "ideographic":
          return 1;
        case "middle":
          return 0.5;
      }
    }
  }, {
    key: "measureText",
    value: function measureText(text, font, textBaseline, textAlign) {
      return this._measureText({
        text: text,
        font: font,
        textBaseline: textBaseline,
        textAlign: textAlign
      });
    }
    /**
     * Returns the width and height of the measured text.
     * @param text The single-line text to measure.
     * @param font The font shorthand string.
     */
  }, {
    key: "getTextSize",
    value: function getTextSize(text, font) {
      return this._getTextSize({
        text: text,
        font: font
      });
    }
  }, {
    key: "getTextSizeMultiline",
    value: function getTextSizeMultiline(lines, font) {
      var textBaseline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Text.defaultStyles.textBaseline;
      var textAlign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _Text.defaultStyles.textAlign;
      var lineHeight = arguments.length > 4 ? arguments[4] : undefined;
      var _a, _b;
      var top = 0;
      var left = 0;
      var width = 0;
      var height = 0;
      var baselineDistance = 0;
      var _iterator62 = _createForOfIteratorHelper(lines.entries()),
        _step62;
      try {
        for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
          var _step62$value = _slicedToArray(_step62.value, 2),
            i = _step62$value[0],
            text = _step62$value[1];
          var metrics = this._measureText({
            text: text,
            font: font,
            textBaseline: textBaseline,
            textAlign: textAlign
          });
          left = Math.max(left, metrics.actualBoundingBoxLeft);
          width = Math.max(width, metrics.width);
          if (i == 0) {
            top += metrics.actualBoundingBoxAscent;
            height += metrics.actualBoundingBoxAscent;
          } else {
            baselineDistance += (_a = metrics.fontBoundingBoxAscent) != null ? _a : metrics.emHeightAscent;
          }
          if (i == lines.length - 1) {
            height += metrics.actualBoundingBoxDescent;
          } else {
            baselineDistance += (_b = metrics.fontBoundingBoxDescent) != null ? _b : metrics.emHeightDescent;
          }
        }
      } catch (err) {
        _iterator62.e(err);
      } finally {
        _iterator62.f();
      }
      if (lineHeight != null) {
        baselineDistance = (lines.length - 1) * lineHeight;
      }
      height += baselineDistance;
      top += baselineDistance * _Text.getVerticalModifier(textBaseline);
      return {
        top: top,
        left: left,
        width: width,
        height: height
      };
    }
  }, {
    key: "textContext",
    get: function get() {
      if (!this._textContext) {
        var canvasElement = _createElement("canvas");
        canvasElement.width = 0;
        canvasElement.height = 0;
        this._textContext = canvasElement.getContext("2d");
      }
      return this._textContext;
    }
  }]);
  return _Text;
}(_Shape6);
_Text.className = "Text";
// The default line spacing for document editors is usually 1.15
_Text.defaultLineHeightRatio = 1.15;
_Text.defaultStyles = Object.assign({}, _Shape6.defaultStyles, {
  textAlign: "start",
  fontStyle: void 0,
  fontWeight: void 0,
  fontSize: 10,
  fontFamily: "sans-serif",
  textBaseline: "alphabetic"
});
_Text.ellipsis = ellipsis;
_Text.punctuationMarks = [".", ",", "-", ":", ";", "!", "?", "'", '"', "(", ")"];
_Text._measureText = memoizeFunction(function (_ref36) {
  var text = _ref36.text,
    font = _ref36.font,
    textBaseline = _ref36.textBaseline,
    textAlign = _ref36.textAlign;
  var ctx = _Text.textContext;
  if (ctx.font !== font) {
    ctx.font = font;
  }
  if (ctx.textBaseline !== textBaseline) {
    ctx.textBaseline = textBaseline;
  }
  if (ctx.textAlign !== textAlign) {
    ctx.textAlign = textAlign;
  }
  return ctx.measureText(text);
});
_Text._getTextSize = memoizeFunction(function (_ref37) {
  var text = _ref37.text,
    font = _ref37.font;
  var ctx = _Text.textContext;
  if (ctx.font !== font) {
    ctx.font = font;
  }
  var metrics = ctx.measureText(text);
  return {
    width: metrics.width,
    height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
  };
});
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Text.prototype, "x", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Text.prototype, "y", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */,
  changeCb: function changeCb(o) {
    return o.onTextChange();
  }
})], _Text.prototype, "text", 2);
__decorateClass([SceneFontChangeDetection()], _Text.prototype, "fontStyle", 2);
__decorateClass([SceneFontChangeDetection()], _Text.prototype, "fontWeight", 2);
__decorateClass([SceneFontChangeDetection()], _Text.prototype, "fontSize", 2);
__decorateClass([SceneFontChangeDetection()], _Text.prototype, "fontFamily", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Text.prototype, "textAlign", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Text.prototype, "textBaseline", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Text.prototype, "lineHeight", 2);
var _Text2 = _Text;
var TextMeasurer = /*#__PURE__*/function () {
  function TextMeasurer(font) {
    _classCallCheck(this, TextMeasurer);
    this.font = _isString(font) ? font : _getFont(font);
  }
  _createClass(TextMeasurer, [{
    key: "size",
    value: function size(text) {
      return text.includes("\n") ? _Text2.getTextSizeMultiline(text.split("\n").map(function (s) {
        return s.trim();
      }), this.font) : _Text2.getTextSize(text, this.font);
    }
  }, {
    key: "width",
    value: function width(text) {
      var _this$size = this.size(text),
        width = _this$size.width;
      return width;
    }
  }]);
  return TextMeasurer;
}();
function _getFont(fontProps) {
  var fontFamily = fontProps.fontFamily,
    fontSize = fontProps.fontSize,
    fontStyle = fontProps.fontStyle,
    fontWeight = fontProps.fontWeight;
  return [fontStyle != null ? fontStyle : "", fontWeight != null ? fontWeight : "", fontSize + "px", fontFamily].join(" ").trim();
}

// packages/ag-charts-community/src/chart/label.ts
var _Label0 = /*#__PURE__*/function (_BaseProperties2) {
  _inherits(Label, _BaseProperties2);
  function Label() {
    var _this30;
    _classCallCheck(this, Label);
    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(Label).apply(this, arguments));
    _this30.enabled = true;
    _this30.fontSize = 12;
    _this30.fontFamily = "Verdana, sans-serif";
    return _this30;
  }
  _createClass(Label, [{
    key: "getFont",
    value: function getFont() {
      return _getFont(this);
    }
  }]);
  return Label;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], _Label0.prototype, "enabled", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _Label0.prototype, "color", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
})], _Label0.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
})], _Label0.prototype, "fontWeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Label0.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING)], _Label0.prototype, "fontFamily", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], _Label0.prototype, "formatter", 2);
function calculateLabelRotation(opts) {
  var _opts$parallelFlipRot = opts.parallelFlipRotation,
    parallelFlipRotation = _opts$parallelFlipRot === void 0 ? 0 : _opts$parallelFlipRot,
    _opts$regularFlipRota = opts.regularFlipRotation,
    regularFlipRotation = _opts$regularFlipRota === void 0 ? 0 : _opts$regularFlipRota;
  var configuredRotation = opts.rotation ? _normalizeAngle2(_toRadians(opts.rotation)) : 0;
  var parallelFlipFlag = !configuredRotation && parallelFlipRotation >= 0 && parallelFlipRotation <= Math.PI ? -1 : 1;
  var regularFlipFlag = !configuredRotation && regularFlipRotation >= 0 && regularFlipRotation <= Math.PI ? -1 : 1;
  var defaultRotation = 0;
  if (opts.parallel) {
    defaultRotation = parallelFlipFlag * Math.PI / 2;
  } else if (regularFlipFlag === -1) {
    defaultRotation = Math.PI;
  }
  return {
    configuredRotation: configuredRotation,
    defaultRotation: defaultRotation,
    parallelFlipFlag: parallelFlipFlag,
    regularFlipFlag: regularFlipFlag
  };
}
function getLabelSpacing(minSpacing, rotated) {
  if (!isNaN(minSpacing)) {
    return minSpacing;
  }
  return rotated ? 0 : 10;
}
function getTextBaseline(parallel, labelRotation, sideFlag, parallelFlipFlag) {
  if (parallel && !labelRotation) {
    return sideFlag * parallelFlipFlag === -1 ? "hanging" : "bottom";
  }
  return "middle";
}
function getTextAlign(parallel, labelRotation, labelAutoRotation, sideFlag, regularFlipFlag) {
  var labelRotated = labelRotation > 0 && labelRotation <= Math.PI;
  var labelAutoRotated = labelAutoRotation > 0 && labelAutoRotation <= Math.PI;
  var alignFlag = labelRotated || labelAutoRotated ? -1 : 1;
  if (parallel) {
    if (labelRotation || labelAutoRotation) {
      if (sideFlag * alignFlag === -1) {
        return "end";
      }
    } else {
      return "center";
    }
  } else if (sideFlag * regularFlipFlag === -1) {
    return "end";
  }
  return "start";
}
function calculateLabelBBox(text, bbox, labelX, labelY, labelMatrix) {
  var width = bbox.width,
    height = bbox.height;
  var translatedBBox = new _BBox2(labelX, labelY, 0, 0);
  labelMatrix.transformBBox(translatedBBox, bbox);
  var x = bbox.x,
    y = bbox.y;
  bbox.width = width;
  bbox.height = height;
  return {
    point: {
      x: x,
      y: y
    },
    label: {
      text: text,
      width: width,
      height: height
    }
  };
}

// packages/ag-charts-community/src/chart/layers.ts
var _Layers = /* @__PURE__ */function (Layers2) {
  Layers2[Layers2["SERIES_BACKGROUND_ZINDEX"] = 0] = "SERIES_BACKGROUND_ZINDEX";
  Layers2[Layers2["AXIS_GRID_ZINDEX"] = 1] = "AXIS_GRID_ZINDEX";
  Layers2[Layers2["AXIS_ZINDEX"] = 2] = "AXIS_ZINDEX";
  Layers2[Layers2["SERIES_CROSSLINE_RANGE_ZINDEX"] = 3] = "SERIES_CROSSLINE_RANGE_ZINDEX";
  Layers2[Layers2["SERIES_LAYER_ZINDEX"] = 4] = "SERIES_LAYER_ZINDEX";
  Layers2[Layers2["SERIES_HIGHLIGHT_ZINDEX"] = 5] = "SERIES_HIGHLIGHT_ZINDEX";
  Layers2[Layers2["AXIS_FOREGROUND_ZINDEX"] = 6] = "AXIS_FOREGROUND_ZINDEX";
  Layers2[Layers2["SERIES_CROSSHAIR_ZINDEX"] = 7] = "SERIES_CROSSHAIR_ZINDEX";
  Layers2[Layers2["SERIES_LABEL_ZINDEX"] = 8] = "SERIES_LABEL_ZINDEX";
  Layers2[Layers2["SERIES_CROSSLINE_LINE_ZINDEX"] = 9] = "SERIES_CROSSLINE_LINE_ZINDEX";
  Layers2[Layers2["SERIES_ANNOTATION_ZINDEX"] = 10] = "SERIES_ANNOTATION_ZINDEX";
  Layers2[Layers2["LEGEND_ZINDEX"] = 11] = "LEGEND_ZINDEX";
  Layers2[Layers2["NAVIGATOR_ZINDEX"] = 12] = "NAVIGATOR_ZINDEX";
  return Layers2;
}(_Layers || {});

// packages/ag-charts-community/src/util/value.ts
function _isStringObject(value) {
  return value != null && Object.hasOwn(value, "toString") && _isString(value.toString());
}
function _isNumberObject(value) {
  return value != null && Object.hasOwn(value, "valueOf") && _isFiniteNumber(value.valueOf());
}
function _isContinuous(value) {
  return _isFiniteNumber(value) || _isValidDate(value) || _isNumberObject(value);
}
function _checkDatum(value, isContinuousScale) {
  return value != null && (!isContinuousScale || _isContinuous(value));
}
function _transformIntegratedCategoryValue(value) {
  if (_isStringObject(value) && Object.hasOwn(value, "id")) {
    return value.id;
  }
  return value;
}

// packages/ag-charts-community/src/chart/crossline/crossLine.ts
var _MATCHING_CROSSLINE_TYPE = function MATCHING_CROSSLINE_TYPE(property) {
  return property === "value" ? _predicateWithMessage(function (_, ctx) {
    return ctx.target["type"] === "line";
  }, function (ctx) {
    return ctx.target["type"] === "range" ? "crossLine type 'range' to have a 'range' property instead of 'value'" : "crossLine property 'type' to be 'line'";
  }) : _predicateWithMessage(function (_, ctx) {
    return ctx.target["type"] === "range";
  }, function (ctx) {
    return ctx.target.type === "line" ? "crossLine type 'line' to have a 'value' property instead of 'range'" : "crossLine property 'type' to be 'range'";
  });
};
var _validateCrossLineValues = function validateCrossLineValues(type, value, range3, scale2) {
  var lineCrossLine = type === "line" && value !== void 0;
  var rangeCrossLine = type === "range" && range3 !== void 0;
  if (!lineCrossLine && !rangeCrossLine) {
    return true;
  }
  var _ref38 = range3 != null ? range3 : [value, void 0],
    _ref39 = _slicedToArray(_ref38, 2),
    start = _ref39[0],
    end = _ref39[1];
  var isContinuous2 = _ContinuousScale5.is(scale2) || _OrdinalTimeScale2.is(scale2);
  var validStart = _checkDatum(start, isContinuous2) && !isNaN(scale2.convert(start));
  var validEnd = _checkDatum(end, isContinuous2) && !isNaN(scale2.convert(end));
  if (lineCrossLine && validStart || rangeCrossLine && validStart && validEnd) {
    return true;
  }
  var message = ["Expecting crossLine"];
  if (rangeCrossLine) {
    if (!validStart) {
      message.push("range start ".concat(_stringify(start)));
    }
    if (!validEnd) {
      message.push("".concat(validStart ? "" : "and ", "range end ").concat(_stringify(end)));
    }
  } else {
    message.push("value ".concat(_stringify(start)));
  }
  message.push("to match the axis scale domain.");
  _Logger.warnOnce(message.join(" "));
  return false;
};

// packages/ag-charts-community/src/chart/crossline/crossLineLabelPosition.ts
var horizontalCrosslineTranslationDirections = {
  top: {
    xTranslationDirection: 0,
    yTranslationDirection: -1
  },
  bottom: {
    xTranslationDirection: 0,
    yTranslationDirection: 1
  },
  left: {
    xTranslationDirection: -1,
    yTranslationDirection: 0
  },
  right: {
    xTranslationDirection: 1,
    yTranslationDirection: 0
  },
  topLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: -1
  },
  topRight: {
    xTranslationDirection: -1,
    yTranslationDirection: -1
  },
  bottomLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: 1
  },
  bottomRight: {
    xTranslationDirection: -1,
    yTranslationDirection: 1
  },
  inside: {
    xTranslationDirection: 0,
    yTranslationDirection: 0
  },
  insideLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: 0
  },
  insideRight: {
    xTranslationDirection: -1,
    yTranslationDirection: 0
  },
  insideTop: {
    xTranslationDirection: 0,
    yTranslationDirection: 1
  },
  insideBottom: {
    xTranslationDirection: 0,
    yTranslationDirection: -1
  },
  insideTopLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: 1
  },
  insideBottomLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: -1
  },
  insideTopRight: {
    xTranslationDirection: -1,
    yTranslationDirection: 1
  },
  insideBottomRight: {
    xTranslationDirection: -1,
    yTranslationDirection: -1
  }
};
var verticalCrossLineTranslationDirections = {
  top: {
    xTranslationDirection: 1,
    yTranslationDirection: 0
  },
  bottom: {
    xTranslationDirection: -1,
    yTranslationDirection: 0
  },
  left: {
    xTranslationDirection: 0,
    yTranslationDirection: -1
  },
  right: {
    xTranslationDirection: 0,
    yTranslationDirection: 1
  },
  topLeft: {
    xTranslationDirection: -1,
    yTranslationDirection: -1
  },
  topRight: {
    xTranslationDirection: -1,
    yTranslationDirection: 1
  },
  bottomLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: -1
  },
  bottomRight: {
    xTranslationDirection: 1,
    yTranslationDirection: 1
  },
  inside: {
    xTranslationDirection: 0,
    yTranslationDirection: 0
  },
  insideLeft: {
    xTranslationDirection: 0,
    yTranslationDirection: 1
  },
  insideRight: {
    xTranslationDirection: 0,
    yTranslationDirection: -1
  },
  insideTop: {
    xTranslationDirection: -1,
    yTranslationDirection: 0
  },
  insideBottom: {
    xTranslationDirection: 1,
    yTranslationDirection: 0
  },
  insideTopLeft: {
    xTranslationDirection: -1,
    yTranslationDirection: 1
  },
  insideBottomLeft: {
    xTranslationDirection: 1,
    yTranslationDirection: 1
  },
  insideTopRight: {
    xTranslationDirection: -1,
    yTranslationDirection: -1
  },
  insideBottomRight: {
    xTranslationDirection: 1,
    yTranslationDirection: -1
  }
};
function calculateLabelTranslation(_ref40) {
  var yDirection = _ref40.yDirection,
    _ref40$padding = _ref40.padding,
    padding = _ref40$padding === void 0 ? 0 : _ref40$padding,
    _ref40$position = _ref40.position,
    position = _ref40$position === void 0 ? "top" : _ref40$position,
    bbox = _ref40.bbox;
  var crossLineTranslationDirections = yDirection ? horizontalCrosslineTranslationDirections : verticalCrossLineTranslationDirections;
  var _crossLineTranslation = crossLineTranslationDirections[position],
    xTranslationDirection = _crossLineTranslation.xTranslationDirection,
    yTranslationDirection = _crossLineTranslation.yTranslationDirection;
  var w = yDirection ? bbox.width : bbox.height;
  var h = yDirection ? bbox.height : bbox.width;
  var xTranslation = xTranslationDirection * (padding + w / 2);
  var yTranslation = yTranslationDirection * (padding + h / 2);
  return {
    xTranslation: xTranslation,
    yTranslation: yTranslation
  };
}
function calculateLabelChartPadding(_ref41) {
  var yDirection = _ref41.yDirection,
    bbox = _ref41.bbox,
    _ref41$padding = _ref41.padding,
    padding = _ref41$padding === void 0 ? 0 : _ref41$padding,
    _ref41$position = _ref41.position,
    position = _ref41$position === void 0 ? "top" : _ref41$position;
  var chartPadding = {};
  if (position.startsWith("inside")) return chartPadding;
  if (position === "top" && !yDirection) {
    chartPadding.top = padding + bbox.height;
  } else if (position === "bottom" && !yDirection) {
    chartPadding.bottom = padding + bbox.height;
  } else if (position === "left" && yDirection) {
    chartPadding.left = padding + bbox.width;
  } else if (position === "right" && yDirection) {
    chartPadding.right = padding + bbox.width;
  }
  return chartPadding;
}
var POSITION_TOP_COORDINATES = function POSITION_TOP_COORDINATES(_ref42) {
  var yDirection = _ref42.yDirection,
    xEnd = _ref42.xEnd,
    yStart = _ref42.yStart,
    yEnd = _ref42.yEnd;
  if (yDirection) {
    return {
      x: xEnd / 2,
      y: yStart
    };
  } else {
    return {
      x: xEnd,
      y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
  }
};
var POSITION_LEFT_COORDINATES = function POSITION_LEFT_COORDINATES(_ref43) {
  var yDirection = _ref43.yDirection,
    xStart = _ref43.xStart,
    xEnd = _ref43.xEnd,
    yStart = _ref43.yStart,
    yEnd = _ref43.yEnd;
  if (yDirection) {
    return {
      x: xStart,
      y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
  } else {
    return {
      x: xEnd / 2,
      y: yStart
    };
  }
};
var POSITION_RIGHT_COORDINATES = function POSITION_RIGHT_COORDINATES(_ref44) {
  var yDirection = _ref44.yDirection,
    xEnd = _ref44.xEnd,
    yStart = _ref44.yStart,
    yEnd = _ref44.yEnd;
  if (yDirection) {
    return {
      x: xEnd,
      y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
  } else {
    return {
      x: xEnd / 2,
      y: isNaN(yEnd) ? yStart : yEnd
    };
  }
};
var POSITION_BOTTOM_COORDINATES = function POSITION_BOTTOM_COORDINATES(_ref45) {
  var yDirection = _ref45.yDirection,
    xStart = _ref45.xStart,
    xEnd = _ref45.xEnd,
    yStart = _ref45.yStart,
    yEnd = _ref45.yEnd;
  if (yDirection) {
    return {
      x: xEnd / 2,
      y: isNaN(yEnd) ? yStart : yEnd
    };
  } else {
    return {
      x: xStart,
      y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
  }
};
var POSITION_INSIDE_COORDINATES = function POSITION_INSIDE_COORDINATES(_ref46) {
  var xEnd = _ref46.xEnd,
    yStart = _ref46.yStart,
    yEnd = _ref46.yEnd;
  return {
    x: xEnd / 2,
    y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
  };
};
var POSITION_TOP_LEFT_COORDINATES = function POSITION_TOP_LEFT_COORDINATES(_ref47) {
  var yDirection = _ref47.yDirection,
    xStart = _ref47.xStart,
    xEnd = _ref47.xEnd,
    yStart = _ref47.yStart;
  if (yDirection) {
    return {
      x: xStart / 2,
      y: yStart
    };
  } else {
    return {
      x: xEnd,
      y: yStart
    };
  }
};
var POSITION_BOTTOM_LEFT_COORDINATES = function POSITION_BOTTOM_LEFT_COORDINATES(_ref48) {
  var yDirection = _ref48.yDirection,
    xStart = _ref48.xStart,
    yStart = _ref48.yStart,
    yEnd = _ref48.yEnd;
  if (yDirection) {
    return {
      x: xStart,
      y: isNaN(yEnd) ? yStart : yEnd
    };
  } else {
    return {
      x: xStart,
      y: yStart
    };
  }
};
var POSITION_TOP_RIGHT_COORDINATES = function POSITION_TOP_RIGHT_COORDINATES(_ref49) {
  var yDirection = _ref49.yDirection,
    xEnd = _ref49.xEnd,
    yStart = _ref49.yStart,
    yEnd = _ref49.yEnd;
  if (yDirection) {
    return {
      x: xEnd,
      y: yStart
    };
  } else {
    return {
      x: xEnd,
      y: isNaN(yEnd) ? yStart : yEnd
    };
  }
};
var POSITION_BOTTOM_RIGHT_COORDINATES = function POSITION_BOTTOM_RIGHT_COORDINATES(_ref50) {
  var yDirection = _ref50.yDirection,
    xStart = _ref50.xStart,
    xEnd = _ref50.xEnd,
    yStart = _ref50.yStart,
    yEnd = _ref50.yEnd;
  if (yDirection) {
    return {
      x: xEnd,
      y: isNaN(yEnd) ? yStart : yEnd
    };
  } else {
    return {
      x: xStart,
      y: isNaN(yEnd) ? yStart : yEnd
    };
  }
};
var labelDirectionHandling = {
  top: {
    c: POSITION_TOP_COORDINATES
  },
  bottom: {
    c: POSITION_BOTTOM_COORDINATES
  },
  left: {
    c: POSITION_LEFT_COORDINATES
  },
  right: {
    c: POSITION_RIGHT_COORDINATES
  },
  topLeft: {
    c: POSITION_TOP_LEFT_COORDINATES
  },
  topRight: {
    c: POSITION_TOP_RIGHT_COORDINATES
  },
  bottomLeft: {
    c: POSITION_BOTTOM_LEFT_COORDINATES
  },
  bottomRight: {
    c: POSITION_BOTTOM_RIGHT_COORDINATES
  },
  inside: {
    c: POSITION_INSIDE_COORDINATES
  },
  insideLeft: {
    c: POSITION_LEFT_COORDINATES
  },
  insideRight: {
    c: POSITION_RIGHT_COORDINATES
  },
  insideTop: {
    c: POSITION_TOP_COORDINATES
  },
  insideBottom: {
    c: POSITION_BOTTOM_COORDINATES
  },
  insideTopLeft: {
    c: POSITION_TOP_LEFT_COORDINATES
  },
  insideBottomLeft: {
    c: POSITION_BOTTOM_LEFT_COORDINATES
  },
  insideTopRight: {
    c: POSITION_TOP_RIGHT_COORDINATES
  },
  insideBottomRight: {
    c: POSITION_BOTTOM_RIGHT_COORDINATES
  }
};

// packages/ag-charts-community/src/chart/crossline/cartesianCrossLine.ts
var CROSSLINE_LABEL_POSITION = _UNION(["top", "left", "right", "bottom", "topLeft", "topRight", "bottomLeft", "bottomRight", "inside", "insideLeft", "insideRight", "insideTop", "insideBottom", "insideTopLeft", "insideBottomLeft", "insideTopRight", "insideBottomRight"], "crossLine label position");
var CartesianCrossLineLabel = function CartesianCrossLineLabel() {
  _classCallCheck(this, CartesianCrossLineLabel);
  this.enabled = void 0;
  this.text = void 0;
  this.fontStyle = void 0;
  this.fontWeight = void 0;
  this.fontSize = 14;
  this.fontFamily = "Verdana, sans-serif";
  this.padding = 5;
  this.color = "rgba(87, 87, 87, 1)";
  this.position = void 0;
  this.rotation = void 0;
  this.parallel = void 0;
};
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], CartesianCrossLineLabel.prototype, "enabled", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], CartesianCrossLineLabel.prototype, "text", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
})], CartesianCrossLineLabel.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
})], CartesianCrossLineLabel.prototype, "fontWeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], CartesianCrossLineLabel.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING)], CartesianCrossLineLabel.prototype, "fontFamily", 2);
__decorateClass([_Validate(_NUMBER)], CartesianCrossLineLabel.prototype, "padding", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], CartesianCrossLineLabel.prototype, "color", 2);
__decorateClass([_Validate(CROSSLINE_LABEL_POSITION, {
  optional: true
})], CartesianCrossLineLabel.prototype, "position", 2);
__decorateClass([_Validate(_DEGREE, {
  optional: true
})], CartesianCrossLineLabel.prototype, "rotation", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], CartesianCrossLineLabel.prototype, "parallel", 2);
var _CartesianCrossLine = /*#__PURE__*/function () {
  function _CartesianCrossLine() {
    _classCallCheck(this, _CartesianCrossLine);
    this.id = _createId(this);
    this.enabled = void 0;
    this.type = void 0;
    this.range = void 0;
    this.value = void 0;
    this.fill = void 0;
    this.fillOpacity = void 0;
    this.stroke = void 0;
    this.strokeWidth = void 0;
    this.strokeOpacity = void 0;
    this.lineDash = void 0;
    this.label = new CartesianCrossLineLabel();
    this.scale = void 0;
    this.clippedRange = [-Infinity, Infinity];
    this.gridLength = 0;
    this.sideFlag = -1;
    this.parallelFlipRotation = 0;
    this.regularFlipRotation = 0;
    this.direction = "x" /* X */;
    this.group = new _Group4({
      name: "".concat(this.id),
      layer: true,
      zIndex: _CartesianCrossLine.LINE_LAYER_ZINDEX
    });
    this.labelGroup = new _Group4({
      name: "".concat(this.id),
      layer: true,
      zIndex: _CartesianCrossLine.LABEL_LAYER_ZINDEX
    });
    this.crossLineRange = new Range();
    this.crossLineLabel = new _Text2();
    this.labelPoint = void 0;
    this.data = [];
    this.startLine = false;
    this.endLine = false;
    this.isRange = false;
    var group2 = this.group,
      labelGroup = this.labelGroup,
      crossLineRange = this.crossLineRange,
      crossLineLabel = this.crossLineLabel;
    group2.append(crossLineRange);
    labelGroup.append(crossLineLabel);
    crossLineRange.pointerEvents = 1 /* None */;
  }
  _createClass(_CartesianCrossLine, [{
    key: "update",
    value: function update(visible) {
      var enabled = this.enabled,
        data = this.data,
        type = this.type,
        value = this.value,
        range3 = this.range,
        scale2 = this.scale;
      if (!type || !scale2 || !enabled || !visible || !_validateCrossLineValues(type, value, range3, scale2) || data.length === 0) {
        this.group.visible = false;
        this.labelGroup.visible = false;
        return;
      }
      this.group.visible = visible;
      this.labelGroup.visible = visible;
      this.group.zIndex = this.getZIndex(this.isRange);
      this.updateNodes();
    }
  }, {
    key: "calculateLayout",
    value: function calculateLayout(visible, reversedAxis) {
      if (!visible) {
        return;
      }
      var dataCreated = this.createNodeData(reversedAxis);
      if (!dataCreated) {
        return;
      }
      var sideFlag = this.sideFlag,
        gridLength = this.gridLength,
        data = this.data;
      var boxes = [];
      var x1 = 0;
      var x2 = sideFlag * gridLength;
      var y1 = data[0];
      var y2 = data[1];
      var crossLineBox = new _BBox2(Math.min(x1, x2), Math.min(y1, y2), Math.abs(x1 - x2), Math.abs(y1 - y2));
      boxes.push(crossLineBox);
      var labelBox = this.computeLabelBBox();
      if (labelBox) {
        boxes.push(labelBox);
      }
      return _BBox2.merge(boxes);
    }
  }, {
    key: "updateNodes",
    value: function updateNodes() {
      this.updateRangeNode();
      if (this.label.enabled) {
        this.updateLabel();
        this.positionLabel();
      }
    }
  }, {
    key: "createNodeData",
    value: function createNodeData(reversedAxis) {
      var _a, _b, _c;
      var scale2 = this.scale,
        gridLength = this.gridLength,
        sideFlag = this.sideFlag,
        direction = this.direction,
        _this$label$position = this.label.position,
        position = _this$label$position === void 0 ? "top" : _this$label$position,
        clippedRange = this.clippedRange,
        _this$strokeWidth = this.strokeWidth,
        strokeWidth = _this$strokeWidth === void 0 ? 0 : _this$strokeWidth;
      this.data = [];
      if (!scale2) {
        return false;
      }
      var bandwidth = (_a = scale2.bandwidth) != null ? _a : 0;
      var step = (_b = scale2.step) != null ? _b : 0;
      var padding = (reversedAxis ? -1 : 1) * (scale2 instanceof _BandScale3 ? (step - bandwidth) / 2 : 0);
      var xStart = 0,
        xEnd = sideFlag * gridLength;
      var _this$getRange = this.getRange(),
        _this$getRange2 = _slicedToArray(_this$getRange, 2),
        yStart = _this$getRange2[0],
        yEnd = _this$getRange2[1];
      var ordinalTimeScalePadding = yEnd === void 0 && _OrdinalTimeScale2.is(scale2) ? bandwidth / 2 + padding : 0;
      var clampedYStart = Number(scale2.convert(yStart, {
          clampMode: "clamped"
        })) - padding + ordinalTimeScalePadding,
        clampedYEnd = scale2.convert(yEnd, {
          clampMode: "clamped"
        }) + bandwidth + padding;
      clampedYStart = _clampArray(clampedYStart, clippedRange);
      clampedYEnd = _clampArray(clampedYEnd, clippedRange);
      var _ref51 = [Number(scale2.convert(yStart)) + ordinalTimeScalePadding, scale2.convert(yEnd) + bandwidth];
      yStart = _ref51[0];
      yEnd = _ref51[1];
      var validRange = (yStart === clampedYStart || yEnd === clampedYEnd || clampedYStart !== clampedYEnd) && Math.abs(clampedYEnd - clampedYStart) > 0;
      if (validRange && clampedYStart > clampedYEnd) {
        var _ref52 = [clampedYEnd, clampedYStart];
        clampedYStart = _ref52[0];
        clampedYEnd = _ref52[1];
        var _ref53 = [yEnd, yStart];
        yStart = _ref53[0];
        yEnd = _ref53[1];
      }
      if (yStart - padding >= clampedYStart) yStart -= padding;
      if (yEnd + padding <= clampedYEnd) yEnd += padding;
      this.isRange = validRange;
      this.startLine = strokeWidth > 0 && yStart >= clampedYStart && yStart <= clampedYStart + padding;
      this.endLine = strokeWidth > 0 && yEnd >= clampedYEnd - bandwidth - padding && yEnd <= clampedYEnd;
      if (!validRange && !this.startLine && !this.endLine) {
        return false;
      }
      this.data = [clampedYStart, clampedYEnd];
      if (this.label.enabled) {
        var yDirection = direction === "y" /* Y */;
        var _ref54 = (_c = labelDirectionHandling[position]) != null ? _c : {},
          _ref54$c = _ref54.c,
          c = _ref54$c === void 0 ? POSITION_TOP_COORDINATES : _ref54$c;
        var _c3 = c({
            yDirection: yDirection,
            xStart: xStart,
            xEnd: xEnd,
            yStart: clampedYStart,
            yEnd: clampedYEnd
          }),
          labelX = _c3.x,
          labelY = _c3.y;
        this.labelPoint = {
          x: labelX,
          y: labelY
        };
      }
      return true;
    }
  }, {
    key: "updateRangeNode",
    value: function updateRangeNode() {
      var _a;
      var crossLineRange = this.crossLineRange,
        sideFlag = this.sideFlag,
        gridLength = this.gridLength,
        data = this.data,
        startLine = this.startLine,
        endLine = this.endLine,
        isRange = this.isRange,
        fill = this.fill,
        fillOpacity = this.fillOpacity,
        stroke = this.stroke,
        strokeWidth = this.strokeWidth,
        lineDash = this.lineDash;
      crossLineRange.x1 = 0;
      crossLineRange.x2 = sideFlag * gridLength;
      crossLineRange.y1 = data[0];
      crossLineRange.y2 = data[1];
      crossLineRange.startLine = startLine;
      crossLineRange.endLine = endLine;
      crossLineRange.isRange = isRange;
      crossLineRange.fill = fill;
      crossLineRange.fillOpacity = fillOpacity != null ? fillOpacity : 1;
      crossLineRange.stroke = stroke;
      crossLineRange.strokeWidth = strokeWidth != null ? strokeWidth : 1;
      crossLineRange.strokeOpacity = (_a = this.strokeOpacity) != null ? _a : 1;
      crossLineRange.lineDash = lineDash;
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      var crossLineLabel = this.crossLineLabel,
        label = this.label;
      if (!label.text) {
        return;
      }
      crossLineLabel.fontStyle = label.fontStyle;
      crossLineLabel.fontWeight = label.fontWeight;
      crossLineLabel.fontSize = label.fontSize;
      crossLineLabel.fontFamily = label.fontFamily;
      crossLineLabel.fill = label.color;
      crossLineLabel.text = label.text;
    }
  }, {
    key: "positionLabel",
    value: function positionLabel() {
      var crossLineLabel = this.crossLineLabel,
        _this$labelPoint = this.labelPoint,
        _this$labelPoint2 = _this$labelPoint === void 0 ? {} : _this$labelPoint,
        _this$labelPoint2$x = _this$labelPoint2.x,
        x = _this$labelPoint2$x === void 0 ? void 0 : _this$labelPoint2$x,
        _this$labelPoint2$y = _this$labelPoint2.y,
        y = _this$labelPoint2$y === void 0 ? void 0 : _this$labelPoint2$y,
        _this$label = this.label,
        parallel = _this$label.parallel,
        rotation = _this$label.rotation,
        _this$label$position2 = _this$label.position,
        position = _this$label$position2 === void 0 ? "top" : _this$label$position2,
        _this$label$padding = _this$label.padding,
        padding = _this$label$padding === void 0 ? 0 : _this$label$padding,
        direction = this.direction,
        parallelFlipRotation = this.parallelFlipRotation,
        regularFlipRotation = this.regularFlipRotation;
      if (x === void 0 || y === void 0) {
        return;
      }
      var _calculateLabelRotati = calculateLabelRotation({
          rotation: rotation,
          parallel: parallel,
          regularFlipRotation: regularFlipRotation,
          parallelFlipRotation: parallelFlipRotation
        }),
        defaultRotation = _calculateLabelRotati.defaultRotation,
        configuredRotation = _calculateLabelRotati.configuredRotation;
      crossLineLabel.rotation = defaultRotation + configuredRotation;
      crossLineLabel.textBaseline = "middle";
      crossLineLabel.textAlign = "center";
      var bbox = crossLineLabel.computeTransformedBBox();
      if (!bbox) {
        return;
      }
      var yDirection = direction === "y" /* Y */;
      var _calculateLabelTransl = calculateLabelTranslation({
          yDirection: yDirection,
          padding: padding,
          position: position,
          bbox: bbox
        }),
        xTranslation = _calculateLabelTransl.xTranslation,
        yTranslation = _calculateLabelTransl.yTranslation;
      crossLineLabel.translationX = x + xTranslation;
      crossLineLabel.translationY = y + yTranslation;
    }
  }, {
    key: "getZIndex",
    value: function getZIndex() {
      var isRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (isRange) {
        return _CartesianCrossLine.RANGE_LAYER_ZINDEX;
      }
      return _CartesianCrossLine.LINE_LAYER_ZINDEX;
    }
  }, {
    key: "getRange",
    value: function getRange() {
      var _a;
      var value = this.value,
        range3 = this.range,
        scale2 = this.scale;
      var isContinuous2 = _ContinuousScale5.is(scale2) || _OrdinalTimeScale2.is(scale2);
      var start = (_a = range3 == null ? void 0 : range3[0]) != null ? _a : value;
      var end = range3 == null ? void 0 : range3[1];
      if (!isContinuous2 && end === void 0) {
        end = start;
      }
      if (isContinuous2 && start === end) {
        end = void 0;
      }
      return [start, end];
    }
  }, {
    key: "computeLabelBBox",
    value: function computeLabelBBox() {
      var label = this.label;
      if (!label.enabled) {
        return;
      }
      var tempText = new _Text2();
      tempText.fontFamily = label.fontFamily;
      tempText.fontSize = label.fontSize;
      tempText.fontStyle = label.fontStyle;
      tempText.fontWeight = label.fontWeight;
      tempText.text = label.text;
      var _this$labelPoint3 = this.labelPoint,
        _this$labelPoint4 = _this$labelPoint3 === void 0 ? {} : _this$labelPoint3,
        _this$labelPoint4$x = _this$labelPoint4.x,
        x = _this$labelPoint4$x === void 0 ? void 0 : _this$labelPoint4$x,
        _this$labelPoint4$y = _this$labelPoint4.y,
        y = _this$labelPoint4$y === void 0 ? void 0 : _this$labelPoint4$y,
        _this$label2 = this.label,
        parallel = _this$label2.parallel,
        rotation = _this$label2.rotation,
        _this$label2$position = _this$label2.position,
        position = _this$label2$position === void 0 ? "top" : _this$label2$position,
        _this$label2$padding = _this$label2.padding,
        padding = _this$label2$padding === void 0 ? 0 : _this$label2$padding,
        direction = this.direction,
        parallelFlipRotation = this.parallelFlipRotation,
        regularFlipRotation = this.regularFlipRotation;
      if (x === void 0 || y === void 0) {
        return;
      }
      var _calculateLabelRotati2 = calculateLabelRotation({
          rotation: rotation,
          parallel: parallel,
          regularFlipRotation: regularFlipRotation,
          parallelFlipRotation: parallelFlipRotation
        }),
        configuredRotation = _calculateLabelRotati2.configuredRotation;
      tempText.rotation = configuredRotation;
      tempText.textBaseline = "middle";
      tempText.textAlign = "center";
      var bbox = tempText.computeTransformedBBox();
      if (!bbox) {
        return;
      }
      var yDirection = direction === "y" /* Y */;
      var _calculateLabelTransl2 = calculateLabelTranslation({
          yDirection: yDirection,
          padding: padding,
          position: position,
          bbox: bbox
        }),
        xTranslation = _calculateLabelTransl2.xTranslation,
        yTranslation = _calculateLabelTransl2.yTranslation;
      tempText.translationX = x + xTranslation;
      tempText.translationY = y + yTranslation;
      return tempText.computeTransformedBBox();
    }
  }, {
    key: "calculatePadding",
    value: function calculatePadding(padding) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      var isRange = this.isRange,
        startLine = this.startLine,
        endLine = this.endLine,
        direction = this.direction,
        _this$label3 = this.label,
        _this$label3$padding = _this$label3.padding,
        labelPadding = _this$label3$padding === void 0 ? 0 : _this$label3$padding,
        _this$label3$position = _this$label3.position,
        position = _this$label3$position === void 0 ? "top" : _this$label3$position;
      if (!isRange && !startLine && !endLine) {
        return;
      }
      var crossLineLabelBBox = this.computeLabelBBox();
      if ((crossLineLabelBBox == null ? void 0 : crossLineLabelBBox.x) == null || (crossLineLabelBBox == null ? void 0 : crossLineLabelBBox.y) == null) {
        return;
      }
      var chartPadding = calculateLabelChartPadding({
        yDirection: direction === "y" /* Y */,
        padding: labelPadding,
        position: position,
        bbox: crossLineLabelBBox
      });
      padding.left = Math.max((_a = padding.left) != null ? _a : 0, (_b = chartPadding.left) != null ? _b : 0);
      padding.right = Math.max((_c = padding.right) != null ? _c : 0, (_d = chartPadding.right) != null ? _d : 0);
      padding.top = Math.max((_e = padding.top) != null ? _e : 0, (_f = chartPadding.top) != null ? _f : 0);
      padding.bottom = Math.max((_g = padding.bottom) != null ? _g : 0, (_h = chartPadding.bottom) != null ? _h : 0);
    }
  }]);
  return _CartesianCrossLine;
}();
_CartesianCrossLine.LINE_LAYER_ZINDEX = 9 /* SERIES_CROSSLINE_LINE_ZINDEX */;
_CartesianCrossLine.RANGE_LAYER_ZINDEX = 3 /* SERIES_CROSSLINE_RANGE_ZINDEX */;
_CartesianCrossLine.LABEL_LAYER_ZINDEX = 8 /* SERIES_LABEL_ZINDEX */;
_CartesianCrossLine.className = "CrossLine";
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], _CartesianCrossLine.prototype, "enabled", 2);
__decorateClass([_Validate(_UNION(["range", "line"], "a crossLine type"), {
  optional: true
})], _CartesianCrossLine.prototype, "type", 2);
__decorateClass([_Validate(_AND(_MATCHING_CROSSLINE_TYPE("range"), _ARRAY.restrict({
  length: 2
})), {
  optional: true
})], _CartesianCrossLine.prototype, "range", 2);
__decorateClass([_Validate(_MATCHING_CROSSLINE_TYPE("value"), {
  optional: true
})], _CartesianCrossLine.prototype, "value", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _CartesianCrossLine.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], _CartesianCrossLine.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _CartesianCrossLine.prototype, "stroke", 2);
__decorateClass([_Validate(_NUMBER, {
  optional: true
})], _CartesianCrossLine.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], _CartesianCrossLine.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH, {
  optional: true
})], _CartesianCrossLine.prototype, "lineDash", 2);
var CartesianCrossLine = _CartesianCrossLine;

// packages/ag-charts-community/src/module/moduleMap.ts
var ModuleMap = /*#__PURE__*/function () {
  function ModuleMap() {
    _classCallCheck(this, ModuleMap);
    this.moduleMap = /* @__PURE__ */new Map();
  }
  _createClass(ModuleMap, [{
    key: "modules",
    value: /*#__PURE__*/_regenerator().m(function modules() {
      var _iterator63, _step63, m, _t5;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            _iterator63 = _createForOfIteratorHelper(this.moduleMap.values());
            _context7.p = 1;
            _iterator63.s();
          case 2:
            if ((_step63 = _iterator63.n()).done) {
              _context7.n = 4;
              break;
            }
            m = _step63.value;
            _context7.n = 3;
            return m.moduleInstance;
          case 3:
            _context7.n = 2;
            break;
          case 4:
            _context7.n = 6;
            break;
          case 5:
            _context7.p = 5;
            _t5 = _context7.v;
            _iterator63.e(_t5);
          case 6:
            _context7.p = 6;
            _iterator63.f();
            return _context7.f(6);
          case 7:
            return _context7.a(2);
        }
      }, modules, this, [[1, 5, 6, 7]]);
    })
  }, {
    key: "addModule",
    value: function addModule(module, moduleFactory) {
      if (this.moduleMap.has(module.optionsKey)) {
        throw new Error("AG Charts - module already initialised: ".concat(module.optionsKey));
      }
      this.moduleMap.set(module.optionsKey, {
        module: module,
        moduleInstance: moduleFactory(module)
      });
    }
  }, {
    key: "removeModule",
    value: function removeModule(module) {
      var _a;
      var moduleKey = _isString(module) ? module : module.optionsKey;
      (_a = this.moduleMap.get(moduleKey)) == null ? void 0 : _a.moduleInstance.destroy();
      this.moduleMap.delete(moduleKey);
    }
  }, {
    key: "getModule",
    value: function getModule(module) {
      var _a;
      return (_a = this.moduleMap.get(_isString(module) ? module : module.optionsKey)) == null ? void 0 : _a.moduleInstance;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(module) {
      return this.moduleMap.has(_isString(module) ? module : module.optionsKey);
    }
  }, {
    key: "mapModules",
    value: function mapModules(callback) {
      return Array.from(this.moduleMap.values(), function (m, i) {
        return callback(m.moduleInstance, i);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;
      var _iterator64 = _createForOfIteratorHelper(this.moduleMap.keys()),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var moduleKey = _step64.value;
          (_a = this.moduleMap.get(moduleKey)) == null ? void 0 : _a.moduleInstance.destroy();
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      this.moduleMap.clear();
    }
  }]);
  return ModuleMap;
}();

// packages/ag-charts-community/src/motion/resetMotion.ts
var resetMotion_exports = {};
__export(resetMotion_exports, {
  resetMotion: function resetMotion() {
    return _resetMotion;
  }
});
function _resetMotion(selectionsOrNodes, propsFn) {
  var _deconstructSelection3 = _deconstructSelectionsOrNodes(selectionsOrNodes),
    nodes = _deconstructSelection3.nodes,
    selections = _deconstructSelection3.selections;
  var _iterator65 = _createForOfIteratorHelper(selections),
    _step65;
  try {
    for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
      var selection = _step65.value;
      var _iterator67 = _createForOfIteratorHelper(selection.nodes()),
        _step67;
      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var node = _step67.value;
          var from = propsFn(node, node.datum);
          node.setProperties(from);
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
      selection.cleanup();
    }
  } catch (err) {
    _iterator65.e(err);
  } finally {
    _iterator65.f();
  }
  var _iterator66 = _createForOfIteratorHelper(nodes),
    _step66;
  try {
    for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
      var _node5 = _step66.value;
      var _from = propsFn(_node5, _node5.datum);
      _node5.setProperties(_from);
    }
  } catch (err) {
    _iterator66.e(err);
  } finally {
    _iterator66.f();
  }
}

// packages/ag-charts-community/src/motion/states.ts
var _StateMachine = /*#__PURE__*/function () {
  function StateMachine(initialState, states, preTransitionCb) {
    _classCallCheck(this, StateMachine);
    this.states = states;
    this.preTransitionCb = preTransitionCb;
    this.debug = Debug.create(true, "animation");
    this.state = initialState;
    this.debug("%c".concat(this.constructor.name, " | init -> ").concat(initialState), "color: green");
  }
  _createClass(StateMachine, [{
    key: "transition",
    value: function transition(event, data) {
      var _a, _b;
      var currentStateConfig = this.states[this.state];
      var destinationTransition = currentStateConfig == null ? void 0 : currentStateConfig[event];
      if (!destinationTransition) {
        this.debug("%c".concat(this.constructor.name, " | ").concat(this.state, " -> ").concat(event, " -> ").concat(this.state), "color: grey");
        return;
      }
      var destinationState = this.state;
      if (typeof destinationTransition === "string") {
        destinationState = destinationTransition;
      } else if (typeof destinationTransition === "object") {
        destinationState = destinationTransition.target;
      }
      this.debug("%c".concat(this.constructor.name, " | ").concat(this.state, " -> ").concat(event, " -> ").concat(destinationState), "color: green");
      (_a = this.preTransitionCb) == null ? void 0 : _a.call(this, this.state, destinationState);
      this.state = destinationState;
      if (typeof destinationTransition === "function") {
        destinationTransition(data);
      } else if (typeof destinationTransition === "object") {
        (_b = destinationTransition.action) == null ? void 0 : _b.call(destinationTransition, data);
      }
      return this.state;
    }
  }]);
  return StateMachine;
}();

// packages/ag-charts-community/src/util/numberFormat.ts
var group = function group(content) {
  return "(".concat(content, ")");
};
var optionalGroup = function optionalGroup(content) {
  return "".concat(group(content), "?");
};
var nonCapturingGroup = function nonCapturingGroup(content) {
  return optionalGroup("?:".concat(content));
};
var formatRegEx = function () {
  var fill = ".";
  var align = "[<>=^]";
  var sign = "[+\\-( ]";
  var symbol = "[$\u20AC\xA3\xA5\u20A3\u20B9#]";
  var zero = "0";
  var width = "\\d+";
  var comma = ",";
  var precision = "\\d+";
  var tilde = "~";
  var type = "[%a-z]";
  return new RegExp(["^", nonCapturingGroup("".concat(optionalGroup(fill)).concat(group(align))), optionalGroup(sign), optionalGroup(symbol), optionalGroup(zero), optionalGroup(width), optionalGroup(comma), nonCapturingGroup("\\.".concat(group(precision))), optionalGroup(tilde), optionalGroup(type), "$"].join(""), "i");
}();
var surroundedRegEx = function () {
  var prefix = ".*?";
  var content = ".+?";
  var suffix = ".*?";
  return new RegExp(["^", group(prefix), "#\\{".concat(group(content), "\\}"), group(suffix), "$"].join(""));
}();
function parseFormatter(formatter) {
  var prefix;
  var suffix;
  var surrounded = surroundedRegEx.exec(formatter);
  if (surrounded) {
    var _surrounded = _slicedToArray(surrounded, 4);
    prefix = _surrounded[1];
    formatter = _surrounded[2];
    suffix = _surrounded[3];
  }
  var match = formatRegEx.exec(formatter);
  if (!match) {
    throw new Error("The number formatter is invalid: ".concat(formatter));
  }
  var _match2 = _slicedToArray(match, 11),
    fill = _match2[1],
    align = _match2[2],
    sign = _match2[3],
    symbol = _match2[4],
    zero = _match2[5],
    width = _match2[6],
    comma = _match2[7],
    precision = _match2[8],
    trim = _match2[9],
    type = _match2[10];
  return {
    fill: fill,
    align: align,
    sign: sign,
    symbol: symbol,
    zero: zero,
    width: parseInt(width),
    comma: comma,
    precision: parseInt(precision),
    trim: Boolean(trim),
    type: type,
    prefix: prefix,
    suffix: suffix
  };
}
function format(formatter) {
  var options = typeof formatter === "string" ? parseFormatter(formatter) : formatter;
  var fill = options.fill,
    align = options.align,
    _options$sign = options.sign,
    sign = _options$sign === void 0 ? "-" : _options$sign,
    symbol = options.symbol,
    zero = options.zero,
    width = options.width,
    comma = options.comma,
    type = options.type,
    _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? "" : _options$prefix,
    _options$suffix = options.suffix,
    suffix = _options$suffix === void 0 ? "" : _options$suffix,
    precision = options.precision;
  var trim = options.trim;
  var precisionIsNaN = precision === void 0 || isNaN(precision);
  var formatBody;
  if (!type) {
    formatBody = decimalTypes["g"];
    trim = true;
  } else if (type in decimalTypes && type in integerTypes) {
    formatBody = precisionIsNaN ? integerTypes[type] : decimalTypes[type];
  } else if (type in decimalTypes) {
    formatBody = decimalTypes[type];
  } else if (type in integerTypes) {
    formatBody = integerTypes[type];
  } else {
    throw new Error("The number formatter type is invalid: ".concat(type));
  }
  var formatterPrecision;
  if (precision == null || precisionIsNaN) {
    formatterPrecision = type ? 6 : 12;
  } else {
    formatterPrecision = precision;
  }
  return function (n) {
    var result = formatBody(n, formatterPrecision);
    if (trim) {
      result = removeTrailingZeros(result);
    }
    if (comma) {
      result = insertSeparator(result, comma);
    }
    result = addSign(n, result, sign);
    if (symbol && symbol !== "#") {
      result = "".concat(symbol).concat(result);
    }
    if (symbol === "#" && type === "x") {
      result = "0x".concat(result);
    }
    if (type === "s") {
      result = "".concat(result).concat(getSIPrefix(n));
    }
    if (type === "%" || type === "p") {
      result = "".concat(result, "%");
    }
    if (width != null && !isNaN(width)) {
      result = addPadding(result, width, fill != null ? fill : zero, align);
    }
    result = "".concat(prefix).concat(result).concat(suffix);
    return result;
  };
}
var absFloor = function absFloor(n) {
  return Math.floor(Math.abs(n));
};
var integerTypes = {
  b: function b(n) {
    return absFloor(n).toString(2);
  },
  c: function c(n) {
    return String.fromCharCode(n);
  },
  d: function d(n) {
    return Math.round(Math.abs(n)).toFixed(0);
  },
  o: function o(n) {
    return absFloor(n).toString(8);
  },
  x: function x(n) {
    return absFloor(n).toString(16);
  },
  X: function X(n) {
    return integerTypes.x(n).toUpperCase();
  },
  n: function n(_n) {
    return integerTypes.d(_n);
  },
  "%": function _(n) {
    return "".concat(absFloor(n * 100).toFixed(0));
  }
};
var decimalTypes = {
  e: function e(n, f) {
    return Math.abs(n).toExponential(f);
  },
  E: function E(n, f) {
    return decimalTypes.e(n, f).toUpperCase();
  },
  f: function f(n, _f2) {
    return Math.abs(n).toFixed(_f2);
  },
  F: function F(n, f) {
    return decimalTypes.f(n, f).toUpperCase();
  },
  g: function g(n, f) {
    if (n === 0) {
      return "0";
    }
    var a = Math.abs(n);
    var p = Math.floor(Math.log10(a));
    if (p >= -4 && p < f) {
      return a.toFixed(f - 1 - p);
    }
    return a.toExponential(f - 1);
  },
  G: function G(n, f) {
    return decimalTypes.g(n, f).toUpperCase();
  },
  n: function n(_n2, f) {
    return decimalTypes.g(_n2, f);
  },
  p: function p(n, f) {
    return decimalTypes.r(n * 100, f);
  },
  r: function r(n, f) {
    if (n === 0) {
      return "0";
    }
    var a = Math.abs(n);
    var p = Math.floor(Math.log10(a));
    var q = p - (f - 1);
    if (q <= 0) {
      return a.toFixed(-q);
    }
    var x = Math.pow(10, q);
    return (Math.round(a / x) * x).toFixed();
  },
  s: function s(n, f) {
    var p = getSIPrefixPower(n);
    return decimalTypes.r(n / Math.pow(10, p), f);
  },
  "%": function _(n, f) {
    return decimalTypes.f(n * 100, f);
  }
};
function removeTrailingZeros(numString) {
  return numString.replace(/\.0+$/, "").replace(/(\.[1-9])0+$/, "$1");
}
function insertSeparator(numString, separator) {
  var dotIndex = numString.indexOf(".");
  if (dotIndex < 0) {
    dotIndex = numString.length;
  }
  var integerChars = numString.substring(0, dotIndex).split("");
  var fractionalPart = numString.substring(dotIndex);
  for (var i = integerChars.length - 3; i > 0; i -= 3) {
    integerChars.splice(i, 0, separator);
  }
  return "".concat(integerChars.join("")).concat(fractionalPart);
}
function getSIPrefix(n) {
  return siPrefixes[getSIPrefixPower(n)];
}
function getSIPrefixPower(n) {
  return _clamp(minSIPrefix, n ? Math.floor(Math.log10(Math.abs(n)) / 3) * 3 : 0, maxSIPrefix);
}
var minSIPrefix = -24;
var maxSIPrefix = 24;
var siPrefixes = (_siPrefixes = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_siPrefixes, minSIPrefix, "y"), -21, "z"), -18, "a"), -15, "f"), -12, "p"), -9, "n"), -6, "\xB5"), -3, "m"), 0, ""), 3, "k"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_siPrefixes, 6, "M"), 9, "G"), 12, "T"), 15, "P"), 18, "E"), 21, "Z"), maxSIPrefix, "Y"));
var minusSign = "\u2212";
function addSign(num, numString) {
  var signType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  if (signType === "(") {
    return num >= 0 ? numString : "(".concat(numString, ")");
  }
  var plusSign = signType === "+" ? "+" : "";
  return "".concat(num >= 0 ? plusSign : minusSign).concat(numString);
}
function addPadding(numString, width) {
  var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : " ";
  var align = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ">";
  var result = numString;
  if (align === ">" || !align) {
    result = result.padStart(width, fill);
  } else if (align === "<") {
    result = result.padEnd(width, fill);
  } else if (align === "^") {
    var padWidth = Math.max(0, width - result.length);
    var padLeft = Math.ceil(padWidth / 2);
    var padRight = Math.floor(padWidth / 2);
    result = result.padStart(padLeft + result.length, fill);
    result = result.padEnd(padRight + result.length, fill);
  }
  return result;
}
function _tickFormat(ticks, formatter) {
  var options = parseFormatter(formatter != null ? formatter : ",f");
  var precision = options.precision;
  if (precision == null || isNaN(precision)) {
    if (options.type === "f" || options.type === "%") {
      options.precision = Math.max.apply(Math, _toConsumableArray(ticks.map(function (x) {
        if (typeof x !== "number" || x === 0) {
          return 0;
        }
        var l = Math.floor(Math.log10(Math.abs(x)));
        var digits = options.type ? 6 : 12;
        var exp = x.toExponential(digits - 1).replace(/\.?0+e/, "e");
        var dotIndex = exp.indexOf(".");
        if (dotIndex < 0) {
          return l >= 0 ? 0 : -l;
        }
        var s = exp.indexOf("e") - dotIndex;
        return Math.max(0, s - l - 1);
      })));
    } else if (!options.type || options.type in decimalTypes) {
      options.precision = Math.max.apply(Math, _toConsumableArray(ticks.map(function (x) {
        if (typeof x !== "number") {
          return 0;
        }
        var exp = x.toExponential((options.type ? 6 : 12) - 1).replace(/\.?0+e/, "e");
        return exp.substring(0, exp.indexOf("e")).replace(".", "").length;
      })));
    }
  }
  var f = format(options);
  return function (n) {
    return f(Number(n));
  };
}

// packages/ag-charts-community/src/scale/logScale.ts
var _LogScale = /*#__PURE__*/function (_ContinuousScale3) {
  _inherits(_LogScale, _ContinuousScale3);
  function _LogScale() {
    var _this31;
    _classCallCheck(this, _LogScale);
    _this31 = _possibleConstructorReturn(this, _getPrototypeOf(_LogScale).call(this, [1, 10], [0, 1]));
    _this31.type = "log";
    _this31.base = 10;
    _this31.baseLog = identity;
    _this31.basePow = identity;
    _this31.log = function (x) {
      var start = Math.min.apply(Math, _toConsumableArray(_this31.domain));
      return start >= 0 ? _this31.baseLog(x) : -_this31.baseLog(-x);
    };
    _this31.pow = function (x) {
      var start = Math.min.apply(Math, _toConsumableArray(_this31.domain));
      return start >= 0 ? _this31.basePow(x) : -_this31.basePow(-x);
    };
    _this31.defaultClampMode = "clamped";
    return _this31;
  }
  _createClass(_LogScale, [{
    key: "toDomain",
    value: function toDomain(d) {
      return d;
    }
  }, {
    key: "transform",
    value: function transform(x) {
      var start = Math.min.apply(Math, _toConsumableArray(this.domain));
      return start >= 0 ? Math.log(x) : -Math.log(-x);
    }
  }, {
    key: "transformInvert",
    value: function transformInvert(x) {
      var start = Math.min.apply(Math, _toConsumableArray(this.domain));
      return start >= 0 ? Math.exp(x) : -Math.exp(-x);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (this.base <= 0) {
        this.base = 0;
        _Logger.warnOnce("expecting a finite Number greater than to 0");
      }
      _superPropGet(_LogScale, "refresh", this, 3)([]);
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.domain || this.domain.length < 2) {
        return;
      }
      this.baseLog = _LogScale.getBaseLogMethod(this.base);
      this.basePow = _LogScale.getBasePowerMethod(this.base);
      if (this.nice) {
        this.updateNiceDomain();
      }
    }
  }, {
    key: "updateNiceDomain",
    value: function updateNiceDomain() {
      var _this$domain2 = _slicedToArray(this.domain, 2),
        d0 = _this$domain2[0],
        d1 = _this$domain2[1];
      var roundStart = d0 > d1 ? Math.ceil : Math.floor;
      var roundStop = d0 > d1 ? Math.floor : Math.ceil;
      var n0 = this.pow(roundStart(this.log(d0)));
      var n1 = this.pow(roundStop(this.log(d1)));
      this.niceDomain = [n0, n1];
    }
  }, {
    key: "ticks",
    value: function ticks() {
      var _this32 = this;
      var _a;
      var count = (_a = this.tickCount) != null ? _a : 10;
      if (!this.domain || this.domain.length < 2 || count < 1) {
        return [];
      }
      this.refresh();
      var base = this.base;
      var _this$getDomain = this.getDomain(),
        _this$getDomain2 = _slicedToArray(_this$getDomain, 2),
        d0 = _this$getDomain2[0],
        d1 = _this$getDomain2[1];
      var start = Math.min(d0, d1);
      var stop = Math.max(d0, d1);
      var p0 = this.log(start);
      var p1 = this.log(stop);
      if (this.interval) {
        var step = Math.abs(this.interval);
        var absDiff = Math.abs(p1 - p0);
        var ticks2 = _range4(p0, p1, Math.min(absDiff, step));
        ticks2 = createNumericTicks(ticks2.fractionDigits, ticks2.map(function (x) {
          return _this32.pow(x);
        }).filter(function (t) {
          return t >= start && t <= stop;
        }));
        var availableRange = this.getPixelRange();
        if (!_isDenseInterval({
          start: start,
          stop: stop,
          interval: step,
          count: ticks2.length,
          availableRange: availableRange
        })) {
          return ticks2;
        }
      }
      var isBaseInteger = base % 1 === 0;
      var isDiffLarge = p1 - p0 >= count;
      if (!isBaseInteger || isDiffLarge) {
        var _ticks = ticks_default(p0, p1, Math.min(p1 - p0, count));
        _ticks = createNumericTicks(_ticks.fractionDigits, _ticks.map(function (x) {
          return _this32.pow(x);
        }));
        return _ticks;
      }
      var ticks = [];
      var isPositive = start > 0;
      p0 = Math.floor(p0) - 1;
      p1 = Math.round(p1) + 1;
      var availableSpacing = _findRangeExtent(this.range) / count;
      var lastTickPosition = Infinity;
      for (var p = p0; p <= p1; p++) {
        var nextMagnitudeTickPosition = this.convert(this.pow(p + 1));
        for (var k = 1; k < base; k++) {
          var q = isPositive ? k : base - k + 1;
          var t = this.pow(p) * q;
          var tickPosition = this.convert(t);
          var prevSpacing = Math.abs(lastTickPosition - tickPosition);
          var nextSpacing = Math.abs(tickPosition - nextMagnitudeTickPosition);
          var fits = prevSpacing >= availableSpacing && nextSpacing >= availableSpacing;
          if (t >= start && t <= stop && (k === 1 || fits || ticks.length === 0)) {
            ticks.push(t);
            lastTickPosition = tickPosition;
          }
        }
      }
      return ticks;
    }
  }, {
    key: "tickFormat",
    value: function tickFormat(_ref55) {
      var count = _ref55.count,
        ticks = _ref55.ticks,
        specifier = _ref55.specifier;
      if (count !== Infinity && ticks == null) {
        this.ticks();
      }
      specifier != null ? specifier : specifier = this.base === 10 ? ".0e" : ",";
      return _isString(specifier) ? format(specifier) : specifier;
    }
  }], [{
    key: "getBaseLogMethod",
    value: function getBaseLogMethod(base) {
      switch (base) {
        case 10:
          return Math.log10;
        case Math.E:
          return Math.log;
        case 2:
          return Math.log2;
        default:
          var logBase = Math.log(base);
          return function (x) {
            return Math.log(x) / logBase;
          };
      }
    }
  }, {
    key: "getBasePowerMethod",
    value: function getBasePowerMethod(base) {
      switch (base) {
        case 10:
          return function (x) {
            return x >= 0 ? __pow(10, x) : 1 / __pow(10, -x);
          };
        case Math.E:
          return Math.exp;
        default:
          return function (x) {
            return __pow(base, x);
          };
      }
    }
  }]);
  return _LogScale;
}(_ContinuousScale5);
__decorateClass([_Invalidating], _LogScale.prototype, "base", 2);
var LogScale = _LogScale;

// packages/ag-charts-community/src/scene/selection.ts
var _Selection2 = /*#__PURE__*/function () {
  function _Selection(parentNode, classOrFactory) {
    var autoCleanup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, _Selection);
    this.parentNode = parentNode;
    this.autoCleanup = autoCleanup;
    this.garbageBin = /* @__PURE__ */new Set();
    this._nodesMap = /* @__PURE__ */new Map();
    this._nodes = [];
    this.data = [];
    this.debug = Debug.create(true, "scene", "scene:selections");
    this.nodeFactory = Object.prototype.isPrototypeOf.call(_Node4, classOrFactory) ? function () {
      return new classOrFactory();
    } : classOrFactory;
  }
  _createClass(_Selection, [{
    key: "createNode",
    value: function createNode(datum, initializer, idx) {
      var node = this.nodeFactory(datum);
      node.datum = datum;
      initializer == null ? void 0 : initializer(node);
      if (idx == null) {
        this._nodes.push(node);
      } else {
        this._nodes.splice(idx, 0, node);
      }
      this.parentNode.appendChild(node);
      return node;
    }
    /**
     * Update the data in a selection. If an `getDatumId()` function is provided, maintain a list of ids related to
     * the nodes. Otherwise, take the more efficient route of simply creating and destroying nodes at the end
     * of the array.
     */
  }, {
    key: "update",
    value: function update(data, initializer, getDatumId) {
      if (this.garbageBin.size > 0) {
        this.debug("Selection - update() called with pending garbage: ".concat(data));
      }
      if (getDatumId) {
        var dataMap = new Map(data.map(function (datum, idx) {
          return [getDatumId(datum), [datum, idx]];
        }));
        var _iterator68 = _createForOfIteratorHelper(this._nodesMap.entries()),
          _step68;
        try {
          for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
            var _step68$value = _slicedToArray(_step68.value, 2),
              node = _step68$value[0],
              datumId = _step68$value[1];
            if (dataMap.has(datumId)) {
              var _dataMap$get = dataMap.get(datumId),
                _dataMap$get2 = _slicedToArray(_dataMap$get, 1),
                newDatum = _dataMap$get2[0];
              node.datum = newDatum;
              this.garbageBin.delete(node);
              dataMap.delete(datumId);
            } else {
              this.garbageBin.add(node);
            }
          }
        } catch (err) {
          _iterator68.e(err);
        } finally {
          _iterator68.f();
        }
        var _iterator69 = _createForOfIteratorHelper(dataMap.entries()),
          _step69;
        try {
          for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
            var _step69$value = _slicedToArray(_step69.value, 2),
              _datumId = _step69$value[0],
              _step69$value$ = _slicedToArray(_step69$value[1], 2),
              datum = _step69$value$[0],
              idx = _step69$value$[1];
            this._nodesMap.set(this.createNode(datum, initializer, idx), _datumId);
          }
        } catch (err) {
          _iterator69.e(err);
        } finally {
          _iterator69.f();
        }
      } else {
        var maxLength = Math.max(data.length, this.data.length);
        for (var i = 0; i < maxLength; i++) {
          if (i >= data.length) {
            this.garbageBin.add(this._nodes[i]);
          } else if (i >= this._nodes.length) {
            this.createNode(data[i], initializer);
          } else {
            this._nodes[i].datum = data[i];
            this.garbageBin.delete(this._nodes[i]);
          }
        }
      }
      this.data = data.slice();
      if (this.autoCleanup) {
        this.cleanup();
      }
      return this;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this33 = this;
      if (this.garbageBin.size === 0) {
        return this;
      }
      this._nodes = this._nodes.filter(function (node) {
        if (_this33.garbageBin.has(node)) {
          _this33._nodesMap.delete(node);
          _this33.garbageBin.delete(node);
          _this33.parentNode.removeChild(node);
          return false;
        }
        return true;
      });
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.update([]);
      return this;
    }
  }, {
    key: "isGarbage",
    value: function isGarbage(node) {
      return this.garbageBin.has(node);
    }
  }, {
    key: "hasGarbage",
    value: function hasGarbage() {
      return this.garbageBin.size > 0;
    }
  }, {
    key: "each",
    value: function each(iterate2) {
      var _iterator70 = _createForOfIteratorHelper(this._nodes.entries()),
        _step70;
      try {
        for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
          var entry = _step70.value;
          iterate2(entry[1], entry[1].datum, entry[0]);
        }
      } catch (err) {
        _iterator70.e(err);
      } finally {
        _iterator70.f();
      }
      return this;
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regenerator().m(function value() {
      var index, node, datum;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            index = 0;
          case 1:
            if (!(index < this._nodes.length)) {
              _context8.n = 3;
              break;
            }
            node = this._nodes[index];
            datum = this._nodes[index].datum;
            _context8.n = 2;
            return {
              node: node,
              datum: datum,
              index: index
            };
          case 2:
            index++;
            _context8.n = 1;
            break;
          case 3:
            return _context8.a(2);
        }
      }, value, this);
    })
  }, {
    key: "select",
    value: function select(predicate) {
      return _Selection.selectAll(this.parentNode, predicate);
    }
  }, {
    key: "selectByClass",
    value: function selectByClass(Class) {
      return _Selection.selectByClass(this.parentNode, Class);
    }
  }, {
    key: "selectByTag",
    value: function selectByTag(tag) {
      return _Selection.selectByTag(this.parentNode, tag);
    }
  }, {
    key: "nodes",
    value: function nodes() {
      return this._nodes;
    }
  }], [{
    key: "select",
    value: function select(parent, classOrFactory) {
      var garbageCollection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return new _Selection(parent, classOrFactory, garbageCollection);
    }
  }, {
    key: "selectAll",
    value: function selectAll(parent, predicate) {
      var results = [];
      var _traverse = function traverse(node) {
        if (predicate(node)) {
          results.push(node);
        }
        node.children.forEach(_traverse);
      };
      _traverse(parent);
      return results;
    }
  }, {
    key: "selectByClass",
    value: function selectByClass(node, Class) {
      for (var _len19 = arguments.length, ExtraClasses = new Array(_len19 > 2 ? _len19 - 2 : 0), _key20 = 2; _key20 < _len19; _key20++) {
        ExtraClasses[_key20 - 2] = arguments[_key20];
      }
      return _Selection.selectAll(node, function (n) {
        return n instanceof Class || ExtraClasses.some(function (C) {
          return n instanceof C;
        });
      });
    }
  }, {
    key: "selectByTag",
    value: function selectByTag(node, tag) {
      return _Selection.selectAll(node, function (n) {
        return n.tag === tag;
      });
    }
  }]);
  return _Selection;
}();

// packages/ag-charts-community/src/util/distance.ts
function pointsDistanceSquared(x1, y1, x2, y2) {
  var dx = x1 - x2;
  var dy = y1 - y2;
  return dx * dx + dy * dy;
}
function lineDistanceSquared(x, y, x1, y1, x2, y2, best) {
  if (x1 === x2 && y1 === y2) {
    return Math.min(best, pointsDistanceSquared(x, y, x1, y1));
  }
  var dx = x2 - x1;
  var dy = y2 - y1;
  var t = Math.max(0, Math.min(1, ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy)));
  var ix = x1 + t * dx;
  var iy = y1 + t * dy;
  return Math.min(best, pointsDistanceSquared(x, y, ix, iy));
}
function arcDistanceSquared(x, y, cx, cy, radius, startAngle, endAngle, counterClockwise, best) {
  if (counterClockwise) {
    var _ref56 = [startAngle, endAngle];
    endAngle = _ref56[0];
    startAngle = _ref56[1];
  }
  var angle = Math.atan2(y - cy, x - cx);
  if (!_isBetweenAngles(angle, startAngle, endAngle)) {
    var startX = cx + Math.cos(startAngle) * radius;
    var startY = cy + Math.sin(startAngle) * radius;
    var endX = cx + Math.cos(startAngle) * radius;
    var endY = cy + Math.sin(startAngle) * radius;
    return Math.min(best, pointsDistanceSquared(x, y, startX, startY), pointsDistanceSquared(x, y, endX, endY));
  }
  var distToArc = radius - Math.sqrt(pointsDistanceSquared(x, y, cx, cy));
  return Math.min(best, distToArc * distToArc);
}

// packages/ag-charts-community/src/scene/shape/line.ts
var _Line = /*#__PURE__*/function (_Shape4) {
  _inherits(Line, _Shape4);
  function Line() {
    var _this34;
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Line);
    _this34 = _possibleConstructorReturn(this, _getPrototypeOf(Line).call(this, opts));
    _this34.x1 = 0;
    _this34.y1 = 0;
    _this34.x2 = 0;
    _this34.y2 = 0;
    _this34.restoreOwnStyles();
    return _this34;
  }
  _createClass(Line, [{
    key: "computeBBox",
    value: function computeBBox() {
      return new _BBox2(Math.min(this.x1, this.x2), Math.min(this.y1, this.y2), Math.abs(this.x2 - this.x1), Math.abs(this.y2 - this.y1));
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(px, py) {
      if (this.x1 === this.x2 || this.y1 === this.y2) {
        var _this$transformPoint = this.transformPoint(px, py),
          x = _this$transformPoint.x,
          y = _this$transformPoint.y;
        return this.computeBBox().grow(this.strokeWidth / 2).containsPoint(x, y);
      }
      return false;
    }
  }, {
    key: "distanceSquared",
    value: function distanceSquared(px, py) {
      var x1 = this.x1,
        y1 = this.y1,
        x2 = this.x2,
        y2 = this.y2;
      return lineDistanceSquared(px, py, x1, y1, x2, y2, Infinity);
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      var _a;
      var ctx = renderCtx.ctx,
        forceRender = renderCtx.forceRender,
        stats = renderCtx.stats,
        devicePixelRatio = renderCtx.devicePixelRatio;
      if (this.dirty === 0 /* NONE */ && !forceRender) {
        if (stats) stats.nodesSkipped += this.nodeCount.count;
        return;
      }
      this.computeTransformMatrix();
      this.matrix.toContext(ctx);
      var x1 = this.x1,
        y1 = this.y1,
        x2 = this.x2,
        y2 = this.y2;
      if (x1 === x2) {
        var strokeWidth = this.strokeWidth;
        var x = Math.round(x1 * devicePixelRatio) / devicePixelRatio + Math.trunc(strokeWidth * devicePixelRatio) % 2 / (devicePixelRatio * 2);
        x1 = x;
        x2 = x;
      } else if (y1 === y2) {
        var _strokeWidth = this.strokeWidth;
        var y = Math.round(y1 * devicePixelRatio) / devicePixelRatio + Math.trunc(_strokeWidth * devicePixelRatio) % 2 / (devicePixelRatio * 2);
        y1 = y;
        y2 = y;
      }
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      this.fillStroke(ctx);
      (_a = this.fillShadow) == null ? void 0 : _a.markClean();
      _superPropGet(Line, "render", this, 3)([renderCtx]);
    }
  }, {
    key: "x",
    set: function set(value) {
      this.x1 = value;
      this.x2 = value;
    }
  }, {
    key: "y",
    set: function set(value) {
      this.y1 = value;
      this.y2 = value;
    }
  }]);
  return Line;
}(_Shape6);
_Line.className = "Line";
_Line.defaultStyles = Object.assign({}, _Shape6.defaultStyles, {
  fill: void 0,
  strokeWidth: 1
});
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Line.prototype, "x1", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Line.prototype, "y1", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Line.prototype, "x2", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Line.prototype, "y2", 2);

// packages/ag-charts-community/src/scene/util/labelPlacement.ts
function circleRectOverlap(c, unitCenter, x, y, w, h) {
  if (c.size === 0) return false;
  var cx = c.x;
  var cy = c.y;
  if (unitCenter != null) {
    cx -= (unitCenter.x - 0.5) * c.size;
    cy -= (unitCenter.y - 0.5) * c.size;
  }
  var edgeX = cx;
  if (cx < x) {
    edgeX = x;
  } else if (cx > x + w) {
    edgeX = x + w;
  }
  var edgeY = cy;
  if (cy < y) {
    edgeY = y;
  } else if (cy > y + h) {
    edgeY = y + h;
  }
  var dx = cx - edgeX;
  var dy = cy - edgeY;
  var d = Math.sqrt(dx * dx + dy * dy);
  return d <= c.size * 0.5;
}
function rectRectOverlap(r1, x2, y2, w2, h2) {
  var xOverlap = r1.x + r1.width > x2 && r1.x < x2 + w2;
  var yOverlap = r1.y + r1.height > y2 && r1.y < y2 + h2;
  return xOverlap && yOverlap;
}
function rectContainsRect(r1, r2x, r2y, r2w, r2h) {
  return r2x + r2w < r1.x + r1.width && r2x > r1.x && r2y > r1.y && r2y + r2h < r1.y + r1.height;
}
function isPointLabelDatum(x) {
  return x != null && typeof x.point === "object" && typeof x.label === "object";
}
var labelPlacements = {
  top: {
    x: 0,
    y: -1
  },
  bottom: {
    x: 0,
    y: 1
  },
  left: {
    x: -1,
    y: 0
  },
  right: {
    x: 1,
    y: 0
  }
};
function _placeLabels(data, bounds) {
  var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var _a, _b;
  var result = [];
  data = data.map(function (d) {
    return d.slice().sort(function (a, b) {
      return b.point.size - a.point.size;
    });
  });
  for (var j = 0; j < data.length; j++) {
    var labels = result[j] = [];
    var datum = data[j];
    if (!((datum == null ? void 0 : datum.length) && datum[0].label)) {
      continue;
    }
    var _loop6 = function _loop6() {
        var d = datum[i];
        var point = d.point,
          label = d.label,
          marker = d.marker;
        var text = label.text,
          width = label.width,
          height = label.height;
        var r = point.size * 0.5;
        var dx = 0;
        var dy = 0;
        if (r > 0 && d.placement != null) {
          var placement = labelPlacements[d.placement];
          dx = (width * 0.5 + r + padding) * placement.x;
          dy = (height * 0.5 + r + padding) * placement.y;
        }
        var x = point.x - width * 0.5 + dx - (((_a = marker == null ? void 0 : marker.center.x) != null ? _a : 0.5) - 0.5) * point.size;
        var y = point.y - height * 0.5 + dy - (((_b = marker == null ? void 0 : marker.center.y) != null ? _b : 0.5) - 0.5) * point.size;
        var withinBounds = !bounds || rectContainsRect(bounds, x, y, width, height);
        if (!withinBounds) {
          return 0; // continue
        }
        var overlapPoints = data.some(function (dataDatums) {
          return dataDatums.some(function (dataDatum) {
            var _a2;
            return circleRectOverlap(dataDatum.point, (_a2 = dataDatum.marker) == null ? void 0 : _a2.center, x, y, width, height);
          });
        });
        if (overlapPoints) {
          return 0; // continue
        }
        var overlapLabels = result.some(function (l2) {
          return l2.some(function (l3) {
            return rectRectOverlap(l3, x, y, width, height);
          });
        });
        if (overlapLabels) {
          return 0; // continue
        }
        labels.push({
          index: i,
          text: text,
          x: x,
          y: y,
          width: width,
          height: height,
          datum: d
        });
      },
      _ret3;
    for (var i = 0, ln = datum.length; i < ln; i++) {
      _ret3 = _loop6();
      if (_ret3 === 0) continue;
    }
  }
  return result;
}
function axisLabelsOverlap(data, padding) {
  var result = [];
  var _loop7 = function _loop7() {
      var datum = data[i];
      var _datum$point = datum.point,
        x = _datum$point.x,
        y = _datum$point.y,
        text = datum.label.text;
      var _datum$label = datum.label,
        width = _datum$label.width,
        height = _datum$label.height;
      width += padding != null ? padding : 0;
      height += padding != null ? padding : 0;
      var overlapLabels = result.some(function (l) {
        return rectRectOverlap(l, x, y, width, height);
      });
      if (overlapLabels) {
        return {
          v: true
        };
      }
      result.push({
        index: i,
        text: text,
        x: x,
        y: y,
        width: width,
        height: height,
        datum: datum
      });
    },
    _ret4;
  for (var i = 0; i < data.length; i++) {
    _ret4 = _loop7();
    if (_ret4) return _ret4.v;
  }
  return false;
}

// packages/ag-charts-community/src/util/equal.ts
function _areArrayItemsStrictlyEqual(arrA, arrB) {
  return arrA.length === arrB.length && arrA.every(function (a, i) {
    var b = arrB[i];
    if (Array.isArray(a) && Array.isArray(b)) {
      return _areArrayItemsStrictlyEqual(a, b);
    }
    return a === b;
  });
}
function _areArrayNumbersEqual(arrA, arrB) {
  return arrA.length === arrB.length && arrA.every(function (item, i) {
    return Number(item) === Number(arrB[i]);
  });
}

// packages/ag-charts-community/src/util/proxy.ts
function _ProxyProperty(proxyPath) {
  var pathArray = _isArray(proxyPath) ? proxyPath : proxyPath.split(".");
  if (pathArray.length === 1) {
    var _pathArray = _slicedToArray(pathArray, 1),
      property = _pathArray[0];
    return addTransformToInstanceProperty(function (target, _, value) {
      return target[property] = value;
    }, function (target) {
      return target[property];
    });
  }
  return addTransformToInstanceProperty(function (target, _, value) {
    return _setPath(target, pathArray, value);
  }, function (target) {
    return _getPath(target, pathArray);
  });
}
function _ProxyOnWrite(proxyProperty) {
  return addTransformToInstanceProperty(function (target, _, value) {
    return target[proxyProperty] = value;
  });
}
function _ProxyPropertyOnWrite(childName, childProperty) {
  return addTransformToInstanceProperty(function (target, key, value) {
    return target[childName][childProperty != null ? childProperty : key] = value;
  });
}
function _ActionOnSet(opts) {
  var newValueFn = opts.newValue,
    oldValueFn = opts.oldValue,
    changeValueFn = opts.changeValue;
  return addTransformToInstanceProperty(function (target, _, newValue, oldValue) {
    if (newValue !== oldValue) {
      if (oldValue !== void 0) {
        oldValueFn == null ? void 0 : oldValueFn.call(target, oldValue);
      }
      if (newValue !== void 0) {
        newValueFn == null ? void 0 : newValueFn.call(target, newValue);
      }
      changeValueFn == null ? void 0 : changeValueFn.call(target, newValue, oldValue);
    }
    return newValue;
  });
}
function _ObserveChanges(observerFn) {
  return addObserverToInstanceProperty(observerFn);
}

// packages/ag-charts-community/src/util/attributeUtil.ts
function _setAttribute(e, qualifiedName, value) {
  if (value === void 0 || value === "") {
    e == null ? void 0 : e.removeAttribute(qualifiedName);
  } else {
    e == null ? void 0 : e.setAttribute(qualifiedName, value.toString());
  }
}

// packages/ag-charts-community/src/util/placement.ts
function _calculatePlacement(naturalWidth, naturalHeight, containerWidth, containerHeight, bounds) {
  var top = bounds.top,
    right = bounds.right,
    bottom = bounds.bottom,
    left = bounds.left,
    width = bounds.width,
    height = bounds.height;
  if (left != null) {
    if (width != null) {
      right = containerWidth - left + width;
    } else if (right != null) {
      width = containerWidth - left - right;
    }
  } else if (right != null && width != null) {
    left = containerWidth - right - width;
  }
  if (top != null) {
    if (height != null) {
      bottom = containerHeight - top - height;
    } else if (bottom != null) {
      height = containerHeight - bottom - top;
    }
  } else if (bottom != null && height != null) {
    top = containerHeight - bottom - height;
  }
  if (width == null) {
    if (height == null) {
      width = naturalWidth;
      height = naturalHeight;
    } else {
      width = Math.ceil(naturalWidth * height / naturalHeight);
    }
  } else if (height == null) {
    height = Math.ceil(naturalHeight * width / naturalWidth);
  }
  if (left == null) {
    if (right == null) {
      left = Math.floor((containerWidth - width) / 2);
    } else {
      left = containerWidth - right - width;
    }
  }
  if (top == null) {
    if (bottom == null) {
      top = Math.floor((containerHeight - height) / 2);
    } else {
      top = containerHeight - height - bottom;
    }
  }
  return {
    x: left,
    y: top,
    width: width,
    height: height
  };
}

// packages/ag-charts-community/src/chart/tooltip/tooltip.ts
var _DEFAULT_TOOLTIP_CLASS = "ag-chart-tooltip";
var _DEFAULT_TOOLTIP_DARK_CLASS = "ag-chart-dark-tooltip";
var _EMPTY_TOOLTIP_CONTENT = {
  html: "",
  ariaLabel: ""
};
function toAccessibleText(inputHtml) {
  var lineConverter = function lineConverter(_match, offset4, str) {
    if (offset4 === 0 || str[offset4 - 1] !== ".") {
      return ". ";
    }
    return " ";
  };
  return inputHtml.replace(/<br\s*\/?>/g, lineConverter).replace(/<\/p\s+>/g, lineConverter).replace(/<\/li\s*\/>/g, lineConverter).replace(/<[^>]+>/g, "");
}
function _toTooltipHtml(input, defaults) {
  var _a, _b, _c;
  if (typeof input === "string") {
    return {
      html: input,
      ariaLabel: input
    };
  }
  var _input$content = input.content,
    content = _input$content === void 0 ? (_a = defaults == null ? void 0 : defaults.content) != null ? _a : "" : _input$content,
    _input$title = input.title,
    title = _input$title === void 0 ? defaults == null ? void 0 : defaults.title : _input$title,
    _input$color = input.color,
    color = _input$color === void 0 ? (_b = defaults == null ? void 0 : defaults.color) != null ? _b : "white" : _input$color,
    _input$backgroundColo = input.backgroundColor,
    backgroundColor = _input$backgroundColo === void 0 ? (_c = defaults == null ? void 0 : defaults.backgroundColor) != null ? _c : "#888" : _input$backgroundColo;
  var titleHtml = title ? "<div class=\"".concat(_DEFAULT_TOOLTIP_CLASS, "-title\"\n        style=\"color: ").concat(color, "; background-color: ").concat(backgroundColor, "\">").concat(title, "</div>") : "";
  var titleAria = title ? "".concat(title, ": ") : "";
  var contentHtml = content ? "<div class=\"".concat(_DEFAULT_TOOLTIP_CLASS, "-content\">").concat(content, "</div>") : "";
  return {
    html: "".concat(titleHtml).concat(contentHtml),
    ariaLabel: toAccessibleText("".concat(titleAria).concat(content))
  };
}
var _TooltipPosition = /*#__PURE__*/function (_BaseProperties3) {
  _inherits(TooltipPosition, _BaseProperties3);
  function TooltipPosition() {
    var _this35;
    _classCallCheck(this, TooltipPosition);
    _this35 = _possibleConstructorReturn(this, _getPrototypeOf(TooltipPosition).apply(this, arguments));
    /** The type of positioning for the tooltip. By default, the tooltip follows the pointer. */
    _this35.type = "pointer";
    /** The horizontal offset in pixels for the position of the tooltip. */
    _this35.xOffset = 0;
    /** The vertical offset in pixels for the position of the tooltip. */
    _this35.yOffset = 0;
    return _this35;
  }
  return TooltipPosition;
}(_BaseProperties35);
__decorateClass([_Validate(_UNION(["pointer", "node", "top", "right", "bottom", "left", "top-left", "top-right", "bottom-right", "bottom-left"], "a position type"))], _TooltipPosition.prototype, "type", 2);
__decorateClass([_Validate(_NUMBER)], _TooltipPosition.prototype, "xOffset", 2);
__decorateClass([_Validate(_NUMBER)], _TooltipPosition.prototype, "yOffset", 2);
var _Tooltip = /*#__PURE__*/function (_BaseProperties4) {
  _inherits(Tooltip, _BaseProperties4);
  function Tooltip() {
    var _this36;
    _classCallCheck(this, Tooltip);
    _this36 = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this));
    _this36.enabled = true;
    _this36.delay = 0;
    _this36.range = "nearest";
    _this36.wrapping = "hyphenate";
    _this36.position = new _TooltipPosition();
    _this36.darkTheme = false;
    _this36.enableInteraction = false;
    _this36.lastVisibilityChange = Date.now();
    _this36.wrapTypes = ["always", "hyphenate", "on-space", "never"];
    _this36.showTimeout = 0;
    _this36._showArrow = true;
    _this36.element = _createElement("div", _DEFAULT_TOOLTIP_CLASS);
    _setAttribute(_this36.element, "aria-hidden", true);
    _this36.root = _getDocument2("body");
    _this36.root.appendChild(_this36.element);
    return _this36;
  }
  _createClass(Tooltip, [{
    key: "destroy",
    value: function destroy() {
      this.element.remove();
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return !this.element.classList.contains(_DEFAULT_TOOLTIP_CLASS + "-hidden");
    }
    /**
     * Shows tooltip at the given event's coordinates.
     * If the `html` parameter is missing, moves the existing tooltip to the new position.
     */
  }, {
    key: "show",
    value: function show(canvasRect, meta, content) {
      var _this37 = this;
      var instantly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      var element2 = this.element;
      if (content != null) {
        element2.innerHTML = content.html;
      } else if (!element2.innerHTML) {
        this.toggle(false);
        return;
      }
      var positionType = (_b = (_a = meta.position) == null ? void 0 : _a.type) != null ? _b : this.position.type;
      var xOffset = (_d = (_c = meta.position) == null ? void 0 : _c.xOffset) != null ? _d : 0;
      var yOffset = (_f = (_e = meta.position) == null ? void 0 : _e.yOffset) != null ? _f : 0;
      var tooltipBounds = this.getTooltipBounds({
        positionType: positionType,
        meta: meta,
        yOffset: yOffset,
        xOffset: xOffset,
        canvasRect: canvasRect
      });
      var windowBounds = this.getWindowSize();
      var position = _calculatePlacement(element2.clientWidth, element2.clientHeight, canvasRect.width, canvasRect.height, tooltipBounds);
      position.x += canvasRect.x;
      position.y += canvasRect.y;
      var left = _clamp(0, position.x, windowBounds.width - element2.clientWidth - 1);
      var top = _clamp(0, position.y, windowBounds.height - element2.clientHeight);
      var constrained = left !== position.x || top !== position.y;
      var defaultShowArrow = (positionType === "node" || positionType === "pointer") && !constrained && !xOffset && !yOffset;
      var showArrow = (_h = (_g = meta.showArrow) != null ? _g : this.showArrow) != null ? _h : defaultShowArrow;
      this.updateShowArrow(showArrow);
      element2.style.transform = "translate(".concat(Math.round(left), "px, ").concat(Math.round(top), "px)");
      this.enableInteraction = (_i = meta.enableInteraction) != null ? _i : false;
      if (this.delay > 0 && !instantly) {
        this.toggle(false);
        this.showTimeout = setTimeout(function () {
          _this37.toggle(true);
        }, this.delay);
      } else {
        this.toggle(true);
      }
    }
  }, {
    key: "getWindowSize",
    value: function getWindowSize() {
      var _getWindow = _getWindow2(),
        innerWidth = _getWindow.innerWidth,
        innerHeight = _getWindow.innerHeight;
      return {
        width: innerWidth,
        height: innerHeight
      };
    }
  }, {
    key: "toggle",
    value: function toggle(visible) {
      var classList = this.element.classList;
      var toggleClass = function toggleClass(name, include) {
        return classList.toggle("".concat(_DEFAULT_TOOLTIP_CLASS, "-").concat(name), include);
      };
      var wasVisible = this.isVisible();
      var timeSinceLastVisibilityChangeMs = Infinity;
      if (!visible) {
        clearTimeout(this.showTimeout);
      }
      if (wasVisible !== visible) {
        var now = Date.now();
        timeSinceLastVisibilityChangeMs = now - this.lastVisibilityChange;
        this.lastVisibilityChange = now;
      }
      var animatedMoveThresholdMs = 100;
      var thrashingThresholdMs = 5;
      var noAnimation = !wasVisible && visible && timeSinceLastVisibilityChangeMs > animatedMoveThresholdMs;
      if (timeSinceLastVisibilityChangeMs > thrashingThresholdMs) {
        toggleClass("no-animation", noAnimation);
      }
      toggleClass("no-interaction", !this.enableInteraction);
      toggleClass("hidden", !visible);
      toggleClass("arrow", this._showArrow);
      classList.toggle(_DEFAULT_TOOLTIP_DARK_CLASS, this.darkTheme);
      var _iterator71 = _createForOfIteratorHelper(this.wrapTypes),
        _step71;
      try {
        for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
          var wrapType = _step71.value;
          classList.toggle("".concat(_DEFAULT_TOOLTIP_CLASS, "-wrap-").concat(wrapType), wrapType === this.wrapping);
        }
      } catch (err) {
        _iterator71.e(err);
      } finally {
        _iterator71.f();
      }
    }
  }, {
    key: "pointerLeftOntoTooltip",
    value: function pointerLeftOntoTooltip(event) {
      var _a;
      if (!this.enableInteraction) return false;
      var classList = (_a = event.sourceEvent.relatedTarget) == null ? void 0 : _a.classList;
      var classes = ["", "-title", "-content"];
      var classListContains = Boolean(classes.filter(function (c) {
        return classList == null ? void 0 : classList.contains("".concat(_DEFAULT_TOOLTIP_CLASS).concat(c));
      }));
      return classList !== void 0 && classListContains;
    }
  }, {
    key: "updateShowArrow",
    value: function updateShowArrow(show) {
      this._showArrow = show;
    }
  }, {
    key: "getTooltipBounds",
    value: function getTooltipBounds(_ref57) {
      var positionType = _ref57.positionType,
        meta = _ref57.meta,
        yOffset = _ref57.yOffset,
        xOffset = _ref57.xOffset,
        canvasRect = _ref57.canvasRect;
      var _this$element = this.element,
        tooltipWidth = _this$element.clientWidth,
        tooltipHeight = _this$element.clientHeight;
      var bounds = {
        width: tooltipWidth,
        height: tooltipHeight
      };
      switch (positionType) {
        case "node":
        case "pointer":
          {
            bounds.top = meta.offsetY + yOffset - tooltipHeight - 8;
            bounds.left = meta.offsetX + xOffset - tooltipWidth / 2;
            return bounds;
          }
        case "top":
          {
            bounds.top = yOffset;
            bounds.left = canvasRect.width / 2 - tooltipWidth / 2 + xOffset;
            return bounds;
          }
        case "right":
          {
            bounds.top = canvasRect.height / 2 - tooltipHeight / 2 + yOffset;
            bounds.left = canvasRect.width - tooltipWidth / 2 + xOffset;
            return bounds;
          }
        case "left":
          {
            bounds.top = canvasRect.height / 2 - tooltipHeight / 2 + yOffset;
            bounds.left = xOffset;
            return bounds;
          }
        case "bottom":
          {
            bounds.top = canvasRect.height - tooltipHeight + yOffset;
            bounds.left = canvasRect.width / 2 - tooltipWidth / 2 + xOffset;
            return bounds;
          }
        case "top-left":
          {
            bounds.top = yOffset;
            bounds.left = xOffset;
            return bounds;
          }
        case "top-right":
          {
            bounds.top = yOffset;
            bounds.left = canvasRect.width - tooltipWidth + xOffset;
            return bounds;
          }
        case "bottom-right":
          {
            bounds.top = canvasRect.height - tooltipHeight + yOffset;
            bounds.left = canvasRect.width - tooltipWidth + xOffset;
            return bounds;
          }
        case "bottom-left":
          {
            bounds.top = canvasRect.height - tooltipHeight + yOffset;
            bounds.left = xOffset;
            return bounds;
          }
      }
    }
  }]);
  return Tooltip;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], _Tooltip.prototype, "enabled", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], _Tooltip.prototype, "showArrow", 2);
__decorateClass([_ObserveChanges(function (target, newValue, oldValue) {
  if (newValue) {
    target.element.classList.add(newValue);
  }
  if (oldValue) {
    target.element.classList.remove(oldValue);
  }
}), _Validate(_STRING, {
  optional: true
})], _Tooltip.prototype, "class", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Tooltip.prototype, "delay", 2);
__decorateClass([_Validate(_INTERACTION_RANGE)], _Tooltip.prototype, "range", 2);
__decorateClass([_Validate(_TEXT_WRAP)], _Tooltip.prototype, "wrapping", 2);
__decorateClass([_Validate(_OBJECT)], _Tooltip.prototype, "position", 2);
__decorateClass([_Validate(_BOOLEAN)], _Tooltip.prototype, "darkTheme", 2);

// packages/ag-charts-community/src/chart/caption.ts
var _Caption3 = /*#__PURE__*/function (_BaseProperties5) {
  _inherits(Caption, _BaseProperties5);
  function Caption() {
    var _this38;
    _classCallCheck(this, Caption);
    _this38 = _possibleConstructorReturn(this, _getPrototypeOf(Caption).apply(this, arguments));
    _this38.id = _createId(_assertThisInitialized(_this38));
    _this38.node = new _Text2({
      zIndex: 1
    }).setProperties({
      textAlign: "center",
      pointerEvents: 1 /* None */
    });
    _this38.enabled = false;
    _this38.textAlign = "center";
    _this38.fontSize = 10;
    _this38.fontFamily = "sans-serif";
    _this38.wrapping = "always";
    _this38.truncated = false;
    return _this38;
  }
  _createClass(Caption, [{
    key: "getOrAddRegion",
    value: function getOrAddRegion(moduleCtx, regionName) {
      var _this39 = this;
      if (regionName === "root") {
        return moduleCtx.regionManager.getRegion("root");
      } else {
        return moduleCtx.regionManager.addRegionFromProperties({
          name: regionName,
          bboxproviders: [this.node],
          canInteraction: function canInteraction() {
            return _this39.enabled && _this39.node.visible;
          }
        });
      }
    }
  }, {
    key: "registerInteraction",
    value: function registerInteraction(moduleCtx, regionName) {
      var _this40 = this;
      var region = this.getOrAddRegion(moduleCtx, regionName);
      var destroyFns = [region.addListener("hover", function (event) {
        return _this40.handleMouseMove(moduleCtx, event);
      }), region.addListener("leave", function (event) {
        return _this40.handleMouseLeave(moduleCtx, event);
      })];
      return joinFunctions.apply(void 0, destroyFns);
    }
  }, {
    key: "computeTextWrap",
    value: function computeTextWrap(containerWidth, containerHeight) {
      var _a, _b;
      var text = this.text,
        wrapping = this.wrapping;
      var maxWidth = Math.min((_a = this.maxWidth) != null ? _a : Infinity, containerWidth);
      var maxHeight = (_b = this.maxHeight) != null ? _b : containerHeight;
      if (!isFinite(maxWidth) && !isFinite(maxHeight)) {
        this.node.text = text;
        return;
      }
      var _Text$wrap = _Text2.wrap(text != null ? text : "", maxWidth, maxHeight, this, wrapping),
        wrappedText = _Text$wrap.text,
        truncated = _Text$wrap.truncated;
      this.node.text = wrappedText;
      this.truncated = truncated;
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip(moduleCtx, event) {
      if (event !== void 0 && this.enabled && this.node.visible && this.truncated) {
        var offsetX = event.offsetX,
          offsetY = event.offsetY;
        moduleCtx.tooltipManager.updateTooltip(this.id, {
          offsetX: offsetX,
          offsetY: offsetY,
          lastPointerEvent: event,
          showArrow: false
        }, _toTooltipHtml({
          content: this.text
        }));
        return true;
      }
      return false;
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(moduleCtx, event) {
      if (this.updateTooltip(moduleCtx, event)) {
        event.consume();
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(moduleCtx, _event) {
      moduleCtx.tooltipManager.removeTooltip(this.id);
    }
  }]);
  return Caption;
}(_BaseProperties35);
_Caption3.SMALL_PADDING = 10;
_Caption3.LARGE_PADDING = 20;
__decorateClass([_Validate(_BOOLEAN)], _Caption3.prototype, "enabled", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
}), _ProxyPropertyOnWrite("node")], _Caption3.prototype, "text", 2);
__decorateClass([_Validate(_TEXT_ALIGN, {
  optional: true
}), _ProxyPropertyOnWrite("node")], _Caption3.prototype, "textAlign", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
}), _ProxyPropertyOnWrite("node")], _Caption3.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
}), _ProxyPropertyOnWrite("node")], _Caption3.prototype, "fontWeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER), _ProxyPropertyOnWrite("node")], _Caption3.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING), _ProxyPropertyOnWrite("node")], _Caption3.prototype, "fontFamily", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
}), _ProxyPropertyOnWrite("node", "fill")], _Caption3.prototype, "color", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _Caption3.prototype, "spacing", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _Caption3.prototype, "lineHeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _Caption3.prototype, "maxWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _Caption3.prototype, "maxHeight", 2);
__decorateClass([_Validate(_TEXT_WRAP)], _Caption3.prototype, "wrapping", 2);

// packages/ag-charts-community/src/chart/axis/axisGridLine.ts
var GRID_STYLE_KEYS = ["stroke", "lineDash"];
var GRID_STYLE = _ARRAY_OF(function (value) {
  return _isObject(value) && Object.keys(value).every(function (key) {
    return GRID_STYLE_KEYS.includes(key);
  });
}, "objects with gridline style properties such as 'stroke' or 'lineDash'");
var AxisGridLine = function AxisGridLine() {
  _classCallCheck(this, AxisGridLine);
  this.enabled = true;
  this.width = 1;
  this.style = [{
    stroke: void 0,
    lineDash: []
  }];
};
__decorateClass([_Validate(_BOOLEAN)], AxisGridLine.prototype, "enabled", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], AxisGridLine.prototype, "width", 2);
__decorateClass([_Validate(GRID_STYLE)], AxisGridLine.prototype, "style", 2);

// packages/ag-charts-community/src/chart/axis/axisLabel.ts
var _AxisLabel3 = /*#__PURE__*/function (_BaseProperties6) {
  _inherits(AxisLabel, _BaseProperties6);
  function AxisLabel() {
    var _this41;
    _classCallCheck(this, AxisLabel);
    _this41 = _possibleConstructorReturn(this, _getPrototypeOf(AxisLabel).apply(this, arguments));
    _this41.enabled = true;
    _this41.autoWrap = false;
    _this41.fontSize = 12;
    _this41.fontFamily = "Verdana, sans-serif";
    _this41.padding = 5;
    _this41.minSpacing = NaN;
    _this41.color = "rgba(87, 87, 87, 1)";
    _this41.avoidCollisions = true;
    _this41.mirrored = false;
    _this41.parallel = false;
    return _this41;
  }
  /**
   * The side of the axis line to position the labels on.
   * -1 = left (default)
   * 1 = right
   */
  _createClass(AxisLabel, [{
    key: "getSideFlag",
    value: function getSideFlag() {
      return this.mirrored ? 1 : -1;
    }
  }]);
  return AxisLabel;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], _AxisLabel3.prototype, "enabled", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], _AxisLabel3.prototype, "autoWrap", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _AxisLabel3.prototype, "maxWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _AxisLabel3.prototype, "maxHeight", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
})], _AxisLabel3.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
})], _AxisLabel3.prototype, "fontWeight", 2);
__decorateClass([_Validate(_NUMBER.restrict({
  min: 1
}))], _AxisLabel3.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING)], _AxisLabel3.prototype, "fontFamily", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _AxisLabel3.prototype, "padding", 2);
__decorateClass([_Validate(_NUMBER_OR_NAN), _Default(NaN)], _AxisLabel3.prototype, "minSpacing", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _AxisLabel3.prototype, "color", 2);
__decorateClass([_Validate(_DEGREE, {
  optional: true
})], _AxisLabel3.prototype, "rotation", 2);
__decorateClass([_Validate(_BOOLEAN)], _AxisLabel3.prototype, "avoidCollisions", 2);
__decorateClass([_Validate(_BOOLEAN)], _AxisLabel3.prototype, "mirrored", 2);
__decorateClass([_Validate(_BOOLEAN)], _AxisLabel3.prototype, "parallel", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], _AxisLabel3.prototype, "formatter", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], _AxisLabel3.prototype, "format", 2);

// packages/ag-charts-community/src/chart/axis/axisLine.ts
var AxisLine = function AxisLine() {
  _classCallCheck(this, AxisLine);
  this.enabled = true;
  this.width = 1;
  this.color = void 0;
};
__decorateClass([_Validate(_BOOLEAN)], AxisLine.prototype, "enabled", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], AxisLine.prototype, "width", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], AxisLine.prototype, "color", 2);

// packages/ag-charts-community/src/chart/axis/axisTitle.ts
var AxisTitle = /*#__PURE__*/function (_BaseProperties7) {
  _inherits(AxisTitle, _BaseProperties7);
  function AxisTitle() {
    var _this42;
    _classCallCheck(this, AxisTitle);
    _this42 = _possibleConstructorReturn(this, _getPrototypeOf(AxisTitle).apply(this, arguments));
    _this42.enabled = false;
    _this42.spacing = _Caption3.SMALL_PADDING;
    _this42.fontSize = 10;
    _this42.fontFamily = "sans-serif";
    _this42.wrapping = "always";
    return _this42;
  }
  return AxisTitle;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], AxisTitle.prototype, "enabled", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], AxisTitle.prototype, "text", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], AxisTitle.prototype, "spacing", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
})], AxisTitle.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
})], AxisTitle.prototype, "fontWeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], AxisTitle.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING)], AxisTitle.prototype, "fontFamily", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], AxisTitle.prototype, "color", 2);
__decorateClass([_Validate(_TEXT_WRAP)], AxisTitle.prototype, "wrapping", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], AxisTitle.prototype, "formatter", 2);

// packages/ag-charts-community/src/chart/axis/axisUtil.ts
function _prepareAxisAnimationContext(axis) {
  var _findMinMax7 = _findMinMax17(axis.range),
    _findMinMax8 = _slicedToArray(_findMinMax7, 2),
    requestedRangeMin = _findMinMax8[0],
    requestedRangeMax = _findMinMax8[1];
  var min = Math.floor(requestedRangeMin);
  var max = Math.ceil(requestedRangeMax);
  return {
    min: min,
    max: max,
    visible: min !== max
  };
}
var fullCircle = Math.PI * 2;
var halfCircle = fullCircle / 2;
function normaliseEndRotation(start, end) {
  var directDistance = Math.abs(end - start);
  if (directDistance < halfCircle) return end;
  if (start > end) return end + fullCircle;
  return end - fullCircle;
}
function _prepareAxisAnimationFunctions(ctx) {
  var outOfBounds = function outOfBounds(y, range3) {
    var _findMinMax9 = _findMinMax17(range3 != null ? range3 : []),
      _findMinMax0 = _slicedToArray(_findMinMax9, 2),
      _findMinMax0$ = _findMinMax0[0],
      min = _findMinMax0$ === void 0 ? ctx.min : _findMinMax0$,
      _findMinMax0$2 = _findMinMax0[1],
      max = _findMinMax0$2 === void 0 ? ctx.max : _findMinMax0$2;
    return y < min || y > max;
  };
  var tick = {
    fromFn: function fromFn(node, datum, status) {
      var y = node.y1 + node.translationY;
      var opacity = node.opacity;
      if (status === "added" || outOfBounds(node.datum.translationY, node.datum.range)) {
        y = datum.translationY;
        opacity = 0;
      }
      return {
        y: 0,
        translationY: y,
        opacity: opacity,
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
      };
    },
    toFn: function toFn(_node, datum, status) {
      var y = datum.translationY;
      var opacity = 1;
      if (status === "removed") {
        opacity = 0;
      }
      return {
        y: 0,
        translationY: y,
        opacity: opacity,
        finish: {
          // Set explicit y after animation so it's pixel aligned
          y: y,
          translationY: 0
        }
      };
    },
    intermediateFn: function intermediateFn(node, _datum, _status) {
      return {
        visible: !outOfBounds(node.y)
      };
    }
  };
  var label = {
    fromFn: function fromFn(node, newDatum, status) {
      var _a;
      var datum = (_a = node.previousDatum) != null ? _a : newDatum;
      var x = datum.x;
      var y = datum.y;
      var rotationCenterX = datum.rotationCenterX;
      var translationY = Math.round(node.translationY);
      var rotation = datum.rotation;
      var opacity = node.opacity;
      if (status === "removed" || outOfBounds(datum.y, datum.range)) {
        rotation = newDatum.rotation;
      } else if (status === "added" || outOfBounds(node.datum.y, node.datum.range)) {
        translationY = Math.round(datum.translationY);
        opacity = 0;
        rotation = newDatum.rotation;
      }
      return {
        x: x,
        y: y,
        rotationCenterX: rotationCenterX,
        translationY: translationY,
        rotation: rotation,
        opacity: opacity,
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
      };
    },
    toFn: function toFn(node, datum, status) {
      var _a, _b;
      var x = datum.x;
      var y = datum.y;
      var rotationCenterX = datum.rotationCenterX;
      var translationY = Math.round(datum.translationY);
      var rotation = 0;
      var opacity = 1;
      if (status === "added") {
        opacity = 1;
        rotation = datum.rotation;
      } else if (status === "removed") {
        opacity = 0;
        rotation = datum.rotation;
      } else {
        rotation = normaliseEndRotation((_b = (_a = node.previousDatum) == null ? void 0 : _a.rotation) != null ? _b : datum.rotation, datum.rotation);
      }
      return {
        x: x,
        y: y,
        rotationCenterX: rotationCenterX,
        translationY: translationY,
        rotation: rotation,
        opacity: opacity,
        finish: {
          rotation: datum.rotation
        }
      };
    }
  };
  var line = {
    fromFn: function fromFn(node, datum) {
      var _a;
      return __spreadProps(__spreadValues({}, (_a = node.previousDatum) != null ? _a : datum), {
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING["updated"]
      });
    },
    toFn: function toFn(_node, datum) {
      return __spreadValues({}, datum);
    }
  };
  var group2 = {
    fromFn: function fromFn(node, _datum) {
      var rotation = node.rotation,
        translationX = node.translationX,
        translationY = node.translationY;
      return {
        rotation: rotation,
        translationX: translationX,
        translationY: translationY,
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING["updated"]
      };
    },
    toFn: function toFn(_node, datum) {
      var rotation = datum.rotation,
        translationX = datum.translationX,
        translationY = datum.translationY;
      return {
        rotation: rotation,
        translationX: translationX,
        translationY: translationY
      };
    }
  };
  return {
    tick: tick,
    line: line,
    label: label,
    group: group2
  };
}
function _resetAxisGroupFn() {
  return function (_node, datum) {
    return {
      rotation: datum.rotation,
      rotationCenterX: datum.rotationCenterX,
      rotationCenterY: datum.rotationCenterY,
      translationX: datum.translationX,
      translationY: datum.translationY
    };
  };
}
function _resetAxisSelectionFn(ctx) {
  var rangeVisible = ctx.visible,
    min = ctx.min,
    max = ctx.max;
  return function (_node, datum) {
    var y = datum.translationY;
    var visible = rangeVisible && y >= min && y <= max;
    return {
      y: y,
      translationY: 0,
      opacity: 1,
      visible: visible
    };
  };
}
function _resetAxisLabelSelectionFn() {
  return function (_node, datum) {
    return {
      x: datum.x,
      y: datum.y,
      translationY: datum.translationY,
      rotation: datum.rotation,
      rotationCenterX: datum.rotationCenterX
    };
  };
}
function _resetAxisLineSelectionFn() {
  return function (_node, datum) {
    return __spreadValues({}, datum);
  };
}

// packages/ag-charts-community/src/chart/axis/axis.ts
var _Axis = /*#__PURE__*/function () {
  function _Axis(moduleCtx, scale2, options) {
    var _this43 = this;
    _classCallCheck(this, _Axis);
    this.moduleCtx = moduleCtx;
    this.scale = scale2;
    this.id = _createId(this);
    this.nice = true;
    this.reverse = false;
    this.keys = [];
    this.dataDomain = {
      domain: [],
      clipped: false
    };
    this.boundSeries = [];
    this.includeInvisibleDomains = false;
    this.interactionEnabled = true;
    this.axisGroup = new _Group4({
      name: "".concat(this.id, "-axis"),
      zIndex: 2 /* AXIS_ZINDEX */
    });
    this.lineNode = this.axisGroup.appendChild(new _Line());
    this.tickLineGroup = this.axisGroup.appendChild(new _Group4({
      name: "".concat(this.id, "-Axis-tick-lines"),
      zIndex: 2 /* AXIS_ZINDEX */
    }));
    this.tickLabelGroup = this.axisGroup.appendChild(new _Group4({
      name: "".concat(this.id, "-Axis-tick-labels"),
      zIndex: 2 /* AXIS_ZINDEX */
    }));
    this.crossLineGroup = new _Group4({
      name: "".concat(this.id, "-CrossLines")
    });
    this.gridGroup = new _Group4({
      name: "".concat(this.id, "-Axis-grid")
    });
    this.gridLineGroup = this.gridGroup.appendChild(new _Group4({
      name: "".concat(this.id, "-gridLines"),
      zIndex: 1 /* AXIS_GRID_ZINDEX */
    }));
    this.tickLineGroupSelection = _Selection2.select(this.tickLineGroup, _Line, false);
    this.tickLabelGroupSelection = _Selection2.select(this.tickLabelGroup, _Text2, false);
    this.gridLineGroupSelection = _Selection2.select(this.gridLineGroup, _Line, false);
    this.line = new AxisLine();
    this.tick = this.createTick();
    this.gridLine = new AxisGridLine();
    this.label = this.createLabel();
    this.defaultTickMinSpacing = _Axis.defaultTickMinSpacing;
    this.translation = {
      x: 0,
      y: 0
    };
    this.rotation = 0;
    // axis rotation angle in degrees
    this.layout = {
      label: {
        fractionDigits: 0,
        padding: this.label.padding,
        format: this.label.format
      }
    };
    this.destroyFns = [];
    this.range = [0, 1];
    this.visibleRange = [0, 1];
    this.title = new AxisTitle();
    this._titleCaption = new _Caption3();
    this.gridLength = 0;
    this.fractionDigits = 0;
    /**
     * The distance between the grid ticks and the axis ticks.
     */
    this.gridPadding = 0;
    /**
     * Is used to avoid collisions between axis labels and series.
     */
    this.seriesAreaPadding = 0;
    this.tickGenerationResult = void 0;
    this.maxThickness = Infinity;
    this.moduleMap = new ModuleMap();
    this.refreshScale();
    this.destroyFns.push(this._titleCaption.registerInteraction(this.moduleCtx, "root"));
    this._titleCaption.node.rotation = -Math.PI / 2;
    this.axisGroup.appendChild(this._titleCaption.node);
    this.destroyFns.push(moduleCtx.regionManager.getRegion("series").addListener("hover", function (e) {
      return _this43.checkAxisHover(e);
    }));
    this.animationManager = moduleCtx.animationManager;
    this.animationState = new _StateMachine("empty", {
      empty: {
        update: {
          target: "ready",
          action: function action() {
            return _this43.resetSelectionNodes();
          }
        },
        reset: "empty"
      },
      ready: {
        update: function update(data) {
          return _this43.animateReadyUpdate(data);
        },
        resize: function resize() {
          return _this43.resetSelectionNodes();
        },
        reset: "empty"
      }
    });
    this._crossLines = [];
    this.assignCrossLineArrayConstructor(this._crossLines);
    var previousSize = void 0;
    this.destroyFns.push(moduleCtx.layoutService.addListener("layout-complete", function (e) {
      if (previousSize != null && _jsonDiff(e.chart, previousSize) != null) {
        _this43.animationState.transition("resize");
      }
      previousSize = __spreadValues({}, e.chart);
    }));
    if ((options == null ? void 0 : options.respondsToZoom) !== false) {
      this.destroyFns.push(moduleCtx.updateService.addListener("update-complete", function (e) {
        _this43.minRect = e.minRect;
      }));
    }
  }
  _createClass(_Axis, [{
    key: "resetAnimation",
    value: function resetAnimation(phase) {
      if (phase === "initial") {
        this.animationState.transition("reset");
      }
    }
  }, {
    key: "attachCrossLine",
    value: function attachCrossLine(crossLine) {
      this.crossLineGroup.appendChild(crossLine.group);
      this.crossLineGroup.appendChild(crossLine.labelGroup);
    }
  }, {
    key: "detachCrossLine",
    value: function detachCrossLine(crossLine) {
      this.crossLineGroup.removeChild(crossLine.group);
      this.crossLineGroup.removeChild(crossLine.labelGroup);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.moduleMap.destroy();
      this.destroyFns.forEach(function (f) {
        return f();
      });
    }
  }, {
    key: "refreshScale",
    value: function refreshScale() {
      var _a;
      this.range = this.scale.range.slice();
      (_a = this.crossLines) == null ? void 0 : _a.forEach(this.initCrossLine, this);
    }
  }, {
    key: "updateRange",
    value: function updateRange() {
      var _a;
      var rr = this.range,
        vr = this.visibleRange,
        scale2 = this.scale;
      var span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
      var shift = span * vr[0];
      var start = rr[0] - shift;
      scale2.range = [start, start + span];
      (_a = this.crossLines) == null ? void 0 : _a.forEach(function (crossLine) {
        crossLine.clippedRange = [rr[0], rr[1]];
      });
    }
  }, {
    key: "setCrossLinesVisible",
    value: function setCrossLinesVisible(visible) {
      this.crossLineGroup.visible = visible;
    }
  }, {
    key: "attachAxis",
    value: function attachAxis(axisNode, gridNode) {
      gridNode.appendChild(this.gridGroup);
      axisNode.appendChild(this.axisGroup);
      axisNode.appendChild(this.crossLineGroup);
    }
  }, {
    key: "detachAxis",
    value: function detachAxis(axisNode, gridNode) {
      gridNode.removeChild(this.gridGroup);
      axisNode.removeChild(this.axisGroup);
      axisNode.removeChild(this.crossLineGroup);
    }
    /**
     * Checks if a point or an object is in range.
     * @param x A point (or object's starting point).
     * @param width Object's width.
     * @param tolerance Expands the range on both ends by this amount.
     */
  }, {
    key: "inRange",
    value: function inRange(x) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _findMinMax1 = _findMinMax17(this.range),
        _findMinMax10 = _slicedToArray(_findMinMax1, 2),
        min = _findMinMax10[0],
        max = _findMinMax10[1];
      return x + width >= min - tolerance && x <= max + tolerance;
    }
  }, {
    key: "onLabelFormatChange",
    value: function onLabelFormatChange(ticks, _domain, format2) {
      var scale2 = this.scale,
        fractionDigits = this.fractionDigits;
      var logScale = scale2 instanceof LogScale;
      var defaultLabelFormatter = !logScale && fractionDigits > 0 ? function (x) {
        return typeof x === "number" ? x.toFixed(fractionDigits) : String(x);
      } : function (x) {
        return String(x);
      };
      if (format2 && scale2 && scale2.tickFormat) {
        try {
          this.labelFormatter = scale2.tickFormat({
            ticks: ticks,
            specifier: format2
          });
        } catch (e) {
          this.labelFormatter = defaultLabelFormatter;
          _Logger.warnOnce("the axis label format string ".concat(format2, " is invalid. No formatting will be applied"));
        }
      } else {
        this.labelFormatter = defaultLabelFormatter;
      }
    }
  }, {
    key: "setTickInterval",
    value: function setTickInterval(interval) {
      var _a;
      this.scale.interval = (_a = this.tick.interval) != null ? _a : interval;
    }
  }, {
    key: "setTickCount",
    value: function setTickCount(count, minTickCount, maxTickCount) {
      var scale2 = this.scale;
      var continuous = _ContinuousScale5.is(scale2) || _OrdinalTimeScale2.is(scale2);
      if (!(count && continuous)) {
        return;
      }
      if (typeof count === "number") {
        scale2.tickCount = count;
        scale2.minTickCount = minTickCount != null ? minTickCount : 0;
        scale2.maxTickCount = maxTickCount != null ? maxTickCount : Infinity;
        return;
      }
      if (scale2 instanceof _TimeScale2) {
        this.setTickInterval(count);
      }
    }
  }, {
    key: "onGridLengthChange",
    value: function onGridLengthChange(value, prevValue) {
      var _a;
      if (prevValue && !value || !prevValue && value) {
        this.onGridVisibilityChange();
      }
      (_a = this.crossLines) == null ? void 0 : _a.forEach(this.initCrossLine, this);
    }
  }, {
    key: "onGridVisibilityChange",
    value: function onGridVisibilityChange() {
      this.gridLineGroupSelection.clear();
    }
  }, {
    key: "createLabel",
    value: function createLabel() {
      return new _AxisLabel3();
    }
  }, {
    key: "checkAxisHover",
    value: function checkAxisHover(event) {
      if (!this.interactionEnabled) return;
      var bbox = this.computeBBox();
      var isInAxis = bbox.containsPoint(event.offsetX, event.offsetY);
      if (!isInAxis) return;
      this.moduleCtx.chartEventManager.axisHover(this.id, this.direction);
    }
    /**
     * Creates/removes/updates the scene graph nodes that constitute the axis.
     */
  }, {
    key: "update",
    value: function update() {
      var _primaryTickCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this.tickGenerationResult) {
        return;
      }
      var _this$calculateRotati = this.calculateRotations(),
        rotation = _this$calculateRotati.rotation,
        parallelFlipRotation = _this$calculateRotati.parallelFlipRotation,
        regularFlipRotation = _this$calculateRotati.regularFlipRotation;
      var sideFlag = this.label.getSideFlag();
      this.updatePosition();
      var lineData = this.getAxisLineCoordinates();
      var _this$tickGenerationR = this.tickGenerationResult,
        tickData = _this$tickGenerationR.tickData,
        combinedRotation = _this$tickGenerationR.combinedRotation,
        textBaseline = _this$tickGenerationR.textBaseline,
        textAlign = _this$tickGenerationR.textAlign,
        primaryTickCount = _this$tickGenerationR.primaryTickCount;
      var previousTicks = this.tickLabelGroupSelection.nodes().map(function (node) {
        return node.datum.tickId;
      });
      this.updateSelections(lineData, tickData.ticks, {
        combinedRotation: combinedRotation,
        textAlign: textAlign,
        textBaseline: textBaseline,
        range: this.scale.range
      });
      if (!animated || this.animationManager.isSkipped()) {
        this.resetSelectionNodes();
      } else {
        var diff2 = this.calculateUpdateDiff(previousTicks, tickData);
        this.animationState.transition("update", diff2);
      }
      this.updateAxisLine();
      this.updateLabels();
      this.updateVisibility();
      this.updateGridLines(sideFlag);
      this.updateTickLines();
      this.updateTitle({
        anyTickVisible: tickData.ticks.length > 0
      });
      this.updateCrossLines({
        rotation: rotation,
        parallelFlipRotation: parallelFlipRotation,
        regularFlipRotation: regularFlipRotation
      });
      this.updateLayoutState();
      return primaryTickCount;
    }
  }, {
    key: "getAxisLineCoordinates",
    value: function getAxisLineCoordinates() {
      var _findMinMax11 = _findMinMax17(this.range),
        _findMinMax12 = _slicedToArray(_findMinMax11, 2),
        min = _findMinMax12[0],
        max = _findMinMax12[1];
      return {
        x: 0,
        y1: min,
        y2: max
      };
    }
  }, {
    key: "getTickLineCoordinates",
    value: function getTickLineCoordinates(datum) {
      var sideFlag = this.label.getSideFlag();
      var x = sideFlag * this.getTickSize();
      var x1 = Math.min(0, x);
      var x2 = x1 + Math.abs(x);
      var y = datum.translationY;
      return {
        x1: x1,
        x2: x2,
        y: y
      };
    }
  }, {
    key: "getTickLabelProps",
    value: function getTickLabelProps(datum, params) {
      var label = this.label;
      var combinedRotation = params.combinedRotation,
        textBaseline = params.textBaseline,
        textAlign = params.textAlign,
        range3 = params.range;
      var text = datum.tickLabel;
      var sideFlag = label.getSideFlag();
      var labelX = sideFlag * (this.getTickSize() + label.padding + this.seriesAreaPadding);
      var visible = text !== "" && text != null;
      return {
        tickId: datum.tickId,
        translationY: datum.translationY,
        fill: label.color,
        fontFamily: label.fontFamily,
        fontSize: label.fontSize,
        fontStyle: label.fontStyle,
        fontWeight: label.fontWeight,
        rotation: combinedRotation,
        rotationCenterX: labelX,
        text: text,
        textAlign: textAlign,
        textBaseline: textBaseline,
        visible: visible,
        x: labelX,
        y: 0,
        range: range3
      };
    }
  }, {
    key: "getTickSize",
    value: function getTickSize() {
      return this.tick.enabled ? this.tick.size : this.createTick().size;
    }
  }, {
    key: "setTitleProps",
    value: function setTitleProps(caption, params) {
      var _a;
      var title = this.title;
      if (!title.enabled) {
        caption.enabled = false;
        return;
      }
      caption.color = title.color;
      caption.fontFamily = title.fontFamily;
      caption.fontSize = title.fontSize;
      caption.fontStyle = title.fontStyle;
      caption.fontWeight = title.fontWeight;
      caption.enabled = title.enabled;
      caption.wrapping = title.wrapping;
      if (title.enabled) {
        var titleNode = caption.node;
        var padding = ((_a = title.spacing) != null ? _a : 0) + params.spacing;
        var sideFlag = this.label.getSideFlag();
        var parallelFlipRotation = _normalizeAngle2(this.rotation);
        var titleRotationFlag = sideFlag === -1 && parallelFlipRotation > Math.PI && parallelFlipRotation < Math.PI * 2 ? -1 : 1;
        var rotation = titleRotationFlag * sideFlag * Math.PI / 2;
        var textBaseline = titleRotationFlag === 1 ? "bottom" : "top";
        var range3 = this.range;
        var x = Math.floor(titleRotationFlag * sideFlag * (range3[0] + range3[1]) / 2);
        var y = sideFlag === -1 ? Math.floor(titleRotationFlag * -padding) : Math.floor(-padding);
        var callbackCache = this.moduleCtx.callbackCache;
        var _title$formatter = title.formatter,
          formatter = _title$formatter === void 0 ? function (p) {
            return p.defaultValue;
          } : _title$formatter;
        var text = callbackCache.call(formatter, this.getTitleFormatterParams());
        titleNode.setProperties({
          rotation: rotation,
          text: text,
          textBaseline: textBaseline,
          visible: true,
          x: x,
          y: y
        });
      }
    }
  }, {
    key: "calculateLayout",
    value: function calculateLayout(primaryTickCount) {
      var _this44 = this;
      var _b, _c;
      var _this$calculateRotati2 = this.calculateRotations(),
        rotation = _this$calculateRotati2.rotation,
        parallelFlipRotation = _this$calculateRotati2.parallelFlipRotation,
        regularFlipRotation = _this$calculateRotati2.regularFlipRotation;
      var sideFlag = this.label.getSideFlag();
      var labelX = sideFlag * (this.getTickSize() + this.label.padding + this.seriesAreaPadding);
      this.updateScale();
      this.tickGenerationResult = this.generateTicks({
        primaryTickCount: primaryTickCount,
        parallelFlipRotation: parallelFlipRotation,
        regularFlipRotation: regularFlipRotation,
        labelX: labelX,
        sideFlag: sideFlag
      });
      this.updateLayoutState();
      var _a = this.tickGenerationResult,
        tickData = _a.tickData,
        combinedRotation = _a.combinedRotation,
        textBaseline = _a.textBaseline,
        textAlign = _a.textAlign,
        ticksResult = __objRest(_a, ["tickData", "combinedRotation", "textBaseline", "textAlign"]);
      var boxes = [];
      var _this$getAxisLineCoor = this.getAxisLineCoordinates(),
        x = _this$getAxisLineCoor.x,
        y1 = _this$getAxisLineCoor.y1,
        y2 = _this$getAxisLineCoor.y2;
      var lineBox = new _BBox2(x + Math.min(sideFlag * this.seriesAreaPadding, 0), y1, this.seriesAreaPadding, y2 - y1);
      boxes.push(lineBox);
      if (this.tick.enabled) {
        tickData.ticks.forEach(function (datum) {
          var _this44$getTickLineCo = _this44.getTickLineCoordinates(datum),
            x1 = _this44$getTickLineCo.x1,
            x2 = _this44$getTickLineCo.x2,
            y = _this44$getTickLineCo.y;
          var tickLineBox = new _BBox2(x1, y, x2 - x1, 0);
          boxes.push(tickLineBox);
        });
      }
      if (this.label.enabled) {
        var tempText = new _Text2();
        tickData.ticks.forEach(function (datum) {
          var labelProps = _this44.getTickLabelProps(datum, {
            combinedRotation: combinedRotation,
            textAlign: textAlign,
            textBaseline: textBaseline,
            range: _this44.scale.range
          });
          if (!labelProps.visible) {
            return;
          }
          tempText.setProperties(__spreadProps(__spreadValues({}, labelProps), {
            translationY: Math.round(datum.translationY)
          }));
          var box = tempText.computeTransformedBBox();
          if (box) {
            boxes.push(box);
          }
        });
      }
      var getTransformBox = function getTransformBox(bbox2) {
        var matrix = new Matrix();
        var _this44$getAxisTransf = _this44.getAxisTransform(),
          axisRotation = _this44$getAxisTransf.rotation,
          translationX = _this44$getAxisTransf.translationX,
          translationY = _this44$getAxisTransf.translationY,
          rotationCenterX = _this44$getAxisTransf.rotationCenterX,
          rotationCenterY = _this44$getAxisTransf.rotationCenterY;
        Matrix.updateTransformMatrix(matrix, 1, 1, axisRotation, translationX, translationY, {
          scalingCenterX: 0,
          scalingCenterY: 0,
          rotationCenterX: rotationCenterX,
          rotationCenterY: rotationCenterY
        });
        return matrix.transformBBox(bbox2);
      };
      if ((_b = this.title) == null ? void 0 : _b.enabled) {
        var caption = new _Caption3();
        var spacing = _BBox2.merge(boxes).width;
        this.setTitleProps(caption, {
          spacing: spacing
        });
        var titleNode = caption.node;
        var titleBox = titleNode.computeTransformedBBox();
        if (titleBox) {
          boxes.push(titleBox);
        }
      }
      var bbox = _BBox2.merge(boxes);
      var transformedBBox = getTransformBox(bbox);
      var anySeriesActive = this.isAnySeriesActive();
      (_c = this.crossLines) == null ? void 0 : _c.forEach(function (crossLine) {
        var _a2;
        crossLine.sideFlag = -sideFlag;
        crossLine.direction = rotation === -Math.PI / 2 ? "x" /* X */ : "y" /* Y */;
        if (crossLine instanceof CartesianCrossLine) {
          crossLine.label.parallel = (_a2 = crossLine.label.parallel) != null ? _a2 : _this44.label.parallel;
        }
        crossLine.parallelFlipRotation = parallelFlipRotation;
        crossLine.regularFlipRotation = regularFlipRotation;
        crossLine.calculateLayout(anySeriesActive, _this44.reverse);
      });
      primaryTickCount = ticksResult.primaryTickCount;
      return {
        primaryTickCount: primaryTickCount,
        bbox: transformedBBox
      };
    }
  }, {
    key: "updateLayoutState",
    value: function updateLayoutState() {
      this.layout.label = {
        fractionDigits: this.fractionDigits,
        padding: this.label.padding,
        format: this.label.format
      };
    }
  }, {
    key: "setDomain",
    value: function setDomain(domain) {
      this.dataDomain = this.normaliseDataDomain(domain);
      if (this.reverse) {
        this.dataDomain.domain.reverse();
      }
      this.scale.domain = this.dataDomain.domain;
    }
  }, {
    key: "updateScale",
    value: function updateScale() {
      this.updateRange();
      this.calculateDomain();
      this.setTickInterval(this.tick.interval);
      var scale2 = this.scale,
        nice = this.nice;
      if (!_ContinuousScale5.is(scale2)) {
        return;
      }
      scale2.nice = nice;
      scale2.update();
    }
  }, {
    key: "calculateRotations",
    value: function calculateRotations() {
      var rotation = _toRadians(this.rotation);
      var parallelFlipRotation = _normalizeAngle2(rotation);
      var regularFlipRotation = _normalizeAngle2(rotation - Math.PI / 2);
      return {
        rotation: rotation,
        parallelFlipRotation: parallelFlipRotation,
        regularFlipRotation: regularFlipRotation
      };
    }
  }, {
    key: "generateTicks",
    value: function generateTicks(_ref58) {
      var primaryTickCount = _ref58.primaryTickCount,
        parallelFlipRotation = _ref58.parallelFlipRotation,
        regularFlipRotation = _ref58.regularFlipRotation,
        labelX = _ref58.labelX,
        sideFlag = _ref58.sideFlag;
      var _a;
      var scale2 = this.scale,
        tick = this.tick,
        _this$label4 = this.label,
        parallel = _this$label4.parallel,
        rotation = _this$label4.rotation,
        fontFamily = _this$label4.fontFamily,
        fontSize = _this$label4.fontSize,
        fontStyle = _this$label4.fontStyle,
        fontWeight = _this$label4.fontWeight;
      var secondaryAxis = primaryTickCount !== void 0;
      var _calculateLabelRotati3 = calculateLabelRotation({
          rotation: rotation,
          parallel: parallel,
          regularFlipRotation: regularFlipRotation,
          parallelFlipRotation: parallelFlipRotation
        }),
        defaultRotation = _calculateLabelRotati3.defaultRotation,
        configuredRotation = _calculateLabelRotati3.configuredRotation,
        parallelFlipFlag = _calculateLabelRotati3.parallelFlipFlag,
        regularFlipFlag = _calculateLabelRotati3.regularFlipFlag;
      var initialRotation = configuredRotation + defaultRotation;
      var labelMatrix = new Matrix();
      var _this$estimateTickCou = this.estimateTickCount({
          minSpacing: tick.minSpacing,
          maxSpacing: (_a = tick.maxSpacing) != null ? _a : NaN
        }),
        maxTickCount = _this$estimateTickCou.maxTickCount;
      var continuous = _ContinuousScale5.is(scale2) || _OrdinalTimeScale2.is(scale2);
      var maxIterations = !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
      var textAlign = getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
      var textBaseline = getTextBaseline(parallel, configuredRotation, sideFlag, parallelFlipFlag);
      var textProps = {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        textBaseline: textBaseline,
        textAlign: textAlign
      };
      var tickData = {
        rawTicks: [],
        ticks: [],
        labelCount: 0
      };
      var index = 0;
      var autoRotation = 0;
      var labelOverlap = true;
      var terminate = false;
      while (labelOverlap && index <= maxIterations) {
        if (terminate) {
          break;
        }
        autoRotation = 0;
        textAlign = getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
        var tickStrategies = this.getTickStrategies({
          secondaryAxis: secondaryAxis,
          index: index
        });
        var _iterator72 = _createForOfIteratorHelper(tickStrategies),
          _step72;
        try {
          for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
            var strategy = _step72.value;
            var _strategy = strategy({
              index: index,
              tickData: tickData,
              textProps: textProps,
              labelOverlap: labelOverlap,
              terminate: terminate,
              primaryTickCount: primaryTickCount
            });
            tickData = _strategy.tickData;
            index = _strategy.index;
            autoRotation = _strategy.autoRotation;
            terminate = _strategy.terminate;
            var rotated = configuredRotation !== 0 || autoRotation !== 0;
            var labelRotation = initialRotation + autoRotation;
            textAlign = getTextAlign(parallel, configuredRotation, autoRotation, sideFlag, regularFlipFlag);
            labelOverlap = this.label.avoidCollisions ? this.checkLabelOverlap(labelRotation, rotated, labelMatrix, tickData.ticks, labelX, __spreadProps(__spreadValues({}, textProps), {
              textAlign: textAlign
            })) : false;
          }
        } catch (err) {
          _iterator72.e(err);
        } finally {
          _iterator72.f();
        }
      }
      var combinedRotation = defaultRotation + configuredRotation + autoRotation;
      if (!secondaryAxis && tickData.rawTicks.length > 0) {
        primaryTickCount = tickData.rawTicks.length;
      }
      return {
        tickData: tickData,
        primaryTickCount: primaryTickCount,
        combinedRotation: combinedRotation,
        textBaseline: textBaseline,
        textAlign: textAlign
      };
    }
  }, {
    key: "getTickStrategies",
    value: function getTickStrategies(_ref59) {
      var _this45 = this;
      var iteration = _ref59.index,
        secondaryAxis = _ref59.secondaryAxis;
      var scale2 = this.scale,
        label = this.label,
        tick = this.tick;
      var continuous = _ContinuousScale5.is(scale2) || _OrdinalTimeScale2.is(scale2);
      var avoidLabelCollisions = label.enabled && label.avoidCollisions;
      var filterTicks = !continuous && iteration !== 0 && avoidLabelCollisions;
      var autoRotate = label.autoRotate === true && label.rotation === void 0;
      var strategies = [];
      var tickGenerationType;
      if (this.tick.values) {
        tickGenerationType = 3 /* VALUES */;
      } else if (secondaryAxis) {
        tickGenerationType = 1 /* CREATE_SECONDARY */;
      } else if (filterTicks) {
        tickGenerationType = 2 /* FILTER */;
      } else {
        tickGenerationType = 0 /* CREATE */;
      }
      var tickGenerationStrategy = function tickGenerationStrategy(_ref60) {
        var index = _ref60.index,
          tickData = _ref60.tickData,
          primaryTickCount = _ref60.primaryTickCount,
          terminate = _ref60.terminate;
        return _this45.createTickData(tickGenerationType, index, tickData, terminate, primaryTickCount);
      };
      strategies.push(tickGenerationStrategy);
      if (!continuous && !isNaN(tick.minSpacing)) {
        var tickFilterStrategy = function tickFilterStrategy(_ref61) {
          var index = _ref61.index,
            tickData = _ref61.tickData,
            primaryTickCount = _ref61.primaryTickCount,
            terminate = _ref61.terminate;
          return _this45.createTickData(2 /* FILTER */, index, tickData, terminate, primaryTickCount);
        };
        strategies.push(tickFilterStrategy);
      }
      if (!avoidLabelCollisions) {
        return strategies;
      }
      if (label.autoWrap) {
        var autoWrapStrategy = function autoWrapStrategy(_ref62) {
          var index = _ref62.index,
            tickData = _ref62.tickData,
            textProps = _ref62.textProps;
          return _this45.wrapLabels(tickData, index, textProps);
        };
        strategies.push(autoWrapStrategy);
      } else if (autoRotate) {
        var autoRotateStrategy = function autoRotateStrategy(_ref63) {
          var index = _ref63.index,
            tickData = _ref63.tickData,
            labelOverlap = _ref63.labelOverlap,
            terminate = _ref63.terminate;
          return {
            index: index,
            tickData: tickData,
            autoRotation: _this45.getAutoRotation(labelOverlap),
            terminate: terminate
          };
        };
        strategies.push(autoRotateStrategy);
      }
      return strategies;
    }
  }, {
    key: "createTickData",
    value: function createTickData(tickGenerationType, index, tickData, terminate, primaryTickCount) {
      var _a;
      var scale2 = this.scale,
        tick = this.tick;
      var _this$estimateTickCou2 = this.estimateTickCount({
          minSpacing: tick.minSpacing,
          maxSpacing: (_a = tick.maxSpacing) != null ? _a : NaN
        }),
        maxTickCount = _this$estimateTickCou2.maxTickCount,
        minTickCount = _this$estimateTickCou2.minTickCount,
        defaultTickCount = _this$estimateTickCou2.defaultTickCount;
      var continuous = _ContinuousScale5.is(scale2) || _OrdinalTimeScale2.is(scale2);
      var maxIterations = !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
      var tickCount = continuous ? Math.max(defaultTickCount - index, minTickCount) : maxTickCount;
      var regenerateTicks = tick.interval === void 0 && tick.values === void 0 && tickCount > minTickCount && (continuous || tickGenerationType === 2 /* FILTER */);
      var unchanged = true;
      while (unchanged && index <= maxIterations) {
        var prevTicks = tickData.rawTicks;
        tickCount = continuous ? Math.max(defaultTickCount - index, minTickCount) : maxTickCount;
        var _this$getTicks = this.getTicks({
            tickGenerationType: tickGenerationType,
            previousTicks: prevTicks,
            tickCount: tickCount,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount,
            primaryTickCount: primaryTickCount
          }),
          rawTicks = _this$getTicks.rawTicks,
          ticks = _this$getTicks.ticks,
          labelCount = _this$getTicks.labelCount;
        tickData.rawTicks = rawTicks;
        tickData.ticks = ticks;
        tickData.labelCount = labelCount;
        unchanged = regenerateTicks ? _areArrayNumbersEqual(rawTicks, prevTicks) : false;
        index++;
      }
      var shouldTerminate = tick.interval !== void 0 || tick.values !== void 0;
      terminate || (terminate = shouldTerminate);
      return {
        tickData: tickData,
        index: index,
        autoRotation: 0,
        terminate: terminate
      };
    }
  }, {
    key: "checkLabelOverlap",
    value: function checkLabelOverlap(rotation, rotated, labelMatrix, tickData, labelX, textProps) {
      Matrix.updateTransformMatrix(labelMatrix, 1, 1, rotation, 0, 0);
      var labelData = this.createLabelData(tickData, labelX, textProps, labelMatrix);
      var labelSpacing = getLabelSpacing(this.label.minSpacing, rotated);
      return axisLabelsOverlap(labelData, labelSpacing);
    }
  }, {
    key: "createLabelData",
    value: function createLabelData(tickData, labelX, textProps, labelMatrix) {
      var labelData = [];
      var measurer = new TextMeasurer(textProps);
      var _iterator73 = _createForOfIteratorHelper(tickData),
        _step73;
      try {
        for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
          var _step73$value = _step73.value,
            tickLabel = _step73$value.tickLabel,
            translationY = _step73$value.translationY;
          if (tickLabel === "" || tickLabel == null) continue;
          var _measurer$size = measurer.size(tickLabel),
            width = _measurer$size.width,
            height = _measurer$size.height;
          var bbox = new _BBox2(labelX, translationY, width, height);
          var labelDatum = calculateLabelBBox(tickLabel, bbox, labelX, translationY, labelMatrix);
          labelData.push(labelDatum);
        }
      } catch (err) {
        _iterator73.e(err);
      } finally {
        _iterator73.f();
      }
      return labelData;
    }
  }, {
    key: "getAutoRotation",
    value: function getAutoRotation(labelOverlap) {
      var _a;
      return labelOverlap ? _normalizeAngle2(_toRadians((_a = this.label.autoRotateAngle) != null ? _a : 0)) : 0;
    }
  }, {
    key: "getTicks",
    value: function getTicks(_ref64) {
      var tickGenerationType = _ref64.tickGenerationType,
        previousTicks = _ref64.previousTicks,
        tickCount = _ref64.tickCount,
        minTickCount = _ref64.minTickCount,
        maxTickCount = _ref64.maxTickCount,
        primaryTickCount = _ref64.primaryTickCount;
      var _a;
      var range3 = this.range,
        scale2 = this.scale,
        visibleRange = this.visibleRange;
      var rawTicks;
      switch (tickGenerationType) {
        case 3 /* VALUES */:
          if (_ContinuousScale5.is(scale2)) {
            var _findMinMax13 = _findMinMax17(scale2.getDomain().map(Number)),
              _findMinMax14 = _slicedToArray(_findMinMax13, 2),
              d0 = _findMinMax14[0],
              d1 = _findMinMax14[1];
            rawTicks = this.tick.values.filter(function (value) {
              return value >= d0 && value <= d1;
            }).sort(function (a, b) {
              return a - b;
            });
          } else {
            rawTicks = this.tick.values;
          }
          break;
        case 1 /* CREATE_SECONDARY */:
          if (_ContinuousScale5.is(scale2)) {
            rawTicks = this.updateSecondaryAxisTicks(primaryTickCount);
          } else {
            rawTicks = this.createTicks(tickCount, minTickCount, maxTickCount);
          }
          break;
        case 2 /* FILTER */:
          rawTicks = this.filterTicks(previousTicks, tickCount);
          break;
        default:
          rawTicks = this.createTicks(tickCount, minTickCount, maxTickCount);
          break;
      }
      this.fractionDigits = rawTicks.fractionDigits >= 0 ? rawTicks.fractionDigits : 0;
      var halfBandwidth = ((_a = scale2.bandwidth) != null ? _a : 0) / 2;
      var ticks = [];
      var labelCount = 0;
      var tickIdCounts = /* @__PURE__ */new Map();
      var start = Math.max(0, Math.floor(visibleRange[0] * rawTicks.length));
      var end = Math.min(rawTicks.length, Math.ceil(visibleRange[1] * rawTicks.length));
      var filteredTicks = rawTicks.slice(start, end);
      this.onLabelFormatChange(filteredTicks, rawTicks, this.label.format);
      for (var i = 0; i < filteredTicks.length; i++) {
        var tick = filteredTicks[i];
        var translationY = scale2.convert(tick) + halfBandwidth;
        if (range3.length > 0 && !this.inRange(translationY, 0, 1e-3)) continue;
        var tickLabel = this.formatTick(tick, start + i);
        var tickId = tickLabel;
        if (tickIdCounts.has(tickId)) {
          var count = tickIdCounts.get(tickId);
          tickIdCounts.set(tickId, count + 1);
          tickId = "".concat(tickId, "_").concat(count);
        } else {
          tickIdCounts.set(tickId, 1);
        }
        ticks.push({
          tick: tick,
          tickId: tickId,
          tickLabel: tickLabel,
          translationY: Math.floor(translationY)
        });
        if (tickLabel === "" || tickLabel == null) {
          continue;
        }
        labelCount++;
      }
      return {
        rawTicks: rawTicks,
        ticks: ticks,
        labelCount: labelCount
      };
    }
  }, {
    key: "filterTicks",
    value: function filterTicks(ticks, tickCount) {
      var _a;
      var tickSpacing = !isNaN(this.tick.minSpacing) || !isNaN((_a = this.tick.maxSpacing) != null ? _a : NaN);
      var keepEvery = tickSpacing ? Math.ceil(ticks.length / tickCount) : 2;
      return ticks.filter(function (_, i) {
        return i % keepEvery === 0;
      });
    }
  }, {
    key: "createTicks",
    value: function createTicks(tickCount, minTickCount, maxTickCount) {
      var _a, _b, _c;
      this.setTickCount(tickCount, minTickCount, maxTickCount);
      return (_c = (_b = (_a = this.scale).ticks) == null ? void 0 : _b.call(_a)) != null ? _c : [];
    }
  }, {
    key: "estimateTickCount",
    value: function estimateTickCount(_ref65) {
      var minSpacing = _ref65.minSpacing,
        maxSpacing = _ref65.maxSpacing;
      var minRect = this.minRect,
        avoidCollisions = this.label.avoidCollisions;
      if (!avoidCollisions) {
        return {
          minTickCount: _ContinuousScale5.defaultMaxTickCount,
          maxTickCount: _ContinuousScale5.defaultMaxTickCount,
          defaultTickCount: _ContinuousScale5.defaultMaxTickCount
        };
      }
      var rangeWithBleed = this.calculateRangeWithBleed();
      var defaultMinSpacing = Math.max(this.defaultTickMinSpacing, rangeWithBleed / _ContinuousScale5.defaultMaxTickCount);
      var clampMaxTickCount = !isNaN(maxSpacing);
      if (isNaN(minSpacing)) {
        minSpacing = defaultMinSpacing;
      }
      if (isNaN(maxSpacing)) {
        maxSpacing = rangeWithBleed;
      }
      if (minSpacing > maxSpacing) {
        if (minSpacing === defaultMinSpacing) {
          minSpacing = maxSpacing;
        } else {
          maxSpacing = minSpacing;
        }
      }
      var minRectDistance = 1;
      if (minRect) {
        minRectDistance = this.direction === "x" /* X */ ? minRect.width : minRect.height;
      }
      clampMaxTickCount && (clampMaxTickCount = minRectDistance < defaultMinSpacing);
      var maxTickCount = _clamp(1, Math.floor(rangeWithBleed / minSpacing), clampMaxTickCount ? Math.min(Math.floor(rangeWithBleed / minRectDistance), 100) : 100);
      var minTickCount = Math.min(maxTickCount, Math.ceil(rangeWithBleed / maxSpacing));
      var defaultTickCount = _clamp(minTickCount, _ContinuousScale5.defaultTickCount, maxTickCount);
      return {
        minTickCount: minTickCount,
        maxTickCount: maxTickCount,
        defaultTickCount: defaultTickCount
      };
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      if (this.moduleCtx.animationManager.isSkipped()) {
        this.resetSelectionNodes();
      }
      this.tickLineGroup.visible = this.tick.enabled;
      this.gridLineGroup.visible = this.gridLine.enabled;
      this.tickLabelGroup.visible = this.label.enabled;
    }
  }, {
    key: "updateCrossLines",
    value: function updateCrossLines(_ref66) {
      var _this46 = this;
      var rotation = _ref66.rotation,
        parallelFlipRotation = _ref66.parallelFlipRotation,
        regularFlipRotation = _ref66.regularFlipRotation;
      var _a;
      var sideFlag = this.label.getSideFlag();
      var anySeriesActive = this.isAnySeriesActive();
      (_a = this.crossLines) == null ? void 0 : _a.forEach(function (crossLine) {
        var _a2;
        crossLine.sideFlag = -sideFlag;
        crossLine.direction = rotation === -Math.PI / 2 ? "x" /* X */ : "y" /* Y */;
        if (crossLine instanceof CartesianCrossLine) {
          crossLine.label.parallel = (_a2 = crossLine.label.parallel) != null ? _a2 : _this46.label.parallel;
        }
        crossLine.parallelFlipRotation = parallelFlipRotation;
        crossLine.regularFlipRotation = regularFlipRotation;
        crossLine.update(anySeriesActive);
      });
    }
  }, {
    key: "updateTickLines",
    value: function updateTickLines() {
      var _this47 = this;
      var tick = this.tick,
        label = this.label;
      var sideFlag = label.getSideFlag();
      this.tickLineGroupSelection.each(function (line) {
        line.strokeWidth = tick.width;
        line.stroke = tick.color;
        line.x1 = sideFlag * _this47.getTickSize();
        line.x2 = 0;
      });
    }
  }, {
    key: "calculateAvailableRange",
    value: function calculateAvailableRange() {
      return _findRangeExtent(this.range);
    }
    /**
     * Calculates the available range with an additional "bleed" beyond the canvas that encompasses the full axis when
     * the visible range is only a portion of the axis.
     */
  }, {
    key: "calculateRangeWithBleed",
    value: function calculateRangeWithBleed() {
      var visibleScale = 1 / _findRangeExtent(this.visibleRange);
      return _round(this.calculateAvailableRange() * visibleScale, 2);
    }
  }, {
    key: "calculateDomain",
    value: function calculateDomain() {
      var _this48 = this;
      var visibleSeries = this.boundSeries.filter(function (s) {
        return _this48.includeInvisibleDomains || s.isEnabled();
      });
      var domains = visibleSeries.flatMap(function (series) {
        return series.getDomain(_this48.direction);
      });
      this.setDomain(domains);
    }
  }, {
    key: "getAxisTransform",
    value: function getAxisTransform() {
      return {
        rotation: _toRadians(this.rotation),
        rotationCenterX: 0,
        rotationCenterY: 0,
        translationX: Math.floor(this.translation.x),
        translationY: Math.floor(this.translation.y)
      };
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var crossLineGroup = this.crossLineGroup,
        axisGroup = this.axisGroup,
        gridGroup = this.gridGroup,
        translation = this.translation,
        gridLineGroupSelection = this.gridLineGroupSelection,
        gridPadding = this.gridPadding,
        gridLength = this.gridLength;
      var _this$calculateRotati3 = this.calculateRotations(),
        rotation = _this$calculateRotati3.rotation;
      var sideFlag = this.label.getSideFlag();
      var translationX = Math.floor(translation.x);
      var translationY = Math.floor(translation.y);
      crossLineGroup.setProperties({
        rotation: rotation,
        translationX: translationX,
        translationY: translationY
      });
      gridGroup.setProperties({
        rotation: rotation,
        translationX: translationX,
        translationY: translationY
      });
      axisGroup.datum = this.getAxisTransform();
      gridLineGroupSelection.each(function (line) {
        line.x1 = gridPadding;
        line.x2 = -sideFlag * gridLength + gridPadding;
      });
    }
  }, {
    key: "updateSecondaryAxisTicks",
    value: function updateSecondaryAxisTicks(_primaryTickCount) {
      throw new Error("AG Charts - unexpected call to updateSecondaryAxisTicks() - check axes configuration.");
    }
  }, {
    key: "updateSelections",
    value: function updateSelections(lineData, data, params) {
      var _this49 = this;
      this.lineNode.datum = lineData;
      this.gridLineGroupSelection.update(this.gridLength ? data : [], function (group2) {
        return group2.append(new _Line());
      }, function (datum) {
        return datum.tickId;
      });
      this.tickLineGroupSelection.update(data, function (group2) {
        return group2.appendChild(new _Line());
      }, function (datum) {
        return datum.tickId;
      });
      this.tickLabelGroupSelection.update(data.map(function (d) {
        return _this49.getTickLabelProps(d, params);
      }), function (group2) {
        return group2.appendChild(new _Text2());
      }, function (datum) {
        return datum.tickId;
      });
    }
  }, {
    key: "updateAxisLine",
    value: function updateAxisLine() {
      var line = this.line;
      var strokeWidth = line.enabled ? line.width : 0;
      this.lineNode.setProperties({
        stroke: line.color,
        strokeWidth: strokeWidth
      });
    }
  }, {
    key: "updateGridLines",
    value: function updateGridLines(sideFlag) {
      var _this$gridLine = this.gridLine,
        style = _this$gridLine.style,
        width = _this$gridLine.width,
        gridPadding = this.gridPadding,
        gridLength = this.gridLength;
      if (gridLength === 0 || style.length === 0) {
        return;
      }
      this.gridLineGroupSelection.each(function (line, _, index) {
        var _style = style[index % style.length],
          stroke = _style.stroke,
          lineDash = _style.lineDash;
        line.setProperties({
          x1: gridPadding,
          x2: -sideFlag * gridLength + gridPadding,
          fill: void 0,
          stroke: stroke,
          strokeWidth: width,
          lineDash: lineDash
        });
      });
    }
  }, {
    key: "updateLabels",
    value: function updateLabels() {
      var label = this.label;
      if (!label.enabled) {
        return;
      }
      this.tickLabelGroupSelection.each(function (node, datum) {
        node.setProperties(datum, ["fill", "fontFamily", "fontSize", "fontStyle", "fontWeight", "text", "textAlign", "textBaseline"]);
      });
    }
  }, {
    key: "wrapLabels",
    value: function wrapLabels(tickData, index, labelProps) {
      var _this$label5 = this.label,
        parallel = _this$label5.parallel,
        maxWidth = _this$label5.maxWidth,
        maxHeight = _this$label5.maxHeight;
      var defaultMaxWidth = this.maxThickness;
      var defaultMaxHeight = Math.round(this.calculateAvailableRange() / tickData.labelCount);
      if (parallel) {
        var _ref67 = [defaultMaxHeight, defaultMaxWidth];
        defaultMaxWidth = _ref67[0];
        defaultMaxHeight = _ref67[1];
      }
      tickData.ticks.forEach(function (tickDatum) {
        var _Text$wrap2 = _Text2.wrap(tickDatum.tickLabel, maxWidth != null ? maxWidth : defaultMaxWidth, maxHeight != null ? maxHeight : defaultMaxHeight, labelProps, "hyphenate"),
          text = _Text$wrap2.text;
        tickDatum.tickLabel = text;
      });
      return {
        tickData: tickData,
        index: index,
        autoRotation: 0,
        terminate: true
      };
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(params) {
      var rotation = this.rotation,
        title = this.title,
        _titleCaption = this._titleCaption,
        lineNode = this.lineNode,
        tickLineGroup = this.tickLineGroup,
        tickLabelGroup = this.tickLabelGroup;
      if (!title) {
        _titleCaption.enabled = false;
        return;
      }
      var spacing = 0;
      if (title.enabled && params.anyTickVisible) {
        var tickBBox = _Group4.computeBBox([tickLineGroup, tickLabelGroup, lineNode]);
        var tickWidth = rotation === 0 ? tickBBox.width : tickBBox.height;
        spacing += tickWidth + (this.tickLabelGroup.visible ? 0 : this.seriesAreaPadding);
      }
      this.setTitleProps(_titleCaption, {
        spacing: spacing
      });
    } // For formatting (nice rounded) tick values.
  }, {
    key: "formatTick",
    value: function formatTick(datum, index) {
      return this.datumFormatter(index)(datum);
    } // For formatting arbitrary values between the ticks.
  }, {
    key: "formatDatum",
    value: function formatDatum(datum) {
      return String(datum);
    }
  }, {
    key: "datumFormatter",
    value: function datumFormatter() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var label = this.label,
        labelFormatter = this.labelFormatter,
        fractionDigits = this.fractionDigits,
        callbackCache = this.moduleCtx.callbackCache;
      if (label.formatter) {
        return function (datum) {
          var _a;
          return (_a = callbackCache.call(label.formatter, {
            value: fractionDigits > 0 ? datum : String(datum),
            index: index,
            fractionDigits: fractionDigits,
            formatter: labelFormatter
          })) != null ? _a : datum;
        };
      } else if (labelFormatter) {
        return function (datum) {
          var _a;
          return (_a = callbackCache.call(labelFormatter, datum)) != null ? _a : String(datum);
        };
      }
      return function (datum) {
        return String(datum);
      };
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      return this.axisGroup.computeBBox();
    }
  }, {
    key: "initCrossLine",
    value: function initCrossLine(crossLine) {
      crossLine.scale = this.scale;
      crossLine.gridLength = this.gridLength;
    }
  }, {
    key: "isAnySeriesActive",
    value: function isAnySeriesActive() {
      var _this50 = this;
      return this.boundSeries.some(function (s) {
        return _this50.includeInvisibleDomains || s.isEnabled();
      });
    }
  }, {
    key: "clipTickLines",
    value: function clipTickLines(x, y, width, height) {
      this.tickLineGroup.setClipRectInGroupCoordinateSpace(new _BBox2(x, y, width, height));
    }
  }, {
    key: "clipGrid",
    value: function clipGrid(x, y, width, height) {
      this.gridGroup.setClipRectInGroupCoordinateSpace(new _BBox2(x, y, width, height));
    }
  }, {
    key: "calculatePadding",
    value: function calculatePadding(min, max) {
      var padding = Math.abs(this.reverse ? max : min) * 0.01;
      return [padding, padding];
    }
  }, {
    key: "getTitleFormatterParams",
    value: function getTitleFormatterParams() {
      var _this51 = this;
      var _a;
      var boundSeries = this.boundSeries.reduce(function (acc, next) {
        var keys = next.getKeys(_this51.direction);
        var names = next.getNames(_this51.direction);
        for (var idx = 0; idx < keys.length; idx++) {
          acc.push({
            key: keys[idx],
            name: names[idx]
          });
        }
        return acc;
      }, []);
      return {
        direction: this.direction,
        boundSeries: boundSeries,
        defaultValue: (_a = this.title) == null ? void 0 : _a.text
      };
    }
  }, {
    key: "normaliseDataDomain",
    value: function normaliseDataDomain(d) {
      return {
        domain: _toConsumableArray(d),
        clipped: false
      };
    }
  }, {
    key: "getLayoutState",
    value: function getLayoutState() {
      return __spreadValues({
        rect: this.computeBBox(),
        gridPadding: this.gridPadding,
        seriesAreaPadding: this.seriesAreaPadding,
        tickSize: this.getTickSize(),
        direction: this.direction,
        domain: this.dataDomain.domain,
        scale: this.scale
      }, this.layout);
    }
  }, {
    key: "getModuleMap",
    value: function getModuleMap() {
      return this.moduleMap;
    }
  }, {
    key: "createModuleContext",
    value: function createModuleContext() {
      var _a;
      (_a = this.axisContext) != null ? _a : this.axisContext = this.createAxisContext();
      return __spreadProps(__spreadValues({}, this.moduleCtx), {
        parent: this.axisContext
      });
    }
  }, {
    key: "createAxisContext",
    value: function createAxisContext() {
      var _this52 = this;
      return {
        axisId: this.id,
        direction: this.direction,
        continuous: _ContinuousScale5.is(this.scale),
        keys: function keys() {
          return _this52.boundSeries.flatMap(function (s) {
            return s.getKeys(_this52.direction);
          });
        },
        seriesKeyProperties: function seriesKeyProperties() {
          return _this52.boundSeries.reduce(function (keys, series) {
            var seriesKeys = series.getKeyProperties(_this52.direction);
            seriesKeys.forEach(function (key) {
              if (keys.indexOf(key) < 0) {
                keys.push(key);
              }
            });
            return keys;
          }, []);
        },
        scaleValueFormatter: function scaleValueFormatter(specifier) {
          var _a, _b;
          return specifier ? (_b = (_a = _this52.scale).tickFormat) == null ? void 0 : _b.call(_a, {
            specifier: specifier
          }) : _this52.formatDatum;
        },
        scaleBandwidth: function scaleBandwidth() {
          var _a;
          return (_a = _this52.scale.bandwidth) != null ? _a : 0;
        },
        scaleConvert: function scaleConvert(val) {
          return _this52.scale.convert(val);
        },
        scaleInvert: function scaleInvert(val) {
          var _a, _b;
          return (_b = (_a = _this52.scale).invert) == null ? void 0 : _b.call(_a, val);
        }
      };
    }
  }, {
    key: "animateReadyUpdate",
    value: function animateReadyUpdate(diff2) {
      var animationManager = this.moduleCtx.animationManager;
      var selectionCtx = _prepareAxisAnimationContext(this);
      var fns = _prepareAxisAnimationFunctions(selectionCtx);
      _fromToMotion(this.id, "axis-group", animationManager, [this.axisGroup], fns.group);
      _fromToMotion(this.id, "line", animationManager, [this.lineNode], fns.line);
      _fromToMotion(this.id, "line-paths", animationManager, [this.gridLineGroupSelection, this.tickLineGroupSelection], fns.tick, function (_, d) {
        return d.tickId;
      }, diff2);
      _fromToMotion(this.id, "tick-labels", animationManager, [this.tickLabelGroupSelection], fns.label, function (_, d) {
        return d.tickId;
      }, diff2);
    }
  }, {
    key: "resetSelectionNodes",
    value: function resetSelectionNodes() {
      var gridLineGroupSelection = this.gridLineGroupSelection,
        tickLineGroupSelection = this.tickLineGroupSelection,
        tickLabelGroupSelection = this.tickLabelGroupSelection,
        lineNode = this.lineNode;
      var selectionCtx = _prepareAxisAnimationContext(this);
      _resetMotion([this.axisGroup], _resetAxisGroupFn());
      _resetMotion([gridLineGroupSelection, tickLineGroupSelection], _resetAxisSelectionFn(selectionCtx));
      _resetMotion([tickLabelGroupSelection], _resetAxisLabelSelectionFn());
      _resetMotion([lineNode], _resetAxisLineSelectionFn());
    }
  }, {
    key: "calculateUpdateDiff",
    value: function calculateUpdateDiff(previous, tickData) {
      var added = /* @__PURE__ */new Set();
      var removed = /* @__PURE__ */new Set();
      var tickMap = {};
      var tickCount = Math.max(previous.length, tickData.ticks.length);
      for (var i = 0; i < tickCount; i++) {
        var tickDatum = tickData.ticks[i];
        var prev = previous[i];
        var tick = tickDatum == null ? void 0 : tickDatum.tickId;
        tickMap[tick != null ? tick : prev] = tickDatum;
        if (prev === tick) {
          continue;
        }
        if (removed.has(tick)) {
          removed.delete(tick);
        } else if (tick) {
          added.add(tick);
        }
        if (added.has(prev)) {
          added.delete(prev);
        } else if (prev) {
          removed.add(prev);
        }
      }
      return {
        changed: added.size > 0 || removed.size > 0,
        added: added,
        removed: removed
      };
    }
  }, {
    key: "isReversed",
    value: function isReversed() {
      return this.reverse;
    }
  }, {
    key: "type",
    get: function get() {
      var _a;
      return (_a = this.constructor.type) != null ? _a : "";
    }
  }, {
    key: "crossLines",
    set: function set(value) {
      var _this53 = this;
      var _a, _b;
      (_a = this._crossLines) == null ? void 0 : _a.forEach(function (crossLine) {
        return _this53.detachCrossLine(crossLine);
      });
      if (value) {
        this.assignCrossLineArrayConstructor(value);
      }
      this._crossLines = value;
      (_b = this._crossLines) == null ? void 0 : _b.forEach(function (crossLine) {
        _this53.attachCrossLine(crossLine);
        _this53.initCrossLine(crossLine);
      });
    },
    get: function get() {
      return this._crossLines;
    }
  }]);
  return _Axis;
}();
_Axis.defaultTickMinSpacing = 50;
__decorateClass([_Validate(_BOOLEAN)], _Axis.prototype, "nice", 2);
__decorateClass([_Validate(_BOOLEAN)], _Axis.prototype, "reverse", 2);
__decorateClass([_Validate(_STRING_ARRAY)], _Axis.prototype, "keys", 2);
__decorateClass([_Validate(_OBJECT, {
  optional: true
})], _Axis.prototype, "title", 2);
__decorateClass([_ObserveChanges(function (target, value, oldValue) {
  return target.onGridLengthChange(value, oldValue);
})], _Axis.prototype, "gridLength", 2);
var _Axis4 = _Axis;

// packages/ag-charts-community/src/chart/axis/cartesianAxisLabel.ts
var CartesianAxisLabel = /*#__PURE__*/function (_AxisLabel) {
  _inherits(CartesianAxisLabel, _AxisLabel);
  function CartesianAxisLabel() {
    var _this54;
    _classCallCheck(this, CartesianAxisLabel);
    _this54 = _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxisLabel).apply(this, arguments));
    _this54.autoRotateAngle = 335;
    return _this54;
  }
  return CartesianAxisLabel;
}(_AxisLabel3);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], CartesianAxisLabel.prototype, "autoRotate", 2);
__decorateClass([_Validate(_DEGREE)], CartesianAxisLabel.prototype, "autoRotateAngle", 2);

// packages/ag-charts-community/src/chart/axis/cartesianAxis.ts
var _CartesianAxis = /*#__PURE__*/function (_Axis2) {
  _inherits(_CartesianAxis, _Axis2);
  function _CartesianAxis() {
    var _this55;
    _classCallCheck(this, _CartesianAxis);
    _this55 = _possibleConstructorReturn(this, _getPrototypeOf(_CartesianAxis).apply(this, arguments));
    _this55.thickness = 0;
    _this55.position = "left";
    return _this55;
  }
  _createClass(_CartesianAxis, [{
    key: "updateDirection",
    value: function updateDirection() {
      switch (this.position) {
        case "top":
          this.rotation = -90;
          this.label.mirrored = true;
          this.label.parallel = true;
          break;
        case "right":
          this.rotation = 0;
          this.label.mirrored = true;
          this.label.parallel = false;
          break;
        case "bottom":
          this.rotation = -90;
          this.label.mirrored = false;
          this.label.parallel = true;
          break;
        case "left":
          this.rotation = 0;
          this.label.mirrored = false;
          this.label.parallel = false;
          break;
      }
      if (this.axisContext) {
        this.axisContext.position = this.position;
        this.axisContext.direction = this.direction;
      }
    }
  }, {
    key: "update",
    value: function update(primaryTickCount, animated) {
      this.updateDirection();
      return _superPropGet(_CartesianAxis, "update", this, 3)([primaryTickCount, animated]);
    }
  }, {
    key: "calculateLayout",
    value: function calculateLayout(primaryTickCount) {
      this.updateDirection();
      return _superPropGet(_CartesianAxis, "calculateLayout", this, 3)([primaryTickCount]);
    }
  }, {
    key: "createAxisContext",
    value: function createAxisContext() {
      return __spreadProps(__spreadValues({}, _superPropGet(_CartesianAxis, "createAxisContext", this, 3)([])), {
        position: this.position
      });
    }
  }, {
    key: "assignCrossLineArrayConstructor",
    value: function assignCrossLineArrayConstructor(crossLines) {
      _assignJsonApplyConstructedArray(crossLines, CartesianCrossLine);
    }
  }, {
    key: "createLabel",
    value: function createLabel() {
      return new CartesianAxisLabel();
    }
  }, {
    key: "direction",
    get: function get() {
      return ["top", "bottom"].includes(this.position) ? "x" /* X */ : "y" /* Y */;
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _CartesianAxis;
    }
  }]);
  return _CartesianAxis;
}(_Axis4);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _CartesianAxis.prototype, "thickness", 2);
__decorateClass([_Validate(POSITION2)], _CartesianAxis.prototype, "position", 2);
var _CartesianAxis6 = _CartesianAxis;

// packages/ag-charts-community/src/chart/axis/categoryAxis.ts
var _CategoryAxisTick = /*#__PURE__*/function (_AxisTick) {
  _inherits(CategoryAxisTick, _AxisTick);
  function CategoryAxisTick() {
    var _this56;
    _classCallCheck(this, CategoryAxisTick);
    _this56 = _possibleConstructorReturn(this, _getPrototypeOf(CategoryAxisTick).apply(this, arguments));
    _this56.minSpacing = NaN;
    return _this56;
  }
  return CategoryAxisTick;
}(_AxisTick4);
__decorateClass([_Validate(_MIN_SPACING), _Default(NaN)], _CategoryAxisTick.prototype, "minSpacing", 2);
var _CategoryAxis = /*#__PURE__*/function (_CartesianAxis2) {
  _inherits(CategoryAxis, _CartesianAxis2);
  function CategoryAxis(moduleCtx) {
    var _this57;
    var scale2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _BandScale3();
    _classCallCheck(this, CategoryAxis);
    _this57 = _possibleConstructorReturn(this, _getPrototypeOf(CategoryAxis).call(this, moduleCtx, scale2));
    _this57._paddingOverrideEnabled = false;
    _this57.groupPaddingInner = 0.1;
    _this57.includeInvisibleDomains = true;
    return _this57;
  }
  _createClass(CategoryAxis, [{
    key: "createTick",
    value: function createTick() {
      return new _CategoryAxisTick();
    }
  }, {
    key: "normaliseDataDomain",
    value: function normaliseDataDomain(d) {
      var domain = [];
      var uniqueValues = /* @__PURE__ */new Set();
      var _iterator74 = _createForOfIteratorHelper(d),
        _step74;
      try {
        for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
          var v = _step74.value;
          var key = v instanceof Date ? v.getTime() : v;
          if (!uniqueValues.has(key)) {
            uniqueValues.add(key);
            domain.push(v);
          }
        }
      } catch (err) {
        _iterator74.e(err);
      } finally {
        _iterator74.f();
      }
      return {
        domain: domain,
        clipped: false
      };
    }
  }, {
    key: "calculateDomain",
    value: function calculateDomain() {
      if (!this._paddingOverrideEnabled) {
        var paddings = this.boundSeries.map(function (s) {
          var _a;
          return (_a = s.getBandScalePadding) == null ? void 0 : _a.call(s);
        }).filter(function (p) {
          return p != null;
        });
        if (paddings.length > 0) {
          this.scale.paddingInner = Math.min.apply(Math, _toConsumableArray(paddings.map(function (p) {
            return p.inner;
          })));
          this.scale.paddingOuter = Math.max.apply(Math, _toConsumableArray(paddings.map(function (p) {
            return p.outer;
          })));
        }
      }
      return _superPropGet(CategoryAxis, "calculateDomain", this, 3)([]);
    }
  }, {
    key: "paddingInner",
    set: function set(value) {
      this._paddingOverrideEnabled = true;
      this.scale.paddingInner = value;
    },
    get: function get() {
      this._paddingOverrideEnabled = true;
      return this.scale.paddingInner;
    }
  }, {
    key: "paddingOuter",
    set: function set(value) {
      this.scale.paddingOuter = value;
    },
    get: function get() {
      return this.scale.paddingOuter;
    }
  }]);
  return CategoryAxis;
}(_CartesianAxis6);
_CategoryAxis.className = "CategoryAxis";
_CategoryAxis.type = "category";
__decorateClass([_Validate(_RATIO)], _CategoryAxis.prototype, "groupPaddingInner", 2);

// packages/ag-charts-community/src/chart/axis/tree.ts
var TreeNode = /*#__PURE__*/function () {
  // current number in sibling group (index)
  function TreeNode() {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var parent = arguments.length > 1 ? arguments[1] : undefined;
    var number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    _classCallCheck(this, TreeNode);
    this.x = 0;
    this.y = 0;
    this.subtreeLeft = NaN;
    this.subtreeRight = NaN;
    this.screenX = 0;
    this.screenY = 0;
    this.children = [];
    this.leafCount = 0;
    this.prelim = 0;
    this.mod = 0;
    this.ancestor = this;
    this.change = 0;
    this.shift = 0;
    this.label = label;
    this.parent = parent;
    this.depth = parent ? parent.depth + 1 : 0;
    this.number = number;
  }
  _createClass(TreeNode, [{
    key: "getLeftSibling",
    value: function getLeftSibling() {
      return this.number > 0 && this.parent ? this.parent.children[this.number - 1] : void 0;
    }
  }, {
    key: "getLeftmostSibling",
    value: function getLeftmostSibling() {
      return this.number > 0 && this.parent ? this.parent.children[0] : void 0;
    } // traverse the left contour of a subtree, return the successor of v on this contour
  }, {
    key: "nextLeft",
    value: function nextLeft() {
      return this.children ? this.children[0] : this.thread;
    } // traverse the right contour of a subtree, return the successor of v on this contour
  }, {
    key: "nextRight",
    value: function nextRight() {
      return this.children ? this.children[this.children.length - 1] : this.thread;
    }
  }, {
    key: "getSiblings",
    value: function getSiblings() {
      var _this58 = this;
      return this.parent ? this.parent.children.filter(function (_, i) {
        return i !== _this58.number;
      }) : [];
    }
  }]);
  return TreeNode;
}();
function ticksToTree(ticks) {
  var pad2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var root = new TreeNode();
  var depth = 0;
  if (pad2) {
    ticks.forEach(function (tick) {
      return depth = Math.max(depth, tick.labels.length);
    });
  }
  ticks.forEach(function (tick) {
    if (pad2) {
      while (tick.labels.length < depth) {
        tick.labels.unshift("");
      }
    }
    insertTick(root, tick);
  });
  return root;
}
function insertTick(root, tick) {
  var pathParts = tick.labels.slice().reverse();
  var lastPartIndex = pathParts.length - 1;
  pathParts.forEach(function (pathPart, partIndex) {
    var children = root.children;
    var existingNode = children.find(function (child) {
      return child.label === pathPart;
    });
    var isNotLeaf = partIndex !== lastPartIndex;
    if (existingNode && isNotLeaf) {
      root = existingNode;
    } else {
      var node = new TreeNode(pathPart, root);
      node.number = children.length;
      children.push(node);
      if (isNotLeaf) {
        root = node;
      }
    }
  });
}
function moveSubtree(wm, wp, shift) {
  var subtrees = wp.number - wm.number;
  var ratio = shift / subtrees;
  wp.change -= ratio;
  wp.shift += shift;
  wm.change += ratio;
  wp.prelim += shift;
  wp.mod += shift;
}
function ancestor(vim, v, defaultAncestor) {
  return v.getSiblings().indexOf(vim.ancestor) >= 0 ? vim.ancestor : defaultAncestor;
}
function executeShifts(v) {
  var children = v.children;
  if (children) {
    var shift = 0;
    var change = 0;
    for (var i = children.length - 1; i >= 0; i--) {
      var w = children[i];
      w.prelim += shift;
      w.mod += shift;
      change += w.change;
      shift += w.shift + change;
    }
  }
}
function apportion(v, defaultAncestor, distance2) {
  var w = v.getLeftSibling();
  if (w) {
    var vop = v;
    var vip = v;
    var vim = w;
    var vom = vip.getLeftmostSibling();
    var sip = vip.mod;
    var sop = vop.mod;
    var sim = vim.mod;
    var som = vom.mod;
    while (vim.nextRight() && vip.nextLeft()) {
      vim = vim.nextRight();
      vip = vip.nextLeft();
      vom = vom.nextLeft();
      vop = vop.nextRight();
      vop.ancestor = v;
      var shift = vim.prelim + sim - (vip.prelim + sip) + distance2;
      if (shift > 0) {
        moveSubtree(ancestor(vim, v, defaultAncestor), v, shift);
        sip += shift;
        sop += shift;
      }
      sim += vim.mod;
      sip += vip.mod;
      som += vom.mod;
      sop += vop.mod;
    }
    if (vim.nextRight() && !vop.nextRight()) {
      vop.thread = vim.nextRight();
      vop.mod += sim - sop;
    } else {
      if (vip.nextLeft() && !vom.nextLeft()) {
        vom.thread = vip.nextLeft();
        vom.mod += sip - som;
      }
      defaultAncestor = v;
    }
  }
  return defaultAncestor;
}
function firstWalk(node, distance2) {
  var children = node.children;
  if (children.length) {
    var defaultAncestor = children[0];
    children.forEach(function (child) {
      firstWalk(child, distance2);
      defaultAncestor = apportion(child, defaultAncestor, distance2);
    });
    executeShifts(node);
    var midpoint = (children[0].prelim + children.at(-1).prelim) / 2;
    var leftSibling = node.getLeftSibling();
    if (leftSibling) {
      node.prelim = leftSibling.prelim + distance2;
      node.mod = node.prelim - midpoint;
    } else {
      node.prelim = midpoint;
    }
  } else {
    var _leftSibling = node.getLeftSibling();
    node.prelim = _leftSibling ? _leftSibling.prelim + distance2 : 0;
  }
}
var Dimensions = /*#__PURE__*/function () {
  function Dimensions() {
    _classCallCheck(this, Dimensions);
    this.top = Infinity;
    this.right = -Infinity;
    this.bottom = -Infinity;
    this.left = Infinity;
  }
  _createClass(Dimensions, [{
    key: "update",
    value: function update(node, xy) {
      var _xy = xy(node),
        x = _xy.x,
        y = _xy.y;
      if (x > this.right) {
        this.right = x;
      }
      if (x < this.left) {
        this.left = x;
      }
      if (y > this.bottom) {
        this.bottom = y;
      }
      if (y < this.top) {
        this.top = y;
      }
    }
  }]);
  return Dimensions;
}();
function secondWalk(v, m, layout) {
  v.x = v.prelim + m;
  v.y = v.depth;
  layout.update(v);
  v.children.forEach(function (w) {
    return secondWalk(w, m + v.mod, layout);
  });
}
function thirdWalk(v) {
  var children = v.children;
  var leafCount = 0;
  children.forEach(function (w) {
    thirdWalk(w);
    if (w.children.length) {
      leafCount += w.leafCount;
    } else {
      leafCount++;
    }
  });
  v.leafCount = leafCount;
  if (children.length) {
    v.subtreeLeft = children[0].subtreeLeft;
    v.subtreeRight = children[v.children.length - 1].subtreeRight;
    v.x = (v.subtreeLeft + v.subtreeRight) / 2;
  } else {
    v.subtreeLeft = v.x;
    v.subtreeRight = v.x;
  }
}
function treeLayout(root) {
  var layout = new TreeLayout();
  firstWalk(root, 1);
  secondWalk(root, -root.prelim, layout);
  thirdWalk(root);
  return layout;
}
var TreeLayout = /*#__PURE__*/function () {
  function TreeLayout() {
    _classCallCheck(this, TreeLayout);
    this.dimensions = new Dimensions();
    this.leafCount = 0;
    this.nodes = [];
    // One might want to process leaf nodes separately from the rest of the tree.
    // For example, position labels corresponding to leafs vertically, rather than horizontally.
    this.leafNodes = [];
    this.nonLeafNodes = [];
    this.depth = 0;
  }
  _createClass(TreeLayout, [{
    key: "update",
    value: function update(node) {
      this.dimensions.update(node, function (n) {
        return {
          x: n.x,
          y: n.y
        };
      });
      if (node.children.length) {
        this.nonLeafNodes.push(node);
      } else {
        this.leafCount++;
        this.leafNodes.push(node);
      }
      if (node.depth > this.depth) {
        this.depth = node.depth;
      }
      this.nodes.push(node);
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      var shiftX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var shiftY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var flipX = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var xSteps = this.leafCount - 1;
      var ySteps = this.depth;
      var dimensions = this.dimensions;
      var scalingX = 1;
      var scalingY = 1;
      if (width > 0 && xSteps) {
        var existingSpacingX = (dimensions.right - dimensions.left) / xSteps;
        var desiredSpacingX = width / xSteps;
        scalingX = desiredSpacingX / existingSpacingX;
        if (flipX) {
          scalingX = -scalingX;
        }
      }
      if (height > 0 && ySteps) {
        var existingSpacingY = (dimensions.bottom - dimensions.top) / ySteps;
        var desiredSpacingY = height / ySteps;
        scalingY = desiredSpacingY / existingSpacingY;
      }
      var screenDimensions = new Dimensions();
      this.nodes.forEach(function (node) {
        node.screenX = node.x * scalingX;
        node.screenY = node.y * scalingY;
        screenDimensions.update(node, function (n) {
          return {
            x: n.screenX,
            y: n.screenY
          };
        });
      });
      var offsetX = -screenDimensions.left;
      var offsetY = -screenDimensions.top;
      this.nodes.forEach(function (node) {
        node.screenX += offsetX + shiftX;
        node.screenY += offsetY + shiftY;
      });
    }
  }]);
  return TreeLayout;
}();

// packages/ag-charts-community/src/chart/axis/groupedCategoryAxis.ts
var GroupedCategoryAxisLabel = /*#__PURE__*/function (_AxisLabel2) {
  _inherits(GroupedCategoryAxisLabel, _AxisLabel2);
  function GroupedCategoryAxisLabel() {
    var _this59;
    _classCallCheck(this, GroupedCategoryAxisLabel);
    _this59 = _possibleConstructorReturn(this, _getPrototypeOf(GroupedCategoryAxisLabel).apply(this, arguments));
    _this59.grid = false;
    return _this59;
  }
  return GroupedCategoryAxisLabel;
}(_AxisLabel3);
__decorateClass([_Validate(_BOOLEAN)], GroupedCategoryAxisLabel.prototype, "grid", 2);
var _GroupedCategoryAxis = /*#__PURE__*/function (_CartesianAxis3) {
  _inherits(GroupedCategoryAxis, _CartesianAxis3);
  function GroupedCategoryAxis(moduleCtx) {
    var _this60;
    _classCallCheck(this, GroupedCategoryAxis);
    _this60 = _possibleConstructorReturn(this, _getPrototypeOf(GroupedCategoryAxis).call(this, moduleCtx, new _BandScale3()));
    // Label scale (labels are positioned between ticks, tick count = label count + 1).
    // We don't call is `labelScale` for consistency with other axes.
    _this60.tickScale = new _BandScale3();
    _this60.line = new AxisLine();
    _this60.label = new GroupedCategoryAxisLabel();
    _this60.labelColor = "rgba(87, 87, 87, 1)";
    _this60.includeInvisibleDomains = true;
    var _assertThisInitialize = _assertThisInitialized(_this60),
      tickLineGroup = _assertThisInitialize.tickLineGroup,
      tickLabelGroup = _assertThisInitialize.tickLabelGroup,
      gridLineGroup = _assertThisInitialize.gridLineGroup,
      tickScale = _assertThisInitialize.tickScale,
      scale2 = _assertThisInitialize.scale;
    scale2.paddingOuter = 0.1;
    scale2.paddingInner = scale2.paddingOuter * 2;
    _this60.refreshScale();
    tickScale.paddingInner = 1;
    tickScale.paddingOuter = 0;
    _this60.gridLineSelection = _Selection2.select(gridLineGroup, _Line);
    _this60.axisLineSelection = _Selection2.select(tickLineGroup, _Line);
    _this60.separatorSelection = _Selection2.select(tickLineGroup, _Line);
    _this60.labelSelection = _Selection2.select(tickLabelGroup, _Text2);
    return _this60;
  }
  _createClass(GroupedCategoryAxis, [{
    key: "updateRange",
    value: function updateRange() {
      var rr = this.range,
        vr = this.visibleRange,
        scale2 = this.scale;
      var span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
      var shift = span * vr[0];
      var start = rr[0] - shift;
      this.tickScale.range = scale2.range = [start, start + span];
      this.resizeTickTree();
    }
  }, {
    key: "resizeTickTree",
    value: function resizeTickTree() {
      var _a;
      var s = this.scale;
      var range3 = s.domain.length ? [s.convert(s.domain[0]), s.convert(s.domain[s.domain.length - 1])] : s.range;
      var layout = this.tickTreeLayout;
      var lineHeight = this.lineHeight;
      if (layout) {
        layout.resize(Math.abs(range3[1] - range3[0]), layout.depth * lineHeight, (Math.min(range3[0], range3[1]) || 0) + ((_a = s.bandwidth) != null ? _a : 0) / 2, -layout.depth * lineHeight, range3[1] - range3[0] < 0);
      }
    }
  }, {
    key: "onGridVisibilityChange",
    /**
     * The length of the grid. The grid is only visible in case of a non-zero value.
     */
    value: function onGridVisibilityChange() {
      this.gridLineSelection.clear();
      this.labelSelection.clear();
    }
  }, {
    key: "createTick",
    value: function createTick() {
      return new _CategoryAxisTick();
    }
  }, {
    key: "calculateDomain",
    value: function calculateDomain() {
      var _a;
      var direction = this.direction;
      var isNumericX = null;
      var flatDomains = this.boundSeries.filter(function (s) {
        return s.visible;
      }).flatMap(function (series) {
        if (direction === "y" /* Y */ || isNumericX) {
          return series.getDomain(direction);
        }
        if (isNumericX === null) {
          var domain2 = series.getDomain(direction);
          isNumericX = _isNumber(domain2[0]);
          return domain2;
        }
        return [];
      });
      this.setDomain((_a = _extent(flatDomains)) != null ? _a : _unique(flatDomains));
      var domain = this.dataDomain.domain;
      this.tickTreeLayout = treeLayout(ticksToTree(domain));
      this.tickScale.domain = domain.concat("");
      this.resizeTickTree();
    }
    /**
     * Creates/removes/updates the scene graph nodes that constitute the axis.
     * Supposed to be called _manually_ after changing _any_ of the axis properties.
     * This allows to bulk set axis properties before updating the nodes.
     * The node changes made by this method are rendered on the next animation frame.
     * We could schedule this method call automatically on the next animation frame
     * when any of the axis properties change (the way we do when properties of scene graph's
     * nodes change), but this will mean that we first wait for the next animation
     * frame to make changes to the nodes of the axis, then wait for another animation
     * frame to render those changes. It's nice to have everything update automatically,
     * but this extra level of async indirection will not just introduce an unwanted delay,
     * it will also make it harder to reason about the program.
     */
  }, {
    key: "update",
    value: function update() {
      if (!this.computedLayout) {
        return;
      }
      this.updatePosition();
      this.updateTitleCaption();
      this.updateCategoryLabels();
      this.updateSeparators();
      this.updateAxisLines();
      this.updateCategoryGridLines();
      this.resetSelectionNodes();
    }
  }, {
    key: "updateTitleCaption",
    value: function updateTitleCaption() {
      var _titleCaption = this._titleCaption;
      _titleCaption.node.visible = false;
    }
  }, {
    key: "updateCategoryLabels",
    value: function updateCategoryLabels() {
      if (!this.computedLayout) return;
      var tickLabelLayout = this.computedLayout.tickLabelLayout;
      var labelSelection = this.labelSelection.update(tickLabelLayout);
      labelSelection.each(function (node, datum) {
        node.setProperties(datum);
      });
    }
  }, {
    key: "updateSeparators",
    value: function updateSeparators() {
      var _this61 = this;
      if (!this.computedLayout) return;
      var separatorLayout = this.computedLayout.separatorLayout;
      var range3 = this.range;
      var epsilon2 = 1e-7;
      var separatorSelection = this.separatorSelection.update(separatorLayout);
      separatorSelection.each(function (line, datum) {
        line.x1 = datum.x1;
        line.x2 = datum.x2;
        line.y1 = datum.y;
        line.y2 = datum.y;
        line.visible = datum.y >= range3[0] - epsilon2 && datum.y <= range3[1] + epsilon2;
        line.stroke = _this61.tick.color;
        line.fill = void 0;
        line.strokeWidth = 1;
      });
    }
  }, {
    key: "updateAxisLines",
    value: function updateAxisLines() {
      var _this62 = this;
      if (!this.computedLayout) return;
      var axisLineLayout = this.computedLayout.axisLineLayout;
      var axisLineSelection = this.axisLineSelection.update(axisLineLayout);
      axisLineSelection.each(function (line, datum) {
        line.setProperties(__spreadProps(__spreadValues({}, datum), {
          stroke: _this62.line.color,
          strokeWidth: _this62.line.width
        }));
        line.x1 = datum.x;
        line.x2 = datum.x;
        line.y1 = datum.y1;
        line.y2 = datum.y2;
        line.strokeWidth = _this62.line.width;
        line.stroke = _this62.line.color;
      });
    }
  }, {
    key: "updateCategoryGridLines",
    value: function updateCategoryGridLines() {
      var gridLength = this.gridLength,
        gridLine = this.gridLine,
        label = this.label,
        range3 = this.range,
        tickScale = this.tickScale;
      var ticks = tickScale.ticks();
      var sideFlag = label.getSideFlag();
      var gridSelection = this.gridLineSelection.update(gridLength ? ticks : []);
      if (gridLength) {
        var width = gridLine.width,
          style = gridLine.style;
        var styleCount = style.length;
        gridSelection.each(function (line, datum, index) {
          var y = Math.round(tickScale.convert(datum));
          line.x1 = 0;
          line.x2 = -sideFlag * gridLength;
          line.y1 = y;
          line.y2 = y;
          line.visible = y >= range3[0] && y <= range3[1];
          var _style2 = style[index % styleCount],
            stroke = _style2.stroke,
            lineDash = _style2.lineDash;
          line.stroke = stroke;
          line.strokeWidth = width;
          line.lineDash = lineDash;
          line.fill = void 0;
        });
      }
    }
  }, {
    key: "computeLayout",
    value: function computeLayout() {
      var _this63 = this;
      this.updateDirection();
      this.calculateDomain();
      this.updateRange();
      var scale2 = this.scale,
        label = this.label,
        parallel = this.label.parallel,
        callbackCache = this.moduleCtx.callbackCache,
        range3 = this.range,
        title = this.title,
        _this$title = this.title,
        _this$title2 = _this$title === void 0 ? {} : _this$title,
        _this$title2$formatte = _this$title2.formatter,
        formatter = _this$title2$formatte === void 0 ? function (p) {
          return p.defaultValue;
        } : _this$title2$formatte;
      var rangeStart = scale2.range[0];
      var rangeEnd = scale2.range[1];
      var rangeLength = Math.abs(rangeEnd - rangeStart);
      var bandwidth = rangeLength / scale2.domain.length || 0;
      var keepEvery = Math.ceil(label.fontSize / bandwidth);
      var rotation = _toRadians(this.rotation);
      var isHorizontal = Math.abs(Math.cos(rotation)) < 1e-8;
      var sideFlag = label.getSideFlag();
      var lineHeight = this.lineHeight;
      var tickTreeLayout = this.tickTreeLayout;
      var labels = scale2.ticks();
      var treeLabels = tickTreeLayout ? tickTreeLayout.nodes : [];
      var isLabelTree = tickTreeLayout ? tickTreeLayout.depth > 1 : false;
      var _calculateLabelRotati4 = calculateLabelRotation({
          rotation: label.rotation,
          parallel: parallel,
          regularFlipRotation: _normalizeAngle2(rotation - Math.PI / 2),
          parallelFlipRotation: _normalizeAngle2(rotation)
        }),
        defaultRotation = _calculateLabelRotati4.defaultRotation,
        configuredRotation = _calculateLabelRotati4.configuredRotation,
        parallelFlipFlag = _calculateLabelRotati4.parallelFlipFlag;
      var tickLabelLayout = [];
      var copyLabelProps = function copyLabelProps(node) {
        return {
          fill: node.fill,
          fontFamily: node.fontFamily,
          fontSize: node.fontSize,
          fontStyle: node.fontStyle,
          fontWeight: node.fontWeight,
          rotation: node.rotation,
          rotationCenterX: node.rotationCenterX,
          rotationCenterY: node.rotationCenterY,
          text: node.text,
          textAlign: node.textAlign,
          textBaseline: node.textBaseline,
          translationX: node.translationX,
          translationY: node.translationY,
          visible: node.visible,
          x: node.x,
          y: node.y
        };
      };
      var labelBBoxes = /* @__PURE__ */new Map();
      var maxLeafLabelWidth = 0;
      var tempText = new _Text2();
      var setLabelProps = function setLabelProps(datum, index) {
        var _a;
        tempText.setProperties({
          fill: label.color,
          fontFamily: label.fontFamily,
          fontSize: label.fontSize,
          fontStyle: label.fontStyle,
          fontWeight: label.fontWeight,
          textAlign: "center",
          textBaseline: parallelFlipFlag === -1 ? "bottom" : "hanging",
          translationX: datum.screenY - label.fontSize * 0.25,
          translationY: datum.screenX
        });
        if (index === 0) {
          var isCaptionEnabled = (title == null ? void 0 : title.enabled) && labels.length > 0;
          if (!isCaptionEnabled) {
            return false;
          }
          var text = callbackCache.call(formatter, _this63.getTitleFormatterParams());
          tempText.setProperties({
            fill: title.color,
            fontFamily: title.fontFamily,
            fontSize: title.fontSize,
            fontStyle: title.fontStyle,
            fontWeight: title.fontWeight,
            text: text,
            textBaseline: "hanging",
            translationX: datum.screenY - label.fontSize * 0.25,
            translationY: datum.screenX
          });
        } else if (index % keepEvery === 0) {
          var isInRange = datum.screenX >= range3[0] && datum.screenX <= range3[1];
          if (!isInRange) {
            return false;
          }
          if (label.formatter) {
            tempText.text = (_a = callbackCache.call(label.formatter, {
              value: String(datum.label),
              index: index
            })) != null ? _a : String(datum.label);
          } else {
            tempText.text = String(datum.label);
          }
        } else {
          return false;
        }
        return true;
      };
      treeLabels.forEach(function (datum, index) {
        var isVisible = setLabelProps(datum, index);
        if (!isVisible) return;
        var bbox2 = tempText.computeTransformedBBox();
        if (!bbox2) return;
        labelBBoxes.set(index, bbox2);
        var isLeaf = !datum.children.length;
        if (isLeaf && bbox2.width > maxLeafLabelWidth) {
          maxLeafLabelWidth = bbox2.width;
        }
      });
      var labelX = sideFlag * label.padding;
      var labelGrid = this.label.grid;
      var separatorData = [];
      treeLabels.forEach(function (datum, index) {
        var visible = setLabelProps(datum, index);
        var id = index;
        tempText.x = labelX;
        tempText.rotationCenterX = labelX;
        var isLeaf = !datum.children.length;
        if (isLeaf) {
          tempText.rotation = configuredRotation;
          tempText.textAlign = "end";
          tempText.textBaseline = "middle";
        } else {
          tempText.translationX -= maxLeafLabelWidth - lineHeight + _this63.label.padding;
          var availableRange = datum.leafCount * bandwidth;
          var bbox2 = labelBBoxes.get(id);
          if (bbox2 && bbox2.width > availableRange) {
            visible = false;
            labelBBoxes.delete(id);
          } else if (isHorizontal) {
            tempText.rotation = defaultRotation;
          } else {
            tempText.rotation = -Math.PI / 2;
          }
        }
        if (datum.parent && isLabelTree) {
          var y = isLeaf ? datum.screenX - bandwidth / 2 : datum.screenX - datum.leafCount * bandwidth / 2;
          if (isLeaf) {
            if (datum.number !== datum.children.length - 1 || labelGrid) {
              separatorData.push({
                y: y,
                x1: 0,
                x2: -maxLeafLabelWidth - _this63.label.padding * 2
              });
            }
          } else {
            var x = -maxLeafLabelWidth - _this63.label.padding * 2 + datum.screenY;
            separatorData.push({
              y: y,
              x1: x + lineHeight,
              x2: x
            });
          }
        }
        var props;
        if (visible) {
          var _bbox = tempText.computeTransformedBBox();
          if (_bbox) {
            labelBBoxes.set(index, _bbox);
          }
          props = __spreadProps(__spreadValues({}, copyLabelProps(tempText)), {
            visible: visible
          });
        } else {
          labelBBoxes.delete(index);
          props = {
            visible: visible
          };
        }
        tickLabelLayout.push(props);
      });
      var minX = 0;
      separatorData.forEach(function (d) {
        return minX = Math.min(minX, d.x2);
      });
      separatorData.push({
        y: Math.max(rangeStart, rangeEnd),
        x1: 0,
        x2: minX
      });
      var separatorLayout = [];
      var separatorBoxes = [];
      var epsilon2 = 1e-7;
      separatorData.forEach(function (datum) {
        if (datum.y >= range3[0] - epsilon2 && datum.y <= range3[1] + epsilon2) {
          var x1 = datum.x1,
            x2 = datum.x2,
            y = datum.y;
          var separatorBox = new _BBox2(Math.min(x1, x2), y, Math.abs(x1 - x2), 0);
          separatorBoxes.push(separatorBox);
          separatorLayout.push({
            x1: x1,
            x2: x2,
            y: y
          });
        }
      });
      var axisLineLayout = [];
      var axisLineBoxes = [];
      var lineCount = tickTreeLayout ? tickTreeLayout.depth + 1 : 1;
      for (var i = 0; i < lineCount; i++) {
        var visible = labels.length > 0 && (i === 0 || labelGrid && isLabelTree);
        var x = i > 0 ? -maxLeafLabelWidth - this.label.padding * 2 - (i - 1) * lineHeight : 0;
        var lineBox = new _BBox2(x, Math.min.apply(Math, _toConsumableArray(range3)), 0, Math.abs(range3[1] - range3[0]));
        axisLineBoxes.push(lineBox);
        axisLineLayout.push({
          x: x,
          y1: range3[0],
          y2: range3[1],
          visible: visible
        });
      }
      var getTransformBox = function getTransformBox(bbox2) {
        var matrix = new Matrix();
        var _this63$getAxisTransf = _this63.getAxisTransform(),
          axisRotation = _this63$getAxisTransf.rotation,
          translationX = _this63$getAxisTransf.translationX,
          translationY = _this63$getAxisTransf.translationY,
          rotationCenterX = _this63$getAxisTransf.rotationCenterX,
          rotationCenterY = _this63$getAxisTransf.rotationCenterY;
        Matrix.updateTransformMatrix(matrix, 1, 1, axisRotation, translationX, translationY, {
          scalingCenterX: 0,
          scalingCenterY: 0,
          rotationCenterX: rotationCenterX,
          rotationCenterY: rotationCenterY
        });
        return matrix.transformBBox(bbox2);
      };
      var bbox = _BBox2.merge([].concat(_toConsumableArray(labelBBoxes.values()), separatorBoxes, axisLineBoxes));
      var transformedBBox = getTransformBox(bbox);
      return {
        bbox: transformedBBox,
        tickLabelLayout: tickLabelLayout,
        separatorLayout: separatorLayout,
        axisLineLayout: axisLineLayout
      };
    }
  }, {
    key: "calculateLayout",
    value: function calculateLayout() {
      var _this$computeLayout = this.computeLayout(),
        axisLineLayout = _this$computeLayout.axisLineLayout,
        separatorLayout = _this$computeLayout.separatorLayout,
        tickLabelLayout = _this$computeLayout.tickLabelLayout,
        bbox = _this$computeLayout.bbox;
      this.computedLayout = {
        axisLineLayout: axisLineLayout,
        separatorLayout: separatorLayout,
        tickLabelLayout: tickLabelLayout
      };
      return {
        bbox: bbox,
        primaryTickCount: void 0
      };
    }
  }, {
    key: "lineHeight",
    get: function get() {
      return this.label.fontSize * 1.5;
    }
  }]);
  return GroupedCategoryAxis;
}(_CartesianAxis6);
_GroupedCategoryAxis.className = "GroupedCategoryAxis";
_GroupedCategoryAxis.type = "grouped-category";
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _GroupedCategoryAxis.prototype, "labelColor", 2);

// packages/ag-charts-community/src/util/userAgent.ts
function hasConstrainedCanvasMemory() {
  if (typeof navigator === "undefined") {
    return false;
  }
  var iPhoneOSMatch = navigator.userAgent.match(/\(iPhone; CPU iPhone OS (\d+_\d+_\d+) like Mac OS X\)/);
  if (iPhoneOSMatch == null) {
    return false;
  }
  var _iPhoneOSMatch$1$spli = iPhoneOSMatch[1].split("_").map(Number),
    _iPhoneOSMatch$1$spli2 = _slicedToArray(_iPhoneOSMatch$1$spli, 2),
    major = _iPhoneOSMatch$1$spli2[0],
    minor = _iPhoneOSMatch$1$spli2[1];
  return major < 16 || major === 16 && minor < 6;
}

// packages/ag-charts-community/src/scene/canvas/hdpiCanvas.ts
var _HdpiCanvas = /*#__PURE__*/function () {
  function _HdpiCanvas(options) {
    _classCallCheck(this, _HdpiCanvas);
    this.enabled = true;
    this.width = 600;
    this.height = 300;
    var width = options.width,
      height = options.height,
      pixelRatio = options.pixelRatio,
      position = options.position,
      insertAsFirstChild = options.insertAsFirstChild;
    this.insertAsFirstChild = insertAsFirstChild != null ? insertAsFirstChild : false;
    this.pixelRatio = hasConstrainedCanvasMemory() ? 1 : pixelRatio != null ? pixelRatio : _getWindow2("devicePixelRatio");
    this.element = _createElement("canvas");
    this.element.width = Math.round((width != null ? width : this.width) * this.pixelRatio);
    this.element.height = Math.round((height != null ? height : this.height) * this.pixelRatio);
    if (position) {
      this.element.style.position = position;
    }
    this.context = this.element.getContext("2d");
    this.onEnabledChange();
    this.resize(width != null ? width : 0, height != null ? height : 0);
    _HdpiCanvas.debugContext(this.context);
  }
  _createClass(_HdpiCanvas, [{
    key: "drawImage",
    value: function drawImage(context) {
      var dx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var dy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return context.drawImage(this.context.canvas, dx, dy);
    }
  }, {
    key: "toDataURL",
    value: function toDataURL(type) {
      return this.element.toDataURL(type);
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      if (!(width > 0 && height > 0)) return;
      var element2 = this.element,
        context = this.context,
        pixelRatio = this.pixelRatio;
      element2.width = Math.round(width * pixelRatio);
      element2.height = Math.round(height * pixelRatio);
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      element2.style.width = width + "px";
      element2.style.height = height + "px";
      this.width = width;
      this.height = height;
    }
  }, {
    key: "snapshot",
    value: function snapshot() {}
  }, {
    key: "clear",
    value: function clear() {
      this.context.save();
      this.context.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      this.context.clearRect(0, 0, this.width, this.height);
      this.context.restore();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.element.remove();
      this.element.width = 0;
      this.element.height = 0;
      this.context.clearRect(0, 0, 0, 0);
      Object.freeze(this);
    }
  }, {
    key: "onContainerChange",
    value: function onContainerChange(newValue, oldValue) {
      var _a, _b, _c, _d;
      if (newValue === oldValue) return;
      (_a = this.element.parentNode) == null ? void 0 : _a.removeChild(this.element);
      if (this.insertAsFirstChild && ((_b = this.container) == null ? void 0 : _b.firstChild)) {
        (_c = this.container) == null ? void 0 : _c.insertBefore(this.element, this.container.firstChild);
      } else {
        (_d = this.container) == null ? void 0 : _d.appendChild(this.element);
      }
    }
  }, {
    key: "onEnabledChange",
    value: function onEnabledChange() {
      if (this.element) {
        this.element.style.display = this.enabled ? "block" : "none";
      }
    } // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _HdpiCanvas;
    }
  }, {
    key: "debugContext",
    value: function debugContext(ctx) {
      if (Debug.check("canvas")) {
        var _save = ctx.save.bind(ctx);
        var _restore = ctx.restore.bind(ctx);
        var depth = 0;
        Object.assign(ctx, {
          save: function save() {
            _save();
            depth++;
          },
          restore: function restore() {
            if (depth === 0) {
              throw new Error("AG Charts - Unable to restore() past depth 0");
            }
            _restore();
            depth--;
          },
          verifyDepthZero: function verifyDepthZero() {
            if (depth !== 0) {
              throw new Error("AG Charts - Save/restore depth is non-zero: ".concat(depth));
            }
          }
        });
      }
    }
  }]);
  return _HdpiCanvas;
}();
__decorateClass([_ObserveChanges(function (target) {
  return target.onEnabledChange();
})], _HdpiCanvas.prototype, "enabled", 2);
__decorateClass([_ObserveChanges(function (target, newValue, oldValue) {
  return target.onContainerChange(newValue, oldValue);
})], _HdpiCanvas.prototype, "container", 2);
var _HdpiCanvas2 = _HdpiCanvas;

// packages/ag-charts-community/src/scene/layersManager.ts
var LayersManager = /*#__PURE__*/function () {
  function _LayersManager(canvas, markDirty) {
    _classCallCheck(this, _LayersManager);
    this.canvas = canvas;
    this.markDirty = markDirty;
    this.debug = Debug.create(true, "scene");
    this.layersMap = /* @__PURE__ */new Map();
    this.nextZIndex = 0;
    this.nextLayerId = 0;
  }
  _createClass(_LayersManager, [{
    key: "forEach",
    value: function forEach(callback) {
      Array.from(this.layersMap.values()).sort(_LayersManager.sortLayers).forEach(callback);
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.canvas.resize(width, height);
      this.layersMap.forEach(function (_ref68) {
        var canvas = _ref68.canvas;
        return canvas.resize(width, height);
      });
    }
  }, {
    key: "addLayer",
    value: function addLayer(opts) {
      var _this$canvas = this.canvas,
        width = _this$canvas.width,
        height = _this$canvas.height,
        pixelRatio = _this$canvas.pixelRatio;
      var _opts$zIndex = opts.zIndex,
        zIndex = _opts$zIndex === void 0 ? this.nextZIndex++ : _opts$zIndex,
        name = opts.name,
        zIndexSubOrder = opts.zIndexSubOrder,
        getComputedOpacity = opts.getComputedOpacity,
        getVisibility = opts.getVisibility;
      var canvas = new _HdpiCanvas2({
        width: width,
        height: height,
        pixelRatio: pixelRatio,
        position: "absolute"
      });
      var newLayer = {
        id: this.nextLayerId++,
        name: name,
        canvas: canvas,
        zIndex: zIndex,
        zIndexSubOrder: zIndexSubOrder,
        getComputedOpacity: getComputedOpacity,
        getVisibility: getVisibility
      };
      if (zIndex >= this.nextZIndex) {
        this.nextZIndex = zIndex + 1;
      }
      this.layersMap.set(canvas, newLayer);
      this.debug("Scene.addLayer() - layers", this.layersMap);
      return newLayer.canvas;
    }
  }, {
    key: "removeLayer",
    value: function removeLayer(canvas) {
      if (this.layersMap.has(canvas)) {
        this.layersMap.delete(canvas);
        canvas.destroy();
        this.markDirty();
        this.debug("Scene.removeLayer() -  layers", this.layersMap);
      }
    }
  }, {
    key: "moveLayer",
    value: function moveLayer(canvas, newZIndex, newZIndexSubOrder) {
      var layer = this.layersMap.get(canvas);
      if (layer) {
        layer.zIndex = newZIndex;
        layer.zIndexSubOrder = newZIndexSubOrder;
        this.markDirty();
        this.debug("Scene.moveLayer() -  layers", this.layersMap);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.layersMap.clear();
    }
  }, {
    key: "size",
    get: function get() {
      return this.layersMap.size;
    }
  }], [{
    key: "sortLayers",
    value: function sortLayers(a, b) {
      var _a, _b;
      return compoundAscending([a.zIndex].concat(_toConsumableArray((_a = a.zIndexSubOrder) != null ? _a : [void 0, void 0]), [a.id]), [b.zIndex].concat(_toConsumableArray((_b = b.zIndexSubOrder) != null ? _b : [void 0, void 0]), [b.id]), ascendingStringNumberUndefined);
    }
  }]);
  return _LayersManager;
}();

// packages/ag-charts-community/src/scene/sceneDebug.ts
function debugStats(layersManager, debugSplitTimes, ctx, renderCtxStats) {
  var extraDebugStats = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  if (!Debug.check("scene:stats" /* SCENE_STATS */, "scene:stats:verbose" /* SCENE_STATS_VERBOSE */)) return;
  var _ref69 = renderCtxStats != null ? renderCtxStats : {},
    _ref69$layersRendered = _ref69.layersRendered,
    layersRendered = _ref69$layersRendered === void 0 ? 0 : _ref69$layersRendered,
    _ref69$layersSkipped = _ref69.layersSkipped,
    layersSkipped = _ref69$layersSkipped === void 0 ? 0 : _ref69$layersSkipped,
    _ref69$nodesRendered = _ref69.nodesRendered,
    nodesRendered = _ref69$nodesRendered === void 0 ? 0 : _ref69$nodesRendered,
    _ref69$nodesSkipped = _ref69.nodesSkipped,
    nodesSkipped = _ref69$nodesSkipped === void 0 ? 0 : _ref69$nodesSkipped;
  var end = performance.now();
  var _a = debugSplitTimes,
    start = _a.start,
    durations = __objRest(_a, ["start"]);
  var splits = Object.entries(durations).map(function (_ref70) {
    var _ref71 = _slicedToArray(_ref70, 2),
      n = _ref71[0],
      t = _ref71[1];
    return time(n, t);
  }).filter(function (v) {
    return v != null;
  }).join(" + ");
  var extras = Object.entries(extraDebugStats).map(function (_ref72) {
    var _ref73 = _slicedToArray(_ref72, 2),
      k = _ref73[0],
      v = _ref73[1];
    return "".concat(k, ": ").concat(v);
  }).join(" ; ");
  var detailedStats = Debug.check("scene:stats:verbose" /* SCENE_STATS_VERBOSE */);
  var stats = ["".concat(time("\u23F1\uFE0F", start, end), " (").concat(splits, ")"), "".concat(extras), "Layers: ".concat(detailedStats ? pct(layersRendered, layersSkipped) : layersManager.size), detailedStats ? "Nodes: ".concat(pct(nodesRendered, nodesSkipped)) : null].filter(_isString);
  var statsSize = new Map(stats.map(function (t) {
    return [t, _Text2.getTextSize(t, ctx.font)];
  }));
  var width = Math.max.apply(Math, _toConsumableArray(Array.from(statsSize.values(), function (s) {
    return s.width;
  })));
  var height = accumulate(statsSize.values(), function (s) {
    return s.height;
  });
  ctx.save();
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "black";
  var y = 0;
  var _iterator75 = _createForOfIteratorHelper(statsSize.entries()),
    _step75;
  try {
    for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
      var _step75$value = _slicedToArray(_step75.value, 2),
        stat = _step75$value[0],
        size = _step75$value[1];
      y += size.height;
      ctx.fillText(stat, 2, y);
    }
  } catch (err) {
    _iterator75.e(err);
  } finally {
    _iterator75.f();
  }
  ctx.restore();
}
function debugSceneNodeHighlight(ctx, debugNodes) {
  ctx.save();
  for (var _i15 = 0, _Object$entries4 = Object.entries(debugNodes); _i15 < _Object$entries4.length; _i15++) {
    var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i15], 2),
      name = _Object$entries4$_i[0],
      node = _Object$entries4$_i[1];
    var bbox = node.computeTransformedBBox();
    if (!bbox) {
      _Logger.log("Scene.render() - no bbox for debugged node [".concat(name, "]."));
      continue;
    }
    ctx.globalAlpha = 0.8;
    ctx.strokeStyle = "red";
    ctx.lineWidth = 1;
    ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);
    ctx.fillStyle = "red";
    ctx.strokeStyle = "white";
    ctx.font = "16px sans-serif";
    ctx.textBaseline = "top";
    ctx.textAlign = "left";
    ctx.lineWidth = 2;
    ctx.strokeText(name, bbox.x, bbox.y, bbox.width);
    ctx.fillText(name, bbox.x, bbox.y, bbox.width);
  }
  ctx.restore();
}
function buildTree(node) {
  var _a, _b;
  if (!Debug.check(true, "scene" /* SCENE */)) return {};
  return __spreadValues(__spreadValues({
    node: node,
    name: (_a = node instanceof _Group4 ? node.name : null) != null ? _a : node.id,
    dirty: _RedrawType[node.dirty]
  }, ((_b = node.parent) == null ? void 0 : _b.isVirtual) ? {
    virtualParentDirty: _RedrawType[node.parent.dirty],
    virtualParent: node.parent
  } : {}), node.children.map(function (c) {
    return buildTree(c);
  }).reduce(function (result, childTree) {
    var treeNodeName = childTree.name;
    var _childTree$node = childTree.node,
      visible = _childTree$node.visible,
      opacity = _childTree$node.opacity,
      zIndex = _childTree$node.zIndex,
      zIndexSubOrder = _childTree$node.zIndexSubOrder,
      childNode = childTree.node,
      virtualParent = childTree.virtualParent;
    if (!visible || opacity <= 0) {
      treeNodeName = "(".concat(treeNodeName, ")");
    }
    if (childNode instanceof _Group4 && childNode.isLayer()) {
      treeNodeName = "*".concat(treeNodeName, "*");
    }
    var key = ["".concat(treeNodeName != null ? treeNodeName : "<unknown>"), "z: ".concat(zIndex), zIndexSubOrder && "zo: ".concat(zIndexSubOrder.map(function (v) {
      return typeof v === "function" ? "".concat(v(), " (fn)") : v;
    }).join(" / ")), virtualParent && "(virtual parent)"].filter(function (v) {
      return !!v;
    }).join(" ");
    var selectedKey = key;
    var index = 1;
    while (result[selectedKey] != null && index < 100) {
      selectedKey = "".concat(key, " (").concat(index++, ")");
    }
    result[selectedKey] = childTree;
    return result;
  }, {}));
}
function buildDirtyTree(node) {
  var _a;
  if (node.dirty === 0 /* NONE */) {
    return {
      dirtyTree: {},
      paths: []
    };
  }
  var childrenDirtyTree = node.children.map(function (c) {
    return buildDirtyTree(c);
  }).filter(function (c) {
    return c.paths.length > 0;
  });
  var name = _Group4.is(node) ? (_a = node.name) != null ? _a : node.id : node.id;
  var paths = childrenDirtyTree.length ? childrenDirtyTree.flatMap(function (c) {
    return c.paths;
  }).map(function (p) {
    return "".concat(name, ".").concat(p);
  }) : [name];
  return {
    dirtyTree: __spreadValues({
      name: name,
      node: node,
      dirty: _RedrawType[node.dirty]
    }, childrenDirtyTree.map(function (c) {
      return c.dirtyTree;
    }).filter(function (t) {
      return t.dirty != null;
    }).reduce(function (result, childTree) {
      var _a2;
      result[(_a2 = childTree.name) != null ? _a2 : "<unknown>"] = childTree;
      return result;
    }, {})),
    paths: paths
  };
}
function pct(rendered, skipped) {
  var total = rendered + skipped;
  return "".concat(rendered, " / ").concat(total, " (").concat(Math.round(100 * rendered / total), "%)");
}
function time(name, start, end) {
  var duration = end != null ? end - start : start;
  return "".concat(name, ": ").concat(Math.round(duration * 100) / 100, "ms");
}
function accumulate(iterator, mapper) {
  var sum2 = 0;
  var _iterator76 = _createForOfIteratorHelper(iterator),
    _step76;
  try {
    for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
      var item = _step76.value;
      sum2 += mapper(item);
    }
  } catch (err) {
    _iterator76.e(err);
  } finally {
    _iterator76.f();
  }
  return sum2;
}

// packages/ag-charts-community/src/scene/scene.ts
var _Scene = /*#__PURE__*/function () {
  function Scene(_ref74) {
    var _this64 = this;
    var width = _ref74.width,
      height = _ref74.height,
      pixelRatio = _ref74.pixelRatio,
      canvasPosition = _ref74.canvasPosition;
    _classCallCheck(this, Scene);
    this.debug = Debug.create(true, "scene" /* SCENE */);
    this.id = _createId(this);
    this.root = null;
    this.isDirty = false;
    this.canvas = new _HdpiCanvas2({
      width: width,
      height: height,
      pixelRatio: pixelRatio,
      position: canvasPosition,
      insertAsFirstChild: canvasPosition === "absolute"
    });
    this.layersManager = new LayersManager(this.canvas, function () {
      _this64.isDirty = true;
    });
  }
  _createClass(Scene, [{
    key: "setContainer",
    value: function setContainer(value) {
      this.canvas.container = value;
      return this;
    }
  }, {
    key: "setRoot",
    value: function setRoot(node) {
      var _a;
      if (this.root === node) {
        return this;
      }
      this.isDirty = true;
      (_a = this.root) == null ? void 0 : _a._setLayerManager();
      this.root = node;
      if (node) {
        node.visible = true;
        node._setLayerManager(this.layersManager);
      }
      return this;
    }
  }, {
    key: "attachNode",
    value: function attachNode(node) {
      var _this65 = this;
      var _a;
      (_a = this.root) == null ? void 0 : _a.appendChild(node);
      return function () {
        return _this65.removeChild(node);
      };
    }
  }, {
    key: "appendChild",
    value: function appendChild(node) {
      var _a;
      (_a = this.root) == null ? void 0 : _a.appendChild(node);
      return this;
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      var _a;
      (_a = this.root) == null ? void 0 : _a.removeChild(node);
      return this;
    }
  }, {
    key: "download",
    value: function download(fileName, fileFormat) {
      var _a;
      _downloadUrl(this.canvas.toDataURL(fileFormat), (_a = fileName == null ? void 0 : fileName.trim()) != null ? _a : "image");
    } /** NOTE: Integrated Charts undocumented image download method. */
  }, {
    key: "getDataURL",
    value: function getDataURL(fileFormat) {
      return this.canvas.toDataURL(fileFormat);
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      width = Math.round(width);
      height = Math.round(height);
      if (width > 0 && height > 0 && (width !== this.width || height !== this.height)) {
        this.pendingSize = [width, height];
        this.isDirty = true;
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee() {
        var _a, _b, _ref75, _ref75$debugSplitTime, debugSplitTimes, extraDebugStats, canvas, _this$canvas2, _this$canvas3, ctx, root, pendingSize, renderStartTime, _this$layersManager, renderCtx, canvasCleared, _buildDirtyTree, dirtyTree, paths, layerRenderStart;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _ref75 = opts != null ? opts : {}, _ref75$debugSplitTime = _ref75.debugSplitTimes, debugSplitTimes = _ref75$debugSplitTime === void 0 ? {
                start: performance.now()
              } : _ref75$debugSplitTime, extraDebugStats = _ref75.extraDebugStats;
              canvas = this.canvas, _this$canvas2 = this.canvas, _this$canvas3 = _this$canvas2 === void 0 ? {} : _this$canvas2, ctx = _this$canvas3.context, root = this.root, pendingSize = this.pendingSize;
              if (ctx) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              renderStartTime = performance.now();
              if (pendingSize) {
                (_this$layersManager = this.layersManager).resize.apply(_this$layersManager, _toConsumableArray(pendingSize));
                this.pendingSize = void 0;
              }
              if (!(root && !root.visible)) {
                _context9.n = 2;
                break;
              }
              this.isDirty = false;
              return _context9.a(2);
            case 2:
              if (!(root && !this.isDirty)) {
                _context9.n = 3;
                break;
              }
              if (this.debug.check()) {
                this.debug("Scene.render() - no-op", {
                  redrawType: _RedrawType[root.dirty],
                  tree: buildTree(root)
                });
              }
              debugStats(this.layersManager, debugSplitTimes, ctx, void 0, extraDebugStats);
              return _context9.a(2);
            case 3:
              renderCtx = {
                ctx: ctx,
                devicePixelRatio: (_a = this.canvas.pixelRatio) != null ? _a : 1,
                forceRender: true,
                resized: Boolean(pendingSize),
                debugNodes: {}
              };
              if (Debug.check("scene:stats:verbose" /* SCENE_STATS_VERBOSE */)) {
                renderCtx.stats = {
                  layersRendered: 0,
                  layersSkipped: 0,
                  nodesRendered: 0,
                  nodesSkipped: 0
                };
              }
              canvasCleared = false;
              if (!root || root.dirty >= 1 /* TRIVIAL */) {
                canvasCleared = true;
                canvas.clear();
              }
              if (root && Debug.check("scene:dirtyTree" /* SCENE_DIRTY_TREE */)) {
                _buildDirtyTree = buildDirtyTree(root), dirtyTree = _buildDirtyTree.dirtyTree, paths = _buildDirtyTree.paths;
                Debug.create("scene:dirtyTree" /* SCENE_DIRTY_TREE */)("Scene.render() - dirtyTree", {
                  dirtyTree: dirtyTree,
                  paths: paths
                });
              }
              if (root && canvasCleared) {
                this.debug("Scene.render() - before", {
                  redrawType: _RedrawType[root.dirty],
                  canvasCleared: canvasCleared,
                  tree: buildTree(root)
                });
                if (root.visible) {
                  root.preRender();
                  ctx.save();
                  root.render(renderCtx);
                  ctx.restore();
                }
              }
              debugSplitTimes["\u270D\uFE0F"] = performance.now() - renderStartTime;
              if (this.layersManager.size && canvasCleared) {
                layerRenderStart = performance.now();
                ctx.save();
                ctx.resetTransform();
                this.layersManager.forEach(function (layer) {
                  if (layer.canvas.enabled && layer.getVisibility()) {
                    ctx.globalAlpha = layer.getComputedOpacity();
                    layer.canvas.drawImage(ctx);
                  }
                });
                ctx.restore();
                debugSplitTimes["\u26D9"] = performance.now() - layerRenderStart;
              }
              (_b = ctx.verifyDepthZero) == null ? void 0 : _b.call(ctx);
              this.isDirty = false;
              debugStats(this.layersManager, debugSplitTimes, ctx, renderCtx.stats, extraDebugStats);
              debugSceneNodeHighlight(ctx, renderCtx.debugNodes);
              if (root && this.debug.check()) {
                this.debug("Scene.render() - after", {
                  redrawType: _RedrawType[root.dirty],
                  tree: buildTree(root),
                  canvasCleared: canvasCleared
                });
              }
            case 4:
              return _context9.a(2);
          }
        }, _callee, this);
      }));
    } /** Alternative to destroy() that preserves re-usable resources. */
  }, {
    key: "strip",
    value: function strip() {
      var _this$canvas4 = this.canvas,
        context = _this$canvas4.context,
        pixelRatio = _this$canvas4.pixelRatio;
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      this.layersManager.clear();
      this.setRoot(null);
      this.isDirty = false;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.canvas.container = void 0;
      this.strip();
      this.canvas.destroy();
      Object.assign(this, {
        canvas: void 0
      });
    }
  }, {
    key: "width",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.pendingSize) == null ? void 0 : _a[0]) != null ? _b : this.canvas.width;
    }
  }, {
    key: "height",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.pendingSize) == null ? void 0 : _a[1]) != null ? _b : this.canvas.height;
    }
  }]);
  return Scene;
}();
_Scene.className = "Scene";

// packages/ag-charts-community/src/styles/icons.ts
var icons_default = "\n[class^='ag-charts-icon'] {\n    display: block;\n    /* speak: none; */\n    mask-size: contain;\n    mask-repeat: no-repeat;\n    background-color: currentColor;\n}\n\n.ag-charts-icon-zoom-in {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXpvb20taW4iPjxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjgiLz48bGluZSB4MT0iMjEiIHgyPSIxNi42NSIgeTE9IjIxIiB5Mj0iMTYuNjUiLz48bGluZSB4MT0iMTEiIHgyPSIxMSIgeTE9IjgiIHkyPSIxNCIvPjxsaW5lIHgxPSI4IiB4Mj0iMTQiIHkxPSIxMSIgeTI9IjExIi8+PC9zdmc+);\n}\n\n.ag-charts-icon-zoom-out {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXpvb20tb3V0Ij48Y2lyY2xlIGN4PSIxMSIgY3k9IjExIiByPSI4Ii8+PGxpbmUgeDE9IjIxIiB4Mj0iMTYuNjUiIHkxPSIyMSIgeTI9IjE2LjY1Ii8+PGxpbmUgeDE9IjgiIHgyPSIxNCIgeTE9IjExIiB5Mj0iMTEiLz48L3N2Zz4=);\n}\n\n.ag-charts-icon-reset {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXJvdGF0ZS1jY3ciPjxwYXRoIGQ9Ik0zIDEyYTkgOSAwIDEgMCA5LTkgOS43NSA5Ljc1IDAgMCAwLTYuNzQgMi43NEwzIDgiLz48cGF0aCBkPSJNMyAzdjVoNSIvPjwvc3ZnPg==);\n}\n\n.ag-charts-icon-pan-left {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tbGVmdCI+PHBhdGggZD0ibTE1IDE4LTYtNiA2LTYiLz48L3N2Zz4=);\n}\n\n.ag-charts-icon-pan-right {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tcmlnaHQiPjxwYXRoIGQ9Im05IDE4IDYtNi02LTYiLz48L3N2Zz4=);\n}\n\n.ag-charts-icon-pan-start {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tZmlyc3QiPjxwYXRoIGQ9Im0xNyAxOC02LTYgNi02Ii8+PHBhdGggZD0iTTcgNnYxMiIvPjwvc3ZnPg==);\n}\n\n.ag-charts-icon-pan-end {\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tbGFzdCI+PHBhdGggZD0ibTcgMTggNi02LTYtNiIvPjxwYXRoIGQ9Ik0xNyA2djEyIi8+PC9zdmc+);\n}\n\n";

// packages/ag-charts-community/src/styles/reset.ts
var reset_default = "\n[class^='ag-charts'],\n[class^='ag-charts']:focus,\n[class^='ag-charts']:after,\n[class^='ag-charts']:before {\n    box-sizing: border-box;\n    outline: none;\n}\n\nbutton[class^='ag-charts'] {\n    background: none;\n    border: 0;\n}\n\n";

// packages/ag-charts-community/src/styles/theme-default.ts
var theme_default_default = "\n.ag-charts-theme-default,\n.ag-charts-theme-default-dark {\n    /* Colors */\n    --ag-charts-active-color: var(--ag-active-color, #2196f3);\n    --ag-charts-background-color: var(--ag-background-color, #fff);\n    --ag-charts-foreground-color: var(--ag-foreground-color, #181d1f);\n    --ag-charts-border-color: var(--ag-border-color, #dddddd);\n\n    /* Sizing */\n    --ag-charts-font-size: var(--ag-font-size, 14px);\n    --ag-charts-size: var(--ag-grid-size, 8px);\n\n    /* Borders */\n    --ag-charts-border: var(--ag-borders, solid 1px);\n    --ag-charts-border-critical: var(--ag-borders-critical, solid 1px);\n\n    /* Toolbar */\n    --ag-charts-toolbar-foreground-color: var(--ag-header-foreground-color, var(--ag-charts-foreground-color));\n    --ag-charts-toolbar-background-color: var(\n        --ag-header-background-color,\n        color-mix(in srgb, var(--ag-charts-background-color), var(--ag-charts-foreground-color) 2%)\n    );\n    --ag-charts-toolbar-size: var(--ag-header-height, 48px);\n    --ag-charts-toolbar-padding: calc(var(--ag-charts-size) * 2);\n    --ag-charts-toolbar-border: var(--ag-charts-border, solid 1px) var(--ag-charts-border-color);\n    --ag-charts-toolbar-border-critical: var(--ag-charts-border-critical, solid 1px) var(--ag-charts-border-color);\n    --ag-charts-toolbar-hover-color: color-mix(in srgb, var(--ag-charts-background-color), var(--ag-charts-active-color) 12%);\n    --ag-charts-toolbar-disabled-foreground-color: var(\n        --ag-disabled-foreground-color,\n        color-mix(in srgb, transparent, var(--ag-charts-toolbar-foreground-color) 50%)\n    );\n    --ag-charts-toolbar-disabled-background-color: var(\n        --ag-input-disabled-background-color,\n        color-mix(in srgb, var(--ag-charts-toolbar-background-color), var(--ag-charts-toolbar-foreground-color) 6%)\n    );\n    --ag-charts-toolbar-gap: var(--ag-charts-size);\n\n    /* Buttons */\n    --ag-charts-button-padding: var(--ag-charts-size);\n    --ag-charts-button-radius: var(--ag-border-radius, 4px);\n\n    /* Focus Indicator */\n    --ag-charts-focus-border: solid 2px var(--ag-input-focus-border-color, var(--ag-charts-active-color));\n    --ag-charts-focus-border-shadow: var(--ag-input-focus-box-shadow, 0 0 0 3px color-mix(in srgb, transparent, var(--ag-charts-focus-border) 47%));\n\n    /* Icons */\n    --ag-charts-icon-font-family: 'agChartsDefault';\n    --ag-charts-icon-font-weight: normal;\n    --ag-charts-icon-font-color: color-mix(in srgb, transparent, var(--ag-charts-foreground-color), 90%);\n}\n\n";

// packages/ag-charts-community/src/styles/theme-default-dark.ts
var theme_default_dark_default = "\n.ag-charts-theme-default-dark {\n    /* Colors */\n    --ag-charts-background-color: var(--ag-background-color, color-mix(in srgb, #fff, #182230 97%));\n    --ag-charts-foreground-color: var(--ag-foreground-color, #fff);\n    --ag-charts-border-color: var(--ag-border-color, rgba(255, 255, 255, 0.16));\n    --ag-charts-hover-color: var(\n        --ag-row-hover-color,\n        color-mix(in srgb, transparent, var(--ag-charts-active-color) 20%)\n    );\n\n    /* Toolbar */\n    --ag-charts-toolbar-background-color: var(--ag-header-background-color, color-mix(in srgb, #fff, #182230 93%));\n}\n\n";

// packages/ag-charts-community/src/styles/styles.ts
var styles_default = "\n/* Reset */\n".concat(reset_default, "\n\n/* Icons */\n").concat(icons_default, "\n\n/* AG Charts Theme Default */\n").concat(theme_default_default, "\n\n/* AG Charts Theme Default Dark */\n").concat(theme_default_dark_default, "\n");

// packages/ag-charts-community/src/util/async.ts
function sleep(sleepTimeoutMs) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(void 0);
    }, sleepTimeoutMs);
  });
}

// packages/ag-charts-community/src/util/mutex.ts
var Mutex = /*#__PURE__*/function () {
  function Mutex() {
    _classCallCheck(this, Mutex);
    this.available = true;
    this.acquireQueue = [];
  }
  _createClass(Mutex, [{
    key: "acquire",
    value: function acquire(cb) {
      var _this66 = this;
      return new Promise(function (resolve) {
        _this66.acquireQueue.push([cb, resolve]);
        if (_this66.available) {
          _this66.dispatchNext().catch(function (e) {
            return _Logger.errorOnce(e);
          });
        }
      });
    }
  }, {
    key: "acquireImmediately",
    value: function acquireImmediately(cb) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (this.available) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, false);
            case 1:
              _context0.n = 2;
              return this.acquire(cb);
            case 2:
              return _context0.a(2, true);
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "waitForClearAcquireQueue",
    value: function waitForClearAcquireQueue() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee4() {
        var _this67 = this;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              return _context10.a(2, this.acquire(function () {
                return __async(_this67, null, /*#__PURE__*/_regenerator().m(function _callee3() {
                  return _regenerator().w(function (_context1) {
                    while (1) switch (_context1.n) {
                      case 0:
                        return _context1.a(2, void 0);
                    }
                  }, _callee3);
                }));
              }));
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "dispatchNext",
    value: function dispatchNext() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee5() {
        var _a, _b, _ref76, _ref77, next, done, _ref78, _ref79, _t6;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              this.available = false;
              _ref76 = (_a = this.acquireQueue.shift()) != null ? _a : [], _ref77 = _slicedToArray(_ref76, 2), next = _ref77[0], done = _ref77[1];
            case 1:
              if (!next) {
                _context11.n = 6;
                break;
              }
              _context11.p = 2;
              _context11.n = 3;
              return next();
            case 3:
              done == null ? void 0 : done();
              _context11.n = 5;
              break;
            case 4:
              _context11.p = 4;
              _t6 = _context11.v;
              _Logger.error("mutex callback error", _t6);
              done == null ? void 0 : done();
            case 5:
              _ref78 = (_b = this.acquireQueue.shift()) != null ? _b : [];
              _ref79 = _slicedToArray(_ref78, 2);
              next = _ref79[0];
              done = _ref79[1];
              _context11.n = 1;
              break;
            case 6:
              this.available = true;
            case 7:
              return _context11.a(2);
          }
        }, _callee5, this, [[2, 4]]);
      }));
    }
  }]);
  return Mutex;
}();

// packages/ag-charts-community/src/util/observable.ts
var Observable = /*#__PURE__*/function () {
  function Observable() {
    _classCallCheck(this, Observable);
    this.eventListeners = /* @__PURE__ */new Map();
  }
  _createClass(Observable, [{
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      if (typeof listener !== "function") {
        throw new Error("AG Charts - listener must be a Function");
      }
      var eventTypeListeners = this.eventListeners.get(eventType);
      if (eventTypeListeners) {
        eventTypeListeners.add(listener);
      } else {
        this.eventListeners.set(eventType, /* @__PURE__ */new Set([listener]));
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var _a;
      (_a = this.eventListeners.get(type)) == null ? void 0 : _a.delete(listener);
      if (this.eventListeners.size === 0) {
        this.eventListeners.delete(type);
      }
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(type) {
      return this.eventListeners.has(type);
    }
  }, {
    key: "clearEventListeners",
    value: function clearEventListeners() {
      this.eventListeners.clear();
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(event) {
      var _a;
      (_a = this.eventListeners.get(event.type)) == null ? void 0 : _a.forEach(function (listener) {
        return listener(event);
      });
    }
  }]);
  return Observable;
}();

// packages/ag-charts-community/src/util/padding.ts
var _Padding = /*#__PURE__*/function (_BaseProperties8) {
  _inherits(Padding, _BaseProperties8);
  function Padding() {
    var _this68;
    var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : top;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : top;
    var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : right;
    _classCallCheck(this, Padding);
    _this68 = _possibleConstructorReturn(this, _getPrototypeOf(Padding).call(this));
    _this68.top = top;
    _this68.right = right;
    _this68.bottom = bottom;
    _this68.left = left;
    return _this68;
  }
  _createClass(Padding, [{
    key: "clear",
    value: function clear() {
      this.top = this.right = this.bottom = this.left = 0;
    }
  }]);
  return Padding;
}(_BaseProperties35);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Padding.prototype, "top", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Padding.prototype, "right", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Padding.prototype, "bottom", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Padding.prototype, "left", 2);

// packages/ag-charts-community/src/util/render.ts
function debouncedAnimationFrame(cb) {
  return buildScheduler(function (innerCb, _delayMs) {
    return requestAnimationFrame(innerCb);
  }, cb);
}
function debouncedCallback(cb) {
  return buildScheduler(function (innerCb) {
    var delayMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return setTimeout(innerCb, delayMs);
  }, cb);
}
function buildScheduler(scheduleFn, cb) {
  var scheduleCount = 0;
  var promiseRunning = false;
  var awaitingPromise;
  var awaitingDone;
  var busy = function busy() {
    return promiseRunning;
  };
  var done = function done() {
    promiseRunning = false;
    awaitingDone == null ? void 0 : awaitingDone();
    awaitingDone = void 0;
    awaitingPromise = void 0;
    if (scheduleCount > 0) {
      scheduleFn(scheduleCb);
    }
  };
  var scheduleCb = function scheduleCb() {
    var count = scheduleCount;
    scheduleCount = 0;
    promiseRunning = true;
    var maybePromise = cb({
      count: count
    });
    if (!maybePromise) {
      done();
      return;
    }
    maybePromise.then(done, done);
  };
  return {
    schedule: function schedule(delayMs) {
      if (scheduleCount === 0 && !busy()) {
        scheduleFn(scheduleCb, delayMs);
      }
      scheduleCount++;
    },
    await: function _await() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (busy()) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              if (awaitingPromise == null) {
                awaitingPromise = new Promise(function (resolve) {
                  awaitingDone = resolve;
                });
              }
            case 2:
              if (!busy()) {
                _context12.n = 4;
                break;
              }
              _context12.n = 3;
              return awaitingPromise;
            case 3:
              _context12.n = 2;
              break;
            case 4:
              return _context12.a(2);
          }
        }, _callee6);
      }));
    }
  };
}

// packages/ag-charts-community/src/util/sizeMonitor.ts
var SizeMonitor = /*#__PURE__*/function () {
  function SizeMonitor() {
    var _this69 = this;
    _classCallCheck(this, SizeMonitor);
    this.elements = /* @__PURE__ */new Map();
    this.documentReady = false;
    this.queuedObserveRequests = [];
    this.onLoad = function () {
      _this69.documentReady = true;
      _this69.queuedObserveRequests.forEach(function (_ref80) {
        var _ref81 = _slicedToArray(_ref80, 2),
          el = _ref81[0],
          cb = _ref81[1];
        return _this69.observe(el, cb);
      });
      _this69.queuedObserveRequests = [];
    };
    var _a;
    if (typeof ResizeObserver === "undefined") return;
    this.resizeObserver = new ResizeObserver(function (entries) {
      var _iterator77 = _createForOfIteratorHelper(entries),
        _step77;
      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var _step77$value = _step77.value,
            target = _step77$value.target,
            contentRect = _step77$value.contentRect;
          var width = contentRect.width,
            height = contentRect.height;
          _this69.checkSize(_this69.elements.get(target), target, width, height);
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
    });
    this.documentReady = _getDocument2("readyState") === "complete";
    if (!this.documentReady) {
      (_a = _getWindow2()) == null ? void 0 : _a.addEventListener("load", this.onLoad);
    }
  }
  _createClass(SizeMonitor, [{
    key: "destroy",
    value: function destroy() {
      var _a, _b;
      (_a = _getWindow2()) == null ? void 0 : _a.removeEventListener("load", this.onLoad);
      (_b = this.resizeObserver) == null ? void 0 : _b.disconnect();
      this.resizeObserver = null;
    }
  }, {
    key: "checkSize",
    value: function checkSize(entry, element2, width, height) {
      var _a, _b;
      if (!entry) return;
      if (width !== ((_a = entry.size) == null ? void 0 : _a.width) || height !== ((_b = entry.size) == null ? void 0 : _b.height)) {
        entry.size = {
          width: width,
          height: height
        };
        entry.cb(entry.size, element2);
      }
    } // Only a single callback is supported.
  }, {
    key: "observe",
    value: function observe(element2, cb) {
      var _a;
      if (!this.documentReady) {
        this.queuedObserveRequests.push([element2, cb]);
        return;
      }
      if (this.elements.has(element2)) {
        this.removeFromQueue(element2);
      } else {
        (_a = this.resizeObserver) == null ? void 0 : _a.observe(element2);
      }
      this.elements.set(element2, {
        cb: cb
      });
    }
  }, {
    key: "unobserve",
    value: function unobserve(element2) {
      var _a;
      (_a = this.resizeObserver) == null ? void 0 : _a.unobserve(element2);
      this.elements.delete(element2);
      this.removeFromQueue(element2);
      if (!this.elements.size) {
        this.destroy();
      }
    }
  }, {
    key: "removeFromQueue",
    value: function removeFromQueue(element2) {
      this.queuedObserveRequests = this.queuedObserveRequests.filter(function (_ref82) {
        var _ref83 = _slicedToArray(_ref82, 1),
          el = _ref83[0];
        return el !== element2;
      });
    }
  }]);
  return SizeMonitor;
}();

// packages/ag-charts-community/src/util/callbackCache.ts
var CallbackCache = /*#__PURE__*/function () {
  function CallbackCache() {
    _classCallCheck(this, CallbackCache);
    this.cache = /* @__PURE__ */new WeakMap();
  }
  _createClass(CallbackCache, [{
    key: "call",
    value: function call(fn) {
      for (var _len20 = arguments.length, params = new Array(_len20 > 1 ? _len20 - 1 : 0), _key21 = 1; _key21 < _len20; _key21++) {
        params[_key21 - 1] = arguments[_key21];
      }
      var serialisedParams;
      var paramCache = this.cache.get(fn);
      var invoke = function invoke() {
        try {
          var result = fn.apply(void 0, params);
          if (paramCache && serialisedParams != null) {
            paramCache.set(serialisedParams, result);
          }
          return result;
        } catch (e) {
          _Logger.warnOnce("User callback errored, ignoring", e);
          return;
        }
      };
      try {
        serialisedParams = JSON.stringify(params);
      } catch (e) {
        return invoke();
      }
      if (paramCache == null) {
        paramCache = /* @__PURE__ */new Map();
        this.cache.set(fn, paramCache);
      }
      if (!paramCache.has(serialisedParams)) {
        return invoke();
      }
      return paramCache.get(serialisedParams);
    }
  }, {
    key: "invalidateCache",
    value: function invalidateCache() {
      this.cache = /* @__PURE__ */new WeakMap();
    }
  }]);
  return CallbackCache;
}();

// packages/ag-charts-community/src/chart/annotation/annotationManager.ts
var AnnotationManager = /*#__PURE__*/function () {
  function AnnotationManager(annotationRoot) {
    _classCallCheck(this, AnnotationManager);
    this.annotationRoot = annotationRoot;
  }
  _createClass(AnnotationManager, [{
    key: "attachNode",
    value: function attachNode(node) {
      var _this70 = this;
      this.annotationRoot.append(node);
      return function () {
        var _a;
        (_a = _this70.annotationRoot) == null ? void 0 : _a.removeChild(node);
        return _this70;
      };
    }
  }, {
    key: "setAnnotationStyles",
    value: function setAnnotationStyles(styles) {
      this.styles = styles;
    }
  }, {
    key: "getAnnotationTypeStyles",
    value: function getAnnotationTypeStyles(type) {
      var _a;
      return (_a = this.styles) == null ? void 0 : _a[type];
    }
  }]);
  return AnnotationManager;
}();

// packages/ag-charts-community/src/util/listeners.ts
var Listeners = /*#__PURE__*/function () {
  function Listeners() {
    _classCallCheck(this, Listeners);
    this.registeredListeners = /* @__PURE__ */new Map();
  }
  _createClass(Listeners, [{
    key: "addListener",
    value: function addListener(eventType, handler) {
      var _this71 = this;
      var record = {
        symbol: Symbol(eventType),
        handler: handler
      };
      if (this.registeredListeners.has(eventType)) {
        this.registeredListeners.get(eventType).push(record);
      } else {
        this.registeredListeners.set(eventType, [record]);
      }
      return function () {
        return _this71.removeListener(record.symbol);
      };
    }
  }, {
    key: "removeListener",
    value: function removeListener(eventSymbol) {
      var _iterator78 = _createForOfIteratorHelper(this.registeredListeners.entries()),
        _step78;
      try {
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          var _step78$value = _slicedToArray(_step78.value, 2),
            type = _step78$value[0],
            listeners = _step78$value[1];
          var matchIndex = listeners.findIndex(function (listener) {
            return listener.symbol === eventSymbol;
          });
          if (matchIndex >= 0) {
            listeners.splice(matchIndex, 1);
            if (listeners.length === 0) {
              this.registeredListeners.delete(type);
            }
            break;
          }
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
    }
  }, {
    key: "dispatch",
    value: function dispatch(eventType) {
      for (var _len21 = arguments.length, params = new Array(_len21 > 1 ? _len21 - 1 : 0), _key22 = 1; _key22 < _len21; _key22++) {
        params[_key22 - 1] = arguments[_key22];
      }
      var _iterator79 = _createForOfIteratorHelper(this.getListenersByType(eventType)),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var listener = _step79.value;
          try {
            listener.handler.apply(listener, params);
          } catch (e) {
            _Logger.errorOnce(e);
          }
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
    }
  }, {
    key: "dispatchWrapHandlers",
    value: function dispatchWrapHandlers(eventType, wrapFn) {
      for (var _len22 = arguments.length, params = new Array(_len22 > 2 ? _len22 - 2 : 0), _key23 = 2; _key23 < _len22; _key23++) {
        params[_key23 - 2] = arguments[_key23];
      }
      var _iterator80 = _createForOfIteratorHelper(this.getListenersByType(eventType)),
        _step80;
      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var listener = _step80.value;
          try {
            wrapFn.apply(void 0, [listener.handler].concat(params));
          } catch (e) {
            _Logger.errorOnce(e);
          }
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
    }
  }, {
    key: "getListenersByType",
    value: function getListenersByType(eventType) {
      var _a;
      return (_a = this.registeredListeners.get(eventType)) != null ? _a : [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.registeredListeners.clear();
    }
  }]);
  return Listeners;
}();

// packages/ag-charts-community/src/chart/data/dataService.ts
var _DataService = /*#__PURE__*/function (_Listeners) {
  _inherits(DataService, _Listeners);
  function DataService(animationManager) {
    var _this72;
    _classCallCheck(this, DataService);
    _this72 = _possibleConstructorReturn(this, _getPrototypeOf(DataService).call(this));
    _this72.animationManager = animationManager;
    _this72.dispatchOnlyLatest = true;
    _this72.dispatchThrottle = 0;
    _this72.requestThrottle = 300;
    _this72.isLoadingInitialData = false;
    _this72.isLoadingData = false;
    _this72.freshRequests = [];
    _this72.requestCounter = 0;
    _this72.debug = Debug.create(true, "data-model", "data-source");
    _this72.throttledFetch = _this72.createThrottledFetch(_this72.requestThrottle);
    _this72.throttledDispatch = _this72.createThrottledDispatch(_this72.dispatchThrottle);
    return _this72;
  }
  _createClass(DataService, [{
    key: "updateCallback",
    value: function updateCallback(dataSourceCallback) {
      if (typeof dataSourceCallback !== "function") return;
      this.debug("DataService - updated data source callback");
      this.dataSourceCallback = dataSourceCallback;
      this.isLoadingInitialData = true;
      this.animationManager.skip();
      this.dispatch("data-source-change");
    }
  }, {
    key: "clearCallback",
    value: function clearCallback() {
      this.dataSourceCallback = void 0;
    }
  }, {
    key: "load",
    value: function load(params) {
      this.isLoadingData = true;
      this.throttledFetch(params);
    }
  }, {
    key: "isLazy",
    value: function isLazy() {
      return this.dataSourceCallback != null;
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.isLazy() && (this.isLoadingInitialData || this.isLoadingData);
    }
  }, {
    key: "createThrottledFetch",
    value: function createThrottledFetch(requestThrottle) {
      var _this73 = this;
      return throttle(function (params) {
        return _this73.fetch(params);
      }, requestThrottle, {
        leading: false,
        trailing: true
      });
    }
  }, {
    key: "createThrottledDispatch",
    value: function createThrottledDispatch(dispatchThrottle) {
      var _this74 = this;
      return throttle(function (id, data) {
        _this74.debug("DataService - dispatching 'data-load' | ".concat(id));
        _this74.dispatch("data-load", {
          type: "data-load",
          data: data
        });
      }, dispatchThrottle, {
        leading: true,
        trailing: true
      });
    }
  }, {
    key: "fetch",
    value: function fetch(params) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee7() {
        var start, id, response, requestIndex, _t7;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              if (this.dataSourceCallback) {
                _context13.n = 1;
                break;
              }
              throw new Error("DataService - [dataSource.getData] callback not initialised");
            case 1:
              start = performance.now();
              id = this.requestCounter++;
              this.debug("DataService - requesting | ".concat(id));
              this.freshRequests.push(id);
              _context13.p = 2;
              _context13.n = 3;
              return this.dataSourceCallback(params);
            case 3:
              response = _context13.v;
              this.debug("DataService - response | ".concat(performance.now() - start, "ms | ").concat(id));
              _context13.n = 5;
              break;
            case 4:
              _context13.p = 4;
              _t7 = _context13.v;
              this.debug("DataService - request failed | ".concat(id));
              _Logger.errorOnce("DataService - request failed | [".concat(_t7, "]"));
            case 5:
              this.isLoadingInitialData = false;
              requestIndex = this.freshRequests.findIndex(function (rid) {
                return rid === id;
              });
              if (!(requestIndex === -1 || this.dispatchOnlyLatest && requestIndex !== this.freshRequests.length - 1)) {
                _context13.n = 6;
                break;
              }
              this.debug("DataService - discarding stale request | ".concat(id));
              return _context13.a(2);
            case 6:
              this.freshRequests = this.freshRequests.slice(requestIndex + 1);
              if (this.freshRequests.length === 0) {
                this.isLoadingData = false;
              }
              if (Array.isArray(response)) {
                this.throttledDispatch(id, response);
              } else {
                this.dispatch("data-error");
              }
            case 7:
              return _context13.a(2);
          }
        }, _callee7, this, [[2, 4]]);
      }));
    }
  }]);
  return DataService;
}(Listeners);
__decorateClass([_ActionOnSet({
  newValue: function newValue(dispatchThrottle) {
    this.throttledDispatch = this.createThrottledDispatch(dispatchThrottle);
  }
})], _DataService.prototype, "dispatchThrottle", 2);
__decorateClass([_ActionOnSet({
  newValue: function newValue(requestThrottle) {
    this.throttledFetch = this.createThrottledFetch(requestThrottle);
  }
})], _DataService.prototype, "requestThrottle", 2);

// packages/ag-charts-community/src/chart/interaction/animationBatch.ts
var AnimationBatch = /*#__PURE__*/function () {
  function AnimationBatch(maxAnimationTime) {
    _classCallCheck(this, AnimationBatch);
    this.maxAnimationTime = maxAnimationTime;
    this.debug = Debug.create(true, "animation");
    this.controllers = /* @__PURE__ */new Map();
    this.stoppedCbs = /* @__PURE__ */new Set();
    this.currentPhase = 0;
    this.phases = new Map(_PHASE_ORDER.map(function (p) {
      return [p, []];
    }));
    this.skipAnimations = false;
    this.animationTimeConsumed = 0;
    /** Guard against premature animation execution. */
    this.isReady = false;
  }
  _createClass(AnimationBatch, [{
    key: "isActive",
    value: function isActive() {
      return this.controllers.size > 0;
    }
  }, {
    key: "getActiveControllers",
    value: function getActiveControllers() {
      var _a;
      return (_a = this.phases.get(_PHASE_ORDER[this.currentPhase])) != null ? _a : [];
    }
  }, {
    key: "checkOverlappingId",
    value: function checkOverlappingId(id) {
      if (id != null && this.controllers.has(id)) {
        this.controllers.get(id).stop();
        this.debug("Skipping animation batch due to update of existing animation: ".concat(id));
        this.skip();
      }
    }
  }, {
    key: "addAnimation",
    value: function addAnimation(animation) {
      var _a;
      if (animation.isComplete) return;
      var animationPhaseIdx = _PHASE_ORDER.indexOf(animation.phase);
      if (animationPhaseIdx < this.currentPhase) {
        this.debug("Skipping animation due to being for an earlier phase", animation.id);
        animation.stop();
        return;
      }
      this.controllers.set(animation.id, animation);
      (_a = this.phases.get(animation.phase)) == null ? void 0 : _a.push(animation);
    }
  }, {
    key: "removeAnimation",
    value: function removeAnimation(animation) {
      this.controllers.delete(animation.id);
      var phase = this.phases.get(animation.phase);
      var index = phase == null ? void 0 : phase.indexOf(animation);
      if (index != null && index >= 0) {
        phase == null ? void 0 : phase.splice(index, 1);
      }
    }
  }, {
    key: "progress",
    value: function progress(deltaTime) {
      var _this75 = this;
      if (!this.isReady) return;
      var unusedTime = deltaTime === 0 ? 0.01 : deltaTime;
      var refresh = function refresh() {
        var phase2 = _PHASE_ORDER[_this75.currentPhase];
        return {
          phaseControllers: _toConsumableArray(_this75.getActiveControllers()),
          phase: phase2,
          phaseMeta: _PHASE_METADATA[phase2]
        };
      };
      var _refresh = refresh(),
        phase = _refresh.phase,
        phaseControllers = _refresh.phaseControllers,
        phaseMeta = _refresh.phaseMeta;
      var arePhasesComplete = function arePhasesComplete() {
        return _PHASE_ORDER[_this75.currentPhase] == null;
      };
      var progressPhase = function progressPhase() {
        var _refresh2 = refresh();
        phase = _refresh2.phase;
        phaseControllers = _refresh2.phaseControllers;
        phaseMeta = _refresh2.phaseMeta;
        while (!arePhasesComplete() && phaseControllers.length === 0) {
          _this75.currentPhase++;
          var _refresh3 = refresh();
          phase = _refresh3.phase;
          phaseControllers = _refresh3.phaseControllers;
          phaseMeta = _refresh3.phaseMeta;
          _this75.debug("AnimationBatch - phase changing to ".concat(phase), {
            unusedTime: unusedTime
          }, phaseControllers);
        }
      };
      var total = this.controllers.size;
      this.debug("AnimationBatch - ".concat(deltaTime, "ms; phase ").concat(phase, " with ").concat(phaseControllers == null ? void 0 : phaseControllers.length, " of ").concat(total));
      do {
        var phaseDeltaTime = unusedTime;
        var skipPhase = phaseMeta.skipIfNoEarlierAnimations && this.animationTimeConsumed === 0;
        var completeCount = 0;
        var _iterator81 = _createForOfIteratorHelper(phaseControllers),
          _step81;
        try {
          for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
            var controller = _step81.value;
            if (skipPhase) {
              controller.stop();
            } else {
              unusedTime = Math.min(controller.update(phaseDeltaTime), unusedTime);
            }
            if (controller.isComplete) {
              completeCount++;
              this.removeAnimation(controller);
            }
          }
        } catch (err) {
          _iterator81.e(err);
        } finally {
          _iterator81.f();
        }
        this.animationTimeConsumed += phaseDeltaTime - unusedTime;
        this.debug("AnimationBatch - updated ".concat(phaseControllers.length, " controllers; ").concat(completeCount, " completed"));
        this.debug("AnimationBatch - animationTimeConsumed: ".concat(this.animationTimeConsumed));
        progressPhase();
      } while (unusedTime > 0 && !arePhasesComplete());
      if (this.animationTimeConsumed > this.maxAnimationTime) {
        _Logger.warnOnce("Animation batch exceeded max animation time, skipping.", new Map(this.controllers.entries()));
        this.stop();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      if (this.isReady) return;
      this.isReady = true;
      this.debug("AnimationBatch - ready; skipped: ".concat(this.skipAnimations), _toConsumableArray(this.controllers));
      var skipAll = true;
      var _iterator82 = _createForOfIteratorHelper(this.controllers),
        _step82;
      try {
        for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
          var _step82$value = _slicedToArray(_step82.value, 2),
            _controller = _step82$value[1];
          if (_controller.duration > 0 && _PHASE_METADATA[_controller.phase].skipIfNoEarlierAnimations !== true) {
            skipAll = false;
            break;
          }
        }
      } catch (err) {
        _iterator82.e(err);
      } finally {
        _iterator82.f();
      }
      if (!skipAll) {
        var _iterator83 = _createForOfIteratorHelper(this.controllers),
          _step83;
        try {
          for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
            var _step83$value = _slicedToArray(_step83.value, 2),
              controller = _step83$value[1];
            if (controller.autoplay) {
              controller.play(true);
            }
          }
        } catch (err) {
          _iterator83.e(err);
        } finally {
          _iterator83.f();
        }
      }
    }
  }, {
    key: "skip",
    value: function skip() {
      var _skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.skipAnimations === false && _skip === true) {
        var _iterator84 = _createForOfIteratorHelper(this.controllers.values()),
          _step84;
        try {
          for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
            var controller = _step84.value;
            controller.stop();
          }
        } catch (err) {
          _iterator84.e(err);
        } finally {
          _iterator84.f();
        }
        this.controllers.clear();
      }
      this.skipAnimations = _skip;
    }
  }, {
    key: "play",
    value: function play() {
      var _iterator85 = _createForOfIteratorHelper(this.controllers.values()),
        _step85;
      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var controller = _step85.value;
          controller.play();
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      var _iterator86 = _createForOfIteratorHelper(this.controllers.values()),
        _step86;
      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var controller = _step86.value;
          controller.pause();
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var _iterator87 = _createForOfIteratorHelper(this.controllers.values()),
        _step87;
      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var controller = _step87.value;
          try {
            controller.stop();
            this.removeAnimation(controller);
          } catch (error) {
            _Logger.error("Error during animation stop", error);
          }
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
      this.dispatchStopped();
    }
  }, {
    key: "stopByAnimationId",
    value: function stopByAnimationId(id) {
      if (id != null && this.controllers.has(id)) {
        var controller = this.controllers.get(id);
        if (controller) {
          controller.stop();
          this.removeAnimation(controller);
        }
      }
    }
  }, {
    key: "stopByAnimationGroupId",
    value: function stopByAnimationGroupId(id) {
      var _iterator88 = _createForOfIteratorHelper(this.controllers.values()),
        _step88;
      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var controller = _step88.value;
          if (controller.groupId === id) {
            this.stopByAnimationId(controller.id);
          }
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
    }
  }, {
    key: "dispatchStopped",
    value: function dispatchStopped() {
      this.stoppedCbs.forEach(function (cb) {
        return cb();
      });
      this.stoppedCbs.clear();
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return this.skipAnimations;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stop();
      this.controllers.clear();
    }
  }, {
    key: "size",
    get: function get() {
      return this.controllers.size;
    }
  }, {
    key: "consumedTimeMs",
    get: function get() {
      return this.animationTimeConsumed;
    }
  }]);
  return AnimationBatch;
}();

// packages/ag-charts-community/src/chart/interaction/baseManager.ts
var BaseManager = /*#__PURE__*/function () {
  function BaseManager() {
    _classCallCheck(this, BaseManager);
    this.listeners = new Listeners();
    this.destroyFns = [];
  }
  _createClass(BaseManager, [{
    key: "addListener",
    value: function addListener(type, handler) {
      return this.listeners.addListener(type, handler);
    }
  }, {
    key: "removeListener",
    value: function removeListener(listenerSymbol) {
      this.listeners.removeListener(listenerSymbol);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners.destroy();
      this.destroyFns.forEach(function (fn) {
        return fn();
      });
    }
  }]);
  return BaseManager;
}();

// packages/ag-charts-community/src/chart/interaction/consumableEvent.ts
function buildConsumable(obj) {
  var builtEvent = __spreadProps(__spreadValues({}, obj), {
    consumed: false,
    consume: function consume() {
      var _a, _b;
      builtEvent.consumed = true;
      if (obj.sourceEvent instanceof Event) {
        (_a = obj.sourceEvent) == null ? void 0 : _a.preventDefault();
      } else {
        (_b = obj.sourceEvent) == null ? void 0 : _b.consume();
      }
    }
  });
  return builtEvent;
}
function buildConsumptionHandler() {
  return function (handler, e) {
    if (!e.consumed) {
      handler(e);
    }
  };
}
function dispatchTypedConsumable(listeners, type, event) {
  listeners.dispatchWrapHandlers(type, buildConsumptionHandler(), event);
}

// packages/ag-charts-community/src/chart/interaction/interactionManager.ts
var _POINTER_INTERACTION_TYPES = ["click", "dblclick", "contextmenu", "hover", "drag-start", "drag", "drag-end", "leave", "enter", "page-left", "wheel"];
var FOCUS_INTERACTION_TYPES = ["blur", "focus"];
var KEY_INTERACTION_TYPES = ["keydown", "keyup"];
var WINDOW_EVENT_HANDLERS = ["pagehide", "mousemove", "mouseup"];
var EVENT_HANDLERS = ["click", "dblclick", "contextmenu", "mousedown", "mouseout", "mouseenter", "touchstart", "touchmove", "touchend", "touchcancel", "wheel", "blur", "focus", "keydown", "keyup"];
var CSS = "\n.ag-chart-wrapper {\n    touch-action: none;\n}\n";
var _InteractionState = /* @__PURE__ */function (InteractionState2) {
  InteractionState2[InteractionState2["Default"] = 16] = "Default";
  InteractionState2[InteractionState2["ZoomDrag"] = 8] = "ZoomDrag";
  InteractionState2[InteractionState2["Annotations"] = 4] = "Annotations";
  InteractionState2[InteractionState2["ContextMenu"] = 2] = "ContextMenu";
  InteractionState2[InteractionState2["Animation"] = 1] = "Animation";
  InteractionState2[InteractionState2["All"] = 31] = "All";
  return InteractionState2;
}(_InteractionState || {});
var _InteractionManager = /*#__PURE__*/function (_BaseManager) {
  _inherits(_InteractionManager, _BaseManager);
  function _InteractionManager(keyboardOptions, element2) {
    var _this76;
    _classCallCheck(this, _InteractionManager);
    _this76 = _possibleConstructorReturn(this, _getPrototypeOf(_InteractionManager).call(this));
    _this76.keyboardOptions = keyboardOptions;
    _this76.debug = Debug.create(true, "interaction");
    _this76.eventHandler = function (event) {
      return _this76.processEvent(event);
    };
    _this76.mouseDown = false;
    _this76.touchDown = false;
    _this76.clickHistory = [{
      offsetX: NaN,
      offsetY: NaN,
      type: "mousedown"
    }];
    _this76.dblclickHistory = [{
      offsetX: NaN,
      offsetY: NaN,
      type: "mousedown"
    }, {
      offsetX: NaN,
      offsetY: NaN,
      type: "mouseup"
    }, {
      offsetX: NaN,
      offsetY: NaN,
      type: "mousedown"
    }];
    _this76.stateQueue = 16 /* Default */ | 1 /* Animation */;
    _this76.rootElement = _getDocument2("body");
    _this76.element = element2;
    var _iterator89 = _createForOfIteratorHelper(EVENT_HANDLERS),
      _step89;
    try {
      for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
        var type = _step89.value;
        if (type.startsWith("touch")) {
          element2.addEventListener(type, _this76.eventHandler, {
            passive: true
          });
        } else if (type === "wheel") {
          element2.addEventListener(type, _this76.eventHandler, {
            passive: false
          });
        } else {
          element2.addEventListener(type, _this76.eventHandler);
        }
      }
    } catch (err) {
      _iterator89.e(err);
    } finally {
      _iterator89.f();
    }
    var _iterator90 = _createForOfIteratorHelper(WINDOW_EVENT_HANDLERS),
      _step90;
    try {
      for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
        var _type = _step90.value;
        _getWindow2().addEventListener(_type, _this76.eventHandler);
      }
    } catch (err) {
      _iterator90.e(err);
    } finally {
      _iterator90.f();
    }
    _injectStyle(CSS, "interactionManager");
    return _this76;
  }
  _createClass(_InteractionManager, [{
    key: "destroy",
    value: function destroy() {
      _superPropGet(_InteractionManager, "destroy", this, 3)([]);
      for (var _i16 = 0, _WINDOW_EVENT_HANDLER = WINDOW_EVENT_HANDLERS; _i16 < _WINDOW_EVENT_HANDLER.length; _i16++) {
        var type = _WINDOW_EVENT_HANDLER[_i16];
        _getWindow2().removeEventListener(type, this.eventHandler);
      }
      for (var _i17 = 0, _EVENT_HANDLERS = EVENT_HANDLERS; _i17 < _EVENT_HANDLERS.length; _i17++) {
        var _type2 = _EVENT_HANDLERS[_i17];
        this.element.removeEventListener(_type2, this.eventHandler);
      }
    } // Wrapper to only broadcast events when the InteractionManager is a given state.
  }, {
    key: "addListener",
    value: function addListener(type, handler) {
      var _this77 = this;
      var triggeringStates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
      return _superPropGet(_InteractionManager, "addListener", this, 3)([type, function (e) {
        var currentState = _this77.getState();
        if (currentState & triggeringStates) {
          handler(e);
        }
      }]);
    }
  }, {
    key: "pushState",
    value: function pushState(state) {
      this.stateQueue |= state;
    }
  }, {
    key: "popState",
    value: function popState(state) {
      this.stateQueue &= ~state;
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.stateQueue & -this.stateQueue;
    }
  }, {
    key: "processEvent",
    value: function processEvent(event) {
      var types = this.decideInteractionEventTypes(event);
      if (types.length > 0) {
        this.dispatchEvent(event, types).catch(function (e) {
          return _Logger.errorOnce(e);
        });
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event, types) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee8() {
        var _iterator91, _step91, type, _iterator92, _step92, _type3;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (_allInStringUnion(_POINTER_INTERACTION_TYPES, types)) {
                this.dispatchPointerEvent(event, types);
              } else if (_allInStringUnion(FOCUS_INTERACTION_TYPES, types)) {
                _iterator91 = _createForOfIteratorHelper(types);
                try {
                  for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                    type = _step91.value;
                    dispatchTypedConsumable(this.listeners, type, buildConsumable({
                      type: type,
                      sourceEvent: event
                    }));
                  }
                } catch (err) {
                  _iterator91.e(err);
                } finally {
                  _iterator91.f();
                }
              } else if (_allInStringUnion(KEY_INTERACTION_TYPES, types)) {
                _iterator92 = _createForOfIteratorHelper(types);
                try {
                  for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
                    _type3 = _step92.value;
                    dispatchTypedConsumable(this.listeners, _type3, buildConsumable({
                      type: _type3,
                      sourceEvent: event
                    }));
                  }
                } catch (err) {
                  _iterator92.e(err);
                } finally {
                  _iterator92.f();
                }
              }
            case 1:
              return _context14.a(2);
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "dispatchPointerEvent",
    value: function dispatchPointerEvent(event, types) {
      var coords = this.calculateCoordinates(event);
      if (coords == null) {
        return;
      }
      var _iterator93 = _createForOfIteratorHelper(types),
        _step93;
      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var type = _step93.value;
          dispatchTypedConsumable(this.listeners, type, this.buildPointerEvent(__spreadValues({
            type: type,
            event: event
          }, coords)));
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
    }
  }, {
    key: "recordDown",
    value: function recordDown(event) {
      if (event instanceof MouseEvent) {
        _partialAssign(["offsetX", "offsetY"], this.clickHistory[0], event);
        _partialAssign(["offsetX", "offsetY"], this.dblclickHistory[2], this.dblclickHistory[0]);
        _partialAssign(["offsetX", "offsetY"], this.dblclickHistory[0], event);
      }
      this.dragStartElement = event.target;
    }
  }, {
    key: "recordUp",
    value: function recordUp(event) {
      if (event instanceof MouseEvent) {
        _partialAssign(["offsetX", "offsetY"], this.dblclickHistory[1], event);
      }
      this.dragStartElement = void 0;
    }
  }, {
    key: "decideInteractionEventTypes",
    value: function decideInteractionEventTypes(event) {
      var dragStart = "drag-start";
      switch (event.type) {
        case "blur":
        case "focus":
        case "keydown":
        case "keyup":
          return this.keyboardOptions.enabled ? [event.type] : [];
        case "click":
        case "dblclick":
        case "contextmenu":
        case "wheel":
          return [event.type];
        case "mousedown":
          if (!this.isEventOverElement(event)) {
            return [];
          }
          this.mouseDown = true;
          this.recordDown(event);
          return [dragStart];
        case "touchstart":
          if (!this.isEventOverElement(event)) {
            return [];
          }
          this.touchDown = true;
          this.recordDown(event);
          return [dragStart];
        case "touchmove":
        case "mousemove":
          if (!this.mouseDown && !this.touchDown && !this.isEventOverElement(event)) {
            return [];
          }
          return this.mouseDown || this.touchDown ? ["drag"] : ["hover"];
        case "mouseup":
          if (!this.mouseDown && !this.isEventOverElement(event)) {
            return [];
          }
          this.mouseDown = false;
          this.recordUp(event);
          return ["drag-end"];
        case "touchend":
          if (!this.touchDown && !this.isEventOverElement(event)) {
            return [];
          }
          this.touchDown = false;
          this.recordUp(event);
          return ["drag-end"];
        case "mouseout":
        case "touchcancel":
          return ["leave"];
        case "mouseenter":
          var mouseButtonDown = event instanceof MouseEvent && (event.buttons & 1) === 1;
          if (this.mouseDown !== mouseButtonDown) {
            this.mouseDown = mouseButtonDown;
            return [mouseButtonDown ? dragStart : "drag-end"];
          }
          return ["enter"];
        case "pagehide":
          return ["page-left"];
      }
      return [];
    }
  }, {
    key: "isEventOverElement",
    value: function isEventOverElement(event) {
      var _a, _b, _c;
      return event.target === this.element || ((_a = event.target) == null ? void 0 : _a.parentElement) === this.element || ((_c = (_b = event.target) == null ? void 0 : _b.parentElement) == null ? void 0 : _c.parentElement) === this.element;
    }
  }, {
    key: "calculateCoordinates",
    value: function calculateCoordinates(event) {
      var _a;
      if (event instanceof MouseEvent) {
        return this.getMouseEventCoords(event);
      } else if (typeof TouchEvent !== "undefined" && event instanceof TouchEvent) {
        var lastTouch = (_a = event.touches[0]) != null ? _a : event.changedTouches[0];
        var clientX = lastTouch.clientX,
          clientY = lastTouch.clientY,
          pageX = lastTouch.pageX,
          pageY = lastTouch.pageY;
        return __spreadProps(__spreadValues({}, _InteractionManager.NULL_COORDS), {
          clientX: clientX,
          clientY: clientY,
          pageX: pageX,
          pageY: pageY
        });
      } else if (event instanceof PageTransitionEvent) {
        if (event.persisted) {
          return;
        }
        return _InteractionManager.NULL_COORDS;
      }
    }
  }, {
    key: "getMouseEventCoords",
    value: function getMouseEventCoords(event) {
      var clientX = event.clientX,
        clientY = event.clientY,
        pageX = event.pageX,
        pageY = event.pageY;
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      var offsets = function offsets(el) {
        var x = 0;
        var y = 0;
        while (el) {
          x += el.offsetLeft;
          y += el.offsetTop;
          el = el.offsetParent;
        }
        return {
          x: x,
          y: y
        };
      };
      if (this.dragStartElement != null && event.target !== this.dragStartElement) {
        var offsetDragStart = offsets(this.dragStartElement);
        var offsetEvent = offsets(event.target);
        offsetX -= offsetDragStart.x - offsetEvent.x;
        offsetY -= offsetDragStart.y - offsetEvent.y;
      }
      return {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY,
        offsetX: offsetX,
        offsetY: offsetY
      };
    }
  }, {
    key: "isWheelEvent",
    value: function isWheelEvent(event) {
      return event.type === "wheel";
    }
  }, {
    key: "buildPointerEvent",
    value: function buildPointerEvent(opts) {
      var type = opts.type,
        event = opts.event,
        clientX = opts.clientX,
        clientY = opts.clientY;
      var offsetX = opts.offsetX,
        offsetY = opts.offsetY,
        pageX = opts.pageX,
        pageY = opts.pageY;
      if (!_isFiniteNumber(offsetX) || !_isFiniteNumber(offsetY)) {
        var rect = this.element.getBoundingClientRect();
        offsetX = clientX - rect.left;
        offsetY = clientY - rect.top;
      }
      if (!_isFiniteNumber(pageX) || !_isFiniteNumber(pageY)) {
        var pageRect = this.rootElement.getBoundingClientRect();
        pageX = clientX - pageRect.left;
        pageY = clientY - pageRect.top;
      }
      var deltaX = NaN,
        deltaY = NaN;
      if (this.isWheelEvent(event)) {
        var factor = event.deltaMode === 0 ? 0.01 : 1;
        deltaX = event.deltaX * factor;
        deltaY = event.deltaY * factor;
      }
      var pointerHistory = [];
      if (event.type === "click") {
        pointerHistory = this.clickHistory;
      } else if (event.type === "dblclick") {
        pointerHistory = this.dblclickHistory;
      }
      var builtEvent = buildConsumable({
        type: type,
        offsetX: offsetX,
        offsetY: offsetY,
        pageX: pageX,
        pageY: pageY,
        deltaX: deltaX,
        deltaY: deltaY,
        pointerHistory: pointerHistory,
        sourceEvent: event
      });
      this.debug("InteractionManager - builtEvent: ", builtEvent);
      return builtEvent;
    }
  }]);
  return _InteractionManager;
}(BaseManager);
_InteractionManager.NULL_COORDS = {
  clientX: -Infinity,
  clientY: -Infinity,
  pageX: -Infinity,
  pageY: -Infinity,
  offsetX: -Infinity,
  offsetY: -Infinity
};
var _InteractionManager2 = _InteractionManager;

// packages/ag-charts-community/src/chart/interaction/animationManager.ts
function validAnimationDuration(testee) {
  if (testee == null) return true;
  return !isNaN(testee) && testee >= 0 && testee <= 2;
}
var _AnimationManager = /*#__PURE__*/function (_BaseManager2) {
  _inherits(AnimationManager, _BaseManager2);
  function AnimationManager(interactionManager, chartUpdateMutex) {
    var _this78;
    _classCallCheck(this, AnimationManager);
    _this78 = _possibleConstructorReturn(this, _getPrototypeOf(AnimationManager).call(this));
    _this78.interactionManager = interactionManager;
    _this78.chartUpdateMutex = chartUpdateMutex;
    _this78.defaultDuration = 1e3;
    _this78.batch = new AnimationBatch(_this78.defaultDuration * 1.5);
    _this78.debug = Debug.create(true, "animation");
    _this78.rafAvailable = typeof requestAnimationFrame !== "undefined";
    _this78.isPlaying = false;
    _this78.requestId = null;
    _this78.skipAnimations = false;
    return _this78;
  }
  /**
   * Create an animation to tween a value between the `from` and `to` properties. If an animation already exists
   * with the same `id`, immediately stop it.
   */
  _createClass(AnimationManager, [{
    key: "animate",
    value: function animate(_a) {
      var opts = __objRest(_a, []);
      var _a2;
      var batch = this.batch;
      try {
        batch.checkOverlappingId(opts.id);
      } catch (error) {
        this.failsafeOnError(error);
        return;
      }
      var id = (_a2 = opts.id) != null ? _a2 : Math.random().toString();
      var skip = this.isSkipped() || opts.phase === "none";
      if (skip) {
        this.debug("AnimationManager - skipping animation");
      }
      var delay = opts.delay,
        duration = opts.duration;
      if (!validAnimationDuration(delay)) {
        throw new Error("Animation delay of ".concat(delay, " is unsupported (").concat(id, ")"));
      }
      if (!validAnimationDuration(duration)) {
        throw new Error("Animation duration of ".concat(duration, " is unsupported (").concat(id, ")"));
      }
      var animation = new _Animation(__spreadProps(__spreadValues({}, opts), {
        id: id,
        skip: skip,
        autoplay: this.isPlaying ? opts.autoplay : false,
        phase: opts.phase,
        defaultDuration: this.defaultDuration
      }));
      if (this.forceTimeJump(animation, this.defaultDuration)) {
        return;
      }
      this.batch.addAnimation(animation);
      return animation;
    }
  }, {
    key: "play",
    value: function play() {
      if (this.isPlaying) {
        return;
      }
      this.isPlaying = true;
      this.debug("AnimationManager.play()");
      try {
        this.batch.play();
      } catch (error) {
        this.failsafeOnError(error);
      }
      this.requestAnimation();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.isPlaying) {
        return;
      }
      this.isPlaying = false;
      this.cancelAnimation();
      this.debug("AnimationManager.pause()");
      try {
        this.batch.pause();
      } catch (error) {
        this.failsafeOnError(error);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isPlaying = false;
      this.cancelAnimation();
      this.debug("AnimationManager.stop()");
      this.batch.stop();
    }
  }, {
    key: "stopByAnimationId",
    value: function stopByAnimationId(id) {
      try {
        this.batch.stopByAnimationId(id);
      } catch (error) {
        this.failsafeOnError(error);
      }
    }
  }, {
    key: "stopByAnimationGroupId",
    value: function stopByAnimationGroupId(id) {
      try {
        this.batch.stopByAnimationGroupId(id);
      } catch (error) {
        this.failsafeOnError(error);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.isPlaying) {
        this.stop();
        this.play();
      } else {
        this.stop();
      }
    }
  }, {
    key: "skip",
    value: function skip() {
      var _skip2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.skipAnimations = _skip2;
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return !this.rafAvailable || this.skipAnimations || this.batch.isSkipped();
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.isPlaying && this.batch.isActive();
    }
  }, {
    key: "skipCurrentBatch",
    value: function skipCurrentBatch() {
      if (this.debug.check()) {
        this.debug("AnimationManager - skipCurrentBatch()", {
          stack: new Error().stack
        });
      }
      this.batch.skip();
    } /** Mocking point for tests to guarantee that animation updates happen. */
  }, {
    key: "isSkippingFrames",
    value: function isSkippingFrames() {
      return true;
    } /** Mocking point for tests to capture requestAnimationFrame callbacks. */
  }, {
    key: "scheduleAnimationFrame",
    value: function scheduleAnimationFrame(cb) {
      this.requestId = requestAnimationFrame(cb);
    } /** Mocking point for tests to skip animations to a specific point in time. */
  }, {
    key: "forceTimeJump",
    value: function forceTimeJump(_animation, _defaultDuration) {
      return false;
    }
  }, {
    key: "requestAnimation",
    value: function requestAnimation() {
      var _this79 = this;
      if (!this.rafAvailable) return;
      if (!this.batch.isActive() || this.requestId !== null) return;
      var prevTime;
      var _onAnimationFrame = function onAnimationFrame(time2) {
        return __async(_this79, null, /*#__PURE__*/_regenerator().m(function _callee0() {
          var _this80 = this;
          var executeAnimationFrame;
          return _regenerator().w(function (_context16) {
            while (1) switch (_context16.n) {
              case 0:
                executeAnimationFrame = function executeAnimationFrame() {
                  return __async(_this80, null, /*#__PURE__*/_regenerator().m(function _callee9() {
                    var deltaTime;
                    return _regenerator().w(function (_context15) {
                      while (1) switch (_context15.n) {
                        case 0:
                          deltaTime = time2 - (prevTime != null ? prevTime : time2);
                          prevTime = time2;
                          this.debug("AnimationManager - onAnimationFrame()", {
                            controllersCount: this.batch.size,
                            deltaTime: deltaTime
                          });
                          this.interactionManager.pushState(1 /* Animation */);
                          try {
                            this.batch.progress(deltaTime);
                          } catch (error) {
                            this.failsafeOnError(error);
                          }
                          this.listeners.dispatch("animation-frame", {
                            type: "animation-frame",
                            deltaMs: deltaTime
                          });
                        case 1:
                          return _context15.a(2);
                      }
                    }, _callee9, this);
                  }));
                };
                if (!this.isSkippingFrames()) {
                  _context16.n = 2;
                  break;
                }
                _context16.n = 1;
                return this.chartUpdateMutex.acquireImmediately(executeAnimationFrame);
              case 1:
                _context16.n = 3;
                break;
              case 2:
                _context16.n = 3;
                return this.chartUpdateMutex.acquire(executeAnimationFrame);
              case 3:
                if (this.batch.isActive()) {
                  this.scheduleAnimationFrame(_onAnimationFrame);
                } else {
                  this.batch.stop();
                  this.listeners.dispatch("animation-stop", {
                    type: "animation-stop",
                    deltaMs: this.batch.consumedTimeMs
                  });
                }
              case 4:
                return _context16.a(2);
            }
          }, _callee0, this);
        }));
      };
      this.listeners.dispatch("animation-start", {
        type: "animation-start",
        deltaMs: 0
      });
      this.scheduleAnimationFrame(_onAnimationFrame);
    }
  }, {
    key: "cancelAnimation",
    value: function cancelAnimation() {
      if (this.requestId === null) return;
      cancelAnimationFrame(this.requestId);
      this.requestId = null;
      this.startBatch();
    }
  }, {
    key: "failsafeOnError",
    value: function failsafeOnError(error) {
      var cancelAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _Logger.error("Error during animation, skipping animations", error);
      if (cancelAnimation) {
        this.cancelAnimation();
      }
    }
  }, {
    key: "startBatch",
    value: function startBatch(skipAnimations) {
      this.debug("AnimationManager - startBatch() with skipAnimations=".concat(skipAnimations, "."));
      this.reset();
      this.batch.stop();
      this.batch.destroy();
      this.batch = new AnimationBatch(this.defaultDuration * 1.5);
      if (skipAnimations === true) {
        this.batch.skip();
      }
    }
  }, {
    key: "endBatch",
    value: function endBatch() {
      if (this.batch.isActive()) {
        this.batch.ready();
        this.requestAnimation();
      } else {
        this.interactionManager.popState(1 /* Animation */);
        if (this.batch.isSkipped()) {
          this.batch.skip(false);
        }
      }
    }
  }, {
    key: "onBatchStop",
    value: function onBatchStop(cb) {
      this.batch.stoppedCbs.add(cb);
    }
  }]);
  return AnimationManager;
}(BaseManager);

// packages/ag-charts-community/src/chart/interaction/ariaAnnouncementServices.ts
var AriaAnnouncementService = /*#__PURE__*/function () {
  function _AriaAnnouncementService(canvas) {
    _classCallCheck(this, _AriaAnnouncementService);
    this.canvas = canvas;
    this.debug = Debug.create(true, "aria");
    this.canvas.appendChild(this.liveElem = _AriaAnnouncementService.createAnnouncer());
  }
  _createClass(_AriaAnnouncementService, [{
    key: "destroy",
    value: function destroy() {
      this.canvas.removeChild(this.liveElem);
    }
  }, {
    key: "announceValue",
    value: function announceValue(value) {
      this.debug("AriaAnnouncementService - announceValue: ".concat(value));
      this.liveElem.textContent = value;
    }
  }], [{
    key: "createAnnouncer",
    value: function createAnnouncer() {
      var e = _getDocument2().createElement("div");
      e.classList.add("ag-charts-aria-announcer");
      _setAttribute(e, "role", "status");
      _setAttribute(e, "aria-live", "assertive");
      return e;
    }
  }]);
  return _AriaAnnouncementService;
}();

// packages/ag-charts-community/src/chart/interaction/chartEventManager.ts
var _ChartEventManager = /*#__PURE__*/function (_BaseManager3) {
  _inherits(ChartEventManager, _BaseManager3);
  function ChartEventManager() {
    _classCallCheck(this, ChartEventManager);
    return _possibleConstructorReturn(this, _getPrototypeOf(ChartEventManager).apply(this, arguments));
  }
  _createClass(ChartEventManager, [{
    key: "legendItemClick",
    value: function legendItemClick(series, itemId, enabled, legendItemName) {
      var event = {
        type: "legend-item-click",
        series: series,
        itemId: itemId,
        enabled: enabled,
        legendItemName: legendItemName
      };
      this.listeners.dispatch("legend-item-click", event);
    }
  }, {
    key: "legendItemDoubleClick",
    value: function legendItemDoubleClick(series, itemId, enabled, numVisibleItems, legendItemName) {
      var event = {
        type: "legend-item-double-click",
        series: series,
        itemId: itemId,
        enabled: enabled,
        legendItemName: legendItemName,
        numVisibleItems: numVisibleItems
      };
      this.listeners.dispatch("legend-item-double-click", event);
    }
  }, {
    key: "axisHover",
    value: function axisHover(axisId, direction) {
      var event = {
        type: "axis-hover",
        axisId: axisId,
        direction: direction
      };
      this.listeners.dispatch("axis-hover", event);
    }
  }]);
  return ChartEventManager;
}(BaseManager);

// packages/ag-charts-community/src/chart/interaction/contextMenuRegistry.ts
var _ContextMenuRegistry = /*#__PURE__*/function () {
  function ContextMenuRegistry() {
    _classCallCheck(this, ContextMenuRegistry);
    this.defaultActions = [];
    this.disabledActions = /* @__PURE__ */new Set();
  }
  _createClass(ContextMenuRegistry, [{
    key: "copyDefaultActions",
    value: function copyDefaultActions() {
      return _toConsumableArray(this.defaultActions);
    }
  }, {
    key: "registerDefaultAction",
    value: function registerDefaultAction(action) {
      if (action.id && this.defaultActions.find(function (_ref84) {
        var id = _ref84.id;
        return id === action.id;
      })) {
        return;
      }
      this.defaultActions.push(action);
    }
  }, {
    key: "enableAction",
    value: function enableAction(actionId) {
      this.disabledActions.delete(actionId);
    }
  }, {
    key: "disableAction",
    value: function disableAction(actionId) {
      this.disabledActions.add(actionId);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(actionId) {
      return this.disabledActions.has(actionId);
    }
  }]);
  return ContextMenuRegistry;
}();

// packages/ag-charts-community/src/util/stateTracker.ts
var StateTracker = /*#__PURE__*/function (_Map3) {
  _inherits(StateTracker, _Map3);
  function StateTracker(defaultValue, defaultState) {
    var _this81;
    _classCallCheck(this, StateTracker);
    _this81 = _possibleConstructorReturn(this, _getPrototypeOf(StateTracker).call(this));
    _this81.defaultValue = defaultValue;
    _this81.defaultState = defaultState;
    return _this81;
  }
  _createClass(StateTracker, [{
    key: "set",
    value: function set(key, value) {
      this.delete(key);
      if (typeof value !== "undefined") {
        _superPropGet(StateTracker, "set", this, 3)([key, value]);
      }
      return this;
    }
  }, {
    key: "stateId",
    value: function stateId() {
      var _a;
      return (_a = Array.from(this.keys()).pop()) != null ? _a : this.defaultState;
    }
  }, {
    key: "stateValue",
    value: function stateValue() {
      var _a;
      return (_a = Array.from(this.values()).pop()) != null ? _a : this.defaultValue;
    }
  }]);
  return StateTracker;
}(_wrapNativeSuper(Map));

// packages/ag-charts-community/src/chart/interaction/cursorManager.ts
var _CursorManager = /*#__PURE__*/function () {
  function CursorManager(element2) {
    _classCallCheck(this, CursorManager);
    this.element = element2;
    this.stateTracker = new StateTracker("default");
  }
  _createClass(CursorManager, [{
    key: "updateCursor",
    value: function updateCursor(callerId, style) {
      this.stateTracker.set(callerId, style);
      this.element.style.cursor = this.stateTracker.stateValue();
    }
  }, {
    key: "getCursor",
    value: function getCursor() {
      return this.element.style.cursor;
    }
  }]);
  return CursorManager;
}();

// packages/ag-charts-community/src/chart/interaction/gestureDetector.ts
function distanceSquared(finger1, finger2) {
  var dx = finger1.screenX - finger2.screenX;
  var dy = finger1.screenY - finger2.screenY;
  return dx * dx + dy * dy;
}
function distance(finger1, finger2) {
  return Math.sqrt(distanceSquared(finger1, finger2));
}
var MIN_DISTANCE_TO_START_PINCH = 1;
var _GestureDetector = /*#__PURE__*/function (_BaseManager4) {
  _inherits(GestureDetector, _BaseManager4);
  function GestureDetector(element2) {
    var _this82;
    _classCallCheck(this, GestureDetector);
    _this82 = _possibleConstructorReturn(this, _getPrototypeOf(GestureDetector).call(this));
    _this82.touchstart = function (event) {
      return _this82.onTouchStart(event);
    };
    _this82.touchmove = function (event) {
      return _this82.onTouchMove(event);
    };
    _this82.touchend = function (event) {
      return _this82.onTouchEnd(event);
    };
    _this82.touchcancel = function (event) {
      return _this82.onTouchCancel(event);
    };
    _this82.pinch = {
      finger1: {
        identifier: NaN,
        screenX: NaN,
        screenY: NaN
      },
      finger2: {
        identifier: NaN,
        screenX: NaN,
        screenY: NaN
      },
      origin: {
        x: NaN,
        y: NaN
      },
      distance: NaN,
      status: 0 /* Off */
    };
    _this82.element = element2;
    element2.addEventListener("touchstart", _this82.touchstart, {
      passive: true
    });
    element2.addEventListener("touchmove", _this82.touchmove, {
      passive: true
    });
    element2.addEventListener("touchend", _this82.touchend);
    element2.addEventListener("touchcancel", _this82.touchcancel);
    return _this82;
  }
  _createClass(GestureDetector, [{
    key: "destroy",
    value: function destroy() {
      var element2 = this.element;
      element2.removeEventListener("touchstart", this.touchstart);
      element2.removeEventListener("touchmove", this.touchmove);
      element2.removeEventListener("touchend", this.touchend);
      element2.removeEventListener("touchcancel", this.touchcancel);
    }
  }, {
    key: "findPinchTouches",
    value: function findPinchTouches(moveEvent) {
      var touches = moveEvent.touches;
      var _this$pinch = this.pinch,
        finger1 = _this$pinch.finger1,
        finger2 = _this$pinch.finger2;
      if (this.pinch.status !== 0 /* Off */ && touches.length === 2) {
        if (touches[0].identifier === finger1.identifier && touches[1].identifier === finger2.identifier) {
          return [touches[0], touches[1]];
        }
        if (touches[0].identifier === finger2.identifier && touches[1].identifier === finger1.identifier) {
          return [touches[1], touches[0]];
        }
      }
    }
  }, {
    key: "copyTouchData",
    value: function copyTouchData(event) {
      var keys = ["identifier", "screenX", "screenY"];
      _partialAssign(keys, this.pinch.finger1, event.touches[0]);
      _partialAssign(keys, this.pinch.finger2, event.touches[1]);
      this.pinch.distance = distance(this.pinch.finger1, this.pinch.finger2);
    }
  }, {
    key: "dispatchPinchEvent",
    value: function dispatchPinchEvent(type, deltaDistance) {
      var _this$pinch2 = this.pinch,
        finger1 = _this$pinch2.finger1,
        finger2 = _this$pinch2.finger2,
        origin = _this$pinch2.origin;
      var newEvent = {
        type: type,
        finger1: finger1,
        finger2: finger2,
        deltaDistance: deltaDistance,
        origin: origin
      };
      this.listeners.dispatch(type, newEvent);
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      this.stopPinchTracking();
      var pinch = this.pinch;
      if (event.touches.length === 2) {
        pinch.status = 1 /* Initialized */;
        this.copyTouchData(event);
        pinch.origin.x = (event.touches[0].clientX + event.touches[1].clientX) / 2;
        pinch.origin.y = (event.touches[0].clientY + event.touches[1].clientY) / 2;
      }
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(event) {
      var pinchTouches = this.findPinchTouches(event);
      if (pinchTouches !== void 0) {
        var _pinchTouches = _slicedToArray(pinchTouches, 2),
          touch1 = _pinchTouches[0],
          touch2 = _pinchTouches[1];
        var pinch = this.pinch;
        var newDistance = distance(touch1, touch2);
        var deltaDistance = newDistance - pinch.distance;
        if (pinch.status === 1 /* Initialized */) {
          if (Math.abs(deltaDistance) > MIN_DISTANCE_TO_START_PINCH) {
            pinch.status = 2 /* Running */;
            this.copyTouchData(event);
            this.dispatchPinchEvent("pinch-start", 0);
          }
        } else if (pinch.status === 2 /* Running */) {
          pinch.distance = newDistance;
          this.copyTouchData(event);
          this.dispatchPinchEvent("pinch-move", deltaDistance);
        } else {
          _Logger.error("unexpected pinch.status: ".concat(pinch.status));
        }
      }
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(_event) {
      this.stopPinchTracking();
    }
  }, {
    key: "onTouchCancel",
    value: function onTouchCancel(_event) {
      this.stopPinchTracking();
    }
  }, {
    key: "stopPinchTracking",
    value: function stopPinchTracking() {
      var pinch = this.pinch;
      if (pinch.status === 2 /* Running */) {
        this.dispatchPinchEvent("pinch-end", 0);
      }
      this.pinch.status = 0 /* Off */;
    }
  }]);
  return GestureDetector;
}(BaseManager);

// packages/ag-charts-community/src/chart/interaction/highlightManager.ts
var _HighlightManager = /*#__PURE__*/function (_BaseManager5) {
  _inherits(HighlightManager, _BaseManager5);
  function HighlightManager() {
    var _this83;
    _classCallCheck(this, HighlightManager);
    _this83 = _possibleConstructorReturn(this, _getPrototypeOf(HighlightManager).apply(this, arguments));
    _this83.highlightStates = new StateTracker();
    _this83.pickedStates = new StateTracker();
    return _this83;
  }
  _createClass(HighlightManager, [{
    key: "updateHighlight",
    value: function updateHighlight(callerId, highlightedDatum) {
      var previousHighlight = this.activeHighlight;
      this.highlightStates.set(callerId, highlightedDatum);
      this.activeHighlight = this.highlightStates.stateValue();
      if (!this.isEqual(this.activeHighlight, previousHighlight)) {
        this.listeners.dispatch("highlight-change", {
          type: "highlight-change",
          currentHighlight: this.activeHighlight,
          previousHighlight: previousHighlight
        });
      }
    }
  }, {
    key: "getActiveHighlight",
    value: function getActiveHighlight() {
      return this.activeHighlight;
    }
  }, {
    key: "updatePicked",
    value: function updatePicked(callerId, clickableDatum) {
      this.pickedStates.set(callerId, clickableDatum);
      this.activePicked = this.pickedStates.stateValue();
    }
  }, {
    key: "getActivePicked",
    value: function getActivePicked() {
      return this.activePicked;
    }
  }, {
    key: "isEqual",
    value: function isEqual(a, b) {
      return a === b || (a == null ? void 0 : a.series) === (b == null ? void 0 : b.series) && (a == null ? void 0 : a.itemId) === (b == null ? void 0 : b.itemId) && (a == null ? void 0 : a.datum) === (b == null ? void 0 : b.datum);
    }
  }]);
  return HighlightManager;
}(BaseManager);

// packages/ag-charts-community/src/chart/interaction/keyNavManager.ts
var KeyNavManager = /*#__PURE__*/function (_BaseManager6) {
  _inherits(KeyNavManager, _BaseManager6);
  function KeyNavManager(interactionManager) {
    var _this84;
    _classCallCheck(this, KeyNavManager);
    _this84 = _possibleConstructorReturn(this, _getPrototypeOf(KeyNavManager).call(this));
    _this84.hasBrowserFocus = false;
    _this84.isMouseBlurred = false;
    _this84.isClicking = false;
    _this84.destroyFns.push(interactionManager.addListener("drag-start", function (e) {
      return _this84.onClickStart(e);
    }, 31 /* All */), interactionManager.addListener("click", function (e) {
      return _this84.onClickStop(e);
    }, 31 /* All */), interactionManager.addListener("drag-end", function (e) {
      return _this84.onClickStop(e);
    }, 31 /* All */), interactionManager.addListener("wheel", function (e) {
      return _this84.mouseBlur(e);
    }), interactionManager.addListener("hover", function (e) {
      return _this84.mouseBlur(e);
    }), interactionManager.addListener("drag", function (e) {
      return _this84.mouseBlur(e);
    }), interactionManager.addListener("blur", function (e) {
      return _this84.onBlur(e);
    }, 31 /* All */), interactionManager.addListener("focus", function (e) {
      return _this84.onFocus(e);
    }, 31 /* All */), interactionManager.addListener("keydown", function (e) {
      return _this84.onKeyDown(e);
    }, 31 /* All */));
    return _this84;
  }
  _createClass(KeyNavManager, [{
    key: "destroy",
    value: function destroy() {
      _superPropGet(KeyNavManager, "destroy", this, 3)([]);
    }
  }, {
    key: "onClickStart",
    value: function onClickStart(event) {
      this.isClicking = true;
      this.mouseBlur(event);
    }
  }, {
    key: "onClickStop",
    value: function onClickStop(event) {
      this.isClicking = false;
      this.mouseBlur(event);
    }
  }, {
    key: "mouseBlur",
    value: function mouseBlur(event) {
      if (!this.hasBrowserFocus) return;
      if (!this.isMouseBlurred) {
        this.dispatch("blur", 0, event);
        this.isMouseBlurred = true;
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      this.hasBrowserFocus = false;
      this.isMouseBlurred = false;
      this.dispatch("blur", 0, event);
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      this.hasBrowserFocus = true;
      if (this.isClicking) {
        this.isMouseBlurred = true;
      } else {
        this.dispatch("browserfocus", 1, event);
        this.dispatch("tab", 0, event);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (!this.hasBrowserFocus || this.isClicking) return;
      this.isMouseBlurred = false;
      switch (event.sourceEvent.code) {
        case "Tab":
          if (event.sourceEvent.shiftKey) {
            return this.dispatch("tab", -1, event);
          } else {
            return this.dispatch("tab", 1, event);
          }
        case "ArrowDown":
          return this.dispatch("nav-vert", 1, event);
        case "ArrowUp":
          return this.dispatch("nav-vert", -1, event);
        case "ArrowLeft":
          return this.dispatch("nav-hori", -1, event);
        case "ArrowRight":
          return this.dispatch("nav-hori", 1, event);
        case "Space":
        case "Enter":
          return this.dispatch("submit", 0, event);
      }
    }
  }, {
    key: "dispatch",
    value: function dispatch(type, delta2, interactionEvent) {
      var event = buildConsumable({
        type: type,
        delta: delta2,
        sourceEvent: interactionEvent
      });
      dispatchTypedConsumable(this.listeners, type, event);
    }
  }]);
  return KeyNavManager;
}(BaseManager);

// packages/ag-charts-community/src/chart/interaction/focusStyles.ts
var focusStyles_exports = {};
__export(focusStyles_exports, {
  block: function block() {
    return _block;
  },
  css: function css() {
    return _css;
  },
  elements: function elements() {
    return _elements;
  },
  modifiers: function modifiers() {
    return _modifiers;
  }
});
var _block = "ag-charts-focus";
var _elements = {
  wrapper: "".concat(_block, "__wrapper"),
  indicator: "".concat(_block, "__indicator")
};
var _modifiers = {
  hidden: "".concat(_block, "--hidden")
};
var _css = "\n.".concat(_block, ".").concat(_elements.wrapper, " {\n    position: relative;\n    display: block;\n    pointer-events: none;\n    user-select: none;\n    overflow: hidden;\n    top: 0;\n    left: 0;\n}\n\n.").concat(_block, ".").concat(_elements.indicator, " {\n    position: absolute;\n    display: block;\n    pointer-events: none;\n    user-select: none;\n    border: var(--ag-charts-focus-border);\n    box-shadow: var(--ag-charts-focus-border-shadow);\n}\n\n.").concat(_modifiers.hidden, " {\n    visibility: hidden;\n}\n");

// packages/ag-charts-community/src/chart/interaction/regionManager.ts
var REGION_TAB_ORDERING = ["series", "legend"];
var RegionListeners = /*#__PURE__*/function (_Listeners2) {
  _inherits(RegionListeners, _Listeners2);
  function RegionListeners() {
    _classCallCheck(this, RegionListeners);
    return _possibleConstructorReturn(this, _getPrototypeOf(RegionListeners).apply(this, arguments));
  }
  return RegionListeners;
}(Listeners);
var RegionManager = /*#__PURE__*/function () {
  function RegionManager(interactionManager, keyNavManager, canvasElement, element2) {
    var _this$destroyFns,
      _this85 = this;
    _classCallCheck(this, RegionManager);
    this.interactionManager = interactionManager;
    this.keyNavManager = keyNavManager;
    this.canvasElement = canvasElement;
    this.currentTabIndex = 0;
    this.isDragging = false;
    this.leftCanvas = false;
    this.regions = /* @__PURE__ */new Map();
    this.destroyFns = [];
    (_this$destroyFns = this.destroyFns).push.apply(_this$destroyFns, _toConsumableArray(_POINTER_INTERACTION_TYPES.map(function (eventName) {
      return interactionManager.addListener(eventName, _this85.processPointerEvent.bind(_this85), 31 /* All */);
    })).concat([this.keyNavManager.addListener("blur", this.onNav.bind(this)), this.keyNavManager.addListener("browserfocus", this.onFocus.bind(this)), this.keyNavManager.addListener("tab", this.onTab.bind(this)), this.keyNavManager.addListener("nav-vert", this.onNav.bind(this)), this.keyNavManager.addListener("nav-hori", this.onNav.bind(this)), this.keyNavManager.addListener("submit", this.onNav.bind(this))]));
    _injectStyle(_css, _block);
    this.focusWrapper = _getDocument2().createElement("div");
    this.focusIndicator = _getDocument2().createElement("div");
    this.focusWrapper.appendChild(this.focusIndicator);
    element2.appendChild(this.focusWrapper);
    var block3 = focusStyles_exports.block,
      elements3 = focusStyles_exports.elements,
      modifiers3 = focusStyles_exports.modifiers;
    this.focusWrapper.classList.add(block3, elements3.wrapper);
    this.focusIndicator.classList.add(block3, elements3.indicator, modifiers3.hidden);
  }
  _createClass(RegionManager, [{
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (fn) {
        return fn();
      });
      this.currentRegion = void 0;
      var _iterator94 = _createForOfIteratorHelper(this.regions.values()),
        _step94;
      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var region = _step94.value;
          region.listeners.destroy();
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
      this.focusWrapper.remove();
      this.regions.clear();
    }
  }, {
    key: "addRegionFromProperties",
    value: function addRegionFromProperties(properties) {
      var region = {
        properties: properties,
        listeners: new RegionListeners()
      };
      this.regions.set(properties.name, region);
      return this.makeObserver(region);
    }
  }, {
    key: "addRegion",
    value: function addRegion(name, bboxprovider) {
      for (var _len23 = arguments.length, extraProviders = new Array(_len23 > 2 ? _len23 - 2 : 0), _key24 = 2; _key24 < _len23; _key24++) {
        extraProviders[_key24 - 2] = arguments[_key24];
      }
      return this.addRegionFromProperties({
        name: name,
        bboxproviders: [bboxprovider].concat(extraProviders),
        canInteraction: function canInteraction() {
          return true;
        }
      });
    }
  }, {
    key: "getRegion",
    value: function getRegion(name) {
      return this.makeObserver(this.regions.get(name));
    }
  }, {
    key: "find",
    value: function find(x, y) {
      var matches = [];
      var _iterator95 = _createForOfIteratorHelper(this.regions.entries()),
        _step95;
      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var _step95$value = _slicedToArray(_step95.value, 2),
            _name = _step95$value[0],
            region = _step95$value[1];
          var _iterator96 = _createForOfIteratorHelper(region.properties.bboxproviders),
            _step96;
          try {
            for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
              var provider = _step96.value;
              var bbox = provider.getCachedBBox();
              if (bbox.containsPoint(x, y)) {
                matches.push([region, bbox.width * bbox.height]);
              }
            }
          } catch (err) {
            _iterator96.e(err);
          } finally {
            _iterator96.f();
          }
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
      return matches.sort(function (a, b) {
        return a[1] - b[1];
      }).map(function (m) {
        return m[0];
      });
    } // This method return a wrapper object that matches the interface of InteractionManager.addListener.
    // The intent is to allow the InteractionManager and RegionManager to be used almost interchangeably.
  }, {
    key: "makeObserver",
    value: function makeObserver(region) {
      var interactionManager = this.interactionManager;
      var ObservableRegionImplementation = /*#__PURE__*/function () {
        function ObservableRegionImplementation() {
          _classCallCheck(this, ObservableRegionImplementation);
        }
        _createClass(ObservableRegionImplementation, [{
          key: "addListener",
          value: function addListener(type, handler) {
            var triggeringStates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
            var _a;
            return (_a = region == null ? void 0 : region.listeners.addListener(type, function (e) {
              if (!e.consumed) {
                var currentState = interactionManager.getState();
                if (currentState & triggeringStates) {
                  handler(e);
                }
              }
            })) != null ? _a : function () {};
          }
        }]);
        return ObservableRegionImplementation;
      }();
      return new ObservableRegionImplementation();
    }
  }, {
    key: "checkPointerHistory",
    value: function checkPointerHistory(targetRegion, event) {
      var _iterator97 = _createForOfIteratorHelper(event.pointerHistory),
        _step97;
      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var historyEvent = _step97.value;
          var historyRegion = this.pickRegion(historyEvent.offsetX, historyEvent.offsetY);
          if (targetRegion.properties.name !== (historyRegion == null ? void 0 : historyRegion.properties.name)) {
            return false;
          }
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
      return true;
    }
  }, {
    key: "dispatch",
    value: function dispatch(region, event) {
      region == null ? void 0 : region.listeners.dispatch(event.type, event);
    } // Process events during a drag action. Returns false if this event should follow the standard
    // RegionManager.processEvent flow, or true if this event already processed by this function.
  }, {
    key: "handleDragging",
    value: function handleDragging(event) {
      var currentRegion = this.currentRegion;
      switch (event.type) {
        case "drag-start":
          this.isDragging = true;
          this.leftCanvas = false;
          break;
        case "leave":
          this.leftCanvas = true;
          return this.isDragging;
        case "enter":
          this.leftCanvas = false;
          return this.isDragging;
        case "drag":
          if (this.isDragging) {
            this.dispatch(currentRegion, event);
            return true;
          }
          break;
        case "drag-end":
          if (this.isDragging) {
            this.isDragging = false;
            this.dispatch(currentRegion, event);
            if (this.leftCanvas) {
              this.dispatch(currentRegion, __spreadProps(__spreadValues({}, event), {
                type: "leave"
              }));
            }
            return true;
          }
          break;
      }
      return false;
    }
  }, {
    key: "processPointerEvent",
    value: function processPointerEvent(event) {
      if (this.handleDragging(event)) {
        return;
      }
      var currentRegion = this.currentRegion;
      var newRegion = this.pickRegion(event.offsetX, event.offsetY);
      if (currentRegion !== void 0 && (newRegion == null ? void 0 : newRegion.properties.name) !== currentRegion.properties.name) {
        this.dispatch(currentRegion, __spreadProps(__spreadValues({}, event), {
          type: "leave"
        }));
      }
      if (newRegion !== void 0 && newRegion.properties.name !== (currentRegion == null ? void 0 : currentRegion.properties.name)) {
        this.dispatch(newRegion, __spreadProps(__spreadValues({}, event), {
          type: "enter"
        }));
      }
      if (newRegion !== void 0 && this.checkPointerHistory(newRegion, event)) {
        this.dispatch(newRegion, event);
      }
      this.currentRegion = newRegion;
    }
  }, {
    key: "pickRegion",
    value: function pickRegion(x, y) {
      var matchingRegions = this.find(x, y);
      return matchingRegions.length > 0 ? matchingRegions[0] : void 0;
    }
  }, {
    key: "getTabRegion",
    value: function getTabRegion(tabIndex) {
      if (tabIndex !== void 0 && tabIndex >= 0 && tabIndex < REGION_TAB_ORDERING.length) {
        return this.regions.get(REGION_TAB_ORDERING[tabIndex]);
      }
      return void 0;
    }
  }, {
    key: "dispatchTabStart",
    value: function dispatchTabStart(event) {
      var delta2 = event.delta,
        sourceEvent = event.sourceEvent;
      var startEvent = buildConsumable({
        type: "tab-start",
        delta: delta2,
        sourceEvent: sourceEvent
      });
      var focusedRegion = this.getTabRegion(this.currentTabIndex);
      this.dispatch(focusedRegion, startEvent);
      return !!startEvent.consumed;
    }
  }, {
    key: "getNextInteractableTabIndex",
    value: function getNextInteractableTabIndex(currentIndex, delta2) {
      var direction = delta2 < 0 ? -1 : 1;
      var i = currentIndex;
      while (delta2 !== 0) {
        var region = this.getTabRegion(i + direction);
        if (region === void 0) {
          return void 0;
        } else if (region.properties.canInteraction()) {
          delta2 = delta2 - direction;
        }
        i = i + direction;
      }
      return i;
    }
  }, {
    key: "validateCurrentTabIndex",
    value: function validateCurrentTabIndex() {
      var _a;
      var focusedRegion = this.getTabRegion(this.currentTabIndex);
      if (focusedRegion !== void 0 && !focusedRegion.properties.canInteraction()) {
        this.currentTabIndex = (_a = this.getNextInteractableTabIndex(-1, 1)) != null ? _a : 0;
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      var delta2 = event.delta,
        sourceEvent = event.sourceEvent;
      var newIndex = delta2 > 0 ? this.getNextInteractableTabIndex(-1, 1) : this.getNextInteractableTabIndex(REGION_TAB_ORDERING.length, -1);
      this.currentTabIndex = newIndex != null ? newIndex : 0;
      var focusedRegion = this.getTabRegion(this.currentTabIndex);
      if (focusedRegion) {
        this.dispatch(focusedRegion, buildConsumable({
          type: "tab",
          delta: delta2,
          sourceEvent: sourceEvent
        }));
      }
    }
  }, {
    key: "onTab",
    value: function onTab(event) {
      var consumed = this.dispatchTabStart(event);
      if (consumed) return;
      this.validateCurrentTabIndex();
      var newTabIndex = this.getNextInteractableTabIndex(this.currentTabIndex, event.delta);
      var newRegion = this.getTabRegion(newTabIndex);
      var focusedRegion = this.getTabRegion(this.currentTabIndex);
      if (newTabIndex !== void 0) {
        this.currentTabIndex = newTabIndex;
      }
      if (focusedRegion !== void 0 && (newRegion == null ? void 0 : newRegion.properties.name) !== focusedRegion.properties.name) {
        var delta2 = event.delta,
          sourceEvent = event.sourceEvent;
        var blurEvent = buildConsumable({
          type: "blur",
          delta: delta2,
          sourceEvent: sourceEvent
        });
        this.dispatch(focusedRegion, blurEvent);
      }
      if (newRegion === void 0 || !newRegion.properties.canInteraction()) {
        this.updateFocusIndicatorRect(void 0);
      } else {
        this.dispatch(newRegion, event);
      }
    }
  }, {
    key: "onNav",
    value: function onNav(event) {
      var focusedRegion = this.getTabRegion(this.currentTabIndex);
      this.dispatch(focusedRegion, event);
    }
  }, {
    key: "updateFocusWrapperRect",
    value: function updateFocusWrapperRect() {
      this.focusWrapper.style.width = this.canvasElement.style.width;
      this.focusWrapper.style.height = this.canvasElement.style.height;
    }
  }, {
    key: "updateFocusIndicatorRect",
    value: function updateFocusIndicatorRect(rect) {
      if (rect == null) {
        this.focusIndicator.classList.add(_modifiers.hidden);
        return;
      }
      this.updateFocusWrapperRect();
      this.focusIndicator.classList.remove(_modifiers.hidden);
      this.focusIndicator.style.width = "".concat(rect.width, "px");
      this.focusIndicator.style.height = "".concat(rect.height, "px");
      this.focusIndicator.style.left = "".concat(rect.x, "px");
      this.focusIndicator.style.top = "".concat(rect.y, "px");
    }
  }]);
  return RegionManager;
}();

// packages/ag-charts-community/src/chart/interaction/toolbarManager.ts
var _ToolbarManager = /*#__PURE__*/function (_BaseManager7) {
  _inherits(ToolbarManager, _BaseManager7);
  function ToolbarManager(element2) {
    var _this86;
    _classCallCheck(this, ToolbarManager);
    _this86 = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarManager).call(this));
    _this86.element = element2;
    return _this86;
  }
  _createClass(ToolbarManager, [{
    key: "pressButton",
    value: function pressButton(group2, value) {
      this.listeners.dispatch("button-pressed", {
        type: "button-pressed",
        group: group2,
        value: value
      });
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup(group2, visible) {
      this.listeners.dispatch("group-toggled", {
        type: "group-toggled",
        group: group2,
        visible: visible
      });
    }
  }, {
    key: "toggleButton",
    value: function toggleButton(group2, value, enabled) {
      this.listeners.dispatch("button-toggled", {
        type: "button-toggled",
        group: group2,
        value: value,
        enabled: enabled
      });
    }
  }, {
    key: "proxyGroupOptions",
    value: function proxyGroupOptions(group2, options) {
      this.listeners.dispatch("proxy-group-options", {
        type: "proxy-group-options",
        group: group2,
        options: options
      });
    }
  }], [{
    key: "isGroup",
    value: function isGroup(group2, event) {
      return event.group === group2;
    }
  }]);
  return ToolbarManager;
}(BaseManager);

// packages/ag-charts-community/src/chart/interaction/tooltipManager.ts
var defaultTooltipCss = "\n.".concat(_DEFAULT_TOOLTIP_CLASS, " {\n    transition: transform 0.1s ease;\n    max-width: 100%;\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    z-index: 99999;\n    font: 12px Verdana, sans-serif;\n    color: rgb(70, 70, 70);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-wrap-always {\n    overflow-wrap: break-word;\n    word-break: break-word;\n    hyphens: none;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-wrap-hyphenate {\n    overflow-wrap: break-word;\n    word-break: break-word;\n    hyphens: auto;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-wrap-on-space {\n    overflow-wrap: normal;\n    word-break: normal;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-wrap-never {\n    white-space: pre;\n    text-overflow: ellipsis;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-no-interaction {\n    pointer-events: none;\n    user-select: none;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-no-animation {\n    transition: none !important;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-hidden {\n    visibility: hidden;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-title {\n    overflow: hidden;\n    position: relative;\n    padding: 8px 14px;\n    border-top-left-radius: 2px;\n    border-top-right-radius: 2px;\n    color: white;\n    background-color: #888888;\n    z-index: 1;\n    text-overflow: inherit;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-title:only-child {\n    border-bottom-left-radius: 2px;\n    border-bottom-right-radius: 2px;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-content {\n    overflow: hidden;\n    padding: 6px 14px;\n    line-height: 1.7em;\n    background: white;\n    border-bottom-left-radius: 2px;\n    border-bottom-right-radius: 2px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    overflow: hidden;\n    text-overflow: inherit;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-arrow::before {\n    content: \"\";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 5px solid #d9d9d9;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.").concat(_DEFAULT_TOOLTIP_CLASS, "-arrow::after {\n    content: \"\";\n\n    position: absolute;\n    top: calc(100% - 1px);\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 5px solid white;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.ag-chart-wrapper {\n    box-sizing: border-box;\n    overflow: hidden;\n}\n");
var _TooltipManager = /*#__PURE__*/function () {
  function TooltipManager(canvasElement, tooltip) {
    var _this87 = this;
    _classCallCheck(this, TooltipManager);
    this.canvasElement = canvasElement;
    this.tooltip = tooltip;
    this.stateTracker = new StateTracker();
    this.appliedState = null;
    if (typeof IntersectionObserver !== "undefined") {
      var observer = new IntersectionObserver(function (entries) {
        var _iterator98 = _createForOfIteratorHelper(entries),
          _step98;
        try {
          for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
            var entry = _step98.value;
            if (entry.target === _this87.canvasElement && entry.intersectionRatio === 0) {
              _this87.tooltip.toggle(false);
            }
          }
        } catch (err) {
          _iterator98.e(err);
        } finally {
          _iterator98.f();
        }
      }, {
        root: this.tooltip.root
      });
      observer.observe(this.canvasElement);
      this.observer = observer;
    }
    _injectStyle(defaultTooltipCss, "tooltip");
  }
  _createClass(TooltipManager, [{
    key: "updateTooltip",
    value: function updateTooltip(callerId, meta, content) {
      var _a;
      if (!this.tooltip.enabled) return;
      content != null ? content : content = (_a = this.stateTracker.get(callerId)) == null ? void 0 : _a.content;
      this.stateTracker.set(callerId, {
        content: content,
        meta: meta
      });
      this.applyStates();
    }
  }, {
    key: "removeTooltip",
    value: function removeTooltip(callerId) {
      if (!this.tooltip.enabled) return;
      this.stateTracker.delete(callerId);
      this.applyStates();
    }
  }, {
    key: "getTooltipMeta",
    value: function getTooltipMeta(callerId) {
      var _a;
      return (_a = this.stateTracker.get(callerId)) == null ? void 0 : _a.meta;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;
      (_a = this.observer) == null ? void 0 : _a.unobserve(this.canvasElement);
    }
  }, {
    key: "applyStates",
    value: function applyStates() {
      var _a;
      var id = this.stateTracker.stateId();
      var state = id ? this.stateTracker.get(id) : null;
      if ((state == null ? void 0 : state.meta) == null || (state == null ? void 0 : state.content) == null) {
        this.appliedState = null;
        this.tooltip.toggle(false);
        return;
      }
      var canvasRect = this.canvasElement.getBoundingClientRect();
      if (((_a = this.appliedState) == null ? void 0 : _a.content) === (state == null ? void 0 : state.content)) {
        var renderInstantly = this.tooltip.isVisible();
        this.tooltip.show(canvasRect, state == null ? void 0 : state.meta, null, renderInstantly);
      } else {
        this.tooltip.show(canvasRect, state == null ? void 0 : state.meta, state == null ? void 0 : state.content);
      }
      this.appliedState = state;
    }
  }], [{
    key: "makeTooltipMeta",
    value: function makeTooltipMeta(event, datum) {
      var _a, _b, _c, _d, _e, _f, _g;
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      var tooltip = datum.series.properties.tooltip;
      var meta = {
        offsetX: offsetX,
        offsetY: offsetY,
        enableInteraction: (_b = (_a = tooltip.interaction) == null ? void 0 : _a.enabled) != null ? _b : false,
        lastPointerEvent: {
          type: event.type,
          offsetX: offsetX,
          offsetY: offsetY
        },
        showArrow: tooltip.showArrow,
        position: {
          type: tooltip.position.type,
          xOffset: tooltip.position.xOffset,
          yOffset: tooltip.position.yOffset
        }
      };
      var refPoint = (_g = (_d = (_c = datum.yBar) == null ? void 0 : _c.upperPoint) != null ? _d : datum.midPoint) != null ? _g : (_f = (_e = datum.series).datumMidPoint) == null ? void 0 : _f.call(_e, datum);
      if (tooltip.position.type === "node" && refPoint) {
        var x = refPoint.x,
          y = refPoint.y;
        var point = datum.series.contentGroup.inverseTransformPoint(x, y);
        return __spreadProps(__spreadValues({}, meta), {
          offsetX: Math.round(point.x),
          offsetY: Math.round(point.y)
        });
      }
      return meta;
    }
  }]);
  return TooltipManager;
}();

// packages/ag-charts-community/src/chart/layout/layoutService.ts
var _LayoutService = /*#__PURE__*/function (_Listeners3) {
  _inherits(LayoutService, _Listeners3);
  function LayoutService() {
    var _this88;
    _classCallCheck(this, LayoutService);
    _this88 = _possibleConstructorReturn(this, _getPrototypeOf(LayoutService).apply(this, arguments));
    _this88.layoutComplete = "layout-complete";
    return _this88;
  }
  _createClass(LayoutService, [{
    key: "addListener",
    value: function addListener(eventType, handler) {
      if (this.isLayoutStage(eventType) || this.isLayoutComplete(eventType)) {
        return _superPropGet(LayoutService, "addListener", this, 3)([eventType, handler]);
      }
      throw new Error("AG Charts - unsupported listener type: ".concat(eventType));
    }
  }, {
    key: "dispatchPerformLayout",
    value: function dispatchPerformLayout(stage, ctx) {
      if (this.isLayoutStage(stage)) {
        return this.getListenersByType(stage).reduce(function (result, listener) {
          try {
            return listener.handler(result);
          } catch (e) {
            _Logger.errorOnce(e);
            return result;
          }
        }, ctx);
      }
      return ctx;
    }
  }, {
    key: "dispatchLayoutComplete",
    value: function dispatchLayoutComplete(event) {
      this.dispatch(this.layoutComplete, event);
    }
  }, {
    key: "isLayoutStage",
    value: function isLayoutStage(eventType) {
      return eventType !== this.layoutComplete;
    }
  }, {
    key: "isLayoutComplete",
    value: function isLayoutComplete(eventType) {
      return eventType === this.layoutComplete;
    }
  }]);
  return LayoutService;
}(Listeners);

// packages/ag-charts-community/src/chart/series/seriesStateManager.ts
var SeriesStateManager = /*#__PURE__*/function () {
  function SeriesStateManager() {
    _classCallCheck(this, SeriesStateManager);
    this.groups = {};
  }
  _createClass(SeriesStateManager, [{
    key: "registerSeries",
    value: function registerSeries(_ref85) {
      var id = _ref85.id,
        seriesGrouping = _ref85.seriesGrouping,
        visible = _ref85.visible,
        type = _ref85.type;
      var _a, _b;
      if (!seriesGrouping) return;
      (_b = (_a = this.groups)[type]) != null ? _b : _a[type] = {};
      this.groups[type][id] = {
        grouping: seriesGrouping,
        visible: visible
      };
    }
  }, {
    key: "deregisterSeries",
    value: function deregisterSeries(_ref86) {
      var id = _ref86.id,
        type = _ref86.type;
      if (this.groups[type]) {
        delete this.groups[type][id];
      }
      if (this.groups[type] && Object.keys(this.groups[type]).length === 0) {
        delete this.groups[type];
      }
    }
  }, {
    key: "getVisiblePeerGroupIndex",
    value: function getVisiblePeerGroupIndex(_ref87) {
      var type = _ref87.type,
        seriesGrouping = _ref87.seriesGrouping,
        visible = _ref87.visible;
      var _a;
      if (!seriesGrouping) return {
        visibleGroupCount: visible ? 1 : 0,
        visibleSameStackCount: visible ? 1 : 0,
        index: 0
      };
      var visibleGroupsSet = /* @__PURE__ */new Set();
      var visibleSameStackSet = /* @__PURE__ */new Set();
      for (var _i18 = 0, _Object$values2 = Object.values((_a = this.groups[type]) != null ? _a : {}); _i18 < _Object$values2.length; _i18++) {
        var entry = _Object$values2[_i18];
        if (!entry.visible) continue;
        visibleGroupsSet.add(entry.grouping.groupIndex);
        if (entry.grouping.groupIndex === seriesGrouping.groupIndex) {
          visibleSameStackSet.add(entry.grouping.stackIndex);
        }
      }
      var visibleGroups = Array.from(visibleGroupsSet);
      visibleGroups.sort(function (a, b) {
        return a - b;
      });
      return {
        visibleGroupCount: visibleGroups.length,
        visibleSameStackCount: visibleSameStackSet.size,
        index: visibleGroups.indexOf(seriesGrouping.groupIndex)
      };
    }
  }]);
  return SeriesStateManager;
}();

// packages/ag-charts-community/src/chart/chartUpdateType.ts
var _ChartUpdateType = /* @__PURE__ */function (ChartUpdateType2) {
  ChartUpdateType2[ChartUpdateType2["FULL"] = 0] = "FULL";
  ChartUpdateType2[ChartUpdateType2["UPDATE_DATA"] = 1] = "UPDATE_DATA";
  ChartUpdateType2[ChartUpdateType2["PROCESS_DATA"] = 2] = "PROCESS_DATA";
  ChartUpdateType2[ChartUpdateType2["PERFORM_LAYOUT"] = 3] = "PERFORM_LAYOUT";
  ChartUpdateType2[ChartUpdateType2["SERIES_UPDATE"] = 4] = "SERIES_UPDATE";
  ChartUpdateType2[ChartUpdateType2["TOOLTIP_RECALCULATION"] = 5] = "TOOLTIP_RECALCULATION";
  ChartUpdateType2[ChartUpdateType2["SCENE_RENDER"] = 6] = "SCENE_RENDER";
  ChartUpdateType2[ChartUpdateType2["NONE"] = 7] = "NONE";
  return ChartUpdateType2;
}(_ChartUpdateType || {});

// packages/ag-charts-community/src/chart/updateService.ts
var _UpdateService = /*#__PURE__*/function (_Listeners4) {
  _inherits(UpdateService, _Listeners4);
  function UpdateService(updateCallback) {
    var _this89;
    _classCallCheck(this, UpdateService);
    _this89 = _possibleConstructorReturn(this, _getPrototypeOf(UpdateService).call(this));
    _this89.updateCallback = updateCallback;
    return _this89;
  }
  _createClass(UpdateService, [{
    key: "update",
    value: function update() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var options = arguments.length > 1 ? arguments[1] : undefined;
      this.updateCallback(type, options);
    }
  }, {
    key: "dispatchUpdateComplete",
    value: function dispatchUpdateComplete(rects) {
      this.dispatch("update-complete", {
        type: "update-complete",
        minRect: rects == null ? void 0 : rects.minRect,
        minVisibleRect: rects == null ? void 0 : rects.minVisibleRect
      });
    }
  }]);
  return UpdateService;
}(Listeners);

// packages/ag-charts-community/src/chart/chartContext.ts
var ChartContext = /*#__PURE__*/function () {
  function ChartContext(chart, vars) {
    _classCallCheck(this, ChartContext);
    var scene = vars.scene,
      syncManager = vars.syncManager,
      element2 = vars.element,
      updateCallback = vars.updateCallback,
      updateMutex = vars.updateMutex;
    this.chartService = chart;
    this.scene = scene;
    this.syncManager = syncManager;
    this.zoomManager = chart.zoomManager;
    this.annotationManager = new AnnotationManager(chart.annotationRoot);
    this.ariaAnnouncementService = new AriaAnnouncementService(scene.canvas.element);
    this.chartEventManager = new _ChartEventManager();
    this.contextMenuRegistry = new _ContextMenuRegistry();
    this.cursorManager = new _CursorManager(element2);
    this.highlightManager = new _HighlightManager();
    this.interactionManager = new _InteractionManager2(chart.keyboard, element2);
    this.keyNavManager = new KeyNavManager(this.interactionManager);
    this.regionManager = new RegionManager(this.interactionManager, this.keyNavManager, this.scene.canvas.element, element2);
    this.toolbarManager = new _ToolbarManager(element2);
    this.gestureDetector = new _GestureDetector(element2);
    this.layoutService = new _LayoutService();
    this.updateService = new _UpdateService(updateCallback);
    this.seriesStateManager = new SeriesStateManager();
    this.callbackCache = new CallbackCache();
    this.animationManager = new _AnimationManager(this.interactionManager, updateMutex);
    this.animationManager.skip();
    this.animationManager.play();
    this.dataService = new _DataService(this.animationManager);
    this.tooltipManager = new _TooltipManager(this.scene.canvas.element, chart.tooltip);
  }
  _createClass(ChartContext, [{
    key: "destroy",
    value: function destroy() {
      this.tooltipManager.destroy();
      this.regionManager.destroy();
      this.keyNavManager.destroy();
      this.interactionManager.destroy();
      this.animationManager.stop();
      this.animationManager.destroy();
      this.ariaAnnouncementService.destroy();
      this.chartEventManager.destroy();
      this.highlightManager.destroy();
      this.callbackCache.invalidateCache();
      this.animationManager.reset();
      this.syncManager.destroy();
    }
  }]);
  return ChartContext;
}();

// packages/ag-charts-community/src/chart/chartHighlight.ts
var ChartHighlight = /*#__PURE__*/function (_BaseProperties9) {
  _inherits(ChartHighlight, _BaseProperties9);
  function ChartHighlight() {
    var _this90;
    _classCallCheck(this, ChartHighlight);
    _this90 = _possibleConstructorReturn(this, _getPrototypeOf(ChartHighlight).apply(this, arguments));
    _this90.range = "tooltip";
    return _this90;
  }
  return ChartHighlight;
}(_BaseProperties35);
__decorateClass([_Validate(_UNION(["tooltip", "node"], "a range"))], ChartHighlight.prototype, "range", 2);

// packages/ag-charts-community/src/chart/data/dataDomain.ts
var DiscreteDomain = /*#__PURE__*/function () {
  function _DiscreteDomain() {
    _classCallCheck(this, _DiscreteDomain);
    this.domain = /* @__PURE__ */new Set();
  }
  _createClass(_DiscreteDomain, [{
    key: "extend",
    value: function extend(val) {
      this.domain.add(val);
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return Array.from(this.domain);
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _DiscreteDomain;
    }
  }]);
  return _DiscreteDomain;
}();
var ContinuousDomain = /*#__PURE__*/function () {
  function _ContinuousDomain() {
    _classCallCheck(this, _ContinuousDomain);
    this.domain = [Infinity, -Infinity];
  }
  _createClass(_ContinuousDomain, [{
    key: "extend",
    value: function extend(value) {
      if (this.domain[0] > value) {
        this.domain[0] = value;
      }
      if (this.domain[1] < value) {
        this.domain[1] = value;
      }
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return _toConsumableArray(this.domain);
    }
  }], [{
    key: "is",
    value: function is(value) {
      return value instanceof _ContinuousDomain;
    }
  }, {
    key: "extendDomain",
    value: function extendDomain(values) {
      var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [Infinity, -Infinity];
      var _iterator99 = _createForOfIteratorHelper(values),
        _step99;
      try {
        for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
          var value = _step99.value;
          if (typeof value !== "number") {
            continue;
          }
          if (domain[0] > value) {
            domain[0] = value;
          }
          if (domain[1] < value) {
            domain[1] = value;
          }
        }
      } catch (err) {
        _iterator99.e(err);
      } finally {
        _iterator99.f();
      }
      return domain;
    }
  }]);
  return _ContinuousDomain;
}();

// packages/ag-charts-community/src/chart/data/dataModel.ts
function toKeyString(keys) {
  return keys.map(function (key) {
    return _isObject(key) ? JSON.stringify(key) : key;
  }).join("-");
}
function round2(val) {
  var accuracy = 1e4;
  if (Number.isInteger(val)) {
    return val;
  } else if (Math.abs(val) > accuracy) {
    return Math.trunc(val);
  }
  return Math.round(val * accuracy) / accuracy;
}
function fixNumericExtentInternal(extent2) {
  if (extent2 == null) {
    return [];
  }
  var _extent2$map = extent2.map(Number),
    _extent2$map2 = _slicedToArray(_extent2$map, 2),
    min = _extent2$map2[0],
    max = _extent2$map2[1];
  if (min === 0 && max === 0) {
    return [0, 1];
  }
  if (min === Infinity && max === -Infinity) {
    return [];
  } else if (min === Infinity) {
    min = 0;
  } else if (max === -Infinity) {
    max = 0;
  }
  return _isFiniteNumber(min) && _isFiniteNumber(max) ? [min, max] : [];
}
function _fixNumericExtent(extent2, axis) {
  var _a;
  var fixedExtent = fixNumericExtentInternal(extent2);
  if (fixedExtent.length === 0) {
    return fixedExtent;
  }
  var _fixedExtent = _slicedToArray(fixedExtent, 2),
    min = _fixedExtent[0],
    max = _fixedExtent[1];
  if (min === max) {
    var _ref88 = (_a = axis == null ? void 0 : axis.calculatePadding(min, max)) != null ? _a : [1, 1],
      _ref89 = _slicedToArray(_ref88, 2),
      paddingMin = _ref89[0],
      paddingMax = _ref89[1];
    min -= paddingMin;
    max += paddingMax;
  }
  return [min, max];
}
function _getMissCount(scopeProvider, missMap) {
  var _a;
  return (_a = missMap == null ? void 0 : missMap.get(scopeProvider.id)) != null ? _a : 0;
}
var INVALID_VALUE = Symbol("invalid");
var _DataModel = /*#__PURE__*/function () {
  function DataModel(opts) {
    var _this91 = this;
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "standalone";
    _classCallCheck(this, DataModel);
    this.opts = opts;
    this.mode = mode;
    this.debug = Debug.create(true, "data-model");
    this.scopeCache = /* @__PURE__ */new Map();
    this.keys = [];
    this.values = [];
    this.aggregates = [];
    this.groupProcessors = [];
    this.propertyProcessors = [];
    this.reducers = [];
    this.processors = [];
    var keys = true;
    var _iterator100 = _createForOfIteratorHelper(opts.props),
      _step100;
    try {
      for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
        var next = _step100.value;
        if (next.type === "key" && !keys) {
          throw new Error("AG Charts - internal config error: keys must come before values.");
        }
        if (next.type === "value" && keys) {
          keys = false;
        }
      }
    } catch (err) {
      _iterator100.e(err);
    } finally {
      _iterator100.f();
    }
    var verifyMatchGroupId = function verifyMatchGroupId(_ref90) {
      var _ref90$matchGroupIds = _ref90.matchGroupIds,
        matchGroupIds = _ref90$matchGroupIds === void 0 ? [] : _ref90$matchGroupIds;
      var _iterator101 = _createForOfIteratorHelper(matchGroupIds),
        _step101;
      try {
        var _loop8 = function _loop8() {
          var matchGroupId = _step101.value;
          if (_this91.values.every(function (def) {
            return def.groupId !== matchGroupId;
          })) {
            throw new Error("AG Charts - internal config error: matchGroupIds properties must match defined groups (".concat(matchGroupId, ")."));
          }
        };
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          _loop8();
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
    };
    var _iterator102 = _createForOfIteratorHelper(opts.props),
      _step102;
    try {
      for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
        var def = _step102.value;
        switch (def.type) {
          case "key":
            this.keys.push(__spreadProps(__spreadValues({}, def), {
              index: this.keys.length,
              missing: /* @__PURE__ */new Map()
            }));
            break;
          case "value":
            if (def.property == null) {
              throw new Error("AG Charts - internal config error: no properties specified for value definitions: ".concat(JSON.stringify(def)));
            }
            this.values.push(__spreadProps(__spreadValues({}, def), {
              index: this.values.length,
              missing: /* @__PURE__ */new Map()
            }));
            break;
          case "aggregate":
            verifyMatchGroupId(def);
            this.aggregates.push(__spreadProps(__spreadValues({}, def), {
              index: this.aggregates.length
            }));
            break;
          case "group-value-processor":
            verifyMatchGroupId(def);
            this.groupProcessors.push(__spreadProps(__spreadValues({}, def), {
              index: this.groupProcessors.length
            }));
            break;
          case "property-value-processor":
            this.propertyProcessors.push(__spreadProps(__spreadValues({}, def), {
              index: this.propertyProcessors.length
            }));
            break;
          case "reducer":
            this.reducers.push(__spreadProps(__spreadValues({}, def), {
              index: this.reducers.length
            }));
            break;
          case "processor":
            this.processors.push(__spreadProps(__spreadValues({}, def), {
              index: this.processors.length
            }));
            break;
        }
      }
    } catch (err) {
      _iterator102.e(err);
    } finally {
      _iterator102.f();
    }
  }
  _createClass(DataModel, [{
    key: "resolveProcessedDataDefById",
    value: function resolveProcessedDataDefById(scope, searchId) {
      var _a;
      var def = (_a = this.scopeCache.get(scope.id)) == null ? void 0 : _a.get(searchId);
      if (!def) {
        throw new Error("AG Charts - didn't find property definition for [".concat(searchId, ", ").concat(scope.id, "]"));
      }
      return {
        index: def.index,
        def: def
      };
    }
  }, {
    key: "resolveProcessedDataIndexById",
    value: function resolveProcessedDataIndexById(scope, searchId) {
      return this.resolveProcessedDataDefById(scope, searchId).index;
    }
  }, {
    key: "resolveProcessedDataDefsByIds",
    value: function resolveProcessedDataDefsByIds(scope, searchIds) {
      var _this92 = this;
      return searchIds.map(function (searchId) {
        return [searchId, _this92.resolveProcessedDataDefById(scope, searchId)];
      });
    }
  }, {
    key: "resolveProcessedDataDefsValues",
    value: function resolveProcessedDataDefsValues(defs, _ref91) {
      var keys = _ref91.keys,
        values = _ref91.values;
      var result = {};
      var _iterator103 = _createForOfIteratorHelper(defs),
        _step103;
      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var _step103$value = _slicedToArray(_step103.value, 2),
            searchId = _step103$value[0],
            _step103$value$ = _step103$value[1],
            index = _step103$value$.index,
            def = _step103$value$.def;
          var processedData = def.type === "key" ? keys : values;
          result[searchId] = processedData[index];
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
      return result;
    }
  }, {
    key: "getDomain",
    value: function getDomain(scope, searchId) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
      var processedData = arguments.length > 3 ? arguments[3] : undefined;
      var _a;
      var domains = this.getDomainsByType(type, processedData);
      return (_a = domains == null ? void 0 : domains[this.resolveProcessedDataIndexById(scope, searchId)]) != null ? _a : [];
    }
  }, {
    key: "getDomainsByType",
    value: function getDomainsByType(type, processedData) {
      switch (type) {
        case "key":
          return processedData.domain.keys;
        case "value":
          return processedData.domain.values;
        case "aggregate":
          return processedData.domain.aggValues;
        case "group-value-processor":
          return processedData.domain.groups;
        default:
          return null;
      }
    }
  }, {
    key: "processData",
    value: function processData(data, sources) {
      var _a;
      var _this$opts3 = this.opts,
        groupByKeys = _this$opts3.groupByKeys,
        groupByFn = _this$opts3.groupByFn,
        aggregates = this.aggregates,
        groupProcessors = this.groupProcessors,
        reducers = this.reducers,
        processors = this.processors,
        propertyProcessors = this.propertyProcessors;
      var start = performance.now();
      if (groupByKeys && this.keys.length === 0) {
        return;
      }
      var processedData = this.extractData(data, sources);
      if (groupByKeys) {
        processedData = this.groupData(processedData);
      } else if (groupByFn) {
        processedData = this.groupData(processedData, groupByFn(processedData));
      }
      if (groupProcessors.length > 0) {
        this.postProcessGroups(processedData);
      }
      if (aggregates.length > 0) {
        this.aggregateData(processedData);
      }
      if (propertyProcessors.length > 0) {
        this.postProcessProperties(processedData);
      }
      if (reducers.length > 0) {
        this.reduceData(processedData);
      }
      if (processors.length > 0) {
        this.postProcessData(processedData);
      }
      if (data.length > 0) {
        var _iterator104 = _createForOfIteratorHelper(iterate(this.keys, this.values)),
          _step104;
        try {
          for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
            var def = _step104.value;
            var _iterator105 = _createForOfIteratorHelper(def.missing),
              _step105;
            try {
              for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                var _step105$value = _slicedToArray(_step105.value, 2),
                  scope = _step105$value[0],
                  missCount = _step105$value[1];
                if (missCount >= data.length) {
                  var scopeHint = scope == null ? "" : " for ".concat(scope);
                  _Logger.warnOnce("the key '".concat(def.property, "' was not found in any data element").concat(scopeHint, "."));
                }
              }
            } catch (err) {
              _iterator105.e(err);
            } finally {
              _iterator105.f();
            }
          }
        } catch (err) {
          _iterator104.e(err);
        } finally {
          _iterator104.f();
        }
      }
      var end = performance.now();
      processedData.time = end - start;
      if (this.debug.check()) {
        logProcessedData(processedData);
      }
      this.scopeCache.clear();
      var _iterator106 = _createForOfIteratorHelper(iterate(this.keys, this.values, this.aggregates)),
        _step106;
      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var _def = _step106.value;
          if (!_def.idsMap) continue;
          var _iterator107 = _createForOfIteratorHelper(_def.idsMap),
            _step107;
          try {
            for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
              var _step107$value = _slicedToArray(_step107.value, 2),
                _scope = _step107$value[0],
                ids = _step107$value[1];
              var _iterator108 = _createForOfIteratorHelper(ids),
                _step108;
              try {
                for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                  var id = _step108.value;
                  if (!this.scopeCache.has(_scope)) {
                    this.scopeCache.set(_scope, /* @__PURE__ */new Map([[id, _def]]));
                  } else if ((_a = this.scopeCache.get(_scope)) == null ? void 0 : _a.has(id)) {
                    throw new Error("duplicate definition ids on the same scope are not allowed.");
                  } else {
                    this.scopeCache.get(_scope).set(id, _def);
                  }
                }
              } catch (err) {
                _iterator108.e(err);
              } finally {
                _iterator108.f();
              }
            }
          } catch (err) {
            _iterator107.e(err);
          } finally {
            _iterator107.f();
          }
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
      return processedData;
    }
  }, {
    key: "valueGroupIdxLookup",
    value: function valueGroupIdxLookup(_ref92) {
      var matchGroupIds = _ref92.matchGroupIds;
      var result = [];
      var _iterator109 = _createForOfIteratorHelper(this.values.entries()),
        _step109;
      try {
        for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
          var _step109$value = _slicedToArray(_step109.value, 2),
            index = _step109$value[0],
            def = _step109$value[1];
          if (!matchGroupIds || def.groupId && matchGroupIds.includes(def.groupId)) {
            result.push(index);
          }
        }
      } catch (err) {
        _iterator109.e(err);
      } finally {
        _iterator109.f();
      }
      return result;
    }
  }, {
    key: "valueIdxLookup",
    value: function valueIdxLookup(scopes, prop) {
      var noScopesToMatch = scopes == null || scopes.length === 0;
      var propId = typeof prop === "string" ? prop : prop.id;
      var hasMatchingScopeId = function hasMatchingScopeId(def) {
        if (def.idsMap) {
          var _iterator110 = _createForOfIteratorHelper(def.idsMap),
            _step110;
          try {
            for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
              var _step110$value = _slicedToArray(_step110.value, 2),
                scope = _step110$value[0],
                ids = _step110$value[1];
              if ((scopes == null ? void 0 : scopes.includes(scope)) && ids.has(propId)) {
                return true;
              }
            }
          } catch (err) {
            _iterator110.e(err);
          } finally {
            _iterator110.f();
          }
        }
        return false;
      };
      var result = this.values.findIndex(function (def) {
        var validDefScopes = def.scopes == null || noScopesToMatch && !def.scopes.length || def.scopes.some(function (s) {
          return scopes == null ? void 0 : scopes.includes(s);
        });
        return validDefScopes && (def.property === propId || def.id === propId || hasMatchingScopeId(def));
      });
      if (result === -1) {
        throw new Error("AG Charts - configuration error, unknown property ".concat(JSON.stringify(prop), " in scope(s) ").concat(JSON.stringify(scopes)));
      }
      return result;
    }
  }, {
    key: "extractData",
    value: function extractData(data, sources) {
      var _a, _b, _c, _d;
      var _this$initDataDomainP = this.initDataDomainProcessor(),
        dataDomain = _this$initDataDomainP.dataDomain,
        processValue = _this$initDataDomainP.processValue,
        scopes = _this$initDataDomainP.scopes,
        allScopesHaveSameDefs = _this$initDataDomainP.allScopesHaveSameDefs;
      var sourcesById = new Map(sources == null ? void 0 : sources.map(function (s) {
        return [s.id, s];
      }));
      var keyDefs = this.keys,
        valueDefs = this.values;
      var resultData = new Array(data.length);
      var resultDataIdx = 0;
      var partialValidDataCount = 0;
      var _iterator111 = _createForOfIteratorHelper(data.entries()),
        _step111;
      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var _step111$value = _slicedToArray(_step111.value, 2),
            datumIdx = _step111$value[0],
            datum = _step111$value[1];
          var sourceDatums = {};
          var validScopes = scopes.size > 0 ? new Set(scopes) : void 0;
          var keys = new Array(keyDefs.length);
          var keyIdx = 0;
          var key = void 0;
          var _iterator112 = _createForOfIteratorHelper(keyDefs),
            _step112;
          try {
            for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
              var def = _step112.value;
              key = processValue(def, datum, key);
              if (key === INVALID_VALUE) break;
              if (keys) {
                keys[keyIdx++] = key;
              }
            }
          } catch (err) {
            _iterator112.e(err);
          } finally {
            _iterator112.f();
          }
          if (key === INVALID_VALUE) continue;
          var values = valueDefs.length > 0 ? new Array(valueDefs.length) : void 0;
          var value = void 0;
          var _iterator113 = _createForOfIteratorHelper(valueDefs.entries()),
            _step113;
          try {
            for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
              var _step113$value = _slicedToArray(_step113.value, 2),
                valueDefIdx = _step113$value[0],
                _def2 = _step113$value[1];
              var _iterator114 = _createForOfIteratorHelper((_a = _def2.scopes) != null ? _a : scopes),
                _step114;
              try {
                for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
                  var _scope2 = _step114.value;
                  var source = sourcesById.get(_scope2);
                  var valueDatum = (_b = source == null ? void 0 : source.data[datumIdx]) != null ? _b : datum;
                  value = processValue(_def2, valueDatum, value, _scope2);
                  if (value === INVALID_VALUE || !values) continue;
                  if (source != null && _def2.includeProperty !== false) {
                    var property = _def2.includeProperty && _def2.id != null ? _def2.id : _def2.property;
                    (_c = sourceDatums[_scope2]) != null ? _c : sourceDatums[_scope2] = {};
                    sourceDatums[_scope2][property] = value;
                  }
                  values[valueDefIdx] = value;
                }
              } catch (err) {
                _iterator114.e(err);
              } finally {
                _iterator114.f();
              }
              if (value === INVALID_VALUE) {
                if (allScopesHaveSameDefs) break;
                var _iterator115 = _createForOfIteratorHelper((_d = _def2.scopes) != null ? _d : scopes),
                  _step115;
                try {
                  for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
                    var scope = _step115.value;
                    validScopes == null ? void 0 : validScopes.delete(scope);
                  }
                } catch (err) {
                  _iterator115.e(err);
                } finally {
                  _iterator115.f();
                }
                if ((validScopes == null ? void 0 : validScopes.size) === 0) break;
              }
            }
          } catch (err) {
            _iterator113.e(err);
          } finally {
            _iterator113.f();
          }
          if (value === INVALID_VALUE && allScopesHaveSameDefs) continue;
          if ((validScopes == null ? void 0 : validScopes.size) === 0) continue;
          var result = {
            datum: __spreadValues(__spreadValues({}, datum), sourceDatums),
            keys: keys,
            values: values
          };
          if (!allScopesHaveSameDefs && validScopes && validScopes.size < scopes.size) {
            partialValidDataCount++;
            result.validScopes = new Set(validScopes);
          }
          resultData[resultDataIdx++] = result;
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
      resultData.length = resultDataIdx;
      var propertyDomain = function propertyDomain(def) {
        var defDomain = dataDomain.get(def);
        var result = defDomain.getDomain();
        if (ContinuousDomain.is(defDomain) && result[0] > result[1]) {
          return [];
        }
        return result;
      };
      return {
        type: "ungrouped",
        input: {
          count: data.length
        },
        data: resultData,
        domain: {
          keys: keyDefs.map(propertyDomain),
          values: valueDefs.map(propertyDomain)
        },
        defs: {
          allScopesHaveSameDefs: allScopesHaveSameDefs,
          keys: keyDefs,
          values: valueDefs
        },
        partialValidDataCount: partialValidDataCount,
        time: 0
      };
    }
  }, {
    key: "groupData",
    value: function groupData(data, groupingFn) {
      var _a;
      var processedData = /* @__PURE__ */new Map();
      var _iterator116 = _createForOfIteratorHelper(data.data),
        _step116;
      try {
        for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
          var dataEntry = _step116.value;
          var keys = dataEntry.keys,
            values = dataEntry.values,
            datum = dataEntry.datum,
            validScopes = dataEntry.validScopes;
          var group2 = (_a = groupingFn == null ? void 0 : groupingFn(dataEntry)) != null ? _a : keys;
          var groupStr = toKeyString(group2);
          if (processedData.has(groupStr)) {
            var existingData = processedData.get(groupStr);
            existingData.values.push(values);
            existingData.datum.push(datum);
            if (validScopes != null && existingData.validScopes != null) {
              var _iterator118 = _createForOfIteratorHelper(existingData.validScopes),
                _step118;
              try {
                for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
                  var scope = _step118.value;
                  if (!validScopes.has(scope)) {
                    existingData.validScopes.delete(scope);
                  }
                }
              } catch (err) {
                _iterator118.e(err);
              } finally {
                _iterator118.f();
              }
            }
          } else {
            processedData.set(groupStr, {
              keys: group2,
              values: [values],
              datum: [datum],
              validScopes: validScopes
            });
          }
        }
      } catch (err) {
        _iterator116.e(err);
      } finally {
        _iterator116.f();
      }
      var resultData = new Array(processedData.size);
      var resultGroups = new Array(processedData.size);
      var dataIndex = 0;
      var _iterator117 = _createForOfIteratorHelper(processedData.values()),
        _step117;
      try {
        for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
          var _step117$value = _step117.value,
            _keys = _step117$value.keys,
            _values2 = _step117$value.values,
            _datum2 = _step117$value.datum,
            _validScopes = _step117$value.validScopes;
          if ((_validScopes == null ? void 0 : _validScopes.size) === 0) continue;
          resultGroups[dataIndex] = _keys;
          resultData[dataIndex++] = {
            keys: _keys,
            values: _values2,
            datum: _datum2,
            validScopes: _validScopes
          };
        }
      } catch (err) {
        _iterator117.e(err);
      } finally {
        _iterator117.f();
      }
      return __spreadProps(__spreadValues({}, data), {
        type: "grouped",
        data: resultData,
        domain: __spreadProps(__spreadValues({}, data.domain), {
          groups: resultGroups
        })
      });
    }
  }, {
    key: "aggregateData",
    value: function aggregateData(processedData) {
      var _a, _b, _c, _d, _e, _f, _g;
      var isUngrouped = processedData.type === "ungrouped";
      processedData.domain.aggValues = [];
      var _iterator119 = _createForOfIteratorHelper(this.aggregates.entries()),
        _step119;
      try {
        for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
          var _step119$value = _slicedToArray(_step119.value, 2),
            index = _step119$value[0],
            def = _step119$value[1];
          var indices = this.valueGroupIdxLookup(def);
          var domain = [Infinity, -Infinity];
          var _iterator120 = _createForOfIteratorHelper(processedData.data),
            _step120;
          try {
            for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
              var datum = _step120.value;
              (_a = datum.aggValues) != null ? _a : datum.aggValues = new Array(this.aggregates.length);
              if (datum.validScopes) continue;
              var values = isUngrouped ? [datum.values] : datum.values;
              var groupAggValues = (_c = (_b = def.groupAggregateFunction) == null ? void 0 : _b.call(def)) != null ? _c : [Infinity, -Infinity];
              var _iterator121 = _createForOfIteratorHelper(values),
                _step121;
              try {
                var _loop9 = function _loop9() {
                  var distinctValues = _step121.value;
                  var valuesToAgg = indices.map(function (valueIdx) {
                    return distinctValues[valueIdx];
                  });
                  var valuesAgg = def.aggregateFunction(valuesToAgg, datum.keys);
                  if (valuesAgg) {
                    groupAggValues = (_e = (_d = def.groupAggregateFunction) == null ? void 0 : _d.call(def, valuesAgg, groupAggValues)) != null ? _e : ContinuousDomain.extendDomain(valuesAgg, groupAggValues);
                  }
                };
                for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                  _loop9();
                }
              } catch (err) {
                _iterator121.e(err);
              } finally {
                _iterator121.f();
              }
              var finalValues = ((_g = (_f = def.finalFunction) == null ? void 0 : _f.call(def, groupAggValues)) != null ? _g : groupAggValues).map(function (v) {
                return round2(v);
              });
              datum.aggValues[index] = finalValues;
              ContinuousDomain.extendDomain(finalValues, domain);
            }
          } catch (err) {
            _iterator120.e(err);
          } finally {
            _iterator120.f();
          }
          processedData.domain.aggValues.push(domain);
        }
      } catch (err) {
        _iterator119.e(err);
      } finally {
        _iterator119.f();
      }
    }
  }, {
    key: "postProcessGroups",
    value: function postProcessGroups(processedData) {
      var _a, _b;
      var groupProcessors = this.groupProcessors;
      var affectedIndices = /* @__PURE__ */new Set();
      var updatedDomains = /* @__PURE__ */new Map();
      var groupProcessorIndices = /* @__PURE__ */new Map();
      var groupProcessorInitFns = /* @__PURE__ */new Map();
      var _iterator122 = _createForOfIteratorHelper(groupProcessors),
        _step122;
      try {
        for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
          var processor = _step122.value;
          var indices = this.valueGroupIdxLookup(processor);
          groupProcessorIndices.set(processor, indices);
          groupProcessorInitFns.set(processor, processor.adjust());
          var _iterator126 = _createForOfIteratorHelper(indices),
            _step126;
          try {
            for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
              var idx = _step126.value;
              var valueDef = this.values[idx];
              var isDiscrete = valueDef.valueType === "category";
              affectedIndices.add(idx);
              updatedDomains.set(idx, isDiscrete ? new DiscreteDomain() : new ContinuousDomain());
            }
          } catch (err) {
            _iterator126.e(err);
          } finally {
            _iterator126.f();
          }
        }
      } catch (err) {
        _iterator122.e(err);
      } finally {
        _iterator122.f();
      }
      var updateDomains = function updateDomains(values) {
        var _a2;
        var _iterator123 = _createForOfIteratorHelper(affectedIndices),
          _step123;
        try {
          for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
            var valueIndex = _step123.value;
            (_a2 = updatedDomains.get(valueIndex)) == null ? void 0 : _a2.extend(values[valueIndex]);
          }
        } catch (err) {
          _iterator123.e(err);
        } finally {
          _iterator123.f();
        }
      };
      var _iterator124 = _createForOfIteratorHelper(processedData.data),
        _step124;
      try {
        for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
          var group2 = _step124.value;
          var _iterator127 = _createForOfIteratorHelper(groupProcessors),
            _step127;
          try {
            for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
              var _processor = _step127.value;
              if (group2.validScopes) continue;
              var valueIndexes = (_a = groupProcessorIndices.get(_processor)) != null ? _a : [];
              var adjustFn = (_b = groupProcessorInitFns.get(_processor)) == null ? void 0 : _b();
              if (!adjustFn) continue;
              if (processedData.type === "grouped") {
                var _iterator129 = _createForOfIteratorHelper(group2.values),
                  _step129;
                try {
                  for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
                    var _values3 = _step129.value;
                    if (_values3) {
                      adjustFn(_values3, valueIndexes);
                    }
                  }
                } catch (err) {
                  _iterator129.e(err);
                } finally {
                  _iterator129.f();
                }
              } else if (group2.values) {
                adjustFn(group2.values, valueIndexes);
              }
            }
          } catch (err) {
            _iterator127.e(err);
          } finally {
            _iterator127.f();
          }
          if (processedData.type === "grouped") {
            var _iterator128 = _createForOfIteratorHelper(group2.values),
              _step128;
            try {
              for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                var values = _step128.value;
                updateDomains(values);
              }
            } catch (err) {
              _iterator128.e(err);
            } finally {
              _iterator128.f();
            }
          } else {
            updateDomains(group2.values);
          }
        }
      } catch (err) {
        _iterator124.e(err);
      } finally {
        _iterator124.f();
      }
      var _iterator125 = _createForOfIteratorHelper(updatedDomains),
        _step125;
      try {
        for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
          var _step125$value = _slicedToArray(_step125.value, 2),
            _idx = _step125$value[0],
            dataDomain = _step125$value[1];
          processedData.domain.values[_idx] = dataDomain.getDomain();
        }
      } catch (err) {
        _iterator125.e(err);
      } finally {
        _iterator125.f();
      }
    }
  }, {
    key: "postProcessProperties",
    value: function postProcessProperties(processedData) {
      var _iterator130 = _createForOfIteratorHelper(this.propertyProcessors),
        _step130;
      try {
        for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
          var _step130$value = _step130.value,
            adjust = _step130$value.adjust,
            property = _step130$value.property,
            scopes = _step130$value.scopes;
          adjust()(processedData, this.valueIdxLookup(scopes, property));
        }
      } catch (err) {
        _iterator130.e(err);
      } finally {
        _iterator130.f();
      }
    }
  }, {
    key: "reduceData",
    value: function reduceData(processedData) {
      var _a, _b;
      (_a = processedData.reduced) != null ? _a : processedData.reduced = {};
      var _iterator131 = _createForOfIteratorHelper(this.reducers),
        _step131;
      try {
        for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
          var def = _step131.value;
          var reducer = def.reducer();
          var accValue = def.initialValue;
          var _iterator132 = _createForOfIteratorHelper(processedData.data),
            _step132;
          try {
            var _loop0 = function _loop0() {
              var datum = _step132.value;
              if (!datum.validScopes || ((_b = def.scopes) == null ? void 0 : _b.some(function (s) {
                var _a2;
                return (_a2 = datum.validScopes) == null ? void 0 : _a2.has(s);
              }))) {
                accValue = reducer(accValue, datum);
              }
            };
            for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
              _loop0();
            }
          } catch (err) {
            _iterator132.e(err);
          } finally {
            _iterator132.f();
          }
          processedData.reduced[def.property] = accValue;
        }
      } catch (err) {
        _iterator131.e(err);
      } finally {
        _iterator131.f();
      }
    }
  }, {
    key: "postProcessData",
    value: function postProcessData(processedData) {
      var _a;
      (_a = processedData.reduced) != null ? _a : processedData.reduced = {};
      var _iterator133 = _createForOfIteratorHelper(this.processors),
        _step133;
      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var def = _step133.value;
          processedData.reduced[def.property] = def.calculate(processedData);
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
    }
  }, {
    key: "initDataDomainProcessor",
    value: function initDataDomainProcessor() {
      var _this93 = this;
      var keyDefs = this.keys,
        valueDefs = this.values;
      var scopes = /* @__PURE__ */new Set();
      var _iterator134 = _createForOfIteratorHelper(valueDefs),
        _step134;
      try {
        for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
          var valueDef = _step134.value;
          if (!valueDef.scopes) continue;
          var _iterator136 = _createForOfIteratorHelper(valueDef.scopes),
            _step136;
          try {
            for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
              var scope = _step136.value;
              scopes.add(scope);
            }
          } catch (err) {
            _iterator136.e(err);
          } finally {
            _iterator136.f();
          }
        }
      } catch (err) {
        _iterator134.e(err);
      } finally {
        _iterator134.f();
      }
      var dataDomain = /* @__PURE__ */new Map();
      var processorFns = /* @__PURE__ */new Map();
      var allScopesHaveSameDefs = true;
      var initDataDomain = function initDataDomain() {
        var _a;
        var _iterator135 = _createForOfIteratorHelper(iterate(keyDefs, valueDefs)),
          _step135;
        try {
          for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
            var def = _step135.value;
            if (def.valueType === "category") {
              dataDomain.set(def, new DiscreteDomain());
            } else {
              dataDomain.set(def, new ContinuousDomain());
              allScopesHaveSameDefs && (allScopesHaveSameDefs = ((_a = def.scopes) != null ? _a : []).length === scopes.size);
            }
          }
        } catch (err) {
          _iterator135.e(err);
        } finally {
          _iterator135.f();
        }
      };
      initDataDomain();
      var accessors = this.buildAccessors(iterate(keyDefs, valueDefs));
      var processValue = function processValue(def, datum, previousDatum, scope) {
        var _a, _b, _c, _d, _e;
        var valueInDatum;
        var value;
        if (accessors.has(def.property)) {
          try {
            value = accessors.get(def.property)(datum);
          } catch (error) {}
          valueInDatum = value != null;
        } else {
          valueInDatum = def.property in datum;
          value = valueInDatum ? datum[def.property] : def.missingValue;
        }
        if (def.forceValue != null) {
          var valueNegative = valueInDatum && _isNegative(value);
          value = valueNegative ? -1 * def.forceValue : def.forceValue;
          valueInDatum = true;
        }
        var missingValueDef = "missingValue" in def;
        if (!valueInDatum && !missingValueDef) {
          var missCount = (_a = def.missing.get(scope)) != null ? _a : 0;
          def.missing.set(scope, missCount + 1);
        }
        if (!dataDomain.has(def)) {
          initDataDomain();
        }
        if (valueInDatum && !((_c = (_b = def.validation) == null ? void 0 : _b.call(def, value, datum)) != null ? _c : true)) {
          if ("invalidValue" in def) {
            value = def.invalidValue;
          } else {
            if (_this93.mode !== "integrated") {
              _Logger.warnOnce("invalid value of type [".concat(typeof value, "] ignored:"), "[".concat(value, "]"));
            }
            return INVALID_VALUE;
          }
        }
        if (def.processor) {
          if (!processorFns.has(def)) {
            processorFns.set(def, def.processor());
          }
          value = (_d = processorFns.get(def)) == null ? void 0 : _d(value, previousDatum === INVALID_VALUE ? void 0 : previousDatum);
        }
        (_e = dataDomain.get(def)) == null ? void 0 : _e.extend(value);
        return value;
      };
      return {
        dataDomain: dataDomain,
        processValue: processValue,
        initDataDomain: initDataDomain,
        scopes: scopes,
        allScopesHaveSameDefs: allScopesHaveSameDefs
      };
    }
  }, {
    key: "buildAccessors",
    value: function buildAccessors(defs) {
      var result = /* @__PURE__ */new Map();
      if (this.mode === "integrated") {
        return result;
      }
      var _iterator137 = _createForOfIteratorHelper(defs),
        _step137;
      try {
        for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
          var def = _step137.value;
          var isPath = def.property.includes(".") || def.property.includes("[");
          if (!isPath) continue;
          var fnBody = void 0;
          if (def.property.startsWith("[")) {
            fnBody = "return datum".concat(def.property, ";");
          } else {
            fnBody = "return datum.".concat(def.property, ";");
          }
          result.set(def.property, new Function("datum", fnBody));
        }
      } catch (err) {
        _iterator137.e(err);
      } finally {
        _iterator137.f();
      }
      return result;
    }
  }]);
  return DataModel;
}();
function logProcessedData(processedData) {
  var _a, _b;
  var logValues = function logValues(name, data) {
    if (data.length > 0) {
      _Logger.log("DataModel.processData() - ".concat(name));
      _Logger.table(data);
    }
  };
  _Logger.log("DataModel.processData() - processedData", processedData);
  logValues("Key Domains", processedData.domain.keys);
  logValues("Group Domains", (_a = processedData.domain.groups) != null ? _a : []);
  logValues("Value Domains", processedData.domain.values);
  logValues("Aggregate Domains", (_b = processedData.domain.aggValues) != null ? _b : []);
  if (processedData.type === "grouped") {
    var flattenedValues = processedData.data.reduce(function (acc, next) {
      var _a2, _b2;
      var keys = (_a2 = next.keys) != null ? _a2 : [];
      var aggValues = (_b2 = next.aggValues) != null ? _b2 : [];
      var skipKeys = next.keys.map(function () {
        return void 0;
      });
      var skipAggValues = aggValues == null ? void 0 : aggValues.map(function () {
        return void 0;
      });
      acc.push.apply(acc, _toConsumableArray(next.values.map(function (v, i) {
        return [].concat(_toConsumableArray(i === 0 ? keys : skipKeys), _toConsumableArray(v != null ? v : []), _toConsumableArray(i == 0 ? aggValues : skipAggValues));
      })));
      return acc;
    }, []);
    logValues("Values", flattenedValues);
  } else {
    var _flattenedValues = processedData.data.reduce(function (acc, next) {
      var _a2;
      var aggValues = (_a2 = next.aggValues) != null ? _a2 : [];
      acc.push([].concat(_toConsumableArray(next.keys), _toConsumableArray(next.values), _toConsumableArray(aggValues)));
      return acc;
    }, []);
    logValues("Values", _flattenedValues);
  }
}

// packages/ag-charts-community/src/chart/data/dataController.ts
var _DataController = /*#__PURE__*/function () {
  function _DataController(mode) {
    _classCallCheck(this, _DataController);
    this.mode = mode;
    this.debug = Debug.create(true, "data-model");
    this.requested = [];
    this.status = "setup";
  }
  _createClass(_DataController, [{
    key: "request",
    value: function request(id, data, opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee1() {
        var _this94 = this;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              if (!(this.status !== "setup")) {
                _context17.n = 1;
                break;
              }
              throw new Error("AG Charts - data request after data setup phase.");
            case 1:
              return _context17.a(2, new Promise(function (resolve, reject) {
                _this94.requested.push({
                  id: id,
                  opts: opts,
                  data: data,
                  resolve: resolve,
                  reject: reject
                });
              }));
          }
        }, _callee1, this);
      }));
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this95 = this;
      if (this.status !== "setup") {
        throw new Error("AG Charts - data request after data setup phase.");
      }
      this.status = "executed";
      this.debug("DataController.execute() - requested", this.requested);
      var valid = this.validateRequests(this.requested);
      this.debug("DataController.execute() - validated", valid);
      var merged = this.mergeRequested(valid);
      this.debug("DataController.execute() - merged", merged);
      if (this.debug.check()) {
        _getWindow2().processedData = [];
      }
      var scopes = this.requested.map(function (_ref93) {
        var id = _ref93.id;
        return id;
      });
      var needsValueExtraction = this.hasMultipleDataSources(valid);
      var _iterator138 = _createForOfIteratorHelper(merged),
        _step138;
      try {
        var _loop1 = function _loop1() {
          var _step138$value = _step138.value,
            opts = _step138$value.opts,
            data = _step138$value.data,
            resolves = _step138$value.resolves,
            rejects = _step138$value.rejects,
            ids = _step138$value.ids;
          try {
            var dataModel = new _DataModel(opts, _this95.mode);
            var processedData = dataModel.processData(data, valid);
            if (_this95.debug.check()) {
              _getWindow2("processedData").push(processedData);
            }
            if ((processedData == null ? void 0 : processedData.partialValidDataCount) === 0) {
              resolves.forEach(function (resolve, requestIdx) {
                return resolve({
                  dataModel: dataModel,
                  processedData: _this95.processScopedData(ids[requestIdx], processedData, scopes, needsValueExtraction)
                });
              });
            } else if (processedData) {
              _this95.splitResult(dataModel, processedData, ids, resolves);
            } else {
              rejects.forEach(function (cb) {
                return cb(new Error("AG Charts - no processed data generated"));
              });
            }
          } catch (error) {
            rejects.forEach(function (cb) {
              return cb(error);
            });
          }
        };
        for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
          _loop1();
        }
      } catch (err) {
        _iterator138.e(err);
      } finally {
        _iterator138.f();
      }
    }
  }, {
    key: "hasMultipleDataSources",
    value: function hasMultipleDataSources(validRequests) {
      if (validRequests.length) {
        var _validRequests = _toArray(validRequests),
          data = _validRequests[0].data,
          restRequests = _validRequests.slice(1);
        return restRequests.some(function (v) {
          return data !== v.data;
        });
      }
      return false;
    }
  }, {
    key: "processScopedData",
    value: function processScopedData(id, processedData, ids, needsValueExtraction) {
      var _extractDatum = function extractDatum(datum) {
        if (Array.isArray(datum)) {
          return datum.map(_extractDatum);
        }
        var extracted = needsValueExtraction ? __spreadValues(__spreadValues({}, datum), datum[id]) : datum;
        var _iterator139 = _createForOfIteratorHelper(ids),
          _step139;
        try {
          for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
            var otherId = _step139.value;
            delete extracted[otherId];
          }
        } catch (err) {
          _iterator139.e(err);
        } finally {
          _iterator139.f();
        }
        return extracted;
      };
      var _extractValues = function extractValues(values) {
        var _a;
        if (Array.isArray(values)) {
          return values.map(_extractValues);
        }
        return (_a = values == null ? void 0 : values[id]) != null ? _a : values;
      };
      return __spreadProps(__spreadValues({}, processedData), {
        data: processedData.data.map(function (datum) {
          var _a;
          return __spreadProps(__spreadValues({}, datum), {
            datum: _extractDatum(datum.datum),
            values: needsValueExtraction ? (_a = datum.values) == null ? void 0 : _a.map(_extractValues) : datum.values
          });
        })
      });
    }
  }, {
    key: "validateRequests",
    value: function validateRequests(requested) {
      var valid = [];
      var _iterator140 = _createForOfIteratorHelper(requested.entries()),
        _step140;
      try {
        for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
          var _step140$value = _slicedToArray(_step140.value, 2),
            index = _step140$value[0],
            request = _step140$value[1];
          if (index > 0 && request.data.length !== requested[0].data.length && request.opts.groupByData === false) {
            request.reject(new Error("all series[].data arrays must be of the same length and have matching keys."));
          } else {
            valid.push(request);
          }
        }
      } catch (err) {
        _iterator140.e(err);
      } finally {
        _iterator140.f();
      }
      return valid;
    }
  }, {
    key: "mergeRequested",
    value: function mergeRequested(requested) {
      var grouped = [];
      var _iterator141 = _createForOfIteratorHelper(requested),
        _step141;
      try {
        for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
          var request = _step141.value;
          var match = grouped.find(_DataController.groupMatch(request));
          if (match) {
            match.push(request);
          } else {
            grouped.push([request]);
          }
        }
      } catch (err) {
        _iterator141.e(err);
      } finally {
        _iterator141.f();
      }
      return grouped.map(_DataController.mergeRequests);
    }
  }, {
    key: "splitResult",
    value: function splitResult(dataModel, processedData, scopes, resolves) {
      var _loop10 = function _loop10() {
        var scope = scopes[i];
        var resolve = resolves[i];
        resolve({
          dataModel: dataModel,
          processedData: __spreadProps(__spreadValues({}, processedData), {
            data: processedData.data.filter(function (_ref94) {
              var validScopes = _ref94.validScopes;
              var _a;
              return (_a = validScopes == null ? void 0 : validScopes.has(scope)) != null ? _a : true;
            })
          })
        });
      };
      for (var i = 0; i < scopes.length; i++) {
        _loop10();
      }
    }
  }], [{
    key: "groupMatch",
    value: function groupMatch(_ref95) {
      var data = _ref95.data,
        opts = _ref95.opts;
      function keys(props) {
        return props.filter(function (p) {
          return p.type === "key";
        }).map(function (p) {
          return p.property;
        }).join(";");
      }
      return function (_ref96) {
        var _ref97 = _slicedToArray(_ref96, 1),
          group2 = _ref97[0];
        return (opts.groupByData === false || group2.data === data) && group2.opts.groupByKeys === opts.groupByKeys && group2.opts.groupByFn === opts.groupByFn && keys(group2.opts.props) === keys(opts.props);
      };
    }
  }, {
    key: "mergeRequests",
    value: function mergeRequests(requests) {
      return requests.reduce(function (result, _a) {
        var id = _a.id,
          data = _a.data,
          resolve = _a.resolve,
          reject = _a.reject,
          _b = _a.opts,
          _c = _b,
          props = _c.props,
          opts = __objRest(_c, ["props"]);
        var _a2, _b2, _c2, _d, _e;
        result.ids.push(id);
        result.rejects.push(reject);
        result.resolves.push(resolve);
        (_a2 = result.data) != null ? _a2 : result.data = data;
        (_b2 = result.opts) != null ? _b2 : result.opts = __spreadProps(__spreadValues({}, opts), {
          props: []
        });
        var _iterator142 = _createForOfIteratorHelper(props),
          _step142;
        try {
          var _loop11 = function _loop11() {
            var _match$scopes;
            var prop = _step142.value;
            var clone = __spreadProps(__spreadValues({}, prop), {
              scopes: [id]
            });
            _DataController.createIdsMap(id, clone);
            var match = result.opts.props.find(function (existing) {
              return existing.type === clone.type && _DataController.deepEqual(existing, clone);
            });
            if (!match) {
              result.opts.props.push(clone);
              return 1; // continue
            }
            (_c2 = match.scopes) != null ? _c2 : match.scopes = [];
            (_match$scopes = match.scopes).push.apply(_match$scopes, _toConsumableArray((_d = clone.scopes) != null ? _d : []));
            if ((match.type === "key" || match.type === "value") && ((_e = clone.idsMap) == null ? void 0 : _e.size)) {
              _DataController.mergeIdsMap(clone.idsMap, match.idsMap);
            }
          };
          for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
            if (_loop11()) continue;
          }
        } catch (err) {
          _iterator142.e(err);
        } finally {
          _iterator142.f();
        }
        return result;
      }, {
        ids: [],
        rejects: [],
        resolves: [],
        data: null,
        opts: null
      });
    }
  }, {
    key: "mergeIdsMap",
    value: function mergeIdsMap(fromMap, toMap) {
      var _iterator143 = _createForOfIteratorHelper(fromMap),
        _step143;
      try {
        for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
          var _step143$value = _slicedToArray(_step143.value, 2),
            scope = _step143$value[0],
            ids = _step143$value[1];
          if (toMap.has(scope)) {
            var _iterator144 = _createForOfIteratorHelper(ids),
              _step144;
            try {
              for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
                var id = _step144.value;
                toMap.get(scope).add(id);
              }
            } catch (err) {
              _iterator144.e(err);
            } finally {
              _iterator144.f();
            }
          } else {
            toMap.set(scope, new Set(ids));
          }
        }
      } catch (err) {
        _iterator143.e(err);
      } finally {
        _iterator143.f();
      }
    }
  }, {
    key: "createIdsMap",
    value: function createIdsMap(scope, prop) {
      var _a;
      if (prop.id == null) return;
      (_a = prop.idsMap) != null ? _a : prop.idsMap = /* @__PURE__ */new Map();
      if (prop.idsMap.has(scope)) {
        prop.idsMap.get(scope).add(prop.id);
      } else {
        prop.idsMap.set(scope, /* @__PURE__ */new Set([prop.id]));
      }
    }
  }, {
    key: "deepEqual",
    value: function deepEqual(a, b) {
      if (a === b) {
        return true;
      }
      if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) {
          return false;
        }
        var i, length;
        if (Array.isArray(a)) {
          length = a.length;
          if (length !== b.length) {
            return false;
          }
          for (i = length - 1; i >= 0; i--) {
            if (!_DataController.deepEqual(a[i], b[i])) {
              return false;
            }
          }
          return true;
        }
        var keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) {
          return false;
        }
        for (i = length - 1; i >= 0; i--) {
          var key = keys[i];
          if (!_DataController.skipKeys.has(key) && (!Object.hasOwn(b, key) || !_DataController.deepEqual(a[key], b[key]))) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
  }]);
  return _DataController;
}();
// optimized version of deep equality for `mergeRequests` which can potentially loop over 1M times
_DataController.skipKeys = /* @__PURE__ */new Set(["id", "idsMap", "type", "scopes"]);
var _DataController2 = _DataController;

// packages/ag-charts-community/src/chart/interaction/syncManager.ts
var _SyncManager = /*#__PURE__*/function (_BaseManager8) {
  _inherits(_SyncManager, _BaseManager8);
  function _SyncManager(chart) {
    var _this96;
    _classCallCheck(this, _SyncManager);
    _this96 = _possibleConstructorReturn(this, _getPrototypeOf(_SyncManager).call(this));
    _this96.chart = chart;
    return _this96;
  }
  _createClass(_SyncManager, [{
    key: "subscribe",
    value: function subscribe() {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SyncManager.DEFAULT_GROUP;
      var syncGroup = this.get(groupId);
      if (!syncGroup) {
        syncGroup = /* @__PURE__ */new Set();
        _SyncManager.chartsGroups.set(groupId, syncGroup);
      }
      syncGroup.add(this.chart);
      return this;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SyncManager.DEFAULT_GROUP;
      var _a;
      (_a = this.get(groupId)) == null ? void 0 : _a.delete(this.chart);
      return this;
    }
  }, {
    key: "getChart",
    value: function getChart() {
      return this.chart;
    }
  }, {
    key: "getGroup",
    value: function getGroup() {
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SyncManager.DEFAULT_GROUP;
      var syncGroup = this.get(groupId);
      return syncGroup ? Array.from(syncGroup) : [];
    }
  }, {
    key: "getGroupSiblings",
    value: function getGroupSiblings() {
      var _this97 = this;
      var groupId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _SyncManager.DEFAULT_GROUP;
      return this.getGroup(groupId).filter(function (chart) {
        return chart !== _this97.chart;
      });
    }
  }, {
    key: "get",
    value: function get(groupId) {
      return _SyncManager.chartsGroups.get(groupId);
    }
  }]);
  return _SyncManager;
}(BaseManager);
_SyncManager.chartsGroups = /* @__PURE__ */new Map();
_SyncManager.DEFAULT_GROUP = Symbol("sync-group-default");
var SyncManager = _SyncManager;

// packages/ag-charts-community/src/chart/interaction/zoomManager.ts
var _ZoomManager = /*#__PURE__*/function (_BaseManager9) {
  _inherits(ZoomManager, _BaseManager9);
  function ZoomManager() {
    var _this98;
    _classCallCheck(this, ZoomManager);
    _this98 = _possibleConstructorReturn(this, _getPrototypeOf(ZoomManager).apply(this, arguments));
    _this98.axisZoomManagers = /* @__PURE__ */new Map();
    _this98.state = new StateTracker(void 0, "initial");
    _this98.rejectCallbacks = /* @__PURE__ */new Map();
    return _this98;
  }
  _createClass(ZoomManager, [{
    key: "updateAxes",
    value: function updateAxes(axes) {
      var _this99 = this;
      var _a;
      var zoomManagers = new Map(axes.map(function (axis) {
        return [axis.id, _this99.axisZoomManagers.get(axis.id)];
      }));
      this.axisZoomManagers.clear();
      var _iterator145 = _createForOfIteratorHelper(axes),
        _step145;
      try {
        for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
          var axis = _step145.value;
          this.axisZoomManagers.set(axis.id, (_a = zoomManagers.get(axis.id)) != null ? _a : new AxisZoomManager(axis));
        }
      } catch (err) {
        _iterator145.e(err);
      } finally {
        _iterator145.f();
      }
      if (this.state.size > 0 && axes.length > 0) {
        this.updateZoom(this.state.stateId(), this.state.stateValue());
      }
    }
  }, {
    key: "updateZoom",
    value: function updateZoom(callerId, newZoom) {
      var canChangeInitial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var rejectCallback = arguments.length > 3 ? arguments[3] : undefined;
      var _a;
      if (rejectCallback) {
        this.rejectCallbacks.set(callerId, rejectCallback);
      }
      if (this.axisZoomManagers.size === 0) {
        var stateId = this.state.stateId();
        if (stateId === "initial" || stateId === callerId || canChangeInitial) {
          this.state.set(callerId, newZoom);
          if (stateId !== callerId) {
            (_a = this.rejectCallbacks.get(stateId)) == null ? void 0 : _a(callerId);
          }
        } else {
          rejectCallback == null ? void 0 : rejectCallback(stateId);
        }
        return;
      }
      this.state.set(callerId, newZoom);
      this.axisZoomManagers.forEach(function (axis) {
        axis.updateZoom(callerId, newZoom == null ? void 0 : newZoom[axis.getDirection()]);
      });
      this.applyChanges(callerId);
    }
  }, {
    key: "updateAxisZoom",
    value: function updateAxisZoom(callerId, axisId, newZoom) {
      var _a;
      (_a = this.axisZoomManagers.get(axisId)) == null ? void 0 : _a.updateZoom(callerId, newZoom);
      this.applyChanges(callerId);
    } // Fire this event to signal to listeners that the view is changing through a zoom and/or pan change.
  }, {
    key: "fireZoomPanStartEvent",
    value: function fireZoomPanStartEvent(callerId) {
      this.listeners.dispatch("zoom-pan-start", {
        type: "zoom-pan-start",
        callerId: callerId
      });
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      var x;
      var y;
      this.axisZoomManagers.forEach(function (axis) {
        if (axis.getDirection() === "x" /* X */) {
          x != null ? x : x = axis.getZoom();
        } else if (axis.getDirection() === "y" /* Y */) {
          y != null ? y : y = axis.getZoom();
        }
      });
      if (x || y) {
        return {
          x: x,
          y: y
        };
      }
    }
  }, {
    key: "getAxisZoom",
    value: function getAxisZoom(axisId) {
      var _a, _b;
      return (_b = (_a = this.axisZoomManagers.get(axisId)) == null ? void 0 : _a.getZoom()) != null ? _b : {
        min: 0,
        max: 1
      };
    }
  }, {
    key: "getAxisZooms",
    value: function getAxisZooms() {
      var axes = {};
      var _iterator146 = _createForOfIteratorHelper(this.axisZoomManagers.entries()),
        _step146;
      try {
        for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
          var _step146$value = _slicedToArray(_step146.value, 2),
            axisId = _step146$value[0],
            axis = _step146$value[1];
          axes[axisId] = {
            direction: axis.getDirection(),
            zoom: axis.getZoom()
          };
        }
      } catch (err) {
        _iterator146.e(err);
      } finally {
        _iterator146.f();
      }
      return axes;
    }
  }, {
    key: "applyChanges",
    value: function applyChanges(callerId) {
      var changed = Array.from(this.axisZoomManagers.values(), function (axis) {
        return axis.applyChanges();
      }).some(Boolean);
      if (!changed) {
        return;
      }
      var axes = {};
      var _iterator147 = _createForOfIteratorHelper(this.axisZoomManagers.entries()),
        _step147;
      try {
        for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
          var _step147$value = _slicedToArray(_step147.value, 2),
            axisId = _step147$value[0],
            axis = _step147$value[1];
          axes[axisId] = axis.getZoom();
        }
      } catch (err) {
        _iterator147.e(err);
      } finally {
        _iterator147.f();
      }
      this.listeners.dispatch("zoom-change", __spreadProps(__spreadValues({
        type: "zoom-change"
      }, this.getZoom()), {
        axes: axes,
        callerId: callerId
      }));
    }
  }]);
  return ZoomManager;
}(BaseManager);
var AxisZoomManager = /*#__PURE__*/function () {
  function AxisZoomManager(axis) {
    _classCallCheck(this, AxisZoomManager);
    this.axis = axis;
    var _axis$visibleRange = _slicedToArray(axis.visibleRange, 2),
      _axis$visibleRange$ = _axis$visibleRange[0],
      min = _axis$visibleRange$ === void 0 ? 0 : _axis$visibleRange$,
      _axis$visibleRange$2 = _axis$visibleRange[1],
      max = _axis$visibleRange$2 === void 0 ? 1 : _axis$visibleRange$2;
    this.state = new StateTracker({
      min: min,
      max: max
    });
    this.currentZoom = this.state.stateValue();
  }
  _createClass(AxisZoomManager, [{
    key: "getDirection",
    value: function getDirection() {
      return this.axis.direction;
    }
  }, {
    key: "updateZoom",
    value: function updateZoom(callerId, newZoom) {
      this.state.set(callerId, newZoom);
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      return _deepClone2(this.state.stateValue());
    }
  }, {
    key: "applyChanges",
    value: function applyChanges() {
      var prevZoom = this.currentZoom;
      this.currentZoom = this.state.stateValue();
      return prevZoom.min !== this.currentZoom.min || prevZoom.max !== this.currentZoom.max;
    }
  }]);
  return AxisZoomManager;
}();

// packages/ag-charts-community/src/chart/keyboard.ts
var Keyboard = /*#__PURE__*/function (_BaseProperties0) {
  _inherits(Keyboard, _BaseProperties0);
  function Keyboard() {
    var _this100;
    _classCallCheck(this, Keyboard);
    _this100 = _possibleConstructorReturn(this, _getPrototypeOf(Keyboard).apply(this, arguments));
    _this100.enabled = false;
    return _this100;
  }
  return Keyboard;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], Keyboard.prototype, "enabled", 2);
__decorateClass([_Validate(_NUMBER)], Keyboard.prototype, "tabIndex", 2);

// packages/ag-charts-community/src/chart/keyboardUtil.ts
function makeKeyboardPointerEvent(regionManager, pick) {
  var bbox = pick.bbox,
    showFocusBox = pick.showFocusBox;
  if (showFocusBox) {
    regionManager.updateFocusIndicatorRect(pick.bbox);
  }
  if (bbox !== void 0) {
    var _bbox$computeCenter = bbox.computeCenter(),
      offsetX = _bbox$computeCenter.x,
      offsetY = _bbox$computeCenter.y;
    return {
      type: "keyboard",
      offsetX: offsetX,
      offsetY: offsetY
    };
  }
  return void 0;
}

// packages/ag-charts-community/src/chart/mapping/prepareAxis.ts
var CARTESIAN_AXIS_POSITIONS = ["top", "right", "bottom", "left"];
var CARTESIAN_AXIS_TYPES = ["category", "grouped-category", "ordinal-time", "number", "log", "time"];
function hasCartesianAxisPosition(axis) {
  var allowedTypes = CARTESIAN_AXIS_TYPES;
  return allowedTypes.includes(axis.type);
}
function isCartesianAxisOptions(options) {
  var allowedTypes = CARTESIAN_AXIS_TYPES;
  return allowedTypes.includes(options.type);
}
function isAxisPosition(position) {
  var allowedPositions = CARTESIAN_AXIS_POSITIONS;
  return typeof position === "string" && allowedPositions.includes(position);
}
var AxisPositionGuesser = /*#__PURE__*/function () {
  function AxisPositionGuesser() {
    _classCallCheck(this, AxisPositionGuesser);
    this.result = [];
    this.valid = [];
    this.invalid = [];
  }
  _createClass(AxisPositionGuesser, [{
    key: "push",
    value: function push(axis, options) {
      var result = this.result,
        valid = this.valid,
        invalid = this.invalid;
      if (isCartesianAxisOptions(options)) {
        if (isAxisPosition(options.position)) {
          valid.push(axis);
        } else {
          invalid.push(axis);
        }
      }
      result.push(axis);
    }
  }, {
    key: "guessInvalidPositions",
    value: function guessInvalidPositions() {
      var takenPosition = this.valid.filter(function (v) {
        return hasCartesianAxisPosition(v);
      }).map(function (v) {
        return v.position;
      }).filter(function (v) {
        return v !== void 0;
      });
      var guesses = ["top", "right", "bottom", "left"];
      var _iterator148 = _createForOfIteratorHelper(this.invalid),
        _step148;
      try {
        for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
          var invalidAxis = _step148.value;
          var nextGuess = guesses.pop();
          while (takenPosition.includes(nextGuess) && nextGuess !== void 0) {
            nextGuess = guesses.pop();
          }
          if (nextGuess === void 0) break;
          invalidAxis.position = nextGuess;
        }
      } catch (err) {
        _iterator148.e(err);
      } finally {
        _iterator148.f();
      }
      return this.result;
    }
  }]);
  return AxisPositionGuesser;
}();

// packages/ag-charts-community/src/chart/mapping/prepareSeries.ts
var MATCHING_KEYS = ["direction", "xKey", "yKey", "sizeKey", "angleKey", "radiusKey", "normalizedTo", "stacked", "grouped", "stackGroup"];
function matchSeriesOptions(series, optSeries, oldOptsSeries) {
  var _a, _b, _c, _d;
  var generateKey = function generateKey(type, i) {
    var result = [type];
    for (var _i19 = 0, _MATCHING_KEYS = MATCHING_KEYS; _i19 < _MATCHING_KEYS.length; _i19++) {
      var key = _MATCHING_KEYS[_i19];
      if (key in i && i[key] != null) result.push("".concat(key, "=").concat(i[key]));
    }
    return result.join(";");
  };
  var seriesMap = /* @__PURE__ */new Map();
  var idx = 0;
  var _iterator149 = _createForOfIteratorHelper(series),
    _step149;
  try {
    for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
      var s = _step149.value;
      var key = generateKey(s.type, s.properties);
      if (!seriesMap.has(key)) {
        seriesMap.set(key, []);
      }
      (_a = seriesMap.get(key)) == null ? void 0 : _a.push([s, idx++]);
    }
  } catch (err) {
    _iterator149.e(err);
  } finally {
    _iterator149.f();
  }
  var optsMap = /* @__PURE__ */new Map();
  var _iterator150 = _createForOfIteratorHelper(optSeries),
    _step150;
  try {
    for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
      var o = _step150.value;
      var _key25 = generateKey(o.type, o);
      if (!optsMap.has(_key25)) {
        optsMap.set(_key25, []);
      }
      (_b = optsMap.get(_key25)) == null ? void 0 : _b.push(o);
    }
  } catch (err) {
    _iterator150.e(err);
  } finally {
    _iterator150.f();
  }
  var overlap = _toConsumableArray(seriesMap.keys()).some(function (k) {
    return optsMap.has(k);
  });
  if (!overlap) {
    return {
      status: "no-overlap",
      oldKeys: seriesMap.keys(),
      newKeys: optsMap.keys()
    };
  }
  var changes = [];
  var targetIdx = -1;
  var _iterator151 = _createForOfIteratorHelper(optsMap.entries()),
    _step151;
  try {
    for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
      var _step151$value = _slicedToArray(_step151.value, 2),
        _key26 = _step151$value[0],
        optArray = _step151$value[1];
      var _iterator153 = _createForOfIteratorHelper(optArray),
        _step153;
      try {
        for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
          var opts = _step153.value;
          targetIdx++;
          var seriesArray = seriesMap.get(_key26);
          if (seriesArray == null || seriesArray.length < 1) {
            changes.push({
              opts: opts,
              idx: targetIdx,
              status: "add"
            });
            seriesMap.delete(_key26);
            continue;
          }
          var _seriesArray$shift = seriesArray.shift(),
            _seriesArray$shift2 = _slicedToArray(_seriesArray$shift, 2),
            outputSeries = _seriesArray$shift2[0],
            outputIdx = _seriesArray$shift2[1];
          var previousOpts = (_c = oldOptsSeries == null ? void 0 : oldOptsSeries[outputIdx]) != null ? _c : {};
          var diff2 = _jsonDiff(previousOpts, opts != null ? opts : {});
          var _ref98 = (_d = diff2 == null ? void 0 : diff2.seriesGrouping) != null ? _d : {},
            groupIndex = _ref98.groupIndex,
            stackIndex = _ref98.stackIndex;
          if (groupIndex != null || stackIndex != null) {
            changes.push({
              opts: opts,
              series: outputSeries,
              diff: diff2,
              idx: outputIdx,
              status: "series-grouping"
            });
          } else if (diff2) {
            changes.push({
              opts: opts,
              series: outputSeries,
              diff: diff2,
              idx: outputIdx,
              status: "update"
            });
          } else {
            changes.push({
              opts: opts,
              series: outputSeries,
              idx: outputIdx,
              status: "no-op"
            });
          }
          if (seriesArray.length === 0) {
            seriesMap.delete(_key26);
          }
        }
      } catch (err) {
        _iterator153.e(err);
      } finally {
        _iterator153.f();
      }
    }
  } catch (err) {
    _iterator151.e(err);
  } finally {
    _iterator151.f();
  }
  var _iterator152 = _createForOfIteratorHelper(seriesMap.values()),
    _step152;
  try {
    for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
      var _seriesArray = _step152.value;
      var _iterator154 = _createForOfIteratorHelper(_seriesArray),
        _step154;
      try {
        for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
          var _step154$value = _slicedToArray(_step154.value, 2),
            _outputSeries = _step154$value[0],
            _outputIdx = _step154$value[1];
          changes.push({
            series: _outputSeries,
            idx: _outputIdx,
            status: "remove"
          });
        }
      } catch (err) {
        _iterator154.e(err);
      } finally {
        _iterator154.f();
      }
    }
  } catch (err) {
    _iterator152.e(err);
  } finally {
    _iterator152.f();
  }
  return {
    status: "overlap",
    changes: changes
  };
}

// packages/ag-charts-community/src/chart/modulesManager.ts
var ModulesManager = /*#__PURE__*/function (_ModuleMap) {
  _inherits(ModulesManager, _ModuleMap);
  function ModulesManager() {
    _classCallCheck(this, ModulesManager);
    return _possibleConstructorReturn(this, _getPrototypeOf(ModulesManager).apply(this, arguments));
  }
  _createClass(ModulesManager, [{
    key: "applyOptions",
    value: function applyOptions(options) {
      var _iterator155 = _createForOfIteratorHelper(this.moduleMap.values()),
        _step155;
      try {
        for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
          var m = _step155.value;
          if (m.module.optionsKey in options && _isProperties(m.moduleInstance)) {
            m.moduleInstance.set(options[m.module.optionsKey]);
          }
        }
      } catch (err) {
        _iterator155.e(err);
      } finally {
        _iterator155.f();
      }
    }
  }, {
    key: "legends",
    value: /*#__PURE__*/_regenerator().m(function legends() {
      var _iterator156, _step156, _step156$value, module, moduleInstance, _t8;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.p = _context18.n) {
          case 0:
            _iterator156 = _createForOfIteratorHelper(this.moduleMap.values());
            _context18.p = 1;
            _iterator156.s();
          case 2:
            if ((_step156 = _iterator156.n()).done) {
              _context18.n = 5;
              break;
            }
            _step156$value = _step156.value, module = _step156$value.module, moduleInstance = _step156$value.moduleInstance;
            if (!(module.type !== "legend")) {
              _context18.n = 3;
              break;
            }
            return _context18.a(3, 4);
          case 3:
            _context18.n = 4;
            return {
              legendType: module.identifier,
              legend: moduleInstance
            };
          case 4:
            _context18.n = 2;
            break;
          case 5:
            _context18.n = 7;
            break;
          case 6:
            _context18.p = 6;
            _t8 = _context18.v;
            _iterator156.e(_t8);
          case 7:
            _context18.p = 7;
            _iterator156.f();
            return _context18.f(7);
          case 8:
            return _context18.a(2);
        }
      }, legends, this, [[1, 6, 7, 8]]);
    })
  }]);
  return ModulesManager;
}(ModuleMap);

// packages/ag-charts-community/src/chart/overlay/overlay.ts
var DEFAULT_OVERLAY_CLASS = "ag-chart-overlay";
var DEFAULT_OVERLAY_DARK_CLASS = "ag-chart-dark-overlay";
var Overlay = /*#__PURE__*/function (_BaseProperties1) {
  _inherits(Overlay, _BaseProperties1);
  function Overlay(className, defaultText) {
    var _this101;
    _classCallCheck(this, Overlay);
    _this101 = _possibleConstructorReturn(this, _getPrototypeOf(Overlay).call(this));
    _this101.className = className;
    _this101.defaultText = defaultText;
    _this101.darkTheme = false;
    return _this101;
  }
  _createClass(Overlay, [{
    key: "getText",
    value: function getText() {
      var _a;
      return (_a = this.text) != null ? _a : this.defaultText;
    }
  }, {
    key: "getElement",
    value: function getElement(animationManager, rect) {
      var _a;
      (_a = this.element) != null ? _a : this.element = _createElement("div", DEFAULT_OVERLAY_CLASS, {
        position: "absolute"
      });
      this.element.classList.toggle(DEFAULT_OVERLAY_DARK_CLASS, this.darkTheme);
      this.focusBox = rect;
      var element2 = this.element;
      element2.style.left = "".concat(rect.x, "px");
      element2.style.top = "".concat(rect.y, "px");
      element2.style.width = "".concat(rect.width, "px");
      element2.style.height = "".concat(rect.height, "px");
      if (this.renderer) {
        var htmlContent = this.renderer();
        if (htmlContent instanceof HTMLElement) {
          element2.replaceChildren(htmlContent);
        } else {
          element2.innerHTML = htmlContent;
        }
      } else {
        var content = _createElement("div", {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          height: "100%",
          margin: "8px",
          font: "12px Verdana, sans-serif"
        });
        content.innerText = this.getText();
        element2.replaceChildren(content);
        animationManager == null ? void 0 : animationManager.animate({
          from: 0,
          to: 1,
          id: "overlay",
          phase: "add",
          groupId: "opacity",
          onUpdate: function onUpdate(value) {
            element2.style.opacity = String(value);
          },
          onStop: function onStop() {
            element2.style.opacity = "1";
          }
        });
      }
      return this.element;
    }
  }, {
    key: "removeElement",
    value: function removeElement(animationManager) {
      if (!this.element) return;
      if (animationManager) {
        var element2 = this.element;
        animationManager.animate({
          from: 1,
          to: 0,
          phase: "remove",
          id: "overlay",
          groupId: "opacity",
          onUpdate: function onUpdate(value) {
            element2.style.opacity = String(value);
          },
          onStop: function onStop() {
            element2.remove();
          }
        });
      } else {
        this.element.remove();
      }
      this.element = void 0;
      this.focusBox = void 0;
    }
  }]);
  return Overlay;
}(_BaseProperties35);
__decorateClass([_Validate(_STRING, {
  optional: true
})], Overlay.prototype, "text", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], Overlay.prototype, "renderer", 2);
__decorateClass([_Validate(_BOOLEAN)], Overlay.prototype, "darkTheme", 2);

// packages/ag-charts-community/src/chart/overlay/chartOverlays.ts
var ChartOverlays = /*#__PURE__*/function (_BaseProperties10) {
  _inherits(ChartOverlays, _BaseProperties10);
  function ChartOverlays() {
    var _this102;
    _classCallCheck(this, ChartOverlays);
    _this102 = _possibleConstructorReturn(this, _getPrototypeOf(ChartOverlays).apply(this, arguments));
    _this102.loading = new Overlay("ag-chart-loading-overlay", "Loading data...");
    _this102.noData = new Overlay("ag-chart-no-data-overlay", "No data to display");
    _this102.noVisibleSeries = new Overlay("ag-chart-no-visible-series", "No visible series");
    return _this102;
  }
  _createClass(ChartOverlays, [{
    key: "getFocusInfo",
    value: function getFocusInfo() {
      for (var _i20 = 0, _arr = [this.loading, this.noData, this.noVisibleSeries]; _i20 < _arr.length; _i20++) {
        var overlay = _arr[_i20];
        if (overlay.focusBox !== void 0) {
          return {
            text: overlay.getText(),
            rect: overlay.focusBox
          };
        }
      }
      return void 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.loading.removeElement();
      this.noData.removeElement();
      this.noVisibleSeries.removeElement();
    }
  }]);
  return ChartOverlays;
}(_BaseProperties35);
__decorateClass([_Validate(_OBJECT)], ChartOverlays.prototype, "loading", 2);
__decorateClass([_Validate(_OBJECT)], ChartOverlays.prototype, "noData", 2);
__decorateClass([_Validate(_OBJECT)], ChartOverlays.prototype, "noVisibleSeries", 2);

// packages/ag-charts-community/src/chart/overlay/loadingSpinner.ts
var defaultOverlayCss = "\n.".concat(DEFAULT_OVERLAY_CLASS, " {\n    color: #181d1f;\n}\n\n.").concat(DEFAULT_OVERLAY_CLASS, ".").concat(DEFAULT_OVERLAY_DARK_CLASS, " {\n    color: #ffffff;\n}\n\n.").concat(DEFAULT_OVERLAY_CLASS, "--loading {\n    color: rgb(140, 140, 140); /* DEFAULT_MUTED_LABEL_COLOUR */\n}\n\n.").concat(DEFAULT_OVERLAY_CLASS, "__loading-background {\n    background: white; /* DEFAULT_BACKGROUND_FILL */\n}\n\n.").concat(DEFAULT_OVERLAY_CLASS, ".").concat(DEFAULT_OVERLAY_DARK_CLASS, " .").concat(DEFAULT_OVERLAY_CLASS, "__loading-background {\n    background: #192232; /* DEFAULT_DARK_BACKGROUND_FILL */\n}\n");
function getLoadingSpinner(text, defaultDuration) {
  var animationDuration = _PHASE_METADATA["add"].animationDuration;
  var duration = animationDuration * defaultDuration;
  var container = _createElement("div", "".concat(DEFAULT_OVERLAY_CLASS, "--loading"), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box",
    font: "13px Verdana, sans-serif",
    // FONT_SIZE.MEDIUM
    userSelect: "none",
    animation: "ag-charts-loading ".concat(duration, "ms linear 50ms both")
  });
  var matrix = _createElement("span", {
    width: "45px",
    height: "40px",
    backgroundImage: ["linear-gradient(#0000 calc(1 * 100% / 6), #ccc 0 calc(3 * 100% / 6), #0000 0), ", "linear-gradient(#0000 calc(2 * 100% / 6), #ccc 0 calc(4 * 100% / 6), #0000 0), ", "linear-gradient(#0000 calc(3 * 100% / 6), #ccc 0 calc(5 * 100% / 6), #0000 0)"].join(""),
    backgroundSize: "10px 400%",
    backgroundRepeat: "no-repeat",
    animation: "ag-charts-loading-matrix 1s infinite linear"
  });
  var label = _createElement("p", {
    marginTop: "1em"
  });
  label.innerText = text;
  var background = _createElement("div", "".concat(DEFAULT_OVERLAY_CLASS, "__loading-background"), {
    position: "absolute",
    inset: "0",
    opacity: "0.5",
    zIndex: "-1"
  });
  var animationStyles = _createElement("style");
  animationStyles.innerText = ["@keyframes ag-charts-loading { from { opacity: 0 } to { opacity: 1 } }", "@keyframes ag-charts-loading-matrix {", "0% { background-position: 0% 0%, 50% 0%, 100% 0%; }", "100% { background-position: 0% 100%, 50% 100%, 100% 100%; }", "}"].join(" ");
  container.replaceChildren(animationStyles, matrix, label, background);
  _injectStyle(defaultOverlayCss, "chartOverlays");
  return container;
}

// packages/ag-charts-community/src/chart/data/aggregateFunctions.ts
function _sumValues(values) {
  var accumulator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0];
  var _iterator157 = _createForOfIteratorHelper(values),
    _step157;
  try {
    for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
      var value = _step157.value;
      if (typeof value !== "number") {
        continue;
      }
      if (value < 0) {
        accumulator[0] += value;
      }
      if (value > 0) {
        accumulator[1] += value;
      }
    }
  } catch (err) {
    _iterator157.e(err);
  } finally {
    _iterator157.f();
  }
  return accumulator;
}
function _sum(id, matchGroupId) {
  var result = {
    id: id,
    matchGroupIds: [matchGroupId],
    type: "aggregate",
    aggregateFunction: function aggregateFunction(values) {
      return _sumValues(values);
    }
  };
  return result;
}
function _groupSum(id, matchGroupId) {
  return {
    id: id,
    type: "aggregate",
    matchGroupIds: matchGroupId ? [matchGroupId] : void 0,
    aggregateFunction: function aggregateFunction(values) {
      return _sumValues(values);
    },
    groupAggregateFunction: function groupAggregateFunction(next) {
      var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0];
      var _a, _b;
      acc[0] += (_a = next == null ? void 0 : next[0]) != null ? _a : 0;
      acc[1] += (_b = next == null ? void 0 : next[1]) != null ? _b : 0;
      return acc;
    }
  };
}
function range2(id, matchGroupId) {
  var result = {
    id: id,
    matchGroupIds: [matchGroupId],
    type: "aggregate",
    aggregateFunction: function aggregateFunction(values) {
      return ContinuousDomain.extendDomain(values);
    }
  };
  return result;
}
function _groupCount(id) {
  return {
    id: id,
    type: "aggregate",
    aggregateFunction: function aggregateFunction() {
      return [0, 1];
    },
    groupAggregateFunction: function groupAggregateFunction(next) {
      var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0];
      var _a, _b;
      acc[0] += (_a = next == null ? void 0 : next[0]) != null ? _a : 0;
      acc[1] += (_b = next == null ? void 0 : next[1]) != null ? _b : 0;
      return acc;
    }
  };
}
function _groupAverage(id, matchGroupId) {
  var def = {
    id: id,
    matchGroupIds: matchGroupId ? [matchGroupId] : void 0,
    type: "aggregate",
    aggregateFunction: function aggregateFunction(values) {
      return _sumValues(values);
    },
    groupAggregateFunction: function groupAggregateFunction(next) {
      var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0, -1];
      var _a, _b;
      acc[0] += (_a = next == null ? void 0 : next[0]) != null ? _a : 0;
      acc[1] += (_b = next == null ? void 0 : next[1]) != null ? _b : 0;
      acc[2]++;
      return acc;
    },
    finalFunction: function finalFunction() {
      var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0];
      var result = acc[0] + acc[1];
      if (result >= 0) {
        return [0, result / acc[2]];
      }
      return [result / acc[2], 0];
    }
  };
  return def;
}
function _area(id, aggFn, matchGroupId) {
  var result = {
    id: id,
    matchGroupIds: matchGroupId ? [matchGroupId] : void 0,
    type: "aggregate",
    aggregateFunction: function aggregateFunction(values) {
      var keyRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var keyWidth = keyRange[1] - keyRange[0];
      return aggFn.aggregateFunction(values).map(function (v) {
        return v / keyWidth;
      });
    }
  };
  if (aggFn.groupAggregateFunction) {
    result.groupAggregateFunction = aggFn.groupAggregateFunction;
  }
  return result;
}
function _accumulatedValue(onlyPositive) {
  return function () {
    var value = 0;
    return function (datum) {
      if (!_isFiniteNumber(datum)) {
        return datum;
      }
      value += onlyPositive ? Math.max(0, datum) : datum;
      return value;
    };
  };
}
function _trailingAccumulatedValue() {
  return function () {
    var value = 0;
    return function (datum) {
      if (!_isFiniteNumber(datum)) {
        return datum;
      }
      var trailingValue = value;
      value += datum;
      return trailingValue;
    };
  };
}

// packages/ag-charts-community/src/chart/data/processors.ts
var _SMALLEST_KEY_INTERVAL = {
  type: "reducer",
  property: "smallestKeyInterval",
  initialValue: Infinity,
  reducer: function reducer() {
    var prevX = NaN;
    return function () {
      var smallestSoFar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
      var next = arguments.length > 1 ? arguments[1] : undefined;
      var nextX = next.keys[0];
      var interval = Math.abs(nextX - prevX);
      prevX = nextX;
      if (!isNaN(interval) && interval > 0 && interval < smallestSoFar) {
        return interval;
      }
      return smallestSoFar;
    };
  }
};
var _SORT_DOMAIN_GROUPS = {
  type: "processor",
  property: "sortedGroupDomain",
  calculate: function calculate(_ref99) {
    var groups = _ref99.domain.groups;
    return groups == null ? void 0 : groups.slice().sort(function (a, b) {
      for (var i = 0; i < a.length; i++) {
        var result = a[i] - b[i];
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
};
function normaliseFnBuilder(_ref100) {
  var normaliseTo = _ref100.normaliseTo,
    mode = _ref100.mode;
  var normalise = function normalise(val, extent2) {
    var result = val * normaliseTo / extent2;
    if (result >= 0) {
      return Math.min(normaliseTo, result);
    }
    return Math.max(-normaliseTo, result);
  };
  return function () {
    return function () {
      return function (values, valueIndexes) {
        var valuesExtent = [0, 0];
        var _iterator158 = _createForOfIteratorHelper(valueIndexes),
          _step158;
        try {
          for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
            var valueIdx = _step158.value;
            var value = values[valueIdx];
            var valIdx = value < 0 ? 0 : 1;
            if (mode === "sum") {
              valuesExtent[valIdx] += value;
            } else if (valIdx === 0) {
              valuesExtent[valIdx] = Math.min(valuesExtent[valIdx], value);
            } else {
              valuesExtent[valIdx] = Math.max(valuesExtent[valIdx], value);
            }
          }
        } catch (err) {
          _iterator158.e(err);
        } finally {
          _iterator158.f();
        }
        var extent2 = Math.max(Math.abs(valuesExtent[0]), valuesExtent[1]);
        var _iterator159 = _createForOfIteratorHelper(valueIndexes),
          _step159;
        try {
          for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
            var _valueIdx = _step159.value;
            values[_valueIdx] = normalise(values[_valueIdx], extent2);
          }
        } catch (err) {
          _iterator159.e(err);
        } finally {
          _iterator159.f();
        }
      };
    };
  };
}
function _normaliseGroupTo(matchGroupIds, normaliseTo) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "sum";
  return {
    type: "group-value-processor",
    matchGroupIds: matchGroupIds,
    adjust: memo({
      normaliseTo: normaliseTo,
      mode: mode
    }, normaliseFnBuilder)
  };
}
function normalisePropertyFnBuilder(_ref101) {
  var normaliseTo = _ref101.normaliseTo,
    zeroDomain = _ref101.zeroDomain,
    rangeMin = _ref101.rangeMin,
    rangeMax = _ref101.rangeMax;
  var normaliseSpan = normaliseTo[1] - normaliseTo[0];
  var normalise = function normalise(val, start, span) {
    var result = normaliseTo[0] + (val - start) / span * normaliseSpan;
    if (span === 0) {
      return zeroDomain;
    } else if (result >= normaliseTo[1]) {
      return normaliseTo[1];
    } else if (result < normaliseTo[0]) {
      return normaliseTo[0];
    }
    return result;
  };
  return function () {
    return function (pData, pIdx) {
      var _pData$domain$values$ = _slicedToArray(pData.domain.values[pIdx], 2),
        start = _pData$domain$values$[0],
        end = _pData$domain$values$[1];
      if (rangeMin != null) start = rangeMin;
      if (rangeMax != null) end = rangeMax;
      var span = end - start;
      pData.domain.values[pIdx] = [normaliseTo[0], normaliseTo[1]];
      var _iterator160 = _createForOfIteratorHelper(pData.data),
        _step160;
      try {
        for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
          var group2 = _step160.value;
          var groupValues = group2.values;
          if (pData.type === "ungrouped") {
            groupValues = [groupValues];
          }
          var _iterator161 = _createForOfIteratorHelper(groupValues),
            _step161;
          try {
            for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
              var values = _step161.value;
              values[pIdx] = normalise(values[pIdx], start, span);
            }
          } catch (err) {
            _iterator161.e(err);
          } finally {
            _iterator161.f();
          }
        }
      } catch (err) {
        _iterator160.e(err);
      } finally {
        _iterator160.f();
      }
    };
  };
}
function _normalisePropertyTo(property, normaliseTo, zeroDomain, rangeMin, rangeMax) {
  return {
    type: "property-value-processor",
    property: property,
    adjust: memo({
      normaliseTo: normaliseTo,
      rangeMin: rangeMin,
      rangeMax: rangeMax,
      zeroDomain: zeroDomain
    }, normalisePropertyFnBuilder)
  };
}
function _animationValidation(valueKeyIds) {
  return {
    type: "processor",
    property: "animationValidation",
    calculate: function calculate(result) {
      var _result$defs = result.defs,
        keys = _result$defs.keys,
        values = _result$defs.values;
      var input = result.input,
        data = result.data;
      var uniqueKeys = true;
      var orderedKeys = true;
      var valueKeys = [];
      for (var k = 0; k < values.length; k++) {
        if (!(valueKeyIds == null ? void 0 : valueKeyIds.includes(values[k].id))) continue;
        valueKeys.push([k, values[k]]);
      }
      var processKey = function processKey(idx, def, type) {
        var _a;
        if (def.valueType === "category") {
          var keyValues = result.domain[type][idx];
          uniqueKeys && (uniqueKeys = keyValues.length === input.count);
          return;
        }
        var lastValue = (_a = data[0]) == null ? void 0 : _a[type][idx];
        for (var d = 1; (uniqueKeys || orderedKeys) && d < data.length; d++) {
          var keyValue = data[d][type][idx];
          orderedKeys && (orderedKeys = lastValue <= keyValue);
          uniqueKeys && (uniqueKeys = lastValue !== keyValue);
          lastValue = keyValue;
        }
      };
      for (var _k = 0; (uniqueKeys || orderedKeys) && _k < keys.length; _k++) {
        processKey(_k, keys[_k], "keys");
      }
      for (var _k2 = 0; (uniqueKeys || orderedKeys) && _k2 < valueKeys.length; _k2++) {
        var _valueKeys$_k = _slicedToArray(valueKeys[_k2], 2),
          idx = _valueKeys$_k[0],
          key = _valueKeys$_k[1];
        processKey(idx, key, "values");
      }
      return {
        uniqueKeys: uniqueKeys,
        orderedKeys: orderedKeys
      };
    }
  };
}
function buildGroupAccFn(_ref102) {
  var mode = _ref102.mode,
    separateNegative = _ref102.separateNegative;
  return function () {
    return function () {
      return function (values, valueIndexes) {
        var acc = [0, 0];
        var _iterator162 = _createForOfIteratorHelper(valueIndexes),
          _step162;
        try {
          for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
            var valueIdx = _step162.value;
            var currentVal = values[valueIdx];
            var accIndex = _isNegative(currentVal) && separateNegative ? 0 : 1;
            if (!_isFiniteNumber(currentVal)) continue;
            if (mode === "normal") acc[accIndex] += currentVal;
            values[valueIdx] = acc[accIndex];
            if (mode === "trailing") acc[accIndex] += currentVal;
          }
        } catch (err) {
          _iterator162.e(err);
        } finally {
          _iterator162.f();
        }
      };
    };
  };
}
function buildGroupWindowAccFn(_ref103) {
  var mode = _ref103.mode,
    sum2 = _ref103.sum;
  return function () {
    var lastValues = [];
    var firstRow = true;
    return function () {
      return function (values, valueIndexes) {
        var acc = 0;
        var _iterator163 = _createForOfIteratorHelper(valueIndexes),
          _step163;
        try {
          for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
            var valueIdx = _step163.value;
            var currentVal = values[valueIdx];
            var lastValue = firstRow && sum2 === "current" ? 0 : lastValues[valueIdx];
            lastValues[valueIdx] = currentVal;
            var sumValue = sum2 === "current" ? currentVal : lastValue;
            if (!_isFiniteNumber(currentVal) || !_isFiniteNumber(lastValue)) {
              values[valueIdx] = acc;
              continue;
            }
            if (mode === "normal") {
              acc += sumValue;
            }
            values[valueIdx] = acc;
            if (mode === "trailing") {
              acc += sumValue;
            }
          }
        } catch (err) {
          _iterator163.e(err);
        } finally {
          _iterator163.f();
        }
        firstRow = false;
      };
    };
  };
}
function _accumulateGroup(matchGroupId, mode, sum2) {
  var separateNegative = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var adjust;
  if (mode.startsWith("window")) {
    var modeParam = mode.endsWith("-trailing") ? "trailing" : "normal";
    adjust = memo({
      mode: modeParam,
      sum: sum2
    }, buildGroupWindowAccFn);
  } else {
    adjust = memo({
      mode: mode,
      separateNegative: separateNegative
    }, buildGroupAccFn);
  }
  return {
    type: "group-value-processor",
    matchGroupIds: [matchGroupId],
    adjust: adjust
  };
}
function _diff(previousData) {
  var updateMovedData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    type: "processor",
    property: "diff",
    calculate: function calculate(processedData) {
      var moved = /* @__PURE__ */new Map();
      var added = /* @__PURE__ */new Map();
      var updated = /* @__PURE__ */new Map();
      var removed = /* @__PURE__ */new Map();
      var length = Math.max(previousData.data.length, processedData.data.length);
      for (var i = 0; i < length; i++) {
        var prev = previousData.data[i];
        var datum = processedData.data[i];
        var prevId = prev ? _createDatumId(prev.keys) : "";
        var datumId = datum ? _createDatumId(datum.keys) : "";
        if (datum && prev && prevId === datumId) {
          if (!_arraysEqual(prev.values, datum.values)) {
            updated.set(datumId, datum);
          }
          continue;
        }
        if (removed.has(datumId)) {
          if (updateMovedData || !_arraysEqual(removed.get(datumId).values, datum.values)) {
            updated.set(datumId, datum);
            moved.set(datumId, datum);
          }
          removed.delete(datumId);
        } else if (datum) {
          added.set(datumId, datum);
        }
        if (added.has(prevId)) {
          if (updateMovedData || !_arraysEqual(added.get(prevId).values, prev.values)) {
            updated.set(prevId, prev);
            moved.set(prevId, prev);
          }
          added.delete(prevId);
        } else if (prev) {
          updated.delete(prevId);
          removed.set(prevId, prev);
        }
      }
      var changed = added.size > 0 || updated.size > 0 || removed.size > 0;
      return {
        changed: changed,
        added: added,
        updated: updated,
        removed: removed,
        moved: moved
      };
    }
  };
}
function _createDatumId(keys) {
  var result;
  if (_isArray(keys)) {
    result = keys.map(function (key) {
      return _transformIntegratedCategoryValue(key);
    }).join("___");
  } else {
    result = _transformIntegratedCategoryValue(keys);
  }
  var primitiveType = typeof result === "string" || typeof result === "number" || result instanceof Date;
  for (var _len24 = arguments.length, extraKeys = new Array(_len24 > 1 ? _len24 - 1 : 0), _key27 = 1; _key27 < _len24; _key27++) {
    extraKeys[_key27 - 1] = arguments[_key27];
  }
  if (primitiveType && extraKeys.length > 0) {
    result += "___".concat(extraKeys.join("___"));
  }
  return result;
}

// packages/ag-charts-community/src/chart/series/series.ts
var _SeriesNodePickMode = /* @__PURE__ */function (SeriesNodePickMode2) {
  SeriesNodePickMode2[SeriesNodePickMode2["EXACT_SHAPE_MATCH"] = 0] = "EXACT_SHAPE_MATCH";
  SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_BY_MAIN_AXIS_FIRST"] = 1] = "NEAREST_BY_MAIN_AXIS_FIRST";
  SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST"] = 2] = "NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST";
  SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_NODE"] = 3] = "NEAREST_NODE";
  return SeriesNodePickMode2;
}(_SeriesNodePickMode || {});
function _basicContinuousCheckDatumValidation(value) {
  return value != null && _isContinuous(value);
}
function basicDiscreteCheckDatumValidation(value) {
  return value != null;
}
function getValidationFn(scaleType) {
  switch (scaleType) {
    case "number":
    case "log":
    case "ordinal-time":
    case "time":
    case "color":
      return _basicContinuousCheckDatumValidation;
    default:
      return basicDiscreteCheckDatumValidation;
  }
}
function getValueType(scaleType) {
  switch (scaleType) {
    case "number":
    case "log":
    case "time":
    case "color":
      return "range";
    default:
      return "category";
  }
}
function _keyProperty(propName, scaleType) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = __spreadValues({
    property: propName,
    type: "key",
    valueType: getValueType(scaleType),
    validation: getValidationFn(scaleType)
  }, opts);
  return result;
}
function _valueProperty(propName, scaleType) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = __spreadValues({
    property: propName,
    type: "value",
    valueType: getValueType(scaleType),
    validation: getValidationFn(scaleType)
  }, opts);
  return result;
}
function _rangedValueProperty(propName) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a = opts,
    _a$min = _a.min,
    min = _a$min === void 0 ? -Infinity : _a$min,
    _a$max = _a.max,
    max = _a$max === void 0 ? Infinity : _a$max,
    defOpts = __objRest(_a, ["min", "max"]);
  return __spreadValues({
    type: "value",
    property: propName,
    valueType: "range",
    validation: _basicContinuousCheckDatumValidation,
    processor: function processor() {
      return function (datum) {
        return _isFiniteNumber(datum) ? _clamp(min, datum, max) : datum;
      };
    }
  }, defOpts);
}
function _accumulativeValueProperty(propName, scaleType) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a = opts,
    onlyPositive = _a.onlyPositive,
    defOpts = __objRest(_a, ["onlyPositive"]);
  var result = __spreadProps(__spreadValues({}, _valueProperty(propName, scaleType, defOpts)), {
    processor: _accumulatedValue(onlyPositive)
  });
  return result;
}
function _trailingAccumulatedValueProperty(propName, scaleType) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = __spreadProps(__spreadValues({}, _valueProperty(propName, scaleType, opts)), {
    processor: _trailingAccumulatedValue()
  });
  return result;
}
function _groupAccumulativeValueProperty(propName, mode) {
  var sum2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "current";
  var opts = arguments.length > 3 ? arguments[3] : undefined;
  var scaleType = arguments.length > 4 ? arguments[4] : undefined;
  return [_valueProperty(propName, scaleType, opts), _accumulateGroup(opts.groupId, mode, sum2, opts.separateNegative)].concat(_toConsumableArray(opts.rangeId != null ? [range2(opts.rangeId, opts.groupId)] : []));
}
var _SeriesNodeEvent4 = function SeriesNodeEvent(type, event, _ref104, series) {
  var datum = _ref104.datum;
  _classCallCheck(this, SeriesNodeEvent);
  this.type = type;
  this.event = event;
  this.datum = datum;
  this.seriesId = series.id;
};
var _SeriesGroupingChangedEvent = function SeriesGroupingChangedEvent(series, seriesGrouping, oldGrouping) {
  _classCallCheck(this, SeriesGroupingChangedEvent);
  this.series = series;
  this.seriesGrouping = seriesGrouping;
  this.oldGrouping = oldGrouping;
  this.type = "groupingChanged";
};
var _Series2 = /*#__PURE__*/function (_Observable) {
  _inherits(Series, _Observable);
  function Series(seriesOpts) {
    var _this103;
    _classCallCheck(this, Series);
    _this103 = _possibleConstructorReturn(this, _getPrototypeOf(Series).call(this));
    _this103.destroyFns = [];
    _this103.seriesGrouping = void 0;
    _this103.NodeEvent = _SeriesNodeEvent4;
    _this103.internalId = _createId(_assertThisInitialized(_this103));
    // The group node that contains all the nodes used to render this series.
    _this103.rootGroup = new _Group4({
      name: "seriesRoot",
      isVirtual: true
    });
    _this103.axes = _defineProperty(_defineProperty({}, "x" /* X */, void 0), "y" /* Y */, void 0);
    _this103.directions = ["x" /* X */, "y" /* Y */];
    // Flag to determine if we should recalculate node data.
    _this103.nodeDataRefresh = true;
    _this103.moduleMap = new ModuleMap();
    _this103._declarationOrder = -1;
    _this103.seriesListeners = new Listeners();
    var moduleCtx = seriesOpts.moduleCtx,
      _seriesOpts$pickModes = seriesOpts.pickModes,
      pickModes = _seriesOpts$pickModes === void 0 ? [1 /* NEAREST_BY_MAIN_AXIS_FIRST */] : _seriesOpts$pickModes,
      _seriesOpts$direction = seriesOpts.directionKeys,
      directionKeys = _seriesOpts$direction === void 0 ? {} : _seriesOpts$direction,
      _seriesOpts$direction2 = seriesOpts.directionNames,
      directionNames = _seriesOpts$direction2 === void 0 ? {} : _seriesOpts$direction2,
      _seriesOpts$contentGr = seriesOpts.contentGroupVirtual,
      contentGroupVirtual = _seriesOpts$contentGr === void 0 ? true : _seriesOpts$contentGr,
      _seriesOpts$canHaveAx = seriesOpts.canHaveAxes,
      canHaveAxes = _seriesOpts$canHaveAx === void 0 ? false : _seriesOpts$canHaveAx;
    _this103.ctx = moduleCtx;
    _this103.directionKeys = directionKeys;
    _this103.directionNames = directionNames;
    _this103.canHaveAxes = canHaveAxes;
    _this103.contentGroup = _this103.rootGroup.appendChild(new _Group4({
      name: "".concat(_this103.internalId, "-content"),
      isVirtual: contentGroupVirtual,
      zIndex: 4 /* SERIES_LAYER_ZINDEX */,
      zIndexSubOrder: _this103.getGroupZIndexSubOrder("data")
    }));
    _this103.highlightGroup = new _Group4({
      name: "".concat(_this103.internalId, "-highlight"),
      isVirtual: contentGroupVirtual,
      zIndex: 4 /* SERIES_LAYER_ZINDEX */,
      zIndexSubOrder: _this103.getGroupZIndexSubOrder("highlight")
    });
    _this103.highlightNode = _this103.highlightGroup.appendChild(new _Group4({
      name: "highlightNode",
      zIndex: 0
    }));
    _this103.highlightLabel = _this103.highlightGroup.appendChild(new _Group4({
      name: "highlightLabel",
      zIndex: 10
    }));
    _this103.pickModes = pickModes;
    _this103.labelGroup = _this103.rootGroup.appendChild(new _Group4({
      name: "".concat(_this103.internalId, "-series-labels"),
      zIndex: 8 /* SERIES_LABEL_ZINDEX */
    }));
    _this103.annotationGroup = new _Group4({
      name: "".concat(_this103.id, "-annotation"),
      isVirtual: contentGroupVirtual,
      zIndex: 4 /* SERIES_LAYER_ZINDEX */,
      zIndexSubOrder: _this103.getGroupZIndexSubOrder("annotation")
    });
    return _this103;
  }
  _createClass(Series, [{
    key: "onDataChange",
    value: function onDataChange() {
      this.nodeDataRefresh = true;
    }
  }, {
    key: "setOptionsData",
    value: function setOptionsData(input) {
      this._data = input;
      this.onDataChange();
    }
  }, {
    key: "setChartData",
    value: function setChartData(input) {
      this._chartData = input;
      if (this.data === input) {
        this.onDataChange();
      }
    }
  }, {
    key: "onSeriesGroupingChange",
    value: function onSeriesGroupingChange(prev, next) {
      var internalId = this.internalId,
        type = this.type,
        visible = this.visible;
      if (prev) {
        this.ctx.seriesStateManager.deregisterSeries({
          id: internalId,
          type: type
        });
      }
      if (next) {
        this.ctx.seriesStateManager.registerSeries({
          id: internalId,
          type: type,
          visible: visible,
          seriesGrouping: next
        });
      }
      this.fireEvent(new _SeriesGroupingChangedEvent(this, next, prev));
    }
  }, {
    key: "getBandScalePadding",
    value: function getBandScalePadding() {
      return {
        inner: 1,
        outer: 0
      };
    }
  }, {
    key: "getGroupZIndexSubOrder",
    value: function getGroupZIndexSubOrder(type) {
      var _this104 = this;
      var subIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var mainAdjust = 0;
      switch (type) {
        case "data":
        case "paths":
          break;
        case "labels":
          mainAdjust += 2e4;
          break;
        case "marker":
          mainAdjust += 1e4;
          break;
        case "highlight":
          subIndex += 15e3;
          break;
        case "annotation":
          mainAdjust += 15e3;
          break;
      }
      var main = function main() {
        return _this104._declarationOrder + mainAdjust;
      };
      return [main, subIndex];
    }
  }, {
    key: "addListener",
    value: function addListener(type, listener) {
      return this.seriesListeners.addListener(type, listener);
    }
  }, {
    key: "dispatch",
    value: function dispatch(type, event) {
      this.seriesListeners.dispatch(type, event);
    }
  }, {
    key: "addChartEventListeners",
    value: function addChartEventListeners() {
      return;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (f) {
        return f();
      });
      this.destroyFns = [];
      this.ctx.seriesStateManager.deregisterSeries(this);
    }
  }, {
    key: "getDirectionValues",
    value: function getDirectionValues(direction, properties) {
      var _this105 = this;
      var resolvedDirection = this.resolveKeyDirection(direction);
      var keys = properties == null ? void 0 : properties[resolvedDirection];
      var values = [];
      if (!keys) {
        return values;
      }
      var _addValues = function addValues() {
        for (var _len25 = arguments.length, items = new Array(_len25), _key28 = 0; _key28 < _len25; _key28++) {
          items[_key28] = arguments[_key28];
        }
        for (var _i21 = 0, _items = items; _i21 < _items.length; _i21++) {
          var value = _items[_i21];
          if (Array.isArray(value)) {
            _addValues.apply(void 0, _toConsumableArray(value));
          } else if (typeof value === "object") {
            _addValues.apply(void 0, _toConsumableArray(Object.values(value)));
          } else {
            values.push(value);
          }
        }
      };
      _addValues.apply(void 0, _toConsumableArray(keys.map(function (key) {
        return _this105.properties[key];
      })));
      return values;
    }
  }, {
    key: "getKeys",
    value: function getKeys(direction) {
      return this.getDirectionValues(direction, this.directionKeys);
    }
  }, {
    key: "getKeyProperties",
    value: function getKeyProperties(direction) {
      var _a;
      return (_a = this.directionKeys[this.resolveKeyDirection(direction)]) != null ? _a : [];
    }
  }, {
    key: "getNames",
    value: function getNames(direction) {
      return this.getDirectionValues(direction, this.directionNames);
    }
  }, {
    key: "resolveKeyDirection",
    value: function resolveKeyDirection(direction) {
      return direction;
    } // The union of the series domain ('community') and series-option domains ('enterprise').
  }, {
    key: "getDomain",
    value: function getDomain(direction) {
      var seriesDomain = this.getSeriesDomain(direction);
      var moduleDomains = this.moduleMap.mapModules(function (module) {
        return module.getDomain(direction);
      });
      return seriesDomain.concat(moduleDomains.flat());
    } // Indicate that something external changed and we should recalculate nodeData.
  }, {
    key: "markNodeDataDirty",
    value: function markNodeDataDirty() {
      this.nodeDataRefresh = true;
    }
  }, {
    key: "visibleChanged",
    value: function visibleChanged() {
      this.ctx.seriesStateManager.registerSeries(this);
    }
  }, {
    key: "getOpacity",
    value: function getOpacity() {
      var defaultOpacity = 1;
      var _this$properties$high = this.properties.highlightStyle.series,
        _this$properties$high2 = _this$properties$high.dimOpacity,
        dimOpacity = _this$properties$high2 === void 0 ? 1 : _this$properties$high2,
        _this$properties$high3 = _this$properties$high.enabled,
        enabled = _this$properties$high3 === void 0 ? true : _this$properties$high3;
      if (!enabled || dimOpacity === defaultOpacity) {
        return defaultOpacity;
      }
      switch (this.isItemIdHighlighted()) {
        case 0 /* None */:
        case 1 /* This */:
          return defaultOpacity;
        case 2 /* Other */:
        default:
          return dimOpacity;
      }
    }
  }, {
    key: "getStrokeWidth",
    value: function getStrokeWidth(defaultStrokeWidth) {
      var _this$properties$high4 = this.properties.highlightStyle.series,
        strokeWidth = _this$properties$high4.strokeWidth,
        _this$properties$high5 = _this$properties$high4.enabled,
        enabled = _this$properties$high5 === void 0 ? true : _this$properties$high5;
      if (!enabled || strokeWidth === void 0) {
        return defaultStrokeWidth;
      }
      switch (this.isItemIdHighlighted()) {
        case 1 /* This */:
          return strokeWidth;
        case 0 /* None */:
        case 2 /* Other */:
          return defaultStrokeWidth;
      }
    }
  }, {
    key: "isItemIdHighlighted",
    value: function isItemIdHighlighted() {
      var _a, _b;
      var series = (_b = (_a = this.ctx.highlightManager) == null ? void 0 : _a.getActiveHighlight()) == null ? void 0 : _b.series;
      if (series == null) {
        return 0 /* None */;
      }
      if (series !== this) {
        return 2 /* Other */;
      }
      return 1 /* This */;
    }
  }, {
    key: "getModuleTooltipParams",
    value: function getModuleTooltipParams() {
      return this.moduleMap.mapModules(function (module) {
        return module.getTooltipParams();
      }).reduce(function (total, current) {
        return Object.assign(total, current);
      }, {});
    }
  }, {
    key: "pickNode",
    value: function pickNode(point, limitPickModes) {
      var pickModes = this.pickModes,
        visible = this.visible,
        rootGroup = this.rootGroup;
      if (!visible || !rootGroup.visible) {
        return;
      }
      var _iterator164 = _createForOfIteratorHelper(pickModes),
        _step164;
      try {
        for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
          var pickMode = _step164.value;
          if (limitPickModes && !limitPickModes.includes(pickMode)) {
            continue;
          }
          var match = void 0;
          switch (pickMode) {
            case 0 /* EXACT_SHAPE_MATCH */:
              match = this.pickNodeExactShape(point);
              break;
            case 1 /* NEAREST_BY_MAIN_AXIS_FIRST */:
            case 2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */:
              match = this.pickNodeMainAxisFirst(point, pickMode === 2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */);
              break;
            case 3 /* NEAREST_NODE */:
              match = this.pickNodeClosestDatum(point);
              break;
          }
          if (match) {
            return {
              pickMode: pickMode,
              match: match.datum,
              distance: match.distance
            };
          }
        }
      } catch (err) {
        _iterator164.e(err);
      } finally {
        _iterator164.f();
      }
    }
  }, {
    key: "pickNodeExactShape",
    value: function pickNodeExactShape(point) {
      var match = this.contentGroup.pickNode(point.x, point.y);
      if (match && match.datum.missing !== true) {
        return {
          datum: match.datum,
          distance: 0
        };
      }
      return void 0;
    }
  }, {
    key: "pickNodeClosestDatum",
    value: function pickNodeClosestDatum(_point) {
      throw new Error("AG Charts - Series.pickNodeClosestDatum() not implemented");
    }
  }, {
    key: "pickNodeNearestDistantObject",
    value: function pickNodeNearestDistantObject(point, items) {
      var match = _nearestSquared(point.x, point.y, items);
      if (match.nearest !== void 0 && match.nearest.datum.missing !== true) {
        return {
          datum: match.nearest.datum,
          distance: Math.sqrt(match.distanceSquared)
        };
      }
      return void 0;
    }
  }, {
    key: "pickNodeMainAxisFirst",
    value: function pickNodeMainAxisFirst(_point, _requireCategoryAxis) {
      throw new Error("AG Charts - Series.pickNodeMainAxisFirst() not implemented");
    }
  }, {
    key: "fireNodeClickEvent",
    value: function fireNodeClickEvent(event, datum) {
      this.fireEvent(new this.NodeEvent("nodeClick", event, datum, this));
    }
  }, {
    key: "fireNodeDoubleClickEvent",
    value: function fireNodeDoubleClickEvent(event, datum) {
      this.fireEvent(new this.NodeEvent("nodeDoubleClick", event, datum, this));
    }
  }, {
    key: "createNodeContextMenuActionEvent",
    value: function createNodeContextMenuActionEvent(event, datum) {
      return new this.NodeEvent("nodeContextMenuAction", event, datum, this);
    }
  }, {
    key: "toggleSeriesItem",
    value: function toggleSeriesItem(itemId, enabled) {
      this.visible = enabled;
      this.nodeDataRefresh = true;
      this.dispatch("visibility-changed", {
        itemId: itemId,
        enabled: enabled
      });
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.visible;
    }
  }, {
    key: "getModuleMap",
    value: function getModuleMap() {
      return this.moduleMap;
    }
  }, {
    key: "createModuleContext",
    value: function createModuleContext() {
      return __spreadProps(__spreadValues({}, this.ctx), {
        series: this
      });
    }
  }, {
    key: "getLabelText",
    value: function getLabelText(label, params) {
      var defaultFormatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : String;
      var _a;
      if (label.formatter) {
        return (_a = this.ctx.callbackCache.call(label.formatter, __spreadValues({
          seriesId: this.id
        }, params))) != null ? _a : defaultFormatter(params.value);
      }
      return defaultFormatter(params.value);
    }
  }, {
    key: "getMarkerStyle",
    value: function getMarkerStyle(marker, params) {
      var defaultStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : marker.getStyle();
      var _a, _b;
      var defaultSize = {
        size: (_b = (_a = params.datum.point) == null ? void 0 : _a.size) != null ? _b : 0
      };
      var markerStyle = _mergeDefaults4(defaultSize, defaultStyle);
      if (marker.formatter) {
        var style = this.ctx.callbackCache.call(marker.formatter, __spreadProps(__spreadValues(__spreadValues({
          seriesId: this.id
        }, markerStyle), params), {
          datum: params.datum.datum
        }));
        return _mergeDefaults4(style, markerStyle);
      }
      return markerStyle;
    }
  }, {
    key: "updateMarkerStyle",
    value: function updateMarkerStyle(markerNode, marker, params) {
      var defaultStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : marker.getStyle();
      var _ref105 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        _ref105$applyTranslat = _ref105.applyTranslation,
        applyTranslation = _ref105$applyTranslat === void 0 ? true : _ref105$applyTranslat;
      var point = params.datum.point;
      var activeStyle = this.getMarkerStyle(marker, params, defaultStyle);
      var visible = this.visible && activeStyle.size > 0 && point && !isNaN(point.x) && !isNaN(point.y);
      if (applyTranslation) {
        markerNode.setProperties(__spreadProps(__spreadValues({
          visible: visible
        }, activeStyle), {
          translationX: point == null ? void 0 : point.x,
          translationY: point == null ? void 0 : point.y
        }));
      } else {
        markerNode.setProperties(__spreadValues({
          visible: visible
        }, activeStyle));
      }
      if (typeof marker.shape === "function" && !markerNode.dirtyPath) {
        markerNode.path.clear(true);
        markerNode.updatePath();
        markerNode.checkPathDirty();
      }
    }
  }, {
    key: "getMinRects",
    value: function getMinRects(_width, _height) {
      return;
    }
  }, {
    key: "checkResize",
    value: function checkResize(newSeriesRect) {
      var _ref106 = newSeriesRect != null ? newSeriesRect : {
          width: NaN,
          height: NaN
        },
        seriesRectWidth = _ref106.width,
        seriesRectHeight = _ref106.height;
      var newNodeDataDependencies = newSeriesRect ? {
        seriesRectWidth: seriesRectWidth,
        seriesRectHeight: seriesRectHeight
      } : void 0;
      var resize = _jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
      if (resize) {
        this._nodeDataDependencies = newNodeDataDependencies;
        this.markNodeDataDirty();
      }
      return resize;
    }
  }, {
    key: "pickFocus",
    value: function pickFocus(_opts) {
      return void 0;
    }
  }, {
    key: "id",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.properties) == null ? void 0 : _a.id) != null ? _b : this.internalId;
    }
  }, {
    key: "type",
    get: function get() {
      var _a;
      return (_a = this.constructor.type) != null ? _a : "";
    }
  }, {
    key: "data",
    get: function get() {
      var _a;
      return (_a = this._data) != null ? _a : this._chartData;
    }
  }, {
    key: "visible",
    set: function set(value) {
      this.properties.visible = value;
      this.visibleChanged();
    },
    get: function get() {
      return this.properties.visible;
    }
  }, {
    key: "hasData",
    get: function get() {
      return this.data != null && this.data.length > 0;
    }
  }, {
    key: "tooltipEnabled",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.properties.tooltip) == null ? void 0 : _a.enabled) != null ? _b : false;
    }
  }, {
    key: "nodeDataDependencies",
    get: function get() {
      var _a;
      return (_a = this._nodeDataDependencies) != null ? _a : {
        seriesRectWidth: NaN,
        seriesRectHeight: NaN
      };
    }
  }]);
  return Series;
}(Observable);
_Series2.highlightedZIndex = 1e12;
__decorateClass([_ActionOnSet({
  changeValue: function changeValue(newVal, oldVal) {
    this.onSeriesGroupingChange(oldVal, newVal);
  }
})], _Series2.prototype, "seriesGrouping", 2);

// packages/ag-charts-community/src/chart/series/seriesLayerManager.ts
var SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION = 30;
var SeriesLayerManager = /*#__PURE__*/function () {
  function SeriesLayerManager(seriesRoot, highlightRoot, annotationRoot) {
    _classCallCheck(this, SeriesLayerManager);
    this.seriesRoot = seriesRoot;
    this.highlightRoot = highlightRoot;
    this.annotationRoot = annotationRoot;
    this.groups = {};
    this.series = {};
    this.expectedSeriesCount = 1;
    this.mode = "normal";
  }
  _createClass(SeriesLayerManager, [{
    key: "setSeriesCount",
    value: function setSeriesCount(count) {
      this.expectedSeriesCount = count;
    }
  }, {
    key: "requestGroup",
    value: function requestGroup(seriesConfig) {
      var _a, _b, _c, _d;
      var internalId = seriesConfig.internalId,
        type = seriesConfig.type,
        seriesRootGroup = seriesConfig.rootGroup,
        seriesHighlightGroup = seriesConfig.highlightGroup,
        seriesAnnotationGroup = seriesConfig.annotationGroup,
        seriesGrouping = seriesConfig.seriesGrouping;
      var _ref107 = seriesGrouping != null ? seriesGrouping : {},
        _ref107$groupIndex = _ref107.groupIndex,
        groupIndex = _ref107$groupIndex === void 0 ? internalId : _ref107$groupIndex;
      if (this.series[internalId] != null) {
        throw new Error("AG Charts - series already has an allocated layer: ".concat(this.series[internalId]));
      }
      if (Object.keys(this.series).length === 0) {
        this.mode = this.expectedSeriesCount >= SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION ? "aggressive-grouping" : "normal";
      }
      (_b = (_a = this.groups)[type]) != null ? _b : _a[type] = {};
      var lookupIndex = this.lookupIdx(groupIndex);
      var groupInfo = this.groups[type][lookupIndex];
      if (!groupInfo) {
        groupInfo = (_d = (_c = this.groups[type])[lookupIndex]) != null ? _d : _c[lookupIndex] = {
          seriesIds: [],
          group: this.seriesRoot.appendChild(new _Group4({
            name: "".concat(type, "-content"),
            layer: true,
            zIndex: 4 /* SERIES_LAYER_ZINDEX */,
            zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder("data")
          })),
          highlight: this.highlightRoot.appendChild(new _Group4({
            name: "".concat(type, "-highlight"),
            zIndex: 4 /* SERIES_LAYER_ZINDEX */,
            zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder("highlight")
          })),
          annotation: this.annotationRoot.appendChild(new _Group4({
            name: "".concat(type, "-annotation"),
            zIndex: 4 /* SERIES_LAYER_ZINDEX */,
            zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder("annotation")
          }))
        };
      }
      this.series[internalId] = {
        layerState: groupInfo,
        seriesConfig: seriesConfig
      };
      groupInfo.seriesIds.push(internalId);
      groupInfo.group.appendChild(seriesRootGroup);
      groupInfo.highlight.appendChild(seriesHighlightGroup);
      groupInfo.annotation.appendChild(seriesAnnotationGroup);
      return groupInfo.group;
    }
  }, {
    key: "changeGroup",
    value: function changeGroup(seriesConfig) {
      var _a, _b;
      var internalId = seriesConfig.internalId,
        seriesGrouping = seriesConfig.seriesGrouping,
        type = seriesConfig.type,
        rootGroup = seriesConfig.rootGroup,
        highlightGroup = seriesConfig.highlightGroup,
        annotationGroup = seriesConfig.annotationGroup,
        oldGrouping = seriesConfig.oldGrouping;
      var _ref108 = seriesGrouping != null ? seriesGrouping : {},
        _ref108$groupIndex = _ref108.groupIndex,
        groupIndex = _ref108$groupIndex === void 0 ? internalId : _ref108$groupIndex;
      if ((_b = (_a = this.groups[type]) == null ? void 0 : _a[groupIndex]) == null ? void 0 : _b.seriesIds.includes(internalId)) {
        return;
      }
      if (this.series[internalId] != null) {
        this.releaseGroup({
          internalId: internalId,
          seriesGrouping: oldGrouping,
          type: type,
          rootGroup: rootGroup,
          highlightGroup: highlightGroup,
          annotationGroup: annotationGroup
        });
      }
      this.requestGroup(seriesConfig);
    }
  }, {
    key: "releaseGroup",
    value: function releaseGroup(seriesConfig) {
      var _a, _b, _c, _d, _e;
      var internalId = seriesConfig.internalId,
        seriesGrouping = seriesConfig.seriesGrouping,
        rootGroup = seriesConfig.rootGroup,
        highlightGroup = seriesConfig.highlightGroup,
        annotationGroup = seriesConfig.annotationGroup,
        type = seriesConfig.type;
      var _ref109 = seriesGrouping != null ? seriesGrouping : {},
        _ref109$groupIndex = _ref109.groupIndex,
        groupIndex = _ref109$groupIndex === void 0 ? internalId : _ref109$groupIndex;
      if (this.series[internalId] == null) {
        throw new Error("AG Charts - series doesn't have an allocated layer: ".concat(internalId));
      }
      var lookupIndex = this.lookupIdx(groupIndex);
      var groupInfo = (_c = (_a = this.groups[type]) == null ? void 0 : _a[lookupIndex]) != null ? _c : (_b = this.series[internalId]) == null ? void 0 : _b.layerState;
      if (groupInfo) {
        groupInfo.seriesIds = groupInfo.seriesIds.filter(function (v) {
          return v !== internalId;
        });
        groupInfo.group.removeChild(rootGroup);
        groupInfo.highlight.removeChild(highlightGroup);
        groupInfo.annotation.removeChild(annotationGroup);
      }
      if ((groupInfo == null ? void 0 : groupInfo.seriesIds.length) === 0) {
        this.seriesRoot.removeChild(groupInfo.group);
        this.highlightRoot.removeChild(groupInfo.highlight);
        this.annotationRoot.removeChild(groupInfo.annotation);
        delete this.groups[type][lookupIndex];
        delete this.groups[type][internalId];
      } else if ((groupInfo == null ? void 0 : groupInfo.seriesIds.length) > 0) {
        var leadSeriesConfig = (_e = this.series[(_d = groupInfo == null ? void 0 : groupInfo.seriesIds) == null ? void 0 : _d[0]]) == null ? void 0 : _e.seriesConfig;
        groupInfo.group.zIndexSubOrder = leadSeriesConfig == null ? void 0 : leadSeriesConfig.getGroupZIndexSubOrder("data");
        groupInfo.highlight.zIndexSubOrder = leadSeriesConfig == null ? void 0 : leadSeriesConfig.getGroupZIndexSubOrder("highlight");
        groupInfo.annotation.zIndexSubOrder = leadSeriesConfig == null ? void 0 : leadSeriesConfig.getGroupZIndexSubOrder("annotation");
      }
      delete this.series[internalId];
    }
  }, {
    key: "lookupIdx",
    value: function lookupIdx(groupIndex) {
      if (this.mode === "normal") {
        return groupIndex;
      }
      if (typeof groupIndex === "string") {
        groupIndex = Number(groupIndex.split("-").slice(-1)[0]);
        if (!groupIndex) {
          return 0;
        }
      }
      return Math.floor(_clamp(0, groupIndex / this.expectedSeriesCount, 1) * SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var _i22 = 0, _Object$values3 = Object.values(this.groups); _i22 < _Object$values3.length; _i22++) {
        var groups = _Object$values3[_i22];
        for (var _i23 = 0, _Object$values4 = Object.values(groups); _i23 < _Object$values4.length; _i23++) {
          var groupInfo = _Object$values4[_i23];
          this.seriesRoot.removeChild(groupInfo.group);
          this.highlightRoot.removeChild(groupInfo.highlight);
          this.annotationRoot.removeChild(groupInfo.annotation);
        }
      }
      this.groups = {};
      this.series = {};
    }
  }]);
  return SeriesLayerManager;
}();

// packages/ag-charts-community/src/chart/update/baseLayoutProcessor.ts
var BaseLayoutProcessor = /*#__PURE__*/function () {
  function BaseLayoutProcessor(chartLike, layoutService) {
    var _this106 = this;
    _classCallCheck(this, BaseLayoutProcessor);
    this.chartLike = chartLike;
    this.layoutService = layoutService;
    this.destroyFns = [];
    this.destroyFns.push(
    // eslint-disable-next-line sonarjs/no-duplicate-string
    this.layoutService.addListener("start-layout", function (e) {
      return _this106.positionPadding(e.shrinkRect);
    }), this.layoutService.addListener("start-layout", function (e) {
      return _this106.positionCaptions(e.shrinkRect);
    }));
  }
  _createClass(BaseLayoutProcessor, [{
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (cb) {
        return cb();
      });
    }
  }, {
    key: "positionPadding",
    value: function positionPadding(shrinkRect) {
      var padding = this.chartLike.padding;
      shrinkRect.shrink(padding.left, "left");
      shrinkRect.shrink(padding.top, "top");
      shrinkRect.shrink(padding.right, "right");
      shrinkRect.shrink(padding.bottom, "bottom");
      return {
        shrinkRect: shrinkRect
      };
    }
  }, {
    key: "positionCaptions",
    value: function positionCaptions(shrinkRect) {
      var _a, _b;
      var _this$chartLike = this.chartLike,
        title = _this$chartLike.title,
        subtitle = _this$chartLike.subtitle,
        footnote = _this$chartLike.footnote;
      var newShrinkRect = shrinkRect.clone();
      var updateCaption = function updateCaption(caption) {
        var _a2;
        var defaultCaptionHeight = shrinkRect.height / 10;
        var captionLineHeight = (_a2 = caption.lineHeight) != null ? _a2 : caption.fontSize * _Text2.defaultLineHeightRatio;
        var maxWidth = shrinkRect.width;
        var maxHeight = Math.max(captionLineHeight, defaultCaptionHeight);
        caption.computeTextWrap(maxWidth, maxHeight);
      };
      var computeX = function computeX(align) {
        if (align === "left") {
          return newShrinkRect.x;
        } else if (align === "right") {
          return newShrinkRect.x + newShrinkRect.width;
        } else if (align !== "center") {
          _Logger.error("invalid textAlign value: ".concat(align));
        }
        return newShrinkRect.x + newShrinkRect.width / 2;
      };
      var positionTopAndShrinkBBox = function positionTopAndShrinkBBox(caption, spacing) {
        var baseY = newShrinkRect.y;
        caption.node.x = computeX(caption.textAlign);
        caption.node.y = baseY;
        caption.node.textBaseline = "top";
        updateCaption(caption);
        var bbox = caption.node.computeBBox();
        var bboxHeight = Math.ceil(bbox.y - baseY + bbox.height + spacing);
        newShrinkRect.shrink(bboxHeight, "top");
      };
      var positionBottomAndShrinkBBox = function positionBottomAndShrinkBBox(caption, spacing) {
        var baseY = newShrinkRect.y + newShrinkRect.height;
        caption.node.x = computeX(caption.textAlign);
        caption.node.y = baseY;
        caption.node.textBaseline = "bottom";
        updateCaption(caption);
        var bbox = caption.node.computeBBox();
        var bboxHeight = Math.ceil(baseY - bbox.y + spacing);
        newShrinkRect.shrink(bboxHeight, "bottom");
      };
      title.node.visible = title.enabled;
      subtitle.node.visible = subtitle.enabled;
      footnote.node.visible = footnote.enabled;
      if (title.enabled) {
        var _title$spacing = title.spacing,
          spacing = _title$spacing === void 0 ? subtitle.enabled ? _Caption3.SMALL_PADDING : _Caption3.LARGE_PADDING : _title$spacing;
        positionTopAndShrinkBBox(title, spacing);
      }
      if (subtitle.enabled) {
        positionTopAndShrinkBBox(subtitle, (_a = subtitle.spacing) != null ? _a : 0);
      }
      if (footnote.enabled) {
        positionBottomAndShrinkBBox(footnote, (_b = footnote.spacing) != null ? _b : 0);
      }
      return {
        shrinkRect: newShrinkRect
      };
    }
  }]);
  return BaseLayoutProcessor;
}();

// packages/ag-charts-community/src/chart/update/dataWindowProcessor.ts
var DataWindowProcessor = /*#__PURE__*/function () {
  function DataWindowProcessor(chart, dataService, updateService, zoomManager) {
    var _this107 = this;
    _classCallCheck(this, DataWindowProcessor);
    this.chart = chart;
    this.dataService = dataService;
    this.updateService = updateService;
    this.zoomManager = zoomManager;
    this.dirtyZoom = false;
    this.dirtyDataSource = false;
    this.lastAxisZooms = /* @__PURE__ */new Map();
    this.destroyFns = [];
    this.destroyFns.push(this.dataService.addListener("data-source-change", function () {
      return _this107.onDataSourceChange();
    }), this.dataService.addListener("data-load", function () {
      return _this107.onDataLoad();
    }), this.dataService.addListener("data-error", function () {
      return _this107.onDataError();
    }), this.updateService.addListener("update-complete", function () {
      return _this107.onUpdateComplete();
    }), this.zoomManager.addListener("zoom-change", function () {
      return _this107.onZoomChange();
    }));
  }
  _createClass(DataWindowProcessor, [{
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (cb) {
        return cb();
      });
    }
  }, {
    key: "onDataLoad",
    value: function onDataLoad() {
      this.updateService.update(1 /* UPDATE_DATA */);
    }
  }, {
    key: "onDataError",
    value: function onDataError() {
      this.updateService.update(3 /* PERFORM_LAYOUT */);
    }
  }, {
    key: "onDataSourceChange",
    value: function onDataSourceChange() {
      this.dirtyDataSource = true;
    }
  }, {
    key: "onUpdateComplete",
    value: function onUpdateComplete() {
      if (!this.dirtyZoom && !this.dirtyDataSource) return;
      this.updateWindow().catch(function (e) {
        return _Logger.errorOnce(e);
      });
    }
  }, {
    key: "onZoomChange",
    value: function onZoomChange() {
      this.dirtyZoom = true;
    }
  }, {
    key: "updateWindow",
    value: function updateWindow() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee10() {
        var axis, window2, shouldRefresh, zoom2;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              if (this.dataService.isLazy()) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2);
            case 1:
              axis = this.getValidAxis();
              shouldRefresh = true;
              if (axis) {
                zoom2 = this.zoomManager.getAxisZoom(axis.id);
                window2 = this.getAxisWindow(axis, zoom2);
                shouldRefresh = this.shouldRefresh(axis, zoom2);
              }
              this.dirtyZoom = false;
              this.dirtyDataSource = false;
              if (shouldRefresh) {
                _context19.n = 2;
                break;
              }
              return _context19.a(2);
            case 2:
              this.dataService.load({
                windowStart: window2 == null ? void 0 : window2.min,
                windowEnd: window2 == null ? void 0 : window2.max
              });
            case 3:
              return _context19.a(2);
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "getValidAxis",
    value: function getValidAxis() {
      return this.chart.axes.find(function (axis) {
        return axis.type === "time";
      });
    }
  }, {
    key: "shouldRefresh",
    value: function shouldRefresh(axis, zoom2) {
      if (this.dirtyDataSource) return true;
      if (!this.dirtyZoom) return false;
      var lastZoom = this.lastAxisZooms.get(axis.id);
      if (lastZoom && zoom2.min === lastZoom.min && zoom2.max === lastZoom.max) {
        return false;
      }
      this.lastAxisZooms.set(axis.id, zoom2);
      return true;
    }
  }, {
    key: "getAxisWindow",
    value: function getAxisWindow(axis, zoom2) {
      var _a, _b;
      var domain = (_b = (_a = axis.scale).getDomain) == null ? void 0 : _b.call(_a);
      if (!zoom2 || !domain || domain.length === 0 || isNaN(Number(domain[0]))) return;
      var diff2 = Number(domain[1]) - Number(domain[0]);
      var min = new Date(Number(domain[0]) + diff2 * zoom2.min);
      var max = new Date(Number(domain[0]) + diff2 * zoom2.max);
      return {
        min: min,
        max: max
      };
    }
  }]);
  return DataWindowProcessor;
}();

// packages/ag-charts-community/src/chart/update/overlaysProcessor.ts
var OverlaysProcessor = /*#__PURE__*/function () {
  function OverlaysProcessor(chartLike, overlays, dataService, layoutService, animationManager) {
    var _this108 = this;
    _classCallCheck(this, OverlaysProcessor);
    this.chartLike = chartLike;
    this.overlays = overlays;
    this.dataService = dataService;
    this.layoutService = layoutService;
    this.animationManager = animationManager;
    this.destroyFns = [];
    this.destroyFns.push(this.layoutService.addListener("layout-complete", function (e) {
      return _this108.onLayoutComplete(e);
    }));
  }
  _createClass(OverlaysProcessor, [{
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (cb) {
        return cb();
      });
    }
  }, {
    key: "onLayoutComplete",
    value: function onLayoutComplete(_ref110) {
      var rect = _ref110.series.rect;
      var isLoading = this.dataService.isLoading();
      var hasData = this.chartLike.series.some(function (s) {
        return s.hasData;
      });
      var anySeriesVisible = this.chartLike.series.some(function (s) {
        return s.visible;
      });
      this.toggleOverlay(this.overlays.loading, rect, isLoading);
      this.toggleOverlay(this.overlays.noData, rect, !isLoading && !hasData);
      this.toggleOverlay(this.overlays.noVisibleSeries, rect, hasData && !anySeriesVisible);
    }
  }, {
    key: "toggleOverlay",
    value: function toggleOverlay(overlay, seriesRect, visible) {
      if (visible) {
        var element2 = overlay.getElement(this.animationManager, seriesRect);
        this.chartLike.element.append(element2);
      } else {
        overlay.removeElement(this.animationManager);
      }
    }
  }]);
  return OverlaysProcessor;
}();

// packages/ag-charts-community/src/chart/chart.ts
var debug = Debug.create(true, "opts");
var SeriesArea = /*#__PURE__*/function (_BaseProperties11) {
  _inherits(SeriesArea, _BaseProperties11);
  function SeriesArea() {
    var _this109;
    _classCallCheck(this, SeriesArea);
    _this109 = _possibleConstructorReturn(this, _getPrototypeOf(SeriesArea).apply(this, arguments));
    _this109.padding = new _Padding(0);
    return _this109;
  }
  return SeriesArea;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], SeriesArea.prototype, "clip", 2);
__decorateClass([_Validate(_OBJECT)], SeriesArea.prototype, "padding", 2);
var _Chart = /*#__PURE__*/function (_Observable2) {
  _inherits(_Chart, _Observable2);
  function _Chart(options, resources) {
    var _this110;
    _classCallCheck(this, _Chart);
    var _a, _b, _c;
    _this110 = _possibleConstructorReturn(this, _getPrototypeOf(_Chart).call(this));
    _this110.id = _createId(_assertThisInitialized(_this110));
    _this110.seriesRoot = new _Group4({
      name: "".concat(_this110.id, "-series-root")
    });
    _this110.highlightRoot = new _Group4({
      name: "".concat(_this110.id, "-highlight-root"),
      layer: true,
      zIndex: 5 /* SERIES_HIGHLIGHT_ZINDEX */,
      nonEmptyChildDerivedZIndex: true
    });
    _this110.annotationRoot = new _Group4({
      name: "".concat(_this110.id, "-annotation-root"),
      layer: true,
      zIndex: 10 /* SERIES_ANNOTATION_ZINDEX */
    });
    _this110.debug = Debug.create();
    _this110.extraDebugStats = {};
    _this110.data = [];
    _this110._firstAutoSize = true;
    _this110.padding = new _Padding(20);
    _this110.seriesArea = new SeriesArea();
    _this110.title = new _Caption3();
    _this110.subtitle = new _Caption3();
    _this110.footnote = new _Caption3();
    _this110.keyboard = new Keyboard();
    _this110.mode = "standalone";
    _this110.destroyed = false;
    _this110._skipSync = false;
    _this110._destroyFns = [];
    _this110.chartAnimationPhase = "initial";
    _this110.modulesManager = new ModulesManager();
    // FIXME: zoomManager should be owned by ctx, but it can't because it is used by CartesianChart.onAxisChange before ctx is initialised
    _this110.zoomManager = new _ZoomManager();
    _this110.processors = [];
    _this110.processedOptions = {};
    _this110.userOptions = {};
    _this110.queuedUserOptions = [];
    _this110._pendingFactoryUpdatesCount = 0;
    _this110._performUpdateNoRenderCount = 0;
    _this110._performUpdateSkipAnimations = false;
    _this110.performUpdateType = 7 /* NONE */;
    _this110.updateShortcutCount = 0;
    _this110.seriesToUpdate = /* @__PURE__ */new Set();
    _this110.updateMutex = new Mutex();
    _this110.updateRequestors = {};
    _this110.performUpdateTrigger = debouncedCallback(function (_0) {
      return __async(_assertThisInitialized(_this110), [_0], function (_ref111) {
        var _this111 = this;
        var count = _ref111.count;
        return /*#__PURE__*/_regenerator().m(function _callee12() {
          return _regenerator().w(function (_context21) {
            while (1) switch (_context21.n) {
              case 0:
                if (!_this111.destroyed) {
                  _context21.n = 1;
                  break;
                }
                return _context21.a(2);
              case 1:
                _this111.updateMutex.acquire(function () {
                  return __async(_this111, null, /*#__PURE__*/_regenerator().m(function _callee11() {
                    var _t9;
                    return _regenerator().w(function (_context20) {
                      while (1) switch (_context20.p = _context20.n) {
                        case 0:
                          _context20.p = 0;
                          _context20.n = 1;
                          return this.performUpdate(count);
                        case 1:
                          _context20.n = 3;
                          break;
                        case 2:
                          _context20.p = 2;
                          _t9 = _context20.v;
                          _Logger.error("update error", _t9);
                        case 3:
                          return _context20.a(2);
                      }
                    }, _callee11, this, [[0, 2]]);
                  }));
                }).catch(function (e) {
                  return _Logger.errorOnce(e);
                });
              case 2:
                return _context21.a(2);
            }
          }, _callee12);
        })();
      });
    });
    _this110._performUpdateSplits = {};
    _this110.axes = [];
    _this110.series = [];
    _this110.focus = {
      hasFocus: false,
      series: void 0,
      seriesIndex: 0,
      datumIndex: 0,
      datum: void 0
    };
    _this110.pointerScheduler = debouncedAnimationFrame(function () {
      if (!_this110.lastInteractionEvent) return;
      if (_this110.performUpdateType <= 4 /* SERIES_UPDATE */) {
        _this110.pointerScheduler.schedule();
        return;
      }
      _this110.handlePointer(_this110.lastInteractionEvent, false);
      _this110.lastInteractionEvent = void 0;
    });
    _this110.onSeriesNodeClick = function (event) {
      var seriesNodeClickEvent = __spreadProps(__spreadValues({}, event), {
        type: "seriesNodeClick"
      });
      Object.defineProperty(seriesNodeClickEvent, "series", {
        enumerable: false,
        // Should display the deprecation warning
        get: function get() {
          return event.series;
        }
      });
      _this110.fireEvent(seriesNodeClickEvent);
    };
    _this110.onSeriesNodeDoubleClick = function (event) {
      var seriesNodeDoubleClick = __spreadProps(__spreadValues({}, event), {
        type: "seriesNodeDoubleClick"
      });
      _this110.fireEvent(seriesNodeDoubleClick);
    };
    _this110.seriesGroupingChanged = function (event) {
      if (!(event instanceof _SeriesGroupingChangedEvent)) return;
      var series = event.series,
        seriesGrouping = event.seriesGrouping,
        oldGrouping = event.oldGrouping;
      if (series.rootGroup.parent == null) return;
      _this110.seriesLayerManager.changeGroup({
        internalId: series.internalId,
        type: series.type,
        rootGroup: series.rootGroup,
        highlightGroup: series.highlightGroup,
        annotationGroup: series.annotationGroup,
        getGroupZIndexSubOrder: function getGroupZIndexSubOrder(type) {
          return series.getGroupZIndexSubOrder(type);
        },
        seriesGrouping: seriesGrouping,
        oldGrouping: oldGrouping
      });
    };
    _this110.dataProcessListeners = /* @__PURE__ */new Set();
    _this110.chartOptions = options;
    var scene = resources == null ? void 0 : resources.scene;
    var element2 = (_a = resources == null ? void 0 : resources.element) != null ? _a : _createElement("div", "ag-chart-wrapper", {
      position: "relative",
      userSelect: "none"
    });
    var container = resources == null ? void 0 : resources.container;
    _this110.element = element2;
    var root = new _Group4({
      name: "root"
    });
    root.visible = false;
    root.append(_this110.seriesRoot);
    root.append(_this110.highlightRoot);
    root.append(_this110.annotationRoot);
    _this110.axisGridGroup = new _Group4({
      name: "Axes-Grids",
      layer: true,
      zIndex: 1 /* AXIS_GRID_ZINDEX */
    });
    root.appendChild(_this110.axisGridGroup);
    _this110.axisGroup = new _Group4({
      name: "Axes",
      layer: true,
      zIndex: 2 /* AXIS_ZINDEX */
    });
    root.appendChild(_this110.axisGroup);
    _this110.sizeMonitor = new SizeMonitor();
    _this110.sizeMonitor.observe(_this110.element, function (size) {
      return _this110.rawResize(size);
    });
    var overrideDevicePixelRatio = options.specialOverrides.overrideDevicePixelRatio;
    scene != null ? scene : scene = new _Scene({
      pixelRatio: overrideDevicePixelRatio,
      canvasPosition: "absolute"
    });
    scene.setRoot(root).setContainer(element2);
    _this110.autoSize = true;
    _this110.tooltip = new _Tooltip();
    _this110.seriesLayerManager = new SeriesLayerManager(_this110.seriesRoot, _this110.highlightRoot, _this110.annotationRoot);
    var ctx = _this110.ctx = new ChartContext(_assertThisInitialized(_this110), {
      scene: scene,
      syncManager: new SyncManager(_assertThisInitialized(_this110)),
      element: element2,
      updateCallback: function updateCallback() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var opts = arguments.length > 1 ? arguments[1] : undefined;
        return _this110.update(type, opts);
      },
      updateMutex: _this110.updateMutex
    });
    _this110.overlays = new ChartOverlays();
    (_c = (_b = _this110.overlays.loading).renderer) != null ? _c : _b.renderer = function () {
      return getLoadingSpinner(_this110.overlays.loading.getText(), ctx.animationManager.defaultDuration);
    };
    _this110.processors = [new BaseLayoutProcessor(_assertThisInitialized(_this110), ctx.layoutService), new DataWindowProcessor(_assertThisInitialized(_this110), ctx.dataService, ctx.updateService, ctx.zoomManager), new OverlaysProcessor(_assertThisInitialized(_this110), _this110.overlays, ctx.dataService, ctx.layoutService, ctx.animationManager)];
    _this110.highlight = new ChartHighlight();
    _this110.container = container;
    var All = _InteractionState.All;
    var moduleContext = _this110.getModuleContext();
    var seriesRegion = ctx.regionManager.addRegion("series", _this110.seriesRoot, _this110.axisGroup);
    ctx.regionManager.addRegion("root", root);
    _this110._destroyFns.push(ctx.dataService.addListener("data-load", function (event) {
      _this110.data = event.data;
    }), ctx.scene.attachNode(_this110.title.node), ctx.scene.attachNode(_this110.subtitle.node), ctx.scene.attachNode(_this110.footnote.node), _this110.title.registerInteraction(moduleContext, "title"), _this110.subtitle.registerInteraction(moduleContext, "subtitle"), _this110.footnote.registerInteraction(moduleContext, "footnote"), ctx.interactionManager.addListener("click", function (event) {
      return _this110.onClick(event);
    }), ctx.interactionManager.addListener("dblclick", function (event) {
      return _this110.onDoubleClick(event);
    }), seriesRegion.addListener("hover", function (event) {
      return _this110.onMouseMove(event);
    }), seriesRegion.addListener("leave", function (event) {
      return _this110.onLeave(event);
    }), seriesRegion.addListener("blur", function () {
      return _this110.onBlur();
    }), seriesRegion.addListener("tab", function (event) {
      return _this110.onTab(event);
    }), seriesRegion.addListener("nav-vert", function (event) {
      return _this110.onNavVert(event);
    }), seriesRegion.addListener("nav-hori", function (event) {
      return _this110.onNavHori(event);
    }), seriesRegion.addListener("submit", function (event) {
      return _this110.onSubmit(event);
    }), ctx.keyNavManager.addListener("browserfocus", function (event) {
      return _this110.onBrowserFocus(event);
    }), ctx.interactionManager.addListener("page-left", function () {
      return _this110.destroy();
    }), ctx.interactionManager.addListener("contextmenu", function (event) {
      return _this110.onContextMenu(event);
    }, All), ctx.animationManager.addListener("animation-start", function () {
      return _this110.onAnimationStart();
    }), ctx.animationManager.addListener("animation-frame", function () {
      _this110.update(6 /* SCENE_RENDER */);
    }), ctx.highlightManager.addListener("highlight-change", function (event) {
      return _this110.changeHighlightDatum(event);
    }), ctx.zoomManager.addListener("zoom-pan-start", function () {
      return _this110.resetPointer();
    }), ctx.zoomManager.addListener("zoom-change", function () {
      _this110.resetPointer();
      _this110.series.map(function (s) {
        var _a2;
        return (_a2 = s.animationState) == null ? void 0 : _a2.transition("updateData");
      });
      var skipAnimations = _this110.chartAnimationPhase !== "initial";
      _this110.update(3 /* PERFORM_LAYOUT */, {
        forceNodeDataRefresh: true,
        skipAnimations: skipAnimations
      });
    }));
    return _this110;
  }
  _createClass(_Chart, [{
    key: "getCanvasDataURL",
    /** NOTE: This is exposed for use by Integrated charts only. */value: function getCanvasDataURL(fileFormat) {
      return this.ctx.scene.getDataURL(fileFormat);
    }
  }, {
    key: "onAutoSizeChange",
    value: function onAutoSizeChange(value) {
      var style = this.element.style;
      if (value) {
        style.display = "block";
        style.width = "100%";
        style.height = "100%";
        if (!this._lastAutoSize) {
          return;
        }
        this.resize(void 0, void 0, "autoSize option");
      } else {
        style.display = "inline-block";
        style.width = "auto";
        style.height = "auto";
      }
    }
  }, {
    key: "download",
    value: function download(fileName, fileFormat) {
      this.ctx.scene.download(fileName, fileFormat);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _a;
      return (_a = this.queuedUserOptions.at(-1)) != null ? _a : this.userOptions;
    }
  }, {
    key: "getModuleContext",
    value: function getModuleContext() {
      return this.ctx;
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel() {
      var _a;
      var captionText = [this.title, this.subtitle, this.footnote].filter(function (caption) {
        return caption.enabled && caption.text;
      }).map(function (caption) {
        return caption.text;
      }).join(". ");
      var nSeries = (_a = this.series.length) != null ? _a : 0;
      return "chart, ".concat(nSeries, " series, ").concat(captionText);
    }
  }, {
    key: "resetAnimations",
    value: function resetAnimations() {
      this.chartAnimationPhase = "initial";
      var _iterator165 = _createForOfIteratorHelper(this.series),
        _step165;
      try {
        for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
          var series = _step165.value;
          series.resetAnimation(this.chartAnimationPhase);
        }
      } catch (err) {
        _iterator165.e(err);
      } finally {
        _iterator165.f();
      }
      var _iterator166 = _createForOfIteratorHelper(this.axes),
        _step166;
      try {
        for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
          var axis = _step166.value;
          axis.resetAnimation(this.chartAnimationPhase);
        }
      } catch (err) {
        _iterator166.e(err);
      } finally {
        _iterator166.f();
      }
      this.animationRect = void 0;
      this.ctx.animationManager.reset();
    }
  }, {
    key: "skipAnimations",
    value: function skipAnimations() {
      this.ctx.animationManager.skipCurrentBatch();
      this._performUpdateSkipAnimations = true;
    }
  }, {
    key: "destroy",
    value: function destroy(opts) {
      if (this.destroyed) {
        return;
      }
      var keepTransferableResources = opts == null ? void 0 : opts.keepTransferableResources;
      var result;
      this.performUpdateType = 7 /* NONE */;
      this._destroyFns.forEach(function (fn) {
        return fn();
      });
      this.processors.forEach(function (p) {
        return p.destroy();
      });
      this.tooltip.destroy();
      this.overlays.destroy();
      this.sizeMonitor.unobserve(this.element);
      this.modulesManager.destroy();
      if (keepTransferableResources) {
        this.ctx.scene.strip();
        result = {
          container: this.container,
          scene: this.ctx.scene,
          element: this.element
        };
      } else {
        this.ctx.scene.destroy();
        this.container = void 0;
      }
      this.destroySeries(this.series);
      this.seriesLayerManager.destroy();
      this.axes.forEach(function (a) {
        return a.destroy();
      });
      this.axes = [];
      this.animationRect = void 0;
      this.ctx.destroy();
      this.zoomManager.destroy();
      this.destroyed = true;
      Object.freeze(this);
      return result;
    }
  }, {
    key: "resetPointer",
    value: function resetPointer() {
      var highlightOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!highlightOnly) {
        this.ctx.tooltipManager.removeTooltip(this.id);
      }
      this.ctx.highlightManager.updateHighlight(this.id);
      this.lastInteractionEvent = void 0;
    }
  }, {
    key: "requestFactoryUpdate",
    value: function requestFactoryUpdate(cb) {
      var _this112 = this;
      if (this.destroyed) return;
      this._pendingFactoryUpdatesCount++;
      this.updateMutex.acquire(function () {
        return __async(_this112, null, /*#__PURE__*/_regenerator().m(function _callee13() {
          return _regenerator().w(function (_context22) {
            while (1) switch (_context22.n) {
              case 0:
                if (!this.destroyed) {
                  _context22.n = 1;
                  break;
                }
                return _context22.a(2);
              case 1:
                _context22.n = 2;
                return cb(this);
              case 2:
                if (!this.destroyed) {
                  _context22.n = 3;
                  break;
                }
                return _context22.a(2);
              case 3:
                this._pendingFactoryUpdatesCount--;
              case 4:
                return _context22.a(2);
            }
          }, _callee13, this);
        }));
      }).catch(function (e) {
        return _Logger.errorOnce(e);
      });
    }
  }, {
    key: "update",
    value: function update() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var opts = arguments.length > 1 ? arguments[1] : undefined;
      var _a, _b;
      var _ref112 = opts != null ? opts : {},
        _ref112$forceNodeData = _ref112.forceNodeDataRefresh,
        forceNodeDataRefresh = _ref112$forceNodeData === void 0 ? false : _ref112$forceNodeData,
        skipAnimations = _ref112.skipAnimations,
        _ref112$seriesToUpdat = _ref112.seriesToUpdate,
        seriesToUpdate = _ref112$seriesToUpdat === void 0 ? this.series : _ref112$seriesToUpdat,
        newAnimationBatch = _ref112.newAnimationBatch;
      if (forceNodeDataRefresh) {
        this.series.forEach(function (series) {
          return series.markNodeDataDirty();
        });
      }
      var _iterator167 = _createForOfIteratorHelper(seriesToUpdate),
        _step167;
      try {
        for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
          var series = _step167.value;
          this.seriesToUpdate.add(series);
        }
      } catch (err) {
        _iterator167.e(err);
      } finally {
        _iterator167.f();
      }
      if (skipAnimations) {
        this.ctx.animationManager.skipCurrentBatch();
        this._performUpdateSkipAnimations = true;
      }
      if (newAnimationBatch && this.ctx.animationManager.isActive()) {
        this._performUpdateSkipAnimations = true;
      }
      this._skipSync = (_a = opts == null ? void 0 : opts.skipSync) != null ? _a : false;
      if (this.debug.check()) {
        var stack = (_b = new Error().stack) != null ? _b : "<unknown>";
        stack = stack.replace(/\([^)]*/g, "");
        this.updateRequestors[stack] = type;
      }
      if (type < this.performUpdateType) {
        this.performUpdateType = type;
        this.performUpdateTrigger.schedule(opts == null ? void 0 : opts.backOffMs);
      }
    }
  }, {
    key: "performUpdate",
    value: function performUpdate(count) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee14() {
        var _this113 = this;
        var _a, performUpdateType, extraDebugStats, splits, ctx, seriesToUpdate, previousSplit, updateSplits, updateDeferred, seriesRect, tooltipMeta, key, end, _t0;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              performUpdateType = this.performUpdateType, extraDebugStats = this.extraDebugStats, splits = this._performUpdateSplits, ctx = this.ctx;
              seriesToUpdate = _toConsumableArray(this.seriesToUpdate);
              this.performUpdateType = 7 /* NONE */;
              this.seriesToUpdate.clear();
              if (this.updateShortcutCount === 0 && performUpdateType < 6 /* SCENE_RENDER */) {
                ctx.animationManager.startBatch(this._performUpdateSkipAnimations);
                ctx.animationManager.onBatchStop(function () {
                  return _this113.chartAnimationPhase = "ready";
                });
              }
              this.debug("Chart.performUpdate() - start", _ChartUpdateType[performUpdateType]);
              previousSplit = performance.now();
              (_a = splits.start) != null ? _a : splits.start = previousSplit;
              updateSplits = function updateSplits(splitName) {
                var _a2;
                (_a2 = splits[splitName]) != null ? _a2 : splits[splitName] = 0;
                splits[splitName] += performance.now() - previousSplit;
                previousSplit = performance.now();
              };
              updateDeferred = false;
              _t0 = performUpdateType;
              _context23.n = _t0 === 0 /* FULL */ ? 1 : _t0 === 1 /* UPDATE_DATA */ ? 2 : _t0 === 2 /* PROCESS_DATA */ ? 4 : _t0 === 3 /* PERFORM_LAYOUT */ ? 6 : _t0 === 4 /* SERIES_UPDATE */ ? 10 : _t0 === 5 /* TOOLTIP_RECALCULATION */ ? 13 : _t0 === 6 /* SCENE_RENDER */ ? 15 : _t0 === 7 /* NONE */ ? 18 : 19;
              break;
            case 1:
              this.updateDOM();
            case 2:
              _context23.n = 3;
              return this.updateData();
            case 3:
              updateSplits("\u2B07\uFE0F");
            case 4:
              _context23.n = 5;
              return this.processData();
            case 5:
              this.resetPointer(true);
              updateSplits("\uD83C\uDFED");
            case 6:
              if (!this.checkUpdateShortcut(3 /* PERFORM_LAYOUT */)) {
                _context23.n = 7;
                break;
              }
              return _context23.a(3, 19);
            case 7:
              if (this.checkFirstAutoSize(seriesToUpdate)) {
                _context23.n = 8;
                break;
              }
              updateDeferred = true;
              return _context23.a(3, 19);
            case 8:
              _context23.n = 9;
              return this.processLayout();
            case 9:
              updateSplits("\u2316");
            case 10:
              if (!this.checkUpdateShortcut(4 /* SERIES_UPDATE */)) {
                _context23.n = 11;
                break;
              }
              return _context23.a(3, 19);
            case 11:
              seriesRect = this.seriesRect;
              _context23.n = 12;
              return Promise.all(seriesToUpdate.map(function (series) {
                return series.update({
                  seriesRect: seriesRect
                });
              }));
            case 12:
              updateSplits("\uD83E\uDD14");
            case 13:
              if (!this.checkUpdateShortcut(5 /* TOOLTIP_RECALCULATION */)) {
                _context23.n = 14;
                break;
              }
              return _context23.a(3, 19);
            case 14:
              tooltipMeta = ctx.tooltipManager.getTooltipMeta(this.id);
              if (performUpdateType <= 4 /* SERIES_UPDATE */ && (tooltipMeta == null ? void 0 : tooltipMeta.lastPointerEvent) != null) {
                this.handlePointer(tooltipMeta.lastPointerEvent, true);
              }
              updateSplits("\u2196");
            case 15:
              if (!this.checkUpdateShortcut(6 /* SCENE_RENDER */)) {
                _context23.n = 16;
                break;
              }
              return _context23.a(3, 19);
            case 16:
              ctx.animationManager.endBatch();
              extraDebugStats["updateShortcutCount"] = this.updateShortcutCount;
              _context23.n = 17;
              return ctx.scene.render({
                debugSplitTimes: splits,
                extraDebugStats: extraDebugStats
              });
            case 17:
              this.ctx.regionManager.updateFocusWrapperRect();
              this.extraDebugStats = {};
              for (key in splits) {
                delete splits[key];
              }
            case 18:
              this.updateShortcutCount = 0;
              this.updateRequestors = {};
              this._performUpdateSkipAnimations = false;
              ctx.animationManager.endBatch();
            case 19:
              if (!updateDeferred) {
                ctx.updateService.dispatchUpdateComplete(this.getMinRects());
              }
              end = performance.now();
              this.debug("Chart.performUpdate() - end", {
                chart: this,
                durationMs: Math.round((end - splits["start"]) * 100) / 100,
                count: count,
                performUpdateType: _ChartUpdateType[performUpdateType]
              });
            case 20:
              return _context23.a(2);
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "updateThemeClassName",
    value: function updateThemeClassName() {
      var element2 = this.element,
        theme = this.processedOptions.theme;
      var themeClassNamePrefix = "ag-charts-theme-";
      var validThemeClassNames = ["".concat(themeClassNamePrefix, "default"), "".concat(themeClassNamePrefix, "default-dark")];
      var themeClassName = validThemeClassNames[0];
      var isDark = false;
      if (typeof theme === "string") {
        themeClassName = theme.replace("ag-", themeClassNamePrefix);
        isDark = theme.includes("-dark");
      } else if (typeof (theme == null ? void 0 : theme.baseTheme) === "string") {
        themeClassName = theme.baseTheme.replace("ag-", themeClassNamePrefix);
        isDark = theme.baseTheme.includes("-dark");
      }
      if (!validThemeClassNames.includes(themeClassName)) {
        themeClassName = isDark ? validThemeClassNames[1] : validThemeClassNames[0];
      }
      element2.classList.forEach(function (className) {
        if (className.startsWith(themeClassNamePrefix) && className !== themeClassName) {
          element2.classList.remove(className);
        }
      });
      element2.classList.add(themeClassName);
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      this.updateThemeClassName();
      var _this$keyboard = this.keyboard,
        enabled = _this$keyboard.enabled,
        tabIndex = _this$keyboard.tabIndex;
      this.element.tabIndex = enabled ? tabIndex != null ? tabIndex : 0 : -1;
      _setAttribute(this.ctx.scene.canvas.element, "role", "figure");
      _setAttribute(this.ctx.scene.canvas.element, "aria-label", this.getAriaLabel());
    }
  }, {
    key: "checkUpdateShortcut",
    value: function checkUpdateShortcut(checkUpdateType) {
      var maxShortcuts = 3;
      if (this.updateShortcutCount > maxShortcuts) {
        _Logger.warn("exceeded the maximum number of simultaneous updates (".concat(maxShortcuts + 1, "), discarding changes and rendering"), this.updateRequestors);
        return false;
      }
      if (this.performUpdateType <= checkUpdateType) {
        this.updateShortcutCount++;
        return true;
      }
      return false;
    }
  }, {
    key: "checkFirstAutoSize",
    value: function checkFirstAutoSize(seriesToUpdate) {
      if (this.autoSize && !this._lastAutoSize) {
        var count = this._performUpdateNoRenderCount++;
        var backOffMs = __pow(count + 1, 2) * 40;
        if (count < 8) {
          this.update(3 /* PERFORM_LAYOUT */, {
            seriesToUpdate: seriesToUpdate,
            backOffMs: backOffMs
          });
          this.debug("Chart.checkFirstAutoSize() - backing off until first size update", backOffMs);
          return false;
        }
        this.debug("Chart.checkFirstAutoSize() - timeout for first size update.");
      }
      this._performUpdateNoRenderCount = 0;
      return true;
    }
  }, {
    key: "onAxisChange",
    value: function onAxisChange(newValue) {
      var oldValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _iterator168 = _createForOfIteratorHelper(oldValue),
        _step168;
      try {
        for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
          var axis = _step168.value;
          if (newValue.includes(axis)) continue;
          axis.detachAxis(this.axisGroup, this.axisGridGroup);
          axis.destroy();
        }
      } catch (err) {
        _iterator168.e(err);
      } finally {
        _iterator168.f();
      }
      var _iterator169 = _createForOfIteratorHelper(newValue),
        _step169;
      try {
        for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
          var _axis = _step169.value;
          if (oldValue == null ? void 0 : oldValue.includes(_axis)) continue;
          _axis.attachAxis(this.axisGroup, this.axisGridGroup);
        }
      } catch (err) {
        _iterator169.e(err);
      } finally {
        _iterator169.f();
      }
    }
  }, {
    key: "onSeriesChange",
    value: function onSeriesChange(newValue, oldValue) {
      var _this114 = this;
      var _a, _b;
      var seriesToDestroy = (_a = oldValue == null ? void 0 : oldValue.filter(function (series) {
        return !newValue.includes(series);
      })) != null ? _a : [];
      this.destroySeries(seriesToDestroy);
      (_b = this.seriesLayerManager) == null ? void 0 : _b.setSeriesCount(newValue.length);
      var _iterator170 = _createForOfIteratorHelper(newValue),
        _step170;
      try {
        var _loop12 = function _loop12() {
          var series = _step170.value;
          if (oldValue == null ? void 0 : oldValue.includes(series)) return 1; // continue
          if (series.rootGroup.parent == null) {
            _this114.seriesLayerManager.requestGroup(series);
          }
          var chart = _this114;
          series.chart = {
            get mode() {
              return chart.mode;
            },
            get isMiniChart() {
              return false;
            },
            get seriesRect() {
              return chart.seriesRect;
            },
            placeLabels: function placeLabels() {
              return chart.placeLabels();
            }
          };
          series.resetAnimation(_this114.chartAnimationPhase);
          _this114.addSeriesListeners(series);
          series.addChartEventListeners();
        };
        for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
          if (_loop12()) continue;
        }
      } catch (err) {
        _iterator170.e(err);
      } finally {
        _iterator170.f();
      }
    }
  }, {
    key: "destroySeries",
    value: function destroySeries(allSeries) {
      var _this115 = this;
      allSeries == null ? void 0 : allSeries.forEach(function (series) {
        series.removeEventListener("nodeClick", _this115.onSeriesNodeClick);
        series.removeEventListener("nodeDoubleClick", _this115.onSeriesNodeDoubleClick);
        series.removeEventListener("groupingChanged", _this115.seriesGroupingChanged);
        series.destroy();
        _this115.seriesLayerManager.releaseGroup(series);
        series.chart = void 0;
      });
    }
  }, {
    key: "addSeriesListeners",
    value: function addSeriesListeners(series) {
      if (this.hasEventListener("seriesNodeClick")) {
        series.addEventListener("nodeClick", this.onSeriesNodeClick);
      }
      if (this.hasEventListener("seriesNodeDoubleClick")) {
        series.addEventListener("nodeDoubleClick", this.onSeriesNodeDoubleClick);
      }
      series.addEventListener("groupingChanged", this.seriesGroupingChanged);
    }
  }, {
    key: "updateAllSeriesListeners",
    value: function updateAllSeriesListeners() {
      var _this116 = this;
      this.series.forEach(function (series) {
        series.removeEventListener("nodeClick", _this116.onSeriesNodeClick);
        series.removeEventListener("nodeDoubleClick", _this116.onSeriesNodeDoubleClick);
        _this116.addSeriesListeners(series);
      });
    }
  }, {
    key: "assignSeriesToAxes",
    value: function assignSeriesToAxes() {
      var _this117 = this;
      this.axes.forEach(function (axis) {
        axis.boundSeries = _this117.series.filter(function (s) {
          var seriesAxis = s.axes[axis.direction];
          return seriesAxis === axis;
        });
      });
    }
  }, {
    key: "assignAxesToSeries",
    value: function assignAxesToSeries() {
      var directionToAxesMap = _groupBy2(this.axes, function (axis) {
        return axis.direction;
      });
      this.series.forEach(function (series) {
        series.directions.forEach(function (direction) {
          var directionAxes = directionToAxesMap[direction];
          if (!directionAxes) {
            _Logger.warnOnce("no available axis for direction [".concat(direction, "]; check series and axes configuration."));
            return;
          }
          var seriesKeys = series.getKeys(direction);
          var newAxis = directionAxes.find(function (axis) {
            return !axis.keys.length || seriesKeys.some(function (key) {
              return axis.keys.includes(key);
            });
          });
          if (!newAxis) {
            _Logger.warnOnce("no matching axis for direction [".concat(direction, "] and keys [").concat(seriesKeys, "]; check series and axes configuration."));
            return;
          }
          series.axes[direction] = newAxis;
        });
      });
    }
  }, {
    key: "rawResize",
    value: function rawResize(_ref113) {
      var width = _ref113.width,
        height = _ref113.height;
      var _a;
      if (!this.autoSize) return;
      width = Math.floor(width);
      height = Math.floor(height);
      if (width === 0 && height === 0) return;
      var _ref114 = (_a = this._lastAutoSize) != null ? _a : [],
        _ref115 = _slicedToArray(_ref114, 2),
        _ref115$ = _ref115[0],
        autoWidth = _ref115$ === void 0 ? 0 : _ref115$,
        _ref115$2 = _ref115[1],
        authHeight = _ref115$2 === void 0 ? 0 : _ref115$2;
      if (autoWidth === width && authHeight === height) return;
      this._lastAutoSize = [width, height];
      this.resize(void 0, void 0, "SizeMonitor");
    }
  }, {
    key: "resize",
    value: function resize(width, height, source) {
      var _a, _b, _c, _d;
      var _this$ctx = this.ctx,
        scene = _this$ctx.scene,
        animationManager = _this$ctx.animationManager;
      width != null ? width : width = (_b = this.width) != null ? _b : this.autoSize ? (_a = this._lastAutoSize) == null ? void 0 : _a[0] : scene.canvas.width;
      height != null ? height : height = (_d = this.height) != null ? _d : this.autoSize ? (_c = this._lastAutoSize) == null ? void 0 : _c[1] : scene.canvas.height;
      this.debug("Chart.resize() from ".concat(source), {
        width: width,
        height: height,
        stack: new Error().stack
      });
      if (!width || !height || !_isFiniteNumber(width) || !_isFiniteNumber(height)) return;
      if (scene.resize(width, height)) {
        this.resetPointer();
        animationManager.reset();
        var skipAnimations = true;
        if (this.autoSize && this._firstAutoSize) {
          skipAnimations = false;
          this._firstAutoSize = false;
        }
        this.update(3 /* PERFORM_LAYOUT */, {
          forceNodeDataRefresh: true,
          skipAnimations: skipAnimations
        });
      }
    }
  }, {
    key: "updateData",
    value: function updateData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee15() {
        var _this118 = this;
        var modulePromises;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              this.series.forEach(function (s) {
                return s.setChartData(_this118.data);
              });
              modulePromises = this.modulesManager.mapModules(function (m) {
                var _a;
                return (_a = m.updateData) == null ? void 0 : _a.call(m, {
                  data: _this118.data
                });
              });
              _context24.n = 1;
              return Promise.all(modulePromises);
            case 1:
              return _context24.a(2);
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "processData",
    value: function processData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee16() {
        var syncModule, dataController, seriesPromises, modulePromises, _iterator171, _step171, _step171$value, legendType, legend;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              if (this.series.some(function (s) {
                return s.canHaveAxes;
              })) {
                this.assignAxesToSeries();
                syncModule = this.modulesManager.getModule("sync");
                if (syncModule == null ? void 0 : syncModule.enabled) {
                  syncModule.syncAxes(this._skipSync);
                } else {
                  this.assignSeriesToAxes();
                }
              }
              dataController = new _DataController2(this.mode);
              seriesPromises = this.series.map(function (s) {
                return s.processData(dataController);
              });
              modulePromises = this.modulesManager.mapModules(function (m) {
                var _a;
                return (_a = m.processData) == null ? void 0 : _a.call(m, {
                  dataController: dataController
                });
              });
              dataController.execute();
              _context25.n = 1;
              return Promise.all([].concat(_toConsumableArray(seriesPromises), _toConsumableArray(modulePromises)));
            case 1:
              _iterator171 = _createForOfIteratorHelper(this.modulesManager.legends());
              try {
                for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
                  _step171$value = _step171.value, legendType = _step171$value.legendType, legend = _step171$value.legend;
                  legend.data = this.getLegendData(legendType, this.mode !== "integrated");
                }
              } catch (err) {
                _iterator171.e(err);
              } finally {
                _iterator171.f();
              }
              this.dataProcessListeners.forEach(function (resolve) {
                return resolve();
              });
              this.dataProcessListeners.clear();
            case 2:
              return _context25.a(2);
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "placeLabels",
    value: function placeLabels() {
      var visibleSeries = [];
      var data = [];
      var _iterator172 = _createForOfIteratorHelper(this.series),
        _step172;
      try {
        for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
          var series = _step172.value;
          if (!series.visible) continue;
          var labelData = series.getLabelData();
          if (isPointLabelDatum(labelData == null ? void 0 : labelData[0])) {
            data.push(labelData);
            visibleSeries.push(series);
          }
        }
      } catch (err) {
        _iterator172.e(err);
      } finally {
        _iterator172.f();
      }
      var seriesRect = this.seriesRect;
      var _this$seriesArea$padd = this.seriesArea.padding,
        top = _this$seriesArea$padd.top,
        right = _this$seriesArea$padd.right,
        bottom = _this$seriesArea$padd.bottom,
        left = _this$seriesArea$padd.left;
      var labels = seriesRect && data.length > 0 ? _placeLabels(data, {
        x: -left,
        y: -top,
        width: seriesRect.width + left + right,
        height: seriesRect.height + top + bottom
      }) : [];
      return new Map(labels.map(function (l, i) {
        return [visibleSeries[i], l];
      }));
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType, warnConflicts) {
      var _a, _b, _c;
      var legendData = this.series.filter(function (s) {
        return s.properties.showInLegend;
      }).flatMap(function (s) {
        return s.getLegendData(legendType);
      });
      var isCategoryLegendData = function isCategoryLegendData(data) {
        return data.every(function (d) {
          return d.legendType === "category";
        });
      };
      if (warnConflicts && isCategoryLegendData(legendData)) {
        var seriesMarkerFills = {};
        var seriesTypeMap = new Map(this.series.map(function (s) {
          return [s.id, s.type];
        }));
        var _iterator173 = _createForOfIteratorHelper(legendData),
          _step173;
        try {
          for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
            var _step173$value = _step173.value,
              seriesId = _step173$value.seriesId,
              marker = _step173$value.marker,
              label = _step173$value.label;
            if (marker.fill == null) continue;
            var seriesType = seriesTypeMap.get(seriesId);
            var markerFill = (_a = seriesMarkerFills[seriesType]) != null ? _a : seriesMarkerFills[seriesType] = {};
            (_c = markerFill[_b = label.text]) != null ? _c : markerFill[_b] = marker.fill;
            if (markerFill[label.text] !== marker.fill) {
              _Logger.warnOnce("legend item '".concat(label.text, "' has multiple fill colors, this may cause unexpected behaviour."));
            }
          }
        } catch (err) {
          _iterator173.e(err);
        } finally {
          _iterator173.f();
        }
      }
      return legendData;
    }
  }, {
    key: "processLayout",
    value: function processLayout() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee17() {
        var _a, oldRect;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              oldRect = this.animationRect;
              _context26.n = 1;
              return this.performLayout();
            case 1:
              if (oldRect && !((_a = this.animationRect) == null ? void 0 : _a.equals(oldRect))) {
                this.ctx.animationManager.skipCurrentBatch();
              }
              this.debug("Chart.performUpdate() - seriesRect", this.seriesRect);
            case 2:
              return _context26.a(2);
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "performLayout",
    value: function performLayout() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee19() {
        var _this119 = this;
        var _this$ctx$scene, width, height, ctx, modulePromises;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.n) {
            case 0:
              _this$ctx$scene = this.ctx.scene, width = _this$ctx$scene.width, height = _this$ctx$scene.height;
              ctx = {
                shrinkRect: new _BBox2(0, 0, width, height)
              };
              ctx = this.ctx.layoutService.dispatchPerformLayout("start-layout", ctx);
              ctx = this.ctx.layoutService.dispatchPerformLayout("before-series", ctx);
              modulePromises = this.modulesManager.mapModules(function (m) {
                return __async(_this119, null, /*#__PURE__*/_regenerator().m(function _callee18() {
                  return _regenerator().w(function (_context27) {
                    while (1) switch (_context27.n) {
                      case 0:
                        if (!(m.performLayout != null)) {
                          _context27.n = 2;
                          break;
                        }
                        _context27.n = 1;
                        return m.performLayout(ctx);
                      case 1:
                        ctx = _context27.v;
                      case 2:
                        return _context27.a(2);
                    }
                  }, _callee18);
                }));
              });
              _context28.n = 1;
              return Promise.all(modulePromises);
            case 1:
              return _context28.a(2, ctx.shrinkRect);
          }
        }, _callee19, this);
      }));
    } // x/y are local canvas coordinates in CSS pixels, not actual pixels
  }, {
    key: "pickSeriesNode",
    value: function pickSeriesNode(point, exactMatchOnly, maxDistance) {
      var _a, _b;
      var start = performance.now();
      var pickModes = exactMatchOnly ? [0 /* EXACT_SHAPE_MATCH */] : void 0;
      var reverseSeries = _toConsumableArray(this.series).reverse();
      var result;
      var _iterator174 = _createForOfIteratorHelper(reverseSeries),
        _step174;
      try {
        for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
          var series = _step174.value;
          if (!series.visible || !series.rootGroup.visible) {
            continue;
          }
          var _ref116 = (_a = series.pickNode(point, pickModes)) != null ? _a : {},
            match = _ref116.match,
            distance2 = _ref116.distance;
          if (!match || distance2 == null) {
            continue;
          }
          if ((!result || result.distance > distance2) && distance2 <= (maxDistance != null ? maxDistance : Infinity)) {
            result = {
              series: series,
              distance: distance2,
              datum: match
            };
          }
          if (distance2 === 0) {
            break;
          }
        }
      } catch (err) {
        _iterator174.e(err);
      } finally {
        _iterator174.f();
      }
      this.extraDebugStats["pickSeriesNode"] = Math.round(((_b = this.extraDebugStats["pickSeriesNode"]) != null ? _b : 0) + (performance.now() - start));
      return result;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      this.lastInteractionEvent = event;
      this.pointerScheduler.schedule();
      this.extraDebugStats["mouseX"] = event.offsetX;
      this.extraDebugStats["mouseY"] = event.offsetY;
      this.update(6 /* SCENE_RENDER */);
    }
  }, {
    key: "onLeave",
    value: function onLeave(event) {
      if (!this.tooltip.pointerLeftOntoTooltip(event)) {
        this.resetPointer();
        this.update(6 /* SCENE_RENDER */);
        this.ctx.cursorManager.updateCursor("chart");
      }
    }
  }, {
    key: "onBrowserFocus",
    value: function onBrowserFocus(event) {
      if (event.delta > 0) {
        this.focus.datum = void 0;
        this.focus.series = void 0;
        this.focus.datumIndex = 0;
        this.focus.seriesIndex = 0;
      } else {
        this.focus.datum = void 0;
        this.focus.series = void 0;
        this.focus.datumIndex = Infinity;
        this.focus.seriesIndex = Infinity;
      }
    }
  }, {
    key: "onAnimationStart",
    value: function onAnimationStart() {
      if (this.focus.hasFocus) {
        this.onBlur();
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.ctx.regionManager.updateFocusIndicatorRect(void 0);
      this.resetPointer();
      this.focus.hasFocus = false;
    }
  }, {
    key: "onTab",
    value: function onTab(event) {
      this.handleFocus();
      event.consume();
      this.focus.hasFocus = true;
    }
  }, {
    key: "onNavVert",
    value: function onNavVert(event) {
      this.focus.seriesIndex += event.delta;
      this.handleFocus();
      event.consume();
    }
  }, {
    key: "onNavHori",
    value: function onNavHori(event) {
      this.focus.datumIndex += event.delta;
      this.handleFocus(event.delta);
      event.consume();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var _this$focus = this.focus,
        series = _this$focus.series,
        datum = _this$focus.datum;
      var sourceEvent = event.sourceEvent.sourceEvent;
      if (series !== void 0 && datum !== void 0) {
        series.fireNodeClickEvent(sourceEvent, datum);
      } else {
        this.fireEvent({
          type: "click",
          event: sourceEvent
        });
      }
    }
  }, {
    key: "onContextMenu",
    value: function onContextMenu(event) {
      var _this120 = this;
      this.ctx.tooltipManager.removeTooltip(this.id);
      var Default2 = _InteractionState.Default,
        ContextMenu = _InteractionState.ContextMenu;
      if (this.ctx.interactionManager.getState() & (Default2 | ContextMenu)) {
        this.checkSeriesNodeRange(event, function () {
          _this120.ctx.highlightManager.updateHighlight(_this120.id);
        });
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(datumIndexDelta) {
      this.focus.hasFocus = true;
      var overlayFocus = this.overlays.getFocusInfo();
      if (overlayFocus == null) {
        this.handleSeriesFocus(datumIndexDelta != null ? datumIndexDelta : 0);
      } else {
        this.ctx.regionManager.updateFocusIndicatorRect(overlayFocus.rect);
        this.ctx.ariaAnnouncementService.announceValue(overlayFocus.text);
      }
    }
  }, {
    key: "handleSeriesFocus",
    value: function handleSeriesFocus(datumIndexDelta) {
      var series = this.series,
        seriesRect = this.seriesRect,
        focus = this.focus;
      var visibleSeries = series.filter(function (s) {
        return s.visible;
      });
      if (visibleSeries.length === 0) return;
      focus.seriesIndex = _clamp(0, focus.seriesIndex, visibleSeries.length - 1);
      focus.series = visibleSeries[focus.seriesIndex];
      var pick = focus.series.pickFocus({
        datumIndex: focus.datumIndex,
        datumIndexDelta: datumIndexDelta,
        seriesRect: seriesRect
      });
      if (pick === void 0) return;
      var datum = pick.datum,
        datumIndex = pick.datumIndex;
      focus.datumIndex = datumIndex;
      focus.datum = datum;
      var keyboardEvent = makeKeyboardPointerEvent(this.ctx.regionManager, pick);
      if (keyboardEvent !== void 0) {
        this.lastInteractionEvent = keyboardEvent;
        var html = focus.series.getTooltipHtml(datum);
        var meta = _TooltipManager.makeTooltipMeta(this.lastInteractionEvent, datum);
        this.ctx.highlightManager.updateHighlight(this.id, datum);
        this.ctx.tooltipManager.updateTooltip(this.id, meta, html);
        this.ctx.ariaAnnouncementService.announceValue(html.ariaLabel);
      }
    }
  }, {
    key: "handlePointer",
    value: function handlePointer(event, redisplay) {
      var _this121 = this;
      if (this.ctx.interactionManager.getState() !== 16 /* Default */ || !_Chart.isHoverEvent(event)) {
        return;
      }
      var lastPick = this.lastPick,
        hoverRect = this.hoverRect;
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      var disablePointer = function disablePointer() {
        var highlightOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (lastPick) {
          _this121.resetPointer(highlightOnly);
        }
      };
      if (redisplay ? this.ctx.animationManager.isActive() : !(hoverRect == null ? void 0 : hoverRect.containsPoint(offsetX, offsetY))) {
        disablePointer();
        return;
      }
      this.handlePointerTooltip(event, disablePointer);
      this.handlePointerNode(event);
    }
  }, {
    key: "handlePointerTooltip",
    value: function handlePointerTooltip(event, disablePointer) {
      var lastPick = this.lastPick,
        tooltip = this.tooltip;
      var range3 = tooltip.range;
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      var pixelRange;
      if (_isFiniteNumber(range3)) {
        pixelRange = range3;
      }
      var pick = this.pickSeriesNode({
        x: offsetX,
        y: offsetY
      }, range3 === "exact", pixelRange);
      if (!pick) {
        this.ctx.tooltipManager.removeTooltip(this.id);
        if (this.highlight.range === "tooltip") {
          disablePointer(true);
        }
        return;
      }
      var isNewDatum = this.highlight.range === "node" || !lastPick || lastPick !== pick.datum;
      var html;
      if (isNewDatum) {
        html = pick.series.getTooltipHtml(pick.datum);
        if (this.highlight.range === "tooltip") {
          this.ctx.highlightManager.updateHighlight(this.id, pick.datum);
        }
      }
      var isPixelRange = pixelRange != null;
      var tooltipEnabled = this.tooltip.enabled && pick.series.tooltipEnabled;
      var exactlyMatched = range3 === "exact" && pick.distance === 0;
      var rangeMatched = range3 === "nearest" || isPixelRange || exactlyMatched;
      var shouldUpdateTooltip = tooltipEnabled && rangeMatched && (!isNewDatum || html !== void 0);
      var meta = _TooltipManager.makeTooltipMeta(event, pick.datum);
      if (shouldUpdateTooltip) {
        this.ctx.tooltipManager.updateTooltip(this.id, meta, html);
      }
    }
  }, {
    key: "handlePointerNode",
    value: function handlePointerNode(event) {
      var _this122 = this;
      var found = this.checkSeriesNodeRange(event, function (series, datum) {
        if (series.hasEventListener("nodeClick") || series.hasEventListener("nodeDoubleClick")) {
          _this122.ctx.cursorManager.updateCursor("chart", "pointer");
        }
        if (_this122.highlight.range === "node") {
          _this122.ctx.highlightManager.updateHighlight(_this122.id, datum);
        }
      });
      if (!found) {
        this.ctx.cursorManager.updateCursor("chart");
        if (this.highlight.range === "node") {
          this.ctx.highlightManager.updateHighlight(this.id);
        }
      }
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (this.checkSeriesNodeClick(event)) {
        this.update(4 /* SERIES_UPDATE */);
        return;
      }
      this.fireEvent({
        type: "click",
        event: event.sourceEvent
      });
    }
  }, {
    key: "onDoubleClick",
    value: function onDoubleClick(event) {
      if (this.checkSeriesNodeDoubleClick(event)) {
        this.update(4 /* SERIES_UPDATE */);
        return;
      }
      this.fireEvent({
        type: "doubleClick",
        event: event.sourceEvent
      });
    }
  }, {
    key: "checkSeriesNodeClick",
    value: function checkSeriesNodeClick(event) {
      return this.checkSeriesNodeRange(event, function (series, datum) {
        return series.fireNodeClickEvent(event.sourceEvent, datum);
      });
    }
  }, {
    key: "checkSeriesNodeDoubleClick",
    value: function checkSeriesNodeDoubleClick(event) {
      return this.checkSeriesNodeRange(event, function (series, datum) {
        return series.fireNodeDoubleClickEvent(event.sourceEvent, datum);
      });
    }
  }, {
    key: "checkSeriesNodeRange",
    value: function checkSeriesNodeRange(event, callback) {
      var _this123 = this;
      var _a;
      var nearestNode = this.pickSeriesNode({
        x: event.offsetX,
        y: event.offsetY
      }, false);
      var datum = nearestNode == null ? void 0 : nearestNode.datum;
      var nodeClickRange = datum == null ? void 0 : datum.series.properties.nodeClickRange;
      var pixelRange;
      if (_isFiniteNumber(nodeClickRange)) {
        pixelRange = nodeClickRange;
      }
      var pickedNode = this.pickSeriesNode({
        x: event.offsetX,
        y: event.offsetY
      }, true);
      if (pickedNode) {
        this.ctx.highlightManager.updatePicked(this.id, pickedNode.datum);
      } else {
        this.ctx.highlightManager.updatePicked(this.id);
      }
      if (datum && nodeClickRange === "nearest") {
        callback(datum.series, datum);
        return true;
      }
      if (nodeClickRange !== "exact") {
        pickedNode = this.pickSeriesNode({
          x: event.offsetX,
          y: event.offsetY
        }, false, pixelRange);
      }
      if (!pickedNode) return false;
      var isPixelRange = pixelRange != null;
      var exactlyMatched = nodeClickRange === "exact" && pickedNode.distance === 0;
      if (isPixelRange || exactlyMatched) {
        var allMatch = event.pointerHistory === void 0 || ((_a = event.pointerHistory) == null ? void 0 : _a.every(function (pastEvent) {
          var historyPoint = {
            x: pastEvent.offsetX,
            y: pastEvent.offsetY
          };
          var historyNode = _this123.pickSeriesNode(historyPoint, false, pixelRange);
          return (historyNode == null ? void 0 : historyNode.datum) === (pickedNode == null ? void 0 : pickedNode.datum);
        }));
        if (allMatch) {
          callback(pickedNode.series, pickedNode.datum);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "changeHighlightDatum",
    value: function changeHighlightDatum(event) {
      var _a, _b;
      var seriesToUpdate = /* @__PURE__ */new Set();
      var _ref117 = (_a = event.currentHighlight) != null ? _a : {},
        _ref117$series = _ref117.series,
        newSeries = _ref117$series === void 0 ? void 0 : _ref117$series,
        newDatum = _ref117.datum;
      var _ref118 = (_b = event.previousHighlight) != null ? _b : {},
        _ref118$series = _ref118.series,
        lastSeries = _ref118$series === void 0 ? void 0 : _ref118$series,
        lastDatum = _ref118.datum;
      if (lastSeries) {
        seriesToUpdate.add(lastSeries);
      }
      if (newSeries) {
        seriesToUpdate.add(newSeries);
      }
      if ((lastSeries == null ? void 0 : lastSeries.properties.cursor) && lastDatum) {
        this.ctx.cursorManager.updateCursor(lastSeries.id);
      }
      if ((newSeries == null ? void 0 : newSeries.properties.cursor) && newDatum) {
        this.ctx.cursorManager.updateCursor(newSeries.id, newSeries.properties.cursor);
      }
      this.lastPick = event.currentHighlight;
      var updateAll = newSeries == null || lastSeries == null;
      if (updateAll) {
        this.update(4 /* SERIES_UPDATE */);
      } else {
        this.update(4 /* SERIES_UPDATE */, {
          seriesToUpdate: seriesToUpdate
        });
      }
    }
  }, {
    key: "waitForUpdate",
    value: function waitForUpdate() {
      var timeoutMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e4;
      var failOnTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee20() {
        var start, message;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              start = performance.now();
              if (!(this._pendingFactoryUpdatesCount > 0)) {
                _context29.n = 1;
                break;
              }
              _context29.n = 1;
              return this.updateMutex.waitForClearAcquireQueue();
            case 1:
              if (!(this.performUpdateType !== 7 /* NONE */)) {
                _context29.n = 5;
                break;
              }
              if (!(performance.now() - start > timeoutMs)) {
                _context29.n = 3;
                break;
              }
              message = "Chart.waitForUpdate() timeout of ".concat(timeoutMs, " reached - first chart update taking too long.");
              if (!failOnTimeout) {
                _context29.n = 2;
                break;
              }
              throw new Error(message);
            case 2:
              _Logger.warnOnce(message);
            case 3:
              _context29.n = 4;
              return sleep(50);
            case 4:
              _context29.n = 1;
              break;
            case 5:
              _context29.n = 6;
              return this.updateMutex.waitForClearAcquireQueue();
            case 6:
              return _context29.a(2);
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "waitForDataProcess",
    value: function waitForDataProcess(timeout) {
      var _this124 = this;
      return new Promise(function (resolve) {
        _this124.dataProcessListeners.add(resolve);
        if (_isNumber(timeout)) {
          setTimeout(function () {
            if (_this124.dataProcessListeners.has(resolve)) {
              _this124.dataProcessListeners.delete(resolve);
              resolve();
            }
          }, timeout);
        }
      });
    }
  }, {
    key: "getMinRects",
    value: function getMinRects() {
      var _this$ctx$scene2 = this.ctx.scene,
        width = _this$ctx$scene2.width,
        height = _this$ctx$scene2.height;
      var minRects = this.series.map(function (series) {
        return series.getMinRects(width, height);
      }).filter(_isDefined);
      if (minRects.length === 0) return;
      var maxWidth = 0;
      var maxHeight = 0;
      var maxVisibleWidth = 0;
      var maxVisibleHeight = 0;
      var _iterator175 = _createForOfIteratorHelper(minRects),
        _step175;
      try {
        for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
          var _step175$value = _step175.value,
            minRect2 = _step175$value.minRect,
            minVisibleRect2 = _step175$value.minVisibleRect;
          maxWidth = Math.max(maxWidth, minRect2.width);
          maxHeight = Math.max(maxHeight, minRect2.height);
          maxVisibleWidth = Math.max(maxVisibleWidth, minVisibleRect2.width);
          maxVisibleHeight = Math.max(maxVisibleHeight, minVisibleRect2.height);
        }
      } catch (err) {
        _iterator175.e(err);
      } finally {
        _iterator175.f();
      }
      var minRect = new _BBox2(0, 0, maxWidth, maxHeight);
      var minVisibleRect = minRect.clone();
      if (maxVisibleWidth > 0 && maxVisibleHeight > 0) {
        minVisibleRect = new _BBox2(0, 0, maxVisibleWidth, maxVisibleHeight);
      }
      return {
        minRect: minRect,
        minVisibleRect: minVisibleRect
      };
    }
  }, {
    key: "filterMiniChartSeries",
    value: function filterMiniChartSeries(series) {
      return series == null ? void 0 : series.filter(function (s) {
        return s.showInMiniChart !== false;
      });
    }
  }, {
    key: "applyOptions",
    value: function applyOptions(chartOptions) {
      var _a, _b, _c, _d, _e;
      var oldOpts = this.processedOptions;
      var deltaOptions = chartOptions.diffOptions(oldOpts);
      var userOptions = chartOptions.userOptions;
      if (deltaOptions == null) return;
      debug("AgChartV2.updateDelta() - applying delta", deltaOptions);
      var completeOptions = _mergeDefaults4(deltaOptions, oldOpts);
      var modulesChanged = this.applyModules(completeOptions);
      var skip = ["type", "data", "series", "listeners", "theme", "legend.listeners", "navigator.miniChart.series", "navigator.miniChart.label", "axes", "topology"];
      if (deltaOptions.listeners) {
        this.registerListeners(this, deltaOptions.listeners);
      }
      _jsonApply(this, deltaOptions, {
        skip: skip
      });
      var forceNodeDataRefresh = false;
      var seriesStatus = "no-op";
      if ((_a = deltaOptions.series) == null ? void 0 : _a.length) {
        seriesStatus = this.applySeries(this, deltaOptions.series, oldOpts == null ? void 0 : oldOpts.series);
        forceNodeDataRefresh = true;
      }
      if (seriesStatus === "replaced") {
        this.resetAnimations();
      }
      if (this.applyAxes(this, completeOptions, oldOpts, seriesStatus)) {
        forceNodeDataRefresh = true;
      }
      if (deltaOptions.data) {
        this.data = deltaOptions.data;
      }
      if (((_b = deltaOptions.legend) == null ? void 0 : _b.listeners) && this.modulesManager.isEnabled("legend")) {
        Object.assign(this.legend.listeners, deltaOptions.legend.listeners);
      }
      if (deltaOptions.listeners) {
        this.updateAllSeriesListeners();
      }
      this.chartOptions = chartOptions;
      this.processedOptions = completeOptions;
      this.userOptions = _mergeDefaults4(userOptions, this.userOptions);
      var navigatorModule = this.modulesManager.getModule("navigator");
      var zoomModule = this.modulesManager.getModule("zoom");
      if (!(navigatorModule == null ? void 0 : navigatorModule.enabled) && !(zoomModule == null ? void 0 : zoomModule.enabled)) {
        this.ctx.zoomManager.updateZoom("chart");
      }
      var miniChart = navigatorModule == null ? void 0 : navigatorModule.miniChart;
      var miniChartSeries = (_e = (_d = (_c = completeOptions.navigator) == null ? void 0 : _c.miniChart) == null ? void 0 : _d.series) != null ? _e : completeOptions.series;
      if ((miniChart == null ? void 0 : miniChart.enabled) === true && miniChartSeries != null) {
        this.applyMiniChartOptions(miniChart, miniChartSeries, completeOptions, oldOpts);
      } else if ((miniChart == null ? void 0 : miniChart.enabled) === false) {
        miniChart.series = [];
        miniChart.axes = [];
      }
      _injectStyle(styles_default, "chart");
      this.ctx.annotationManager.setAnnotationStyles(chartOptions.annotationThemes);
      forceNodeDataRefresh || (forceNodeDataRefresh = this.shouldForceNodeDataRefresh(deltaOptions, seriesStatus));
      var majorChange = forceNodeDataRefresh || modulesChanged;
      var updateType = majorChange ? 0 /* FULL */ : 3 /* PERFORM_LAYOUT */;
      this.maybeResetAnimations(seriesStatus);
      debug("AgChartV2.applyChartOptions() - update type", _ChartUpdateType[updateType], {
        seriesStatus: seriesStatus,
        forceNodeDataRefresh: forceNodeDataRefresh
      });
      this.update(updateType, {
        forceNodeDataRefresh: forceNodeDataRefresh,
        newAnimationBatch: true
      });
    }
  }, {
    key: "maybeResetAnimations",
    value: function maybeResetAnimations(seriesStatus) {
      if (this.mode !== "standalone") return;
      switch (seriesStatus) {
        case "series-grouping-change":
        case "replaced":
          this.resetAnimations();
          break;
        default:
      }
    }
  }, {
    key: "shouldForceNodeDataRefresh",
    value: function shouldForceNodeDataRefresh(deltaOptions, seriesStatus) {
      var seriesDataUpdate = !!deltaOptions.data || seriesStatus === "data-change" || seriesStatus === "replaced";
      var legendKeys = legendRegistry.getKeys();
      var optionsHaveLegend = Object.values(legendKeys).some(function (legendKey) {
        return deltaOptions[legendKey] != null;
      });
      var otherRefreshUpdate = deltaOptions.title != null && deltaOptions.subtitle != null;
      return seriesDataUpdate || optionsHaveLegend || otherRefreshUpdate;
    }
  }, {
    key: "applyMiniChartOptions",
    value: function applyMiniChartOptions(miniChart, miniChartSeries, completeOptions, oldOpts) {
      var _a, _b, _c, _d, _e;
      var oldSeries = (_c = (_b = (_a = oldOpts == null ? void 0 : oldOpts.navigator) == null ? void 0 : _a.miniChart) == null ? void 0 : _b.series) != null ? _c : oldOpts == null ? void 0 : oldOpts.series;
      var miniChartSeriesStatus = this.applySeries(miniChart, this.filterMiniChartSeries(miniChartSeries), this.filterMiniChartSeries(oldSeries));
      this.applyAxes(miniChart, completeOptions, oldOpts, miniChartSeriesStatus, ["axes[].tick", "axes[].thickness", "axes[].title", "axes[].crosshair", "axes[].gridLine", "axes[].label"]);
      var axes = miniChart.axes;
      var horizontalAxis = axes.find(function (axis) {
        return axis.direction === "x";
      } /* X */);
      var _iterator176 = _createForOfIteratorHelper(axes),
        _step176;
      try {
        for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
          var axis = _step176.value;
          axis.gridLine.enabled = false;
          axis.label.enabled = axis === horizontalAxis;
          axis.tick.enabled = false;
          axis.interactionEnabled = false;
        }
      } catch (err) {
        _iterator176.e(err);
      } finally {
        _iterator176.f();
      }
      if (horizontalAxis != null) {
        var miniChartOpts = (_d = completeOptions.navigator) == null ? void 0 : _d.miniChart;
        var labelOptions = miniChartOpts == null ? void 0 : miniChartOpts.label;
        var intervalOptions = (_e = miniChartOpts == null ? void 0 : miniChartOpts.label) == null ? void 0 : _e.interval;
        horizontalAxis.line.enabled = false;
        horizontalAxis.label.set(_without(labelOptions, ["interval", "rotation", "minSpacing", "autoRotate", "autoRotateAngle"]));
        horizontalAxis.tick.set(_without(intervalOptions, ["enabled", "width", "size", "color", "interval", "step"]));
        var step = intervalOptions == null ? void 0 : intervalOptions.step;
        if (step != null) {
          horizontalAxis.tick.interval = step;
        }
      }
    }
  }, {
    key: "applyModules",
    value: function applyModules(options) {
      var _this125 = this;
      var _a;
      var chartType2 = this.constructor.type;
      var modulesChanged = false;
      var _iterator177 = _createForOfIteratorHelper(_moduleRegistry.byType("root", "legend")),
        _step177;
      try {
        for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
          var module = _step177.value;
          var isConfigured = options[module.optionsKey] != null;
          var shouldBeEnabled = isConfigured && module.chartTypes.includes(chartType2);
          if (shouldBeEnabled === this.modulesManager.isEnabled(module)) continue;
          if (shouldBeEnabled) {
            this.modulesManager.addModule(module, function (m) {
              return new m.instanceConstructor(_this125.getModuleContext());
            });
            if (module.type === "legend") {
              (_a = this.modulesManager.getModule(module)) == null ? void 0 : _a.attachLegend(this.ctx.scene);
            }
            this[module.optionsKey] = this.modulesManager.getModule(module);
          } else {
            this.modulesManager.removeModule(module);
            delete this[module.optionsKey];
          }
          modulesChanged = true;
        }
      } catch (err) {
        _iterator177.e(err);
      } finally {
        _iterator177.f();
      }
      return modulesChanged;
    }
  }, {
    key: "applySeries",
    value: function applySeries(chart, optSeries, oldOptSeries) {
      var _this126 = this;
      var _a;
      if (!optSeries) {
        return "no-change";
      }
      var matchResult = matchSeriesOptions(chart.series, optSeries, oldOptSeries);
      if (matchResult.status === "no-overlap") {
        debug("AgChartV2.applySeries() - creating new series instances, status: ".concat(matchResult.status), matchResult);
        chart.series = optSeries.map(function (opts) {
          return _this126.createSeries(opts);
        });
        return "replaced";
      }
      debug("AgChartV2.applySeries() - matchResult", matchResult);
      var seriesInstances = [];
      var dataChanged = false;
      var groupingChanged = false;
      var isUpdated = false;
      var _iterator178 = _createForOfIteratorHelper(matchResult.changes),
        _step178;
      try {
        for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
          var change = _step178.value;
          groupingChanged || (groupingChanged = change.status === "series-grouping");
          dataChanged || (dataChanged = ((_a = change.diff) == null ? void 0 : _a.data) != null);
          isUpdated || (isUpdated = change.status !== "no-op");
          switch (change.status) {
            case "add":
              var newSeries = this.createSeries(change.opts);
              seriesInstances.push(newSeries);
              debug("AgChartV2.applySeries() - created new series", newSeries);
              break;
            case "remove":
              debug("AgChartV2.applySeries() - removing series at previous idx ".concat(change.idx), change.series);
              break;
            case "no-op":
              seriesInstances.push(change.series);
              debug("AgChartV2.applySeries() - no change to series at previous idx ".concat(change.idx), change.series);
              break;
            case "series-grouping":
            case "update":
            default:
              var series = change.series,
                diff2 = change.diff,
                _idx2 = change.idx;
              debug("AgChartV2.applySeries() - applying series diff previous idx ".concat(_idx2), diff2, series);
              this.applySeriesValues(series, diff2);
              series.markNodeDataDirty();
              seriesInstances.push(series);
          }
        }
      } catch (err) {
        _iterator178.e(err);
      } finally {
        _iterator178.f();
      }
      for (var idx = 0; idx < seriesInstances.length; idx++) {
        seriesInstances[idx]._declarationOrder = idx;
      }
      debug("AgChartV2.applySeries() - final series instances", seriesInstances);
      chart.series = seriesInstances;
      if (groupingChanged) {
        return "series-grouping-change";
      }
      if (dataChanged) {
        return "data-change";
      }
      return isUpdated ? "updated" : "no-op";
    }
  }, {
    key: "applyAxes",
    value: function applyAxes(chart, options, oldOpts, seriesStatus) {
      var skip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      if (!("axes" in options) || !options.axes) {
        return false;
      }
      skip = ["axes[].type"].concat(_toConsumableArray(skip));
      var axes = options.axes;
      var forceRecreate = seriesStatus === "replaced";
      var matchingTypes = !forceRecreate && chart.axes.length === axes.length && chart.axes.every(function (a, i) {
        return a.type === axes[i].type;
      });
      if (matchingTypes && isAgCartesianChartOptions(oldOpts)) {
        chart.axes.forEach(function (axis, index) {
          var _a, _b;
          var previousOpts = (_b = (_a = oldOpts.axes) == null ? void 0 : _a[index]) != null ? _b : {};
          var axisDiff = _jsonDiff(previousOpts, axes[index]);
          debug("AgChartV2.applyAxes() - applying axis diff idx ".concat(index), axisDiff);
          var path = "axes[".concat(index, "]");
          _jsonApply(axis, axisDiff, __spreadProps(__spreadValues({}, JSON_APPLY_PLUGINS), {
            path: path,
            skip: skip
          }));
        });
        return true;
      }
      debug("AgChartV2.applyAxes() - creating new axes instances; seriesStatus: ".concat(seriesStatus));
      chart.axes = this.createAxis(axes, skip);
      return true;
    }
  }, {
    key: "createSeries",
    value: function createSeries(seriesOptions) {
      var seriesInstance = seriesRegistry.create(seriesOptions.type, this.getModuleContext());
      this.applySeriesOptionModules(seriesInstance, seriesOptions);
      this.applySeriesValues(seriesInstance, seriesOptions);
      return seriesInstance;
    }
  }, {
    key: "applySeriesOptionModules",
    value: function applySeriesOptionModules(series, options) {
      var moduleContext = series.createModuleContext();
      var moduleMap = series.getModuleMap();
      var _iterator179 = _createForOfIteratorHelper(_moduleRegistry.byType("series-option")),
        _step179;
      try {
        for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
          var module = _step179.value;
          if (module.optionsKey in options && module.seriesTypes.includes(series.type)) {
            moduleMap.addModule(module, function (m) {
              return new m.instanceConstructor(moduleContext);
            });
          }
        }
      } catch (err) {
        _iterator179.e(err);
      } finally {
        _iterator179.f();
      }
    }
  }, {
    key: "applySeriesValues",
    value: function applySeriesValues(target, options) {
      var moduleMap = target.getModuleMap();
      var _a = options,
        _ = _a.type,
        data = _a.data,
        listeners = _a.listeners,
        seriesGrouping = _a.seriesGrouping,
        __ = _a.showInMiniChart,
        seriesOptions = __objRest(_a, ["type", "data", "listeners", "seriesGrouping", "showInMiniChart"]);
      for (var _i24 = 0, _EXPECTED_ENTERPRISE_3 = EXPECTED_ENTERPRISE_MODULES; _i24 < _EXPECTED_ENTERPRISE_3.length; _i24++) {
        var moduleDef = _EXPECTED_ENTERPRISE_3[_i24];
        if (moduleDef.type !== "series-option") continue;
        if (moduleDef.optionsKey in seriesOptions) {
          var module = moduleMap.getModule(moduleDef.optionsKey);
          var moduleOptions = seriesOptions[moduleDef.optionsKey];
          delete seriesOptions[moduleDef.optionsKey];
          module.properties.set(moduleOptions);
        }
      }
      target.properties.set(seriesOptions);
      if ("data" in options) {
        target.setOptionsData(data);
      }
      if (listeners) {
        this.registerListeners(target, listeners);
      }
      if ("seriesGrouping" in options) {
        if (seriesGrouping == null) {
          target.seriesGrouping = void 0;
        } else {
          target.seriesGrouping = __spreadValues(__spreadValues({}, target.seriesGrouping), seriesGrouping);
        }
      }
    }
  }, {
    key: "createAxis",
    value: function createAxis(options, skip) {
      var guesser = new AxisPositionGuesser();
      var moduleContext = this.getModuleContext();
      for (var index = 0; index < options.length; index++) {
        var axisOptions = options[index];
        var axis = axisRegistry.create(axisOptions.type, moduleContext);
        this.applyAxisModules(axis, axisOptions);
        _jsonApply(axis, axisOptions, __spreadProps(__spreadValues({}, JSON_APPLY_PLUGINS), {
          path: "axes[".concat(index, "]"),
          skip: skip
        }));
        guesser.push(axis, axisOptions);
      }
      return guesser.guessInvalidPositions();
    }
  }, {
    key: "applyAxisModules",
    value: function applyAxisModules(axis, options) {
      var moduleContext = axis.createModuleContext();
      var moduleMap = axis.getModuleMap();
      var _iterator180 = _createForOfIteratorHelper(_moduleRegistry.byType("axis-option")),
        _step180;
      try {
        for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
          var module = _step180.value;
          var shouldBeEnabled = options[module.optionsKey] != null;
          if (shouldBeEnabled === moduleMap.isEnabled(module)) continue;
          if (shouldBeEnabled) {
            moduleMap.addModule(module, function (m) {
              return new m.instanceConstructor(moduleContext);
            });
            axis[module.optionsKey] = moduleMap.getModule(module);
          } else {
            moduleMap.removeModule(module);
            delete axis[module.optionsKey];
          }
        }
      } catch (err) {
        _iterator180.e(err);
      } finally {
        _iterator180.f();
      }
    }
  }, {
    key: "registerListeners",
    value: function registerListeners(source, listeners) {
      source.clearEventListeners();
      for (var _i25 = 0, _Object$entries5 = Object.entries(listeners); _i25 < _Object$entries5.length; _i25++) {
        var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i25], 2),
          property = _Object$entries5$_i[0],
          listener = _Object$entries5$_i[1];
        if (_isFunction(listener)) {
          source.addEventListener(property, listener);
        }
      }
    }
  }, {
    key: "canvasElement",
    /** NOTE: This is exposed for use by Integrated charts only. */get: function get() {
      return this.ctx.scene.canvas.element;
    }
  }], [{
    key: "getInstance",
    value: function getInstance(element2) {
      return _Chart.chartsInstances.get(element2);
    }
  }, {
    key: "isHoverEvent",
    value: function isHoverEvent(event) {
      return event !== void 0 && event.type === "hover";
    }
  }]);
  return _Chart;
}(Observable);
_Chart.chartsInstances = /* @__PURE__ */new WeakMap();
__decorateClass([_ActionOnSet({
  newValue: function newValue(value) {
    if (this.destroyed) return;
    value.setAttribute("data-ag-charts", "");
    value.appendChild(this.element);
    _Chart.chartsInstances.set(value, this);
  },
  oldValue: function oldValue(value) {
    value.removeAttribute("data-ag-charts");
    value.removeChild(this.element);
    _Chart.chartsInstances.delete(value);
  }
})], _Chart.prototype, "container", 2);
__decorateClass([_ActionOnSet({
  newValue: function newValue(value) {
    this.resize(value, void 0, "width option");
  }
})], _Chart.prototype, "width", 2);
__decorateClass([_ActionOnSet({
  newValue: function newValue(value) {
    this.resize(void 0, value, "height option");
  }
})], _Chart.prototype, "height", 2);
__decorateClass([_ActionOnSet({
  newValue: function newValue(value) {
    this.onAutoSizeChange(value);
  }
}), _Validate(_BOOLEAN)], _Chart.prototype, "autoSize", 2);
__decorateClass([_Validate(_OBJECT)], _Chart.prototype, "padding", 2);
__decorateClass([_Validate(_OBJECT)], _Chart.prototype, "seriesArea", 2);
__decorateClass([_Validate(_OBJECT)], _Chart.prototype, "title", 2);
__decorateClass([_Validate(_OBJECT)], _Chart.prototype, "subtitle", 2);
__decorateClass([_Validate(_OBJECT)], _Chart.prototype, "footnote", 2);
__decorateClass([_Validate(_OBJECT)], _Chart.prototype, "keyboard", 2);
__decorateClass([_Validate(_UNION(["standalone", "integrated"], "a chart mode"))], _Chart.prototype, "mode", 2);
__decorateClass([_ActionOnSet({
  changeValue: function changeValue(newValue, oldValue) {
    this.onAxisChange(newValue, oldValue);
  }
})], _Chart.prototype, "axes", 2);
__decorateClass([_ActionOnSet({
  changeValue: function changeValue(newValue, oldValue) {
    this.onSeriesChange(newValue, oldValue);
  }
})], _Chart.prototype, "series", 2);
var Chart = _Chart;

// packages/ag-charts-community/src/scene/polyRoots.ts
function linearRoot(a, b) {
  var t = -b / a;
  return a !== 0 && t >= 0 && t <= 1 ? [t] : [];
}
function quadraticRoots(a, b, c) {
  if (a === 0) {
    return linearRoot(b, c);
  }
  var D = b * b - 4 * a * c;
  var roots = [];
  if (D === 0) {
    var t = -b / (2 * a);
    if (t >= 0 && t <= 1) {
      roots.push(t);
    }
  } else if (D > 0) {
    var rD = Math.sqrt(D);
    var t1 = (-b - rD) / (2 * a);
    var t2 = (-b + rD) / (2 * a);
    if (t1 >= 0 && t1 <= 1) {
      roots.push(t1);
    }
    if (t2 >= 0 && t2 <= 1) {
      roots.push(t2);
    }
  }
  return roots;
}
function cubicRoots(a, b, c, d) {
  if (a === 0) {
    return quadraticRoots(b, c, d);
  }
  var A = b / a;
  var B = c / a;
  var C = d / a;
  var Q = (3 * B - A * A) / 9;
  var R = (9 * A * B - 27 * C - 2 * A * A * A) / 54;
  var D = Q * Q * Q + R * R;
  var third = 1 / 3;
  var roots = [];
  if (D >= 0) {
    var rD = Math.sqrt(D);
    var S = Math.sign(R + rD) * Math.pow(Math.abs(R + rD), third);
    var T = Math.sign(R - rD) * Math.pow(Math.abs(R - rD), third);
    var Im = Math.abs(Math.sqrt(3) * (S - T) / 2);
    var t = -third * A + (S + T);
    if (t >= 0 && t <= 1) {
      roots.push(t);
    }
    if (Im === 0) {
      var t2 = -third * A - (S + T) / 2;
      if (t2 >= 0 && t2 <= 1) {
        roots.push(t2);
      }
    }
  } else {
    var theta = Math.acos(R / Math.sqrt(-Q * Q * Q));
    var thirdA = third * A;
    var twoSqrtQ = 2 * Math.sqrt(-Q);
    var t1 = twoSqrtQ * Math.cos(third * theta) - thirdA;
    var _t1 = twoSqrtQ * Math.cos(third * (theta + 2 * Math.PI)) - thirdA;
    var t3 = twoSqrtQ * Math.cos(third * (theta + 4 * Math.PI)) - thirdA;
    if (t1 >= 0 && t1 <= 1) {
      roots.push(t1);
    }
    if (_t1 >= 0 && _t1 <= 1) {
      roots.push(_t1);
    }
    if (t3 >= 0 && t3 <= 1) {
      roots.push(t3);
    }
  }
  return roots;
}

// packages/ag-charts-community/src/scene/intersection.ts
function segmentIntersection(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
  var d = (ax2 - ax1) * (by2 - by1) - (ay2 - ay1) * (bx2 - bx1);
  if (d === 0) {
    return 0;
  }
  var ua = ((bx2 - bx1) * (ay1 - by1) - (ax1 - bx1) * (by2 - by1)) / d;
  var ub = ((ax2 - ax1) * (ay1 - by1) - (ay2 - ay1) * (ax1 - bx1)) / d;
  if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
    return 1;
  }
  return 0;
}
function cubicSegmentIntersections(px1, py1, px2, py2, px3, py3, px4, py4, x1, y1, x2, y2) {
  var intersections = 0;
  var A = y1 - y2;
  var B = x2 - x1;
  var C = x1 * (y2 - y1) - y1 * (x2 - x1);
  var bx = bezierCoefficients(px1, px2, px3, px4);
  var by = bezierCoefficients(py1, py2, py3, py4);
  var a = A * bx[0] + B * by[0];
  var b = A * bx[1] + B * by[1];
  var c = A * bx[2] + B * by[2];
  var d = A * bx[3] + B * by[3] + C;
  var roots = cubicRoots(a, b, c, d);
  var _iterator181 = _createForOfIteratorHelper(roots),
    _step181;
  try {
    for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
      var t = _step181.value;
      var tt = t * t;
      var ttt = t * tt;
      var x = bx[0] * ttt + bx[1] * tt + bx[2] * t + bx[3];
      var y = by[0] * ttt + by[1] * tt + by[2] * t + by[3];
      var s = void 0;
      if (x1 === x2) {
        s = (y - y1) / (y2 - y1);
      } else {
        s = (x - x1) / (x2 - x1);
      }
      if (s >= 0 && s <= 1) {
        intersections++;
      }
    }
  } catch (err) {
    _iterator181.e(err);
  } finally {
    _iterator181.f();
  }
  return intersections;
}
function bezierCoefficients(P1, P2, P3, P4) {
  return [
  // Bézier expressed as matrix operations:
  -P1 + 3 * P2 - 3 * P3 + P4,
  //                 |-1  3 -3  1| |P1|
  3 * P1 - 6 * P2 + 3 * P3,
  //   [t^3 t^2 t 1] | 3 -6  3  0| |P2|
  -3 * P1 + 3 * P2,
  //                 |-3  3  0  0| |P3|
  P1
  //                 | 1  0  0  0| |P4|
  ];
}
function arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, x1, y1, x2, y2) {
  if (isNaN(cx) || isNaN(cy)) {
    return 0;
  }
  if (counterClockwise) {
    var _ref119 = [startAngle, endAngle];
    endAngle = _ref119[0];
    startAngle = _ref119[1];
  }
  var k = (y2 - y1) / (x2 - x1);
  var y0 = y1 - k * x1;
  var a = Math.pow(k, 2) + 1;
  var b = 2 * (k * (y0 - cy) - cx);
  var c = Math.pow(cx, 2) + Math.pow(y0 - cy, 2) - Math.pow(r, 2);
  var d = Math.pow(b, 2) - 4 * a * c;
  if (d < 0) {
    return 0;
  }
  var i1x = (-b + Math.sqrt(d)) / 2 / a;
  var i2x = (-b - Math.sqrt(d)) / 2 / a;
  var intersections = 0;
  [i1x, i2x].forEach(function (x) {
    var isXInsideLine = x >= Math.min(x1, x2) && x <= Math.max(x1, x2);
    if (!isXInsideLine) {
      return;
    }
    var y = k * x + y0;
    var adjacent = x - cx;
    var opposite = y - cy;
    var angle = Math.atan2(opposite, adjacent);
    if (_isBetweenAngles(angle, startAngle, endAngle)) {
      intersections++;
    }
  });
  return intersections;
}

// packages/ag-charts-community/src/scene/extendedPath2D.ts
var _ExtendedPath2D = /*#__PURE__*/function () {
  function ExtendedPath2D() {
    _classCallCheck(this, ExtendedPath2D);
    // The methods of this class will likely be called many times per animation frame,
    // and any allocation can trigger a GC cycle during animation, so we attempt
    // to minimize the number of allocations.
    this.path2d = new Path2D();
    this.previousCommands = [];
    this.previousParams = [];
    this.previousClosedPath = false;
    this.commands = [];
    this.params = [];
    this.openedPath = false;
    this.closedPath = false;
  }
  _createClass(ExtendedPath2D, [{
    key: "isDirty",
    value: function isDirty() {
      return this.closedPath !== this.previousClosedPath || this.previousCommands.length !== this.commands.length || this.previousParams.length !== this.params.length || this.previousCommands.toString() !== this.commands.toString() || this.previousParams.toString() !== this.params.toString();
    }
  }, {
    key: "getPath2D",
    value: function getPath2D() {
      return this.path2d;
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      this.openedPath = true;
      this.path2d.moveTo(x, y);
      this.commands.push(0 /* Move */);
      this.params.push(x, y);
    }
  }, {
    key: "lineTo",
    value: function lineTo(x, y) {
      if (this.openedPath) {
        this.path2d.lineTo(x, y);
        this.commands.push(1 /* Line */);
        this.params.push(x, y);
      } else {
        this.moveTo(x, y);
      }
    }
  }, {
    key: "rect",
    value: function rect(x, y, width, height) {
      this.moveTo(x, y);
      this.lineTo(x + width, y);
      this.lineTo(x + width, y + height);
      this.lineTo(x, y + height);
      this.closePath();
    }
  }, {
    key: "roundRect",
    value: function roundRect(x, y, width, height, radii) {
      radii = Math.min(radii, width / 2, height / 2);
      this.moveTo(x, y + radii);
      this.arc(x + radii, y + radii, radii, Math.PI, 1.5 * Math.PI);
      this.lineTo(x + radii, y);
      this.lineTo(x + width - radii, y);
      this.arc(x + width - radii, y + radii, radii, 1.5 * Math.PI, 2 * Math.PI);
      this.lineTo(x + width, y + radii);
      this.lineTo(x + width, y + height - radii);
      this.arc(x + width - radii, y + height - radii, radii, 0, Math.PI / 2);
      this.lineTo(x + width - radii, y + height);
      this.lineTo(x + radii, y + height);
      this.arc(x + +radii, y + height - radii, radii, Math.PI / 2, Math.PI);
      this.lineTo(x, y + height - radii);
      this.closePath();
    }
  }, {
    key: "arc",
    value: function arc(x, y, r, sAngle, eAngle, counterClockwise) {
      this.openedPath = true;
      this.path2d.arc(x, y, r, sAngle, eAngle, counterClockwise);
      this.commands.push(2 /* Arc */);
      this.params.push(x, y, r, sAngle, eAngle, counterClockwise ? 1 : 0);
    }
  }, {
    key: "cubicCurveTo",
    value: function cubicCurveTo(cx1, cy1, cx2, cy2, x, y) {
      if (!this.openedPath) {
        this.moveTo(cx1, cy1);
      }
      this.path2d.bezierCurveTo(cx1, cy1, cx2, cy2, x, y);
      this.commands.push(3 /* Curve */);
      this.params.push(cx1, cy1, cx2, cy2, x, y);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      if (this.openedPath) {
        this.path2d.closePath();
        this.commands.push(4 /* ClosePath */);
        this.openedPath = false;
        this.closedPath = true;
      }
    }
  }, {
    key: "clear",
    value: function clear(trackChanges) {
      if (trackChanges) {
        this.previousCommands = this.commands;
        this.previousParams = this.params;
        this.previousClosedPath = this.closedPath;
      }
      this.path2d = new Path2D();
      this.openedPath = false;
      this.closedPath = false;
      this.commands = [];
      this.params = [];
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var commands = this.commands;
      var params = this.params;
      var cn = commands.length;
      var ox = -1e4;
      var oy = -1e4;
      var sx = NaN;
      var sy = NaN;
      var px = 0;
      var py = 0;
      var intersectionCount = 0;
      for (var ci = 0, pi = 0; ci < cn; ci++) {
        switch (commands[ci]) {
          case 0 /* Move */:
            intersectionCount += segmentIntersection(sx, sy, px, py, ox, oy, x, y);
            px = params[pi++];
            sx = px;
            py = params[pi++];
            sy = py;
            break;
          case 1 /* Line */:
            intersectionCount += segmentIntersection(px, py, params[pi++], params[pi++], ox, oy, x, y);
            px = params[pi - 2];
            py = params[pi - 1];
            break;
          case 3 /* Curve */:
            intersectionCount += cubicSegmentIntersections(px, py, params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], ox, oy, x, y);
            px = params[pi - 2];
            py = params[pi - 1];
            break;
          case 2 /* Arc */:
            var cx = params[pi++];
            var cy = params[pi++];
            var r = params[pi++];
            var startAngle = params[pi++];
            var endAngle = params[pi++];
            var counterClockwise = Boolean(params[pi++]);
            intersectionCount += arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, ox, oy, x, y);
            if (!isNaN(sx)) {
              var startX = cx + Math.cos(startAngle) * r;
              var startY = cy + Math.sin(startAngle) * r;
              intersectionCount += segmentIntersection(px, py, startX, startY, ox, oy, x, y);
            }
            px = cx + Math.cos(endAngle) * r;
            py = cy + Math.sin(endAngle) * r;
            break;
          case 4 /* ClosePath */:
            intersectionCount += segmentIntersection(sx, sy, px, py, ox, oy, x, y);
            break;
        }
      }
      return intersectionCount % 2 === 1;
    }
  }, {
    key: "distanceSquared",
    value: function distanceSquared(x, y) {
      var best = Infinity;
      var commands = this.commands;
      var params = this.params;
      var cn = commands.length;
      var sx = NaN;
      var sy = NaN;
      var px = 0;
      var py = 0;
      for (var ci = 0, pi = 0; ci < cn; ci++) {
        switch (commands[ci]) {
          case 0 /* Move */:
            px = sx = params[pi++];
            py = sy = params[pi++];
            break;
          case 1 /* Line */:
            {
              var nx = params[pi++];
              var ny = params[pi++];
              best = lineDistanceSquared(x, y, px, py, nx, ny, best);
              break;
            }
          case 3 /* Curve */:
            _Logger.error("Command.Curve distanceSquare not implemented");
            break;
          case 2 /* Arc */:
            {
              var cx = params[pi++];
              var cy = params[pi++];
              var r = params[pi++];
              var startAngle = params[pi++];
              var endAngle = params[pi++];
              var startX = cx + Math.cos(startAngle) * r;
              var startY = cy + Math.sin(startAngle) * r;
              var counterClockwise = Boolean(params[pi++]);
              best = lineDistanceSquared(x, y, px, py, startX, startY, best);
              best = arcDistanceSquared(x, y, cx, cy, r, startAngle, endAngle, counterClockwise, best);
              px = cx + Math.cos(endAngle) * r;
              py = cy + Math.sin(endAngle) * r;
              break;
            }
          case 4 /* ClosePath */:
            best = lineDistanceSquared(x, y, px, py, sx, sy, best);
            break;
        }
      }
      return best;
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var commands = this.commands,
        params = this.params;
      var coords = [];
      var pi = 0;
      for (var ci = 0; ci < commands.length; ci++) {
        switch (commands[ci]) {
          case 0 /* Move */:
          case 1 /* Line */:
            coords.push({
              x: params[pi++],
              y: params[pi++]
            });
            break;
          case 3 /* Curve */:
            pi += 4;
            coords.push({
              x: params[pi++],
              y: params[pi++]
            });
            break;
          case 2 /* Arc */:
            coords.push({
              x: params[pi++],
              y: params[pi++]
            });
            pi += 4;
            break;
          case 4 /* ClosePath */:
            break;
        }
      }
      return coords;
    }
  }]);
  return ExtendedPath2D;
}();

// packages/ag-charts-community/src/scene/shape/path.ts
function _ScenePathChangeDetection(opts) {
  var _ref120 = opts != null ? opts : {},
    _ref120$redraw = _ref120.redraw,
    redraw = _ref120$redraw === void 0 ? 3 : _ref120$redraw,
    changeCb = _ref120.changeCb,
    convertor = _ref120.convertor;
  return _SceneChangeDetection({
    redraw: redraw,
    type: "path",
    convertor: convertor,
    changeCb: changeCb
  });
}
var _Path6 = /*#__PURE__*/function (_Shape5) {
  _inherits(Path, _Shape5);
  function Path() {
    var _this127;
    _classCallCheck(this, Path);
    _this127 = _possibleConstructorReturn(this, _getPrototypeOf(Path).apply(this, arguments));
    /**
     * Declare a path to retain for later rendering and hit testing
     * using custom Path2D class. Think of it as a TypeScript version
     * of the native Path2D (with some differences) that works in all browsers.
     */
    _this127.path = new _ExtendedPath2D();
    _this127._clipX = NaN;
    _this127._clipY = NaN;
    /**
     * The path only has to be updated when certain attributes change.
     * For example, if transform attributes (such as `translationX`)
     * are changed, we don't have to update the path. The `dirtyPath` flag
     * is how we keep track if the path has to be updated or not.
     */
    _this127._dirtyPath = true;
    return _this127;
  }
  _createClass(Path, [{
    key: "checkPathDirty",
    value: function checkPathDirty() {
      var _a, _b, _c, _d;
      if (this._dirtyPath) {
        return;
      }
      this.dirtyPath = this.path.isDirty() || ((_b = (_a = this.fillShadow) == null ? void 0 : _a.isDirty()) != null ? _b : false) || ((_d = (_c = this._clipPath) == null ? void 0 : _c.isDirty()) != null ? _d : false);
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var point = this.transformPoint(x, y);
      return this.path.closedPath && this.path.isPointInPath(point.x, point.y);
    }
  }, {
    key: "distanceSquared",
    value: function distanceSquared(x, y) {
      var point = this.transformPoint(x, y);
      return this.path.distanceSquared(point.x, point.y);
    }
  }, {
    key: "isDirtyPath",
    value: function isDirtyPath() {
      return false;
    }
  }, {
    key: "updatePath",
    value: function updatePath() {}
  }, {
    key: "render",
    value: function render(renderCtx) {
      var _a, _b, _c, _d, _e;
      var ctx = renderCtx.ctx,
        forceRender = renderCtx.forceRender,
        stats = renderCtx.stats;
      if (this.dirty === 0 /* NONE */ && !forceRender) {
        if (stats) stats.nodesSkipped += this.nodeCount.count;
        return;
      }
      this.computeTransformMatrix();
      this.matrix.toContext(ctx);
      if (this.dirtyPath || this.isDirtyPath()) {
        this.updatePath();
        this.dirtyPath = false;
      }
      if (!isNaN(this._clipX) && !isNaN(this._clipY) && this.clipMode != null) {
        ctx.save();
        var margin = this.strokeWidth / 2;
        (_a = this._clipPath) != null ? _a : this._clipPath = new _ExtendedPath2D();
        this._clipPath.clear();
        this._clipPath.rect(-margin, -margin, this._clipX + margin, this._clipY + margin + margin);
        if (this.clipMode === "normal") {
          ctx.clip((_b = this._clipPath) == null ? void 0 : _b.getPath2D());
        }
        if (this._clipX > 0 && this._clipY > 0) {
          this.drawPath(ctx);
        }
        if (this.clipMode === "punch-out") {
          ctx.clip((_c = this._clipPath) == null ? void 0 : _c.getPath2D());
          var _ref121 = (_d = this.computeBBox()) != null ? _d : {},
            _ref121$x = _ref121.x,
            x = _ref121$x === void 0 ? -1e4 : _ref121$x,
            _ref121$y = _ref121.y,
            y = _ref121$y === void 0 ? -1e4 : _ref121$y,
            _ref121$width = _ref121.width,
            width = _ref121$width === void 0 ? 2e4 : _ref121$width,
            _ref121$height = _ref121.height,
            height = _ref121$height === void 0 ? 2e4 : _ref121$height;
          ctx.clearRect(x, y, width, height);
        }
        ctx.restore();
      } else {
        this.drawPath(ctx);
      }
      (_e = this.fillShadow) == null ? void 0 : _e.markClean();
      _superPropGet(Path, "render", this, 3)([renderCtx]);
    }
  }, {
    key: "drawPath",
    value: function drawPath(ctx) {
      this.fillStroke(ctx, this.path.getPath2D());
    }
  }, {
    key: "clipX",
    set: function set(value) {
      this._clipX = value;
      this.dirtyPath = true;
    }
  }, {
    key: "clipY",
    set: function set(value) {
      this._clipY = value;
      this.dirtyPath = true;
    }
  }, {
    key: "dirtyPath",
    set: function set(value) {
      if (this._dirtyPath !== value) {
        this._dirtyPath = value;
        if (value) {
          this.markDirty(this, 3 /* MAJOR */);
        }
      }
    },
    get: function get() {
      return this._dirtyPath;
    }
  }]);
  return Path;
}(_Shape6);
_Path6.className = "Path";
__decorateClass([_ScenePathChangeDetection()], _Path6.prototype, "clipMode", 2);
__decorateClass([_ScenePathChangeDetection()], _Path6.prototype, "clipX", 1);
__decorateClass([_ScenePathChangeDetection()], _Path6.prototype, "clipY", 1);

// packages/ag-charts-community/src/scene/util/quadtree.ts
var QuadtreeNearest = /*#__PURE__*/function () {
  function QuadtreeNearest(capacity, maxdepth, boundary) {
    _classCallCheck(this, QuadtreeNearest);
    this.root = new QuadtreeNodeNearest(capacity, maxdepth, boundary);
  }
  _createClass(QuadtreeNearest, [{
    key: "clear",
    value: function clear(boundary) {
      this.root.clear(boundary);
    }
  }, {
    key: "addValue",
    value: function addValue(hitTester, value) {
      var elem = {
        hitTester: hitTester,
        value: value,
        distanceSquared: function distanceSquared(x, y) {
          return hitTester.distanceSquared(x, y);
        }
      };
      this.root.addElem(elem);
    }
  }, {
    key: "find",
    value: function find(x, y) {
      var arg = {
        best: {
          nearest: void 0,
          distanceSquared: Infinity
        }
      };
      this.root.find(x, y, arg);
      return arg.best;
    }
  }]);
  return QuadtreeNearest;
}();
var QuadtreeSubdivisions = /*#__PURE__*/function () {
  function QuadtreeSubdivisions(nw, ne, sw, se) {
    _classCallCheck(this, QuadtreeSubdivisions);
    this.nw = nw;
    this.ne = ne;
    this.sw = sw;
    this.se = se;
  }
  _createClass(QuadtreeSubdivisions, [{
    key: "addElem",
    value: function addElem(elem) {
      this.nw.addElem(elem);
      this.ne.addElem(elem);
      this.sw.addElem(elem);
      this.se.addElem(elem);
    }
  }, {
    key: "find",
    value: function find(x, y, arg) {
      this.nw.find(x, y, arg);
      this.ne.find(x, y, arg);
      this.sw.find(x, y, arg);
      this.se.find(x, y, arg);
    }
  }]);
  return QuadtreeSubdivisions;
}();
var QuadtreeNode = /*#__PURE__*/function () {
  function QuadtreeNode(capacity, maxdepth, boundary) {
    _classCallCheck(this, QuadtreeNode);
    this.capacity = capacity;
    this.maxdepth = maxdepth;
    this.boundary = boundary != null ? boundary : _BBox2.NaN;
    this.elems = [];
    this.subdivisions = void 0;
  }
  _createClass(QuadtreeNode, [{
    key: "clear",
    value: function clear(boundary) {
      this.elems.length = 0;
      this.boundary = boundary;
      this.subdivisions = void 0;
    }
  }, {
    key: "addElem",
    value: function addElem(e) {
      if (this.addCondition(e)) {
        if (this.subdivisions === void 0) {
          if (this.maxdepth === 0 || this.elems.length < this.capacity) {
            this.elems.push(e);
          } else {
            this.subdivide(e);
          }
        } else {
          this.subdivisions.addElem(e);
        }
      }
    }
  }, {
    key: "find",
    value: function find(x, y, arg) {
      if (this.findCondition(x, y, arg)) {
        if (this.subdivisions === void 0) {
          this.findAction(x, y, arg);
        } else {
          this.subdivisions.find(x, y, arg);
        }
      }
    }
  }, {
    key: "subdivide",
    value: function subdivide(newElem) {
      this.subdivisions = this.makeSubdivisions();
      var _iterator182 = _createForOfIteratorHelper(this.elems),
        _step182;
      try {
        for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
          var e = _step182.value;
          this.subdivisions.addElem(e);
        }
      } catch (err) {
        _iterator182.e(err);
      } finally {
        _iterator182.f();
      }
      this.subdivisions.addElem(newElem);
      this.elems.length = 0;
    }
  }, {
    key: "makeSubdivisions",
    value: function makeSubdivisions() {
      var _this$boundary = this.boundary,
        x = _this$boundary.x,
        y = _this$boundary.y,
        width = _this$boundary.width,
        height = _this$boundary.height;
      var capacity = this.capacity;
      var depth = this.maxdepth - 1;
      var halfWidth = width / 2;
      var halfHeight = height / 2;
      var nwBoundary = new _BBox2(x, y, halfWidth, halfHeight);
      var neBoundary = new _BBox2(x + halfWidth, y, halfWidth, halfHeight);
      var swBoundary = new _BBox2(x, y + halfHeight, halfWidth, halfHeight);
      var seBoundary = new _BBox2(x + halfWidth, y + halfHeight, halfWidth, halfHeight);
      return new QuadtreeSubdivisions(this.child(capacity, depth, nwBoundary), this.child(capacity, depth, neBoundary), this.child(capacity, depth, swBoundary), this.child(capacity, depth, seBoundary));
    }
  }]);
  return QuadtreeNode;
}();
var QuadtreeNodeNearest = /*#__PURE__*/function (_QuadtreeNode) {
  _inherits(_QuadtreeNodeNearest, _QuadtreeNode);
  function _QuadtreeNodeNearest() {
    _classCallCheck(this, _QuadtreeNodeNearest);
    return _possibleConstructorReturn(this, _getPrototypeOf(_QuadtreeNodeNearest).apply(this, arguments));
  }
  _createClass(_QuadtreeNodeNearest, [{
    key: "addCondition",
    value: function addCondition(e) {
      var _e$hitTester$midPoint = e.hitTester.midPoint,
        x = _e$hitTester$midPoint.x,
        y = _e$hitTester$midPoint.y;
      return this.boundary.containsPoint(x, y);
    }
  }, {
    key: "findCondition",
    value: function findCondition(x, y, arg) {
      var best = arg.best;
      return best.distanceSquared !== 0 && this.boundary.distanceSquared(x, y) < best.distanceSquared;
    }
  }, {
    key: "findAction",
    value: function findAction(x, y, arg) {
      var other = _nearestSquared(x, y, this.elems, arg.best.distanceSquared);
      if (other.nearest !== void 0 && other.distanceSquared < arg.best.distanceSquared) {
        arg.best = other;
      }
    }
  }, {
    key: "child",
    value: function child(capacity, depth, boundary) {
      return new _QuadtreeNodeNearest(capacity, depth, boundary);
    }
  }]);
  return _QuadtreeNodeNearest;
}(QuadtreeNode);

// packages/ag-charts-community/src/chart/marker/marker.ts
var _Marker0 = /*#__PURE__*/function (_Path) {
  _inherits(Marker, _Path);
  function Marker() {
    var _this128;
    _classCallCheck(this, Marker);
    _this128 = _possibleConstructorReturn(this, _getPrototypeOf(Marker).apply(this, arguments));
    _this128.x = 0;
    _this128.y = 0;
    _this128.size = 12;
    return _this128;
  }
  _createClass(Marker, [{
    key: "computeBBox",
    value: function computeBBox() {
      var x = this.x,
        y = this.y,
        size = this.size;
      var center = this.constructor.center;
      return new _BBox2(x - size * center.x, y - size * center.y, size, size);
    }
  }, {
    key: "applyPath",
    value: function applyPath(s, moves) {
      var path = this.path;
      var x = this.x,
        y = this.y;
      if (this.repeat != null) {
        x = 0;
        y = 0;
      }
      path.clear();
      var _iterator183 = _createForOfIteratorHelper(moves),
        _step183;
      try {
        for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
          var _step183$value = _step183.value,
            mx = _step183$value.x,
            my = _step183$value.y,
            t = _step183$value.t;
          x += mx * s;
          y += my * s;
          if (t === "move") {
            path.moveTo(x, y);
          } else {
            path.lineTo(x, y);
          }
        }
      } catch (err) {
        _iterator183.e(err);
      } finally {
        _iterator183.f();
      }
      path.closePath();
    }
  }, {
    key: "executeFill",
    value: function executeFill(ctx, path) {
      if (!path) return;
      if (this.repeat == null) {
        return _superPropGet(Marker, "executeFill", this, 3)([ctx, path]);
      }
      ctx.save();
      var x = this.translationX;
      var y = this.translationY;
      var _iterator184 = _createForOfIteratorHelper(this.repeat),
        _step184;
      try {
        for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
          var translation = _step184.value;
          ctx.translate(translation.x - x, translation.y - y);
          ctx.fill(path);
          x = translation.x;
          y = translation.y;
        }
      } catch (err) {
        _iterator184.e(err);
      } finally {
        _iterator184.f();
      }
      ctx.restore();
    }
  }, {
    key: "executeStroke",
    value: function executeStroke(ctx, path) {
      if (!path) return;
      if (this.repeat == null) {
        return _superPropGet(Marker, "executeStroke", this, 3)([ctx, path]);
      }
      ctx.save();
      var x = this.translationX;
      var y = this.translationY;
      var _iterator185 = _createForOfIteratorHelper(this.repeat),
        _step185;
      try {
        for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
          var translation = _step185.value;
          ctx.translate(translation.x - x, translation.y - y);
          ctx.stroke(path);
          x = translation.x;
          y = translation.y;
        }
      } catch (err) {
        _iterator185.e(err);
      } finally {
        _iterator185.f();
      }
      ctx.restore();
    }
  }]);
  return Marker;
}(_Path6);
_Marker0.center = {
  x: 0.5,
  y: 0.5
};
__decorateClass([_ScenePathChangeDetection()], _Marker0.prototype, "x", 2);
__decorateClass([_ScenePathChangeDetection()], _Marker0.prototype, "y", 2);
__decorateClass([_ScenePathChangeDetection({
  convertor: Math.abs
})], _Marker0.prototype, "size", 2);
__decorateClass([_ScenePathChangeDetection()], _Marker0.prototype, "repeat", 2);

// packages/ag-charts-community/src/chart/marker/circle.ts
var _Circle = /*#__PURE__*/function (_Marker) {
  _inherits(Circle, _Marker);
  function Circle() {
    _classCallCheck(this, Circle);
    return _possibleConstructorReturn(this, _getPrototypeOf(Circle).apply(this, arguments));
  }
  _createClass(Circle, [{
    key: "updatePath",
    value: function updatePath() {
      var x = this.x,
        y = this.y,
        path = this.path,
        size = this.size;
      var r = size / 2;
      path.clear();
      path.arc(x, y, r, 0, Math.PI * 2);
      path.closePath();
    }
  }]);
  return Circle;
}(_Marker0);
_Circle.className = "Circle";

// packages/ag-charts-community/src/chart/marker/cross.ts
var _Cross = /*#__PURE__*/function (_Marker2) {
  _inherits(_Cross, _Marker2);
  function _Cross() {
    _classCallCheck(this, _Cross);
    return _possibleConstructorReturn(this, _getPrototypeOf(_Cross).apply(this, arguments));
  }
  _createClass(_Cross, [{
    key: "updatePath",
    value: function updatePath() {
      var s = this.size / 4.2;
      _superPropGet(_Cross, "applyPath", this, 3)([s, _Cross.moves]);
    }
  }]);
  return _Cross;
}(_Marker0);
_Cross.className = "Cross";
_Cross.moves = [{
  x: -1,
  y: 0,
  t: "move"
}, {
  x: -1,
  y: -1
}, {
  x: 1,
  y: -1
}, {
  x: 1,
  y: 1
}, {
  x: 1,
  y: -1
}, {
  x: 1,
  y: 1
}, {
  x: -1,
  y: 1
}, {
  x: 1,
  y: 1
}, {
  x: -1,
  y: 1
}, {
  x: -1,
  y: -1
}, {
  x: -1,
  y: 1
}, {
  x: -1,
  y: -1
}];
var Cross = _Cross;

// packages/ag-charts-community/src/chart/marker/diamond.ts
var _Diamond = /*#__PURE__*/function (_Marker3) {
  _inherits(_Diamond, _Marker3);
  function _Diamond() {
    _classCallCheck(this, _Diamond);
    return _possibleConstructorReturn(this, _getPrototypeOf(_Diamond).apply(this, arguments));
  }
  _createClass(_Diamond, [{
    key: "updatePath",
    value: function updatePath() {
      var s = this.size / 2;
      _superPropGet(_Diamond, "applyPath", this, 3)([s, _Diamond.moves]);
    }
  }]);
  return _Diamond;
}(_Marker0);
_Diamond.className = "Diamond";
_Diamond.moves = [{
  x: 0,
  y: -1,
  t: "move"
}, {
  x: 1,
  y: 1
}, {
  x: -1,
  y: 1
}, {
  x: -1,
  y: -1
}, {
  x: 1,
  y: -1
}];
var _Diamond2 = _Diamond;

// packages/ag-charts-community/src/chart/marker/heart.ts
var Heart = /*#__PURE__*/function (_Marker4) {
  _inherits(Heart, _Marker4);
  function Heart() {
    _classCallCheck(this, Heart);
    return _possibleConstructorReturn(this, _getPrototypeOf(Heart).apply(this, arguments));
  }
  _createClass(Heart, [{
    key: "rad",
    value: function rad(degree) {
      return degree / 180 * Math.PI;
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var x = this.x,
        path = this.path,
        size = this.size,
        rad = this.rad;
      var r = size / 4;
      var y = this.y + r / 2;
      path.clear();
      path.arc(x - r, y - r, r, rad(130), rad(330));
      path.arc(x + r, y - r, r, rad(220), rad(50));
      path.lineTo(x, y + r);
      path.closePath();
    }
  }]);
  return Heart;
}(_Marker0);
Heart.className = "Heart";

// packages/ag-charts-community/src/chart/marker/pin.ts
var Pin = /*#__PURE__*/function (_Marker5) {
  _inherits(Pin, _Marker5);
  function Pin() {
    _classCallCheck(this, Pin);
    return _possibleConstructorReturn(this, _getPrototypeOf(Pin).apply(this, arguments));
  }
  _createClass(Pin, [{
    key: "updatePath",
    value: function updatePath() {
      var path = this.path,
        x = this.x,
        y = this.y;
      var s = this.size;
      var cx = 0.5;
      var cy = 1;
      path.clear();
      path.moveTo(x + (0.15625 - cx) * s, y + (0.34375 - cy) * s);
      path.cubicCurveTo(x + (0.15625 - cx) * s, y + (0.151491 - cy) * s, x + (0.307741 - cx) * s, y + (0 - cy) * s, x + (0.5 - cx) * s, y + (0 - cy) * s);
      path.cubicCurveTo(x + (0.692259 - cx) * s, y + (0 - cy) * s, x + (0.84375 - cx) * s, y + (0.151491 - cy) * s, x + (0.84375 - cx) * s, y + (0.34375 - cy) * s);
      path.cubicCurveTo(x + (0.84375 - cx) * s, y + (0.493824 - cy) * s, x + (0.784625 - cx) * s, y + (0.600181 - cy) * s, x + (0.716461 - cx) * s, y + (0.695393 - cy) * s);
      path.cubicCurveTo(x + (0.699009 - cx) * s, y + (0.719769 - cy) * s, x + (0.681271 - cx) * s, y + (0.743104 - cy) * s, x + (0.663785 - cx) * s, y + (0.766105 - cy) * s);
      path.cubicCurveTo(x + (0.611893 - cx) * s, y + (0.834367 - cy) * s, x + (0.562228 - cx) * s, y + (0.899699 - cy) * s, x + (0.528896 - cx) * s, y + (0.980648 - cy) * s);
      path.cubicCurveTo(x + (0.524075 - cx) * s, y + (0.992358 - cy) * s, x + (0.512663 - cx) * s, y + (1 - cy) * s, x + (0.5 - cx) * s, y + (1 - cy) * s);
      path.cubicCurveTo(x + (0.487337 - cx) * s, y + (1 - cy) * s, x + (0.475925 - cx) * s, y + (0.992358 - cy) * s, x + (0.471104 - cx) * s, y + (0.980648 - cy) * s);
      path.cubicCurveTo(x + (0.487337 - cx) * s, y + (1 - cy) * s, x + (0.475925 - cx) * s, y + (0.992358 - cy) * s, x + (0.471104 - cx) * s, y + (0.980648 - cy) * s);
      path.cubicCurveTo(x + (0.437772 - cx) * s, y + (0.899699 - cy) * s, x + (0.388107 - cx) * s, y + (0.834367 - cy) * s, x + (0.336215 - cx) * s, y + (0.766105 - cy) * s);
      path.cubicCurveTo(x + (0.318729 - cx) * s, y + (0.743104 - cy) * s, x + (0.300991 - cx) * s, y + (0.719769 - cy) * s, x + (0.283539 - cx) * s, y + (0.695393 - cy) * s);
      path.cubicCurveTo(x + (0.215375 - cx) * s, y + (0.600181 - cy) * s, x + (0.15625 - cx) * s, y + (0.493824 - cy) * s, x + (0.15625 - cx) * s, y + (0.34375 - cy) * s);
      path.closePath();
    }
  }]);
  return Pin;
}(_Marker0);
Pin.className = "MapPin";
Pin.center = {
  x: 0.5,
  y: 1
};

// packages/ag-charts-community/src/chart/marker/plus.ts
var _Plus = /*#__PURE__*/function (_Marker6) {
  _inherits(_Plus, _Marker6);
  function _Plus() {
    _classCallCheck(this, _Plus);
    return _possibleConstructorReturn(this, _getPrototypeOf(_Plus).apply(this, arguments));
  }
  _createClass(_Plus, [{
    key: "updatePath",
    value: function updatePath() {
      var s = this.size / 3;
      _superPropGet(_Plus, "applyPath", this, 3)([s, _Plus.moves]);
    }
  }]);
  return _Plus;
}(_Marker0);
_Plus.className = "Plus";
_Plus.moves = [{
  x: -0.5,
  y: -0.5,
  t: "move"
}, {
  x: 0,
  y: -1
}, {
  x: 1,
  y: 0
}, {
  x: 0,
  y: 1
}, {
  x: 1,
  y: 0
}, {
  x: 0,
  y: 1
}, {
  x: -1,
  y: 0
}, {
  x: 0,
  y: 1
}, {
  x: -1,
  y: 0
}, {
  x: 0,
  y: -1
}, {
  x: -1,
  y: 0
}, {
  x: 0,
  y: -1
}];
var Plus = _Plus;

// packages/ag-charts-community/src/chart/marker/square.ts
var _Square = /*#__PURE__*/function (_Marker7) {
  _inherits(Square, _Marker7);
  function Square() {
    _classCallCheck(this, Square);
    return _possibleConstructorReturn(this, _getPrototypeOf(Square).apply(this, arguments));
  }
  _createClass(Square, [{
    key: "updatePath",
    value: function updatePath() {
      var path = this.path,
        x = this.x,
        y = this.y;
      var hs = this.size / 2;
      path.clear();
      path.moveTo(this.align(x - hs), this.align(y - hs));
      path.lineTo(this.align(x + hs), this.align(y - hs));
      path.lineTo(this.align(x + hs), this.align(y + hs));
      path.lineTo(this.align(x - hs), this.align(y + hs));
      path.closePath();
    }
  }]);
  return Square;
}(_Marker0);
_Square.className = "Square";

// packages/ag-charts-community/src/chart/marker/star.ts
var Star = /*#__PURE__*/function (_Marker8) {
  _inherits(Star, _Marker8);
  function Star() {
    _classCallCheck(this, Star);
    return _possibleConstructorReturn(this, _getPrototypeOf(Star).apply(this, arguments));
  }
  _createClass(Star, [{
    key: "updatePath",
    value: function updatePath() {
      var x = this.x,
        y = this.y,
        path = this.path,
        size = this.size;
      var spikes = 5;
      var innerRadius = size / 2;
      var rotation = Math.PI / 2;
      path.clear();
      for (var i = 0; i < spikes * 2; i++) {
        var radius = i % 2 === 0 ? size : innerRadius;
        var angle = i * Math.PI / spikes - rotation;
        var xCoordinate = x + Math.cos(angle) * radius;
        var yCoordinate = y + Math.sin(angle) * radius;
        path.lineTo(xCoordinate, yCoordinate);
      }
      path.closePath();
    }
  }]);
  return Star;
}(_Marker0);
Star.className = "Star";

// packages/ag-charts-community/src/chart/marker/triangle.ts
var _Triangle = /*#__PURE__*/function (_Marker9) {
  _inherits(_Triangle, _Marker9);
  function _Triangle() {
    _classCallCheck(this, _Triangle);
    return _possibleConstructorReturn(this, _getPrototypeOf(_Triangle).apply(this, arguments));
  }
  _createClass(_Triangle, [{
    key: "updatePath",
    value: function updatePath() {
      var s = this.size * 1.1;
      _superPropGet(_Triangle, "applyPath", this, 3)([s, _Triangle.moves]);
    }
  }]);
  return _Triangle;
}(_Marker0);
_Triangle.className = "Triangle";
_Triangle.moves = [{
  x: 0,
  y: -0.48,
  t: "move"
}, {
  x: 0.5,
  y: 0.87
}, {
  x: -1,
  y: 0
}];
var _Triangle2 = _Triangle;

// packages/ag-charts-community/src/chart/marker/util.ts
var MARKER_SHAPES = {
  circle: _Circle,
  cross: Cross,
  diamond: _Diamond2,
  heart: Heart,
  pin: Pin,
  plus: Plus,
  square: _Square,
  star: Star,
  triangle: _Triangle2
};
var MARKER_SUPPORTED_SHAPES = Object.keys(MARKER_SHAPES);
function isMarkerShape(shape) {
  return typeof shape === "string" && MARKER_SUPPORTED_SHAPES.includes(shape);
}
function _getMarker() {
  var shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Square;
  if (isMarkerShape(shape)) {
    return MARKER_SHAPES[shape];
  }
  if (typeof shape === "function") {
    return shape;
  }
  return _Square;
}

// packages/ag-charts-community/src/chart/series/dataModelSeries.ts
var _DataModelSeries3 = /*#__PURE__*/function (_Series) {
  _inherits(DataModelSeries, _Series);
  function DataModelSeries() {
    var _this129;
    _classCallCheck(this, DataModelSeries);
    _this129 = _possibleConstructorReturn(this, _getPrototypeOf(DataModelSeries).apply(this, arguments));
    _this129.showFocusBox = true;
    return _this129;
  }
  _createClass(DataModelSeries, [{
    key: "getScaleInformation",
    value: function getScaleInformation(_ref122) {
      var xScale = _ref122.xScale,
        yScale = _ref122.yScale;
      var isContinuousX = _ContinuousScale5.is(xScale);
      var isContinuousY = _ContinuousScale5.is(yScale);
      return {
        isContinuousX: isContinuousX,
        isContinuousY: isContinuousY,
        xScaleType: xScale == null ? void 0 : xScale.type,
        yScaleType: yScale == null ? void 0 : yScale.type
      };
    }
  }, {
    key: "getModulePropertyDefinitions",
    value: function getModulePropertyDefinitions() {
      var _this130 = this;
      var _a, _b;
      var xScale = (_a = this.axes["x" /* X */]) == null ? void 0 : _a.scale;
      var yScale = (_b = this.axes["y" /* Y */]) == null ? void 0 : _b.scale;
      return this.moduleMap.mapModules(function (mod2) {
        return mod2.getPropertyDefinitions(_this130.getScaleInformation({
          xScale: xScale,
          yScale: yScale
        }));
      }).flat();
    } // Request data, but with message dispatching to series-options (modules).
  }, {
    key: "requestDataModel",
    value: function requestDataModel(dataController, data, opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee21() {
        var _opts$props;
        var _yield$dataController, dataModel, processedData;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              (_opts$props = opts.props).push.apply(_opts$props, _toConsumableArray(this.getModulePropertyDefinitions()));
              _context30.n = 1;
              return dataController.request(this.id, data != null ? data : [], opts);
            case 1:
              _yield$dataController = _context30.v;
              dataModel = _yield$dataController.dataModel;
              processedData = _yield$dataController.processedData;
              this.dataModel = dataModel;
              this.processedData = processedData;
              this.dispatch("data-processed", {
                dataModel: dataModel,
                processedData: processedData
              });
              return _context30.a(2, {
                dataModel: dataModel,
                processedData: processedData
              });
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "isProcessedDataAnimatable",
    value: function isProcessedDataAnimatable() {
      var _a, _b;
      var validationResults = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.animationValidation;
      if (!validationResults) {
        return true;
      }
      var orderedKeys = validationResults.orderedKeys,
        uniqueKeys = validationResults.uniqueKeys;
      return orderedKeys && uniqueKeys;
    }
  }, {
    key: "checkProcessedDataAnimatable",
    value: function checkProcessedDataAnimatable() {
      if (!this.isProcessedDataAnimatable()) {
        this.ctx.animationManager.skipCurrentBatch();
      }
    }
  }, {
    key: "pickFocus",
    value: function pickFocus(opts) {
      return this.doPickFocus(opts, this);
    } // The legend behaves differently for Pie and Donut series. We need to use a seriesItemEnabled
    // array to determine whether a datum has been toggled on/off using the legend.
  }, {
    key: "doPickFocus",
    value: function doPickFocus(opts, derivedSeries) {
      var nodeData = this.getNodeData();
      if (nodeData === void 0 || nodeData.length === 0) {
        return void 0;
      }
      var datumIndexDelta = opts.datumIndexDelta,
        seriesRect = opts.seriesRect;
      var datumIndex = this.computeFocusDatumIndex(opts, nodeData, derivedSeries.seriesItemEnabled);
      if (datumIndex === void 0) {
        return void 0;
      }
      var showFocusBox = this.showFocusBox;
      var datum = nodeData[datumIndex];
      var bbox = this.computeFocusBounds({
        datumIndex: datumIndex,
        datumIndexDelta: datumIndexDelta,
        seriesRect: seriesRect
      });
      if (bbox !== void 0) {
        return {
          bbox: bbox,
          showFocusBox: showFocusBox,
          datum: datum,
          datumIndex: datumIndex
        };
      }
    }
  }, {
    key: "computeFocusDatumIndex",
    value: function computeFocusDatumIndex(opts, nodeData, seriesItemEnabled) {
      if (seriesItemEnabled && nodeData.length !== seriesItemEnabled.length) {
        _Logger.error("invalid state: nodeData.length (".concat(nodeData.length, " !== seriesItemEnabled.length (").concat(seriesItemEnabled == null ? void 0 : seriesItemEnabled.length, ")"));
      }
      var isDatumEnabled = function isDatumEnabled(datumIndex2) {
        var nodeDatum = nodeData[datumIndex2];
        return (nodeDatum.missing === void 0 || nodeDatum.missing === false) && (seriesItemEnabled === void 0 || seriesItemEnabled[datumIndex2]);
      };
      var searchBackward = function searchBackward(datumIndex2) {
        while (datumIndex2 >= 0 && !isDatumEnabled(datumIndex2)) {
          datumIndex2--;
        }
        return datumIndex2 === -1 ? void 0 : datumIndex2;
      };
      var searchForward = function searchForward(datumIndex2) {
        while (datumIndex2 < nodeData.length && !isDatumEnabled(datumIndex2)) {
          datumIndex2++;
        }
        return datumIndex2 === nodeData.length ? void 0 : datumIndex2;
      };
      var datumIndex;
      var clampedIndex = _clamp(0, opts.datumIndex, nodeData.length - 1);
      if (opts.datumIndexDelta < 0) {
        datumIndex = searchBackward(clampedIndex);
      } else if (opts.datumIndexDelta > 0) {
        datumIndex = searchForward(clampedIndex);
      } else {
        datumIndex != null ? datumIndex : datumIndex = searchForward(clampedIndex);
        datumIndex != null ? datumIndex : datumIndex = searchBackward(clampedIndex);
      }
      if (datumIndex === void 0) {
        if (opts.datumIndexDelta === 0) {
          return void 0;
        } else {
          return opts.datumIndex - opts.datumIndexDelta;
        }
      } else {
        return datumIndex;
      }
    }
  }]);
  return DataModelSeries;
}(_Series2);

// packages/ag-charts-community/src/chart/series/seriesProperties.ts
var _SeriesItemHighlightStyle = /*#__PURE__*/function (_BaseProperties12) {
  _inherits(SeriesItemHighlightStyle, _BaseProperties12);
  function SeriesItemHighlightStyle() {
    var _this131;
    _classCallCheck(this, SeriesItemHighlightStyle);
    _this131 = _possibleConstructorReturn(this, _getPrototypeOf(SeriesItemHighlightStyle).apply(this, arguments));
    _this131.fill = "rgba(255,255,255, 0.33)";
    _this131.stroke = "rgba(0, 0, 0, 0.4)";
    _this131.strokeWidth = 2;
    return _this131;
  }
  return SeriesItemHighlightStyle;
}(_BaseProperties35);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], _SeriesItemHighlightStyle.prototype, "lineDashOffset", 2);
var SeriesHighlightStyle = /*#__PURE__*/function (_BaseProperties13) {
  _inherits(SeriesHighlightStyle, _BaseProperties13);
  function SeriesHighlightStyle() {
    _classCallCheck(this, SeriesHighlightStyle);
    return _possibleConstructorReturn(this, _getPrototypeOf(SeriesHighlightStyle).apply(this, arguments));
  }
  return SeriesHighlightStyle;
}(_BaseProperties35);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], SeriesHighlightStyle.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], SeriesHighlightStyle.prototype, "dimOpacity", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], SeriesHighlightStyle.prototype, "enabled", 2);
var TextHighlightStyle = /*#__PURE__*/function (_BaseProperties14) {
  _inherits(TextHighlightStyle, _BaseProperties14);
  function TextHighlightStyle() {
    var _this132;
    _classCallCheck(this, TextHighlightStyle);
    _this132 = _possibleConstructorReturn(this, _getPrototypeOf(TextHighlightStyle).apply(this, arguments));
    _this132.color = "black";
    return _this132;
  }
  return TextHighlightStyle;
}(_BaseProperties35);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], TextHighlightStyle.prototype, "color", 2);
var _HighlightStyle = /*#__PURE__*/function (_BaseProperties15) {
  _inherits(HighlightStyle, _BaseProperties15);
  function HighlightStyle() {
    var _this133;
    _classCallCheck(this, HighlightStyle);
    _this133 = _possibleConstructorReturn(this, _getPrototypeOf(HighlightStyle).apply(this, arguments));
    _this133.item = new _SeriesItemHighlightStyle();
    _this133.series = new SeriesHighlightStyle();
    _this133.text = new TextHighlightStyle();
    return _this133;
  }
  return HighlightStyle;
}(_BaseProperties35);
__decorateClass([_Validate(_OBJECT)], _HighlightStyle.prototype, "item", 2);
__decorateClass([_Validate(_OBJECT)], _HighlightStyle.prototype, "series", 2);
__decorateClass([_Validate(_OBJECT)], _HighlightStyle.prototype, "text", 2);
var _SeriesProperties4 = /*#__PURE__*/function (_BaseProperties16) {
  _inherits(SeriesProperties, _BaseProperties16);
  function SeriesProperties() {
    var _this134;
    _classCallCheck(this, SeriesProperties);
    _this134 = _possibleConstructorReturn(this, _getPrototypeOf(SeriesProperties).apply(this, arguments));
    _this134.visible = true;
    _this134.showInLegend = true;
    _this134.cursor = "default";
    _this134.nodeClickRange = "exact";
    _this134.highlightStyle = new _HighlightStyle();
    return _this134;
  }
  return SeriesProperties;
}(_BaseProperties35);
__decorateClass([_Validate(_STRING, {
  optional: true
})], _SeriesProperties4.prototype, "id", 2);
__decorateClass([_Validate(_BOOLEAN)], _SeriesProperties4.prototype, "visible", 2);
__decorateClass([_Validate(_BOOLEAN)], _SeriesProperties4.prototype, "showInLegend", 2);
__decorateClass([_Validate(_STRING)], _SeriesProperties4.prototype, "cursor", 2);
__decorateClass([_Validate(_INTERACTION_RANGE)], _SeriesProperties4.prototype, "nodeClickRange", 2);
__decorateClass([_Validate(_OBJECT)], _SeriesProperties4.prototype, "highlightStyle", 2);

// packages/ag-charts-community/src/chart/series/cartesian/cartesianSeries.ts
var _DEFAULT_CARTESIAN_DIRECTION_KEYS = _defineProperty(_defineProperty({}, "x" /* X */, ["xKey"]), "y" /* Y */, ["yKey"]);
var _DEFAULT_CARTESIAN_DIRECTION_NAMES = _defineProperty(_defineProperty({}, "x" /* X */, ["xName"]), "y" /* Y */, ["yName"]);
var _CartesianSeriesNodeEvent = /*#__PURE__*/function (_SeriesNodeEvent) {
  _inherits(CartesianSeriesNodeEvent, _SeriesNodeEvent);
  function CartesianSeriesNodeEvent(type, nativeEvent, datum, series) {
    var _this135;
    _classCallCheck(this, CartesianSeriesNodeEvent);
    _this135 = _possibleConstructorReturn(this, _getPrototypeOf(CartesianSeriesNodeEvent).call(this, type, nativeEvent, datum, series));
    _this135.xKey = series.properties.xKey;
    _this135.yKey = series.properties.yKey;
    return _this135;
  }
  return CartesianSeriesNodeEvent;
}(_SeriesNodeEvent4);
var _CartesianSeriesProperties = /*#__PURE__*/function (_SeriesProperties) {
  _inherits(CartesianSeriesProperties, _SeriesProperties);
  function CartesianSeriesProperties() {
    _classCallCheck(this, CartesianSeriesProperties);
    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianSeriesProperties).apply(this, arguments));
  }
  return CartesianSeriesProperties;
}(_SeriesProperties4);
__decorateClass([_Validate(_STRING, {
  optional: true
})], _CartesianSeriesProperties.prototype, "legendItemName", 2);
var _CartesianSeries7 = /*#__PURE__*/function (_DataModelSeries) {
  _inherits(CartesianSeries, _DataModelSeries);
  function CartesianSeries(_a) {
    var _this136;
    _classCallCheck(this, CartesianSeries);
    var _b = _a,
      _b$pathsPerSeries = _b.pathsPerSeries,
      pathsPerSeries = _b$pathsPerSeries === void 0 ? 1 : _b$pathsPerSeries,
      _b$hasMarkers = _b.hasMarkers,
      hasMarkers = _b$hasMarkers === void 0 ? false : _b$hasMarkers,
      _b$hasHighlightedLabe = _b.hasHighlightedLabels,
      hasHighlightedLabels = _b$hasHighlightedLabe === void 0 ? false : _b$hasHighlightedLabe,
      _b$pathsZIndexSubOrde = _b.pathsZIndexSubOrderOffset,
      pathsZIndexSubOrderOffset = _b$pathsZIndexSubOrde === void 0 ? [] : _b$pathsZIndexSubOrde,
      _b$datumSelectionGarb = _b.datumSelectionGarbageCollection,
      datumSelectionGarbageCollection = _b$datumSelectionGarb === void 0 ? true : _b$datumSelectionGarb,
      _b$markerSelectionGar = _b.markerSelectionGarbageCollection,
      markerSelectionGarbageCollection = _b$markerSelectionGar === void 0 ? true : _b$markerSelectionGar,
      _b$animationAlwaysUpd = _b.animationAlwaysUpdateSelections,
      animationAlwaysUpdateSelections = _b$animationAlwaysUpd === void 0 ? false : _b$animationAlwaysUpd,
      animationResetFns = _b.animationResetFns,
      directionKeys = _b.directionKeys,
      directionNames = _b.directionNames,
      otherOpts = __objRest(_b, ["pathsPerSeries", "hasMarkers", "hasHighlightedLabels", "pathsZIndexSubOrderOffset", "datumSelectionGarbageCollection", "markerSelectionGarbageCollection", "animationAlwaysUpdateSelections", "animationResetFns", "directionKeys", "directionNames"]);
    _this136 = _possibleConstructorReturn(this, _getPrototypeOf(CartesianSeries).call(this, __spreadValues({
      directionKeys: directionKeys,
      directionNames: directionNames,
      canHaveAxes: true
    }, otherOpts)));
    _this136.NodeEvent = _CartesianSeriesNodeEvent;
    _this136.dataNodeGroup = _this136.contentGroup.appendChild(new _Group4({
      name: "".concat(_this136.id, "-series-dataNodes"),
      zIndex: 4 /* SERIES_LAYER_ZINDEX */,
      zIndexSubOrder: _this136.getGroupZIndexSubOrder("data")
    }));
    _this136.markerGroup = _this136.contentGroup.appendChild(new _Group4({
      name: "".concat(_this136.id, "-series-markers"),
      zIndex: 4 /* SERIES_LAYER_ZINDEX */,
      zIndexSubOrder: _this136.getGroupZIndexSubOrder("marker")
    }));
    _this136.labelGroup = _this136.contentGroup.appendChild(new _Group4({
      name: "".concat(_this136.id, "-series-labels"),
      zIndex: 8 /* SERIES_LABEL_ZINDEX */,
      zIndexSubOrder: _this136.getGroupZIndexSubOrder("labels")
    }));
    _this136.labelSelection = _Selection2.select(_this136.labelGroup, _Text2);
    _this136.highlightSelection = _Selection2.select(_this136.highlightNode, function () {
      return _this136.opts.hasMarkers ? _this136.markerFactory() : _this136.nodeFactory();
    });
    _this136.highlightLabelSelection = _Selection2.select(_this136.highlightLabel, _Text2);
    _this136.annotationSelections = /* @__PURE__ */new Set();
    _this136.minRectsCache = {
      dirtyNodeData: true
    };
    _this136.debug = Debug.create();
    if (!directionKeys || !directionNames) throw new Error("Unable to initialise series type ".concat(_this136.type));
    _this136.opts = {
      pathsPerSeries: pathsPerSeries,
      hasMarkers: hasMarkers,
      hasHighlightedLabels: hasHighlightedLabels,
      pathsZIndexSubOrderOffset: pathsZIndexSubOrderOffset,
      directionKeys: directionKeys,
      directionNames: directionNames,
      animationResetFns: animationResetFns,
      animationAlwaysUpdateSelections: animationAlwaysUpdateSelections,
      datumSelectionGarbageCollection: datumSelectionGarbageCollection,
      markerSelectionGarbageCollection: markerSelectionGarbageCollection
    };
    _this136.paths = [];
    for (var index = 0; index < pathsPerSeries; index++) {
      _this136.paths[index] = new _Path6();
      _this136.paths[index].zIndex = 4 /* SERIES_LAYER_ZINDEX */;
      _this136.paths[index].zIndexSubOrder = _this136.getGroupZIndexSubOrder("paths", index);
      _this136.contentGroup.appendChild(_this136.paths[index]);
    }
    _this136.datumSelection = _Selection2.select(_this136.dataNodeGroup, function () {
      return _this136.nodeFactory();
    }, datumSelectionGarbageCollection);
    _this136.markerSelection = _Selection2.select(_this136.markerGroup, function () {
      return _this136.markerFactory();
    }, markerSelectionGarbageCollection);
    _this136.animationState = new _StateMachine("empty", {
      empty: {
        update: {
          target: "ready",
          action: function action(data) {
            return _this136.animateEmptyUpdateReady(data);
          }
        },
        reset: "empty",
        skip: "ready",
        disable: "disabled"
      },
      ready: {
        updateData: "waiting",
        clear: "clearing",
        highlight: function highlight(data) {
          return _this136.animateReadyHighlight(data);
        },
        highlightMarkers: function highlightMarkers(data) {
          return _this136.animateReadyHighlightMarkers(data);
        },
        resize: function resize(data) {
          return _this136.animateReadyResize(data);
        },
        reset: "empty",
        skip: "ready",
        disable: "disabled"
      },
      waiting: {
        update: {
          target: "ready",
          action: function action(data) {
            return _this136.animateWaitingUpdateReady(data);
          }
        },
        reset: "empty",
        skip: "ready",
        disable: "disabled"
      },
      disabled: {
        update: function update(data) {
          return _this136.resetAllAnimation(data);
        },
        reset: "empty"
      },
      clearing: {
        update: {
          target: "empty",
          action: function action(data) {
            return _this136.animateClearingUpdateEmpty(data);
          }
        },
        reset: "empty",
        skip: "ready"
      }
    }, function () {
      return _this136.checkProcessedDataAnimatable();
    });
    return _this136;
  }
  _createClass(CartesianSeries, [{
    key: "getNodeData",
    value: function getNodeData() {
      var _a;
      return (_a = this.contextNodeData) == null ? void 0 : _a.nodeData;
    }
  }, {
    key: "resetAnimation",
    value: function resetAnimation(phase) {
      if (phase === "initial") {
        this.animationState.transition("reset");
      } else if (phase === "ready") {
        this.animationState.transition("skip");
      } else if (phase === "disabled") {
        this.animationState.transition("disable");
      }
    }
  }, {
    key: "addChartEventListeners",
    value: function addChartEventListeners() {
      var _this137 = this;
      this.destroyFns.push(this.ctx.chartEventManager.addListener("legend-item-click", function (event) {
        return _this137.onLegendItemClick(event);
      }), this.ctx.chartEventManager.addListener("legend-item-double-click", function (event) {
        return _this137.onLegendItemDoubleClick(event);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(CartesianSeries, "destroy", this, 3)([]);
      this._contextNodeData = void 0;
    }
  }, {
    key: "update",
    value: function update(_0) {
      return __async(this, arguments, function (_ref123) {
        var _this138 = this;
        var seriesRect = _ref123.seriesRect;
        return /*#__PURE__*/_regenerator().m(function _callee22() {
          var _a, _b, visible, previousContextData, series, seriesHighlighted, resize, highlightItems, animationData;
          return _regenerator().w(function (_context31) {
            while (1) switch (_context31.n) {
              case 0:
                visible = _this138.visible, previousContextData = _this138._contextNodeData;
                series = (_b = (_a = _this138.ctx.highlightManager) == null ? void 0 : _a.getActiveHighlight()) == null ? void 0 : _b.series;
                seriesHighlighted = series === _this138;
                resize = _this138.checkResize(seriesRect);
                _context31.n = 1;
                return _this138.updateHighlightSelection(seriesHighlighted);
              case 1:
                highlightItems = _context31.v;
                _context31.n = 2;
                return _this138.updateSelections(visible);
              case 2:
                _context31.n = 3;
                return _this138.updateNodes(highlightItems, seriesHighlighted, visible);
              case 3:
                animationData = _this138.getAnimationData(seriesRect, previousContextData);
                if (animationData) {
                  _context31.n = 4;
                  break;
                }
                return _context31.a(2);
              case 4:
                if (resize) {
                  _this138.animationState.transition("resize", animationData);
                }
                _this138.animationState.transition("update", animationData);
              case 5:
                return _context31.a(2);
            }
          }, _callee22);
        })();
      });
    }
  }, {
    key: "updateSelections",
    value: function updateSelections(anySeriesItemEnabled) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee23() {
        var _a, _b, animationSkipUpdate, animationValid, dataModel, processedData;
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              animationSkipUpdate = !this.opts.animationAlwaysUpdateSelections && this.ctx.animationManager.isSkipped();
              if (!(!anySeriesItemEnabled && animationSkipUpdate)) {
                _context32.n = 1;
                break;
              }
              return _context32.a(2);
            case 1:
              if (!(!this.nodeDataRefresh && !this.isPathOrSelectionDirty())) {
                _context32.n = 2;
                break;
              }
              return _context32.a(2);
            case 2:
              if (!this.nodeDataRefresh) {
                _context32.n = 4;
                break;
              }
              this.nodeDataRefresh = false;
              this.debug("CartesianSeries.updateSelections() - calling createNodeData() for", this.id);
              this.markQuadtreeDirty();
              _context32.n = 3;
              return this.createNodeData();
            case 3:
              this._contextNodeData = _context32.v;
              animationValid = this.isProcessedDataAnimatable();
              if (this._contextNodeData) {
                (_b = (_a = this._contextNodeData).animationValid) != null ? _b : _a.animationValid = animationValid;
              }
              this.minRectsCache.dirtyNodeData = true;
              dataModel = this.dataModel, processedData = this.processedData;
              if (dataModel !== void 0 && processedData !== void 0) {
                this.dispatch("data-update", {
                  dataModel: dataModel,
                  processedData: processedData
                });
              }
            case 4:
              _context32.n = 5;
              return this.updateSeriesSelections();
            case 5:
              return _context32.a(2);
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "updateSeriesSelections",
    value: function updateSeriesSelections(seriesHighlighted) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee24() {
        var datumSelection, labelSelection, markerSelection, paths, contextData, nodeData, labelData, itemId;
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.n) {
            case 0:
              datumSelection = this.datumSelection, labelSelection = this.labelSelection, markerSelection = this.markerSelection, paths = this.paths;
              contextData = this._contextNodeData;
              if (contextData) {
                _context33.n = 1;
                break;
              }
              return _context33.a(2);
            case 1:
              nodeData = contextData.nodeData, labelData = contextData.labelData, itemId = contextData.itemId;
              _context33.n = 2;
              return this.updatePaths({
                seriesHighlighted: seriesHighlighted,
                itemId: itemId,
                contextData: contextData,
                paths: paths
              });
            case 2:
              _context33.n = 3;
              return this.updateDatumSelection({
                nodeData: nodeData,
                datumSelection: datumSelection
              });
            case 3:
              this.datumSelection = _context33.v;
              _context33.n = 4;
              return this.updateLabelSelection({
                labelData: labelData,
                labelSelection: labelSelection
              });
            case 4:
              this.labelSelection = _context33.v;
              if (!this.opts.hasMarkers) {
                _context33.n = 6;
                break;
              }
              _context33.n = 5;
              return this.updateMarkerSelection({
                nodeData: nodeData,
                markerSelection: markerSelection
              });
            case 5:
              this.markerSelection = _context33.v;
            case 6:
              return _context33.a(2);
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "markerFactory",
    value: function markerFactory() {
      var MarkerShape = _getMarker();
      return new MarkerShape();
    }
  }, {
    key: "getGroupZIndexSubOrder",
    value: function getGroupZIndexSubOrder(type) {
      var subIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _a;
      var result = _superPropGet(CartesianSeries, "getGroupZIndexSubOrder", this, 3)([type, subIndex]);
      if (type === "paths") {
        var _result = _slicedToArray(result, 1),
          superFn = _result[0];
        var pathOffset = (_a = this.opts.pathsZIndexSubOrderOffset[subIndex]) != null ? _a : 0;
        result[0] = _isFunction(superFn) ? function () {
          return Number(superFn()) + pathOffset;
        } : Number(superFn) + pathOffset;
      }
      return result;
    }
  }, {
    key: "updateNodes",
    value: function updateNodes(highlightedItems, seriesHighlighted, anySeriesItemEnabled) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee25() {
        var _a, highlightSelection, highlightLabelSelection, _this$opts4, hasMarkers, hasHighlightedLabels, animationEnabled, visible, opacity, dataNodeGroup, markerGroup, datumSelection, labelSelection, markerSelection, paths, labelGroup, _ref124, itemId;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              highlightSelection = this.highlightSelection, highlightLabelSelection = this.highlightLabelSelection, _this$opts4 = this.opts, hasMarkers = _this$opts4.hasMarkers, hasHighlightedLabels = _this$opts4.hasHighlightedLabels;
              animationEnabled = !this.ctx.animationManager.isSkipped();
              visible = this.visible && this._contextNodeData != null && anySeriesItemEnabled;
              this.rootGroup.visible = animationEnabled || visible;
              this.contentGroup.visible = animationEnabled || visible;
              this.highlightGroup.visible = (animationEnabled || visible) && seriesHighlighted;
              opacity = this.getOpacity();
              if (!hasMarkers) {
                _context34.n = 2;
                break;
              }
              _context34.n = 1;
              return this.updateMarkerNodes({
                markerSelection: highlightSelection,
                isHighlight: true
              });
            case 1:
              this.animationState.transition("highlightMarkers", highlightSelection);
              _context34.n = 4;
              break;
            case 2:
              _context34.n = 3;
              return this.updateDatumNodes({
                datumSelection: highlightSelection,
                isHighlight: true
              });
            case 3:
              this.animationState.transition("highlight", highlightSelection);
            case 4:
              if (!hasHighlightedLabels) {
                _context34.n = 5;
                break;
              }
              _context34.n = 5;
              return this.updateLabelNodes({
                labelSelection: highlightLabelSelection
              });
            case 5:
              dataNodeGroup = this.dataNodeGroup, markerGroup = this.markerGroup, datumSelection = this.datumSelection, labelSelection = this.labelSelection, markerSelection = this.markerSelection, paths = this.paths, labelGroup = this.labelGroup;
              _ref124 = (_a = this.contextNodeData) != null ? _a : {}, itemId = _ref124.itemId;
              dataNodeGroup.opacity = opacity;
              dataNodeGroup.visible = animationEnabled || visible;
              labelGroup.visible = visible;
              if (hasMarkers) {
                markerGroup.opacity = opacity;
                markerGroup.zIndex = dataNodeGroup.zIndex >= 4 /* SERIES_LAYER_ZINDEX */ ? dataNodeGroup.zIndex : dataNodeGroup.zIndex + 1;
                markerGroup.visible = visible;
              }
              if (labelGroup) {
                labelGroup.opacity = opacity;
              }
              _context34.n = 6;
              return this.updatePathNodes({
                seriesHighlighted: seriesHighlighted,
                itemId: itemId,
                paths: paths,
                opacity: opacity,
                visible: visible,
                animationEnabled: animationEnabled
              });
            case 6:
              if (dataNodeGroup.visible) {
                _context34.n = 7;
                break;
              }
              return _context34.a(2);
            case 7:
              _context34.n = 8;
              return this.updateDatumNodes({
                datumSelection: datumSelection,
                highlightedItems: highlightedItems,
                isHighlight: false
              });
            case 8:
              _context34.n = 9;
              return this.updateLabelNodes({
                labelSelection: labelSelection
              });
            case 9:
              if (!hasMarkers) {
                _context34.n = 10;
                break;
              }
              _context34.n = 10;
              return this.updateMarkerNodes({
                markerSelection: markerSelection,
                isHighlight: false
              });
            case 10:
              return _context34.a(2);
          }
        }, _callee25, this);
      }));
    }
  }, {
    key: "getHighlightLabelData",
    value: function getHighlightLabelData(labelData, highlightedItem) {
      var labelItems = labelData.filter(function (ld) {
        return ld.datum === highlightedItem.datum && ld.itemId === highlightedItem.itemId;
      });
      return labelItems.length === 0 ? void 0 : labelItems;
    }
  }, {
    key: "getHighlightData",
    value: function getHighlightData(_nodeData, highlightedItem) {
      return highlightedItem ? [highlightedItem] : void 0;
    }
  }, {
    key: "updateHighlightSelection",
    value: function updateHighlightSelection(seriesHighlighted) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee26() {
        var _a, highlightSelection, highlightLabelSelection, contextNodeData, highlightedDatum, item, labelItems, highlightItems, labelsEnabled, labelData, nodeData;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.n) {
            case 0:
              highlightSelection = this.highlightSelection, highlightLabelSelection = this.highlightLabelSelection, contextNodeData = this._contextNodeData;
              if (contextNodeData) {
                _context35.n = 1;
                break;
              }
              return _context35.a(2);
            case 1:
              highlightedDatum = (_a = this.ctx.highlightManager) == null ? void 0 : _a.getActiveHighlight();
              item = seriesHighlighted && (highlightedDatum == null ? void 0 : highlightedDatum.datum) ? highlightedDatum : void 0;
              if (item != null) {
                labelsEnabled = this.isLabelEnabled();
                labelData = contextNodeData.labelData, nodeData = contextNodeData.nodeData;
                highlightItems = this.getHighlightData(nodeData, item);
                labelItems = labelsEnabled ? this.getHighlightLabelData(labelData, item) : void 0;
              }
              _context35.n = 2;
              return this.updateHighlightSelectionItem({
                items: highlightItems,
                highlightSelection: highlightSelection
              });
            case 2:
              this.highlightSelection = _context35.v;
              _context35.n = 3;
              return this.updateHighlightSelectionLabel({
                items: labelItems,
                highlightLabelSelection: highlightLabelSelection
              });
            case 3:
              this.highlightLabelSelection = _context35.v;
              return _context35.a(2, highlightItems);
          }
        }, _callee26, this);
      }));
    }
  }, {
    key: "markQuadtreeDirty",
    value: function markQuadtreeDirty() {
      this.quadtree = void 0;
    }
  }, {
    key: "datumNodesIter",
    value: /*#__PURE__*/_regenerator().m(function datumNodesIter() {
      var _iterator186, _step186, node, _t10;
      return _regenerator().w(function (_context36) {
        while (1) switch (_context36.p = _context36.n) {
          case 0:
            _iterator186 = _createForOfIteratorHelper(this.datumSelection);
            _context36.p = 1;
            _iterator186.s();
          case 2:
            if ((_step186 = _iterator186.n()).done) {
              _context36.n = 5;
              break;
            }
            node = _step186.value.node;
            if (!(node.datum.missing === true)) {
              _context36.n = 3;
              break;
            }
            return _context36.a(3, 4);
          case 3:
            _context36.n = 4;
            return node;
          case 4:
            _context36.n = 2;
            break;
          case 5:
            _context36.n = 7;
            break;
          case 6:
            _context36.p = 6;
            _t10 = _context36.v;
            _iterator186.e(_t10);
          case 7:
            _context36.p = 7;
            _iterator186.f();
            return _context36.f(7);
          case 8:
            return _context36.a(2);
        }
      }, datumNodesIter, this, [[1, 6, 7, 8]]);
    })
  }, {
    key: "getQuadTree",
    value: function getQuadTree() {
      if (this.quadtree === void 0) {
        var _this$ctx$scene$canva = this.ctx.scene.canvas,
          width = _this$ctx$scene$canva.width,
          height = _this$ctx$scene$canva.height;
        var canvasRect = new _BBox2(0, 0, width, height);
        this.quadtree = new QuadtreeNearest(100, 10, canvasRect);
        this.initQuadTree(this.quadtree);
      }
      return this.quadtree;
    }
  }, {
    key: "initQuadTree",
    value: function initQuadTree(_quadtree) {}
  }, {
    key: "pickNodeExactShape",
    value: function pickNodeExactShape(point) {
      var _a;
      var result = _superPropGet(CartesianSeries, "pickNodeExactShape", this, 3)([point]);
      if (result) {
        return result;
      }
      var x = point.x,
        y = point.y;
      var hasMarkers = this.opts.hasMarkers;
      var match;
      var dataNodeGroup = this.dataNodeGroup,
        markerGroup = this.markerGroup;
      match = dataNodeGroup.pickNode(x, y);
      if (!match && hasMarkers) {
        match = markerGroup == null ? void 0 : markerGroup.pickNode(x, y);
      }
      if (match && match.datum.missing !== true) {
        return {
          datum: match.datum,
          distance: 0
        };
      }
      var _iterator187 = _createForOfIteratorHelper(this.moduleMap.modules()),
        _step187;
      try {
        for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
          var mod2 = _step187.value;
          var _ref125 = (_a = mod2.pickNodeExact(point)) != null ? _a : {},
            datum = _ref125.datum;
          if (datum == null) continue;
          if ((datum == null ? void 0 : datum.missing) === true) continue;
          return {
            datum: datum,
            distance: 0
          };
        }
      } catch (err) {
        _iterator187.e(err);
      } finally {
        _iterator187.f();
      }
    }
  }, {
    key: "pickNodeClosestDatum",
    value: function pickNodeClosestDatum(point) {
      var _a, _b;
      var x = point.x,
        y = point.y;
      var axes = this.axes,
        rootGroup = this.rootGroup,
        contextNodeData = this._contextNodeData;
      if (!contextNodeData) return;
      var xAxis = axes["x" /* X */];
      var yAxis = axes["y" /* Y */];
      var hitPoint = rootGroup.transformPoint(x, y);
      var minDistance = Infinity;
      var closestDatum;
      var _iterator188 = _createForOfIteratorHelper(contextNodeData.nodeData),
        _step188;
      try {
        for (_iterator188.s(); !(_step188 = _iterator188.n()).done;) {
          var datum = _step188.value;
          var _datum$point2 = datum.point,
            _datum$point3 = _datum$point2 === void 0 ? {} : _datum$point2,
            _datum$point3$x = _datum$point3.x,
            datumX = _datum$point3$x === void 0 ? NaN : _datum$point3$x,
            _datum$point3$y = _datum$point3.y,
            datumY = _datum$point3$y === void 0 ? NaN : _datum$point3$y;
          if (isNaN(datumX) || isNaN(datumY)) {
            continue;
          }
          var isInRange = (xAxis == null ? void 0 : xAxis.inRange(datumX)) && (yAxis == null ? void 0 : yAxis.inRange(datumY));
          if (!isInRange) {
            continue;
          }
          var _distance = Math.max(__pow(hitPoint.x - datumX, 2) + __pow(hitPoint.y - datumY, 2), 0);
          if (_distance < minDistance) {
            minDistance = _distance;
            closestDatum = datum;
          }
        }
      } catch (err) {
        _iterator188.e(err);
      } finally {
        _iterator188.f();
      }
      var _iterator189 = _createForOfIteratorHelper(this.moduleMap.modules()),
        _step189;
      try {
        for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
          var mod2 = _step189.value;
          var modPick = mod2.pickNodeNearest(point);
          if (modPick !== void 0 && modPick.distanceSquared < minDistance) {
            minDistance = modPick.distanceSquared;
            closestDatum = modPick.datum;
            break;
          }
        }
      } catch (err) {
        _iterator189.e(err);
      } finally {
        _iterator189.f();
      }
      if (closestDatum) {
        var distance2 = Math.max(Math.sqrt(minDistance) - ((_b = (_a = closestDatum.point) == null ? void 0 : _a.size) != null ? _b : 0), 0);
        return {
          datum: closestDatum,
          distance: distance2
        };
      }
    }
  }, {
    key: "pickNodeMainAxisFirst",
    value: function pickNodeMainAxisFirst(point, requireCategoryAxis) {
      var _a, _b, _c, _d;
      var x = point.x,
        y = point.y;
      var axes = this.axes,
        rootGroup = this.rootGroup,
        contextNodeData = this._contextNodeData;
      if (!contextNodeData) return;
      var xAxis = axes["x" /* X */];
      var yAxis = axes["y" /* Y */];
      var directions2 = [xAxis, yAxis].filter(function (a) {
        return a instanceof _CategoryAxis;
      }).map(function (a) {
        return a.direction;
      });
      if (requireCategoryAxis && directions2.length === 0) {
        return;
      }
      var _directions = _slicedToArray(directions2, 1),
        _directions$ = _directions[0],
        primaryDirection = _directions$ === void 0 ? "x" : _directions$;
      var hitPoint = rootGroup.transformPoint(x, y);
      var hitPointCoords = primaryDirection === "x" /* X */ ? [hitPoint.x, hitPoint.y] : [hitPoint.y, hitPoint.x];
      var minDistance = [Infinity, Infinity];
      var closestDatum;
      var _iterator190 = _createForOfIteratorHelper(contextNodeData.nodeData),
        _step190;
      try {
        for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
          var datum = _step190.value;
          var _ref126 = (_b = (_a = datum.point) != null ? _a : datum.midPoint) != null ? _b : {},
            _ref126$x = _ref126.x,
            datumX = _ref126$x === void 0 ? NaN : _ref126$x,
            _ref126$y = _ref126.y,
            datumY = _ref126$y === void 0 ? NaN : _ref126$y;
          if (isNaN(datumX) || isNaN(datumY) || datum.missing === true) {
            continue;
          }
          var isInRange = (xAxis == null ? void 0 : xAxis.inRange(datumX)) && (yAxis == null ? void 0 : yAxis.inRange(datumY));
          if (!isInRange) {
            continue;
          }
          var datumPoint = primaryDirection === "x" /* X */ ? [datumX, datumY] : [datumY, datumX];
          var newMinDistance = true;
          for (var i = 0; i < datumPoint.length; i++) {
            var dist = Math.abs(datumPoint[i] - hitPointCoords[i]);
            if (dist > minDistance[i]) {
              newMinDistance = false;
              break;
            }
            if (dist < minDistance[i]) {
              minDistance[i] = dist;
              minDistance.fill(Infinity, i + 1, minDistance.length);
            }
          }
          if (newMinDistance) {
            closestDatum = datum;
          }
        }
      } catch (err) {
        _iterator190.e(err);
      } finally {
        _iterator190.f();
      }
      if (closestDatum) {
        var closestDistanceSquared = Math.max(__pow(minDistance[0], 2) + __pow(minDistance[1], 2) - ((_d = (_c = closestDatum.point) == null ? void 0 : _c.size) != null ? _d : 0), 0);
        var _iterator191 = _createForOfIteratorHelper(this.moduleMap.modules()),
          _step191;
        try {
          for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
            var mod2 = _step191.value;
            var modPick = mod2.pickNodeMainAxisFirst(point);
            if (modPick !== void 0 && modPick.distanceSquared < closestDistanceSquared) {
              closestDatum = modPick.datum;
              closestDistanceSquared = modPick.distanceSquared;
              break;
            }
          }
        } catch (err) {
          _iterator191.e(err);
        } finally {
          _iterator191.f();
        }
        return {
          datum: closestDatum,
          distance: Math.sqrt(closestDistanceSquared)
        };
      }
    }
  }, {
    key: "onLegendItemClick",
    value: function onLegendItemClick(event) {
      var legendItemName = this.properties.legendItemName;
      var enabled = event.enabled,
        itemId = event.itemId,
        series = event.series;
      var matchedLegendItemName = legendItemName != null && legendItemName === event.legendItemName;
      if (series.id === this.id || matchedLegendItemName) {
        this.toggleSeriesItem(itemId, enabled);
      }
    }
  }, {
    key: "onLegendItemDoubleClick",
    value: function onLegendItemDoubleClick(event) {
      var enabled = event.enabled,
        itemId = event.itemId,
        series = event.series,
        numVisibleItems = event.numVisibleItems;
      var legendItemName = this.properties.legendItemName;
      var matchedLegendItemName = legendItemName != null && legendItemName === event.legendItemName;
      if (series.id === this.id || matchedLegendItemName) {
        this.toggleSeriesItem(itemId, true);
      } else if (enabled && numVisibleItems === 1) {
        this.toggleSeriesItem(itemId, true);
      } else {
        this.toggleSeriesItem(itemId, false);
      }
    }
  }, {
    key: "isPathOrSelectionDirty",
    value: function isPathOrSelectionDirty() {
      return false;
    }
  }, {
    key: "getLabelData",
    value: function getLabelData() {
      return [];
    }
  }, {
    key: "shouldFlipXY",
    value: function shouldFlipXY() {
      return false;
    }
    /**
     * Get the minimum bounding box that contains any adjacent two nodes. The axes are treated independently, so this
     * may not represent the same two points for both directions. The dimensions represent the greatest distance
     * between any two adjacent nodes.
     */
  }, {
    key: "getMinRects",
    value: function getMinRects(width, height) {
      var _this$minRectsCache = this.minRectsCache,
        dirtyNodeData = _this$minRectsCache.dirtyNodeData,
        sizeCache = _this$minRectsCache.sizeCache,
        minRect = _this$minRectsCache.minRect,
        minVisibleRect = _this$minRectsCache.minVisibleRect;
      var newSizeCache = JSON.stringify({
        width: width,
        height: height
      });
      var dirtySize = newSizeCache !== sizeCache;
      if (!dirtySize && !dirtyNodeData && minRect && minVisibleRect) {
        return {
          minRect: minRect,
          minVisibleRect: minVisibleRect
        };
      }
      var rects = this.computeMinRects(width, height);
      this.minRectsCache = {
        dirtyNodeData: false,
        sizeCache: newSizeCache,
        minRect: rects == null ? void 0 : rects.minRect,
        minVisibleRect: rects == null ? void 0 : rects.minVisibleRect
      };
      return rects;
    }
  }, {
    key: "computeMinRects",
    value: function computeMinRects(width, height) {
      var _a, _b;
      var context = this._contextNodeData;
      if (!(context == null ? void 0 : context.nodeData.length)) {
        return;
      }
      var nodeData = context.nodeData;
      var minRectXs = Array(nodeData.length);
      var minRectYs = Array(nodeData.length);
      var _iterator192 = _createForOfIteratorHelper(nodeData.entries()),
        _step192;
      try {
        for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
          var _step192$value = _slicedToArray(_step192.value, 2),
            _i27 = _step192$value[0],
            midPoint = _step192$value[1].midPoint;
          minRectXs[_i27] = (_a = midPoint == null ? void 0 : midPoint.x) != null ? _a : 0;
          minRectYs[_i27] = (_b = midPoint == null ? void 0 : midPoint.y) != null ? _b : 0;
        }
      } catch (err) {
        _iterator192.e(err);
      } finally {
        _iterator192.f();
      }
      minRectXs.sort(function (a, b) {
        return a - b;
      });
      minRectYs.sort(function (a, b) {
        return a - b;
      });
      var zeroX, widthX, zeroY, heightY;
      var maxWidth = 0;
      var maxHeight = 0;
      for (var i = 1; i < nodeData.length; i++) {
        if (minRectXs[i] >= 0) zeroX != null ? zeroX : zeroX = i;
        if (minRectXs[i] > width) widthX != null ? widthX : widthX = i;
        if (minRectYs[i] >= 0) zeroY != null ? zeroY : zeroY = i;
        if (minRectYs[i] > height) heightY != null ? heightY : heightY = i;
        maxWidth = Math.max(maxWidth, minRectXs[i] - minRectXs[i - 1]);
        maxHeight = Math.max(maxHeight, minRectYs[i] - minRectYs[i - 1]);
      }
      widthX != null ? widthX : widthX = nodeData.length;
      heightY != null ? heightY : heightY = nodeData.length;
      var minVisibleRectXs = zeroX != null && widthX != null ? minRectXs.slice(zeroX, widthX) : [];
      var minVisibleRectYs = zeroY != null && heightY != null ? minRectYs.slice(zeroY, heightY) : [];
      var maxVisibleWidth = 0;
      var maxVisibleHeight = 0;
      for (var _i26 = 1; _i26 < Math.max(minVisibleRectXs.length, minVisibleRectYs.length); _i26++) {
        var x1 = minVisibleRectXs[_i26];
        var x2 = minVisibleRectXs[_i26 - 1];
        var y1 = minVisibleRectYs[_i26];
        var y2 = minVisibleRectYs[_i26 - 1];
        if (x1 != null && x2 != null) {
          maxVisibleWidth = Math.max(maxVisibleWidth, x1 - x2);
        }
        if (y1 != null && y2 != null) {
          maxVisibleHeight = Math.max(maxVisibleHeight, y1 - y2);
        }
      }
      var minRect = new _BBox2(0, 0, maxWidth, maxHeight);
      var minVisibleRect = new _BBox2(0, 0, maxVisibleWidth, maxVisibleHeight);
      return {
        minRect: minRect,
        minVisibleRect: minVisibleRect
      };
    }
  }, {
    key: "updateHighlightSelectionItem",
    value: function updateHighlightSelectionItem(opts) {
      var hasMarkers = this.opts.hasMarkers;
      var items = opts.items,
        highlightSelection = opts.highlightSelection;
      var nodeData = items != null ? items : [];
      if (hasMarkers) {
        var markerSelection = highlightSelection;
        return this.updateMarkerSelection({
          nodeData: nodeData,
          markerSelection: markerSelection
        });
      } else {
        return this.updateDatumSelection({
          nodeData: nodeData,
          datumSelection: highlightSelection
        });
      }
    }
  }, {
    key: "updateHighlightSelectionLabel",
    value: function updateHighlightSelectionLabel(opts) {
      var _a;
      return this.updateLabelSelection({
        labelData: (_a = opts.items) != null ? _a : [],
        labelSelection: opts.highlightLabelSelection
      });
    }
  }, {
    key: "updateDatumSelection",
    value: function updateDatumSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee27() {
        return _regenerator().w(function (_context37) {
          while (1) switch (_context37.n) {
            case 0:
              return _context37.a(2, opts.datumSelection);
          }
        }, _callee27);
      }));
    }
  }, {
    key: "updateDatumNodes",
    value: function updateDatumNodes(_opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee28() {
        return _regenerator().w(function (_context38) {
          while (1) switch (_context38.n) {
            case 0:
              return _context38.a(2);
          }
        }, _callee28);
      }));
    }
  }, {
    key: "updateMarkerSelection",
    value: function updateMarkerSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee29() {
        return _regenerator().w(function (_context39) {
          while (1) switch (_context39.n) {
            case 0:
              return _context39.a(2, opts.markerSelection);
          }
        }, _callee29);
      }));
    }
  }, {
    key: "updateMarkerNodes",
    value: function updateMarkerNodes(_opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee30() {
        return _regenerator().w(function (_context40) {
          while (1) switch (_context40.n) {
            case 0:
              return _context40.a(2);
          }
        }, _callee30);
      }));
    }
  }, {
    key: "updatePaths",
    value: function updatePaths(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee31() {
        return _regenerator().w(function (_context41) {
          while (1) switch (_context41.n) {
            case 0:
              opts.paths.forEach(function (p) {
                return p.visible = false;
              });
            case 1:
              return _context41.a(2);
          }
        }, _callee31);
      }));
    }
  }, {
    key: "updatePathNodes",
    value: function updatePathNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee32() {
        var paths, opacity, visible, _iterator193, _step193, path;
        return _regenerator().w(function (_context42) {
          while (1) switch (_context42.n) {
            case 0:
              paths = opts.paths, opacity = opts.opacity, visible = opts.visible;
              _iterator193 = _createForOfIteratorHelper(paths);
              try {
                for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
                  path = _step193.value;
                  path.opacity = opacity;
                  path.visible = visible;
                }
              } catch (err) {
                _iterator193.e(err);
              } finally {
                _iterator193.f();
              }
            case 1:
              return _context42.a(2);
          }
        }, _callee32);
      }));
    }
  }, {
    key: "resetAllAnimation",
    value: function resetAllAnimation(data) {
      var _a, _b, _c;
      var _ref127 = (_b = (_a = this.opts) == null ? void 0 : _a.animationResetFns) != null ? _b : {},
        path = _ref127.path,
        datum = _ref127.datum,
        label = _ref127.label,
        marker = _ref127.marker;
      this.ctx.animationManager.stopByAnimationGroupId(this.id);
      if (path) {
        data.paths.forEach(function (paths) {
          _resetMotion([paths], path);
        });
      }
      if (datum) {
        _resetMotion([data.datumSelection], datum);
      }
      if (label) {
        _resetMotion([data.labelSelection], label);
      }
      if (marker && this.opts.hasMarkers) {
        _resetMotion([data.markerSelection], marker);
      }
      if (((_c = data.contextData) == null ? void 0 : _c.animationValid) === false) {
        this.ctx.animationManager.skipCurrentBatch();
      }
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation(data);
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation(data);
    }
  }, {
    key: "animateReadyHighlight",
    value: function animateReadyHighlight(data) {
      var _a, _b;
      var _ref128 = (_b = (_a = this.opts) == null ? void 0 : _a.animationResetFns) != null ? _b : {},
        datum = _ref128.datum;
      if (datum) {
        _resetMotion([data], datum);
      }
    }
  }, {
    key: "animateReadyHighlightMarkers",
    value: function animateReadyHighlightMarkers(data) {
      var _a, _b;
      var _ref129 = (_b = (_a = this.opts) == null ? void 0 : _a.animationResetFns) != null ? _b : {},
        marker = _ref129.marker;
      if (marker) {
        _resetMotion([data], marker);
      }
    }
  }, {
    key: "animateReadyResize",
    value: function animateReadyResize(data) {
      this.resetAllAnimation(data);
    }
  }, {
    key: "animateClearingUpdateEmpty",
    value: function animateClearingUpdateEmpty(data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation(data);
    }
  }, {
    key: "animationTransitionClear",
    value: function animationTransitionClear() {
      var animationData = this.getAnimationData();
      if (!animationData) return;
      this.animationState.transition("clear", animationData);
    }
  }, {
    key: "getAnimationData",
    value: function getAnimationData(seriesRect, previousContextData) {
      var contextData = this._contextNodeData;
      if (!contextData) return;
      var animationData = {
        datumSelection: this.datumSelection,
        markerSelection: this.markerSelection,
        labelSelection: this.labelSelection,
        annotationSelections: _toConsumableArray(this.annotationSelections),
        contextData: contextData,
        previousContextData: previousContextData,
        paths: this.paths,
        seriesRect: seriesRect
      };
      return animationData;
    }
  }, {
    key: "calculateScaling",
    value: function calculateScaling() {
      var _this139 = this;
      var result = {};
      var _loop13 = function _loop13() {
        var direction = _Object$values5[_i28];
        var axis = _this139.axes[direction];
        if (!axis) return 1; // continue
        if (axis.scale instanceof LogScale) {
          var _axis$scale = axis.scale,
            range3 = _axis$scale.range,
            domain = _axis$scale.domain;
          result[direction] = {
            type: "log",
            convert: function convert(d) {
              return axis.scale.convert(d);
            },
            domain: [domain[0], domain[1]],
            range: [range3[0], range3[1]]
          };
        } else if (axis.scale instanceof _ContinuousScale5) {
          var _range3 = axis.scale.range;
          var _domain4 = axis.scale.getDomain();
          result[direction] = {
            type: "continuous",
            domain: [_domain4[0], _domain4[1]],
            range: [_range3[0], _range3[1]]
          };
        } else if (axis.scale) {
          var _domain5 = axis.scale.domain;
          result[direction] = {
            type: "category",
            domain: _domain5,
            range: _domain5.map(function (d) {
              return axis.scale.convert(d);
            })
          };
        }
      };
      for (var _i28 = 0, _Object$values5 = Object.values(_ChartAxisDirection); _i28 < _Object$values5.length; _i28++) {
        if (_loop13()) continue;
      }
      return result;
    }
  }, {
    key: "contextNodeData",
    get: function get() {
      return this._contextNodeData;
    }
  }]);
  return CartesianSeries;
}(_DataModelSeries3);

// packages/ag-charts-community/src/chart/cartesianChart.ts
var directions = ["top", "right", "bottom", "left"];
var _CartesianChart = /*#__PURE__*/function (_Chart2) {
  _inherits(_CartesianChart, _Chart2);
  function _CartesianChart(options, resources) {
    var _this140;
    _classCallCheck(this, _CartesianChart);
    _this140 = _possibleConstructorReturn(this, _getPrototypeOf(_CartesianChart).call(this, options, resources));
    /** Integrated Charts feature state - not used in Standalone Charts. */
    _this140.paired = true;
    _this140.firstSeriesTranslation = true;
    _this140._lastCrossLineIds = void 0;
    _this140._lastAxisWidths = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    _this140._lastClipSeries = false;
    _this140._lastVisibility = {
      crossLines: true,
      series: true
    };
    return _this140;
  }
  _createClass(_CartesianChart, [{
    key: "onAxisChange",
    value: function onAxisChange(newValue, oldValue) {
      _superPropGet(_CartesianChart, "onAxisChange", this, 3)([newValue, oldValue]);
      this.zoomManager.updateAxes(newValue);
    }
  }, {
    key: "destroySeries",
    value: function destroySeries(series) {
      _superPropGet(_CartesianChart, "destroySeries", this, 3)([series]);
      this.firstSeriesTranslation = true;
    }
  }, {
    key: "performLayout",
    value: function performLayout() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee33() {
        var shrinkRect, firstSeriesTranslation, seriesRoot, annotationRoot, highlightRoot, _this$updateAxes, animationRect, seriesRect, visibility, clipSeries, x, y, _i29, _arr2, group2, translationX, translationY, seriesPaddedRect, clipRect, modulePromises;
        return _regenerator().w(function (_context43) {
          while (1) switch (_context43.n) {
            case 0:
              _context43.n = 1;
              return __superGet(_CartesianChart.prototype, this, "performLayout").call(this);
            case 1:
              shrinkRect = _context43.v;
              firstSeriesTranslation = this.firstSeriesTranslation, seriesRoot = this.seriesRoot, annotationRoot = this.annotationRoot, highlightRoot = this.highlightRoot;
              _this$updateAxes = this.updateAxes(shrinkRect), animationRect = _this$updateAxes.animationRect, seriesRect = _this$updateAxes.seriesRect, visibility = _this$updateAxes.visibility, clipSeries = _this$updateAxes.clipSeries;
              this.seriesRoot.visible = visibility.series;
              this.seriesRect = seriesRect;
              this.animationRect = animationRect;
              x = seriesRect.x, y = seriesRect.y;
              if (firstSeriesTranslation) {
                for (_i29 = 0, _arr2 = [seriesRoot, annotationRoot, highlightRoot]; _i29 < _arr2.length; _i29++) {
                  group2 = _arr2[_i29];
                  group2.translationX = Math.floor(x);
                  group2.translationY = Math.floor(y);
                }
                this.firstSeriesTranslation = false;
              } else {
                translationX = seriesRoot.translationX, translationY = seriesRoot.translationY;
                _staticFromToMotion(this.id, "seriesRect", this.ctx.animationManager, [seriesRoot, highlightRoot, annotationRoot], {
                  translationX: translationX,
                  translationY: translationY
                }, {
                  translationX: Math.floor(x),
                  translationY: Math.floor(y)
                }, {
                  phase: "update"
                });
              }
              seriesPaddedRect = seriesRect.clone().grow(this.seriesArea.padding);
              this.hoverRect = seriesPaddedRect;
              clipRect = this.seriesArea.clip || clipSeries ? seriesPaddedRect : void 0;
              seriesRoot.setClipRectInGroupCoordinateSpace(clipRect);
              highlightRoot.setClipRectInGroupCoordinateSpace(clipRect);
              annotationRoot.setClipRectInGroupCoordinateSpace(clipRect);
              this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                  width: this.ctx.scene.width,
                  height: this.ctx.scene.height
                },
                clipSeries: clipSeries,
                series: {
                  rect: seriesRect,
                  paddedRect: seriesPaddedRect,
                  visible: visibility.series,
                  shouldFlipXY: this.shouldFlipXY()
                },
                axes: this.axes.map(function (axis) {
                  return __spreadValues({
                    id: axis.id
                  }, axis.getLayoutState());
                })
              });
              modulePromises = this.modulesManager.mapModules(function (m) {
                var _a;
                return (_a = m.performCartesianLayout) == null ? void 0 : _a.call(m, {
                  seriesRect: seriesRect
                });
              });
              _context43.n = 2;
              return Promise.all(modulePromises);
            case 2:
              return _context43.a(2, shrinkRect);
          }
        }, _callee33, this);
      }));
    }
  }, {
    key: "updateAxes",
    value: function updateAxes(inputShrinkRect) {
      var _a;
      var crossLineIds = this.axes.flatMap(function (axis) {
        var _a2;
        return (_a2 = axis.crossLines) != null ? _a2 : [];
      }).map(function (crossLine) {
        return crossLine.id;
      });
      var axesValid = this._lastCrossLineIds != null && this._lastCrossLineIds.length === crossLineIds.length && this._lastCrossLineIds.every(function (id, index) {
        return crossLineIds[index] === id;
      });
      var axisWidths;
      var clipSeries;
      var visibility;
      if (axesValid) {
        axisWidths = __spreadValues({}, this._lastAxisWidths);
        clipSeries = this._lastClipSeries;
        visibility = __spreadValues({}, this._lastVisibility);
      } else {
        axisWidths = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };
        clipSeries = false;
        visibility = {
          crossLines: true,
          series: true
        };
        this._lastCrossLineIds = crossLineIds;
      }
      var liveAxisWidths = new Set(this.axes.map(function (a) {
        return a.position;
      }));
      for (var _i30 = 0, _Object$keys2 = Object.keys(axisWidths); _i30 < _Object$keys2.length; _i30++) {
        var position = _Object$keys2[_i30];
        if (!liveAxisWidths.has(position)) {
          delete axisWidths[position];
        }
      }
      var stableOutputs = function stableOutputs(otherAxisWidths, otherClipSeries, otherVisibility) {
        if (Object.keys(otherAxisWidths).some(function (k) {
          return axisWidths[k] == null;
        })) {
          return false;
        }
        return visibility.crossLines === otherVisibility.crossLines && visibility.series === otherVisibility.series &&
        // Check for existing axis positions and equality.
        Object.entries(axisWidths).every(function (_ref130) {
          var _ref131 = _slicedToArray(_ref130, 2),
            p = _ref131[0],
            w = _ref131[1];
          var otherW = otherAxisWidths[p];
          if (w != null || otherW != null) {
            return w === otherW;
          }
          return true;
        }) && clipSeries === otherClipSeries;
      };
      var ceilValues = function ceilValues(records) {
        return _mapValues(records, function (value) {
          if (value && Math.abs(value) === Infinity) {
            return 0;
          }
          return value != null ? Math.ceil(value) : value;
        });
      };
      var lastPassAxisWidths = {};
      var lastPassVisibility = {};
      var lastPassClipSeries = false;
      var seriesRect = (_a = this.seriesRect) == null ? void 0 : _a.clone();
      var count = 0;
      var primaryTickCounts = {};
      do {
        Object.assign(axisWidths, lastPassAxisWidths);
        clipSeries = lastPassClipSeries;
        Object.assign(visibility, lastPassVisibility);
        var result = this.updateAxesPass(axisWidths, inputShrinkRect.clone(), seriesRect);
        lastPassAxisWidths = ceilValues(result.axisWidths);
        lastPassVisibility = result.visibility;
        lastPassClipSeries = result.clipSeries;
        seriesRect = result.seriesRect;
        primaryTickCounts = result.primaryTickCounts;
        if (count++ > 10) {
          _Logger.warn("unable to find stable axis layout.");
          break;
        }
      } while (!stableOutputs(lastPassAxisWidths, lastPassClipSeries, lastPassVisibility));
      this.axes.forEach(function (axis) {
        axis.update(primaryTickCounts[axis.direction]);
      });
      var clipRectPadding = 5;
      this.axes.forEach(function (axis) {
        axis.setCrossLinesVisible(visibility.crossLines);
        if (!seriesRect) {
          return;
        }
        axis.clipGrid(seriesRect.x, seriesRect.y, seriesRect.width + clipRectPadding, seriesRect.height + clipRectPadding);
        switch (axis.position) {
          case "left":
          case "right":
            axis.clipTickLines(inputShrinkRect.x, seriesRect.y, inputShrinkRect.width + clipRectPadding, seriesRect.height + clipRectPadding);
            break;
          case "top":
          case "bottom":
            axis.clipTickLines(seriesRect.x, inputShrinkRect.y, seriesRect.width + clipRectPadding, inputShrinkRect.height + clipRectPadding);
            break;
        }
      });
      this._lastAxisWidths = axisWidths;
      this._lastVisibility = visibility;
      return {
        seriesRect: seriesRect,
        animationRect: inputShrinkRect,
        visibility: visibility,
        clipSeries: clipSeries
      };
    }
  }, {
    key: "updateAxesPass",
    value: function updateAxesPass(axisWidths, bounds, lastPassSeriesRect) {
      var _this141 = this;
      var visited = {};
      var newAxisWidths = {};
      var visibility = {
        series: true,
        crossLines: true
      };
      var clipSeries = false;
      var primaryTickCounts = {};
      var paddedBounds = this.applySeriesPadding(bounds);
      var crossLinePadding = lastPassSeriesRect ? this.buildCrossLinePadding(axisWidths) : {};
      var axisBound = this.buildAxisBound(paddedBounds, axisWidths, crossLinePadding, visibility);
      var seriesRect = this.buildSeriesRect(axisBound, axisWidths);
      this.axes.forEach(function (axis) {
        var _a, _b;
        var _axis$position = axis.position,
          position = _axis$position === void 0 ? "left" : _axis$position;
        var _this141$calculateAxi = _this141.calculateAxisDimensions({
            axis: axis,
            seriesRect: seriesRect,
            paddedBounds: paddedBounds,
            axisWidths: axisWidths,
            newAxisWidths: newAxisWidths,
            primaryTickCounts: primaryTickCounts,
            clipSeries: clipSeries,
            addInterAxisPadding: ((_a = visited[position]) != null ? _a : 0) > 0
          }),
          newClipSeries = _this141$calculateAxi.clipSeries,
          axisThickness = _this141$calculateAxi.axisThickness,
          axisOffset = _this141$calculateAxi.axisOffset;
        visited[position] = ((_b = visited[position]) != null ? _b : 0) + 1;
        clipSeries = clipSeries || newClipSeries;
        _this141.positionAxis({
          axis: axis,
          axisBound: axisBound,
          axisOffset: axisOffset,
          axisThickness: axisThickness,
          axisWidths: axisWidths,
          primaryTickCounts: primaryTickCounts,
          seriesRect: seriesRect
        });
      });
      return {
        clipSeries: clipSeries,
        seriesRect: seriesRect,
        axisWidths: newAxisWidths,
        visibility: visibility,
        primaryTickCounts: primaryTickCounts
      };
    }
  }, {
    key: "buildCrossLinePadding",
    value: function buildCrossLinePadding(axisWidths) {
      var _a;
      var crossLinePadding = {};
      this.axes.forEach(function (axis) {
        if (axis.crossLines) {
          axis.crossLines.forEach(function (crossLine) {
            var _a2;
            (_a2 = crossLine.calculatePadding) == null ? void 0 : _a2.call(crossLine, crossLinePadding);
          });
        }
      });
      for (var _i31 = 0, _Object$entries6 = Object.entries(crossLinePadding); _i31 < _Object$entries6.length; _i31++) {
        var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i31], 2),
          side = _Object$entries6$_i[0],
          _Object$entries6$_i$ = _Object$entries6$_i[1],
          padding = _Object$entries6$_i$ === void 0 ? 0 : _Object$entries6$_i$;
        crossLinePadding[side] = Math.max(padding - ((_a = axisWidths[side]) != null ? _a : 0), 0);
      }
      return crossLinePadding;
    }
  }, {
    key: "applySeriesPadding",
    value: function applySeriesPadding(bounds) {
      var _this142 = this;
      var paddedRect = bounds.clone();
      var reversedAxes = this.axes.slice().reverse();
      directions.forEach(function (dir) {
        var padding = _this142.seriesArea.padding[dir];
        var axis = reversedAxes.find(function (a) {
          return a.position === dir;
        });
        if (axis) {
          axis.seriesAreaPadding = padding;
        } else {
          paddedRect.shrink(padding, dir);
        }
      });
      return paddedRect;
    }
  }, {
    key: "buildAxisBound",
    value: function buildAxisBound(bounds, axisWidths, crossLinePadding, visibility) {
      var _a, _b, _c, _d;
      var result = bounds.clone();
      var _crossLinePadding$top = crossLinePadding.top,
        top = _crossLinePadding$top === void 0 ? 0 : _crossLinePadding$top,
        _crossLinePadding$rig = crossLinePadding.right,
        right = _crossLinePadding$rig === void 0 ? 0 : _crossLinePadding$rig,
        _crossLinePadding$bot = crossLinePadding.bottom,
        bottom = _crossLinePadding$bot === void 0 ? 0 : _crossLinePadding$bot,
        _crossLinePadding$lef = crossLinePadding.left,
        left = _crossLinePadding$lef === void 0 ? 0 : _crossLinePadding$lef;
      var horizontalPadding = left + right;
      var verticalPadding = top + bottom;
      var totalWidth = ((_a = axisWidths.left) != null ? _a : 0) + ((_b = axisWidths.right) != null ? _b : 0) + horizontalPadding;
      var totalHeight = ((_c = axisWidths.top) != null ? _c : 0) + ((_d = axisWidths.bottom) != null ? _d : 0) + verticalPadding;
      if (result.width <= totalWidth || result.height <= totalHeight) {
        visibility.crossLines = false;
        visibility.series = false;
        return result;
      }
      result.x += left;
      result.y += top;
      result.width -= horizontalPadding;
      result.height -= verticalPadding;
      return result;
    }
  }, {
    key: "buildSeriesRect",
    value: function buildSeriesRect(axisBound, axisWidths) {
      var result = axisBound.clone();
      var top = axisWidths.top,
        bottom = axisWidths.bottom,
        left = axisWidths.left,
        right = axisWidths.right;
      result.x += left != null ? left : 0;
      result.y += top != null ? top : 0;
      result.width -= (left != null ? left : 0) + (right != null ? right : 0);
      result.height -= (top != null ? top : 0) + (bottom != null ? bottom : 0);
      result.width = Math.max(0, result.width);
      result.height = Math.max(0, result.height);
      return result;
    }
  }, {
    key: "clampToOutsideSeriesRect",
    value: function clampToOutsideSeriesRect(seriesRect, value, dimension, direction) {
      var x = seriesRect.x,
        y = seriesRect.y,
        width = seriesRect.width,
        height = seriesRect.height;
      var clampBounds = [x, y, x + width, y + height];
      var compareTo = clampBounds[(dimension === "x" ? 0 : 1) + (direction === 1 ? 0 : 2)];
      var clampFn = direction === 1 ? Math.min : Math.max;
      return clampFn(value, compareTo);
    }
  }, {
    key: "calculateAxisDimensions",
    value: function calculateAxisDimensions(opts) {
      var _a, _b, _c, _d;
      var axis = opts.axis,
        seriesRect = opts.seriesRect,
        paddedBounds = opts.paddedBounds,
        axisWidths = opts.axisWidths,
        newAxisWidths = opts.newAxisWidths,
        primaryTickCounts = opts.primaryTickCounts,
        addInterAxisPadding = opts.addInterAxisPadding;
      var clipSeries = opts.clipSeries;
      var _axis$position2 = axis.position,
        position = _axis$position2 === void 0 ? "left" : _axis$position2,
        direction = axis.direction;
      var isCategory = axis instanceof _CategoryAxis || axis instanceof _GroupedCategoryAxis;
      var isLeftRight = position === "left" || position === "right";
      var axisOffset = (_a = newAxisWidths[position]) != null ? _a : 0;
      var _this$ctx$zoomManager = this.ctx.zoomManager.getAxisZoom(axis.id),
        min = _this$ctx$zoomManager.min,
        max = _this$ctx$zoomManager.max;
      if (isLeftRight) {
        if (isCategory) {
          axis.range = [0, seriesRect.height];
          axis.visibleRange = [1 - max, 1 - min];
        } else {
          axis.range = [seriesRect.height, 0];
          axis.visibleRange = [min, max];
        }
        axis.gridLength = seriesRect.width;
      } else {
        axis.range = [0, seriesRect.width];
        axis.visibleRange = [min, max];
        axis.gridLength = seriesRect.height;
      }
      var primaryTickCount = axis.nice ? primaryTickCounts[direction] : void 0;
      var isVertical = direction === "y" /* Y */;
      var paddedBoundsCoefficient = 0.3;
      if (axis.thickness) {
        axis.maxThickness = axis.thickness;
      } else {
        axis.maxThickness = (isVertical ? paddedBounds.width : paddedBounds.height) * paddedBoundsCoefficient;
      }
      var layout = axis.calculateLayout(primaryTickCount);
      primaryTickCount = layout.primaryTickCount;
      (_b = primaryTickCounts[direction]) != null ? _b : primaryTickCounts[direction] = primaryTickCount;
      clipSeries || (clipSeries = axis.dataDomain.clipped || axis.visibleRange[0] > 0 || axis.visibleRange[1] < 1);
      var axisThickness;
      if (axis.thickness != null && axis.thickness > 0) {
        axisThickness = axis.thickness;
      } else {
        var bbox = layout.bbox;
        axisThickness = isVertical ? bbox.width : bbox.height;
      }
      var axisPadding = 15;
      if (addInterAxisPadding) {
        axisThickness += axisPadding;
      }
      axisThickness = Math.ceil(axisThickness);
      newAxisWidths[position] = ((_c = newAxisWidths[position]) != null ? _c : 0) + axisThickness;
      axis.gridPadding = ((_d = axisWidths[position]) != null ? _d : 0) - newAxisWidths[position];
      return {
        clipSeries: clipSeries,
        axisThickness: axisThickness,
        axisOffset: axisOffset,
        primaryTickCount: primaryTickCount
      };
    }
  }, {
    key: "positionAxis",
    value: function positionAxis(opts) {
      var _a, _b, _c, _d;
      var axis = opts.axis,
        axisBound = opts.axisBound,
        axisWidths = opts.axisWidths,
        seriesRect = opts.seriesRect,
        axisOffset = opts.axisOffset,
        axisThickness = opts.axisThickness;
      var position = axis.position;
      switch (position) {
        case "top":
          axis.translation.x = axisBound.x + ((_a = axisWidths.left) != null ? _a : 0);
          axis.translation.y = this.clampToOutsideSeriesRect(seriesRect, axisBound.y + 1 + axisOffset + axisThickness, "y", 1);
          break;
        case "bottom":
          axis.translation.x = axisBound.x + ((_b = axisWidths.left) != null ? _b : 0);
          axis.translation.y = this.clampToOutsideSeriesRect(seriesRect, axisBound.y + axisBound.height + 1 - axisThickness - axisOffset, "y", -1);
          break;
        case "left":
          axis.translation.y = axisBound.y + ((_c = axisWidths.top) != null ? _c : 0);
          axis.translation.x = this.clampToOutsideSeriesRect(seriesRect, axisBound.x + axisOffset + axisThickness, "x", 1);
          break;
        case "right":
          axis.translation.y = axisBound.y + ((_d = axisWidths.top) != null ? _d : 0);
          axis.translation.x = this.clampToOutsideSeriesRect(seriesRect, axisBound.x + axisBound.width - axisThickness - axisOffset, "x", -1);
          break;
      }
      axis.updatePosition({
        rotation: _toRadians(axis.rotation),
        sideFlag: axis.label.getSideFlag()
      });
    }
  }, {
    key: "shouldFlipXY",
    value: function shouldFlipXY() {
      return !this.series.some(function (series) {
        return !(series instanceof _CartesianSeries7 && series.shouldFlipXY());
      });
    }
  }]);
  return _CartesianChart;
}(Chart);
_CartesianChart.className = "CartesianChart";
_CartesianChart.type = "cartesian";
var CartesianChart = _CartesianChart;

// packages/ag-charts-community/src/chart/chartProxy.ts
var _AgChartInstanceProxy = /*#__PURE__*/function () {
  _createClass(_AgChartInstanceProxy, null, [{
    key: "isInstance",
    value: function isInstance(x) {
      var _a;
      if (x instanceof _AgChartInstanceProxy) {
        return true;
      }
      if (((_a = x.constructor) == null ? void 0 : _a.name) === "AgChartInstanceProxy" && x.chart != null) {
        return true;
      }
      return x.chart != null && this.validateImplementation(x);
    }
  }, {
    key: "validateImplementation",
    value: function validateImplementation(x) {
      var _a;
      var chartProps = ["getOptions", "destroy"];
      var signatureProps = Object.keys((_a = Object.getPrototypeOf(x)) != null ? _a : {});
      return chartProps.every(function (prop) {
        return signatureProps.includes(prop);
      });
    }
  }]);
  function _AgChartInstanceProxy(chart) {
    _classCallCheck(this, _AgChartInstanceProxy);
    this.chart = chart;
  }
  _createClass(_AgChartInstanceProxy, [{
    key: "getOptions",
    value: function getOptions() {
      return _deepClone2(this.chart.getOptions());
    }
  }, {
    key: "resetAnimations",
    value: function resetAnimations() {
      this.chart.resetAnimations();
    }
  }, {
    key: "skipAnimations",
    value: function skipAnimations() {
      this.chart.skipAnimations();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.chart.destroy();
    }
  }]);
  return _AgChartInstanceProxy;
}();
_AgChartInstanceProxy.chartInstances = /* @__PURE__ */new WeakMap();
__decorateClass([_ActionOnSet({
  oldValue: function oldValue(chart) {
    _AgChartInstanceProxy.chartInstances.delete(chart);
  },
  newValue: function newValue(chart) {
    _AgChartInstanceProxy.chartInstances.set(chart, this);
  }
})], _AgChartInstanceProxy.prototype, "chart", 2);
var AgChartInstanceProxy = _AgChartInstanceProxy;

// packages/ag-charts-community/src/scale/linearScale.ts
var _LinearScale = /*#__PURE__*/function (_ContinuousScale4) {
  _inherits(LinearScale, _ContinuousScale4);
  function LinearScale() {
    var _this143;
    _classCallCheck(this, LinearScale);
    _this143 = _possibleConstructorReturn(this, _getPrototypeOf(LinearScale).call(this, [0, 1], [0, 1]));
    _this143.type = "number";
    return _this143;
  }
  _createClass(LinearScale, [{
    key: "toDomain",
    value: function toDomain(d) {
      return d;
    }
  }, {
    key: "ticks",
    value: function ticks() {
      var _a;
      var count = (_a = this.tickCount) != null ? _a : _ContinuousScale5.defaultTickCount;
      if (!this.domain || this.domain.length < 2 || count < 1 || this.domain.some(function (d) {
        return !isFinite(d);
      })) {
        return [];
      }
      this.refresh();
      var _this$getDomain3 = this.getDomain(),
        _this$getDomain4 = _slicedToArray(_this$getDomain3, 2),
        d0 = _this$getDomain4[0],
        d1 = _this$getDomain4[1];
      var interval = this.interval;
      if (interval) {
        var step = Math.abs(interval);
        var availableRange = this.getPixelRange();
        if (!_isDenseInterval({
          start: d0,
          stop: d1,
          interval: step,
          availableRange: availableRange
        })) {
          return _range4(d0, d1, step);
        }
      }
      return ticks_default(d0, d1, count, this.minTickCount, this.maxTickCount);
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.domain || this.domain.length < 2) {
        return;
      }
      if (this.nice) {
        this.updateNiceDomain();
      }
    }
  }, {
    key: "getTickStep",
    value: function getTickStep(start, stop) {
      var _a, _b;
      var count = (_a = this.tickCount) != null ? _a : _ContinuousScale5.defaultTickCount;
      return (_b = this.interval) != null ? _b : _tickStep(start, stop, count, this.minTickCount, this.maxTickCount);
    }
    /**
     * Extends the domain so that it starts and ends on nice round values.
     */
  }, {
    key: "updateNiceDomain",
    value: function updateNiceDomain() {
      var _a;
      var count = (_a = this.tickCount) != null ? _a : _ContinuousScale5.defaultTickCount;
      if (count < 1) {
        this.niceDomain = _toConsumableArray(this.domain);
        return;
      }
      var _this$domain3 = _slicedToArray(this.domain, 2),
        start = _this$domain3[0],
        stop = _this$domain3[1];
      if (count === 1) {
        var _singleTickDomain = singleTickDomain(start, stop);
        var _singleTickDomain2 = _slicedToArray(_singleTickDomain, 2);
        start = _singleTickDomain2[0];
        stop = _singleTickDomain2[1];
      } else {
        var roundStart = start > stop ? Math.ceil : Math.floor;
        var roundStop = stop < start ? Math.floor : Math.ceil;
        var maxAttempts = 4;
        for (var i = 0; i < maxAttempts; i++) {
          var prev0 = start;
          var prev1 = stop;
          var step = this.getTickStep(start, stop);
          var _this$domain4 = _slicedToArray(this.domain, 2),
            d0 = _this$domain4[0],
            d1 = _this$domain4[1];
          if (step >= 1) {
            start = roundStart(d0 / step) * step;
            stop = roundStop(d1 / step) * step;
          } else {
            var s = 1 / step;
            start = roundStart(d0 * s) / s;
            stop = roundStop(d1 * s) / s;
          }
          if (start === prev0 && stop === prev1) {
            break;
          }
        }
      }
      this.niceDomain = [start, stop];
    }
  }, {
    key: "tickFormat",
    value: function tickFormat(_ref132) {
      var specifiedTicks = _ref132.ticks,
        specifier = _ref132.specifier;
      return _tickFormat(specifiedTicks != null ? specifiedTicks : this.ticks(), specifier);
    }
  }]);
  return LinearScale;
}(_ContinuousScale5);

// packages/ag-charts-community/src/util/secondaryAxisTicks.ts
function calculateNiceSecondaryAxis(domain, primaryTickCount, reverse) {
  var _findMinMax15 = _findMinMax17(domain),
    _findMinMax16 = _slicedToArray(_findMinMax15, 2),
    start = _findMinMax16[0],
    stop = _findMinMax16[1];
  start = calculateNiceStart(Math.floor(start), stop, primaryTickCount);
  var step = getTickStep(start, stop, primaryTickCount);
  var segments = primaryTickCount - 1;
  stop = start + segments * step;
  var d = reverse ? [stop, start] : [start, stop];
  var ticks = getTicks(start, step, primaryTickCount);
  return [d, ticks];
}
function calculateNiceStart(a, b, count) {
  var rawStep = Math.abs(b - a) / (count - 1);
  var order = Math.floor(Math.log10(rawStep));
  var magnitude = Math.pow(10, order);
  return Math.floor(a / magnitude) * magnitude;
}
function getTicks(start, step, count) {
  var stepPower = Math.floor(Math.log10(step));
  var fractionDigits = step > 0 && step < 1 ? Math.abs(stepPower) : 0;
  var f = Math.pow(10, fractionDigits);
  var ticks = createNumericTicks(fractionDigits);
  for (var i = 0; i < count; i++) {
    var tick = start + step * i;
    ticks[i] = Math.round(tick * f) / f;
  }
  return ticks;
}
function getTickStep(start, stop, count) {
  var segments = count - 1;
  var rawStep = (stop - start) / segments;
  return calculateNextNiceStep(rawStep);
}
function calculateNextNiceStep(rawStep) {
  var order = Math.floor(Math.log10(rawStep));
  var magnitude = Math.pow(10, order);
  var step = rawStep / magnitude * 10;
  if (step > 0 && step <= 1) {
    return magnitude / 10;
  }
  if (step > 1 && step <= 2) {
    return 2 * magnitude / 10;
  }
  if (step > 1 && step <= 5) {
    return 5 * magnitude / 10;
  }
  if (step > 5 && step <= 10) {
    return 10 * magnitude / 10;
  }
  if (step > 10 && step <= 20) {
    return 20 * magnitude / 10;
  }
  if (step > 20 && step <= 40) {
    return 40 * magnitude / 10;
  }
  if (step > 40 && step <= 50) {
    return 50 * magnitude / 10;
  }
  if (step > 50 && step <= 100) {
    return 100 * magnitude / 10;
  }
  return step;
}

// packages/ag-charts-community/src/chart/axis/numberAxis.ts
var NumberAxisTick = /*#__PURE__*/function (_AxisTick2) {
  _inherits(NumberAxisTick, _AxisTick2);
  function NumberAxisTick() {
    var _this144;
    _classCallCheck(this, NumberAxisTick);
    _this144 = _possibleConstructorReturn(this, _getPrototypeOf(NumberAxisTick).apply(this, arguments));
    _this144.minSpacing = NaN;
    _this144.maxSpacing = NaN;
    return _this144;
  }
  return NumberAxisTick;
}(_AxisTick4);
__decorateClass([_Validate(_MIN_SPACING), _Default(NaN)], NumberAxisTick.prototype, "minSpacing", 2);
__decorateClass([_Validate(_MAX_SPACING), _Default(NaN)], NumberAxisTick.prototype, "maxSpacing", 2);
var NumberAxis = /*#__PURE__*/function (_CartesianAxis4) {
  _inherits(NumberAxis, _CartesianAxis4);
  function NumberAxis(moduleCtx) {
    var _this145;
    var scale2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _LinearScale();
    _classCallCheck(this, NumberAxis);
    _this145 = _possibleConstructorReturn(this, _getPrototypeOf(NumberAxis).call(this, moduleCtx, scale2));
    _this145.min = NaN;
    _this145.max = NaN;
    return _this145;
  }
  _createClass(NumberAxis, [{
    key: "normaliseDataDomain",
    value: function normaliseDataDomain(d) {
      var min = this.min,
        max = this.max;
      var _normalisedExtentWith = _normalisedExtentWithMetadata(d, min, max),
        extent2 = _normalisedExtentWith.extent,
        clipped = _normalisedExtentWith.clipped;
      return {
        domain: extent2,
        clipped: clipped
      };
    }
  }, {
    key: "createTick",
    value: function createTick() {
      return new NumberAxisTick();
    }
  }, {
    key: "updateSecondaryAxisTicks",
    value: function updateSecondaryAxisTicks(primaryTickCount) {
      if (this.dataDomain == null) {
        throw new Error("AG Charts - dataDomain not calculated, cannot perform tick calculation.");
      }
      if (this.dataDomain.domain.length === 0) return [];
      var _calculateNiceSeconda = calculateNiceSecondaryAxis(this.dataDomain.domain, primaryTickCount != null ? primaryTickCount : 0, this.reverse),
        _calculateNiceSeconda2 = _slicedToArray(_calculateNiceSeconda, 2),
        d = _calculateNiceSeconda2[0],
        ticks = _calculateNiceSeconda2[1];
      this.scale.nice = false;
      this.scale.domain = d;
      this.scale.update();
      return ticks;
    }
  }, {
    key: "formatDatum",
    value: function formatDatum(datum) {
      if (typeof datum === "number") {
        return datum.toFixed(2);
      } else {
        return String(datum);
      }
    }
  }]);
  return NumberAxis;
}(_CartesianAxis6);
NumberAxis.className = "NumberAxis";
NumberAxis.type = "number";
__decorateClass([_Validate(_AND(_NUMBER_OR_NAN, _LESS_THAN("max"))), _Default(NaN)], NumberAxis.prototype, "min", 2);
__decorateClass([_Validate(_AND(_NUMBER_OR_NAN, _GREATER_THAN("min"))), _Default(NaN)], NumberAxis.prototype, "max", 2);

// packages/ag-charts-community/src/chart/axis/logAxis.ts
var NON_ZERO_NUMBER = _predicateWithMessage(function (value) {
  return _isNumber(value) && value !== 0;
}, "a non-zero number");
var LogAxis = /*#__PURE__*/function (_NumberAxis) {
  _inherits(LogAxis, _NumberAxis);
  function LogAxis(moduleCtx) {
    var _this146;
    _classCallCheck(this, LogAxis);
    _this146 = _possibleConstructorReturn(this, _getPrototypeOf(LogAxis).call(this, moduleCtx, new LogScale()));
    _this146.min = NaN;
    _this146.max = NaN;
    return _this146;
  }
  _createClass(LogAxis, [{
    key: "normaliseDataDomain",
    value: function normaliseDataDomain(d) {
      var min = this.min,
        max = this.max;
      var _normalisedExtentWith2 = _normalisedExtentWithMetadata(d, min, max),
        extent2 = _normalisedExtentWith2.extent,
        clipped = _normalisedExtentWith2.clipped;
      var isInverted = extent2[0] > extent2[1];
      var crossesZero = extent2[0] < 0 && extent2[1] > 0;
      var hasZeroExtent = extent2[0] === 0 && extent2[1] === 0;
      var invalidDomain = isInverted || crossesZero || hasZeroExtent;
      if (invalidDomain) {
        if (crossesZero) {
          _Logger.warn("the data domain crosses zero, the chart data cannot be rendered. See log axis documentation for more information.");
        } else if (hasZeroExtent) {
          _Logger.warn("the data domain has 0 extent, no data is rendered.");
        }
      }
      if (extent2[0] === 0) {
        extent2[0] = 1;
      }
      if (extent2[1] === 0) {
        extent2[1] = -1;
      }
      return {
        domain: extent2,
        clipped: clipped
      };
    }
  }, {
    key: "base",
    set: function set(value) {
      this.scale.base = value;
    },
    get: function get() {
      return this.scale.base;
    }
  }]);
  return LogAxis;
}(NumberAxis);
LogAxis.className = "LogAxis";
LogAxis.type = "log";
__decorateClass([_Validate(_AND(_NUMBER_OR_NAN, NON_ZERO_NUMBER, _LESS_THAN("max"))), _Default(NaN)], LogAxis.prototype, "min", 2);
__decorateClass([_Validate(_AND(_NUMBER_OR_NAN, NON_ZERO_NUMBER, _GREATER_THAN("min"))), _Default(NaN)], LogAxis.prototype, "max", 2);

// packages/ag-charts-community/src/chart/axis/timeAxis.ts
var TimeAxisTick = /*#__PURE__*/function (_AxisTick3) {
  _inherits(TimeAxisTick, _AxisTick3);
  function TimeAxisTick() {
    var _this147;
    _classCallCheck(this, TimeAxisTick);
    _this147 = _possibleConstructorReturn(this, _getPrototypeOf(TimeAxisTick).apply(this, arguments));
    _this147.minSpacing = NaN;
    _this147.maxSpacing = NaN;
    return _this147;
  }
  return TimeAxisTick;
}(_AxisTick4);
__decorateClass([_Validate(_MIN_SPACING), _Default(NaN)], TimeAxisTick.prototype, "minSpacing", 2);
__decorateClass([_Validate(_MAX_SPACING), _Default(NaN)], TimeAxisTick.prototype, "maxSpacing", 2);
var TimeAxis = /*#__PURE__*/function (_CartesianAxis5) {
  _inherits(TimeAxis, _CartesianAxis5);
  function TimeAxis(moduleCtx) {
    var _this148;
    _classCallCheck(this, TimeAxis);
    _this148 = _possibleConstructorReturn(this, _getPrototypeOf(TimeAxis).call(this, moduleCtx, new _TimeScale2()));
    _this148.min = void 0;
    _this148.max = void 0;
    _this148.refreshScale();
    return _this148;
  }
  _createClass(TimeAxis, [{
    key: "normaliseDataDomain",
    value: function normaliseDataDomain(d) {
      var _a;
      var min = this.min,
        max = this.max;
      var clipped = false;
      if (typeof min === "number") {
        min = new Date(min);
      }
      if (typeof max === "number") {
        max = new Date(max);
      }
      if (d.length > 2) {
        d = ((_a = _extent(d)) != null ? _a : [0, 1e3]).map(function (x) {
          return new Date(x);
        });
      }
      if (min instanceof Date) {
        clipped || (clipped = min > d[0]);
        d = [min, d[1]];
      }
      if (max instanceof Date) {
        clipped || (clipped = max < d[1]);
        d = [d[0], max];
      }
      if (d[0] > d[1]) {
        d = [];
      }
      return {
        domain: d,
        clipped: clipped
      };
    }
  }, {
    key: "createTick",
    value: function createTick() {
      return new TimeAxisTick();
    }
  }, {
    key: "onLabelFormatChange",
    value: function onLabelFormatChange(ticks, domain, format2) {
      if (format2) {
        _superPropGet(TimeAxis, "onLabelFormatChange", this, 3)([ticks, domain, format2]);
      } else {
        this.labelFormatter = this.scale.tickFormat({
          ticks: ticks,
          domain: domain
        });
      }
    }
  }, {
    key: "calculatePadding",
    value: function calculatePadding() {
      return [0, 0];
    }
  }, {
    key: "formatDatum",
    value: function formatDatum(datum) {
      var _a;
      var formatter = this.scale.tickFormat({
        specifier: "%m/%d/%y, %H:%M:%S"
      });
      return (_a = this.moduleCtx.callbackCache.call(formatter, datum)) != null ? _a : String(datum);
    }
  }]);
  return TimeAxis;
}(_CartesianAxis6);
TimeAxis.className = "TimeAxis";
TimeAxis.type = "time";
__decorateClass([_Validate(_AND(_DATE_OR_DATETIME_MS, _LESS_THAN("max")), {
  optional: true
})], TimeAxis.prototype, "min", 2);
__decorateClass([_Validate(_AND(_DATE_OR_DATETIME_MS, _GREATER_THAN("min")), {
  optional: true
})], TimeAxis.prototype, "max", 2);

// packages/ag-charts-community/src/scene/shape/rect.ts
var epsilon = 1e-6;
var cornerEdges = function cornerEdges(leadingEdge, trailingEdge, leadingInset, trailingInset, cornerRadius) {
  var leadingClipped = false;
  var trailingClipped = false;
  var leading0 = trailingInset - Math.sqrt(Math.max(__pow(cornerRadius, 2) - __pow(leadingInset, 2), 0));
  var leading1 = 0;
  var trailing0 = 0;
  var trailing1 = leadingInset - Math.sqrt(Math.max(__pow(cornerRadius, 2) - __pow(trailingInset, 2), 0));
  if (leading0 > leadingEdge) {
    leadingClipped = true;
    leading0 = leadingEdge;
    leading1 = leadingInset - Math.sqrt(Math.max(__pow(cornerRadius, 2) - __pow(trailingInset - leadingEdge, 2)));
  } else if (leading0 < epsilon) {
    leading0 = 0;
  }
  if (trailing1 > trailingEdge) {
    trailingClipped = true;
    trailing0 = trailingInset - Math.sqrt(Math.max(__pow(cornerRadius, 2) - __pow(leadingInset - trailingEdge, 2)));
    trailing1 = trailingEdge;
  } else if (trailing1 < epsilon) {
    trailing1 = 0;
  }
  return {
    leading0: leading0,
    leading1: leading1,
    trailing0: trailing0,
    trailing1: trailing1,
    leadingClipped: leadingClipped,
    trailingClipped: trailingClipped
  };
};
var drawCorner = function drawCorner(path, _ref133, cornerRadius, move) {
  var x0 = _ref133.x0,
    y0 = _ref133.y0,
    x1 = _ref133.x1,
    y1 = _ref133.y1,
    cx = _ref133.cx,
    cy = _ref133.cy;
  if (move) {
    path.moveTo(x0, y0);
  }
  if (x0 !== x1 || y0 !== y1) {
    var r0 = Math.atan2(y0 - cy, x0 - cx);
    var r1 = Math.atan2(y1 - cy, x1 - cx);
    path.arc(cx, cy, cornerRadius, r0, r1);
  } else {
    path.lineTo(x0, y0);
  }
};
var insetCornerRadiusRect = function insetCornerRadiusRect(path, x, y, width, height, cornerRadii, clipBBox) {
  var topLeftCornerRadius = cornerRadii.topLeft,
    topRightCornerRadius = cornerRadii.topRight,
    bottomRightCornerRadius = cornerRadii.bottomRight,
    bottomLeftCornerRadius = cornerRadii.bottomLeft;
  var maxVerticalCornerRadius = Math.max(topLeftCornerRadius + bottomLeftCornerRadius, topRightCornerRadius + bottomRightCornerRadius);
  var maxHorizontalCornerRadius = Math.max(topLeftCornerRadius + topRightCornerRadius, bottomLeftCornerRadius + bottomRightCornerRadius);
  if (maxVerticalCornerRadius <= 0 && maxHorizontalCornerRadius <= 0) {
    if (clipBBox == null) {
      path.rect(x, y, width, height);
    } else {
      path.rect(clipBBox.x, clipBBox.y, clipBBox.width, clipBBox.height);
    }
    return;
  } else if (clipBBox == null && topLeftCornerRadius === topRightCornerRadius && topLeftCornerRadius === bottomRightCornerRadius && topLeftCornerRadius === bottomLeftCornerRadius) {
    path.roundRect(x, y, width, height, topLeftCornerRadius);
    return;
  }
  if (width < 0) {
    x += width;
    width = Math.abs(width);
  }
  if (height < 0) {
    y += height;
    height = Math.abs(height);
  }
  if (width <= 0 || height <= 0) return;
  if (clipBBox == null) {
    clipBBox = new _BBox2(x, y, width, height);
  } else {
    var x0 = Math.max(x, clipBBox.x);
    var x1 = Math.min(x + width, clipBBox.x + clipBBox.width);
    var y0 = Math.max(y, clipBBox.y);
    var y1 = Math.min(y + height, clipBBox.y + clipBBox.height);
    clipBBox = new _BBox2(x0, y0, x1 - x0, y1 - y0);
  }
  var borderScale = Math.max(maxVerticalCornerRadius / height, maxHorizontalCornerRadius / width, 1);
  if (borderScale > 1) {
    topLeftCornerRadius /= borderScale;
    topRightCornerRadius /= borderScale;
    bottomRightCornerRadius /= borderScale;
    bottomLeftCornerRadius /= borderScale;
  }
  var drawTopLeftCorner = true;
  var drawTopRightCorner = true;
  var drawBottomRightCorner = true;
  var drawBottomLeftCorner = true;
  var topLeftCorner;
  var topRightCorner;
  var bottomRightCorner;
  var bottomLeftCorner;
  if (drawTopLeftCorner) {
    var nodes = cornerEdges(clipBBox.height, clipBBox.width, Math.max(x + topLeftCornerRadius - clipBBox.x, 0), Math.max(y + topLeftCornerRadius - clipBBox.y, 0), topLeftCornerRadius);
    if (nodes.leadingClipped) drawBottomLeftCorner = false;
    if (nodes.trailingClipped) drawTopRightCorner = false;
    var _x3 = Math.max(clipBBox.x + nodes.leading1, clipBBox.x);
    var _y3 = Math.max(clipBBox.y + nodes.leading0, clipBBox.y);
    var _x4 = Math.max(clipBBox.x + nodes.trailing1, clipBBox.x);
    var _y4 = Math.max(clipBBox.y + nodes.trailing0, clipBBox.y);
    var cx = x + topLeftCornerRadius;
    var cy = y + topLeftCornerRadius;
    topLeftCorner = {
      x0: _x3,
      y0: _y3,
      x1: _x4,
      y1: _y4,
      cx: cx,
      cy: cy
    };
  }
  if (drawTopRightCorner) {
    var _nodes = cornerEdges(clipBBox.width, clipBBox.height, Math.max(y + topRightCornerRadius - clipBBox.y, 0), Math.max(clipBBox.x + clipBBox.width - (x + width - topRightCornerRadius), 0), topRightCornerRadius);
    if (_nodes.leadingClipped) drawTopLeftCorner = false;
    if (_nodes.trailingClipped) drawBottomRightCorner = false;
    var _x5 = Math.min(clipBBox.x + clipBBox.width - _nodes.leading0, clipBBox.x + clipBBox.width);
    var _y5 = Math.max(clipBBox.y + _nodes.leading1, clipBBox.y);
    var _x6 = Math.min(clipBBox.x + clipBBox.width - _nodes.trailing0, clipBBox.x + clipBBox.width);
    var _y6 = Math.max(clipBBox.y + _nodes.trailing1, clipBBox.y);
    var _cx = x + width - topRightCornerRadius;
    var _cy = y + topRightCornerRadius;
    topRightCorner = {
      x0: _x5,
      y0: _y5,
      x1: _x6,
      y1: _y6,
      cx: _cx,
      cy: _cy
    };
  }
  if (drawBottomRightCorner) {
    var _nodes2 = cornerEdges(clipBBox.height, clipBBox.width, Math.max(clipBBox.x + clipBBox.width - (x + width - bottomRightCornerRadius), 0), Math.max(clipBBox.y + clipBBox.height - (y + height - bottomRightCornerRadius), 0), bottomRightCornerRadius);
    if (_nodes2.leadingClipped) drawTopRightCorner = false;
    if (_nodes2.trailingClipped) drawBottomLeftCorner = false;
    var _x7 = Math.min(clipBBox.x + clipBBox.width - _nodes2.leading1, clipBBox.x + clipBBox.width);
    var _y7 = Math.min(clipBBox.y + clipBBox.height - _nodes2.leading0, clipBBox.y + clipBBox.height);
    var _x8 = Math.min(clipBBox.x + clipBBox.width - _nodes2.trailing1, clipBBox.x + clipBBox.width);
    var _y8 = Math.min(clipBBox.y + clipBBox.height - _nodes2.trailing0, clipBBox.y + clipBBox.height);
    var _cx2 = x + width - bottomRightCornerRadius;
    var _cy2 = y + height - bottomRightCornerRadius;
    bottomRightCorner = {
      x0: _x7,
      y0: _y7,
      x1: _x8,
      y1: _y8,
      cx: _cx2,
      cy: _cy2
    };
  }
  if (drawBottomLeftCorner) {
    var _nodes3 = cornerEdges(clipBBox.width, clipBBox.height, Math.max(clipBBox.y + clipBBox.height - (y + height - bottomLeftCornerRadius), 0), Math.max(x + bottomLeftCornerRadius - clipBBox.x, 0), bottomLeftCornerRadius);
    if (_nodes3.leadingClipped) drawBottomRightCorner = false;
    if (_nodes3.trailingClipped) drawTopLeftCorner = false;
    var _x9 = Math.max(clipBBox.x + _nodes3.leading0, clipBBox.x);
    var _y9 = Math.min(clipBBox.y + clipBBox.height - _nodes3.leading1, clipBBox.y + clipBBox.height);
    var _x0 = Math.max(clipBBox.x + _nodes3.trailing0, clipBBox.x);
    var _y0 = Math.min(clipBBox.y + clipBBox.height - _nodes3.trailing1, clipBBox.y + clipBBox.height);
    var _cx3 = x + bottomLeftCornerRadius;
    var _cy3 = y + height - bottomLeftCornerRadius;
    bottomLeftCorner = {
      x0: _x9,
      y0: _y9,
      x1: _x0,
      y1: _y0,
      cx: _cx3,
      cy: _cy3
    };
  }
  var didMove = false;
  if (drawTopLeftCorner && topLeftCorner != null) {
    drawCorner(path, topLeftCorner, topLeftCornerRadius, !didMove);
    didMove || (didMove = true);
  }
  if (drawTopRightCorner && topRightCorner != null) {
    drawCorner(path, topRightCorner, topRightCornerRadius, !didMove);
    didMove || (didMove = true);
  }
  if (drawBottomRightCorner && bottomRightCorner != null) {
    drawCorner(path, bottomRightCorner, bottomRightCornerRadius, !didMove);
    didMove || (didMove = true);
  }
  if (drawBottomLeftCorner && bottomLeftCorner != null) {
    drawCorner(path, bottomLeftCorner, bottomLeftCornerRadius, !didMove);
    didMove || (didMove = true);
  }
  path.closePath();
};
var _Rect = /*#__PURE__*/function (_Path2) {
  _inherits(Rect, _Path2);
  function Rect() {
    var _this149;
    _classCallCheck(this, Rect);
    _this149 = _possibleConstructorReturn(this, _getPrototypeOf(Rect).apply(this, arguments));
    _this149.borderPath = new _ExtendedPath2D();
    _this149.x = 0;
    _this149.y = 0;
    _this149.width = 10;
    _this149.height = 10;
    _this149.topLeftCornerRadius = 0;
    _this149.topRightCornerRadius = 0;
    _this149.bottomRightCornerRadius = 0;
    _this149.bottomLeftCornerRadius = 0;
    _this149.clipBBox = void 0;
    _this149.crisp = false;
    _this149.lastUpdatePathStrokeWidth = _Shape6.defaultStyles.strokeWidth;
    _this149.effectiveStrokeWidth = _Shape6.defaultStyles.strokeWidth;
    _this149.hittester = _superPropGet((_assertThisInitialized(_this149), Rect), "isPointInPath", _assertThisInitialized(_this149), 1);
    _this149.distanceCalculator = _superPropGet((_assertThisInitialized(_this149), Rect), "distanceSquared", _assertThisInitialized(_this149), 1);
    /**
     * When the rectangle's width or height is less than a pixel
     * and crisp mode is on, the rectangle will still fit into the pixel,
     * but will be less opaque to make an effect of holding less space.
     */
    _this149.microPixelEffectOpacity = 1;
    return _this149;
  }
  _createClass(Rect, [{
    key: "isDirtyPath",
    value: function isDirtyPath() {
      return this.lastUpdatePathStrokeWidth !== this.strokeWidth || Boolean(this.path.isDirty() || this.borderPath.isDirty());
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var _this150 = this;
      var _a, _b, _c;
      var path = this.path,
        borderPath = this.borderPath,
        crisp = this.crisp,
        topLeft = this.topLeftCornerRadius,
        topRight = this.topRightCornerRadius,
        bottomRight = this.bottomRightCornerRadius,
        bottomLeft = this.bottomLeftCornerRadius;
      var x = this.x,
        y = this.y,
        w = this.width,
        h = this.height,
        strokeWidth = this.strokeWidth,
        clipBBox = this.clipBBox;
      var pixelRatio = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas.pixelRatio) != null ? _b : 1;
      var pixelSize = 1 / pixelRatio;
      var microPixelEffectOpacity = 1;
      path.clear(true);
      borderPath.clear(true);
      if (crisp) {
        if (w <= pixelSize) {
          microPixelEffectOpacity *= w / pixelSize;
        }
        if (h <= pixelSize) {
          microPixelEffectOpacity *= h / pixelSize;
        }
        w = this.align(x, w);
        h = this.align(y, h);
        x = this.align(x);
        y = this.align(y);
        clipBBox = clipBBox != null ? new _BBox2(this.align(clipBBox.x), this.align(clipBBox.y), this.align(clipBBox.x, clipBBox.width), this.align(clipBBox.y, clipBBox.height)) : void 0;
      }
      if (strokeWidth) {
        if (w < pixelSize) {
          var lx = x + pixelSize / 2;
          borderPath.moveTo(lx, y);
          borderPath.lineTo(lx, y + h);
          strokeWidth = pixelSize;
          this.borderClipPath = void 0;
        } else if (h < pixelSize) {
          var ly = y + pixelSize / 2;
          borderPath.moveTo(x, ly);
          borderPath.lineTo(x + w, ly);
          strokeWidth = pixelSize;
          this.borderClipPath = void 0;
        } else if (strokeWidth < w && strokeWidth < h) {
          var halfStrokeWidth = strokeWidth / 2;
          x += halfStrokeWidth;
          y += halfStrokeWidth;
          w -= strokeWidth;
          h -= strokeWidth;
          var adjustedClipBBox = clipBBox == null ? void 0 : clipBBox.clone().shrink(halfStrokeWidth);
          var cornerRadii = {
            topLeft: topLeft > 0 ? topLeft - strokeWidth : 0,
            topRight: topRight > 0 ? topRight - strokeWidth : 0,
            bottomRight: bottomRight > 0 ? bottomRight - strokeWidth : 0,
            bottomLeft: bottomLeft > 0 ? bottomLeft - strokeWidth : 0
          };
          this.borderClipPath = void 0;
          if (w > 0 && h > 0 && (adjustedClipBBox == null || (adjustedClipBBox == null ? void 0 : adjustedClipBBox.width) > 0 && (adjustedClipBBox == null ? void 0 : adjustedClipBBox.height) > 0)) {
            insetCornerRadiusRect(path, x, y, w, h, cornerRadii, adjustedClipBBox);
            insetCornerRadiusRect(borderPath, x, y, w, h, cornerRadii, adjustedClipBBox);
          }
        } else {
          this.borderClipPath = (_c = this.borderClipPath) != null ? _c : new _ExtendedPath2D();
          this.borderClipPath.clear(true);
          this.borderClipPath.rect(x, y, w, h);
          borderPath.rect(x, y, w, h);
        }
      } else {
        var _cornerRadii = {
          topLeft: topLeft,
          topRight: topRight,
          bottomRight: bottomRight,
          bottomLeft: bottomLeft
        };
        this.borderClipPath = void 0;
        insetCornerRadiusRect(path, x, y, w, h, _cornerRadii, clipBBox);
      }
      if ([topLeft, topRight, bottomRight, bottomLeft].every(function (r) {
        return r === 0;
      })) {
        this.hittester = function (hitX, hitY) {
          var point = _this150.transformPoint(hitX, hitY);
          return _this150.getCachedBBox().containsPoint(point.x, point.y);
        };
        this.distanceSquared = function (hitX, hitY) {
          return _this150.getCachedBBox().distanceSquared(hitX, hitY);
        };
      } else {
        this.hittester = _superPropGet(Rect, "isPointInPath", this, 1);
        this.distanceCalculator = _superPropGet(Rect, "distanceSquared", this, 1);
      }
      this.effectiveStrokeWidth = strokeWidth;
      this.lastUpdatePathStrokeWidth = strokeWidth;
      this.microPixelEffectOpacity = microPixelEffectOpacity;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      var _a;
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height,
        clipBBox = this.clipBBox;
      return (_a = clipBBox == null ? void 0 : clipBBox.clone()) != null ? _a : new _BBox2(x, y, width, height);
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      return this.hittester(x, y);
    }
  }, {
    key: "distanceSquared",
    value: function distanceSquared(x, y) {
      return this.distanceCalculator(x, y);
    }
  }, {
    key: "applyFillAlpha",
    value: function applyFillAlpha(ctx) {
      var fillOpacity = this.fillOpacity,
        microPixelEffectOpacity = this.microPixelEffectOpacity,
        opacity = this.opacity;
      ctx.globalAlpha *= opacity * fillOpacity * microPixelEffectOpacity;
    }
  }, {
    key: "renderStroke",
    value: function renderStroke(ctx) {
      var stroke = this.stroke,
        effectiveStrokeWidth = this.effectiveStrokeWidth;
      if (stroke && effectiveStrokeWidth) {
        var globalAlpha = ctx.globalAlpha;
        var strokeOpacity = this.strokeOpacity,
          lineDash = this.lineDash,
          lineDashOffset = this.lineDashOffset,
          lineCap = this.lineCap,
          lineJoin = this.lineJoin,
          borderPath = this.borderPath,
          borderClipPath = this.borderClipPath,
          opacity = this.opacity,
          microPixelEffectOpacity = this.microPixelEffectOpacity;
        if (borderClipPath) {
          ctx.clip(borderClipPath.getPath2D());
        }
        ctx.strokeStyle = stroke;
        ctx.globalAlpha *= opacity * strokeOpacity * microPixelEffectOpacity;
        ctx.lineWidth = effectiveStrokeWidth;
        if (lineDash) {
          ctx.setLineDash(lineDash);
        }
        if (lineDashOffset) {
          ctx.lineDashOffset = lineDashOffset;
        }
        if (lineCap) {
          ctx.lineCap = lineCap;
        }
        if (lineJoin) {
          ctx.lineJoin = lineJoin;
        }
        ctx.stroke(borderPath.getPath2D());
        ctx.globalAlpha = globalAlpha;
      }
    }
  }, {
    key: "cornerRadius",
    set: function set(cornerRadius) {
      this.topLeftCornerRadius = cornerRadius;
      this.topRightCornerRadius = cornerRadius;
      this.bottomRightCornerRadius = cornerRadius;
      this.bottomLeftCornerRadius = cornerRadius;
    }
  }, {
    key: "midPoint",
    get: function get() {
      return {
        x: this.x + this.width / 2,
        y: this.y + this.height / 2
      };
    }
  }]);
  return Rect;
}(_Path6);
_Rect.className = "Rect";
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "x", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "y", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "width", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "height", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "topLeftCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "topRightCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "bottomRightCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "bottomLeftCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "clipBBox", 2);
__decorateClass([_ScenePathChangeDetection()], _Rect.prototype, "crisp", 2);

// packages/ag-charts-community/src/chart/background/background.ts
var _Background = /*#__PURE__*/function (_BaseModuleInstance) {
  _inherits(Background, _BaseModuleInstance);
  function Background(ctx) {
    var _this151;
    _classCallCheck(this, Background);
    _this151 = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this));
    _this151.node = new _Group4({
      name: "background",
      zIndex: 0 /* SERIES_BACKGROUND_ZINDEX */
    });
    _this151.rectNode = new _Rect();
    _this151.visible = true;
    _this151.fill = "white";
    _this151.node.appendChild(_this151.rectNode);
    _this151.destroyFns.push(ctx.scene.attachNode(_this151.node), ctx.layoutService.addListener("layout-complete", function (e) {
      return _this151.onLayoutComplete(e);
    }));
    return _this151;
  }
  _createClass(Background, [{
    key: "onLayoutComplete",
    value: function onLayoutComplete(e) {
      var _e$chart = e.chart,
        width = _e$chart.width,
        height = _e$chart.height;
      this.rectNode.width = width;
      this.rectNode.height = height;
    }
  }]);
  return Background;
}(_BaseModuleInstance4);
__decorateClass([_Validate(_BOOLEAN), _ProxyPropertyOnWrite("node", "visible")], _Background.prototype, "visible", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
}), _ProxyPropertyOnWrite("rectNode", "fill")], _Background.prototype, "fill", 2);
__decorateClass([_Validate(_OBJECT, {
  optional: true
})], _Background.prototype, "image", 2);

// packages/ag-charts-community/src/chart/background/backgroundModule.ts
var _BackgroundModule = {
  type: "root",
  optionsKey: "background",
  packageType: "community",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"],
  instanceConstructor: _Background
};

// packages/ag-charts-community/src/chart/gridLayout.ts
function gridLayout(_ref134) {
  var orientation = _ref134.orientation,
    bboxes = _ref134.bboxes,
    maxHeight = _ref134.maxHeight,
    maxWidth = _ref134.maxWidth,
    _ref134$itemPaddingY = _ref134.itemPaddingY,
    itemPaddingY = _ref134$itemPaddingY === void 0 ? 0 : _ref134$itemPaddingY,
    _ref134$itemPaddingX = _ref134.itemPaddingX,
    itemPaddingX = _ref134$itemPaddingX === void 0 ? 0 : _ref134$itemPaddingX,
    _ref134$forceResult = _ref134.forceResult,
    forceResult = _ref134$forceResult === void 0 ? false : _ref134$forceResult;
  var horizontal = orientation === "horizontal";
  var primary = {
    max: horizontal ? maxWidth : maxHeight,
    fn: horizontal ? function (b) {
      return b.width;
    } : function (b) {
      return b.height;
    },
    padding: horizontal ? itemPaddingX : itemPaddingY
  };
  var secondary = {
    max: horizontal ? maxHeight : maxWidth,
    fn: horizontal ? function (b) {
      return b.height;
    } : function (b) {
      return b.width;
    },
    padding: horizontal ? itemPaddingY : itemPaddingX
  };
  var processedBBoxCount = 0;
  var rawPages = [];
  while (processedBBoxCount < bboxes.length) {
    var unprocessedBBoxes = bboxes.slice(processedBBoxCount);
    var result = processBBoxes(unprocessedBBoxes, processedBBoxCount, primary, secondary, forceResult);
    if (!result) {
      return;
    }
    processedBBoxCount += result.processedBBoxCount;
    rawPages.push(result.pageIndices);
  }
  return buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX);
}
function processBBoxes(bboxes, indexOffset, primary, secondary, forceResult) {
  var minGuess = 1;
  var startingGuess = estimateStartingGuess(bboxes, primary);
  if (startingGuess < minGuess) {
    if (!forceResult) {
      return;
    }
    startingGuess = minGuess;
  }
  var guess = startingGuess;
  while (guess >= minGuess) {
    var pageIndices = calculatePage(bboxes, indexOffset, guess, primary, secondary, forceResult);
    if (pageIndices == null && guess <= minGuess) {
      return;
    }
    if (pageIndices == null) {
      guess--;
      continue;
    }
    if (typeof pageIndices === "number") {
      if (pageIndices <= minGuess) {
        return;
      }
      guess = pageIndices < guess && pageIndices > minGuess ? pageIndices : guess;
      guess--;
      continue;
    }
    var processedBBoxCount = pageIndices.length * pageIndices[0].length;
    return {
      processedBBoxCount: processedBBoxCount,
      pageIndices: pageIndices
    };
  }
}
function calculatePage(bboxes, indexOffset, primaryCount, primary, secondary, forceResult) {
  var _a;
  var result = [];
  var sumSecondary = 0;
  var currentMaxSecondary = 0;
  var currentPrimaryIndices = [];
  var maxPrimaryValues = [];
  for (var bboxIndex = 0; bboxIndex < bboxes.length; bboxIndex++) {
    var primaryValueIdx = (bboxIndex + primaryCount) % primaryCount;
    if (primaryValueIdx === 0) {
      sumSecondary += currentMaxSecondary;
      currentMaxSecondary = 0;
      if (currentPrimaryIndices.length > 0) {
        result.push(currentPrimaryIndices);
      }
      currentPrimaryIndices = [];
    }
    var primaryValue = primary.fn(bboxes[bboxIndex]) + primary.padding;
    maxPrimaryValues[primaryValueIdx] = Math.max((_a = maxPrimaryValues[primaryValueIdx]) != null ? _a : 0, primaryValue);
    currentMaxSecondary = Math.max(currentMaxSecondary, secondary.fn(bboxes[bboxIndex]) + secondary.padding);
    var currentSecondaryDimension = sumSecondary + currentMaxSecondary;
    var returnResult = !forceResult || result.length > 0;
    if (currentSecondaryDimension > secondary.max && returnResult) {
      currentPrimaryIndices = [];
      break;
    }
    var sumPrimary = maxPrimaryValues.reduce(function (sum2, next) {
      return sum2 + next;
    }, 0);
    if (sumPrimary > primary.max && !forceResult) {
      if (maxPrimaryValues.length < primaryCount) {
        return maxPrimaryValues.length;
      }
      return;
    }
    currentPrimaryIndices.push(bboxIndex + indexOffset);
  }
  if (currentPrimaryIndices.length > 0) {
    result.push(currentPrimaryIndices);
  }
  return result.length > 0 ? result : void 0;
}
function buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX) {
  var maxPageWidth = 0;
  var maxPageHeight = 0;
  var pages = rawPages.map(function (indices) {
    if (orientation === "horizontal") {
      indices = transpose(indices);
    }
    var endIndex = 0;
    var columns = indices.map(function (colIndices) {
      var colBBoxes = colIndices.map(function (bboxIndex) {
        endIndex = Math.max(bboxIndex, endIndex);
        return bboxes[bboxIndex];
      });
      var columnHeight = 0;
      var columnWidth = 0;
      colBBoxes.forEach(function (bbox) {
        columnHeight += bbox.height + itemPaddingY;
        columnWidth = Math.max(columnWidth, bbox.width + itemPaddingX);
      });
      return {
        indices: colIndices,
        bboxes: colBBoxes,
        columnHeight: Math.ceil(columnHeight),
        columnWidth: Math.ceil(columnWidth)
      };
    });
    var pageWidth = 0;
    var pageHeight = 0;
    columns.forEach(function (column) {
      pageWidth += column.columnWidth;
      pageHeight = Math.max(pageHeight, column.columnHeight);
    });
    maxPageWidth = Math.max(pageWidth, maxPageWidth);
    maxPageHeight = Math.max(pageHeight, maxPageHeight);
    return {
      columns: columns,
      startIndex: indices[0][0],
      endIndex: endIndex,
      pageWidth: pageWidth,
      pageHeight: pageHeight
    };
  });
  return {
    pages: pages,
    maxPageWidth: maxPageWidth,
    maxPageHeight: maxPageHeight
  };
}
function transpose(data) {
  var result = [];
  var _iterator194 = _createForOfIteratorHelper(data[0]),
    _step194;
  try {
    for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
      var _ = _step194.value;
      result.push([]);
    }
  } catch (err) {
    _iterator194.e(err);
  } finally {
    _iterator194.f();
  }
  data.forEach(function (innerData, dataIdx) {
    innerData.forEach(function (item, itemIdx) {
      result[itemIdx][dataIdx] = item;
    });
  });
  return result;
}
function estimateStartingGuess(bboxes, primary) {
  var n = bboxes.length;
  var primarySum = 0;
  for (var bboxIndex = 0; bboxIndex < n; bboxIndex++) {
    primarySum += primary.fn(bboxes[bboxIndex]) + primary.padding;
    if (primarySum > primary.max) {
      var ratio = n / bboxIndex;
      if (ratio < 2) {
        return Math.ceil(n / 2);
      }
      return bboxIndex;
    }
  }
  return n;
}

// packages/ag-charts-community/src/chart/markerLabel.ts
var MarkerLabel = /*#__PURE__*/function (_Group2) {
  _inherits(MarkerLabel, _Group2);
  function MarkerLabel() {
    var _this152;
    _classCallCheck(this, MarkerLabel);
    _this152 = _possibleConstructorReturn(this, _getPrototypeOf(MarkerLabel).call(this, {
      name: "markerLabelGroup"
    }));
    _this152.label = new _Text2();
    _this152.line = new _Line();
    _this152._marker = new _Square();
    _this152._markerSize = 15;
    _this152._spacing = 8;
    var _assertThisInitialize2 = _assertThisInitialized(_this152),
      marker = _assertThisInitialize2.marker,
      label = _assertThisInitialize2.label,
      line = _assertThisInitialize2.line;
    label.textBaseline = "middle";
    label.fontSize = 12;
    label.fontFamily = "Verdana, sans-serif";
    label.fill = "black";
    label.y = 1;
    _this152.append([line, marker, label]);
    _this152.update();
    return _this152;
  }
  _createClass(MarkerLabel, [{
    key: "setSeriesStrokeOffset",
    value: function setSeriesStrokeOffset(xOff) {
      var offset4 = this.marker.size / 2 + xOff;
      this.line.x1 = -offset4;
      this.line.x2 = offset4;
      this.line.y1 = 0;
      this.line.y2 = 0;
      this.line.markDirtyTransform();
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var markerSize = this.markerSize;
      var center = this.marker.constructor.center;
      this.marker.size = markerSize;
      this.marker.x = (center.x - 0.5) * markerSize;
      this.marker.y = (center.y - 0.5) * markerSize;
      var lineEnd = this.line.visible ? this.line.x2 : -Infinity;
      var markerEnd = markerSize / 2;
      this.label.x = Math.max(lineEnd, markerEnd) + this.spacing;
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      this.marker.opacity = this.opacity;
      this.label.opacity = this.opacity;
      this.line.opacity = this.opacity;
      _superPropGet(MarkerLabel, "render", this, 3)([renderCtx]);
    }
  }, {
    key: "marker",
    set: function set(value) {
      if (this._marker !== value) {
        this.removeChild(this._marker);
        this._marker = value;
        this.appendChild(value);
        this.update();
      }
    },
    get: function get() {
      return this._marker;
    }
  }, {
    key: "markerSize",
    set: function set(value) {
      if (this._markerSize !== value) {
        this._markerSize = value;
        this.update();
      }
    },
    get: function get() {
      return this._markerSize;
    }
  }, {
    key: "spacing",
    set: function set(value) {
      if (this._spacing !== value) {
        this._spacing = value;
        this.update();
      }
    },
    get: function get() {
      return this._spacing;
    }
  }]);
  return MarkerLabel;
}(_Group4);
MarkerLabel.className = "MarkerLabel";
__decorateClass([_ProxyPropertyOnWrite("label")], MarkerLabel.prototype, "text", 2);
__decorateClass([_ProxyPropertyOnWrite("label")], MarkerLabel.prototype, "fontStyle", 2);
__decorateClass([_ProxyPropertyOnWrite("label")], MarkerLabel.prototype, "fontWeight", 2);
__decorateClass([_ProxyPropertyOnWrite("label")], MarkerLabel.prototype, "fontSize", 2);
__decorateClass([_ProxyPropertyOnWrite("label")], MarkerLabel.prototype, "fontFamily", 2);
__decorateClass([_ProxyPropertyOnWrite("label", "fill")], MarkerLabel.prototype, "color", 2);
__decorateClass([_ProxyPropertyOnWrite("marker", "fill")], MarkerLabel.prototype, "markerFill", 2);
__decorateClass([_ProxyPropertyOnWrite("marker", "stroke")], MarkerLabel.prototype, "markerStroke", 2);
__decorateClass([_ProxyPropertyOnWrite("marker", "strokeWidth")], MarkerLabel.prototype, "markerStrokeWidth", 2);
__decorateClass([_ProxyPropertyOnWrite("marker", "fillOpacity")], MarkerLabel.prototype, "markerFillOpacity", 2);
__decorateClass([_ProxyPropertyOnWrite("marker", "strokeOpacity")], MarkerLabel.prototype, "markerStrokeOpacity", 2);
__decorateClass([_ProxyPropertyOnWrite("marker", "visible")], MarkerLabel.prototype, "markerVisible", 2);
__decorateClass([_ProxyPropertyOnWrite("line", "stroke")], MarkerLabel.prototype, "lineStroke", 2);
__decorateClass([_ProxyPropertyOnWrite("line", "strokeWidth")], MarkerLabel.prototype, "lineStrokeWidth", 2);
__decorateClass([_ProxyPropertyOnWrite("line", "strokeOpacity")], MarkerLabel.prototype, "lineStrokeOpacity", 2);
__decorateClass([_ProxyPropertyOnWrite("line", "lineDash")], MarkerLabel.prototype, "lineLineDash", 2);
__decorateClass([_ProxyPropertyOnWrite("line", "visible")], MarkerLabel.prototype, "lineVisible", 2);

// packages/ag-charts-community/src/chart/pagination/pagination.ts
var PaginationLabel = /*#__PURE__*/function (_BaseProperties17) {
  _inherits(PaginationLabel, _BaseProperties17);
  function PaginationLabel() {
    var _this153;
    _classCallCheck(this, PaginationLabel);
    _this153 = _possibleConstructorReturn(this, _getPrototypeOf(PaginationLabel).apply(this, arguments));
    _this153.color = "black";
    _this153.fontStyle = void 0;
    _this153.fontWeight = void 0;
    _this153.fontSize = 12;
    _this153.fontFamily = "Verdana, sans-serif";
    return _this153;
  }
  return PaginationLabel;
}(_BaseProperties35);
__decorateClass([_Validate(_COLOR_STRING)], PaginationLabel.prototype, "color", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
})], PaginationLabel.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
})], PaginationLabel.prototype, "fontWeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PaginationLabel.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING)], PaginationLabel.prototype, "fontFamily", 2);
var PaginationMarkerStyle = /*#__PURE__*/function (_BaseProperties18) {
  _inherits(PaginationMarkerStyle, _BaseProperties18);
  function PaginationMarkerStyle() {
    var _this154;
    _classCallCheck(this, PaginationMarkerStyle);
    _this154 = _possibleConstructorReturn(this, _getPrototypeOf(PaginationMarkerStyle).apply(this, arguments));
    _this154.size = 15;
    _this154.fill = void 0;
    _this154.fillOpacity = void 0;
    _this154.stroke = void 0;
    _this154.strokeWidth = 1;
    _this154.strokeOpacity = 1;
    return _this154;
  }
  return PaginationMarkerStyle;
}(_BaseProperties35);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PaginationMarkerStyle.prototype, "size", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], PaginationMarkerStyle.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], PaginationMarkerStyle.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], PaginationMarkerStyle.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PaginationMarkerStyle.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO)], PaginationMarkerStyle.prototype, "strokeOpacity", 2);
var PaginationMarker = /*#__PURE__*/function (_BaseProperties19) {
  _inherits(PaginationMarker, _BaseProperties19);
  function PaginationMarker(parent) {
    var _this155;
    _classCallCheck(this, PaginationMarker);
    _this155 = _possibleConstructorReturn(this, _getPrototypeOf(PaginationMarker).call(this));
    _this155.parent = parent;
    _this155.shape = _Triangle2;
    _this155.size = 15;
    _this155.padding = 8;
    return _this155;
  }
  return PaginationMarker;
}(_BaseProperties35);
__decorateClass([_ActionOnSet({
  changeValue: function changeValue() {
    if (this.parent.marker === this) {
      this.parent.onMarkerShapeChange();
    }
  }
})], PaginationMarker.prototype, "shape", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PaginationMarker.prototype, "size", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PaginationMarker.prototype, "padding", 2);
var Pagination = /*#__PURE__*/function (_BaseProperties20) {
  _inherits(Pagination, _BaseProperties20);
  function Pagination(chartUpdateCallback, pageUpdateCallback, regionManager, cursorManager) {
    var _this156;
    _classCallCheck(this, Pagination);
    _this156 = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this));
    _this156.chartUpdateCallback = chartUpdateCallback;
    _this156.pageUpdateCallback = pageUpdateCallback;
    _this156.regionManager = regionManager;
    _this156.cursorManager = cursorManager;
    _this156.id = _createId(_assertThisInitialized(_this156));
    _this156.marker = new PaginationMarker(_assertThisInitialized(_this156));
    _this156.activeStyle = new PaginationMarkerStyle();
    _this156.inactiveStyle = new PaginationMarkerStyle();
    _this156.highlightStyle = new PaginationMarkerStyle();
    _this156.label = new PaginationLabel();
    _this156.group = new _Group4({
      name: "pagination"
    });
    _this156.labelNode = new _Text2();
    _this156.destroyFns = [];
    _this156.totalPages = 0;
    _this156.currentPage = 0;
    _this156.translationX = 0;
    _this156.translationY = 0;
    _this156.nextButtonDisabled = false;
    _this156.previousButtonDisabled = false;
    _this156._visible = true;
    _this156._enabled = true;
    _this156._orientation = "vertical";
    _this156._nextButton = new _Triangle2();
    _this156._previousButton = new _Triangle2();
    _this156.labelNode.setProperties({
      textBaseline: "middle",
      fontSize: 12,
      fontFamily: "Verdana, sans-serif",
      fill: "black",
      y: 1
    });
    _this156.group.append([_this156.nextButton, _this156.previousButton, _this156.labelNode]);
    var region = _this156.regionManager.addRegion("pagination", _this156.group);
    _this156.destroyFns.push(region.addListener("click", function (event) {
      return _this156.onPaginationClick(event);
    }), region.addListener("hover", function (event) {
      return _this156.onPaginationMouseMove(event);
    }));
    _this156.update();
    _this156.updateMarkers();
    return _this156;
  }
  _createClass(Pagination, [{
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (f) {
        return f();
      });
    }
  }, {
    key: "updateGroupVisibility",
    value: function updateGroupVisibility() {
      this.group.visible = this.enabled && this.visible;
    }
  }, {
    key: "update",
    value: function update() {
      this.updateLabel();
      this.updatePositions();
      this.enableOrDisableButtons();
    }
  }, {
    key: "updatePositions",
    value: function updatePositions() {
      this.group.translationX = this.translationX;
      this.group.translationY = this.translationY;
      this.updateLabelPosition();
      this.updateNextButtonPosition();
    }
  }, {
    key: "updateLabelPosition",
    value: function updateLabelPosition() {
      var _this$marker = this.marker,
        markerSize = _this$marker.size,
        markerPadding = _this$marker.padding;
      this.nextButton.size = markerSize;
      this.previousButton.size = markerSize;
      this.labelNode.x = markerSize / 2 + markerPadding;
    }
  }, {
    key: "updateNextButtonPosition",
    value: function updateNextButtonPosition() {
      var labelBBox = this.labelNode.computeBBox();
      this.nextButton.translationX = labelBBox.x + labelBBox.width + this.marker.size / 2 + this.marker.padding;
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      var currentPage = this.currentPage,
        pages = this.totalPages,
        labelNode = this.labelNode,
        _this$label6 = this.label,
        color = _this$label6.color,
        fontStyle = _this$label6.fontStyle,
        fontWeight = _this$label6.fontWeight,
        fontSize = _this$label6.fontSize,
        fontFamily = _this$label6.fontFamily;
      labelNode.text = "".concat(currentPage + 1, " / ").concat(pages);
      labelNode.fill = color;
      labelNode.fontStyle = fontStyle;
      labelNode.fontWeight = fontWeight;
      labelNode.fontSize = fontSize;
      labelNode.fontFamily = fontFamily;
    }
  }, {
    key: "updateMarkers",
    value: function updateMarkers() {
      var nextButton = this.nextButton,
        previousButton = this.previousButton,
        nextButtonDisabled = this.nextButtonDisabled,
        previousButtonDisabled = this.previousButtonDisabled,
        activeStyle = this.activeStyle,
        inactiveStyle = this.inactiveStyle,
        highlightStyle = this.highlightStyle,
        highlightActive = this.highlightActive;
      var buttonStyle = function buttonStyle(button, disabled) {
        if (disabled) {
          return inactiveStyle;
        } else if (button === highlightActive) {
          return highlightStyle;
        }
        return activeStyle;
      };
      this.updateMarker(nextButton, buttonStyle("next", nextButtonDisabled));
      this.updateMarker(previousButton, buttonStyle("previous", previousButtonDisabled));
    }
  }, {
    key: "updateMarker",
    value: function updateMarker(marker, style) {
      var _a;
      var size = this.marker.size;
      marker.size = size;
      marker.fill = style.fill;
      marker.fillOpacity = (_a = style.fillOpacity) != null ? _a : 1;
      marker.stroke = style.stroke;
      marker.strokeWidth = style.strokeWidth;
      marker.strokeOpacity = style.strokeOpacity;
    }
  }, {
    key: "enableOrDisableButtons",
    value: function enableOrDisableButtons() {
      var currentPage = this.currentPage,
        totalPages = this.totalPages;
      var zeroPagesToDisplay = totalPages === 0;
      var onLastPage = currentPage === totalPages - 1;
      var onFirstPage = currentPage === 0;
      this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
      this.previousButtonDisabled = onFirstPage || zeroPagesToDisplay;
    }
  }, {
    key: "nextButtonContainsPoint",
    value: function nextButtonContainsPoint(offsetX, offsetY) {
      return !this.nextButtonDisabled && this.nextButton.containsPoint(offsetX, offsetY);
    }
  }, {
    key: "previousButtonContainsPoint",
    value: function previousButtonContainsPoint(offsetX, offsetY) {
      return !this.previousButtonDisabled && this.previousButton.containsPoint(offsetX, offsetY);
    }
  }, {
    key: "clickNext",
    value: function clickNext() {
      this.incrementPage();
      this.onPaginationChanged();
    }
  }, {
    key: "clickPrevious",
    value: function clickPrevious() {
      this.decrementPage();
      this.onPaginationChanged();
    }
  }, {
    key: "setPage",
    value: function setPage(pageNumber) {
      pageNumber = _clamp(0, pageNumber, this.totalPages - 1);
      if (this.currentPage !== pageNumber) {
        this.currentPage = pageNumber;
        this.onPaginationChanged();
      }
    }
  }, {
    key: "onPaginationClick",
    value: function onPaginationClick(event) {
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      if (this.nextButtonContainsPoint(offsetX, offsetY)) {
        this.clickNext();
        event.consume();
      } else if (this.previousButtonContainsPoint(offsetX, offsetY)) {
        this.clickPrevious();
        event.consume();
      }
    }
  }, {
    key: "onPaginationMouseMove",
    value: function onPaginationMouseMove(event) {
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      if (this.nextButtonContainsPoint(offsetX, offsetY)) {
        this.cursorManager.updateCursor(this.id, "pointer");
        this.highlightActive = "next";
      } else if (this.previousButtonContainsPoint(offsetX, offsetY)) {
        this.cursorManager.updateCursor(this.id, "pointer");
        this.highlightActive = "previous";
      } else {
        this.cursorManager.updateCursor(this.id);
        this.highlightActive = void 0;
      }
      this.updateMarkers();
      this.chartUpdateCallback(6 /* SCENE_RENDER */);
    }
  }, {
    key: "onPaginationChanged",
    value: function onPaginationChanged() {
      this.pageUpdateCallback(this.currentPage);
    }
  }, {
    key: "incrementPage",
    value: function incrementPage() {
      this.currentPage = Math.min(this.currentPage + 1, this.totalPages - 1);
    }
  }, {
    key: "decrementPage",
    value: function decrementPage() {
      this.currentPage = Math.max(this.currentPage - 1, 0);
    }
  }, {
    key: "onMarkerShapeChange",
    value: function onMarkerShapeChange() {
      var Marker2 = _getMarker(this.marker.shape || _Triangle2);
      this.previousButton = new Marker2();
      this.nextButton = new Marker2();
      this.updatePositions();
      this.updateMarkers();
      this.chartUpdateCallback(6 /* SCENE_RENDER */);
    }
  }, {
    key: "attachPagination",
    value: function attachPagination(node) {
      node.append(this.group);
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      return this.group.computeBBox();
    }
  }, {
    key: "visible",
    set: function set(value) {
      this._visible = value;
      this.updateGroupVisibility();
    },
    get: function get() {
      return this._visible;
    }
  }, {
    key: "enabled",
    set: function set(value) {
      this._enabled = value;
      this.updateGroupVisibility();
    },
    get: function get() {
      return this._enabled;
    }
  }, {
    key: "orientation",
    set: function set(value) {
      this._orientation = value;
      switch (value) {
        case "horizontal":
          {
            this.previousButton.rotation = -Math.PI / 2;
            this.nextButton.rotation = Math.PI / 2;
            break;
          }
        case "vertical":
        default:
          {
            this.previousButton.rotation = 0;
            this.nextButton.rotation = Math.PI;
          }
      }
    },
    get: function get() {
      return this._orientation;
    }
  }, {
    key: "nextButton",
    set: function set(value) {
      if (this._nextButton !== value) {
        this.group.removeChild(this._nextButton);
        this._nextButton = value;
        this.group.appendChild(value);
      }
    },
    get: function get() {
      return this._nextButton;
    }
  }, {
    key: "previousButton",
    set: function set(value) {
      if (this._previousButton !== value) {
        this.group.removeChild(this._previousButton);
        this._previousButton = value;
        this.group.appendChild(value);
      }
    },
    get: function get() {
      return this._previousButton;
    }
  }]);
  return Pagination;
}(_BaseProperties35);
Pagination.className = "Pagination";
__decorateClass([_Validate(_OBJECT)], Pagination.prototype, "marker", 2);
__decorateClass([_Validate(_OBJECT)], Pagination.prototype, "activeStyle", 2);
__decorateClass([_Validate(_OBJECT)], Pagination.prototype, "inactiveStyle", 2);
__decorateClass([_Validate(_OBJECT)], Pagination.prototype, "highlightStyle", 2);
__decorateClass([_Validate(_OBJECT)], Pagination.prototype, "label", 2);

// packages/ag-charts-community/src/chart/legend.ts
var LegendLabel = /*#__PURE__*/function (_BaseProperties21) {
  _inherits(LegendLabel, _BaseProperties21);
  function LegendLabel() {
    var _this157;
    _classCallCheck(this, LegendLabel);
    _this157 = _possibleConstructorReturn(this, _getPrototypeOf(LegendLabel).apply(this, arguments));
    _this157.maxLength = void 0;
    _this157.color = "black";
    _this157.fontStyle = void 0;
    _this157.fontWeight = void 0;
    _this157.fontSize = 12;
    _this157.fontFamily = "Verdana, sans-serif";
    _this157.formatter = void 0;
    return _this157;
  }
  return LegendLabel;
}(_BaseProperties35);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], LegendLabel.prototype, "maxLength", 2);
__decorateClass([_Validate(_COLOR_STRING)], LegendLabel.prototype, "color", 2);
__decorateClass([_Validate(_FONT_STYLE, {
  optional: true
})], LegendLabel.prototype, "fontStyle", 2);
__decorateClass([_Validate(FONT_WEIGHT2, {
  optional: true
})], LegendLabel.prototype, "fontWeight", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LegendLabel.prototype, "fontSize", 2);
__decorateClass([_Validate(_STRING)], LegendLabel.prototype, "fontFamily", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], LegendLabel.prototype, "formatter", 2);
var LegendMarker = /*#__PURE__*/function (_BaseProperties22) {
  _inherits(LegendMarker, _BaseProperties22);
  function LegendMarker() {
    var _this158;
    _classCallCheck(this, LegendMarker);
    _this158 = _possibleConstructorReturn(this, _getPrototypeOf(LegendMarker).apply(this, arguments));
    _this158.size = 15;
    _this158.padding = 8;
    _this158.enabled = true;
    return _this158;
  }
  return LegendMarker;
}(_BaseProperties35);
__decorateClass([_ObserveChanges(function (target) {
  var _a;
  return (_a = target.parent) == null ? void 0 : _a.onMarkerShapeChange();
})], LegendMarker.prototype, "shape", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LegendMarker.prototype, "size", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LegendMarker.prototype, "padding", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], LegendMarker.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_BOOLEAN)], LegendMarker.prototype, "enabled", 2);
var LegendLine = /*#__PURE__*/function (_BaseProperties23) {
  _inherits(LegendLine, _BaseProperties23);
  function LegendLine() {
    _classCallCheck(this, LegendLine);
    return _possibleConstructorReturn(this, _getPrototypeOf(LegendLine).apply(this, arguments));
  }
  return LegendLine;
}(_BaseProperties35);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], LegendLine.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], LegendLine.prototype, "length", 2);
var LegendItem = /*#__PURE__*/function (_BaseProperties24) {
  _inherits(LegendItem, _BaseProperties24);
  function LegendItem() {
    var _this159;
    _classCallCheck(this, LegendItem);
    _this159 = _possibleConstructorReturn(this, _getPrototypeOf(LegendItem).apply(this, arguments));
    _this159.paddingX = 16;
    _this159.paddingY = 8;
    _this159.toggleSeriesVisible = true;
    _this159.showSeriesStroke = false;
    _this159.marker = new LegendMarker();
    _this159.label = new LegendLabel();
    _this159.line = new LegendLine();
    return _this159;
  }
  return LegendItem;
}(_BaseProperties35);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], LegendItem.prototype, "maxWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LegendItem.prototype, "paddingX", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LegendItem.prototype, "paddingY", 2);
__decorateClass([_Validate(_BOOLEAN)], LegendItem.prototype, "toggleSeriesVisible", 2);
__decorateClass([_Validate(_BOOLEAN)], LegendItem.prototype, "showSeriesStroke", 2);
__decorateClass([_Validate(_OBJECT)], LegendItem.prototype, "marker", 2);
__decorateClass([_Validate(_OBJECT)], LegendItem.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], LegendItem.prototype, "line", 2);
var LegendListeners = /*#__PURE__*/function (_BaseProperties25) {
  _inherits(LegendListeners, _BaseProperties25);
  function LegendListeners() {
    _classCallCheck(this, LegendListeners);
    return _possibleConstructorReturn(this, _getPrototypeOf(LegendListeners).apply(this, arguments));
  }
  return LegendListeners;
}(_BaseProperties35);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], LegendListeners.prototype, "legendItemClick", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], LegendListeners.prototype, "legendItemDoubleClick", 2);
var Legend = /*#__PURE__*/function (_BaseProperties26) {
  _inherits(Legend, _BaseProperties26);
  function Legend(ctx) {
    var _this160;
    _classCallCheck(this, Legend);
    _this160 = _possibleConstructorReturn(this, _getPrototypeOf(Legend).call(this));
    _this160.ctx = ctx;
    _this160.id = _createId(_assertThisInitialized(_this160));
    _this160.group = new _Group4({
      name: "legend",
      layer: true,
      zIndex: 11 /* LEGEND_ZINDEX */
    });
    _this160.itemSelection = _Selection2.select(_this160.group, MarkerLabel);
    _this160.oldSize = [0, 0];
    _this160.pages = [];
    _this160.maxPageSize = [0, 0];
    /** Item index to track on re-pagination, so current page updates appropriately. */
    _this160.paginationTrackingIndex = 0;
    _this160.truncatedItems = /* @__PURE__ */new Set();
    _this160._data = [];
    _this160.item = new LegendItem();
    _this160.listeners = new LegendListeners();
    _this160.enabled = true;
    _this160.position = "bottom";
    _this160.spacing = 20;
    _this160.characterWidths = /* @__PURE__ */new Map();
    _this160.destroyFns = [];
    _this160.size = [0, 0];
    _this160._visible = true;
    _this160.focus = {
      mode: "item",
      index: 0
    };
    _this160.item.marker.parent = _assertThisInitialized(_this160);
    _this160.pagination = new Pagination(function (type) {
      return ctx.updateService.update(type);
    }, function (page) {
      return _this160.updatePageNumber(page);
    }, ctx.regionManager, ctx.cursorManager);
    _this160.pagination.attachPagination(_this160.group);
    _this160.item.marker.parent = _assertThisInitialized(_this160);
    var animationState = 16 /* Default */ | 1 /* Animation */;
    var region = ctx.regionManager.addRegionFromProperties({
      name: "legend",
      bboxproviders: [_this160.group],
      canInteraction: function canInteraction() {
        return _this160.enabled && _this160.group.visible;
      }
    });
    _this160.destroyFns.push(region.addListener("click", function (e) {
      return _this160.checkLegendClick(e);
    }, animationState), region.addListener("dblclick", function (e) {
      return _this160.checkLegendDoubleClick(e);
    }, animationState), region.addListener("hover", function (e) {
      return _this160.handleLegendMouseMove(e);
    }), region.addListener("leave", function (e) {
      return _this160.handleLegendMouseExit(e);
    }, animationState), region.addListener("enter", function (e) {
      return _this160.handleLegendMouseEnter(e);
    }, animationState), region.addListener("blur", function (e) {
      return _this160.onBlur(e);
    }), region.addListener("tab", function (e) {
      return _this160.onTab(e);
    }), region.addListener("tab-start", function (e) {
      return _this160.onTabStart(e);
    }), region.addListener("nav-vert", function (e) {
      return _this160.onNav(e);
    }), region.addListener("nav-hori", function (e) {
      return _this160.onNav(e);
    }), region.addListener("submit", function (e) {
      return _this160.onSubmit(e);
    }), ctx.layoutService.addListener("start-layout", function (e) {
      return _this160.positionLegend(e.shrinkRect);
    }), function () {
      return _this160.detachLegend();
    });
    return _this160;
  }
  _createClass(Legend, [{
    key: "destroy",
    value: function destroy() {
      this.destroyFns.forEach(function (f) {
        return f();
      });
      this.pagination.destroy();
    }
  }, {
    key: "onMarkerShapeChange",
    value: function onMarkerShapeChange() {
      this.itemSelection.clear();
      this.group.markDirty(this.group, 2 /* MINOR */);
    }
  }, {
    key: "getOrientation",
    value: function getOrientation() {
      if (this.orientation !== void 0) {
        return this.orientation;
      }
      switch (this.position) {
        case "right":
        case "left":
          return "vertical";
        case "bottom":
        case "top":
          return "horizontal";
      }
    }
  }, {
    key: "getCharacterWidths",
    value: function getCharacterWidths(font) {
      var characterWidths = this.characterWidths;
      if (characterWidths.has(font)) {
        return characterWidths.get(font);
      }
      var cw = {
        "...": _Text2.getTextSize("...", font).width
      };
      characterWidths.set(font, cw);
      return cw;
    }
  }, {
    key: "updateGroupVisibility",
    value: function updateGroupVisibility() {
      this.group.visible = this.enabled && this.visible && this.data.length > 0;
    }
  }, {
    key: "attachLegend",
    value: function attachLegend(scene) {
      scene.appendChild(this.group);
    }
  }, {
    key: "detachLegend",
    value: function detachLegend() {
      var _a;
      (_a = this.group.parent) == null ? void 0 : _a.removeChild(this.group);
    }
  }, {
    key: "getItemLabel",
    value: function getItemLabel(datum) {
      var callbackCache = this.ctx.callbackCache;
      var formatter = this.item.label.formatter;
      if (formatter) {
        return callbackCache.call(formatter, {
          itemId: datum.itemId,
          value: datum.label.text,
          seriesId: datum.seriesId
        });
      }
      return datum.label.text;
    }
    /**
     * The method is given the desired size of the legend, which only serves as a hint.
     * The vertically oriented legend will take as much horizontal space as needed, but will
     * respect the height constraints, and the horizontal legend will take as much vertical
     * space as needed in an attempt not to exceed the given width.
     * After the layout is done, the {@link size} will contain the actual size of the legend.
     * If the actual size is not the same as the previous actual size, the legend will fire
     * the 'layoutChange' event to communicate that another layout is needed, and the above
     * process should be repeated.
     * @param width
     * @param height
     */
  }, {
    key: "calcLayout",
    value: function calcLayout(width, height) {
      var _this161 = this;
      var _this$item = this.item,
        paddingX = _this$item.paddingX,
        paddingY = _this$item.paddingY,
        label = _this$item.label,
        maxWidth = _this$item.maxWidth,
        _this$item$marker = _this$item.marker,
        markerSize = _this$item$marker.size,
        markerPadding = _this$item$marker.padding,
        markerShape = _this$item$marker.shape,
        _this$item$label = _this$item.label,
        _this$item$label$maxL = _this$item$label.maxLength,
        maxLength = _this$item$label$maxL === void 0 ? Infinity : _this$item$label$maxL,
        fontStyle = _this$item$label.fontStyle,
        fontWeight = _this$item$label.fontWeight,
        fontSize = _this$item$label.fontSize,
        fontFamily = _this$item$label.fontFamily,
        itemLine = _this$item.line,
        showSeriesStroke = _this$item.showSeriesStroke;
      var data = _toConsumableArray(this.data);
      if (this.reverseOrder) {
        data.reverse();
      }
      this.itemSelection.update(data);
      var bboxes = [];
      var font = _getFont(label);
      var itemMaxWidthPercentage = 0.8;
      var maxItemWidth = maxWidth != null ? maxWidth : width * itemMaxWidthPercentage;
      var paddedMarkerWidth = markerSize + markerPadding + paddingX;
      this.itemSelection.each(function (markerLabel, datum) {
        var _a, _b, _c;
        var Marker2 = _getMarker(markerShape != null ? markerShape : datum.marker.shape);
        var markerEnabled = (_a = datum.marker.enabled) != null ? _a : _this161.item.marker.enabled;
        if (!(markerLabel.marker && markerLabel.marker instanceof Marker2)) {
          markerLabel.marker = new Marker2();
        }
        markerLabel.markerSize = markerSize;
        markerLabel.spacing = markerPadding;
        markerLabel.fontStyle = fontStyle;
        markerLabel.fontWeight = fontWeight;
        markerLabel.fontSize = fontSize;
        markerLabel.fontFamily = fontFamily;
        var id = (_b = datum.itemId) != null ? _b : datum.id;
        var labelText = _this161.getItemLabel(datum);
        var text = (labelText != null ? labelText : "<unknown>").replace(/\r?\n/g, " ");
        markerLabel.text = _this161.truncate(text, maxLength, maxItemWidth, paddedMarkerWidth, font, id);
        if (showSeriesStroke && datum.line !== void 0) {
          markerLabel.lineVisible = true;
          markerLabel.markerVisible = markerEnabled;
          markerLabel.setSeriesStrokeOffset((_c = itemLine.length) != null ? _c : 5);
        } else {
          markerLabel.lineVisible = false;
          markerLabel.markerVisible = true;
        }
        bboxes.push(markerLabel.computeBBox());
      });
      width = Math.max(1, width);
      height = Math.max(1, height);
      if (!isFinite(width)) {
        return false;
      }
      var size = this.size;
      var oldSize = this.oldSize;
      size[0] = width;
      size[1] = height;
      if (size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
        oldSize[0] = size[0];
        oldSize[1] = size[1];
      }
      var _this$updatePaginatio = this.updatePagination(bboxes, width, height),
        pages = _this$updatePaginatio.pages,
        maxPageHeight = _this$updatePaginatio.maxPageHeight,
        maxPageWidth = _this$updatePaginatio.maxPageWidth;
      this.pages = pages;
      this.maxPageSize = [maxPageWidth - paddingX, maxPageHeight - paddingY];
      var pageNumber = this.pagination.currentPage;
      var page = this.pages[pageNumber];
      if (this.pages.length < 1 || !page) {
        this.visible = false;
        return;
      }
      this.visible = true;
      this.updatePositions(pageNumber);
      this.update();
    }
  }, {
    key: "truncate",
    value: function truncate(text, maxCharLength, maxItemWidth, paddedMarkerWidth, font, id) {
      var ellipsis2 = "...";
      var textChars = text.split("");
      var addEllipsis = false;
      if (text.length > maxCharLength) {
        text = "".concat(text.substring(0, maxCharLength));
        addEllipsis = true;
      }
      var labelWidth = Math.floor(paddedMarkerWidth + _Text2.getTextSize(text, font).width);
      if (labelWidth > maxItemWidth) {
        var truncatedText = "";
        var characterWidths = this.getCharacterWidths(font);
        var cumulativeWidth = paddedMarkerWidth + characterWidths[ellipsis2];
        var _iterator195 = _createForOfIteratorHelper(textChars),
          _step195;
        try {
          for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
            var char = _step195.value;
            if (!characterWidths[char]) {
              characterWidths[char] = _Text2.getTextSize(char, font).width;
            }
            cumulativeWidth += characterWidths[char];
            if (cumulativeWidth > maxItemWidth) {
              break;
            }
            truncatedText += char;
          }
        } catch (err) {
          _iterator195.e(err);
        } finally {
          _iterator195.f();
        }
        text = truncatedText;
        addEllipsis = true;
      }
      if (addEllipsis) {
        text += ellipsis2;
        this.truncatedItems.add(id);
      } else {
        this.truncatedItems.delete(id);
      }
      return text;
    }
  }, {
    key: "updatePagination",
    value: function updatePagination(bboxes, width, height) {
      var orientation = this.getOrientation();
      var trackingIndex = Math.min(this.paginationTrackingIndex, bboxes.length);
      this.pagination.orientation = orientation;
      this.pagination.translationX = 0;
      this.pagination.translationY = 0;
      var _this$calculatePagina = this.calculatePagination(bboxes, width, height),
        pages = _this$calculatePagina.pages,
        maxPageHeight = _this$calculatePagina.maxPageHeight,
        maxPageWidth = _this$calculatePagina.maxPageWidth,
        paginationBBox = _this$calculatePagina.paginationBBox,
        paginationVertical = _this$calculatePagina.paginationVertical;
      var newCurrentPage = pages.findIndex(function (p) {
        return p.endIndex >= trackingIndex;
      });
      this.pagination.currentPage = _clamp(0, newCurrentPage, pages.length - 1);
      var _this$item2 = this.item,
        itemPaddingX = _this$item2.paddingX,
        itemPaddingY = _this$item2.paddingY;
      var paginationComponentPadding = 8;
      var legendItemsWidth = maxPageWidth - itemPaddingX;
      var legendItemsHeight = maxPageHeight - itemPaddingY;
      var paginationX = 0;
      var paginationY = -paginationBBox.y - this.item.marker.size / 2;
      if (paginationVertical) {
        paginationY += legendItemsHeight + paginationComponentPadding;
      } else {
        paginationX += -paginationBBox.x + legendItemsWidth + paginationComponentPadding;
        paginationY += (legendItemsHeight - paginationBBox.height) / 2;
      }
      this.pagination.translationX = paginationX;
      this.pagination.translationY = paginationY;
      this.pagination.update();
      this.pagination.updateMarkers();
      return {
        maxPageHeight: maxPageHeight,
        maxPageWidth: maxPageWidth,
        pages: pages
      };
    }
  }, {
    key: "calculatePagination",
    value: function calculatePagination(bboxes, width, height) {
      var _a, _b, _c;
      var _this$item3 = this.item,
        itemPaddingX = _this$item3.paddingX,
        itemPaddingY = _this$item3.paddingY;
      var orientation = this.getOrientation();
      var paginationVertical = ["left", "right"].includes(this.position);
      var paginationBBox = this.pagination.computeBBox();
      var lastPassPaginationBBox = new _BBox2(0, 0, 0, 0);
      var pages = [];
      var maxPageWidth = 0;
      var maxPageHeight = 0;
      var count = 0;
      var stableOutput = function stableOutput(bbox) {
        return bbox.width === paginationBBox.width && bbox.height === paginationBBox.height;
      };
      var forceResult = this.maxWidth !== void 0 && this.maxHeight !== void 0;
      do {
        if (count++ > 10) {
          _Logger.warn("unable to find stable legend layout.");
          break;
        }
        paginationBBox = lastPassPaginationBBox;
        var maxWidth = width - (paginationVertical ? 0 : paginationBBox.width);
        var maxHeight = height - (paginationVertical ? paginationBBox.height : 0);
        var layout = gridLayout({
          orientation: orientation,
          bboxes: bboxes,
          maxHeight: maxHeight,
          maxWidth: maxWidth,
          itemPaddingY: itemPaddingY,
          itemPaddingX: itemPaddingX,
          forceResult: forceResult
        });
        pages = (_a = layout == null ? void 0 : layout.pages) != null ? _a : [];
        maxPageWidth = (_b = layout == null ? void 0 : layout.maxPageWidth) != null ? _b : 0;
        maxPageHeight = (_c = layout == null ? void 0 : layout.maxPageHeight) != null ? _c : 0;
        var totalPages = pages.length;
        this.pagination.visible = totalPages > 1;
        this.pagination.totalPages = totalPages;
        this.pagination.update();
        lastPassPaginationBBox = this.pagination.computeBBox();
        if (!this.pagination.visible) {
          break;
        }
      } while (!stableOutput(lastPassPaginationBBox));
      return {
        maxPageWidth: maxPageWidth,
        maxPageHeight: maxPageHeight,
        pages: pages,
        paginationBBox: paginationBBox,
        paginationVertical: paginationVertical
      };
    }
  }, {
    key: "getPageItemCount",
    value: function getPageItemCount(pageNumber) {
      var count = 0;
      var _iterator196 = _createForOfIteratorHelper(this.pages[pageNumber].columns),
        _step196;
      try {
        for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
          var col = _step196.value;
          count += col.indices.length;
        }
      } catch (err) {
        _iterator196.e(err);
      } finally {
        _iterator196.f();
      }
      return count;
    }
  }, {
    key: "getNodeIndexFromFocusIndex",
    value: function getNodeIndexFromFocusIndex() {
      var index = this.focus.index;
      var page = this.pages[this.pagination.currentPage];
      var itemCount = 0;
      var _iterator197 = _createForOfIteratorHelper(page.columns),
        _step197;
      try {
        for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
          var col = _step197.value;
          if (index < itemCount + col.indices.length) {
            return col.indices[index - itemCount];
          } else {
            itemCount += col.indices.length;
          }
        }
      } catch (err) {
        _iterator197.e(err);
      } finally {
        _iterator197.f();
      }
      return -1;
    }
  }, {
    key: "updatePositions",
    value: function updatePositions() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var paddingY = this.item.paddingY,
        itemSelection = this.itemSelection,
        pages = this.pages;
      if (pages.length < 1 || !pages[pageNumber]) {
        return;
      }
      var _pages$pageNumber = pages[pageNumber],
        columns = _pages$pageNumber.columns,
        visibleStart = _pages$pageNumber.startIndex,
        visibleEnd = _pages$pageNumber.endIndex;
      var x = 0;
      var y = 0;
      var columnCount = columns.length;
      var rowCount = columns[0].indices.length;
      var horizontal = this.getOrientation() === "horizontal";
      var itemHeight = columns[0].bboxes[0].height + paddingY;
      var rowSumColumnWidths = [];
      itemSelection.each(function (markerLabel, _, i) {
        var _a, _b;
        if (i < visibleStart || i > visibleEnd) {
          markerLabel.visible = false;
          return;
        }
        var pageIndex = i - visibleStart;
        var columnIndex = 0;
        var rowIndex = 0;
        if (horizontal) {
          columnIndex = pageIndex % columnCount;
          rowIndex = Math.floor(pageIndex / columnCount);
        } else {
          columnIndex = Math.floor(pageIndex / rowCount);
          rowIndex = pageIndex % rowCount;
        }
        markerLabel.visible = true;
        var column = columns[columnIndex];
        if (!column) {
          return;
        }
        y = itemHeight * rowIndex;
        x = (_a = rowSumColumnWidths[rowIndex]) != null ? _a : 0;
        rowSumColumnWidths[rowIndex] = ((_b = rowSumColumnWidths[rowIndex]) != null ? _b : 0) + column.columnWidth;
        markerLabel.translationX = Math.floor(x);
        markerLabel.translationY = Math.floor(y);
      });
    }
  }, {
    key: "updatePageNumber",
    value: function updatePageNumber(pageNumber) {
      var pages = this.pages;
      var _pages$pageNumber2 = pages[pageNumber],
        startIndex = _pages$pageNumber2.startIndex,
        endIndex = _pages$pageNumber2.endIndex;
      if (startIndex === 0) {
        this.paginationTrackingIndex = 0;
      } else if (pageNumber === pages.length - 1) {
        this.paginationTrackingIndex = endIndex;
      } else {
        this.paginationTrackingIndex = Math.floor((startIndex + endIndex) / 2);
      }
      this.pagination.update();
      this.pagination.updateMarkers();
      this.updatePositions(pageNumber);
      this.ctx.updateService.update(6 /* SCENE_RENDER */);
    }
  }, {
    key: "update",
    value: function update() {
      var _this$item4 = this.item,
        color = _this$item4.label.color,
        itemMarker = _this$item4.marker,
        itemLine = _this$item4.line,
        showSeriesStroke = _this$item4.showSeriesStroke;
      this.itemSelection.each(function (markerLabel, datum) {
        var _a, _b;
        var marker = datum.marker;
        markerLabel.markerFill = marker.fill;
        markerLabel.markerStroke = marker.stroke;
        markerLabel.markerStrokeWidth = (_a = itemMarker.strokeWidth) != null ? _a : Math.min(2, marker.strokeWidth);
        markerLabel.markerFillOpacity = marker.fillOpacity;
        markerLabel.markerStrokeOpacity = marker.strokeOpacity;
        markerLabel.opacity = datum.enabled ? 1 : 0.5;
        markerLabel.color = color;
        var line = datum.line;
        if (showSeriesStroke && line !== void 0) {
          markerLabel.lineStroke = line.stroke;
          markerLabel.lineStrokeOpacity = line.strokeOpacity;
          markerLabel.lineStrokeWidth = (_b = itemLine.strokeWidth) != null ? _b : Math.min(2, line.strokeWidth);
          markerLabel.lineLineDash = line.lineDash;
        }
      });
    }
  }, {
    key: "getDatumForPoint",
    value: function getDatumForPoint(x, y) {
      var visibleChildBBoxes = [];
      var closestLeftTop = {
        dist: Infinity,
        datum: void 0
      };
      var _iterator198 = _createForOfIteratorHelper(this.group.children),
        _step198;
      try {
        for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
          var child = _step198.value;
          if (!child.visible) continue;
          if (!(child instanceof MarkerLabel)) continue;
          var childBBox = child.computeBBox();
          childBBox.grow(this.item.paddingX / 2, "horizontal");
          childBBox.grow(this.item.paddingY / 2, "vertical");
          if (childBBox.containsPoint(x, y)) {
            return child.datum;
          }
          var distX = x - childBBox.x - this.item.paddingX / 2;
          var distY = y - childBBox.y - this.item.paddingY / 2;
          var dist = __pow(distX, 2) + __pow(distY, 2);
          var toTheLeftTop = distX >= 0 && distY >= 0;
          if (toTheLeftTop && dist < closestLeftTop.dist) {
            closestLeftTop.dist = dist;
            closestLeftTop.datum = child.datum;
          }
          visibleChildBBoxes.push(childBBox);
        }
      } catch (err) {
        _iterator198.e(err);
      } finally {
        _iterator198.f();
      }
      var pageBBox = _BBox2.merge(visibleChildBBoxes);
      if (!pageBBox.containsPoint(x, y)) {
        return;
      }
      return closestLeftTop.datum;
    }
  }, {
    key: "computePagedBBox",
    value: function computePagedBBox() {
      var actualBBox = this.group.computeBBox();
      if (this.pages.length <= 1) {
        return actualBBox;
      }
      var _this$maxPageSize = _slicedToArray(this.maxPageSize, 2),
        maxPageWidth = _this$maxPageSize[0],
        maxPageHeight = _this$maxPageSize[1];
      actualBBox.height = Math.max(maxPageHeight, actualBBox.height);
      actualBBox.width = Math.max(maxPageWidth, actualBBox.width);
      return actualBBox;
    }
  }, {
    key: "checkLegendClick",
    value: function checkLegendClick(event) {
      var datum = this.getDatumForPoint(event.offsetX, event.offsetY);
      if (this.doClick(datum)) {
        event.consume();
      }
    }
  }, {
    key: "doClick",
    value: function doClick(datum) {
      var legendItemClick = this.listeners.legendItemClick,
        _this$ctx2 = this.ctx,
        chartService = _this$ctx2.chartService,
        highlightManager = _this$ctx2.highlightManager,
        toggleSeriesVisible = this.item.toggleSeriesVisible,
        preventHidingAll = this.preventHidingAll;
      if (!datum) {
        return false;
      }
      var id = datum.id,
        itemId = datum.itemId,
        enabled = datum.enabled;
      var series = chartService.series.find(function (s) {
        return s.id === id;
      });
      if (!series) {
        return false;
      }
      var newEnabled = enabled;
      if (toggleSeriesVisible) {
        newEnabled = !enabled;
        if (preventHidingAll && !newEnabled) {
          var numVisibleItems = chartService.series.flatMap(function (s) {
            return s.getLegendData("category");
          }).filter(function (d) {
            return d.enabled;
          }).length;
          if (numVisibleItems < 2) {
            newEnabled = true;
          }
        }
        var status = newEnabled ? "visible" : "hidden";
        this.ctx.ariaAnnouncementService.announceValue("".concat(status));
        this.ctx.chartEventManager.legendItemClick(series, itemId, newEnabled, datum.legendItemName);
      }
      if (newEnabled) {
        highlightManager.updateHighlight(this.id, {
          series: series,
          itemId: itemId,
          datum: void 0
        });
      } else {
        highlightManager.updateHighlight(this.id);
      }
      this.ctx.updateService.update(2 /* PROCESS_DATA */, {
        forceNodeDataRefresh: true
      });
      legendItemClick == null ? void 0 : legendItemClick({
        type: "click",
        enabled: newEnabled,
        itemId: itemId,
        seriesId: series.id
      });
      return true;
    }
  }, {
    key: "checkLegendDoubleClick",
    value: function checkLegendDoubleClick(event) {
      var _a;
      var legendItemDoubleClick = this.listeners.legendItemDoubleClick,
        chartService = this.ctx.chartService,
        toggleSeriesVisible = this.item.toggleSeriesVisible;
      if (chartService.mode === "integrated") {
        return;
      }
      var datum = this.getDatumForPoint(event.offsetX, event.offsetY);
      if (!datum) {
        return;
      }
      var id = datum.id,
        itemId = datum.itemId,
        seriesId = datum.seriesId;
      var series = chartService.series.find(function (s) {
        return s.id === id;
      });
      if (!series) {
        return;
      }
      event.consume();
      if (toggleSeriesVisible) {
        var legendData = chartService.series.flatMap(function (s) {
          return s.getLegendData("category");
        });
        var numVisibleItems = legendData.filter(function (d) {
          return d.enabled;
        }).length;
        var clickedItem = legendData.find(function (d) {
          return d.itemId === itemId && d.seriesId === seriesId;
        });
        this.ctx.chartEventManager.legendItemDoubleClick(series, itemId, (_a = clickedItem == null ? void 0 : clickedItem.enabled) != null ? _a : false, numVisibleItems, clickedItem == null ? void 0 : clickedItem.legendItemName);
      }
      this.ctx.updateService.update(2 /* PROCESS_DATA */, {
        forceNodeDataRefresh: true
      });
      legendItemDoubleClick == null ? void 0 : legendItemDoubleClick({
        type: "dblclick",
        enabled: true,
        itemId: itemId,
        seriesId: series.id
      });
    }
  }, {
    key: "handleLegendMouseMove",
    value: function handleLegendMouseMove(event) {
      if (!this.enabled) {
        return;
      }
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      event.consume();
      var datum = this.getDatumForPoint(offsetX, offsetY);
      this.doHover(event, datum);
    }
  }, {
    key: "doHover",
    value: function doHover(event, datum) {
      var _a;
      var toggleSeriesVisible = this.item.toggleSeriesVisible,
        listeners = this.listeners;
      if (event === void 0 || datum === void 0) {
        this.ctx.cursorManager.updateCursor(this.id);
        this.ctx.highlightManager.updateHighlight(this.id);
        return;
      }
      var series = datum ? this.ctx.chartService.series.find(function (s) {
        return s.id === (datum == null ? void 0 : datum.id);
      }) : void 0;
      if (datum && this.truncatedItems.has((_a = datum.itemId) != null ? _a : datum.id)) {
        var offsetX = event.offsetX,
          offsetY = event.offsetY;
        this.ctx.tooltipManager.updateTooltip(this.id, {
          offsetX: offsetX,
          offsetY: offsetY,
          lastPointerEvent: event,
          showArrow: false
        }, _toTooltipHtml({
          content: this.getItemLabel(datum)
        }));
      } else {
        this.ctx.tooltipManager.removeTooltip(this.id);
      }
      if (toggleSeriesVisible || listeners.legendItemClick != null || listeners.legendItemDoubleClick != null) {
        this.ctx.cursorManager.updateCursor(this.id, "pointer");
      }
      if ((datum == null ? void 0 : datum.enabled) && series) {
        this.ctx.highlightManager.updateHighlight(this.id, {
          series: series,
          itemId: datum == null ? void 0 : datum.itemId,
          datum: void 0
        });
      } else {
        this.ctx.highlightManager.updateHighlight(this.id);
      }
    }
  }, {
    key: "handleLegendMouseExit",
    value: function handleLegendMouseExit(_event) {
      this.doMouseExit();
    }
  }, {
    key: "doMouseExit",
    value: function doMouseExit() {
      this.ctx.cursorManager.updateCursor(this.id);
      this.ctx.tooltipManager.removeTooltip(this.id);
      if (this.ctx.interactionManager.getState() === 16 /* Default */) {
        this.ctx.highlightManager.updateHighlight(this.id);
      }
    }
  }, {
    key: "handleLegendMouseEnter",
    value: function handleLegendMouseEnter(event) {
      var enabled = this.enabled,
        toggle = this.item.toggleSeriesVisible,
        _this$listeners = this.listeners,
        clickListener = _this$listeners.legendItemClick,
        dblclickListener = _this$listeners.legendItemDoubleClick;
      var datum = this.getDatumForPoint(event.offsetX, event.offsetY);
      if (enabled && datum !== void 0 && (toggle || clickListener != null || dblclickListener != null)) {
        this.ctx.cursorManager.updateCursor(this.id, "pointer");
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(_event) {
      this.doMouseExit();
      this.focus.mode = "item";
      this.ctx.regionManager.updateFocusIndicatorRect(void 0);
    }
  }, {
    key: "onTab",
    value: function onTab(event) {
      this.updateFocus();
      event.consume();
    }
  }, {
    key: "onTabStart",
    value: function onTabStart(event) {
      var _this162 = this;
      if (!this.pagination.visible || !this.pagination.enabled) return;
      var consumeTabStart = function consumeTabStart(newMode) {
        _this162.focus.mode = newMode;
        _this162.updateFocus();
        event.consume();
      };
      if (this.focus.mode === "item" && event.delta === 1) {
        this.focus.index = this.pagination.currentPage === 0 ? 1 : 0;
        consumeTabStart("page");
      } else if (this.focus.mode === "page" && event.delta === -1) {
        this.focus.index = 0;
        consumeTabStart("item");
      }
    }
  }, {
    key: "onNav",
    value: function onNav(event) {
      if (this.focus.mode === "item") {
        var newIndex = this.focus.index + event.delta;
        var pageItemCount = this.getPageItemCount(this.pagination.currentPage);
        this.focus.index = _clamp(-1, newIndex, pageItemCount);
        this.updateFocus();
        event.consume();
      } else if (this.focus.mode === "page") {
        if (event.delta < 0) this.focus.index = 0;
        if (event.delta > 0) this.focus.index = 1;
        this.updateFocus();
        event.consume();
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(_event) {
      if (this.focus.mode === "item") {
        this.doClick(this.getFocusedItem().datum);
      } else if (this.focus.mode === "page") {
        if (this.focus.index === 0) this.pagination.clickPrevious();
        if (this.focus.index === 1) this.pagination.clickNext();
        this.ctx.ariaAnnouncementService.announceValue("Legend page ".concat(this.pagination.currentPage + 1, " of ").concat(this.pages.length));
      }
    }
  }, {
    key: "maybeChangeFocusPage",
    value: function maybeChangeFocusPage() {
      var oldPage = this.pagination.currentPage;
      var oldPageItemCount = this.getPageItemCount(oldPage);
      if (this.focus.index === -1) {
        this.pagination.setPage(oldPage - 1);
      } else if (this.focus.index === oldPageItemCount) {
        this.pagination.setPage(oldPage + 1);
      } else {
        return;
      }
      var currentPage = this.pagination.currentPage;
      if (oldPage === currentPage) {
        this.focus.index = _clamp(0, this.focus.index, oldPageItemCount - 1);
      } else if (this.focus.index === -1) {
        this.focus.index = this.getPageItemCount(currentPage) - 1;
      } else {
        this.focus.index = 0;
      }
    }
  }, {
    key: "getFocusedItem",
    value: function getFocusedItem() {
      if (this.focus.mode !== "item") {
        _Logger.error("getFocusedItem() should be called only when focus.mode is 'item'");
        return {
          nodeIndex: -1,
          node: void 0,
          datum: void 0
        };
      }
      this.maybeChangeFocusPage();
      var nodeIndex = this.getNodeIndexFromFocusIndex();
      if (nodeIndex < 0) {
        _Logger.error("Cannot access negative nodeIndex ".concat(nodeIndex));
        return {
          nodeIndex: -1,
          node: void 0,
          datum: void 0
        };
      }
      var node = this.itemSelection.nodes()[nodeIndex];
      var data = this.data;
      var datum;
      if (nodeIndex < data.length) {
        datum = this.data[nodeIndex];
      } else {
        _Logger.error("Cannot access datum[".concat(nodeIndex, "]"));
      }
      return {
        nodeIndex: nodeIndex,
        node: node,
        datum: datum
      };
    }
  }, {
    key: "updateFocus",
    value: function updateFocus() {
      var focus = this.focus,
        pagination = this.pagination;
      if (focus.mode === "item") {
        var _this$getFocusedItem = this.getFocusedItem(),
          nodeIndex = _this$getFocusedItem.nodeIndex,
          node = _this$getFocusedItem.node,
          datum = _this$getFocusedItem.datum;
        if (datum === void 0) return;
        var bbox = node == null ? void 0 : node.computeTransformedBBox();
        this.doHover(makeKeyboardPointerEvent(this.ctx.regionManager, {
          bbox: bbox,
          showFocusBox: true
        }), datum);
        var label = datum && this.getItemLabel(datum);
        if (label) {
          var visibility = datum.enabled ? "visible" : "hidden";
          this.ctx.ariaAnnouncementService.announceValue("Legend item ".concat(nodeIndex + 1, " of ").concat(this.data.length, ", ").concat(label, ", ").concat(visibility));
        }
      } else if (focus.mode === "page") {
        var button = focus.index === 0 ? pagination.previousButton : pagination.nextButton;
        this.ctx.regionManager.updateFocusIndicatorRect(button.computeTransformedBBox());
        var value = ["Previous legend page", "Next legend page"][focus.index];
        this.ctx.ariaAnnouncementService.announceValue("".concat(value, ", button"));
      }
    }
  }, {
    key: "positionLegend",
    value: function positionLegend(shrinkRect) {
      var _this163 = this;
      var newShrinkRect = shrinkRect.clone();
      if (!this.enabled || !this.data.length) {
        return {
          shrinkRect: newShrinkRect
        };
      }
      var _this$calculateLegend = this.calculateLegendDimensions(shrinkRect),
        _this$calculateLegend2 = _slicedToArray(_this$calculateLegend, 2),
        legendWidth = _this$calculateLegend2[0],
        legendHeight = _this$calculateLegend2[1];
      this.group.translationX = 0;
      this.group.translationY = 0;
      this.calcLayout(legendWidth, legendHeight);
      var legendBBox = this.computePagedBBox();
      var calculateTranslationPerpendicularDimension = function calculateTranslationPerpendicularDimension() {
        switch (_this163.position) {
          case "top":
          case "left":
            return 0;
          case "bottom":
            return shrinkRect.height - legendBBox.height;
          case "right":
          default:
            return shrinkRect.width - legendBBox.width;
        }
      };
      if (this.visible) {
        var translationX;
        var translationY;
        switch (this.position) {
          case "top":
          case "bottom":
            translationX = (shrinkRect.width - legendBBox.width) / 2;
            translationY = calculateTranslationPerpendicularDimension();
            newShrinkRect.shrink(legendBBox.height, this.position);
            break;
          case "left":
          case "right":
          default:
            translationX = calculateTranslationPerpendicularDimension();
            translationY = (shrinkRect.height - legendBBox.height) / 2;
            newShrinkRect.shrink(legendBBox.width, this.position);
        }
        this.group.translationX = Math.floor(-legendBBox.x + shrinkRect.x + translationX);
        this.group.translationY = Math.floor(-legendBBox.y + shrinkRect.y + translationY);
      }
      if (this.visible && this.enabled && this.data.length) {
        var legendPadding = this.spacing;
        newShrinkRect.shrink(legendPadding, this.position);
        var legendPositionedBBox = legendBBox.clone();
        legendPositionedBBox.x += this.group.translationX;
        legendPositionedBBox.y += this.group.translationY;
      }
      return {
        shrinkRect: newShrinkRect
      };
    }
  }, {
    key: "calculateLegendDimensions",
    value: function calculateLegendDimensions(shrinkRect) {
      var width = shrinkRect.width,
        height = shrinkRect.height;
      var aspectRatio = width / height;
      var maxCoefficient = 0.5;
      var minHeightCoefficient = 0.2;
      var minWidthCoefficient = 0.25;
      var legendWidth, legendHeight;
      switch (this.position) {
        case "top":
        case "bottom":
          var heightCoefficient = aspectRatio < 1 ? Math.min(maxCoefficient, minHeightCoefficient * (1 / aspectRatio)) : minHeightCoefficient;
          legendWidth = this.maxWidth ? Math.min(this.maxWidth, width) : width;
          legendHeight = this.maxHeight ? Math.min(this.maxHeight, height) : Math.round(height * heightCoefficient);
          break;
        case "left":
        case "right":
        default:
          var widthCoefficient = aspectRatio > 1 ? Math.min(maxCoefficient, minWidthCoefficient * aspectRatio) : minWidthCoefficient;
          legendWidth = this.maxWidth ? Math.min(this.maxWidth, width) : Math.round(width * widthCoefficient);
          legendHeight = this.maxHeight ? Math.min(this.maxHeight, height) : height;
      }
      return [legendWidth, legendHeight];
    }
  }, {
    key: "data",
    set: function set(value) {
      this._data = value;
      this.updateGroupVisibility();
    },
    get: function get() {
      return this._data;
    }
  }, {
    key: "visible",
    set: function set(value) {
      this._visible = value;
      this.updateGroupVisibility();
    },
    get: function get() {
      return this._visible;
    }
  }]);
  return Legend;
}(_BaseProperties35);
Legend.className = "Legend";
__decorateClass([_Validate(_OBJECT)], Legend.prototype, "pagination", 2);
__decorateClass([_Validate(_OBJECT)], Legend.prototype, "item", 2);
__decorateClass([_Validate(_OBJECT)], Legend.prototype, "listeners", 2);
__decorateClass([_ObserveChanges(function (target) {
  return target.updateGroupVisibility();
}), _Validate(_BOOLEAN)], Legend.prototype, "enabled", 2);
__decorateClass([_Validate(POSITION2)], Legend.prototype, "position", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], Legend.prototype, "maxWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], Legend.prototype, "maxHeight", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], Legend.prototype, "reverseOrder", 2);
__decorateClass([_Validate(_UNION(["horizontal", "vertical"], "an orientation"), {
  optional: true
})], Legend.prototype, "orientation", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], Legend.prototype, "preventHidingAll", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], Legend.prototype, "spacing", 2);

// packages/ag-charts-community/src/chart/legendModule.ts
var CommunityLegendModule = {
  type: "legend",
  optionsKey: "legend",
  identifier: "category",
  chartTypes: ["cartesian", "polar", "hierarchy", "topology"],
  instanceConstructor: Legend,
  packageType: "community"
};

// packages/ag-charts-community/src/chart/navigator/shapes/rangeHandle.ts
var RangeHandle = /*#__PURE__*/function (_Path3) {
  _inherits(RangeHandle, _Path3);
  function RangeHandle() {
    var _this164;
    _classCallCheck(this, RangeHandle);
    _this164 = _possibleConstructorReturn(this, _getPrototypeOf(RangeHandle).apply(this, arguments));
    _this164.zIndex = 3;
    _this164._fill = "#f2f2f2";
    _this164._stroke = "#999999";
    _this164._strokeWidth = 1;
    _this164._lineCap = "square";
    _this164._centerX = 0;
    _this164._centerY = 0;
    _this164._width = 8;
    _this164._gripLineGap = 2;
    _this164._gripLineLength = 8;
    _this164._height = 16;
    return _this164;
  }
  _createClass(RangeHandle, [{
    key: "layout",
    value: function layout(x, y) {
      this.centerX = x;
      this.centerY = y;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      var centerX = this.centerX,
        centerY = this.centerY,
        width = this.width,
        height = this.height;
      var x = centerX - width / 2;
      var y = centerY - height / 2;
      return new _BBox2(x, y, width, height);
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var point = this.transformPoint(x, y);
      var bbox = this.computeBBox();
      return bbox.containsPoint(point.x, point.y);
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var _a, _b, _c;
      var centerX = this.centerX,
        centerY = this.centerY,
        path = this.path,
        strokeWidth = this.strokeWidth,
        gripLineGap = this.gripLineGap,
        gripLineLength = this.gripLineLength;
      var pixelRatio = (_c = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas) == null ? void 0 : _b.pixelRatio) != null ? _c : 1;
      path.clear();
      var halfWidth = Math.floor(this.width / 2 * pixelRatio) / pixelRatio;
      var halfHeight = Math.floor(this.height / 2 * pixelRatio) / pixelRatio;
      path.moveTo(centerX - halfWidth, centerY - halfHeight);
      path.lineTo(centerX + halfWidth, centerY - halfHeight);
      path.lineTo(centerX + halfWidth, centerY + halfHeight);
      path.lineTo(centerX - halfWidth, centerY + halfHeight);
      path.closePath();
      var dx = Math.floor((gripLineGap + strokeWidth) / 2 * pixelRatio) / pixelRatio;
      var dy = Math.floor(gripLineLength / 2 * pixelRatio) / pixelRatio;
      path.moveTo(centerX - dx, centerY - dy);
      path.lineTo(centerX - dx, centerY + dy);
      path.moveTo(centerX + dx, centerY - dy);
      path.lineTo(centerX + dx, centerY + dy);
    }
  }, {
    key: "centerX",
    set: function set(value) {
      if (this._centerX !== value) {
        this._centerX = value;
        this.dirtyPath = true;
      }
    },
    get: function get() {
      return this._centerX;
    }
  }, {
    key: "centerY",
    set: function set(value) {
      if (this._centerY !== value) {
        this._centerY = value;
        this.dirtyPath = true;
      }
    },
    get: function get() {
      return this._centerY;
    }
  }, {
    key: "width",
    set: function set(value) {
      if (this._width !== value) {
        this._width = value;
        this.dirtyPath = true;
      }
    },
    get: function get() {
      return this._width;
    }
  }, {
    key: "gripLineGap",
    set: function set(value) {
      if (this._gripLineGap !== value) {
        this._gripLineGap = value;
        this.dirtyPath = true;
      }
    },
    get: function get() {
      return this._gripLineGap;
    }
  }, {
    key: "gripLineLength",
    set: function set(value) {
      if (this._gripLineLength !== value) {
        this._gripLineLength = value;
        this.dirtyPath = true;
      }
    },
    get: function get() {
      return this._gripLineLength;
    }
  }, {
    key: "height",
    set: function set(value) {
      if (this._height !== value) {
        this._height = value;
        this.dirtyPath = true;
      }
    },
    get: function get() {
      return this._height;
    }
  }], [{
    key: "align",
    value: function align(minHandle, maxHandle, x, y, width, height, min, max) {
      var handlePixelAlign = minHandle.strokeWidth / 2;
      var minHandleX = minHandle.align(x + width * min) + handlePixelAlign;
      var maxHandleX = minHandleX + minHandle.align(x + width * min, width * (max - min)) - 2 * handlePixelAlign;
      var handleY = minHandle.align(y + height / 2) + handlePixelAlign;
      minHandle.layout(minHandleX, handleY);
      maxHandle.layout(maxHandleX, handleY);
    }
  }]);
  return RangeHandle;
}(_Path6);
RangeHandle.className = "RangeHandle";
__decorateClass([_Validate(_COLOR_STRING)], RangeHandle.prototype, "_fill", 2);
__decorateClass([_Validate(_COLOR_STRING)], RangeHandle.prototype, "_stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], RangeHandle.prototype, "_strokeWidth", 2);
__decorateClass([_Validate(_LINE_CAP)], RangeHandle.prototype, "_lineCap", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], RangeHandle.prototype, "_width", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], RangeHandle.prototype, "_gripLineGap", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], RangeHandle.prototype, "_gripLineLength", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], RangeHandle.prototype, "_height", 2);

// packages/ag-charts-community/src/chart/navigator/shapes/rangeMask.ts
var RangeMask = /*#__PURE__*/function (_Path4) {
  _inherits(RangeMask, _Path4);
  function RangeMask() {
    var _this165;
    _classCallCheck(this, RangeMask);
    _this165 = _possibleConstructorReturn(this, _getPrototypeOf(RangeMask).apply(this, arguments));
    _this165.zIndex = 2;
    _this165.x = 0;
    _this165.y = 0;
    _this165.width = 200;
    _this165.height = 30;
    _this165.min = 0;
    _this165.max = 1;
    return _this165;
  }
  _createClass(RangeMask, [{
    key: "layout",
    value: function layout(x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
      this.dirtyPath = true;
    }
  }, {
    key: "update",
    value: function update(min, max) {
      this.min = isNaN(min) ? this.min : min;
      this.max = isNaN(max) ? this.max : max;
      this.dirtyPath = true;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height;
      return new _BBox2(x, y, width, height);
    }
  }, {
    key: "computeVisibleRangeBBox",
    value: function computeVisibleRangeBBox() {
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height,
        min = this.min,
        max = this.max;
      var minX = x + width * min;
      var maxX = x + width * max;
      return new _BBox2(minX, y, maxX - minX, height);
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var path = this.path,
        x = this.x,
        y = this.y,
        width = this.width,
        height = this.height,
        min = this.min,
        max = this.max,
        strokeWidth = this.strokeWidth;
      var pixelAlign = strokeWidth / 2;
      path.clear();
      var ax = this.align(x) + pixelAlign;
      var ay = this.align(y) + pixelAlign;
      var axw = ax + this.align(x, width) - 2 * pixelAlign;
      var ayh = ay + this.align(y, height) - 2 * pixelAlign;
      path.moveTo(ax, ay);
      path.lineTo(axw, ay);
      path.lineTo(axw, ayh);
      path.lineTo(ax, ayh);
      path.closePath();
      var minX = this.align(x + width * min) + pixelAlign;
      var maxX = minX + this.align(x + width * min, width * (max - min)) - 2 * pixelAlign;
      path.moveTo(minX, ay);
      path.lineTo(minX, ayh);
      path.lineTo(maxX, ayh);
      path.lineTo(maxX, ay);
      path.closePath();
    }
  }]);
  return RangeMask;
}(_Path6);
RangeMask.className = "RangeMask";

// packages/ag-charts-community/src/chart/navigator/shapes/rangeSelector.ts
var RangeSelector = /*#__PURE__*/function (_Group3) {
  _inherits(RangeSelector, _Group3);
  function RangeSelector(children) {
    var _this166;
    _classCallCheck(this, RangeSelector);
    _this166 = _possibleConstructorReturn(this, _getPrototypeOf(RangeSelector).call(this, {
      name: "rangeSelectorGroup",
      layer: true,
      zIndex: 12 /* NAVIGATOR_ZINDEX */
    }));
    _this166.x = 0;
    _this166.y = 0;
    _this166.width = 200;
    _this166.height = 30;
    _this166.lOffset = 0;
    _this166.rOffset = 0;
    _this166.isContainerNode = true;
    _this166.background = new _Group4({
      name: "navigator-background"
    });
    _this166.background.zIndex = 1;
    _this166.appendChild(_this166.background);
    _this166.append(children);
    return _this166;
  }
  _createClass(RangeSelector, [{
    key: "layout",
    value: function layout(x, y, width, height, lOffset, rOffset) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
      this.lOffset = lOffset;
      this.rOffset = rOffset;
      this.background.translationX = x;
      this.background.translationY = y;
    }
  }, {
    key: "updateBackground",
    value: function updateBackground(oldGroup, newGroup) {
      if (oldGroup != null) {
        this.background.removeChild(oldGroup);
      }
      if (newGroup != null) {
        this.background.appendChild(newGroup);
      }
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height,
        lOffset = this.lOffset,
        rOffset = this.rOffset;
      return new _BBox2(x - lOffset, y, width + (lOffset + rOffset), height);
    }
  }]);
  return RangeSelector;
}(_Group4);

// packages/ag-charts-community/src/chart/navigator/navigator.ts
var _Navigator = /*#__PURE__*/function (_BaseModuleInstance2) {
  _inherits(Navigator, _BaseModuleInstance2);
  function Navigator(ctx) {
    var _this167;
    _classCallCheck(this, Navigator);
    _this167 = _possibleConstructorReturn(this, _getPrototypeOf(Navigator).call(this));
    _this167.ctx = ctx;
    _this167.miniChart = void 0;
    _this167.enabled = false;
    _this167.mask = new RangeMask();
    _this167.minHandle = new RangeHandle();
    _this167.maxHandle = new RangeHandle();
    _this167.height = 30;
    _this167.margin = 10;
    _this167.x = 0;
    _this167.y = 0;
    _this167.width = 0;
    _this167.rangeSelector = new RangeSelector([_this167.mask, _this167.minHandle, _this167.maxHandle]);
    _this167._min = 0;
    _this167._max = 1;
    _this167.minRange = 1e-3;
    var region = ctx.regionManager.addRegion("navigator", _this167.rangeSelector);
    var dragStates = 16 /* Default */ | 1 /* Animation */ | 8 /* ZoomDrag */;
    _this167.destroyFns.push(ctx.scene.attachNode(_this167.rangeSelector), region.addListener("hover", function (event) {
      return _this167.onHover(event);
    }, dragStates), region.addListener("drag-start", function (event) {
      return _this167.onDragStart(event);
    }, dragStates), region.addListener("drag", function (event) {
      return _this167.onDrag(event);
    }, dragStates), region.addListener("drag-end", function () {
      return _this167.onDragEnd();
    }, dragStates), region.addListener("leave", function (event) {
      return _this167.onLeave(event);
    }, dragStates), ctx.zoomManager.addListener("zoom-change", function (event) {
      return _this167.onZoomChange(event);
    }));
    _this167.updateGroupVisibility();
    return _this167;
  }
  _createClass(Navigator, [{
    key: "updateBackground",
    value: function updateBackground(oldGroup, newGroup) {
      var _a;
      (_a = this.rangeSelector) == null ? void 0 : _a.updateBackground(oldGroup, newGroup);
    }
  }, {
    key: "updateGroupVisibility",
    value: function updateGroupVisibility() {
      var enabled = this.enabled;
      if (this.rangeSelector == null || enabled === this.rangeSelector.visible) return;
      this.rangeSelector.visible = enabled;
      if (enabled) {
        this.updateZoom();
      } else {
        this.ctx.zoomManager.updateZoom("navigator");
      }
    }
  }, {
    key: "performLayout",
    value: function performLayout(_0) {
      return __async(this, arguments, function (_ref135) {
        var _this168 = this;
        var shrinkRect = _ref135.shrinkRect;
        return /*#__PURE__*/_regenerator().m(function _callee34() {
          var navigatorTotalHeight;
          return _regenerator().w(function (_context44) {
            while (1) switch (_context44.n) {
              case 0:
                if (_this168.enabled) {
                  navigatorTotalHeight = _this168.height + _this168.margin;
                  shrinkRect.shrink(navigatorTotalHeight, "bottom");
                  _this168.y = shrinkRect.y + shrinkRect.height + _this168.margin;
                } else {
                  _this168.y = 0;
                }
                return _context44.a(2, {
                  shrinkRect: shrinkRect
                });
            }
          }, _callee34);
        })();
      });
    }
  }, {
    key: "performCartesianLayout",
    value: function performCartesianLayout(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee35() {
        var _opts$seriesRect, x, width, y, height;
        return _regenerator().w(function (_context45) {
          while (1) switch (_context45.n) {
            case 0:
              _opts$seriesRect = opts.seriesRect, x = _opts$seriesRect.x, width = _opts$seriesRect.width;
              if (this.enabled) {
                y = this.y, height = this.height;
                this.layoutNodes(x, y, width, height);
              }
              this.x = x;
              this.width = width;
            case 1:
              return _context45.a(2);
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "onHover",
    value: function onHover(event) {
      if (!this.enabled) return;
      var mask = this.mask,
        minHandle = this.minHandle,
        maxHandle = this.maxHandle;
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      if (minHandle.containsPoint(offsetX, offsetY) || maxHandle.containsPoint(offsetX, offsetY)) {
        this.ctx.cursorManager.updateCursor("navigator", "ew-resize");
      } else if (mask.computeVisibleRangeBBox().containsPoint(offsetX, offsetY)) {
        this.ctx.cursorManager.updateCursor("navigator", "grab");
      } else {
        this.ctx.cursorManager.updateCursor("navigator");
      }
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(event) {
      if (!this.enabled) return;
      var mask = this.mask,
        minHandle = this.minHandle,
        maxHandle = this.maxHandle,
        x = this.x,
        width = this.width,
        min = this._min;
      var offsetX = event.offsetX,
        offsetY = event.offsetY;
      if (minHandle.zIndex < maxHandle.zIndex) {
        if (maxHandle.containsPoint(offsetX, offsetY)) {
          this.dragging = "max";
        } else if (minHandle.containsPoint(offsetX, offsetY)) {
          this.dragging = "min";
        }
      } else if (minHandle.containsPoint(offsetX, offsetY)) {
        this.dragging = "min";
      } else if (maxHandle.containsPoint(offsetX, offsetY)) {
        this.dragging = "max";
      }
      if (this.dragging == null && mask.computeVisibleRangeBBox().containsPoint(offsetX, offsetY)) {
        this.dragging = "pan";
        this.panStart = (offsetX - x) / width - min;
      }
      if (this.dragging != null) {
        this.ctx.zoomManager.fireZoomPanStartEvent("navigator");
      }
    }
  }, {
    key: "onDrag",
    value: function onDrag(event) {
      if (!this.enabled || this.dragging == null) return;
      var dragging = this.dragging,
        minRange = this.minRange,
        panStart = this.panStart,
        x = this.x,
        width = this.width;
      var min = this._min,
        max = this._max;
      var offsetX = event.offsetX;
      var ratio = (offsetX - x) / width;
      if (dragging === "min") {
        min = _clamp(0, ratio, max - minRange);
      } else if (dragging === "max") {
        max = _clamp(min + minRange, ratio, 1);
      } else if (dragging === "pan" && panStart != null) {
        var span = max - min;
        min = _clamp(0, ratio - panStart, 1 - span);
        max = min + span;
      }
      this._min = min;
      this._max = max;
      this.updateZoom();
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd() {
      this.dragging = void 0;
    }
  }, {
    key: "onLeave",
    value: function onLeave(_event) {
      this.ctx.cursorManager.updateCursor("navigator");
    }
  }, {
    key: "onZoomChange",
    value: function onZoomChange(event) {
      var x = event.x;
      if (!x) return;
      this._min = x.min;
      this._max = x.max;
      this.updateNodes(x.min, x.max);
    }
  }, {
    key: "layoutNodes",
    value: function layoutNodes(x, y, width, height) {
      var rangeSelector = this.rangeSelector,
        mask = this.mask,
        minHandle = this.minHandle,
        maxHandle = this.maxHandle,
        min = this._min,
        max = this._max;
      rangeSelector.layout(x, y, width, height, minHandle.width / 2, maxHandle.width / 2);
      mask.layout(x, y, width, height);
      RangeHandle.align(minHandle, maxHandle, x, y, width, height, min, max);
      if (min + (max - min) / 2 < 0.5) {
        minHandle.zIndex = 3;
        maxHandle.zIndex = 4;
      } else {
        minHandle.zIndex = 4;
        maxHandle.zIndex = 3;
      }
    }
  }, {
    key: "updateNodes",
    value: function updateNodes(min, max) {
      this.mask.update(min, max);
    }
  }, {
    key: "updateZoom",
    value: function updateZoom() {
      var _this169 = this;
      if (!this.enabled) return;
      var min = this._min,
        max = this._max;
      var zoom2 = this.ctx.zoomManager.getZoom();
      if (min == null || max == null) return;
      var warnOnConflict = function warnOnConflict(stateId) {
        if (_this169.min == null && _this169.max == null) return;
        _Logger.warnOnce("Could not apply [navigator.min] or [navigator.max] as [".concat(stateId, "] has modified the initial zoom state."));
      };
      return this.ctx.zoomManager.updateZoom("navigator", {
        x: {
          min: min,
          max: max
        },
        y: zoom2 == null ? void 0 : zoom2.y
      }, false, warnOnConflict);
    }
  }]);
  return Navigator;
}(_BaseModuleInstance4);
__decorateClass([_Validate(_OBJECT, {
  optional: true
})], _Navigator.prototype, "miniChart", 2);
__decorateClass([_Validate(_BOOLEAN), _ObserveChanges(function (target) {
  return target.updateGroupVisibility();
})], _Navigator.prototype, "enabled", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Navigator.prototype, "height", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], _Navigator.prototype, "margin", 2);
__decorateClass([_ActionOnSet({
  newValue: function newValue(min) {
    this._min = min;
    this.updateZoom();
  }
}), _Validate(_AND(_RATIO, _LESS_THAN("max")), {
  optional: true
})], _Navigator.prototype, "min", 2);
__decorateClass([_ActionOnSet({
  newValue: function newValue(max) {
    this._max = max;
    this.updateZoom();
  }
}), _Validate(_AND(_RATIO, _GREATER_THAN("min")), {
  optional: true
})], _Navigator.prototype, "max", 2);

// packages/ag-charts-community/src/chart/navigator/navigatorModule.ts
var _NavigatorModule = {
  type: "root",
  optionsKey: "navigator",
  packageType: "community",
  chartTypes: ["cartesian"],
  instanceConstructor: _Navigator,
  themeTemplate: {
    navigator: {
      enabled: false,
      height: 30,
      mask: {
        fill: "#999999",
        stroke: "#999999",
        strokeWidth: 1,
        fillOpacity: 0.2
      },
      minHandle: {
        fill: "#f2f2f2",
        stroke: "#999999",
        strokeWidth: 1,
        width: 9,
        height: 16,
        gripLineGap: 1,
        gripLineLength: 8
      },
      maxHandle: {
        fill: "#f2f2f2",
        stroke: "#999999",
        strokeWidth: 1,
        width: 9,
        height: 16,
        gripLineGap: 1,
        gripLineLength: 8
      }
    }
  }
};

// packages/ag-charts-community/src/module/theme.ts
var _singleSeriesPaletteFactory = function singleSeriesPaletteFactory(_ref136) {
  var takeColors = _ref136.takeColors;
  var _takeColors = takeColors(1),
    _takeColors$fills = _slicedToArray(_takeColors.fills, 1),
    fill = _takeColors$fills[0],
    _takeColors$strokes = _slicedToArray(_takeColors.strokes, 1),
    stroke = _takeColors$strokes[0];
  return {
    fill: fill,
    stroke: stroke
  };
};
var _markerPaletteFactory3 = function markerPaletteFactory(params) {
  var _singleSeriesPaletteF = _singleSeriesPaletteFactory(params),
    fill = _singleSeriesPaletteF.fill,
    stroke = _singleSeriesPaletteF.stroke;
  return {
    marker: {
      fill: fill,
      stroke: stroke
    }
  };
};

// packages/ag-charts-community/src/motion/pathMotion.ts
function pathMotion(groupId, subId, animationManager, paths, fns) {
  var addPhaseFn = fns.addPhaseFn,
    updatePhaseFn = fns.updatePhaseFn,
    removePhaseFn = fns.removePhaseFn;
  var animate = function animate(phase, path, updateFn) {
    animationManager.animate({
      id: "".concat(groupId, "_").concat(subId, "_").concat(path.id, "_").concat(phase),
      groupId: groupId,
      from: 0,
      to: 1,
      ease: _easeOut,
      collapsable: false,
      onUpdate: function onUpdate(ratio, preInit) {
        if (preInit && phase !== "removed") return;
        path.path.clear(true);
        updateFn(ratio, path);
        path.checkPathDirty();
      },
      onStop: function onStop() {
        if (phase !== "added") return;
        path.path.clear(true);
        updateFn(1, path);
        path.checkPathDirty();
      },
      phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
    });
  };
  var _iterator199 = _createForOfIteratorHelper(paths),
    _step199;
  try {
    for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
      var path = _step199.value;
      if (!animationManager.isSkipped()) {
        animate("removed", path, removePhaseFn);
        animate("updated", path, updatePhaseFn);
      }
      animate("added", path, addPhaseFn);
    }
  } catch (err) {
    _iterator199.e(err);
  } finally {
    _iterator199.f();
  }
}

// packages/ag-charts-community/src/util/sanitize.ts
var element = null;
function _sanitizeHtml(text) {
  if (text == null) {
    return;
  } else if (text === "") {
    return "";
  }
  element != null ? element : element = _createElement("div");
  element.textContent = String(text);
  return element.innerHTML;
}

// packages/ag-charts-community/src/chart/series/seriesLabelUtil.ts
function _seriesLabelFadeInAnimation(_ref137, subId, animationManager) {
  var id = _ref137.id;
  for (var _len26 = arguments.length, labelSelections = new Array(_len26 > 3 ? _len26 - 3 : 0), _key29 = 3; _key29 < _len26; _key29++) {
    labelSelections[_key29 - 3] = arguments[_key29];
  }
  _staticFromToMotion(id, subId, animationManager, labelSelections, {
    opacity: 0
  }, {
    opacity: 1
  }, {
    phase: "trailing"
  });
}
function _seriesLabelFadeOutAnimation(_ref138, subId, animationManager) {
  var id = _ref138.id;
  for (var _len27 = arguments.length, labelSelections = new Array(_len27 > 3 ? _len27 - 3 : 0), _key30 = 3; _key30 < _len27; _key30++) {
    labelSelections[_key30 - 3] = arguments[_key30];
  }
  _staticFromToMotion(id, subId, animationManager, labelSelections, {
    opacity: 1
  }, {
    opacity: 0
  }, {
    phase: "remove"
  });
}
function _resetLabelFn(_node) {
  return {
    opacity: 1
  };
}

// packages/ag-charts-community/src/scene/util/changeDetectableProperties.ts
var _ChangeDetectableProperties = /*#__PURE__*/function (_BaseProperties27) {
  _inherits(ChangeDetectableProperties, _BaseProperties27);
  function ChangeDetectableProperties() {
    var _this170;
    _classCallCheck(this, ChangeDetectableProperties);
    _this170 = _possibleConstructorReturn(this, _getPrototypeOf(ChangeDetectableProperties).apply(this, arguments));
    _this170._dirty = 3 /* MAJOR */;
    return _this170;
  }
  _createClass(ChangeDetectableProperties, [{
    key: "markDirty",
    value: function markDirty(_source) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (this._dirty < type) {
        this._dirty = type;
      }
    }
  }, {
    key: "markClean",
    value: function markClean(_opts) {
      this._dirty = 0 /* NONE */;
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      return this._dirty > 0 /* NONE */;
    }
  }]);
  return ChangeDetectableProperties;
}(_BaseProperties35);

// packages/ag-charts-community/src/scene/dropShadow.ts
var _DropShadow = /*#__PURE__*/function (_ChangeDetectableProp) {
  _inherits(DropShadow, _ChangeDetectableProp);
  function DropShadow() {
    var _this171;
    _classCallCheck(this, DropShadow);
    _this171 = _possibleConstructorReturn(this, _getPrototypeOf(DropShadow).apply(this, arguments));
    _this171.enabled = true;
    _this171.color = "rgba(0, 0, 0, 0.5)";
    _this171.xOffset = 0;
    _this171.yOffset = 0;
    _this171.blur = 5;
    return _this171;
  }
  return DropShadow;
}(_ChangeDetectableProperties);
__decorateClass([_Validate(_BOOLEAN), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _DropShadow.prototype, "enabled", 2);
__decorateClass([_Validate(_COLOR_STRING), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _DropShadow.prototype, "color", 2);
__decorateClass([_Validate(_NUMBER), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _DropShadow.prototype, "xOffset", 2);
__decorateClass([_Validate(_NUMBER), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _DropShadow.prototype, "yOffset", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _DropShadow.prototype, "blur", 2);

// packages/ag-charts-community/src/chart/series/seriesMarker.ts
var _MARKER_SHAPE = _predicateWithMessage(function (value) {
  return isMarkerShape(value) || typeof _Marker0 === "function" && Object.create(value.prototype) instanceof _Marker0;
}, "a marker shape keyword such as 'circle', 'diamond' or 'square' or an object extending the Marker class");
var _SeriesMarker2 = /*#__PURE__*/function (_ChangeDetectableProp2) {
  _inherits(SeriesMarker, _ChangeDetectableProp2);
  function SeriesMarker() {
    var _this172;
    _classCallCheck(this, SeriesMarker);
    _this172 = _possibleConstructorReturn(this, _getPrototypeOf(SeriesMarker).apply(this, arguments));
    _this172.enabled = true;
    _this172.shape = _Circle;
    _this172.size = 6;
    _this172.fillOpacity = 1;
    _this172.strokeWidth = 1;
    _this172.strokeOpacity = 1;
    return _this172;
  }
  _createClass(SeriesMarker, [{
    key: "getStyle",
    value: function getStyle() {
      var size = this.size,
        fill = this.fill,
        fillOpacity = this.fillOpacity,
        stroke = this.stroke,
        strokeWidth = this.strokeWidth,
        strokeOpacity = this.strokeOpacity;
      return {
        size: size,
        fill: fill,
        fillOpacity: fillOpacity,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeOpacity: strokeOpacity
      };
    }
  }, {
    key: "getDiameter",
    value: function getDiameter() {
      return this.size + this.strokeWidth;
    }
  }]);
  return SeriesMarker;
}(_ChangeDetectableProperties);
__decorateClass([_Validate(_BOOLEAN), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "enabled", 2);
__decorateClass([_Validate(_MARKER_SHAPE), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "shape", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "size", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
}), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
}), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
}), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _SeriesMarker2.prototype, "formatter", 2);

// packages/ag-charts-community/src/chart/series/seriesTooltip.ts
var SeriesTooltipInteraction = /*#__PURE__*/function (_BaseProperties28) {
  _inherits(SeriesTooltipInteraction, _BaseProperties28);
  function SeriesTooltipInteraction() {
    var _this173;
    _classCallCheck(this, SeriesTooltipInteraction);
    _this173 = _possibleConstructorReturn(this, _getPrototypeOf(SeriesTooltipInteraction).apply(this, arguments));
    _this173.enabled = false;
    return _this173;
  }
  return SeriesTooltipInteraction;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], SeriesTooltipInteraction.prototype, "enabled", 2);
var _SeriesTooltip = /*#__PURE__*/function (_BaseProperties29) {
  _inherits(SeriesTooltip, _BaseProperties29);
  function SeriesTooltip() {
    var _this174;
    _classCallCheck(this, SeriesTooltip);
    _this174 = _possibleConstructorReturn(this, _getPrototypeOf(SeriesTooltip).apply(this, arguments));
    _this174.enabled = true;
    _this174.interaction = new SeriesTooltipInteraction();
    _this174.position = new _TooltipPosition();
    return _this174;
  }
  _createClass(SeriesTooltip, [{
    key: "toTooltipHtml",
    value: function toTooltipHtml(defaults, params) {
      if (this.renderer) {
        return _toTooltipHtml(this.renderer(params), defaults);
      }
      return _toTooltipHtml(defaults);
    }
  }]);
  return SeriesTooltip;
}(_BaseProperties35);
__decorateClass([_Validate(_BOOLEAN)], _SeriesTooltip.prototype, "enabled", 2);
__decorateClass([_Validate(_BOOLEAN, {
  optional: true
})], _SeriesTooltip.prototype, "showArrow", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], _SeriesTooltip.prototype, "renderer", 2);
__decorateClass([_Validate(_OBJECT)], _SeriesTooltip.prototype, "interaction", 2);
__decorateClass([_Validate(_OBJECT)], _SeriesTooltip.prototype, "position", 2);

// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesProperties.ts
var AreaSeriesProperties = /*#__PURE__*/function (_CartesianSeriesPrope) {
  _inherits(AreaSeriesProperties, _CartesianSeriesPrope);
  function AreaSeriesProperties() {
    var _this175;
    _classCallCheck(this, AreaSeriesProperties);
    _this175 = _possibleConstructorReturn(this, _getPrototypeOf(AreaSeriesProperties).apply(this, arguments));
    _this175.xName = void 0;
    _this175.fill = "#c16068";
    _this175.fillOpacity = 1;
    _this175.stroke = "#874349";
    _this175.strokeWidth = 2;
    _this175.strokeOpacity = 1;
    _this175.lineDash = [0];
    _this175.lineDashOffset = 0;
    _this175.shadow = new _DropShadow();
    _this175.marker = new _SeriesMarker2();
    _this175.label = new _Label0();
    _this175.tooltip = new _SeriesTooltip();
    _this175.connectMissingData = false;
    return _this175;
  }
  return AreaSeriesProperties;
}(_CartesianSeriesProperties);
__decorateClass([_Validate(_STRING)], AreaSeriesProperties.prototype, "xKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], AreaSeriesProperties.prototype, "xName", 2);
__decorateClass([_Validate(_STRING)], AreaSeriesProperties.prototype, "yKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], AreaSeriesProperties.prototype, "yName", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], AreaSeriesProperties.prototype, "normalizedTo", 2);
__decorateClass([_Validate(_COLOR_STRING)], AreaSeriesProperties.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO)], AreaSeriesProperties.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING)], AreaSeriesProperties.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], AreaSeriesProperties.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO)], AreaSeriesProperties.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH)], AreaSeriesProperties.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], AreaSeriesProperties.prototype, "lineDashOffset", 2);
__decorateClass([_Validate(_OBJECT)], AreaSeriesProperties.prototype, "shadow", 2);
__decorateClass([_Validate(_OBJECT)], AreaSeriesProperties.prototype, "marker", 2);
__decorateClass([_Validate(_OBJECT)], AreaSeriesProperties.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], AreaSeriesProperties.prototype, "tooltip", 2);
__decorateClass([_Validate(_BOOLEAN)], AreaSeriesProperties.prototype, "connectMissingData", 2);

// packages/ag-charts-community/src/chart/series/cartesian/markerUtil.ts
function _markerFadeInAnimation(_ref139, animationManager, status) {
  var id = _ref139.id;
  var params = {
    phase: status ? _NODE_UPDATE_STATE_TO_PHASE_MAPPING[status] : "trailing"
  };
  for (var _len28 = arguments.length, markerSelections = new Array(_len28 > 3 ? _len28 - 3 : 0), _key31 = 3; _key31 < _len28; _key31++) {
    markerSelections[_key31 - 3] = arguments[_key31];
  }
  _staticFromToMotion(id, "markers", animationManager, markerSelections, {
    opacity: 0
  }, {
    opacity: 1
  }, params);
  markerSelections.forEach(function (s) {
    return s.cleanup();
  });
}
function _markerScaleInAnimation(_ref140, animationManager) {
  var id = _ref140.id;
  for (var _len29 = arguments.length, markerSelections = new Array(_len29 > 2 ? _len29 - 2 : 0), _key32 = 2; _key32 < _len29; _key32++) {
    markerSelections[_key32 - 2] = arguments[_key32];
  }
  _staticFromToMotion(id, "markers", animationManager, markerSelections, {
    scalingX: 0,
    scalingY: 0
  }, {
    scalingX: 1,
    scalingY: 1
  }, {
    phase: "initial"
  });
  markerSelections.forEach(function (s) {
    return s.cleanup();
  });
}
function _markerSwipeScaleInAnimation(_ref141, animationManager) {
  var id = _ref141.id,
    nodeDataDependencies = _ref141.nodeDataDependencies;
  var seriesWidth = nodeDataDependencies.seriesRectWidth;
  var fromFn = function fromFn(_, datum) {
    var _a, _b;
    var x = (_b = (_a = datum.midPoint) == null ? void 0 : _a.x) != null ? _b : seriesWidth;
    var delay = _clamp(0, _inverseEaseOut(x / seriesWidth), 1);
    if (isNaN(delay)) {
      delay = 0;
    }
    return {
      scalingX: 0,
      scalingY: 0,
      delay: delay,
      duration: _QUICK_TRANSITION,
      phase: "initial"
    };
  };
  var toFn = function toFn() {
    return {
      scalingX: 1,
      scalingY: 1
    };
  };
  for (var _len30 = arguments.length, markerSelections = new Array(_len30 > 2 ? _len30 - 2 : 0), _key33 = 2; _key33 < _len30; _key33++) {
    markerSelections[_key33 - 2] = arguments[_key33];
  }
  _fromToMotion(id, "markers", animationManager, markerSelections, {
    fromFn: fromFn,
    toFn: toFn
  });
}
function _resetMarkerFn(_node) {
  return {
    opacity: 1,
    scalingX: 1,
    scalingY: 1
  };
}
function _resetMarkerPositionFn(_node, datum) {
  var _a, _b, _c, _d;
  return {
    translationX: (_b = (_a = datum.point) == null ? void 0 : _a.x) != null ? _b : NaN,
    translationY: (_d = (_c = datum.point) == null ? void 0 : _c.y) != null ? _d : NaN
  };
}
function _prepareMarkerAnimation(pairMap, parentStatus) {
  var readFirstPair = function readFirstPair(xValue, type) {
    var val = pairMap[type][xValue];
    return Array.isArray(val) ? val[0] : val;
  };
  var markerStatus = function markerStatus(datum) {
    var xValue = datum.xValue;
    if (pairMap.moved[xValue]) {
      return {
        point: readFirstPair(xValue, "moved"),
        status: "updated"
      };
    } else if (pairMap.removed[xValue]) {
      return {
        point: readFirstPair(xValue, "removed"),
        status: "removed"
      };
    } else if (pairMap.added[xValue]) {
      return {
        point: readFirstPair(xValue, "added"),
        status: "added"
      };
    }
    return {
      status: "unknown"
    };
  };
  var fromFn = function fromFn(marker, datum) {
    var _a, _b, _c, _d, _e, _f;
    var _markerStatus = markerStatus(datum),
      status = _markerStatus.status,
      point = _markerStatus.point;
    if (status === "unknown") return {
      opacity: 0
    };
    var defaults = {
      translationX: (_b = (_a = point == null ? void 0 : point.from) == null ? void 0 : _a.x) != null ? _b : marker.translationX,
      translationY: (_d = (_c = point == null ? void 0 : point.from) == null ? void 0 : _c.y) != null ? _d : marker.translationY,
      opacity: marker.opacity,
      phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
    };
    if (parentStatus === "added") {
      return __spreadProps(__spreadValues({}, defaults), {
        opacity: 0,
        translationX: (_e = point == null ? void 0 : point.to) == null ? void 0 : _e.x,
        translationY: (_f = point == null ? void 0 : point.to) == null ? void 0 : _f.y,
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING["added"]
      });
    }
    if (status === "added") {
      defaults.opacity = 0;
    }
    return defaults;
  };
  var toFn = function toFn(_marker, datum) {
    var _a, _b;
    var _markerStatus2 = markerStatus(datum),
      status = _markerStatus2.status,
      point = _markerStatus2.point;
    if (status === "unknown") return {
      opacity: 0
    };
    var defaults = {
      translationX: datum.point.x,
      translationY: datum.point.y,
      opacity: 1,
      phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
    };
    if (status === "removed" || parentStatus === "removed") {
      return __spreadProps(__spreadValues({}, defaults), {
        translationX: (_a = point == null ? void 0 : point.to) == null ? void 0 : _a.x,
        translationY: (_b = point == null ? void 0 : point.to) == null ? void 0 : _b.y,
        opacity: 0,
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING["removed"]
      });
    }
    return defaults;
  };
  return {
    fromFn: fromFn,
    toFn: toFn
  };
}
function _computeMarkerFocusBounds(series, _ref142) {
  var datumIndex = _ref142.datumIndex;
  var nodeData = series.getNodeData();
  if (nodeData === void 0) return void 0;
  var datum = nodeData[datumIndex];
  if (datum === void 0 || datum.point === void 0) return void 0;
  var size = series.getFormattedMarkerStyle(datum).size;
  var radius = size / 2;
  var _series$contentGroup$ = series.contentGroup.inverseTransformPoint(datum.point.x - radius, datum.point.y - radius),
    x = _series$contentGroup$.x,
    y = _series$contentGroup$.y;
  return new _BBox2(x, y, size, size);
}

// packages/ag-charts-community/src/chart/series/cartesian/pathUtil.ts
function _minMax3(nodeData) {
  return nodeData.reduce(function (_ref143, node) {
    var min = _ref143.min,
      max = _ref143.max;
    if (min == null || min.point.x > node.point.x) {
      min = node;
    }
    if (max == null || max.point.x < node.point.x) {
      max = node;
    }
    return {
      min: min,
      max: max
    };
  }, {});
}
function intersectionOnLine(a, b, targetX) {
  var m = (b.y - a.y) / (b.x - a.x);
  var y = (targetX - a.x) * m + a.y;
  return {
    x: targetX,
    y: y
  };
}
function backfillPathPoint(results, process, skip, processFn) {
  var prevMarkerIdx = -1,
    nextMarkerIdx = 0;
  var toProcess = [];
  while (nextMarkerIdx < results.length) {
    if (results[nextMarkerIdx].change === process) {
      toProcess.push(results[nextMarkerIdx]);
      nextMarkerIdx++;
      continue;
    }
    if (results[nextMarkerIdx].change === skip) {
      nextMarkerIdx++;
      continue;
    }
    if (toProcess.length > 0) {
      processFn(toProcess, prevMarkerIdx, nextMarkerIdx);
      toProcess.length = 0;
    }
    prevMarkerIdx = nextMarkerIdx;
    nextMarkerIdx++;
  }
  if (toProcess.length > 0) {
    processFn(toProcess, prevMarkerIdx, nextMarkerIdx);
  }
}
function _backfillPathPointData(result, splitMode) {
  backfillPathPoint(result, "out", "in", function (toProcess, sIdx, eIdx) {
    var _a, _b;
    if (sIdx === -1 && result[eIdx]) {
      toProcess.forEach(function (d) {
        return d.to = result[eIdx].from;
      });
    } else if (eIdx === result.length && result[sIdx]) {
      toProcess.forEach(function (d) {
        return d.to = result[sIdx].from;
      });
    } else if (splitMode === "intersect" && ((_a = result[sIdx]) == null ? void 0 : _a.from) && ((_b = result[eIdx]) == null ? void 0 : _b.from)) {
      toProcess.forEach(function (d) {
        return d.to = intersectionOnLine(result[sIdx].from, result[eIdx].from, d.from.x);
      });
    } else {
      toProcess.forEach(function (d) {
        return d.to = d.from;
      });
    }
  });
  backfillPathPoint(result, "in", "out", function (toProcess, sIdx, eIdx) {
    var _a, _b;
    if (sIdx === -1 && result[eIdx]) {
      toProcess.forEach(function (d) {
        return d.from = result[eIdx].to;
      });
    } else if (eIdx === result.length && result[sIdx]) {
      toProcess.forEach(function (d) {
        return d.from = result[sIdx].to;
      });
    } else if (splitMode === "intersect" && ((_a = result[sIdx]) == null ? void 0 : _a.to) && ((_b = result[eIdx]) == null ? void 0 : _b.to)) {
      toProcess.forEach(function (d) {
        return d.from = intersectionOnLine(result[sIdx].to, result[eIdx].to, d.to.x);
      });
    } else {
      toProcess.forEach(function (d) {
        return d.from = d.to;
      });
    }
  });
}
function calculatePoint(from, to, ratio) {
  var x1 = isNaN(from.x) ? to.x : from.x;
  var y1 = isNaN(from.y) ? to.y : from.y;
  var xd = to.x - from.x;
  var yd = to.y - from.y;
  var xr = isNaN(xd) ? 0 : xd * ratio;
  var yr = isNaN(yd) ? 0 : yd * ratio;
  return {
    x: x1 + xr,
    y: y1 + yr
  };
}
function _renderPartialPath(pairData, ratios, path) {
  var linePath = path.path;
  var previousTo;
  var _iterator200 = _createForOfIteratorHelper(pairData),
    _step200;
  try {
    for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
      var data = _step200.value;
      var from = data.from,
        to = data.to;
      var ratio = ratios[data.change];
      if (ratio == null || from == null || to == null) continue;
      var _calculatePoint = calculatePoint(from, to, ratio),
        x = _calculatePoint.x,
        y = _calculatePoint.y;
      if (data.moveTo === false) {
        linePath.lineTo(x, y);
      } else if (data.moveTo === true || !previousTo) {
        linePath.moveTo(x, y);
      } else if (previousTo) {
        var moveToRatio = data.moveTo === "in" ? ratio : 1 - ratio;
        var _calculatePoint2 = calculatePoint(previousTo, {
            x: x,
            y: y
          }, moveToRatio),
          midPointX = _calculatePoint2.x,
          midPointY = _calculatePoint2.y;
        linePath.lineTo(midPointX, midPointY);
        linePath.moveTo(x, y);
      }
      previousTo = {
        x: x,
        y: y
      };
    }
  } catch (err) {
    _iterator200.e(err);
  } finally {
    _iterator200.f();
  }
}
function _pathSwipeInAnimation(_ref144, animationManager) {
  var id = _ref144.id,
    visible = _ref144.visible,
    nodeDataDependencies = _ref144.nodeDataDependencies;
  var width = nodeDataDependencies.seriesRectWidth,
    height = nodeDataDependencies.seriesRectHeight;
  for (var _len31 = arguments.length, paths = new Array(_len31 > 2 ? _len31 - 2 : 0), _key34 = 2; _key34 < _len31; _key34++) {
    paths[_key34 - 2] = arguments[_key34];
  }
  _staticFromToMotion(id, "path_properties", animationManager, paths, {
    clipX: 0
  }, {
    clipX: width
  }, {
    phase: "initial",
    start: {
      clipMode: "normal",
      clipY: height,
      visible: visible
    },
    finish: {
      clipMode: void 0,
      visible: visible
    }
  });
}
function _pathFadeInAnimation(_ref145, subId, animationManager) {
  var id = _ref145.id;
  var phase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "add";
  for (var _len32 = arguments.length, selection = new Array(_len32 > 4 ? _len32 - 4 : 0), _key35 = 4; _key35 < _len32; _key35++) {
    selection[_key35 - 4] = arguments[_key35];
  }
  _staticFromToMotion(id, subId, animationManager, selection, {
    opacity: 0
  }, {
    opacity: 1
  }, {
    phase: phase
  });
}
function _pathFadeOutAnimation(_ref146, subId, animationManager) {
  var id = _ref146.id;
  for (var _len33 = arguments.length, selection = new Array(_len33 > 3 ? _len33 - 3 : 0), _key36 = 3; _key36 < _len33; _key36++) {
    selection[_key36 - 3] = arguments[_key36];
  }
  _staticFromToMotion(id, subId, animationManager, selection, {
    opacity: 1
  }, {
    opacity: 0
  }, {
    phase: "remove"
  });
}
function _buildResetPathFn(opts) {
  return function (_node) {
    return {
      opacity: opts.getOpacity(),
      clipScalingX: 1,
      clipMode: void 0
    };
  };
}
function _updateClipPath(_ref147, path) {
  var nodeDataDependencies = _ref147.nodeDataDependencies;
  var toFinite = function toFinite(value) {
    return isFinite(value) ? value : 0;
  };
  path.clipX = toFinite(nodeDataDependencies.seriesRectWidth);
  path.clipY = toFinite(nodeDataDependencies.seriesRectHeight);
}

// packages/ag-charts-community/src/chart/series/cartesian/scaling.ts
function isContinuousScaling(scaling) {
  return scaling.type === "continuous" || scaling.type === "log";
}
function isCategoryScaling(scaling) {
  return scaling.type === "category";
}
function areEqual(a, b) {
  return a.domain.length === b.domain.length && a.range.length === b.range.length && a.domain.every(function (val, index) {
    return val === b.domain[index];
  }) && a.range.every(function (val, index) {
    return val === b.range[index];
  });
}
function areScalingEqual(a, b) {
  if (a === void 0 || b === void 0) {
    return a !== void 0 || b !== void 0;
  }
  if (isContinuousScaling(a) && isContinuousScaling(b)) {
    return a.type === b.type && areEqual(a, b);
  }
  if (isCategoryScaling(a) && isCategoryScaling(b)) {
    return areEqual(a, b);
  }
  return false;
}

// packages/ag-charts-community/src/chart/series/cartesian/lineUtil.ts
function scale(val, scaling) {
  if (!scaling) return NaN;
  if (val instanceof Date) {
    val = val.getTime();
  }
  if (scaling.type === "continuous" && typeof val === "number") {
    var domainRatio = (val - scaling.domain[0]) / (scaling.domain[1] - scaling.domain[0]);
    return domainRatio * (scaling.range[1] - scaling.range[0]) + scaling.range[0];
  }
  if (scaling.type === "log" && typeof val === "number") {
    return scaling.convert(val);
  }
  var matchingIndex = scaling.domain.findIndex(function (d) {
    return d === val;
  });
  if (matchingIndex >= 0) {
    return scaling.range[matchingIndex];
  }
  return NaN;
}
function scalesChanged(newData, oldData) {
  return !areScalingEqual(newData.scales.x, oldData.scales.x) || !areScalingEqual(newData.scales.y, oldData.scales.y);
}
function closeMatch(a, b) {
  var an = Number(a);
  var bn = Number(b);
  if (!isNaN(an) && !isNaN(bn)) {
    return Math.abs(bn - an) < 0.25;
  }
  return a === b;
}
function calculateMoveTo() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (from === to) {
    return Boolean(from);
  }
  return from ? "in" : "out";
}
function _pairContinuousData(newData, oldData) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a, _b, _c, _d;
  var _opts$backfillSplitMo = opts.backfillSplitMode,
    backfillSplitMode = _opts$backfillSplitMo === void 0 ? "intersect" : _opts$backfillSplitMo;
  var toNewScale = function toNewScale(oldDatum) {
    var _a2, _b2;
    return {
      x: scale((_a2 = oldDatum.xValue) != null ? _a2 : NaN, newData.scales.x),
      y: scale((_b2 = oldDatum.yValue) != null ? _b2 : NaN, newData.scales.y)
    };
  };
  var toOldScale = function toOldScale(newDatum) {
    var _a2, _b2;
    return {
      x: scale((_a2 = newDatum.xValue) != null ? _a2 : NaN, oldData.scales.x),
      y: scale((_b2 = newDatum.yValue) != null ? _b2 : NaN, oldData.scales.y)
    };
  };
  var result = [];
  var resultMap = {
    added: {},
    moved: {},
    removed: {}
  };
  var pairUp = function pairUp(from, to, xValue) {
    var change = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "move";
    if (from && (isNaN(from.point.x) || isNaN(from.point.y))) {
      from = to;
    }
    var resultPoint = {
      from: from == null ? void 0 : from.point,
      to: to == null ? void 0 : to.point,
      moveTo: calculateMoveTo(from == null ? void 0 : from.point.moveTo, to == null ? void 0 : to.point.moveTo),
      change: change
    };
    if (change === "move") {
      resultMap.moved[xValue] = resultPoint;
      oldIdx++;
      newIdx++;
    } else if (change === "in") {
      resultMap.added[xValue] = resultPoint;
      newIdx++;
    } else if (change === "out") {
      resultMap.removed[xValue] = resultPoint;
      oldIdx++;
    }
    result.push(resultPoint);
  };
  var _minMax = _minMax3(oldData.nodeData),
    minFromNode = _minMax.min,
    maxFromNode = _minMax.max;
  var _minMax2 = _minMax3(newData.nodeData),
    minToNode = _minMax2.min,
    maxToNode = _minMax2.max;
  var oldIdx = 0;
  var newIdx = 0;
  while (oldIdx < oldData.nodeData.length || newIdx < newData.nodeData.length) {
    var from = oldData.nodeData[oldIdx];
    var to = newData.nodeData[newIdx];
    var fromShifted = from ? toNewScale(from) : void 0;
    var toUnshifted = to ? toOldScale(to) : void 0;
    var NA = void 0;
    if (fromShifted && closeMatch(fromShifted.x, to == null ? void 0 : to.point.x)) {
      pairUp(from, to, to.xValue, "move");
    } else if (fromShifted && fromShifted.x < ((_a = minToNode == null ? void 0 : minToNode.point.x) != null ? _a : -Infinity)) {
      pairUp(from, NA, from.xValue, "out");
    } else if (fromShifted && fromShifted.x > ((_b = maxToNode == null ? void 0 : maxToNode.point.x) != null ? _b : Infinity)) {
      pairUp(from, NA, from.xValue, "out");
    } else if (toUnshifted && toUnshifted.x < ((_c = minFromNode == null ? void 0 : minFromNode.point.x) != null ? _c : -Infinity)) {
      pairUp(NA, to, to.xValue, "in");
    } else if (toUnshifted && toUnshifted.x > ((_d = maxFromNode == null ? void 0 : maxFromNode.point.x) != null ? _d : Infinity)) {
      pairUp(NA, to, to.xValue, "in");
    } else if (fromShifted && fromShifted.x < (to == null ? void 0 : to.point.x)) {
      pairUp(from, NA, from.xValue, "out");
    } else if (toUnshifted && toUnshifted.x < (from == null ? void 0 : from.point.x)) {
      pairUp(NA, to, to.xValue, "in");
    } else if (from) {
      pairUp(from, NA, from.xValue, "out");
    } else if (to) {
      pairUp(NA, to, to.xValue, "in");
    } else {
      throw new Error("Unable to process points");
    }
  }
  _backfillPathPointData(result, backfillSplitMode);
  return {
    result: result,
    resultMap: resultMap
  };
}
function _pairCategoryData(newData, oldData, diff2) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a, _b, _c;
  var _opts$backfillSplitMo2 = opts.backfillSplitMode,
    backfillSplitMode = _opts$backfillSplitMo2 === void 0 ? "intersect" : _opts$backfillSplitMo2,
    _opts$multiDatum = opts.multiDatum,
    multiDatum = _opts$multiDatum === void 0 ? false : _opts$multiDatum;
  var result = [];
  var resultMapSingle = {
    added: {},
    moved: {},
    removed: {}
  };
  var resultMapMulti = {
    added: {},
    moved: {},
    removed: {}
  };
  var pointResultMapping = {
    in: "added",
    move: "moved",
    out: "removed"
  };
  var previousResultPoint = void 0;
  var previousXValue = void 0;
  var addToResultMap = function addToResultMap(xValue, newPoint) {
    var _a2, _b2;
    var type = pointResultMapping[newPoint.change];
    if (multiDatum) {
      (_b2 = (_a2 = resultMapMulti[type])[xValue]) != null ? _b2 : _a2[xValue] = [];
      resultMapMulti[type][xValue].push(newPoint);
    } else {
      resultMapSingle[type][xValue] = newPoint;
    }
    previousResultPoint = newPoint;
    previousXValue = _transformIntegratedCategoryValue(xValue);
  };
  var oldIndex = 0;
  var newIndex = 0;
  var isXUnordered = false;
  while (oldIndex < oldData.nodeData.length || newIndex < newData.nodeData.length) {
    var before = oldData.nodeData[oldIndex];
    var after = newData.nodeData[newIndex];
    var bXValue = _transformIntegratedCategoryValue(before == null ? void 0 : before.xValue);
    var aXValue = _transformIntegratedCategoryValue(after == null ? void 0 : after.xValue);
    var resultPoint = void 0;
    if (bXValue === aXValue) {
      resultPoint = {
        change: "move",
        moveTo: calculateMoveTo((_a = before.point.moveTo) != null ? _a : false, after.point.moveTo),
        from: before.point,
        to: after.point
      };
      addToResultMap(before == null ? void 0 : before.xValue, resultPoint);
      oldIndex++;
      newIndex++;
    } else if (diff2 == null ? void 0 : diff2.removed.has(String(bXValue))) {
      resultPoint = {
        change: "out",
        moveTo: (_b = before.point.moveTo) != null ? _b : false,
        from: before.point
      };
      addToResultMap(before == null ? void 0 : before.xValue, resultPoint);
      oldIndex++;
    } else if (diff2 == null ? void 0 : diff2.added.has(String(aXValue))) {
      resultPoint = {
        change: "in",
        moveTo: (_c = after.point.moveTo) != null ? _c : false,
        to: after.point
      };
      addToResultMap(after == null ? void 0 : after.xValue, resultPoint);
      newIndex++;
    } else if (multiDatum && previousResultPoint && previousXValue === bXValue) {
      resultPoint = __spreadValues({}, previousResultPoint);
      addToResultMap(before == null ? void 0 : before.xValue, resultPoint);
      oldIndex++;
    } else if (multiDatum && previousResultPoint && previousXValue === aXValue) {
      resultPoint = __spreadValues({}, previousResultPoint);
      addToResultMap(after == null ? void 0 : after.xValue, resultPoint);
      newIndex++;
    } else {
      isXUnordered = true;
      break;
    }
    result.push(resultPoint);
  }
  var previousX = -Infinity;
  isXUnordered || (isXUnordered = result.some(function (pathPoint) {
    var marker = pathPoint.change,
      _pathPoint$to = pathPoint.to,
      _pathPoint$to2 = _pathPoint$to === void 0 ? {} : _pathPoint$to,
      _pathPoint$to2$x = _pathPoint$to2.x,
      x = _pathPoint$to2$x === void 0 ? -Infinity : _pathPoint$to2$x;
    if (marker === "out") return;
    var unordered = x < previousX;
    previousX = x;
    return unordered;
  }));
  if (isXUnordered) {
    return {
      result: void 0,
      resultMap: void 0
    };
  }
  _backfillPathPointData(result, backfillSplitMode);
  return {
    result: result,
    resultMap: multiDatum ? resultMapMulti : resultMapSingle
  };
}
function _determinePathStatus(newData, oldData, pairData) {
  var _a, _b, _c, _d;
  var status = "updated";
  var visible = function visible(data) {
    return data.visible;
  };
  if (!visible(oldData) && visible(newData)) {
    status = "added";
  } else if (visible(oldData) && !visible(newData)) {
    status = "removed";
  } else {
    for (var i = 0; i < pairData.length; i++) {
      if (pairData[i].change !== "move") break;
      if (((_a = pairData[i].from) == null ? void 0 : _a.x) !== ((_b = pairData[i].to) == null ? void 0 : _b.x)) break;
      if (((_c = pairData[i].from) == null ? void 0 : _c.y) !== ((_d = pairData[i].to) == null ? void 0 : _d.y)) break;
      if (i === pairData.length - 1) return "no-op";
    }
  }
  return status;
}
function prepareLinePathPropertyAnimation(status, visibleToggleMode) {
  var phase = visibleToggleMode === "none" ? "updated" : status;
  var result = {
    fromFn: function fromFn(_path) {
      var mixin;
      if (status === "removed") {
        mixin = {
          finish: {
            visible: false
          }
        };
      } else if (status === "added") {
        mixin = {
          start: {
            visible: true
          }
        };
      } else {
        mixin = {};
      }
      return __spreadValues({
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
      }, mixin);
    },
    toFn: function toFn(_path) {
      return {
        phase: _NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
      };
    }
  };
  if (visibleToggleMode === "fade") {
    return {
      fromFn: function fromFn(path) {
        var opacity = status === "added" ? 0 : path.opacity;
        return __spreadValues({
          opacity: opacity
        }, result.fromFn(path));
      },
      toFn: function toFn(path) {
        var opacity = status === "removed" ? 0 : 1;
        return __spreadValues({
          opacity: opacity
        }, result.toFn(path));
      }
    };
  }
  return result;
}
function _prepareLinePathAnimationFns(newData, oldData, pairData, visibleToggleMode, render) {
  var status = _determinePathStatus(newData, oldData, pairData);
  var removePhaseFn = function removePhaseFn(ratio, path) {
    render(pairData, {
      move: 0,
      out: ratio
    }, path);
  };
  var updatePhaseFn = function updatePhaseFn(ratio, path) {
    render(pairData, {
      move: ratio
    }, path);
  };
  var addPhaseFn = function addPhaseFn(ratio, path) {
    render(pairData, {
      move: 1,
      in: ratio
    }, path);
  };
  var pathProperties = prepareLinePathPropertyAnimation(status, visibleToggleMode);
  return {
    status: status,
    path: {
      addPhaseFn: addPhaseFn,
      updatePhaseFn: updatePhaseFn,
      removePhaseFn: removePhaseFn
    },
    pathProperties: pathProperties
  };
}
function _prepareLinePathAnimation(newData, oldData, diff2) {
  var _a, _b, _c;
  var isCategoryBased = ((_a = newData.scales.x) == null ? void 0 : _a.type) === "category";
  var wasCategoryBased = ((_b = oldData.scales.x) == null ? void 0 : _b.type) === "category";
  if (isCategoryBased !== wasCategoryBased) {
    return;
  }
  var _ref148 = isCategoryBased ? _pairCategoryData(newData, oldData, diff2) : _pairContinuousData(newData, oldData),
    pairData = _ref148.result,
    pairMap = _ref148.resultMap;
  var status = "updated";
  if (oldData.visible && !newData.visible) {
    status = "removed";
  } else if (!oldData.visible && newData.visible) {
    status = "added";
  }
  if (pairData === void 0 || pairMap === void 0) {
    return;
  }
  var hasMotion = ((_c = diff2 == null ? void 0 : diff2.changed) != null ? _c : true) || scalesChanged(newData, oldData) || status !== "updated";
  var pathFns = _prepareLinePathAnimationFns(newData, oldData, pairData, "fade", _renderPartialPath);
  var marker = _prepareMarkerAnimation(pairMap, status);
  return __spreadProps(__spreadValues({}, pathFns), {
    marker: marker,
    hasMotion: hasMotion
  });
}

// packages/ag-charts-community/src/chart/series/cartesian/areaUtil.ts
var _AreaSeriesTag = /* @__PURE__ */function (AreaSeriesTag2) {
  AreaSeriesTag2[AreaSeriesTag2["Fill"] = 0] = "Fill";
  AreaSeriesTag2[AreaSeriesTag2["Stroke"] = 1] = "Stroke";
  AreaSeriesTag2[AreaSeriesTag2["Marker"] = 2] = "Marker";
  AreaSeriesTag2[AreaSeriesTag2["Label"] = 3] = "Label";
  return AreaSeriesTag2;
}(_AreaSeriesTag || {});
function splitFillPoints(context) {
  var _context$fillData = context.fillData,
    points = _context$fillData.points,
    phantomPoints = _context$fillData.phantomPoints;
  return {
    top: points,
    bottom: phantomPoints
  };
}
function prepPoints(key, ctx, points) {
  return {
    scales: ctx.scales,
    nodeData: points[key],
    visible: ctx.visible
  };
}
function pairFillCategoryData(newData, oldData, diff2) {
  var oldPoints = splitFillPoints(oldData);
  var newPoints = splitFillPoints(newData);
  var pairOpts = {
    multiDatum: true
  };
  return {
    top: _pairCategoryData(prepPoints("top", newData, newPoints), prepPoints("top", oldData, oldPoints), diff2, pairOpts),
    bottom: _pairCategoryData(prepPoints("bottom", newData, newPoints), prepPoints("bottom", oldData, oldPoints), diff2, pairOpts)
  };
}
function pairFillContinuousData(newData, oldData) {
  var oldPoints = splitFillPoints(oldData);
  var newPoints = splitFillPoints(newData);
  return {
    top: _pairContinuousData(prepPoints("top", newData, newPoints), prepPoints("top", oldData, oldPoints)),
    bottom: _pairContinuousData(prepPoints("bottom", newData, newPoints), prepPoints("bottom", oldData, oldPoints))
  };
}
function _prepareAreaPathAnimation(newData, oldData, diff2) {
  var _a, _b;
  var isCategoryBased = ((_a = newData.scales.x) == null ? void 0 : _a.type) === "category";
  var wasCategoryBased = ((_b = oldData.scales.x) == null ? void 0 : _b.type) === "category";
  if (isCategoryBased !== wasCategoryBased) {
    return;
  }
  var status = "updated";
  if (oldData.visible && !newData.visible) {
    status = "removed";
  } else if (!oldData.visible && newData.visible) {
    status = "added";
  }
  var prepareMarkerPairs = function prepareMarkerPairs() {
    if (isCategoryBased) {
      return _pairCategoryData(newData, oldData, diff2, {
        backfillSplitMode: "static",
        multiDatum: true
      });
    }
    return _pairContinuousData(newData, oldData, {
      backfillSplitMode: "static"
    });
  };
  var prepareFillPairs = function prepareFillPairs() {
    if (isCategoryBased) {
      return pairFillCategoryData(newData, oldData, diff2);
    }
    return pairFillContinuousData(newData, oldData);
  };
  var _prepareMarkerPairs = prepareMarkerPairs(),
    markerPairMap = _prepareMarkerPairs.resultMap;
  var _prepareFillPairs = prepareFillPairs(),
    top = _prepareFillPairs.top,
    bottom = _prepareFillPairs.bottom;
  if (markerPairMap === void 0 || top.result === void 0 || bottom.result === void 0) {
    return;
  }
  var pairData = [].concat(_toConsumableArray(top.result), _toConsumableArray(bottom.result.reverse()));
  var stackVisible = oldData.stackVisible ? newData.stackVisible : false;
  var fadeMode = stackVisible ? "none" : "fade";
  var fill = _prepareLinePathAnimationFns(newData, oldData, pairData, fadeMode, _renderPartialPath);
  var marker = _prepareMarkerAnimation(markerPairMap, status);
  return {
    status: fill.status,
    fill: fill,
    marker: marker
  };
}

// packages/ag-charts-community/src/chart/series/cartesian/areaSeries.ts
var AreaSeries = /*#__PURE__*/function (_CartesianSeries) {
  _inherits(AreaSeries, _CartesianSeries);
  function AreaSeries(moduleCtx) {
    var _this176;
    _classCallCheck(this, AreaSeries);
    _this176 = _possibleConstructorReturn(this, _getPrototypeOf(AreaSeries).call(this, {
      moduleCtx: moduleCtx,
      directionKeys: _DEFAULT_CARTESIAN_DIRECTION_KEYS,
      directionNames: _DEFAULT_CARTESIAN_DIRECTION_NAMES,
      pathsPerSeries: 2,
      pathsZIndexSubOrderOffset: [0, 1e3],
      hasMarkers: true,
      markerSelectionGarbageCollection: false,
      pickModes: [1 /* NEAREST_BY_MAIN_AXIS_FIRST */, 0 /* EXACT_SHAPE_MATCH */],
      animationResetFns: {
        path: _buildResetPathFn({
          getOpacity: function getOpacity() {
            return _this176.getOpacity();
          }
        }),
        label: _resetLabelFn,
        marker: function marker(node, datum) {
          return __spreadValues(__spreadValues({}, _resetMarkerFn(node)), _resetMarkerPositionFn(node, datum));
        }
      }
    }));
    _this176.properties = new AreaSeriesProperties();
    return _this176;
  }
  _createClass(AreaSeries, [{
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee36() {
        var _a, _b, data, visible, _this$seriesGrouping, _this$seriesGrouping2, _this$seriesGrouping3, groupIndex, _this$seriesGrouping4, stackCount, _this$properties, xKey, yKey, connectMissingData, normalizedTo, animationEnabled, xScale, yScale, _this$getScaleInforma, isContinuousX, xScaleType, yScaleType, ids, extraProps, common;
        return _regenerator().w(function (_context46) {
          while (1) switch (_context46.n) {
            case 0:
              if (!(this.data == null || !this.properties.isValid())) {
                _context46.n = 1;
                break;
              }
              return _context46.a(2);
            case 1:
              data = this.data, visible = this.visible, _this$seriesGrouping = this.seriesGrouping, _this$seriesGrouping2 = _this$seriesGrouping === void 0 ? {} : _this$seriesGrouping, _this$seriesGrouping3 = _this$seriesGrouping2.groupIndex, groupIndex = _this$seriesGrouping3 === void 0 ? this.id : _this$seriesGrouping3, _this$seriesGrouping4 = _this$seriesGrouping2.stackCount, stackCount = _this$seriesGrouping4 === void 0 ? 1 : _this$seriesGrouping4;
              _this$properties = this.properties, xKey = _this$properties.xKey, yKey = _this$properties.yKey, connectMissingData = _this$properties.connectMissingData, normalizedTo = _this$properties.normalizedTo;
              animationEnabled = !this.ctx.animationManager.isSkipped();
              xScale = (_a = this.axes["x" /* X */]) == null ? void 0 : _a.scale;
              yScale = (_b = this.axes["y" /* Y */]) == null ? void 0 : _b.scale;
              _this$getScaleInforma = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
              }), isContinuousX = _this$getScaleInforma.isContinuousX, xScaleType = _this$getScaleInforma.xScaleType, yScaleType = _this$getScaleInforma.yScaleType;
              ids = ["area-stack-".concat(groupIndex, "-yValues"), "area-stack-".concat(groupIndex, "-yValues-trailing"), "area-stack-".concat(groupIndex, "-yValues-prev"), "area-stack-".concat(groupIndex, "-yValues-trailing-prev"), "area-stack-".concat(groupIndex, "-yValues-marker")];
              extraProps = [];
              if (_isDefined(normalizedTo)) {
                extraProps.push(_normaliseGroupTo([ids[0], ids[1], ids[4]], normalizedTo, "range"));
                extraProps.push(_normaliseGroupTo([ids[2], ids[3]], normalizedTo, "range"));
              }
              if (!isContinuousX && animationEnabled && this.processedData) {
                extraProps.push(_diff(this.processedData));
              }
              if (animationEnabled) {
                extraProps.push(_animationValidation());
              }
              common = {
                invalidValue: null
              };
              if (connectMissingData && stackCount > 1) {
                common.invalidValue = 0;
              }
              if (!visible) {
                common.forceValue = 0;
              }
              _context46.n = 2;
              return this.requestDataModel(dataController, data, {
                props: [_keyProperty(xKey, xScaleType, {
                  id: "xValue"
                }), _valueProperty(yKey, yScaleType, __spreadValues({
                  id: "yValueRaw"
                }, common))].concat(_toConsumableArray(_groupAccumulativeValueProperty(yKey, "window", "current", __spreadProps(__spreadValues({
                  id: "yValueEnd"
                }, common), {
                  groupId: ids[0]
                }), yScaleType)), _toConsumableArray(_groupAccumulativeValueProperty(yKey, "window-trailing", "current", __spreadProps(__spreadValues({
                  id: "yValueStart"
                }, common), {
                  groupId: ids[1]
                }), yScaleType)), _toConsumableArray(_groupAccumulativeValueProperty(yKey, "window", "last", __spreadProps(__spreadValues({
                  id: "yValuePreviousEnd"
                }, common), {
                  groupId: ids[2]
                }), yScaleType)), _toConsumableArray(_groupAccumulativeValueProperty(yKey, "window-trailing", "last", __spreadProps(__spreadValues({
                  id: "yValuePreviousStart"
                }, common), {
                  groupId: ids[3]
                }), yScaleType)), _toConsumableArray(_groupAccumulativeValueProperty(yKey, "normal", "current", __spreadProps(__spreadValues({
                  id: "yValueCumulative"
                }, common), {
                  groupId: ids[4]
                }), yScaleType)), extraProps),
                groupByKeys: true,
                groupByData: false
              });
            case 2:
              this.animationState.transition("updateData");
            case 3:
              return _context46.a(2);
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      var processedData = this.processedData,
        dataModel = this.dataModel,
        axes = this.axes;
      if (!processedData || !dataModel || processedData.data.length === 0) return [];
      var xAxis = axes["x" /* X */];
      var yAxis = axes["y" /* Y */];
      var keyDef = dataModel.resolveProcessedDataDefById(this, "xValue");
      var keys = dataModel.getDomain(this, "xValue", "key", processedData);
      var yExtent = dataModel.getDomain(this, "yValueEnd", "value", processedData);
      if (direction === "x" /* X */) {
        if ((keyDef == null ? void 0 : keyDef.def.type) === "key" && keyDef.def.valueType === "category") {
          return keys;
        }
        return _fixNumericExtent(_extent(keys), xAxis);
      } else if (yAxis instanceof LogAxis || yAxis instanceof TimeAxis) {
        return _fixNumericExtent(yExtent, yAxis);
      } else {
        var fixedYExtent = [yExtent[0] > 0 ? 0 : yExtent[0], yExtent[1] < 0 ? 0 : yExtent[1]];
        return _fixNumericExtent(fixedYExtent, yAxis);
      }
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee37() {
        var _this177 = this;
        var _a, axes, data, _this$processedData, _this$processedData2, groupedData, dataModel, xAxis, yAxis, _this$properties2, yKey, xKey, marker, label, seriesFill, seriesStroke, connectMissingData, xScale, yScale, _this$getScaleInforma2, isContinuousY, xOffset, defs, createMovePoint, createPathCoordinates, createMarkerCoordinate, itemId, labelData, markerData, _this$ctx$seriesState, visibleSameStackCount, context, fillPoints, fillPhantomPoints, strokePoints, datumIdx, lastXDatum, lastYDatum;
        return _regenerator().w(function (_context47) {
          while (1) switch (_context47.n) {
            case 0:
              axes = this.axes, data = this.data, _this$processedData = this.processedData, _this$processedData2 = _this$processedData === void 0 ? {} : _this$processedData, groupedData = _this$processedData2.data, dataModel = this.dataModel;
              xAxis = axes["x" /* X */];
              yAxis = axes["y" /* Y */];
              if (!(!xAxis || !yAxis || !data || !dataModel || !this.properties.isValid())) {
                _context47.n = 1;
                break;
              }
              return _context47.a(2);
            case 1:
              _this$properties2 = this.properties, yKey = _this$properties2.yKey, xKey = _this$properties2.xKey, marker = _this$properties2.marker, label = _this$properties2.label, seriesFill = _this$properties2.fill, seriesStroke = _this$properties2.stroke, connectMissingData = _this$properties2.connectMissingData;
              xScale = xAxis.scale;
              yScale = yAxis.scale;
              _this$getScaleInforma2 = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
              }), isContinuousY = _this$getScaleInforma2.isContinuousY;
              xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
              defs = dataModel.resolveProcessedDataDefsByIds(this, ["yValueStart", "yValueEnd", "yValueRaw", "yValuePreviousStart", "yValuePreviousEnd", "yValueCumulative"]);
              createMovePoint = function createMovePoint(plainPoint) {
                return __spreadProps(__spreadValues({}, plainPoint), {
                  point: __spreadProps(__spreadValues({}, plainPoint.point), {
                    moveTo: true
                  })
                });
              };
              createPathCoordinates = function createPathCoordinates(xValue, lastYEnd, yEnd) {
                var x = xScale.convert(xValue) + xOffset;
                var prevYCoordinate = yScale.convert(lastYEnd);
                var currYCoordinate = yScale.convert(yEnd);
                return [{
                  point: {
                    x: x,
                    y: currYCoordinate
                  },
                  yValue: yEnd,
                  xValue: xValue
                }, {
                  point: {
                    x: x,
                    y: prevYCoordinate
                  },
                  yValue: lastYEnd,
                  xValue: xValue
                }];
              };
              createMarkerCoordinate = function createMarkerCoordinate(xDatum, yEnd, rawYDatum) {
                var currY;
                if (_isDefined(_this177.properties.normalizedTo) ? isContinuousY && _isContinuous(rawYDatum) : !isNaN(rawYDatum)) {
                  currY = yEnd;
                }
                return {
                  x: xScale.convert(xDatum) + xOffset,
                  y: yScale.convert(currY),
                  size: marker.size
                };
              };
              itemId = yKey;
              labelData = [];
              markerData = [];
              _this$ctx$seriesState = this.ctx.seriesStateManager.getVisiblePeerGroupIndex(this), visibleSameStackCount = _this$ctx$seriesState.visibleSameStackCount;
              context = {
                itemId: itemId,
                fillData: {
                  itemId: itemId,
                  points: [],
                  phantomPoints: []
                },
                strokeData: {
                  itemId: itemId,
                  points: []
                },
                labelData: labelData,
                nodeData: markerData,
                scales: this.calculateScaling(),
                visible: this.visible,
                stackVisible: visibleSameStackCount > 0
              };
              fillPoints = context.fillData.points;
              fillPhantomPoints = context.fillData.phantomPoints;
              strokePoints = context.strokeData.points;
              datumIdx = -1;
              lastYDatum = -Infinity;
              groupedData == null ? void 0 : groupedData.forEach(function (datumGroup) {
                var keys = datumGroup.keys,
                  _datumGroup$keys = _slicedToArray(datumGroup.keys, 1),
                  xDatum = _datumGroup$keys[0],
                  datumArray = datumGroup.datum,
                  valuesArray = datumGroup.values;
                valuesArray.forEach(function (values, valueIdx) {
                  var _a2, _b, _c;
                  datumIdx++;
                  var seriesDatum = datumArray[valueIdx];
                  var dataValues = dataModel.resolveProcessedDataDefsValues(defs, {
                    keys: keys,
                    values: values
                  });
                  var yDatum = dataValues.yValueRaw,
                    yValueCumulative = dataValues.yValueCumulative;
                  var yValueStart = dataValues.yValueStart,
                    yValueEnd = dataValues.yValueEnd,
                    yValuePreviousStart = dataValues.yValuePreviousStart,
                    yValuePreviousEnd = dataValues.yValuePreviousEnd;
                  var validPoint = yDatum != null;
                  var point = createMarkerCoordinate(xDatum, +yValueCumulative, yDatum);
                  if (validPoint && marker) {
                    markerData.push({
                      index: datumIdx,
                      series: _this177,
                      itemId: itemId,
                      datum: seriesDatum,
                      midPoint: {
                        x: point.x,
                        y: point.y
                      },
                      cumulativeValue: yValueEnd,
                      yValue: yDatum,
                      xValue: xDatum,
                      yKey: yKey,
                      xKey: xKey,
                      point: point,
                      fill: (_a2 = marker.fill) != null ? _a2 : seriesFill,
                      stroke: (_b = marker.stroke) != null ? _b : seriesStroke,
                      strokeWidth: (_c = marker.strokeWidth) != null ? _c : _this177.getStrokeWidth(_this177.properties.strokeWidth)
                    });
                  }
                  if (validPoint && label) {
                    var labelText = _this177.getLabelText(label, {
                      value: yDatum,
                      datum: seriesDatum,
                      xKey: xKey,
                      yKey: yKey,
                      xName: _this177.properties.xName,
                      yName: _this177.properties.yName
                    }, function (value) {
                      return _isFiniteNumber(value) ? value.toFixed(2) : String(value);
                    });
                    labelData.push({
                      index: datumIdx,
                      series: _this177,
                      itemId: yKey,
                      datum: seriesDatum,
                      x: point.x,
                      y: point.y,
                      label: labelText ? {
                        text: labelText,
                        fontStyle: label.fontStyle,
                        fontWeight: label.fontWeight,
                        fontSize: label.fontSize,
                        fontFamily: label.fontFamily,
                        textAlign: "center",
                        textBaseline: "bottom",
                        fill: label.color
                      } : void 0
                    });
                  }
                  var xValid = lastXDatum != null && xDatum != null;
                  var yValid = lastYDatum != null && validPoint;
                  if (!yValid) {
                    yValueStart = yValueStart != null ? yValueStart : 0;
                    yValueEnd = yValueStart != null ? yValueStart : 0;
                    yValuePreviousStart = yValuePreviousStart != null ? yValuePreviousStart : 0;
                    yValuePreviousEnd = yValuePreviousStart != null ? yValuePreviousStart : 0;
                  }
                  var _createPathCoordinate = createPathCoordinates(lastXDatum, yValuePreviousStart, yValuePreviousEnd),
                    _createPathCoordinate2 = _slicedToArray(_createPathCoordinate, 2),
                    prevTop = _createPathCoordinate2[0],
                    prevBottom = _createPathCoordinate2[1];
                  var _createPathCoordinate3 = createPathCoordinates(xDatum, yValueStart, yValueEnd),
                    _createPathCoordinate4 = _slicedToArray(_createPathCoordinate3, 2),
                    top = _createPathCoordinate4[0],
                    bottom = _createPathCoordinate4[1];
                  if (xValid && (!connectMissingData || yValid)) {
                    fillPoints.push(prevTop, top);
                    fillPhantomPoints.push(prevBottom, bottom);
                  }
                  if (yValid && datumIdx > 0) {
                    strokePoints.push(createMovePoint(prevTop), top);
                  }
                  lastXDatum = xDatum;
                  lastYDatum = yDatum;
                });
              });
              if (strokePoints.length > 0) {
                strokePoints[0] = createMovePoint(strokePoints[0]);
              }
              return _context47.a(2, context);
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "isPathOrSelectionDirty",
    value: function isPathOrSelectionDirty() {
      return this.properties.marker.isDirty();
    }
  }, {
    key: "markerFactory",
    value: function markerFactory() {
      var shape = this.properties.marker.shape;
      var MarkerShape = _getMarker(shape);
      return new MarkerShape();
    }
  }, {
    key: "updatePathNodes",
    value: function updatePathNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee38() {
        var opacity, visible, animationEnabled, _opts$paths, fill, stroke, strokeWidth;
        return _regenerator().w(function (_context48) {
          while (1) switch (_context48.n) {
            case 0:
              opacity = opts.opacity, visible = opts.visible, animationEnabled = opts.animationEnabled;
              _opts$paths = _slicedToArray(opts.paths, 2), fill = _opts$paths[0], stroke = _opts$paths[1];
              strokeWidth = this.getStrokeWidth(this.properties.strokeWidth);
              stroke.setProperties({
                tag: 1 /* Stroke */,
                fill: void 0,
                lineJoin: stroke.lineCap = "round",
                pointerEvents: 1 /* None */,
                stroke: this.properties.stroke,
                strokeWidth: strokeWidth,
                strokeOpacity: this.properties.strokeOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset,
                opacity: opacity,
                visible: visible
              });
              fill.setProperties({
                tag: 0 /* Fill */,
                stroke: void 0,
                lineJoin: "round",
                pointerEvents: 1 /* None */,
                fill: this.properties.fill,
                fillOpacity: this.properties.fillOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset,
                strokeOpacity: this.properties.strokeOpacity,
                fillShadow: this.properties.shadow,
                opacity: opacity,
                visible: visible || animationEnabled,
                strokeWidth: strokeWidth
              });
              _updateClipPath(this, stroke);
              _updateClipPath(this, fill);
            case 1:
              return _context48.a(2);
          }
        }, _callee38, this);
      }));
    }
  }, {
    key: "updatePaths",
    value: function updatePaths(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee39() {
        return _regenerator().w(function (_context49) {
          while (1) switch (_context49.n) {
            case 0:
              this.updateAreaPaths(opts.paths, opts.contextData);
            case 1:
              return _context49.a(2);
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "updateAreaPaths",
    value: function updateAreaPaths(paths, contextData) {
      this.updateFillPath(paths, contextData);
      this.updateStrokePath(paths, contextData);
    }
  }, {
    key: "updateFillPath",
    value: function updateFillPath(paths, contextData) {
      var fillData = contextData.fillData;
      var _paths = _slicedToArray(paths, 1),
        fill = _paths[0];
      var fillPath = fill.path;
      fillPath.clear(true);
      var lastPoint;
      var _iterator201 = _createForOfIteratorHelper(iterate(fillData.points, iterateReverseArray(fillData.phantomPoints))),
        _step201;
      try {
        for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
          var point = _step201.value.point;
          if (point.moveTo) {
            fillPath.moveTo(point.x, point.y);
          } else if ((lastPoint == null ? void 0 : lastPoint.y) !== point.y) {
            if (lastPoint) {
              fillPath.lineTo(lastPoint.x, lastPoint.y);
            }
            fillPath.lineTo(point.x, point.y);
          }
          lastPoint = point;
        }
      } catch (err) {
        _iterator201.e(err);
      } finally {
        _iterator201.f();
      }
      if (lastPoint) {
        fillPath.lineTo(lastPoint.x, lastPoint.y);
      }
      fillPath.closePath();
      fill.checkPathDirty();
    }
  }, {
    key: "updateStrokePath",
    value: function updateStrokePath(paths, contextData) {
      var strokeData = contextData.strokeData;
      var _paths2 = _slicedToArray(paths, 2),
        stroke = _paths2[1];
      var strokePath = stroke.path;
      strokePath.clear(true);
      var _iterator202 = _createForOfIteratorHelper(strokeData.points),
        _step202;
      try {
        for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
          var point = _step202.value.point;
          if (point.moveTo) {
            strokePath.moveTo(point.x, point.y);
          } else {
            strokePath.lineTo(point.x, point.y);
          }
        }
      } catch (err) {
        _iterator202.e(err);
      } finally {
        _iterator202.f();
      }
      stroke.checkPathDirty();
    }
  }, {
    key: "updateMarkerSelection",
    value: function updateMarkerSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee40() {
        var nodeData, markerSelection;
        return _regenerator().w(function (_context50) {
          while (1) switch (_context50.n) {
            case 0:
              nodeData = opts.nodeData, markerSelection = opts.markerSelection;
              if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
              }
              return _context50.a(2, markerSelection.update(this.properties.marker.enabled ? nodeData : []));
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "updateMarkerNodes",
    value: function updateMarkerNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee41() {
        var _this178 = this;
        var markerSelection, highlighted, _this$properties3, xKey, yKey, marker, fill, stroke, strokeWidth, fillOpacity, strokeOpacity, highlightStyle, baseStyle;
        return _regenerator().w(function (_context51) {
          while (1) switch (_context51.n) {
            case 0:
              markerSelection = opts.markerSelection, highlighted = opts.isHighlight;
              _this$properties3 = this.properties, xKey = _this$properties3.xKey, yKey = _this$properties3.yKey, marker = _this$properties3.marker, fill = _this$properties3.fill, stroke = _this$properties3.stroke, strokeWidth = _this$properties3.strokeWidth, fillOpacity = _this$properties3.fillOpacity, strokeOpacity = _this$properties3.strokeOpacity, highlightStyle = _this$properties3.highlightStyle;
              baseStyle = _mergeDefaults4(highlighted && highlightStyle.item, marker.getStyle(), {
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity
              });
              markerSelection.each(function (node, datum) {
                _this178.updateMarkerStyle(node, marker, {
                  datum: datum,
                  highlighted: highlighted,
                  xKey: xKey,
                  yKey: yKey
                }, baseStyle);
              });
              if (!highlighted) {
                this.properties.marker.markClean();
              }
            case 1:
              return _context51.a(2);
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "updateLabelSelection",
    value: function updateLabelSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee42() {
        var labelData, labelSelection;
        return _regenerator().w(function (_context52) {
          while (1) switch (_context52.n) {
            case 0:
              labelData = opts.labelData, labelSelection = opts.labelSelection;
              return _context52.a(2, labelSelection.update(labelData, function (text) {
                text.tag = 3 /* Label */;
              }));
          }
        }, _callee42);
      }));
    }
  }, {
    key: "updateLabelNodes",
    value: function updateLabelNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee43() {
        var _this179 = this;
        var labelSelection, _this$properties$labe, labelEnabled, fontStyle, fontWeight, fontSize, fontFamily, color;
        return _regenerator().w(function (_context53) {
          while (1) switch (_context53.n) {
            case 0:
              labelSelection = opts.labelSelection;
              _this$properties$labe = this.properties.label, labelEnabled = _this$properties$labe.enabled, fontStyle = _this$properties$labe.fontStyle, fontWeight = _this$properties$labe.fontWeight, fontSize = _this$properties$labe.fontSize, fontFamily = _this$properties$labe.fontFamily, color = _this$properties$labe.color;
              labelSelection.each(function (text, datum) {
                var x = datum.x,
                  y = datum.y,
                  label = datum.label;
                if (label && labelEnabled && _this179.visible) {
                  text.fontStyle = fontStyle;
                  text.fontWeight = fontWeight;
                  text.fontSize = fontSize;
                  text.fontFamily = fontFamily;
                  text.textAlign = label.textAlign;
                  text.textBaseline = label.textBaseline;
                  text.text = label.text;
                  text.x = x;
                  text.y = y - 10;
                  text.fill = color;
                  text.visible = true;
                } else {
                  text.visible = false;
                }
              });
            case 1:
              return _context53.a(2);
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var seriesId = this.id,
        axes = this.axes,
        dataModel = this.dataModel;
      var _this$properties4 = this.properties,
        xKey = _this$properties4.xKey,
        xName = _this$properties4.xName,
        yName = _this$properties4.yName,
        tooltip = _this$properties4.tooltip,
        marker = _this$properties4.marker;
      var yKey = nodeDatum.yKey,
        xValue = nodeDatum.xValue,
        yValue = nodeDatum.yValue,
        datum = nodeDatum.datum,
        itemId = nodeDatum.itemId;
      var xAxis = axes["x" /* X */];
      var yAxis = axes["y" /* Y */];
      if (!this.properties.isValid() || !(xAxis && yAxis && _isFiniteNumber(yValue)) || !dataModel) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var xString = xAxis.formatDatum(xValue);
      var yString = yAxis.formatDatum(yValue);
      var title = _sanitizeHtml(yName);
      var content = _sanitizeHtml(xString + ": " + yString);
      var baseStyle = _mergeDefaults4({
        fill: this.properties.fill
      }, marker.getStyle(), {
        stroke: this.properties.stroke,
        strokeWidth: this.properties.strokeWidth
      });
      var _this$getMarkerStyle = this.getMarkerStyle(marker, {
          datum: nodeDatum,
          xKey: xKey,
          yKey: yKey,
          highlighted: false
        }, baseStyle),
        color = _this$getMarkerStyle.fill;
      return tooltip.toTooltipHtml({
        title: title,
        content: content,
        backgroundColor: color
      }, {
        datum: datum,
        itemId: itemId,
        xKey: xKey,
        xName: xName,
        yKey: yKey,
        yName: yName,
        color: color,
        title: title,
        seriesId: seriesId
      });
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b, _c, _d;
      if (!((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid() || legendType !== "category") {
        return [];
      }
      var _this$properties5 = this.properties,
        yKey = _this$properties5.yKey,
        yName = _this$properties5.yName,
        fill = _this$properties5.fill,
        stroke = _this$properties5.stroke,
        fillOpacity = _this$properties5.fillOpacity,
        strokeOpacity = _this$properties5.strokeOpacity,
        strokeWidth = _this$properties5.strokeWidth,
        lineDash = _this$properties5.lineDash,
        marker = _this$properties5.marker,
        visible = _this$properties5.visible;
      var useAreaFill = !marker.enabled || marker.fill === void 0;
      return [{
        legendType: legendType,
        id: this.id,
        itemId: yKey,
        seriesId: this.id,
        enabled: visible,
        label: {
          text: yName != null ? yName : yKey
        },
        marker: {
          shape: marker.shape,
          fill: useAreaFill ? fill : marker.fill,
          fillOpacity: useAreaFill ? fillOpacity : marker.fillOpacity,
          stroke: (_b = marker.stroke) != null ? _b : stroke,
          strokeOpacity: (_c = marker.strokeOpacity) != null ? _c : strokeOpacity,
          strokeWidth: (_d = marker.strokeWidth) != null ? _d : 0,
          enabled: marker.enabled || strokeWidth <= 0
        },
        line: {
          stroke: stroke,
          strokeOpacity: strokeOpacity,
          strokeWidth: strokeWidth,
          lineDash: lineDash
        }
      }];
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(animationData) {
      var markerSelection = animationData.markerSelection,
        labelSelection = animationData.labelSelection,
        contextData = animationData.contextData,
        paths = animationData.paths;
      var animationManager = this.ctx.animationManager;
      this.updateAreaPaths(paths, contextData);
      _pathSwipeInAnimation.apply(void 0, [this, animationManager].concat(_toConsumableArray(paths)));
      _resetMotion([markerSelection], _resetMarkerPositionFn);
      _markerSwipeScaleInAnimation(this, animationManager, markerSelection);
      _seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
    }
  }, {
    key: "animateReadyResize",
    value: function animateReadyResize(animationData) {
      var contextData = animationData.contextData,
        paths = animationData.paths;
      this.updateAreaPaths(paths, contextData);
      _superPropGet(AreaSeries, "animateReadyResize", this, 3)([animationData]);
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(animationData) {
      var _this180 = this;
      var _a, _b;
      var animationManager = this.ctx.animationManager;
      var markerSelection = animationData.markerSelection,
        labelSelection = animationData.labelSelection,
        contextData = animationData.contextData,
        paths = animationData.paths,
        previousContextData = animationData.previousContextData;
      var _paths3 = _slicedToArray(paths, 2),
        fill = _paths3[0],
        stroke = _paths3[1];
      if (fill == null && stroke == null) return;
      _superPropGet(AreaSeries, "resetAllAnimation", this, 3)([animationData]);
      var update = function update() {
        _this180.updateAreaPaths(paths, contextData);
        _this180.updateStrokePath(paths, contextData);
      };
      var skip = function skip() {
        animationManager.skipCurrentBatch();
        update();
      };
      if (contextData == null || previousContextData == null) {
        update();
        _markerFadeInAnimation(this, animationManager, "added", markerSelection);
        _pathFadeInAnimation(this, "fill_path_properties", animationManager, "add", fill);
        _pathFadeInAnimation(this, "stroke", animationManager, "trailing", stroke);
        _seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
        return;
      }
      var fns = _prepareAreaPathAnimation(contextData, previousContextData, (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff);
      if (fns === void 0) {
        skip();
        return;
      } else if (fns.status === "no-op") {
        return;
      }
      _markerFadeInAnimation(this, animationManager, void 0, markerSelection);
      _fromToMotion(this.id, "fill_path_properties", animationManager, [fill], fns.fill.pathProperties);
      pathMotion(this.id, "fill_path_update", animationManager, [fill], fns.fill.path);
      this.updateStrokePath(paths, contextData);
      _pathFadeInAnimation(this, "stroke", animationManager, "trailing", stroke);
      _seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
    }
  }, {
    key: "isLabelEnabled",
    value: function isLabelEnabled() {
      return this.properties.label.enabled;
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Group4();
    }
  }, {
    key: "getFormattedMarkerStyle",
    value: function getFormattedMarkerStyle(datum) {
      var xKey = datum.xKey,
        yKey = datum.yKey;
      return this.getMarkerStyle(this.properties.marker, {
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        highlighted: true
      });
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(opts) {
      return _computeMarkerFocusBounds(this, opts);
    }
  }]);
  return AreaSeries;
}(_CartesianSeries7);
AreaSeries.className = "AreaSeries";
AreaSeries.type = "area";

// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesModule.ts
var AreaSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["cartesian"],
  identifier: "area",
  instanceConstructor: AreaSeries,
  stackable: true,
  defaultAxes: [{
    type: "number" /* NUMBER */,
    position: "left" /* LEFT */
  }, {
    type: "category" /* CATEGORY */,
    position: "bottom" /* BOTTOM */
  }],
  themeTemplate: {
    series: {
      __extends__: _EXTENDS_SERIES_DEFAULTS,
      nodeClickRange: "nearest",
      tooltip: {
        position: {
          type: "node"
        }
      },
      fillOpacity: 0.8,
      strokeOpacity: 1,
      strokeWidth: 0,
      lineDash: [0],
      lineDashOffset: 0,
      shadow: {
        enabled: false,
        color: _DEFAULT_SHADOW_COLOUR,
        xOffset: 3,
        yOffset: 3,
        blur: 5
      },
      marker: {
        __extends__: _EXTENDS_CARTESIAN_MARKER_DEFAULTS,
        enabled: false,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWidth: 0
      },
      label: {
        enabled: false,
        fontSize: 12,
        fontFamily: _DEFAULT_FONT_FAMILY,
        color: _DEFAULT_LABEL_COLOUR
      }
    }
  },
  paletteFactory: function paletteFactory(params) {
    var _markerPaletteFactory = _markerPaletteFactory3(params),
      marker = _markerPaletteFactory.marker;
    return {
      fill: marker.fill,
      stroke: marker.stroke,
      marker: marker
    };
  }
};

// packages/ag-charts-community/src/chart/series/cartesian/quadtreeUtil.ts
function _childrenIter(parent) {
  var _iterator203, _step203, node, _t11;
  return _regenerator().w(function (_context54) {
    while (1) switch (_context54.p = _context54.n) {
      case 0:
        _iterator203 = _createForOfIteratorHelper(parent.children);
        _context54.p = 1;
        _iterator203.s();
      case 2:
        if ((_step203 = _iterator203.n()).done) {
          _context54.n = 4;
          break;
        }
        node = _step203.value;
        _context54.n = 3;
        return node;
      case 3:
        _context54.n = 2;
        break;
      case 4:
        _context54.n = 6;
        break;
      case 5:
        _context54.p = 5;
        _t11 = _context54.v;
        _iterator203.e(_t11);
      case 6:
        _context54.p = 6;
        _iterator203.f();
        return _context54.f(6);
      case 7:
        return _context54.a(2);
    }
  }, _marked4, null, [[1, 5, 6, 7]]);
}
function _addHitTestersToQuadtree(quadtree, hitTesters) {
  var _iterator204 = _createForOfIteratorHelper(hitTesters),
    _step204;
  try {
    for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
      var node = _step204.value;
      var datum = node.datum;
      if (datum === void 0) {
        _Logger.error("undefined datum");
      } else {
        quadtree.addValue(node, datum);
      }
    }
  } catch (err) {
    _iterator204.e(err);
  } finally {
    _iterator204.f();
  }
}
function _findQuadtreeMatch(series, point) {
  var _series$contentGroup$2 = series.contentGroup.transformPoint(point.x, point.y),
    x = _series$contentGroup$2.x,
    y = _series$contentGroup$2.y;
  var _series$getQuadTree$f = series.getQuadTree().find(x, y),
    nearest = _series$getQuadTree$f.nearest,
    distanceSquared2 = _series$getQuadTree$f.distanceSquared;
  if (nearest !== void 0) {
    return {
      datum: nearest.value,
      distance: Math.sqrt(distanceSquared2)
    };
  }
  return void 0;
}

// packages/ag-charts-community/src/chart/series/cartesian/abstractBarSeries.ts
var _AbstractBarSeriesProperties = /*#__PURE__*/function (_CartesianSeriesPrope2) {
  _inherits(AbstractBarSeriesProperties, _CartesianSeriesPrope2);
  function AbstractBarSeriesProperties() {
    var _this181;
    _classCallCheck(this, AbstractBarSeriesProperties);
    _this181 = _possibleConstructorReturn(this, _getPrototypeOf(AbstractBarSeriesProperties).apply(this, arguments));
    _this181.direction = "vertical";
    return _this181;
  }
  return AbstractBarSeriesProperties;
}(_CartesianSeriesProperties);
__decorateClass([_Validate(_DIRECTION)], _AbstractBarSeriesProperties.prototype, "direction", 2);
var _AbstractBarSeries2 = /*#__PURE__*/function (_CartesianSeries2) {
  _inherits(AbstractBarSeries, _CartesianSeries2);
  function AbstractBarSeries() {
    var _this182;
    _classCallCheck(this, AbstractBarSeries);
    _this182 = _possibleConstructorReturn(this, _getPrototypeOf(AbstractBarSeries).apply(this, arguments));
    /**
     * Used to get the position of bars within each group.
     */
    _this182.groupScale = new _BandScale3();
    _this182.smallestDataInterval = void 0;
    return _this182;
  }
  _createClass(AbstractBarSeries, [{
    key: "getBandScalePadding",
    value: function getBandScalePadding() {
      return {
        inner: 0.2,
        outer: 0.1
      };
    }
  }, {
    key: "shouldFlipXY",
    value: function shouldFlipXY() {
      return !this.isVertical();
    }
  }, {
    key: "isVertical",
    value: function isVertical() {
      return this.properties.direction === "vertical";
    }
  }, {
    key: "getBarDirection",
    value: function getBarDirection() {
      return this.shouldFlipXY() ? "x" /* X */ : "y" /* Y */;
    }
  }, {
    key: "getCategoryDirection",
    value: function getCategoryDirection() {
      return this.shouldFlipXY() ? "y" /* Y */ : "x" /* X */;
    }
  }, {
    key: "getValueAxis",
    value: function getValueAxis() {
      var direction = this.getBarDirection();
      return this.axes[direction];
    }
  }, {
    key: "getCategoryAxis",
    value: function getCategoryAxis() {
      var direction = this.getCategoryDirection();
      return this.axes[direction];
    }
  }, {
    key: "updateGroupScale",
    value: function updateGroupScale(xAxis) {
      var groupScale = this.groupScale,
        smallestDataInterval = this.smallestDataInterval,
        seriesStateManager = this.ctx.seriesStateManager;
      var xScale = xAxis.scale;
      var xBandWidth = _ContinuousScale5.is(xScale) ? xScale.calcBandwidth(smallestDataInterval) : xScale.bandwidth;
      var domain = [];
      var _seriesStateManager$g = seriesStateManager.getVisiblePeerGroupIndex(this),
        groupIndex = _seriesStateManager$g.index,
        visibleGroupCount = _seriesStateManager$g.visibleGroupCount;
      for (var groupIdx = 0; groupIdx < visibleGroupCount; groupIdx++) {
        domain.push(String(groupIdx));
      }
      groupScale.domain = domain;
      groupScale.range = [0, xBandWidth != null ? xBandWidth : 0];
      if (xAxis instanceof _CategoryAxis) {
        groupScale.paddingInner = xAxis.groupPaddingInner;
      } else if (xAxis instanceof _GroupedCategoryAxis) {
        groupScale.padding = 0.1;
      } else {
        groupScale.padding = 0;
      }
      groupScale.round = groupScale.padding !== 0;
      var barWidth = groupScale.bandwidth >= 1 ?
      // Pixel-rounded value for low-volume bar charts.
      groupScale.bandwidth :
      // Handle high-volume bar charts gracefully.
      groupScale.rawBandwidth;
      return {
        barWidth: barWidth,
        groupIndex: groupIndex
      };
    }
  }, {
    key: "resolveKeyDirection",
    value: function resolveKeyDirection(direction) {
      if (this.getBarDirection() === "x" /* X */) {
        if (direction === "x" /* X */) {
          return "y" /* Y */;
        }
        return "x" /* X */;
      }
      return direction;
    }
  }, {
    key: "initQuadTree",
    value: function initQuadTree(quadtree) {
      _addHitTestersToQuadtree(quadtree, this.datumNodesIter());
    }
  }, {
    key: "pickNodeClosestDatum",
    value: function pickNodeClosestDatum(point) {
      return _findQuadtreeMatch(this, point);
    }
  }]);
  return AbstractBarSeries;
}(_CartesianSeries7);

// packages/ag-charts-community/src/chart/series/cartesian/barSeriesProperties.ts
var BarSeriesLabel = /*#__PURE__*/function (_Label) {
  _inherits(BarSeriesLabel, _Label);
  function BarSeriesLabel() {
    var _this183;
    _classCallCheck(this, BarSeriesLabel);
    _this183 = _possibleConstructorReturn(this, _getPrototypeOf(BarSeriesLabel).apply(this, arguments));
    _this183.placement = "inside";
    return _this183;
  }
  return BarSeriesLabel;
}(_Label0);
__decorateClass([_Validate(_PLACEMENT)], BarSeriesLabel.prototype, "placement", 2);
var BarSeriesProperties = /*#__PURE__*/function (_AbstractBarSeriesPro) {
  _inherits(BarSeriesProperties, _AbstractBarSeriesPro);
  function BarSeriesProperties() {
    var _this184;
    _classCallCheck(this, BarSeriesProperties);
    _this184 = _possibleConstructorReturn(this, _getPrototypeOf(BarSeriesProperties).apply(this, arguments));
    _this184.fill = "#c16068";
    _this184.fillOpacity = 1;
    _this184.stroke = "#874349";
    _this184.strokeWidth = 1;
    _this184.strokeOpacity = 1;
    _this184.lineDash = [0];
    _this184.lineDashOffset = 0;
    _this184.cornerRadius = 0;
    _this184.shadow = new _DropShadow();
    _this184.label = new BarSeriesLabel();
    _this184.tooltip = new _SeriesTooltip();
    return _this184;
  }
  return BarSeriesProperties;
}(_AbstractBarSeriesProperties);
__decorateClass([_Validate(_STRING)], BarSeriesProperties.prototype, "xKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BarSeriesProperties.prototype, "xName", 2);
__decorateClass([_Validate(_STRING)], BarSeriesProperties.prototype, "yKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BarSeriesProperties.prototype, "yName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BarSeriesProperties.prototype, "stackGroup", 2);
__decorateClass([_Validate(_NUMBER, {
  optional: true
})], BarSeriesProperties.prototype, "normalizedTo", 2);
__decorateClass([_Validate(_COLOR_STRING)], BarSeriesProperties.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO)], BarSeriesProperties.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING)], BarSeriesProperties.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], BarSeriesProperties.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO)], BarSeriesProperties.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH)], BarSeriesProperties.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], BarSeriesProperties.prototype, "lineDashOffset", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], BarSeriesProperties.prototype, "cornerRadius", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], BarSeriesProperties.prototype, "formatter", 2);
__decorateClass([_Validate(_OBJECT, {
  optional: true
})], BarSeriesProperties.prototype, "shadow", 2);
__decorateClass([_Validate(_OBJECT)], BarSeriesProperties.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], BarSeriesProperties.prototype, "tooltip", 2);

// packages/ag-charts-community/src/chart/series/cartesian/barUtil.ts
function _updateRect(_ref149) {
  var rect = _ref149.rect,
    config = _ref149.config;
  var _config$crisp = config.crisp,
    crisp = _config$crisp === void 0 ? true : _config$crisp,
    fill = config.fill,
    stroke = config.stroke,
    strokeWidth = config.strokeWidth,
    fillOpacity = config.fillOpacity,
    strokeOpacity = config.strokeOpacity,
    lineDash = config.lineDash,
    lineDashOffset = config.lineDashOffset,
    fillShadow = config.fillShadow,
    _config$cornerRadius = config.cornerRadius,
    cornerRadius = _config$cornerRadius === void 0 ? 0 : _config$cornerRadius,
    _config$topLeftCorner = config.topLeftCornerRadius,
    topLeftCornerRadius = _config$topLeftCorner === void 0 ? true : _config$topLeftCorner,
    _config$topRightCorne = config.topRightCornerRadius,
    topRightCornerRadius = _config$topRightCorne === void 0 ? true : _config$topRightCorne,
    _config$bottomRightCo = config.bottomRightCornerRadius,
    bottomRightCornerRadius = _config$bottomRightCo === void 0 ? true : _config$bottomRightCo,
    _config$bottomLeftCor = config.bottomLeftCornerRadius,
    bottomLeftCornerRadius = _config$bottomLeftCor === void 0 ? true : _config$bottomLeftCor,
    _config$visible = config.visible,
    visible = _config$visible === void 0 ? true : _config$visible;
  rect.crisp = crisp;
  rect.fill = fill;
  rect.stroke = stroke;
  rect.strokeWidth = strokeWidth;
  rect.fillOpacity = fillOpacity;
  rect.strokeOpacity = strokeOpacity;
  rect.lineDash = lineDash;
  rect.lineDashOffset = lineDashOffset;
  rect.fillShadow = fillShadow;
  rect.topLeftCornerRadius = topLeftCornerRadius ? cornerRadius : 0;
  rect.topRightCornerRadius = topRightCornerRadius ? cornerRadius : 0;
  rect.bottomRightCornerRadius = bottomRightCornerRadius ? cornerRadius : 0;
  rect.bottomLeftCornerRadius = bottomLeftCornerRadius ? cornerRadius : 0;
  rect.visible = visible;
}
function _getRectConfig(_a) {
  var _b = _a,
    datum = _b.datum,
    isHighlighted = _b.isHighlighted,
    style = _b.style,
    highlightStyle = _b.highlightStyle,
    formatter = _b.formatter,
    seriesId = _b.seriesId,
    callbackCache = _b.ctx.callbackCache,
    opts = __objRest(_b, ["datum", "isHighlighted", "style", "highlightStyle", "formatter", "seriesId", "ctx"]);
  var _a2, _b2, _c, _d, _e, _f;
  var _mergeDefaults = _mergeDefaults4(isHighlighted && highlightStyle, style),
    fill = _mergeDefaults.fill,
    fillOpacity = _mergeDefaults.fillOpacity,
    stroke = _mergeDefaults.stroke,
    strokeWidth = _mergeDefaults.strokeWidth;
  var strokeOpacity = style.strokeOpacity,
    fillShadow = style.fillShadow,
    lineDash = style.lineDash,
    lineDashOffset = style.lineDashOffset,
    _style$cornerRadius = style.cornerRadius,
    cornerRadius = _style$cornerRadius === void 0 ? 0 : _style$cornerRadius,
    _style$topLeftCornerR = style.topLeftCornerRadius,
    topLeftCornerRadius = _style$topLeftCornerR === void 0 ? true : _style$topLeftCornerR,
    _style$topRightCorner = style.topRightCornerRadius,
    topRightCornerRadius = _style$topRightCorner === void 0 ? true : _style$topRightCorner,
    _style$bottomRightCor = style.bottomRightCornerRadius,
    bottomRightCornerRadius = _style$bottomRightCor === void 0 ? true : _style$bottomRightCor,
    _style$bottomLeftCorn = style.bottomLeftCornerRadius,
    bottomLeftCornerRadius = _style$bottomLeftCorn === void 0 ? true : _style$bottomLeftCorn;
  var format2;
  if (formatter) {
    format2 = callbackCache.call(formatter, __spreadValues({
      datum: datum.datum,
      xKey: datum.xKey,
      fill: fill,
      stroke: stroke,
      strokeWidth: strokeWidth,
      cornerRadius: cornerRadius,
      highlighted: isHighlighted,
      seriesId: seriesId
    }, opts));
  }
  return {
    fill: (_a2 = format2 == null ? void 0 : format2.fill) != null ? _a2 : fill,
    stroke: (_b2 = format2 == null ? void 0 : format2.stroke) != null ? _b2 : stroke,
    strokeWidth: (_c = format2 == null ? void 0 : format2.strokeWidth) != null ? _c : strokeWidth,
    fillOpacity: (_d = format2 == null ? void 0 : format2.fillOpacity) != null ? _d : fillOpacity,
    strokeOpacity: (_e = format2 == null ? void 0 : format2.strokeOpacity) != null ? _e : strokeOpacity,
    lineDash: lineDash,
    lineDashOffset: lineDashOffset,
    fillShadow: fillShadow,
    cornerRadius: (_f = format2 == null ? void 0 : format2.cornerRadius) != null ? _f : cornerRadius,
    topLeftCornerRadius: topLeftCornerRadius,
    topRightCornerRadius: topRightCornerRadius,
    bottomRightCornerRadius: bottomRightCornerRadius,
    bottomLeftCornerRadius: bottomLeftCornerRadius
  };
}
function _checkCrisp() {
  var visibleRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _visibleRange = _slicedToArray(visibleRange, 2),
    visibleMin = _visibleRange[0],
    visibleMax = _visibleRange[1];
  var isZoomed = visibleMin !== 0 || visibleMax !== 1;
  return !isZoomed;
}
var isDatumNegative = function isDatumNegative(datum) {
  var _a;
  return _isNegative((_a = datum.yValue) != null ? _a : 0);
};
function _collapsedStartingBarPosition(isVertical, axes, mode) {
  var _getStartingValues = getStartingValues(isVertical, axes),
    startingX = _getStartingValues.startingX,
    startingY = _getStartingValues.startingY;
  var calculate = function calculate(datum, prevDatum) {
    var x = isVertical ? datum.x : startingX;
    var y = isVertical ? startingY : datum.y;
    var width = isVertical ? datum.width : 0;
    var height = isVertical ? 0 : datum.height;
    var opacity = datum.opacity;
    if (prevDatum && (isNaN(x) || isNaN(y))) {
      x = prevDatum.x;
      y = prevDatum.y;
      width = isVertical ? prevDatum.width : 0;
      height = isVertical ? 0 : prevDatum.height;
      if (isVertical && !isDatumNegative(prevDatum)) {
        y += prevDatum.height;
      } else if (!isVertical && isDatumNegative(prevDatum)) {
        x += prevDatum.width;
      }
    }
    var clipBBox;
    if (datum.clipBBox == null) {
      clipBBox = void 0;
    } else if (isDatumNegative(datum)) {
      clipBBox = isVertical ? new _BBox2(x, y - height, width, height) : new _BBox2(x - width, y, width, height);
    } else {
      clipBBox = new _BBox2(x, y, width, height);
    }
    return {
      x: x,
      y: y,
      width: width,
      height: height,
      clipBBox: clipBBox,
      opacity: opacity
    };
  };
  return {
    isVertical: isVertical,
    calculate: calculate,
    mode: mode
  };
}
function _midpointStartingBarPosition(isVertical, mode) {
  return {
    isVertical: isVertical,
    calculate: function calculate(datum) {
      return {
        x: isVertical ? datum.x : datum.x + datum.width / 2,
        y: isVertical ? datum.y + datum.height / 2 : datum.y,
        width: isVertical ? datum.width : 0,
        height: isVertical ? 0 : datum.height,
        clipBBox: datum.clipBBox,
        opacity: datum.opacity
      };
    },
    mode: mode
  };
}
function _prepareBarAnimationFunctions(initPos) {
  var isRemoved = function isRemoved(datum) {
    return datum == null || isNaN(datum.x) || isNaN(datum.y);
  };
  var fromFn = function fromFn(rect, datum, status) {
    if (status === "updated" && isRemoved(datum)) {
      status = "removed";
    } else if (status === "updated" && isRemoved(rect.previousDatum)) {
      status = "added";
    }
    var source;
    if (status === "added" && rect.previousDatum == null && initPos.mode === "fade") {
      source = __spreadProps(__spreadValues({}, _resetBarSelectionsFn(rect, datum)), {
        opacity: 0
      });
    } else if (status === "unknown" || status === "added") {
      source = initPos.calculate(datum, rect.previousDatum);
    } else {
      source = {
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
        clipBBox: rect.clipBBox,
        opacity: rect.opacity
      };
    }
    var phase = _NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
    return __spreadProps(__spreadValues({}, source), {
      phase: phase
    });
  };
  var toFn = function toFn(rect, datum, status) {
    var source;
    if (status === "removed" && rect.datum == null && initPos.mode === "fade") {
      source = __spreadProps(__spreadValues({}, _resetBarSelectionsFn(rect, datum)), {
        opacity: 0
      });
    } else if (status === "removed" || isRemoved(datum)) {
      source = initPos.calculate(datum, rect.previousDatum);
    } else {
      source = {
        x: datum.x,
        y: datum.y,
        width: datum.width,
        height: datum.height,
        clipBBox: datum.clipBBox,
        opacity: datum.opacity
      };
    }
    return source;
  };
  return {
    toFn: toFn,
    fromFn: fromFn
  };
}
function getStartingValues(isVertical, axes) {
  var axis = axes[isVertical ? "y" /* Y */ : "x" /* X */];
  var startingX = Infinity;
  var startingY = 0;
  if (!axis) {
    return {
      startingX: startingX,
      startingY: startingY
    };
  }
  if (isVertical) {
    startingY = axis.scale.convert(_ContinuousScale5.is(axis.scale) ? 0 : Math.max.apply(Math, _toConsumableArray(axis.range)));
  } else {
    startingX = axis.scale.convert(_ContinuousScale5.is(axis.scale) ? 0 : Math.min.apply(Math, _toConsumableArray(axis.range)));
  }
  return {
    startingX: startingX,
    startingY: startingY
  };
}
function _resetBarSelectionsFn(_node, _ref150) {
  var x = _ref150.x,
    y = _ref150.y,
    width = _ref150.width,
    height = _ref150.height,
    clipBBox = _ref150.clipBBox,
    opacity = _ref150.opacity;
  return {
    x: x,
    y: y,
    width: width,
    height: height,
    clipBBox: clipBBox,
    opacity: opacity
  };
}
function _computeBarFocusBounds(datum, barGroup, seriesRect) {
  if (datum === void 0) return void 0;
  var x = datum.x,
    y = datum.y,
    width = datum.width,
    height = datum.height;
  return barGroup.inverseTransformBBox(new _BBox2(x, y, width, height)).clip(seriesRect);
}

// packages/ag-charts-community/src/chart/series/cartesian/labelUtil.ts
function _updateLabelNode(textNode, label, labelDatum) {
  if (label.enabled && labelDatum) {
    var x = labelDatum.x,
      y = labelDatum.y,
      text = labelDatum.text,
      textAlign = labelDatum.textAlign,
      textBaseline = labelDatum.textBaseline;
    var fill = label.color,
      fontStyle = label.fontStyle,
      fontWeight = label.fontWeight,
      fontSize = label.fontSize,
      fontFamily = label.fontFamily;
    textNode.setProperties({
      visible: true,
      x: x,
      y: y,
      text: text,
      fill: fill,
      fontStyle: fontStyle,
      fontWeight: fontWeight,
      fontSize: fontSize,
      fontFamily: fontFamily,
      textAlign: textAlign,
      textBaseline: textBaseline
    });
  } else {
    textNode.visible = false;
  }
}
function _adjustLabelPlacement(_ref151) {
  var isPositive = _ref151.isPositive,
    isVertical = _ref151.isVertical,
    placement = _ref151.placement,
    _ref151$padding = _ref151.padding,
    padding = _ref151$padding === void 0 ? 0 : _ref151$padding,
    rect = _ref151.rect;
  var x = rect.x + rect.width / 2;
  var y = rect.y + rect.height / 2;
  var textAlign = "center";
  var textBaseline = "middle";
  switch (placement) {
    case "start":
      {
        if (isVertical) {
          y = isPositive ? rect.y + rect.height + padding : rect.y - padding;
          textBaseline = isPositive ? "top" : "bottom";
        } else {
          x = isPositive ? rect.x - padding : rect.x + rect.width + padding;
          textAlign = isPositive ? "start" : "end";
        }
        break;
      }
    case "outside":
    case "end":
      {
        if (isVertical) {
          y = isPositive ? rect.y - padding : rect.y + rect.height + padding;
          textBaseline = isPositive ? "bottom" : "top";
        } else {
          x = isPositive ? rect.x + rect.width + padding : rect.x - padding;
          textAlign = isPositive ? "start" : "end";
        }
        break;
      }
  }
  return {
    x: x,
    y: y,
    textAlign: textAlign,
    textBaseline: textBaseline
  };
}

// packages/ag-charts-community/src/chart/series/cartesian/barSeries.ts
var BarSeries = /*#__PURE__*/function (_AbstractBarSeries) {
  _inherits(BarSeries, _AbstractBarSeries);
  function BarSeries(moduleCtx) {
    var _this185;
    _classCallCheck(this, BarSeries);
    _this185 = _possibleConstructorReturn(this, _getPrototypeOf(BarSeries).call(this, {
      moduleCtx: moduleCtx,
      directionKeys: _DEFAULT_CARTESIAN_DIRECTION_KEYS,
      directionNames: _DEFAULT_CARTESIAN_DIRECTION_NAMES,
      pickModes: [0 /* EXACT_SHAPE_MATCH */],
      pathsPerSeries: 0,
      hasHighlightedLabels: true,
      datumSelectionGarbageCollection: false,
      animationAlwaysUpdateSelections: true,
      animationResetFns: {
        datum: _resetBarSelectionsFn,
        label: _resetLabelFn
      }
    }));
    _this185.properties = new BarSeriesProperties();
    return _this185;
  }
  _createClass(BarSeries, [{
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee44() {
        var _a, _b, _c, _this$seriesGrouping5, _this$seriesGrouping6, _this$seriesGrouping7, groupIndex, _this$data, data, _this$properties6, xKey, yKey, normalizedTo, animationEnabled, xScale, yScale, _this$getScaleInforma3, isContinuousX, xScaleType, yScaleType, stackGroupName, stackGroupTrailingName, extraProps, visibleProps, _yield$this$requestDa, processedData;
        return _regenerator().w(function (_context55) {
          while (1) switch (_context55.n) {
            case 0:
              if (!(!this.properties.isValid() || !this.data)) {
                _context55.n = 1;
                break;
              }
              return _context55.a(2);
            case 1:
              _this$seriesGrouping5 = this.seriesGrouping, _this$seriesGrouping6 = _this$seriesGrouping5 === void 0 ? {} : _this$seriesGrouping5, _this$seriesGrouping7 = _this$seriesGrouping6.groupIndex, groupIndex = _this$seriesGrouping7 === void 0 ? this.id : _this$seriesGrouping7, _this$data = this.data, data = _this$data === void 0 ? [] : _this$data;
              _this$properties6 = this.properties, xKey = _this$properties6.xKey, yKey = _this$properties6.yKey, normalizedTo = _this$properties6.normalizedTo;
              animationEnabled = !this.ctx.animationManager.isSkipped();
              xScale = (_a = this.getCategoryAxis()) == null ? void 0 : _a.scale;
              yScale = (_b = this.getValueAxis()) == null ? void 0 : _b.scale;
              _this$getScaleInforma3 = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
              }), isContinuousX = _this$getScaleInforma3.isContinuousX, xScaleType = _this$getScaleInforma3.xScaleType, yScaleType = _this$getScaleInforma3.yScaleType;
              stackGroupName = "bar-stack-".concat(groupIndex, "-yValues");
              stackGroupTrailingName = "".concat(stackGroupName, "-trailing");
              extraProps = [];
              if (_isFiniteNumber(normalizedTo)) {
                extraProps.push(_normaliseGroupTo([stackGroupName, stackGroupTrailingName], Math.abs(normalizedTo), "range"));
              }
              if (animationEnabled && this.processedData) {
                extraProps.push(_diff(this.processedData));
              }
              if (animationEnabled) {
                extraProps.push(_animationValidation());
              }
              visibleProps = this.visible ? {} : {
                forceValue: 0
              };
              _context55.n = 2;
              return this.requestDataModel(dataController, data, {
                props: [_keyProperty(xKey, xScaleType, {
                  id: "xValue"
                }), _valueProperty(yKey, yScaleType, __spreadValues({
                  id: "yValue-raw",
                  invalidValue: null
                }, visibleProps))].concat(_toConsumableArray(_groupAccumulativeValueProperty(yKey, "normal", "current", __spreadValues({
                  id: "yValue-end",
                  rangeId: "yValue-range",
                  invalidValue: null,
                  missingValue: 0,
                  groupId: stackGroupName,
                  separateNegative: true
                }, visibleProps), yScaleType)), _toConsumableArray(_groupAccumulativeValueProperty(yKey, "trailing", "current", __spreadValues({
                  id: "yValue-start",
                  invalidValue: null,
                  missingValue: 0,
                  groupId: stackGroupTrailingName,
                  separateNegative: true
                }, visibleProps), yScaleType)), _toConsumableArray(isContinuousX ? [_SMALLEST_KEY_INTERVAL] : []), extraProps),
                groupByKeys: true,
                groupByData: false
              });
            case 2:
              _yield$this$requestDa = _context55.v;
              processedData = _yield$this$requestDa.processedData;
              this.smallestDataInterval = (_c = processedData.reduced) == null ? void 0 : _c.smallestKeyInterval;
              this.animationState.transition("updateData");
            case 3:
              return _context55.a(2);
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      var _a;
      var processedData = this.processedData,
        dataModel = this.dataModel,
        smallestDataInterval = this.smallestDataInterval;
      if (!processedData || !dataModel || processedData.data.length === 0) return [];
      var categoryAxis = this.getCategoryAxis();
      var valueAxis = this.getValueAxis();
      var keyDef = dataModel.resolveProcessedDataDefById(this, "xValue");
      var keys = dataModel.getDomain(this, "xValue", "key", processedData);
      var yExtent = dataModel.getDomain(this, "yValue-end", "value", processedData);
      if (direction === this.getCategoryDirection()) {
        if ((keyDef == null ? void 0 : keyDef.def.type) === "key" && keyDef.def.valueType === "category") {
          return keys;
        }
        var scalePadding = _isFiniteNumber(smallestDataInterval) ? smallestDataInterval * 0.5 : 0;
        var keysExtent = (_a = _extent(keys)) != null ? _a : [NaN, NaN];
        var d0 = keysExtent[0] + -scalePadding;
        var d1 = keysExtent[1] + scalePadding;
        return _fixNumericExtent([d0, d1], categoryAxis);
      } else if (this.getValueAxis() instanceof LogAxis) {
        return _fixNumericExtent(yExtent, valueAxis);
      } else {
        var fixedYExtent = [Math.min(0, yExtent[0]), Math.max(0, yExtent[1])];
        return _fixNumericExtent(fixedYExtent, valueAxis);
      }
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee45() {
        var _this186 = this;
        var dataModel, xAxis, yAxis, xScale, yScale, _this$properties7, xKey, yKey, xName, yName, fill, stroke, strokeWidth, cornerRadius, legendItemName, label, yReversed, _this$updateGroupScal, barWidth, groupIndex, barOffset, xIndex, yRawIndex, yStartIndex, yEndIndex, yRangeIndex, animationEnabled, context, groupScale, processedData;
        return _regenerator().w(function (_context56) {
          while (1) switch (_context56.n) {
            case 0:
              dataModel = this.dataModel;
              xAxis = this.getCategoryAxis();
              yAxis = this.getValueAxis();
              if (!(!dataModel || !xAxis || !yAxis || !this.properties.isValid())) {
                _context56.n = 1;
                break;
              }
              return _context56.a(2);
            case 1:
              xScale = xAxis.scale;
              yScale = yAxis.scale;
              _this$properties7 = this.properties, xKey = _this$properties7.xKey, yKey = _this$properties7.yKey, xName = _this$properties7.xName, yName = _this$properties7.yName, fill = _this$properties7.fill, stroke = _this$properties7.stroke, strokeWidth = _this$properties7.strokeWidth, cornerRadius = _this$properties7.cornerRadius, legendItemName = _this$properties7.legendItemName, label = _this$properties7.label;
              yReversed = yAxis.isReversed();
              _this$updateGroupScal = this.updateGroupScale(xAxis), barWidth = _this$updateGroupScal.barWidth, groupIndex = _this$updateGroupScal.groupIndex;
              barOffset = _ContinuousScale5.is(xScale) ? barWidth * -0.5 : 0;
              xIndex = dataModel.resolveProcessedDataIndexById(this, "xValue");
              yRawIndex = dataModel.resolveProcessedDataIndexById(this, "yValue-raw");
              yStartIndex = dataModel.resolveProcessedDataIndexById(this, "yValue-start");
              yEndIndex = dataModel.resolveProcessedDataIndexById(this, "yValue-end");
              yRangeIndex = dataModel.resolveProcessedDataIndexById(this, "yValue-range");
              animationEnabled = !this.ctx.animationManager.isSkipped();
              context = {
                itemId: yKey,
                nodeData: [],
                labelData: [],
                scales: this.calculateScaling(),
                visible: this.visible || animationEnabled
              };
              groupScale = this.groupScale, processedData = this.processedData;
              processedData == null ? void 0 : processedData.data.forEach(function (_ref152) {
                var keys = _ref152.keys,
                  seriesDatum = _ref152.datum,
                  values = _ref152.values,
                  aggValues = _ref152.aggValues;
                values.forEach(function (value, valueIndex) {
                  var _a;
                  var xValue = keys[xIndex];
                  var x = xScale.convert(xValue);
                  var currY = +value[yEndIndex];
                  var prevY = +value[yStartIndex];
                  var yRawValue = value[yRawIndex];
                  var isPositive = yRawValue >= 0 && !Object.is(yRawValue, -0);
                  var isUpward = isPositive !== yReversed;
                  var yRange = (_a = aggValues == null ? void 0 : aggValues[yRangeIndex][isPositive ? 1 : 0]) != null ? _a : 0;
                  var barX = x + groupScale.convert(String(groupIndex)) + barOffset;
                  if (isNaN(currY)) return;
                  var y = yScale.convert(currY);
                  var bottomY = yScale.convert(prevY);
                  var barAlongX = _this186.getBarDirection() === "x" /* X */;
                  var bboxHeight = yScale.convert(yRange);
                  var bboxBottom = yScale.convert(0);
                  var rect = {
                    x: barAlongX ? Math.min(y, bottomY) : barX,
                    y: barAlongX ? barX : Math.min(y, bottomY),
                    width: barAlongX ? Math.abs(bottomY - y) : barWidth,
                    height: barAlongX ? barWidth : Math.abs(bottomY - y)
                  };
                  var clipBBox = new _BBox2(rect.x, rect.y, rect.width, rect.height);
                  var barRect = {
                    x: barAlongX ? Math.min(bboxBottom, bboxHeight) : barX,
                    y: barAlongX ? barX : Math.min(bboxBottom, bboxHeight),
                    width: barAlongX ? Math.abs(bboxBottom - bboxHeight) : barWidth,
                    height: barAlongX ? barWidth : Math.abs(bboxBottom - bboxHeight),
                    clipBBox: clipBBox
                  };
                  var labelFontStyle = label.fontStyle,
                    labelFontWeight = label.fontWeight,
                    labelFontSize = label.fontSize,
                    labelFontFamily = label.fontFamily,
                    labelColor = label.color,
                    placement = label.placement;
                  var labelText = _this186.getLabelText(_this186.properties.label, {
                    datum: seriesDatum[valueIndex],
                    value: yRawValue,
                    xKey: xKey,
                    yKey: yKey,
                    xName: xName,
                    yName: yName,
                    legendItemName: legendItemName
                  }, function (v) {
                    return _isFiniteNumber(v) ? v.toFixed(2) : String(v);
                  });
                  var labelDatum = labelText ? __spreadValues({
                    text: labelText,
                    fill: labelColor,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily
                  }, _adjustLabelPlacement({
                    isPositive: isPositive,
                    isVertical: !barAlongX,
                    placement: placement,
                    rect: rect
                  })) : void 0;
                  var lengthRatioMultiplier = _this186.shouldFlipXY() ? rect.height : rect.width;
                  var nodeData = {
                    series: _this186,
                    itemId: yKey,
                    datum: seriesDatum[valueIndex],
                    valueIndex: valueIndex,
                    cumulativeValue: currY,
                    xValue: xValue,
                    yValue: yRawValue,
                    yKey: yKey,
                    xKey: xKey,
                    capDefaults: {
                      lengthRatioMultiplier: lengthRatioMultiplier,
                      lengthMax: lengthRatioMultiplier
                    },
                    x: barRect.x,
                    y: barRect.y,
                    width: barRect.width,
                    height: barRect.height,
                    midPoint: {
                      x: rect.x + rect.width / 2,
                      y: rect.y + rect.height / 2
                    },
                    fill: fill,
                    stroke: stroke,
                    opacity: 1,
                    strokeWidth: strokeWidth,
                    cornerRadius: cornerRadius,
                    topLeftCornerRadius: barAlongX !== isUpward,
                    topRightCornerRadius: isUpward,
                    bottomRightCornerRadius: barAlongX === isUpward,
                    bottomLeftCornerRadius: !isUpward,
                    clipBBox: clipBBox,
                    label: labelDatum,
                    missing: yRawValue == null
                  };
                  context.nodeData.push(nodeData);
                  context.labelData.push(nodeData);
                });
              });
              return _context56.a(2, context);
          }
        }, _callee45, this);
      }));
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Rect();
    }
  }, {
    key: "updateDatumSelection",
    value: function updateDatumSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee46() {
        return _regenerator().w(function (_context57) {
          while (1) switch (_context57.n) {
            case 0:
              return _context57.a(2, opts.datumSelection.update(opts.nodeData, function (rect) {
                rect.tag = 0 /* Bar */;
              }, function (datum) {
                return _createDatumId(datum.xValue, datum.valueIndex);
              }));
          }
        }, _callee46);
      }));
    }
  }, {
    key: "updateDatumNodes",
    value: function updateDatumNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee47() {
        var _this187 = this;
        var _this$properties8, yKey, stackGroup, fill, fillOpacity, stroke, strokeWidth, strokeOpacity, lineDash, lineDashOffset, formatter, shadow, itemHighlightStyle, xAxis, crisp, categoryAlongX;
        return _regenerator().w(function (_context58) {
          while (1) switch (_context58.n) {
            case 0:
              if (this.properties.isValid()) {
                _context58.n = 1;
                break;
              }
              return _context58.a(2);
            case 1:
              _this$properties8 = this.properties, yKey = _this$properties8.yKey, stackGroup = _this$properties8.stackGroup, fill = _this$properties8.fill, fillOpacity = _this$properties8.fillOpacity, stroke = _this$properties8.stroke, strokeWidth = _this$properties8.strokeWidth, strokeOpacity = _this$properties8.strokeOpacity, lineDash = _this$properties8.lineDash, lineDashOffset = _this$properties8.lineDashOffset, formatter = _this$properties8.formatter, shadow = _this$properties8.shadow, itemHighlightStyle = _this$properties8.highlightStyle.item;
              xAxis = this.axes["x" /* X */];
              crisp = _checkCrisp(xAxis == null ? void 0 : xAxis.visibleRange);
              categoryAlongX = this.getCategoryDirection() === "x";
              opts.datumSelection.each(function (rect, datum) {
                var _a, _b, _c, _d;
                var style = {
                  fill: fill,
                  stroke: stroke,
                  fillOpacity: fillOpacity,
                  strokeOpacity: strokeOpacity,
                  lineDash: lineDash,
                  lineDashOffset: lineDashOffset,
                  fillShadow: shadow,
                  strokeWidth: _this187.getStrokeWidth(strokeWidth),
                  cornerRadius: datum.cornerRadius,
                  topLeftCornerRadius: datum.topLeftCornerRadius,
                  topRightCornerRadius: datum.topRightCornerRadius,
                  bottomRightCornerRadius: datum.bottomRightCornerRadius,
                  bottomLeftCornerRadius: datum.bottomLeftCornerRadius
                };
                var visible = categoryAlongX ? ((_b = (_a = datum.clipBBox) == null ? void 0 : _a.width) != null ? _b : datum.width) > 0 : ((_d = (_c = datum.clipBBox) == null ? void 0 : _c.height) != null ? _d : datum.height) > 0;
                var config = _getRectConfig({
                  datum: datum,
                  ctx: _this187.ctx,
                  seriesId: _this187.id,
                  isHighlighted: opts.isHighlight,
                  highlightStyle: itemHighlightStyle,
                  yKey: yKey,
                  style: style,
                  formatter: formatter,
                  stackGroup: stackGroup
                });
                config.crisp = crisp;
                config.visible = visible;
                _updateRect({
                  rect: rect,
                  config: config
                });
              });
            case 2:
              return _context58.a(2);
          }
        }, _callee47, this);
      }));
    }
  }, {
    key: "updateLabelSelection",
    value: function updateLabelSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee48() {
        var data;
        return _regenerator().w(function (_context59) {
          while (1) switch (_context59.n) {
            case 0:
              data = this.isLabelEnabled() ? opts.labelData : [];
              return _context59.a(2, opts.labelSelection.update(data, function (text) {
                text.tag = 1 /* Label */;
                text.pointerEvents = 1 /* None */;
              }));
          }
        }, _callee48, this);
      }));
    }
  }, {
    key: "updateLabelNodes",
    value: function updateLabelNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee49() {
        var _this188 = this;
        return _regenerator().w(function (_context60) {
          while (1) switch (_context60.n) {
            case 0:
              opts.labelSelection.each(function (textNode, datum) {
                _updateLabelNode(textNode, _this188.properties.label, datum.label);
              });
            case 1:
              return _context60.a(2);
          }
        }, _callee49);
      }));
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var _a;
      var seriesId = this.id,
        processedData = this.processedData,
        callbackCache = this.ctx.callbackCache;
      var xAxis = this.getCategoryAxis();
      var yAxis = this.getValueAxis();
      if (!processedData || !this.properties.isValid() || !xAxis || !yAxis) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var _this$properties9 = this.properties,
        xKey = _this$properties9.xKey,
        yKey = _this$properties9.yKey,
        xName = _this$properties9.xName,
        yName = _this$properties9.yName,
        fill = _this$properties9.fill,
        stroke = _this$properties9.stroke,
        strokeWidth = _this$properties9.strokeWidth,
        tooltip = _this$properties9.tooltip,
        formatter = _this$properties9.formatter,
        stackGroup = _this$properties9.stackGroup,
        legendItemName = _this$properties9.legendItemName;
      var xValue = nodeDatum.xValue,
        yValue = nodeDatum.yValue,
        datum = nodeDatum.datum,
        itemId = nodeDatum.itemId;
      var xString = xAxis.formatDatum(xValue);
      var yString = yAxis.formatDatum(yValue);
      var title = _sanitizeHtml(yName);
      var content = _sanitizeHtml(xString + ": " + yString);
      var format2;
      if (formatter) {
        format2 = callbackCache.call(formatter, {
          seriesId: seriesId,
          datum: datum,
          xKey: xKey,
          yKey: yKey,
          stackGroup: stackGroup,
          fill: fill,
          stroke: stroke,
          strokeWidth: this.getStrokeWidth(strokeWidth),
          highlighted: false
        });
      }
      var color = (_a = format2 == null ? void 0 : format2.fill) != null ? _a : fill;
      return tooltip.toTooltipHtml({
        title: title,
        content: content,
        backgroundColor: color
      }, __spreadValues({
        seriesId: seriesId,
        itemId: itemId,
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        xName: xName,
        yName: yName,
        stackGroup: stackGroup,
        title: title,
        color: color,
        legendItemName: legendItemName
      }, this.getModuleTooltipParams()));
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b;
      var showInLegend = this.properties.showInLegend;
      if (legendType !== "category" || !((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid() || !showInLegend) {
        return [];
      }
      var _this$properties0 = this.properties,
        yKey = _this$properties0.yKey,
        yName = _this$properties0.yName,
        fill = _this$properties0.fill,
        stroke = _this$properties0.stroke,
        strokeWidth = _this$properties0.strokeWidth,
        fillOpacity = _this$properties0.fillOpacity,
        strokeOpacity = _this$properties0.strokeOpacity,
        legendItemName = _this$properties0.legendItemName,
        visible = _this$properties0.visible;
      return [{
        legendType: "category",
        id: this.id,
        itemId: yKey,
        seriesId: this.id,
        enabled: visible,
        label: {
          text: (_b = legendItemName != null ? legendItemName : yName) != null ? _b : yKey
        },
        marker: {
          fill: fill,
          fillOpacity: fillOpacity,
          stroke: stroke,
          strokeWidth: strokeWidth,
          strokeOpacity: strokeOpacity
        },
        legendItemName: legendItemName
      }];
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(_ref153) {
      var datumSelection = _ref153.datumSelection,
        labelSelection = _ref153.labelSelection,
        annotationSelections = _ref153.annotationSelections;
      var fns = _prepareBarAnimationFunctions(_collapsedStartingBarPosition(this.isVertical(), this.axes, "normal"));
      _fromToMotion(this.id, "nodes", this.ctx.animationManager, [datumSelection], fns);
      _seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
      _seriesLabelFadeInAnimation.apply(void 0, [this, "annotations", this.ctx.animationManager].concat(_toConsumableArray(annotationSelections)));
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(data) {
      var _a, _b, _c;
      var datumSelection = data.datumSelection,
        labelSelection = data.labelSelection,
        annotationSelections = data.annotationSelections,
        previousContextData = data.previousContextData;
      this.ctx.animationManager.stopByAnimationGroupId(this.id);
      var dataDiff = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff;
      var mode = previousContextData == null ? "fade" : "normal";
      var fns = _prepareBarAnimationFunctions(_collapsedStartingBarPosition(this.isVertical(), this.axes, mode));
      _fromToMotion(this.id, "nodes", this.ctx.animationManager, [datumSelection], fns, function (_, datum) {
        return _createDatumId(datum.xValue, datum.valueIndex);
      }, dataDiff);
      var hasMotion = (_c = dataDiff == null ? void 0 : dataDiff.changed) != null ? _c : true;
      if (hasMotion) {
        _seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
        _seriesLabelFadeInAnimation.apply(void 0, [this, "annotations", this.ctx.animationManager].concat(_toConsumableArray(annotationSelections)));
      }
    }
  }, {
    key: "isLabelEnabled",
    value: function isLabelEnabled() {
      return this.properties.label.enabled;
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(_ref154) {
      var datumIndex = _ref154.datumIndex,
        seriesRect = _ref154.seriesRect;
      var _a;
      var datumBox = (_a = this.contextNodeData) == null ? void 0 : _a.nodeData[datumIndex].clipBBox;
      return _computeBarFocusBounds(datumBox, this.contentGroup, seriesRect);
    }
  }]);
  return BarSeries;
}(_AbstractBarSeries2);
BarSeries.className = "BarSeries";
BarSeries.type = "bar";

// packages/ag-charts-community/src/chart/series/cartesian/barSeriesModule.ts
var BarSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["cartesian"],
  identifier: "bar",
  instanceConstructor: BarSeries,
  stackable: true,
  groupable: true,
  defaultAxes: [{
    type: "number" /* NUMBER */,
    position: "left" /* LEFT */
  }, {
    type: "category" /* CATEGORY */,
    position: "bottom" /* BOTTOM */
  }],
  swapDefaultAxesCondition: function swapDefaultAxesCondition(series) {
    return (series == null ? void 0 : series.direction) === "horizontal";
  },
  themeTemplate: {
    series: {
      __extends__: _EXTENDS_SERIES_DEFAULTS,
      direction: "vertical",
      fillOpacity: 1,
      strokeWidth: 0,
      lineDash: [0],
      lineDashOffset: 0,
      label: {
        enabled: false,
        fontWeight: "normal" /* NORMAL */,
        fontSize: 12,
        fontFamily: _DEFAULT_FONT_FAMILY,
        color: _DEFAULT_INSIDE_SERIES_LABEL_COLOUR,
        placement: "inside"
      },
      shadow: {
        enabled: false,
        color: _DEFAULT_SHADOW_COLOUR,
        xOffset: 3,
        yOffset: 3,
        blur: 5
      }
    }
  },
  enterpriseThemeTemplate: {
    series: {
      errorBar: {
        cap: {
          lengthRatio: 0.3
        }
      }
    }
  },
  paletteFactory: _singleSeriesPaletteFactory
};

// packages/ag-charts-community/src/scale/colorScale.ts
var convertColorStringToOklcha = function convertColorStringToOklcha(v) {
  var color = _Color2.fromString(v);
  var _Color$RGBtoOKLCH = _Color2.RGBtoOKLCH(color.r, color.g, color.b),
    _Color$RGBtoOKLCH2 = _slicedToArray(_Color$RGBtoOKLCH, 3),
    l = _Color$RGBtoOKLCH2[0],
    c = _Color$RGBtoOKLCH2[1],
    h = _Color$RGBtoOKLCH2[2];
  return {
    l: l,
    c: c,
    h: h,
    a: color.a
  };
};
var interpolateOklch = function interpolateOklch(x, y, d) {
  d = _clamp(0, d, 1);
  var h;
  var c;
  if (Number.isNaN(x.h) && Number.isNaN(y.h)) {
    h = 0;
    c = 0;
  } else if (Number.isNaN(x.h)) {
    h = y.h;
    c = y.c;
  } else if (Number.isNaN(y.h)) {
    h = x.h;
    c = x.c;
  } else {
    var xH = x.h;
    var yH = y.h;
    var deltaH = y.h - x.h;
    if (deltaH > 180) {
      yH -= 360;
    } else if (deltaH < -180) {
      yH += 360;
    }
    h = xH * (1 - d) + yH * d;
    c = x.c * (1 - d) + y.c * d;
  }
  var l = x.l * (1 - d) + y.l * d;
  var a = x.a * (1 - d) + y.a * d;
  return _Color2.fromOKLCH(l, c, h, a);
};
var _ColorScale = /*#__PURE__*/function () {
  function ColorScale() {
    _classCallCheck(this, ColorScale);
    this.type = "color";
    this.invalid = true;
    this.domain = [0, 1];
    this.range = ["red", "blue"];
    this.parsedRange = this.range.map(convertColorStringToOklcha);
  }
  _createClass(ColorScale, [{
    key: "update",
    value: function update() {
      var domain = this.domain,
        range3 = this.range;
      if (domain.length < 2) {
        _Logger.warnOnce("`colorDomain` should have at least 2 values.");
        if (domain.length === 0) {
          domain.push(0, 1);
        } else if (domain.length === 1) {
          domain.push(domain[0] + 1);
        }
      }
      for (var i = 1; i < domain.length; i++) {
        var a = domain[i - 1];
        var b = domain[i];
        if (a >= b) {
          _Logger.warnOnce("`colorDomain` values should be supplied in ascending order.");
          domain.sort(function (a2, b2) {
            return a2 - b2;
          });
          break;
        }
      }
      if (range3.length < domain.length) {
        for (var _i32 = range3.length; _i32 < domain.length; _i32++) {
          range3.push(range3.length > 0 ? range3[0] : "black");
        }
      }
      this.parsedRange = this.range.map(convertColorStringToOklcha);
    }
  }, {
    key: "convert",
    value: function convert(x) {
      this.refresh();
      var domain = this.domain,
        range3 = this.range,
        parsedRange = this.parsedRange;
      var d0 = domain[0];
      var d1 = domain.at(-1);
      var r0 = range3[0];
      var r1 = range3[range3.length - 1];
      if (x <= d0) {
        return r0;
      }
      if (x >= d1) {
        return r1;
      }
      var index;
      var q;
      if (domain.length === 2) {
        var t = (x - d0) / (d1 - d0);
        var step = 1 / (range3.length - 1);
        index = range3.length <= 2 ? 0 : Math.min(Math.floor(t * (range3.length - 1)), range3.length - 2);
        q = (t - index * step) / step;
      } else {
        for (index = 0; index < domain.length - 2; index++) {
          if (x < domain[index + 1]) {
            break;
          }
        }
        var a = domain[index];
        var b = domain[index + 1];
        q = (x - a) / (b - a);
      }
      var c0 = parsedRange[index];
      var c1 = parsedRange[index + 1];
      return interpolateOklch(c0, c1, q).toRgbaString();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (!this.invalid) return;
      this.invalid = false;
      this.update();
      if (this.invalid) {
        _Logger.warnOnce("Expected update to not invalidate scale");
      }
    }
  }]);
  return ColorScale;
}();
__decorateClass([_Invalidating], _ColorScale.prototype, "domain", 2);
__decorateClass([_Invalidating], _ColorScale.prototype, "range", 2);

// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeriesProperties.ts
var BubbleSeriesMarker = /*#__PURE__*/function (_SeriesMarker) {
  _inherits(BubbleSeriesMarker, _SeriesMarker);
  function BubbleSeriesMarker() {
    var _this189;
    _classCallCheck(this, BubbleSeriesMarker);
    _this189 = _possibleConstructorReturn(this, _getPrototypeOf(BubbleSeriesMarker).apply(this, arguments));
    _this189.maxSize = 30;
    return _this189;
  }
  return BubbleSeriesMarker;
}(_SeriesMarker2);
__decorateClass([_Validate(_POSITIVE_NUMBER), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], BubbleSeriesMarker.prototype, "maxSize", 2);
__decorateClass([_Validate(_NUMBER_ARRAY, {
  optional: true
}), _SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], BubbleSeriesMarker.prototype, "domain", 2);
var BubbleSeriesLabel = /*#__PURE__*/function (_Label2) {
  _inherits(BubbleSeriesLabel, _Label2);
  function BubbleSeriesLabel() {
    var _this190;
    _classCallCheck(this, BubbleSeriesLabel);
    _this190 = _possibleConstructorReturn(this, _getPrototypeOf(BubbleSeriesLabel).apply(this, arguments));
    _this190.placement = "top";
    return _this190;
  }
  return BubbleSeriesLabel;
}(_Label0);
__decorateClass([_Validate(_LABEL_PLACEMENT)], BubbleSeriesLabel.prototype, "placement", 2);
var BubbleSeriesProperties = /*#__PURE__*/function (_CartesianSeriesPrope3) {
  _inherits(BubbleSeriesProperties, _CartesianSeriesPrope3);
  function BubbleSeriesProperties() {
    var _this191;
    _classCallCheck(this, BubbleSeriesProperties);
    _this191 = _possibleConstructorReturn(this, _getPrototypeOf(BubbleSeriesProperties).apply(this, arguments));
    _this191.colorRange = ["#ffff00", "#00ff00", "#0000ff"];
    _this191.marker = new BubbleSeriesMarker();
    _this191.label = new BubbleSeriesLabel();
    _this191.tooltip = new _SeriesTooltip();
    return _this191;
  }
  return BubbleSeriesProperties;
}(_CartesianSeriesProperties);
__decorateClass([_Validate(_STRING)], BubbleSeriesProperties.prototype, "xKey", 2);
__decorateClass([_Validate(_STRING)], BubbleSeriesProperties.prototype, "yKey", 2);
__decorateClass([_Validate(_STRING)], BubbleSeriesProperties.prototype, "sizeKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "labelKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "colorKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "xName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "yName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "sizeName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "labelName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "colorName", 2);
__decorateClass([_Validate(_NUMBER_ARRAY, {
  optional: true
})], BubbleSeriesProperties.prototype, "colorDomain", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], BubbleSeriesProperties.prototype, "colorRange", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], BubbleSeriesProperties.prototype, "title", 2);
__decorateClass([_Validate(_OBJECT)], BubbleSeriesProperties.prototype, "marker", 2);
__decorateClass([_Validate(_OBJECT)], BubbleSeriesProperties.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], BubbleSeriesProperties.prototype, "tooltip", 2);

// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeries.ts
var BubbleSeriesNodeEvent = /*#__PURE__*/function (_CartesianSeriesNodeE) {
  _inherits(BubbleSeriesNodeEvent, _CartesianSeriesNodeE);
  function BubbleSeriesNodeEvent(type, nativeEvent, datum, series) {
    var _this192;
    _classCallCheck(this, BubbleSeriesNodeEvent);
    _this192 = _possibleConstructorReturn(this, _getPrototypeOf(BubbleSeriesNodeEvent).call(this, type, nativeEvent, datum, series));
    _this192.sizeKey = series.properties.sizeKey;
    return _this192;
  }
  return BubbleSeriesNodeEvent;
}(_CartesianSeriesNodeEvent);
var BubbleSeries = /*#__PURE__*/function (_CartesianSeries3) {
  _inherits(BubbleSeries, _CartesianSeries3);
  function BubbleSeries(moduleCtx) {
    var _this193;
    _classCallCheck(this, BubbleSeries);
    _this193 = _possibleConstructorReturn(this, _getPrototypeOf(BubbleSeries).call(this, {
      moduleCtx: moduleCtx,
      directionKeys: _DEFAULT_CARTESIAN_DIRECTION_KEYS,
      directionNames: _DEFAULT_CARTESIAN_DIRECTION_NAMES,
      pickModes: [2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */, 3 /* NEAREST_NODE */, 0 /* EXACT_SHAPE_MATCH */],
      pathsPerSeries: 0,
      hasMarkers: true,
      markerSelectionGarbageCollection: false,
      animationResetFns: {
        label: _resetLabelFn,
        marker: _resetMarkerFn
      }
    }));
    _this193.NodeEvent = BubbleSeriesNodeEvent;
    _this193.properties = new BubbleSeriesProperties();
    _this193.sizeScale = new _LinearScale();
    _this193.colorScale = new _ColorScale();
    return _this193;
  }
  _createClass(BubbleSeries, [{
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee50() {
        var _a, _b, _c, _d, xScale, yScale, _this$getScaleInforma4, xScaleType, yScaleType, colorScaleType, sizeScaleType, _this$properties1, xKey, yKey, sizeKey, labelKey, colorDomain, colorRange, colorKey, marker, _yield$this$requestDa2, dataModel, processedData, sizeKeyIdx, processedSize, colorKeyIdx;
        return _regenerator().w(function (_context61) {
          while (1) switch (_context61.n) {
            case 0:
              if (!(!this.properties.isValid() || this.data == null || !this.visible)) {
                _context61.n = 1;
                break;
              }
              return _context61.a(2);
            case 1:
              xScale = (_a = this.axes["x" /* X */]) == null ? void 0 : _a.scale;
              yScale = (_b = this.axes["y" /* Y */]) == null ? void 0 : _b.scale;
              _this$getScaleInforma4 = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
              }), xScaleType = _this$getScaleInforma4.xScaleType, yScaleType = _this$getScaleInforma4.yScaleType;
              colorScaleType = this.colorScale.type;
              sizeScaleType = this.sizeScale.type;
              _this$properties1 = this.properties, xKey = _this$properties1.xKey, yKey = _this$properties1.yKey, sizeKey = _this$properties1.sizeKey, labelKey = _this$properties1.labelKey, colorDomain = _this$properties1.colorDomain, colorRange = _this$properties1.colorRange, colorKey = _this$properties1.colorKey, marker = _this$properties1.marker;
              _context61.n = 2;
              return this.requestDataModel(dataController, this.data, {
                props: [_keyProperty(xKey, xScaleType, {
                  id: "xKey-raw"
                }), _keyProperty(yKey, yScaleType, {
                  id: "yKey-raw"
                })].concat(_toConsumableArray(labelKey ? [_keyProperty(labelKey, "band", {
                  id: "labelKey-raw"
                })] : []), [_valueProperty(xKey, xScaleType, {
                  id: "xValue"
                }), _valueProperty(yKey, yScaleType, {
                  id: "yValue"
                }), _valueProperty(sizeKey, sizeScaleType, {
                  id: "sizeValue"
                })], _toConsumableArray(colorKey ? [_valueProperty(colorKey, colorScaleType, {
                  id: "colorValue"
                })] : []), _toConsumableArray(labelKey ? [_valueProperty(labelKey, "band", {
                  id: "labelValue"
                })] : []))
              });
            case 2:
              _yield$this$requestDa2 = _context61.v;
              dataModel = _yield$this$requestDa2.dataModel;
              processedData = _yield$this$requestDa2.processedData;
              sizeKeyIdx = dataModel.resolveProcessedDataIndexById(this, "sizeValue");
              processedSize = (_c = processedData.domain.values[sizeKeyIdx]) != null ? _c : [];
              this.sizeScale.domain = marker.domain ? marker.domain : processedSize;
              if (colorKey) {
                colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
                this.colorScale.domain = (_d = colorDomain != null ? colorDomain : processedData.domain.values[colorKeyIdx]) != null ? _d : [];
                this.colorScale.range = colorRange;
                this.colorScale.update();
              }
              this.animationState.transition("updateData");
            case 3:
              return _context61.a(2);
          }
        }, _callee50, this);
      }));
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      var dataModel = this.dataModel,
        processedData = this.processedData;
      if (!processedData || !dataModel) return [];
      var id = direction === "x" /* X */ ? "xValue" : "yValue";
      var dataDef = dataModel.resolveProcessedDataDefById(this, id);
      var domain = dataModel.getDomain(this, id, "value", processedData);
      if ((dataDef == null ? void 0 : dataDef.def.type) === "value" && (dataDef == null ? void 0 : dataDef.def.valueType) === "category") {
        return domain;
      }
      var axis = this.axes[direction];
      return _fixNumericExtent(_extent(domain), axis);
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee51() {
        var _a, _b, _c, axes, dataModel, processedData, colorScale, sizeScale, _this$properties10, xKey, yKey, sizeKey, labelKey, xName, yName, sizeName, labelName, label, colorKey, marker, visible, markerShape, placement, xAxis, yAxis, xDataIdx, yDataIdx, sizeDataIdx, colorDataIdx, labelDataIdx, xScale, yScale, xOffset, yOffset, nodeData, font, _iterator205, _step205, _step205$value, values, datum, xDatum, yDatum, x, y, labelText, size, markerSize, fill;
        return _regenerator().w(function (_context62) {
          while (1) switch (_context62.n) {
            case 0:
              axes = this.axes, dataModel = this.dataModel, processedData = this.processedData, colorScale = this.colorScale, sizeScale = this.sizeScale;
              _this$properties10 = this.properties, xKey = _this$properties10.xKey, yKey = _this$properties10.yKey, sizeKey = _this$properties10.sizeKey, labelKey = _this$properties10.labelKey, xName = _this$properties10.xName, yName = _this$properties10.yName, sizeName = _this$properties10.sizeName, labelName = _this$properties10.labelName, label = _this$properties10.label, colorKey = _this$properties10.colorKey, marker = _this$properties10.marker, visible = _this$properties10.visible;
              markerShape = _getMarker(marker.shape);
              placement = label.placement;
              xAxis = axes["x" /* X */];
              yAxis = axes["y" /* Y */];
              if (dataModel && processedData && visible && xAxis && yAxis) {
                _context62.n = 1;
                break;
              }
              return _context62.a(2);
            case 1:
              xDataIdx = dataModel.resolveProcessedDataIndexById(this, "xValue");
              yDataIdx = dataModel.resolveProcessedDataIndexById(this, "yValue");
              sizeDataIdx = sizeKey ? dataModel.resolveProcessedDataIndexById(this, "sizeValue") : -1;
              colorDataIdx = colorKey ? dataModel.resolveProcessedDataIndexById(this, "colorValue") : -1;
              labelDataIdx = labelKey ? dataModel.resolveProcessedDataIndexById(this, "labelValue") : -1;
              xScale = xAxis.scale;
              yScale = yAxis.scale;
              xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
              yOffset = ((_b = yScale.bandwidth) != null ? _b : 0) / 2;
              nodeData = [];
              sizeScale.range = [marker.size, marker.maxSize];
              font = label.getFont();
              _iterator205 = _createForOfIteratorHelper((_c = processedData.data) != null ? _c : []);
              try {
                for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
                  _step205$value = _step205.value, values = _step205$value.values, datum = _step205$value.datum;
                  xDatum = values[xDataIdx];
                  yDatum = values[yDataIdx];
                  x = xScale.convert(xDatum) + xOffset;
                  y = yScale.convert(yDatum) + yOffset;
                  labelText = this.getLabelText(label, {
                    value: labelKey ? values[labelDataIdx] : yDatum,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    sizeKey: sizeKey,
                    labelKey: labelKey,
                    xName: xName,
                    yName: yName,
                    sizeName: sizeName,
                    labelName: labelName
                  });
                  size = _Text2.getTextSize(String(labelText), font);
                  markerSize = sizeKey ? sizeScale.convert(values[sizeDataIdx]) : marker.size;
                  fill = colorKey ? colorScale.convert(values[colorDataIdx]) : void 0;
                  nodeData.push({
                    series: this,
                    itemId: yKey,
                    yKey: yKey,
                    xKey: xKey,
                    datum: datum,
                    xValue: xDatum,
                    yValue: yDatum,
                    sizeValue: values[sizeDataIdx],
                    point: {
                      x: x,
                      y: y,
                      size: markerSize
                    },
                    midPoint: {
                      x: x,
                      y: y
                    },
                    fill: fill,
                    label: __spreadValues({
                      text: labelText
                    }, size),
                    marker: markerShape,
                    placement: placement
                  });
                }
              } catch (err) {
                _iterator205.e(err);
              } finally {
                _iterator205.f();
              }
              return _context62.a(2, {
                itemId: yKey,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                visible: this.visible
              });
          }
        }, _callee51, this);
      }));
    }
  }, {
    key: "isPathOrSelectionDirty",
    value: function isPathOrSelectionDirty() {
      return this.properties.marker.isDirty();
    }
  }, {
    key: "getLabelData",
    value: function getLabelData() {
      var _a, _b;
      return (_b = (_a = this.contextNodeData) == null ? void 0 : _a.labelData) != null ? _b : [];
    }
  }, {
    key: "markerFactory",
    value: function markerFactory() {
      var shape = this.properties.marker.shape;
      var MarkerShape = _getMarker(shape);
      return new MarkerShape();
    }
  }, {
    key: "updateMarkerSelection",
    value: function updateMarkerSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee52() {
        var nodeData, markerSelection, data;
        return _regenerator().w(function (_context63) {
          while (1) switch (_context63.n) {
            case 0:
              nodeData = opts.nodeData, markerSelection = opts.markerSelection;
              if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
              }
              data = this.properties.marker.enabled ? nodeData : [];
              return _context63.a(2, markerSelection.update(data, void 0, function (datum) {
                return _createDatumId([datum.xValue, datum.yValue, datum.label.text]);
              }));
          }
        }, _callee52, this);
      }));
    }
  }, {
    key: "updateMarkerNodes",
    value: function updateMarkerNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee53() {
        var _this194 = this;
        var markerSelection, highlighted, _this$properties11, xKey, yKey, sizeKey, labelKey, marker, baseStyle;
        return _regenerator().w(function (_context64) {
          while (1) switch (_context64.n) {
            case 0:
              markerSelection = opts.markerSelection, highlighted = opts.isHighlight;
              _this$properties11 = this.properties, xKey = _this$properties11.xKey, yKey = _this$properties11.yKey, sizeKey = _this$properties11.sizeKey, labelKey = _this$properties11.labelKey, marker = _this$properties11.marker;
              baseStyle = _mergeDefaults4(highlighted && this.properties.highlightStyle.item, marker.getStyle());
              this.sizeScale.range = [marker.size, marker.maxSize];
              markerSelection.each(function (node, datum) {
                _this194.updateMarkerStyle(node, marker, {
                  datum: datum,
                  highlighted: highlighted,
                  xKey: xKey,
                  yKey: yKey,
                  sizeKey: sizeKey,
                  labelKey: labelKey
                }, baseStyle);
              });
              if (!highlighted) {
                this.properties.marker.markClean();
              }
            case 1:
              return _context64.a(2);
          }
        }, _callee53, this);
      }));
    }
  }, {
    key: "updateLabelSelection",
    value: function updateLabelSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee54() {
        var _a, _b, placedLabels;
        return _regenerator().w(function (_context65) {
          while (1) switch (_context65.n) {
            case 0:
              placedLabels = this.properties.label.enabled ? (_b = (_a = this.chart) == null ? void 0 : _a.placeLabels().get(this)) != null ? _b : [] : [];
              return _context65.a(2, opts.labelSelection.update(placedLabels.map(function (v) {
                return __spreadProps(__spreadValues({}, v.datum), {
                  point: {
                    x: v.x,
                    y: v.y,
                    size: v.datum.point.size
                  }
                });
              })));
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "updateLabelNodes",
    value: function updateLabelNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee55() {
        var label;
        return _regenerator().w(function (_context66) {
          while (1) switch (_context66.n) {
            case 0:
              label = this.properties.label;
              opts.labelSelection.each(function (text, datum) {
                var _a, _b, _c, _d;
                text.text = datum.label.text;
                text.fill = label.color;
                text.x = (_b = (_a = datum.point) == null ? void 0 : _a.x) != null ? _b : 0;
                text.y = (_d = (_c = datum.point) == null ? void 0 : _c.y) != null ? _d : 0;
                text.fontStyle = label.fontStyle;
                text.fontWeight = label.fontWeight;
                text.fontSize = label.fontSize;
                text.fontFamily = label.fontFamily;
                text.textAlign = "left";
                text.textBaseline = "top";
              });
            case 1:
              return _context66.a(2);
          }
        }, _callee55, this);
      }));
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var _a;
      var xAxis = this.axes["x" /* X */];
      var yAxis = this.axes["y" /* Y */];
      if (!this.properties.isValid() || !xAxis || !yAxis) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var _this$properties12 = this.properties,
        xKey = _this$properties12.xKey,
        yKey = _this$properties12.yKey,
        sizeKey = _this$properties12.sizeKey,
        labelKey = _this$properties12.labelKey,
        xName = _this$properties12.xName,
        yName = _this$properties12.yName,
        sizeName = _this$properties12.sizeName,
        labelName = _this$properties12.labelName,
        marker = _this$properties12.marker,
        tooltip = _this$properties12.tooltip;
      var title = (_a = this.properties.title) != null ? _a : yName;
      var baseStyle = _mergeDefaults4({
        fill: nodeDatum.fill,
        strokeWidth: this.getStrokeWidth(marker.strokeWidth)
      }, marker.getStyle());
      var _this$getMarkerStyle2 = this.getMarkerStyle(marker, {
          datum: nodeDatum,
          highlighted: false,
          xKey: xKey,
          yKey: yKey,
          sizeKey: sizeKey,
          labelKey: labelKey
        }, baseStyle),
        _this$getMarkerStyle3 = _this$getMarkerStyle2.fill,
        color = _this$getMarkerStyle3 === void 0 ? "gray" : _this$getMarkerStyle3;
      var datum = nodeDatum.datum,
        xValue = nodeDatum.xValue,
        yValue = nodeDatum.yValue,
        sizeValue = nodeDatum.sizeValue,
        labelText = nodeDatum.label.text,
        itemId = nodeDatum.itemId;
      var xString = _sanitizeHtml(xAxis.formatDatum(xValue));
      var yString = _sanitizeHtml(yAxis.formatDatum(yValue));
      var content = "<b>".concat(_sanitizeHtml(xName != null ? xName : xKey), "</b>: ").concat(xString, "<br><b>").concat(_sanitizeHtml(yName != null ? yName : yKey), "</b>: ").concat(yString);
      if (sizeKey) {
        content += "<br><b>".concat(_sanitizeHtml(sizeName != null ? sizeName : sizeKey), "</b>: ").concat(_sanitizeHtml(String(sizeValue)));
      }
      if (labelKey) {
        content = "<b>".concat(_sanitizeHtml(labelName != null ? labelName : labelKey), "</b>: ").concat(_sanitizeHtml(labelText), "<br>") + content;
      }
      return tooltip.toTooltipHtml({
        title: title,
        content: content,
        backgroundColor: color
      }, {
        datum: datum,
        itemId: itemId,
        xKey: xKey,
        xName: xName,
        yKey: yKey,
        yName: yName,
        sizeKey: sizeKey,
        sizeName: sizeName,
        labelKey: labelKey,
        labelName: labelName,
        title: title,
        color: color,
        seriesId: this.id
      });
    }
  }, {
    key: "getLegendData",
    value: function getLegendData() {
      var _a, _b;
      if (!((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid()) {
        return [];
      }
      var _this$properties13 = this.properties,
        yKey = _this$properties13.yKey,
        yName = _this$properties13.yName,
        title = _this$properties13.title,
        marker = _this$properties13.marker,
        visible = _this$properties13.visible;
      var shape = marker.shape,
        fill = marker.fill,
        stroke = marker.stroke,
        fillOpacity = marker.fillOpacity,
        strokeOpacity = marker.strokeOpacity,
        strokeWidth = marker.strokeWidth;
      return [{
        legendType: "category",
        id: this.id,
        itemId: yKey,
        seriesId: this.id,
        enabled: visible,
        label: {
          text: (_b = title != null ? title : yName) != null ? _b : yKey
        },
        marker: {
          shape: shape,
          fill: fill != null ? fill : "rgba(0, 0, 0, 0)",
          stroke: stroke != null ? stroke : "rgba(0, 0, 0, 0)",
          fillOpacity: fillOpacity != null ? fillOpacity : 1,
          strokeOpacity: strokeOpacity != null ? strokeOpacity : 1,
          strokeWidth: strokeWidth != null ? strokeWidth : 0
        }
      }];
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(_ref155) {
      var markerSelection = _ref155.markerSelection,
        labelSelection = _ref155.labelSelection;
      _markerScaleInAnimation(this, this.ctx.animationManager, markerSelection);
      _seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
    }
  }, {
    key: "isLabelEnabled",
    value: function isLabelEnabled() {
      return this.properties.label.enabled;
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Group4();
    }
  }, {
    key: "getFormattedMarkerStyle",
    value: function getFormattedMarkerStyle(datum) {
      var _this$properties14 = this.properties,
        xKey = _this$properties14.xKey,
        yKey = _this$properties14.yKey,
        sizeKey = _this$properties14.sizeKey,
        labelKey = _this$properties14.labelKey;
      return this.getMarkerStyle(this.properties.marker, {
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        sizeKey: sizeKey,
        labelKey: labelKey,
        highlighted: false
      });
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(opts) {
      return _computeMarkerFocusBounds(this, opts);
    }
  }]);
  return BubbleSeries;
}(_CartesianSeries7);
BubbleSeries.className = "BubbleSeries";
BubbleSeries.type = "bubble";

// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeriesModule.ts
var BubbleSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["cartesian"],
  identifier: "bubble",
  instanceConstructor: BubbleSeries,
  defaultAxes: [{
    type: "number" /* NUMBER */,
    position: "bottom" /* BOTTOM */
  }, {
    type: "number" /* NUMBER */,
    position: "left" /* LEFT */
  }],
  themeTemplate: {
    series: {
      __extends__: _EXTENDS_SERIES_DEFAULTS,
      tooltip: {
        position: {
          type: "node"
        }
      },
      marker: {
        __extends__: _EXTENDS_CARTESIAN_MARKER_DEFAULTS,
        maxSize: 30,
        fillOpacity: 0.8
      },
      label: {
        enabled: false,
        fontSize: 12,
        fontFamily: _DEFAULT_FONT_FAMILY,
        color: _DEFAULT_LABEL_COLOUR
      }
    }
  },
  paletteFactory: _markerPaletteFactory3
};

// packages/ag-charts-community/src/chart/series/cartesian/histogramSeriesProperties.ts
var HistogramSeriesProperties = /*#__PURE__*/function (_CartesianSeriesPrope4) {
  _inherits(HistogramSeriesProperties, _CartesianSeriesPrope4);
  function HistogramSeriesProperties() {
    var _this195;
    _classCallCheck(this, HistogramSeriesProperties);
    _this195 = _possibleConstructorReturn(this, _getPrototypeOf(HistogramSeriesProperties).apply(this, arguments));
    _this195.fillOpacity = 1;
    _this195.strokeWidth = 1;
    _this195.strokeOpacity = 1;
    _this195.lineDash = [0];
    _this195.lineDashOffset = 0;
    _this195.cornerRadius = 0;
    _this195.areaPlot = false;
    _this195.aggregation = "sum";
    _this195.shadow = new _DropShadow();
    _this195.label = new _Label0();
    _this195.tooltip = new _SeriesTooltip();
    return _this195;
  }
  return HistogramSeriesProperties;
}(_CartesianSeriesProperties);
__decorateClass([_Validate(_STRING)], HistogramSeriesProperties.prototype, "xKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], HistogramSeriesProperties.prototype, "yKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], HistogramSeriesProperties.prototype, "xName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], HistogramSeriesProperties.prototype, "yName", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], HistogramSeriesProperties.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO)], HistogramSeriesProperties.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_COLOR_STRING, {
  optional: true
})], HistogramSeriesProperties.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], HistogramSeriesProperties.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO)], HistogramSeriesProperties.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH)], HistogramSeriesProperties.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], HistogramSeriesProperties.prototype, "lineDashOffset", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], HistogramSeriesProperties.prototype, "cornerRadius", 2);
__decorateClass([_Validate(_BOOLEAN)], HistogramSeriesProperties.prototype, "areaPlot", 2);
__decorateClass([_Validate(_ARRAY, {
  optional: true
})], HistogramSeriesProperties.prototype, "bins", 2);
__decorateClass([_Validate(_UNION(["count", "sum", "mean"], "a histogram aggregation"))], HistogramSeriesProperties.prototype, "aggregation", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], HistogramSeriesProperties.prototype, "binCount", 2);
__decorateClass([_Validate(_OBJECT)], HistogramSeriesProperties.prototype, "shadow", 2);
__decorateClass([_Validate(_OBJECT)], HistogramSeriesProperties.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], HistogramSeriesProperties.prototype, "tooltip", 2);

// packages/ag-charts-community/src/chart/series/cartesian/histogramSeries.ts
var defaultBinCount = 10;
var HistogramSeries = /*#__PURE__*/function (_CartesianSeries4) {
  _inherits(HistogramSeries, _CartesianSeries4);
  function HistogramSeries(moduleCtx) {
    var _this196;
    _classCallCheck(this, HistogramSeries);
    _this196 = _possibleConstructorReturn(this, _getPrototypeOf(HistogramSeries).call(this, {
      moduleCtx: moduleCtx,
      directionKeys: _DEFAULT_CARTESIAN_DIRECTION_KEYS,
      directionNames: _DEFAULT_CARTESIAN_DIRECTION_NAMES,
      pickModes: [0 /* EXACT_SHAPE_MATCH */],
      datumSelectionGarbageCollection: false,
      animationResetFns: {
        datum: _resetBarSelectionsFn,
        label: _resetLabelFn
      }
    }));
    _this196.properties = new HistogramSeriesProperties();
    _this196.calculatedBins = [];
    return _this196;
  }
  // During processData phase, used to unify different ways of the user specifying
  // the bins. Returns bins in format[[min1, max1], [min2, max2], ... ].
  _createClass(HistogramSeries, [{
    key: "deriveBins",
    value: function deriveBins(xDomain) {
      var binStarts = ticks_default(xDomain[0], xDomain[1], defaultBinCount);
      var binSize = _tickStep(xDomain[0], xDomain[1], defaultBinCount);
      var _binStarts = _slicedToArray(binStarts, 1),
        firstBinEnd = _binStarts[0];
      var expandStartToBin = function expandStartToBin(n) {
        return [n, n + binSize];
      };
      return [[firstBinEnd - binSize, firstBinEnd]].concat(_toConsumableArray(binStarts.map(expandStartToBin)));
    }
  }, {
    key: "calculateNiceBins",
    value: function calculateNiceBins(domain, binCount) {
      var startGuess = Math.floor(domain[0]);
      var stop = domain[1];
      var segments = binCount || 1;
      var _this$calculateNiceSt = this.calculateNiceStart(startGuess, stop, segments),
        start = _this$calculateNiceSt.start,
        binSize = _this$calculateNiceSt.binSize;
      return this.getBins(start, stop, binSize, segments);
    }
  }, {
    key: "getBins",
    value: function getBins(start, stop, step, count) {
      var bins = [];
      var precision = this.calculatePrecision(step);
      for (var i = 0; i < count; i++) {
        var a = Math.round((start + i * step) * precision) / precision;
        var b = Math.round((start + (i + 1) * step) * precision) / precision;
        if (i === count - 1) {
          b = Math.max(b, stop);
        }
        bins[i] = [a, b];
      }
      return bins;
    }
  }, {
    key: "calculatePrecision",
    value: function calculatePrecision(step) {
      var precision = 10;
      if (isFinite(step) && step > 0) {
        while (step < 1) {
          precision *= 10;
          step *= 10;
        }
      }
      return precision;
    }
  }, {
    key: "calculateNiceStart",
    value: function calculateNiceStart(a, b, segments) {
      var binSize = Math.abs(b - a) / segments;
      var order = Math.floor(Math.log10(binSize));
      var magnitude = Math.pow(10, order);
      var start = Math.floor(a / magnitude) * magnitude;
      return {
        start: start,
        binSize: binSize
      };
    }
  }, {
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee56() {
        var _this197 = this;
        var _a, _b, _this$properties15, xKey, yKey, areaPlot, aggregation, xScale, yScale, _this$getScaleInforma5, xScaleType, yScaleType, props, aggProp, _aggProp, groupByFn;
        return _regenerator().w(function (_context67) {
          while (1) switch (_context67.n) {
            case 0:
              if (!this.visible) {
                this.processedData = void 0;
                this.animationState.transition("updateData");
              }
              _this$properties15 = this.properties, xKey = _this$properties15.xKey, yKey = _this$properties15.yKey, areaPlot = _this$properties15.areaPlot, aggregation = _this$properties15.aggregation;
              xScale = (_a = this.axes["x" /* X */]) == null ? void 0 : _a.scale;
              yScale = (_b = this.axes["y" /* Y */]) == null ? void 0 : _b.scale;
              _this$getScaleInforma5 = this.getScaleInformation({
                yScale: yScale,
                xScale: xScale
              }), xScaleType = _this$getScaleInforma5.xScaleType, yScaleType = _this$getScaleInforma5.yScaleType;
              props = [_keyProperty(xKey, xScaleType), _SORT_DOMAIN_GROUPS];
              if (yKey) {
                aggProp = _groupCount("groupAgg");
                if (aggregation === "count") {} else if (aggregation === "sum") {
                  aggProp = _groupSum("groupAgg");
                } else if (aggregation === "mean") {
                  aggProp = _groupAverage("groupAgg");
                }
                if (areaPlot) {
                  aggProp = _area("groupAgg", aggProp);
                }
                props.push(_valueProperty(yKey, yScaleType, {
                  invalidValue: void 0
                }), aggProp);
              } else {
                _aggProp = _groupCount("groupAgg");
                if (areaPlot) {
                  _aggProp = _area("groupAgg", _aggProp);
                }
                props.push(_aggProp);
              }
              groupByFn = function groupByFn(dataSet) {
                var _a2;
                var xExtent = _fixNumericExtent(dataSet.domain.keys[0]);
                if (xExtent.length === 0) {
                  dataSet.domain.groups = [];
                  return function () {
                    return [];
                  };
                }
                var bins = _isNumber(_this197.properties.binCount) ? _this197.calculateNiceBins(xExtent, _this197.properties.binCount) : (_a2 = _this197.properties.bins) != null ? _a2 : _this197.deriveBins(xExtent);
                var binCount = bins.length;
                _this197.calculatedBins = _toConsumableArray(bins);
                return function (item) {
                  var xValue = item.keys[0];
                  for (var i = 0; i < binCount; i++) {
                    var nextBin = bins[i];
                    if (xValue >= nextBin[0] && xValue < nextBin[1]) {
                      return nextBin;
                    }
                    if (i === binCount - 1 && xValue <= nextBin[1]) {
                      return nextBin;
                    }
                  }
                  return [];
                };
              };
              if (!this.ctx.animationManager.isSkipped() && this.processedData) {
                props.push(_diff(this.processedData, false));
              }
              _context67.n = 1;
              return this.requestDataModel(dataController, this.data, {
                props: props,
                groupByFn: groupByFn
              });
            case 1:
              this.animationState.transition("updateData");
            case 2:
              return _context67.a(2);
          }
        }, _callee56, this);
      }));
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      var _a, _b, _c, _d;
      var processedData = this.processedData,
        dataModel = this.dataModel;
      if (!processedData || !dataModel || !this.calculatedBins.length) return [];
      var yDomain = dataModel.getDomain(this, "groupAgg", "aggregate", processedData);
      var xDomainMin = (_a = this.calculatedBins) == null ? void 0 : _a[0][0];
      var xDomainMax = (_d = this.calculatedBins) == null ? void 0 : _d[((_c = (_b = this.calculatedBins) == null ? void 0 : _b.length) != null ? _c : 0) - 1][1];
      if (direction === "x" /* X */) {
        return _fixNumericExtent([xDomainMin, xDomainMax]);
      }
      return _fixNumericExtent(yDomain);
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee57() {
        var _this198 = this;
        var _a, seriesId, axes, processedData, callbackCache, xAxis, yAxis, xScale, yScale, _this$properties16, xKey, yKey, xName, yName, fill, stroke, strokeWidth, cornerRadius, _this$properties$labe2, _this$properties$labe3, labelFormatter, labelFontStyle, labelFontWeight, labelFontSize, labelFontFamily, labelColor, nodeData, context;
        return _regenerator().w(function (_context68) {
          while (1) switch (_context68.n) {
            case 0:
              seriesId = this.id, axes = this.axes, processedData = this.processedData, callbackCache = this.ctx.callbackCache;
              xAxis = axes["x" /* X */];
              yAxis = axes["y" /* Y */];
              if (!(!xAxis || !yAxis)) {
                _context68.n = 1;
                break;
              }
              return _context68.a(2);
            case 1:
              xScale = xAxis.scale;
              yScale = yAxis.scale;
              _this$properties16 = this.properties, xKey = _this$properties16.xKey, yKey = _this$properties16.yKey, xName = _this$properties16.xName, yName = _this$properties16.yName, fill = _this$properties16.fill, stroke = _this$properties16.stroke, strokeWidth = _this$properties16.strokeWidth, cornerRadius = _this$properties16.cornerRadius;
              _this$properties$labe2 = this.properties.label, _this$properties$labe3 = _this$properties$labe2.formatter, labelFormatter = _this$properties$labe3 === void 0 ? function (params) {
                return String(params.value);
              } : _this$properties$labe3, labelFontStyle = _this$properties$labe2.fontStyle, labelFontWeight = _this$properties$labe2.fontWeight, labelFontSize = _this$properties$labe2.fontSize, labelFontFamily = _this$properties$labe2.fontFamily, labelColor = _this$properties$labe2.color;
              nodeData = [];
              context = {
                itemId: (_a = this.properties.yKey) != null ? _a : this.id,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                animationValid: true,
                visible: this.visible
              };
              if (!(!this.visible || !processedData || processedData.type !== "grouped")) {
                _context68.n = 2;
                break;
              }
              return _context68.a(2, context);
            case 2:
              processedData.data.forEach(function (group2) {
                var _a2;
                var _group2$aggValues = group2.aggValues,
                  _group2$aggValues2 = _group2$aggValues === void 0 ? [[0, 0]] : _group2$aggValues,
                  _group2$aggValues3 = _slicedToArray(_group2$aggValues2, 1),
                  _group2$aggValues3$ = _slicedToArray(_group2$aggValues3[0], 2),
                  negativeAgg = _group2$aggValues3$[0],
                  positiveAgg = _group2$aggValues3$[1],
                  datum = group2.datum,
                  frequency = group2.datum.length,
                  domain = group2.keys,
                  _group2$keys = _slicedToArray(group2.keys, 2),
                  xDomainMin = _group2$keys[0],
                  xDomainMax = _group2$keys[1];
                var xMinPx = xScale.convert(xDomainMin);
                var xMaxPx = xScale.convert(xDomainMax);
                var total = negativeAgg + positiveAgg;
                var yZeroPx = yScale.convert(0);
                var yMaxPx = yScale.convert(total);
                var w = Math.abs(xMaxPx - xMinPx);
                var h = Math.abs(yMaxPx - yZeroPx);
                var x = Math.min(xMinPx, xMaxPx);
                var y = Math.min(yZeroPx, yMaxPx);
                var selectionDatumLabel = void 0;
                if (total !== 0) {
                  selectionDatumLabel = {
                    text: (_a2 = callbackCache.call(labelFormatter, {
                      value: total,
                      datum: datum,
                      seriesId: seriesId,
                      xKey: xKey,
                      yKey: yKey,
                      xName: xName,
                      yName: yName
                    })) != null ? _a2 : String(total),
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    fill: labelColor,
                    x: x + w / 2,
                    y: y + h / 2
                  };
                }
                var nodeMidPoint = {
                  x: x + w / 2,
                  y: y + h / 2
                };
                var yAxisReversed = yAxis.isReversed();
                nodeData.push({
                  series: _this198,
                  datum: datum,
                  // required by SeriesNodeDatum, but might not make sense here
                  // since each selection is an aggregation of multiple data.
                  aggregatedValue: total,
                  frequency: frequency,
                  domain: domain,
                  yKey: yKey,
                  xKey: xKey,
                  x: x,
                  y: y,
                  xValue: xMinPx,
                  yValue: yMaxPx,
                  width: w,
                  height: h,
                  midPoint: nodeMidPoint,
                  fill: fill,
                  stroke: stroke,
                  cornerRadius: cornerRadius,
                  topLeftCornerRadius: !yAxisReversed,
                  topRightCornerRadius: !yAxisReversed,
                  bottomRightCornerRadius: yAxisReversed,
                  bottomLeftCornerRadius: yAxisReversed,
                  opacity: 1,
                  strokeWidth: strokeWidth,
                  label: selectionDatumLabel
                });
              });
              nodeData.sort(function (a, b) {
                return a.x - b.x;
              });
              return _context68.a(2, context);
          }
        }, _callee57, this);
      }));
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Rect();
    }
  }, {
    key: "updateDatumSelection",
    value: function updateDatumSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee58() {
        var nodeData, datumSelection;
        return _regenerator().w(function (_context69) {
          while (1) switch (_context69.n) {
            case 0:
              nodeData = opts.nodeData, datumSelection = opts.datumSelection;
              return _context69.a(2, datumSelection.update(nodeData, function (rect) {
                rect.tag = 0 /* Bin */;
                rect.crisp = true;
              }, function (datum) {
                return datum.domain.join("_");
              }));
          }
        }, _callee58);
      }));
    }
  }, {
    key: "updateDatumNodes",
    value: function updateDatumNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee59() {
        var isDatumHighlighted, _this$properties17, seriesFillOpacity, strokeOpacity, lineDash, lineDashOffset, shadow, _this$properties17$hi, highlightedFill, _this$properties17$hi2, highlightFillOpacity, highlightedStroke, highlightedDatumStrokeWidth;
        return _regenerator().w(function (_context70) {
          while (1) switch (_context70.n) {
            case 0:
              isDatumHighlighted = opts.isHighlight;
              _this$properties17 = this.properties, seriesFillOpacity = _this$properties17.fillOpacity, strokeOpacity = _this$properties17.strokeOpacity, lineDash = _this$properties17.lineDash, lineDashOffset = _this$properties17.lineDashOffset, shadow = _this$properties17.shadow, _this$properties17$hi = _this$properties17.highlightStyle.item, highlightedFill = _this$properties17$hi.fill, _this$properties17$hi2 = _this$properties17$hi.fillOpacity, highlightFillOpacity = _this$properties17$hi2 === void 0 ? seriesFillOpacity : _this$properties17$hi2, highlightedStroke = _this$properties17$hi.stroke, highlightedDatumStrokeWidth = _this$properties17$hi.strokeWidth;
              opts.datumSelection.each(function (rect, datum, index) {
                var _a, _b;
                var cornerRadius = datum.cornerRadius,
                  topLeftCornerRadius = datum.topLeftCornerRadius,
                  topRightCornerRadius = datum.topRightCornerRadius,
                  bottomRightCornerRadius = datum.bottomRightCornerRadius,
                  bottomLeftCornerRadius = datum.bottomLeftCornerRadius;
                var strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== void 0 ? highlightedDatumStrokeWidth : datum.strokeWidth;
                var fillOpacity = isDatumHighlighted ? highlightFillOpacity : seriesFillOpacity;
                rect.fill = (_a = isDatumHighlighted ? highlightedFill : void 0) != null ? _a : datum.fill;
                rect.stroke = (_b = isDatumHighlighted ? highlightedStroke : void 0) != null ? _b : datum.stroke;
                rect.fillOpacity = fillOpacity;
                rect.strokeOpacity = strokeOpacity;
                rect.strokeWidth = strokeWidth;
                rect.lineDash = lineDash;
                rect.lineDashOffset = lineDashOffset;
                rect.topLeftCornerRadius = topLeftCornerRadius ? cornerRadius : 0;
                rect.topRightCornerRadius = topRightCornerRadius ? cornerRadius : 0;
                rect.bottomRightCornerRadius = bottomRightCornerRadius ? cornerRadius : 0;
                rect.bottomLeftCornerRadius = bottomLeftCornerRadius ? cornerRadius : 0;
                rect.fillShadow = shadow;
                rect.zIndex = isDatumHighlighted ? _Series2.highlightedZIndex : index;
                rect.visible = datum.height > 0;
              });
            case 1:
              return _context70.a(2);
          }
        }, _callee59, this);
      }));
    }
  }, {
    key: "updateLabelSelection",
    value: function updateLabelSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee60() {
        var labelData, labelSelection;
        return _regenerator().w(function (_context71) {
          while (1) switch (_context71.n) {
            case 0:
              labelData = opts.labelData, labelSelection = opts.labelSelection;
              return _context71.a(2, labelSelection.update(labelData, function (text) {
                text.tag = 1 /* Label */;
                text.pointerEvents = 1 /* None */;
                text.textAlign = "center";
                text.textBaseline = "middle";
              }));
          }
        }, _callee60);
      }));
    }
  }, {
    key: "updateLabelNodes",
    value: function updateLabelNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee61() {
        var labelEnabled;
        return _regenerator().w(function (_context72) {
          while (1) switch (_context72.n) {
            case 0:
              labelEnabled = this.isLabelEnabled();
              opts.labelSelection.each(function (text, datum) {
                var label = datum.label;
                if (label && labelEnabled) {
                  text.text = label.text;
                  text.x = label.x;
                  text.y = label.y;
                  text.fontStyle = label.fontStyle;
                  text.fontWeight = label.fontWeight;
                  text.fontSize = label.fontSize;
                  text.fontFamily = label.fontFamily;
                  text.fill = label.fill;
                  text.visible = true;
                } else {
                  text.visible = false;
                }
              });
            case 1:
              return _context72.a(2);
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "initQuadTree",
    value: function initQuadTree(quadtree) {
      _addHitTestersToQuadtree(quadtree, _childrenIter(this.contentGroup.children[0]));
    }
  }, {
    key: "pickNodeClosestDatum",
    value: function pickNodeClosestDatum(point) {
      return _findQuadtreeMatch(this, point);
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var xAxis = this.axes["x" /* X */];
      var yAxis = this.axes["y" /* Y */];
      if (!this.properties.isValid() || !xAxis || !yAxis) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var _this$properties18 = this.properties,
        xKey = _this$properties18.xKey,
        yKey = _this$properties18.yKey,
        xName = _this$properties18.xName,
        yName = _this$properties18.yName,
        color = _this$properties18.fill,
        aggregation = _this$properties18.aggregation,
        tooltip = _this$properties18.tooltip;
      var aggregatedValue = nodeDatum.aggregatedValue,
        frequency = nodeDatum.frequency,
        _nodeDatum$domain = _slicedToArray(nodeDatum.domain, 2),
        rangeMin = _nodeDatum$domain[0],
        rangeMax = _nodeDatum$domain[1],
        itemId = nodeDatum.itemId;
      var title = "".concat(_sanitizeHtml(xName != null ? xName : xKey), ": ").concat(xAxis.formatDatum(rangeMin), " - ").concat(xAxis.formatDatum(rangeMax));
      var content = yKey ? "<b>".concat(_sanitizeHtml(yName != null ? yName : yKey), " (").concat(aggregation, ")</b>: ").concat(yAxis.formatDatum(aggregatedValue), "<br>") : "";
      content += "<b>Frequency</b>: ".concat(frequency);
      var defaults = {
        title: title,
        backgroundColor: color,
        content: content
      };
      return tooltip.toTooltipHtml(defaults, {
        datum: {
          data: nodeDatum.datum,
          aggregatedValue: nodeDatum.aggregatedValue,
          domain: nodeDatum.domain,
          frequency: nodeDatum.frequency
        },
        itemId: itemId,
        xKey: xKey,
        xName: xName,
        yKey: yKey,
        yName: yName,
        color: color,
        title: title,
        seriesId: this.id
      });
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b;
      if (!((_a = this.data) == null ? void 0 : _a.length) || legendType !== "category") {
        return [];
      }
      var _this$properties19 = this.properties,
        xKey = _this$properties19.xKey,
        yName = _this$properties19.yName,
        fill = _this$properties19.fill,
        fillOpacity = _this$properties19.fillOpacity,
        stroke = _this$properties19.stroke,
        strokeWidth = _this$properties19.strokeWidth,
        strokeOpacity = _this$properties19.strokeOpacity,
        visible = _this$properties19.visible;
      return [{
        legendType: "category",
        id: this.id,
        itemId: xKey,
        seriesId: this.id,
        enabled: visible,
        label: {
          text: (_b = yName != null ? yName : xKey) != null ? _b : "Frequency"
        },
        marker: {
          fill: fill != null ? fill : "rgba(0, 0, 0, 0)",
          stroke: stroke != null ? stroke : "rgba(0, 0, 0, 0)",
          fillOpacity: fillOpacity,
          strokeOpacity: strokeOpacity,
          strokeWidth: strokeWidth
        }
      }];
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(_ref156) {
      var datumSelection = _ref156.datumSelection,
        labelSelection = _ref156.labelSelection;
      var fns = _prepareBarAnimationFunctions(_collapsedStartingBarPosition(true, this.axes, "normal"));
      _fromToMotion(this.id, "datums", this.ctx.animationManager, [datumSelection], fns);
      _seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(data) {
      var _a, _b;
      var dataDiff = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff;
      var fns = _prepareBarAnimationFunctions(_collapsedStartingBarPosition(true, this.axes, "normal"));
      _fromToMotion(this.id, "datums", this.ctx.animationManager, [data.datumSelection], fns, function (_, datum) {
        return _createDatumId(datum.domain);
      }, dataDiff);
      _seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, data.labelSelection);
    }
  }, {
    key: "isLabelEnabled",
    value: function isLabelEnabled() {
      return this.properties.label.enabled;
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(_ref157) {
      var datumIndex = _ref157.datumIndex,
        seriesRect = _ref157.seriesRect;
      var _a;
      return _computeBarFocusBounds((_a = this.contextNodeData) == null ? void 0 : _a.nodeData[datumIndex], this.contentGroup, seriesRect);
    }
  }]);
  return HistogramSeries;
}(_CartesianSeries7);
HistogramSeries.className = "HistogramSeries";
HistogramSeries.type = "histogram";

// packages/ag-charts-community/src/chart/series/cartesian/histogramSeriesModule.ts
var HistogramSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["cartesian"],
  identifier: "histogram",
  instanceConstructor: HistogramSeries,
  defaultAxes: [{
    type: "number" /* NUMBER */,
    position: "bottom" /* BOTTOM */
  }, {
    type: "number" /* NUMBER */,
    position: "left" /* LEFT */
  }],
  themeTemplate: {
    series: {
      __extends__: _EXTENDS_SERIES_DEFAULTS,
      strokeWidth: 1,
      fillOpacity: 1,
      strokeOpacity: 1,
      lineDash: [0],
      lineDashOffset: 0,
      label: {
        enabled: false,
        fontSize: 12,
        fontFamily: _DEFAULT_FONT_FAMILY,
        color: _DEFAULT_INSIDE_SERIES_LABEL_COLOUR
      },
      shadow: {
        enabled: false,
        color: _DEFAULT_SHADOW_COLOUR,
        xOffset: 3,
        yOffset: 3,
        blur: 5
      }
    }
  },
  paletteFactory: function paletteFactory(_ref158) {
    var takeColors = _ref158.takeColors;
    var _takeColors2 = takeColors(1),
      _takeColors2$fills = _slicedToArray(_takeColors2.fills, 1),
      fill = _takeColors2$fills[0],
      _takeColors2$strokes = _slicedToArray(_takeColors2.strokes, 1),
      stroke = _takeColors2$strokes[0];
    return {
      fill: fill,
      stroke: stroke
    };
  }
};

// packages/ag-charts-community/src/chart/series/cartesian/lineSeriesProperties.ts
var LineSeriesProperties = /*#__PURE__*/function (_CartesianSeriesPrope5) {
  _inherits(LineSeriesProperties, _CartesianSeriesPrope5);
  function LineSeriesProperties() {
    var _this199;
    _classCallCheck(this, LineSeriesProperties);
    _this199 = _possibleConstructorReturn(this, _getPrototypeOf(LineSeriesProperties).apply(this, arguments));
    _this199.stroke = "#874349";
    _this199.strokeWidth = 2;
    _this199.strokeOpacity = 1;
    _this199.lineDash = [0];
    _this199.lineDashOffset = 0;
    _this199.marker = new _SeriesMarker2();
    _this199.label = new _Label0();
    _this199.tooltip = new _SeriesTooltip();
    _this199.connectMissingData = false;
    return _this199;
  }
  return LineSeriesProperties;
}(_CartesianSeriesProperties);
__decorateClass([_Validate(_STRING)], LineSeriesProperties.prototype, "xKey", 2);
__decorateClass([_Validate(_STRING)], LineSeriesProperties.prototype, "yKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], LineSeriesProperties.prototype, "xName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], LineSeriesProperties.prototype, "yName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], LineSeriesProperties.prototype, "title", 2);
__decorateClass([_Validate(_COLOR_STRING)], LineSeriesProperties.prototype, "stroke", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LineSeriesProperties.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_RATIO)], LineSeriesProperties.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH)], LineSeriesProperties.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], LineSeriesProperties.prototype, "lineDashOffset", 2);
__decorateClass([_Validate(_OBJECT)], LineSeriesProperties.prototype, "marker", 2);
__decorateClass([_Validate(_OBJECT)], LineSeriesProperties.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], LineSeriesProperties.prototype, "tooltip", 2);
__decorateClass([_Validate(_BOOLEAN)], LineSeriesProperties.prototype, "connectMissingData", 2);

// packages/ag-charts-community/src/chart/series/cartesian/lineSeries.ts
var LineSeries = /*#__PURE__*/function (_CartesianSeries5) {
  _inherits(LineSeries, _CartesianSeries5);
  function LineSeries(moduleCtx) {
    var _this200;
    _classCallCheck(this, LineSeries);
    _this200 = _possibleConstructorReturn(this, _getPrototypeOf(LineSeries).call(this, {
      moduleCtx: moduleCtx,
      directionKeys: _DEFAULT_CARTESIAN_DIRECTION_KEYS,
      directionNames: _DEFAULT_CARTESIAN_DIRECTION_NAMES,
      hasMarkers: true,
      pickModes: [2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */, 3 /* NEAREST_NODE */, 0 /* EXACT_SHAPE_MATCH */],
      markerSelectionGarbageCollection: false,
      animationResetFns: {
        path: _buildResetPathFn({
          getOpacity: function getOpacity() {
            return _this200.getOpacity();
          }
        }),
        label: _resetLabelFn,
        marker: function marker(node, datum) {
          return __spreadValues(__spreadValues({}, _resetMarkerFn(node)), _resetMarkerPositionFn(node, datum));
        }
      }
    }));
    _this200.properties = new LineSeriesProperties();
    return _this200;
  }
  _createClass(LineSeries, [{
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee62() {
        var _a, _b, _this$properties20, xKey, yKey, animationEnabled, xScale, yScale, _this$getScaleInforma6, isContinuousX, xScaleType, yScaleType, props;
        return _regenerator().w(function (_context73) {
          while (1) switch (_context73.n) {
            case 0:
              if (!(!this.properties.isValid() || this.data == null)) {
                _context73.n = 1;
                break;
              }
              return _context73.a(2);
            case 1:
              _this$properties20 = this.properties, xKey = _this$properties20.xKey, yKey = _this$properties20.yKey;
              animationEnabled = !this.ctx.animationManager.isSkipped();
              xScale = (_a = this.axes["x" /* X */]) == null ? void 0 : _a.scale;
              yScale = (_b = this.axes["y" /* Y */]) == null ? void 0 : _b.scale;
              _this$getScaleInforma6 = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
              }), isContinuousX = _this$getScaleInforma6.isContinuousX, xScaleType = _this$getScaleInforma6.xScaleType, yScaleType = _this$getScaleInforma6.yScaleType;
              props = [];
              if (!isContinuousX) {
                props.push(_keyProperty(xKey, xScaleType, {
                  id: "xKey"
                }));
              }
              if (animationEnabled) {
                props.push(_animationValidation(isContinuousX ? ["xValue"] : void 0));
                if (this.processedData) {
                  props.push(_diff(this.processedData));
                }
              }
              props.push(_valueProperty(xKey, xScaleType, {
                id: "xValue"
              }), _valueProperty(yKey, yScaleType, {
                id: "yValue",
                invalidValue: void 0
              }));
              _context73.n = 2;
              return this.requestDataModel(dataController, this.data, {
                props: props
              });
            case 2:
              this.animationState.transition("updateData");
            case 3:
              return _context73.a(2);
          }
        }, _callee62, this);
      }));
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      var axes = this.axes,
        dataModel = this.dataModel,
        processedData = this.processedData;
      if (!processedData || !dataModel) return [];
      var xAxis = axes["x" /* X */];
      var yAxis = axes["y" /* Y */];
      var xDef = dataModel.resolveProcessedDataDefById(this, "xValue");
      if (direction === "x" /* X */) {
        var domain = dataModel.getDomain(this, "xValue", "value", processedData);
        if ((xDef == null ? void 0 : xDef.def.type) === "value" && xDef.def.valueType === "category") {
          return domain;
        }
        return _fixNumericExtent(_extent(domain), xAxis);
      } else {
        var _domain6 = dataModel.getDomain(this, "yValue", "value", processedData);
        return _fixNumericExtent(_domain6, yAxis);
      }
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee63() {
        var _a, _b, _c, processedData, dataModel, axes, xAxis, yAxis, _this$properties21, xKey, yKey, xName, yName, marker, label, connectMissingData, legendItemName, xScale, yScale, xOffset, yOffset, nodeData, size, xIdx, yIdx, moveTo, nextPoint, i, _ref159, datum, values, xDatum, yDatum, x, y, labelText;
        return _regenerator().w(function (_context74) {
          while (1) switch (_context74.n) {
            case 0:
              processedData = this.processedData, dataModel = this.dataModel, axes = this.axes;
              xAxis = axes["x" /* X */];
              yAxis = axes["y" /* Y */];
              if (!(!processedData || !dataModel || !xAxis || !yAxis)) {
                _context74.n = 1;
                break;
              }
              return _context74.a(2);
            case 1:
              _this$properties21 = this.properties, xKey = _this$properties21.xKey, yKey = _this$properties21.yKey, xName = _this$properties21.xName, yName = _this$properties21.yName, marker = _this$properties21.marker, label = _this$properties21.label, connectMissingData = _this$properties21.connectMissingData, legendItemName = _this$properties21.legendItemName;
              xScale = xAxis.scale;
              yScale = yAxis.scale;
              xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
              yOffset = ((_b = yScale.bandwidth) != null ? _b : 0) / 2;
              nodeData = [];
              size = marker.enabled ? marker.size : 0;
              xIdx = dataModel.resolveProcessedDataIndexById(this, "xValue");
              yIdx = dataModel.resolveProcessedDataIndexById(this, "yValue");
              moveTo = true;
              i = 0;
            case 2:
              if (!(i < processedData.data.length)) {
                _context74.n = 6;
                break;
              }
              _ref159 = nextPoint != null ? nextPoint : processedData.data[i], datum = _ref159.datum, values = _ref159.values;
              xDatum = values[xIdx];
              yDatum = values[yIdx];
              if (!(yDatum === void 0)) {
                _context74.n = 3;
                break;
              }
              moveTo = !connectMissingData;
              _context74.n = 5;
              break;
            case 3:
              x = xScale.convert(xDatum) + xOffset;
              if (!isNaN(x)) {
                _context74.n = 4;
                break;
              }
              moveTo = !connectMissingData;
              nextPoint = void 0;
              return _context74.a(3, 5);
            case 4:
              nextPoint = ((_c = processedData.data[i + 1]) == null ? void 0 : _c.values[yIdx]) === void 0 ? void 0 : processedData.data[i + 1];
              y = yScale.convert(yDatum) + yOffset;
              labelText = this.getLabelText(label, {
                value: yDatum,
                datum: datum,
                xKey: xKey,
                yKey: yKey,
                xName: xName,
                yName: yName,
                legendItemName: legendItemName
              }, function (value) {
                return _isFiniteNumber(value) ? value.toFixed(2) : String(value);
              });
              nodeData.push({
                series: this,
                datum: datum,
                yKey: yKey,
                xKey: xKey,
                point: {
                  x: x,
                  y: y,
                  moveTo: moveTo,
                  size: size
                },
                midPoint: {
                  x: x,
                  y: y
                },
                yValue: yDatum,
                xValue: xDatum,
                capDefaults: {
                  lengthRatioMultiplier: this.properties.marker.getDiameter(),
                  lengthMax: Infinity
                },
                label: labelText ? {
                  text: labelText,
                  fontStyle: label.fontStyle,
                  fontWeight: label.fontWeight,
                  fontSize: label.fontSize,
                  fontFamily: label.fontFamily,
                  textAlign: "center",
                  textBaseline: "bottom",
                  fill: label.color
                } : void 0
              });
              moveTo = false;
            case 5:
              i++;
              _context74.n = 2;
              break;
            case 6:
              return _context74.a(2, {
                itemId: yKey,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                visible: this.visible
              });
          }
        }, _callee63, this);
      }));
    }
  }, {
    key: "isPathOrSelectionDirty",
    value: function isPathOrSelectionDirty() {
      return this.properties.marker.isDirty();
    }
  }, {
    key: "markerFactory",
    value: function markerFactory() {
      var shape = this.properties.marker.shape;
      var MarkerShape = _getMarker(shape);
      return new MarkerShape();
    }
  }, {
    key: "updatePathNodes",
    value: function updatePathNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee64() {
        var _opts$paths2, lineNode, opacity, visible, animationEnabled;
        return _regenerator().w(function (_context75) {
          while (1) switch (_context75.n) {
            case 0:
              _opts$paths2 = _slicedToArray(opts.paths, 1), lineNode = _opts$paths2[0], opacity = opts.opacity, visible = opts.visible, animationEnabled = opts.animationEnabled;
              lineNode.setProperties({
                fill: void 0,
                lineJoin: "round",
                pointerEvents: 1 /* None */,
                opacity: opacity,
                stroke: this.properties.stroke,
                strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
                strokeOpacity: this.properties.strokeOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset
              });
              if (!animationEnabled) {
                lineNode.visible = visible;
              }
              _updateClipPath(this, lineNode);
            case 1:
              return _context75.a(2);
          }
        }, _callee64, this);
      }));
    }
  }, {
    key: "updateMarkerSelection",
    value: function updateMarkerSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee65() {
        var nodeData, markerSelection, _this$properties$mark, shape, enabled;
        return _regenerator().w(function (_context76) {
          while (1) switch (_context76.n) {
            case 0:
              nodeData = opts.nodeData;
              markerSelection = opts.markerSelection;
              _this$properties$mark = this.properties.marker, shape = _this$properties$mark.shape, enabled = _this$properties$mark.enabled;
              nodeData = shape && enabled ? nodeData : [];
              if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
              }
              return _context76.a(2, markerSelection.update(nodeData, void 0, function (datum) {
                return _createDatumId(datum.xValue);
              }));
          }
        }, _callee65, this);
      }));
    }
  }, {
    key: "updateMarkerNodes",
    value: function updateMarkerNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee66() {
        var _this201 = this;
        var markerSelection, highlighted, _this$properties22, xKey, yKey, stroke, strokeWidth, strokeOpacity, marker, highlightStyle, baseStyle, applyTranslation;
        return _regenerator().w(function (_context77) {
          while (1) switch (_context77.n) {
            case 0:
              markerSelection = opts.markerSelection, highlighted = opts.isHighlight;
              _this$properties22 = this.properties, xKey = _this$properties22.xKey, yKey = _this$properties22.yKey, stroke = _this$properties22.stroke, strokeWidth = _this$properties22.strokeWidth, strokeOpacity = _this$properties22.strokeOpacity, marker = _this$properties22.marker, highlightStyle = _this$properties22.highlightStyle;
              baseStyle = _mergeDefaults4(highlighted && highlightStyle.item, marker.getStyle(), {
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity
              });
              applyTranslation = this.ctx.animationManager.isSkipped();
              markerSelection.each(function (node, datum) {
                _this201.updateMarkerStyle(node, marker, {
                  datum: datum,
                  highlighted: highlighted,
                  xKey: xKey,
                  yKey: yKey
                }, baseStyle, {
                  applyTranslation: applyTranslation
                });
              });
              if (!highlighted) {
                marker.markClean();
              }
            case 1:
              return _context77.a(2);
          }
        }, _callee66, this);
      }));
    }
  }, {
    key: "updateLabelSelection",
    value: function updateLabelSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee67() {
        return _regenerator().w(function (_context78) {
          while (1) switch (_context78.n) {
            case 0:
              return _context78.a(2, opts.labelSelection.update(this.isLabelEnabled() ? opts.labelData : []));
          }
        }, _callee67, this);
      }));
    }
  }, {
    key: "updateLabelNodes",
    value: function updateLabelNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee68() {
        var _this$properties$labe4, enabled, fontStyle, fontWeight, fontSize, fontFamily, color;
        return _regenerator().w(function (_context79) {
          while (1) switch (_context79.n) {
            case 0:
              _this$properties$labe4 = this.properties.label, enabled = _this$properties$labe4.enabled, fontStyle = _this$properties$labe4.fontStyle, fontWeight = _this$properties$labe4.fontWeight, fontSize = _this$properties$labe4.fontSize, fontFamily = _this$properties$labe4.fontFamily, color = _this$properties$labe4.color;
              opts.labelSelection.each(function (text, datum) {
                var point = datum.point,
                  label = datum.label;
                if (datum && label && enabled) {
                  text.fontStyle = fontStyle;
                  text.fontWeight = fontWeight;
                  text.fontSize = fontSize;
                  text.fontFamily = fontFamily;
                  text.textAlign = label.textAlign;
                  text.textBaseline = label.textBaseline;
                  text.text = label.text;
                  text.x = point.x;
                  text.y = point.y - 10;
                  text.fill = color;
                  text.visible = true;
                } else {
                  text.visible = false;
                }
              });
            case 1:
              return _context79.a(2);
          }
        }, _callee68, this);
      }));
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var _a;
      var xAxis = this.axes["x" /* X */];
      var yAxis = this.axes["y" /* Y */];
      if (!this.properties.isValid() || !xAxis || !yAxis) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var _this$properties23 = this.properties,
        xKey = _this$properties23.xKey,
        yKey = _this$properties23.yKey,
        xName = _this$properties23.xName,
        yName = _this$properties23.yName,
        strokeWidth = _this$properties23.strokeWidth,
        marker = _this$properties23.marker,
        tooltip = _this$properties23.tooltip;
      var datum = nodeDatum.datum,
        xValue = nodeDatum.xValue,
        yValue = nodeDatum.yValue,
        itemId = nodeDatum.itemId;
      var xString = xAxis.formatDatum(xValue);
      var yString = yAxis.formatDatum(yValue);
      var title = _sanitizeHtml((_a = this.properties.title) != null ? _a : yName);
      var content = _sanitizeHtml(xString + ": " + yString);
      var baseStyle = _mergeDefaults4({
        fill: marker.stroke
      }, marker.getStyle(), {
        strokeWidth: strokeWidth
      });
      var _this$getMarkerStyle4 = this.getMarkerStyle(marker, {
          datum: nodeDatum,
          xKey: xKey,
          yKey: yKey,
          highlighted: false
        }, baseStyle),
        color = _this$getMarkerStyle4.fill;
      return tooltip.toTooltipHtml({
        title: title,
        content: content,
        backgroundColor: color
      }, __spreadValues({
        datum: datum,
        itemId: itemId,
        xKey: xKey,
        xName: xName,
        yKey: yKey,
        yName: yName,
        title: title,
        color: color,
        seriesId: this.id
      }, this.getModuleTooltipParams()));
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      if (!(((_a = this.data) == null ? void 0 : _a.length) && this.properties.isValid() && legendType === "category")) {
        return [];
      }
      var _this$properties24 = this.properties,
        yKey = _this$properties24.yKey,
        yName = _this$properties24.yName,
        stroke = _this$properties24.stroke,
        strokeOpacity = _this$properties24.strokeOpacity,
        strokeWidth = _this$properties24.strokeWidth,
        lineDash = _this$properties24.lineDash,
        title = _this$properties24.title,
        marker = _this$properties24.marker,
        visible = _this$properties24.visible,
        legendItemName = _this$properties24.legendItemName;
      var color0 = "rgba(0, 0, 0, 0)";
      return [{
        legendType: "category",
        id: this.id,
        itemId: yKey,
        legendItemName: legendItemName,
        seriesId: this.id,
        enabled: visible,
        label: {
          text: (_c = (_b = legendItemName != null ? legendItemName : title) != null ? _b : yName) != null ? _c : yKey
        },
        marker: {
          shape: marker.shape,
          fill: (_d = marker.fill) != null ? _d : color0,
          stroke: (_f = (_e = marker.stroke) != null ? _e : stroke) != null ? _f : color0,
          fillOpacity: (_g = marker.fillOpacity) != null ? _g : 1,
          strokeOpacity: (_i = (_h = marker.strokeOpacity) != null ? _h : strokeOpacity) != null ? _i : 1,
          strokeWidth: (_j = marker.strokeWidth) != null ? _j : 0,
          enabled: marker.enabled
        },
        line: {
          stroke: stroke != null ? stroke : color0,
          strokeOpacity: strokeOpacity,
          strokeWidth: strokeWidth,
          lineDash: lineDash
        }
      }];
    }
  }, {
    key: "updatePaths",
    value: function updatePaths(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee69() {
        return _regenerator().w(function (_context80) {
          while (1) switch (_context80.n) {
            case 0:
              this.updateLinePaths(opts.paths, opts.contextData);
            case 1:
              return _context80.a(2);
          }
        }, _callee69, this);
      }));
    }
  }, {
    key: "updateLinePaths",
    value: function updateLinePaths(paths, contextData) {
      var nodeData = contextData.nodeData;
      var _paths4 = _slicedToArray(paths, 1),
        lineNode = _paths4[0];
      var linePath = lineNode.path;
      linePath.clear(true);
      var _iterator206 = _createForOfIteratorHelper(nodeData),
        _step206;
      try {
        for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
          var data = _step206.value;
          if (data.point.moveTo) {
            linePath.moveTo(data.point.x, data.point.y);
          } else {
            linePath.lineTo(data.point.x, data.point.y);
          }
        }
      } catch (err) {
        _iterator206.e(err);
      } finally {
        _iterator206.f();
      }
      lineNode.checkPathDirty();
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(animationData) {
      var markerSelection = animationData.markerSelection,
        labelSelection = animationData.labelSelection,
        annotationSelections = animationData.annotationSelections,
        contextData = animationData.contextData,
        paths = animationData.paths;
      var animationManager = this.ctx.animationManager;
      this.updateLinePaths(paths, contextData);
      _pathSwipeInAnimation.apply(void 0, [this, animationManager].concat(_toConsumableArray(paths)));
      _resetMotion([markerSelection], _resetMarkerPositionFn);
      _markerSwipeScaleInAnimation(this, animationManager, markerSelection);
      _seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
      _seriesLabelFadeInAnimation.apply(void 0, [this, "annotations", animationManager].concat(_toConsumableArray(annotationSelections)));
    }
  }, {
    key: "animateReadyResize",
    value: function animateReadyResize(animationData) {
      var contextData = animationData.contextData,
        paths = animationData.paths;
      this.updateLinePaths(paths, contextData);
      _superPropGet(LineSeries, "animateReadyResize", this, 3)([animationData]);
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(animationData) {
      var _this202 = this;
      var _a, _b;
      var animationManager = this.ctx.animationManager;
      var markerSelections = animationData.markerSelection,
        labelSelections = animationData.labelSelection,
        annotationSelections = animationData.annotationSelections,
        contextData = animationData.contextData,
        paths = animationData.paths,
        previousContextData = animationData.previousContextData;
      var _paths5 = _slicedToArray(paths, 1),
        path = _paths5[0];
      _superPropGet(LineSeries, "resetAllAnimation", this, 3)([animationData]);
      var update = function update() {
        _this202.updateLinePaths(paths, contextData);
      };
      var skip = function skip() {
        animationManager.skipCurrentBatch();
        update();
      };
      if (contextData == null || previousContextData == null) {
        update();
        _markerFadeInAnimation(this, animationManager, "added", markerSelections);
        _pathFadeInAnimation(this, "path_properties", animationManager, "add", path);
        _seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelections);
        _seriesLabelFadeInAnimation.apply(void 0, [this, "annotations", animationManager].concat(_toConsumableArray(annotationSelections)));
        return;
      }
      var fns = _prepareLinePathAnimation(contextData, previousContextData, (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff);
      if (fns === void 0) {
        skip();
        return;
      } else if (fns.status === "no-op") {
        return;
      }
      _markerFadeInAnimation(this, animationManager, void 0, markerSelections);
      _fromToMotion(this.id, "path_properties", animationManager, [path], fns.pathProperties);
      pathMotion(this.id, "path_update", animationManager, [path], fns.path);
      if (fns.hasMotion) {
        _seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelections);
        _seriesLabelFadeInAnimation.apply(void 0, [this, "annotations", animationManager].concat(_toConsumableArray(annotationSelections)));
      }
    }
  }, {
    key: "isLabelEnabled",
    value: function isLabelEnabled() {
      return this.properties.label.enabled;
    }
  }, {
    key: "getBandScalePadding",
    value: function getBandScalePadding() {
      return {
        inner: 1,
        outer: 0.1
      };
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Group4();
    }
  }, {
    key: "getFormattedMarkerStyle",
    value: function getFormattedMarkerStyle(datum) {
      var _this$properties25 = this.properties,
        xKey = _this$properties25.xKey,
        yKey = _this$properties25.yKey;
      return this.getMarkerStyle(this.properties.marker, {
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        highlighted: true
      });
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(opts) {
      return _computeMarkerFocusBounds(this, opts);
    }
  }]);
  return LineSeries;
}(_CartesianSeries7);
LineSeries.className = "LineSeries";
LineSeries.type = "line";

// packages/ag-charts-community/src/chart/series/cartesian/lineSeriesModule.ts
var LineSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["cartesian"],
  identifier: "line",
  instanceConstructor: LineSeries,
  defaultAxes: [{
    type: "number" /* NUMBER */,
    position: "left" /* LEFT */
  }, {
    type: "category" /* CATEGORY */,
    position: "bottom" /* BOTTOM */
  }],
  themeTemplate: {
    series: {
      __extends__: _EXTENDS_SERIES_DEFAULTS,
      tooltip: {
        position: {
          type: "node"
        }
      },
      strokeWidth: 2,
      strokeOpacity: 1,
      lineDash: [0],
      lineDashOffset: 0,
      marker: {
        __extends__: _EXTENDS_CARTESIAN_MARKER_DEFAULTS,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWidth: 0
      },
      label: {
        enabled: false,
        fontSize: 12,
        fontFamily: _DEFAULT_FONT_FAMILY,
        color: _DEFAULT_LABEL_COLOUR
      }
    }
  },
  enterpriseThemeTemplate: {
    series: {
      errorBar: {
        cap: {
          lengthRatio: 1
        }
      }
    }
  },
  paletteFactory: function paletteFactory(params) {
    var _markerPaletteFactory2 = _markerPaletteFactory3(params),
      marker = _markerPaletteFactory2.marker;
    return {
      stroke: marker.fill,
      marker: marker
    };
  }
};

// packages/ag-charts-community/src/chart/series/cartesian/scatterSeriesProperties.ts
var ScatterSeriesLabel = /*#__PURE__*/function (_Label3) {
  _inherits(ScatterSeriesLabel, _Label3);
  function ScatterSeriesLabel() {
    var _this203;
    _classCallCheck(this, ScatterSeriesLabel);
    _this203 = _possibleConstructorReturn(this, _getPrototypeOf(ScatterSeriesLabel).apply(this, arguments));
    _this203.placement = "top";
    return _this203;
  }
  return ScatterSeriesLabel;
}(_Label0);
__decorateClass([_Validate(_LABEL_PLACEMENT)], ScatterSeriesLabel.prototype, "placement", 2);
var ScatterSeriesProperties = /*#__PURE__*/function (_CartesianSeriesPrope6) {
  _inherits(ScatterSeriesProperties, _CartesianSeriesPrope6);
  function ScatterSeriesProperties() {
    var _this204;
    _classCallCheck(this, ScatterSeriesProperties);
    _this204 = _possibleConstructorReturn(this, _getPrototypeOf(ScatterSeriesProperties).apply(this, arguments));
    _this204.colorRange = ["#ffff00", "#00ff00", "#0000ff"];
    _this204.marker = new _SeriesMarker2();
    _this204.label = new ScatterSeriesLabel();
    _this204.tooltip = new _SeriesTooltip();
    return _this204;
  }
  return ScatterSeriesProperties;
}(_CartesianSeriesProperties);
__decorateClass([_Validate(_STRING)], ScatterSeriesProperties.prototype, "xKey", 2);
__decorateClass([_Validate(_STRING)], ScatterSeriesProperties.prototype, "yKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "labelKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "colorKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "xName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "yName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "labelName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "colorName", 2);
__decorateClass([_Validate(_NUMBER_ARRAY, {
  optional: true
})], ScatterSeriesProperties.prototype, "colorDomain", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], ScatterSeriesProperties.prototype, "colorRange", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], ScatterSeriesProperties.prototype, "title", 2);
__decorateClass([_Validate(_OBJECT)], ScatterSeriesProperties.prototype, "marker", 2);
__decorateClass([_Validate(_OBJECT)], ScatterSeriesProperties.prototype, "label", 2);
__decorateClass([_Validate(_OBJECT)], ScatterSeriesProperties.prototype, "tooltip", 2);

// packages/ag-charts-community/src/chart/series/cartesian/scatterSeries.ts
var ScatterSeries = /*#__PURE__*/function (_CartesianSeries6) {
  _inherits(ScatterSeries, _CartesianSeries6);
  function ScatterSeries(moduleCtx) {
    var _this205;
    _classCallCheck(this, ScatterSeries);
    _this205 = _possibleConstructorReturn(this, _getPrototypeOf(ScatterSeries).call(this, {
      moduleCtx: moduleCtx,
      directionKeys: _DEFAULT_CARTESIAN_DIRECTION_KEYS,
      directionNames: _DEFAULT_CARTESIAN_DIRECTION_NAMES,
      pickModes: [2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */, 3 /* NEAREST_NODE */, 0 /* EXACT_SHAPE_MATCH */],
      pathsPerSeries: 0,
      hasMarkers: true,
      markerSelectionGarbageCollection: false,
      animationResetFns: {
        marker: _resetMarkerFn,
        label: _resetLabelFn
      }
    }));
    _this205.properties = new ScatterSeriesProperties();
    _this205.colorScale = new _ColorScale();
    return _this205;
  }
  _createClass(ScatterSeries, [{
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee70() {
        var _a, _b, _c, xScale, yScale, _this$getScaleInforma7, xScaleType, yScaleType, colorScaleType, _this$properties26, xKey, yKey, labelKey, colorKey, colorDomain, colorRange, _yield$this$requestDa3, dataModel, processedData, colorKeyIdx;
        return _regenerator().w(function (_context81) {
          while (1) switch (_context81.n) {
            case 0:
              if (!(!this.properties.isValid() || this.data == null || !this.visible)) {
                _context81.n = 1;
                break;
              }
              return _context81.a(2);
            case 1:
              xScale = (_a = this.axes["x" /* X */]) == null ? void 0 : _a.scale;
              yScale = (_b = this.axes["y" /* Y */]) == null ? void 0 : _b.scale;
              _this$getScaleInforma7 = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
              }), xScaleType = _this$getScaleInforma7.xScaleType, yScaleType = _this$getScaleInforma7.yScaleType;
              colorScaleType = this.colorScale.type;
              _this$properties26 = this.properties, xKey = _this$properties26.xKey, yKey = _this$properties26.yKey, labelKey = _this$properties26.labelKey, colorKey = _this$properties26.colorKey, colorDomain = _this$properties26.colorDomain, colorRange = _this$properties26.colorRange;
              _context81.n = 2;
              return this.requestDataModel(dataController, this.data, {
                props: [_keyProperty(xKey, xScaleType, {
                  id: "xKey-raw"
                }), _keyProperty(yKey, yScaleType, {
                  id: "yKey-raw"
                })].concat(_toConsumableArray(labelKey ? [_keyProperty(labelKey, "band", {
                  id: "labelKey-raw"
                })] : []), [_valueProperty(xKey, xScaleType, {
                  id: "xValue"
                }), _valueProperty(yKey, yScaleType, {
                  id: "yValue"
                })], _toConsumableArray(colorKey ? [_valueProperty(colorKey, colorScaleType, {
                  id: "colorValue"
                })] : []), _toConsumableArray(labelKey ? [_valueProperty(labelKey, "band", {
                  id: "labelValue"
                })] : []))
              });
            case 2:
              _yield$this$requestDa3 = _context81.v;
              dataModel = _yield$this$requestDa3.dataModel;
              processedData = _yield$this$requestDa3.processedData;
              if (colorKey) {
                colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, "colorValue");
                this.colorScale.domain = (_c = colorDomain != null ? colorDomain : processedData.domain.values[colorKeyIdx]) != null ? _c : [];
                this.colorScale.range = colorRange;
                this.colorScale.update();
              }
              this.animationState.transition("updateData");
            case 3:
              return _context81.a(2);
          }
        }, _callee70, this);
      }));
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      var dataModel = this.dataModel,
        processedData = this.processedData;
      if (!processedData || !dataModel) return [];
      var id = direction === "x" /* X */ ? "xValue" : "yValue";
      var dataDef = dataModel.resolveProcessedDataDefById(this, id);
      var domain = dataModel.getDomain(this, id, "value", processedData);
      if ((dataDef == null ? void 0 : dataDef.def.type) === "value" && (dataDef == null ? void 0 : dataDef.def.valueType) === "category") {
        return domain;
      }
      var axis = this.axes[direction];
      return _fixNumericExtent(_extent(domain), axis);
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee71() {
        var _a, _b, _c, axes, dataModel, processedData, colorScale, _this$properties27, xKey, yKey, labelKey, colorKey, xName, yName, labelName, marker, label, visible, placement, markerShape, xAxis, yAxis, xDataIdx, yDataIdx, colorDataIdx, labelDataIdx, xScale, yScale, xOffset, yOffset, nodeData, font, _iterator207, _step207, _step207$value, values, datum, xDatum, yDatum, x, y, labelText, size, fill;
        return _regenerator().w(function (_context82) {
          while (1) switch (_context82.n) {
            case 0:
              axes = this.axes, dataModel = this.dataModel, processedData = this.processedData, colorScale = this.colorScale;
              _this$properties27 = this.properties, xKey = _this$properties27.xKey, yKey = _this$properties27.yKey, labelKey = _this$properties27.labelKey, colorKey = _this$properties27.colorKey, xName = _this$properties27.xName, yName = _this$properties27.yName, labelName = _this$properties27.labelName, marker = _this$properties27.marker, label = _this$properties27.label, visible = _this$properties27.visible;
              placement = label.placement;
              markerShape = _getMarker(marker.shape);
              xAxis = axes["x" /* X */];
              yAxis = axes["y" /* Y */];
              if (dataModel && processedData && visible && xAxis && yAxis) {
                _context82.n = 1;
                break;
              }
              return _context82.a(2);
            case 1:
              xDataIdx = dataModel.resolveProcessedDataIndexById(this, "xValue");
              yDataIdx = dataModel.resolveProcessedDataIndexById(this, "yValue");
              colorDataIdx = colorKey ? dataModel.resolveProcessedDataIndexById(this, "colorValue") : -1;
              labelDataIdx = labelKey ? dataModel.resolveProcessedDataIndexById(this, "labelValue") : -1;
              xScale = xAxis.scale;
              yScale = yAxis.scale;
              xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
              yOffset = ((_b = yScale.bandwidth) != null ? _b : 0) / 2;
              nodeData = [];
              font = label.getFont();
              _iterator207 = _createForOfIteratorHelper((_c = processedData.data) != null ? _c : []);
              try {
                for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
                  _step207$value = _step207.value, values = _step207$value.values, datum = _step207$value.datum;
                  xDatum = values[xDataIdx];
                  yDatum = values[yDataIdx];
                  x = xScale.convert(xDatum) + xOffset;
                  y = yScale.convert(yDatum) + yOffset;
                  labelText = this.getLabelText(label, {
                    value: labelKey ? values[labelDataIdx] : yDatum,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    labelKey: labelKey,
                    xName: xName,
                    yName: yName,
                    labelName: labelName
                  });
                  size = _Text2.getTextSize(labelText, font);
                  fill = colorKey ? colorScale.convert(values[colorDataIdx]) : void 0;
                  nodeData.push({
                    series: this,
                    itemId: yKey,
                    yKey: yKey,
                    xKey: xKey,
                    datum: datum,
                    xValue: xDatum,
                    yValue: yDatum,
                    capDefaults: {
                      lengthRatioMultiplier: marker.getDiameter(),
                      lengthMax: Infinity
                    },
                    point: {
                      x: x,
                      y: y,
                      size: marker.size
                    },
                    midPoint: {
                      x: x,
                      y: y
                    },
                    fill: fill,
                    label: __spreadValues({
                      text: labelText
                    }, size),
                    marker: markerShape,
                    placement: placement
                  });
                }
              } catch (err) {
                _iterator207.e(err);
              } finally {
                _iterator207.f();
              }
              return _context82.a(2, {
                itemId: yKey,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                visible: this.visible
              });
          }
        }, _callee71, this);
      }));
    }
  }, {
    key: "isPathOrSelectionDirty",
    value: function isPathOrSelectionDirty() {
      return this.properties.marker.isDirty();
    }
  }, {
    key: "getLabelData",
    value: function getLabelData() {
      var _a, _b;
      return (_b = (_a = this.contextNodeData) == null ? void 0 : _a.labelData) != null ? _b : [];
    }
  }, {
    key: "markerFactory",
    value: function markerFactory() {
      var shape = this.properties.marker.shape;
      var MarkerShape = _getMarker(shape);
      return new MarkerShape();
    }
  }, {
    key: "updateMarkerSelection",
    value: function updateMarkerSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee72() {
        var nodeData, markerSelection;
        return _regenerator().w(function (_context83) {
          while (1) switch (_context83.n) {
            case 0:
              nodeData = opts.nodeData, markerSelection = opts.markerSelection;
              if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
              }
              return _context83.a(2, markerSelection.update(this.properties.marker.enabled ? nodeData : []));
          }
        }, _callee72, this);
      }));
    }
  }, {
    key: "updateMarkerNodes",
    value: function updateMarkerNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee73() {
        var _this206 = this;
        var markerSelection, highlighted, _this$properties28, xKey, yKey, labelKey, marker, highlightStyle, baseStyle;
        return _regenerator().w(function (_context84) {
          while (1) switch (_context84.n) {
            case 0:
              markerSelection = opts.markerSelection, highlighted = opts.isHighlight;
              _this$properties28 = this.properties, xKey = _this$properties28.xKey, yKey = _this$properties28.yKey, labelKey = _this$properties28.labelKey, marker = _this$properties28.marker, highlightStyle = _this$properties28.highlightStyle;
              baseStyle = _mergeDefaults4(highlighted && highlightStyle.item, marker.getStyle());
              markerSelection.each(function (node, datum) {
                _this206.updateMarkerStyle(node, marker, {
                  datum: datum,
                  highlighted: highlighted,
                  xKey: xKey,
                  yKey: yKey,
                  labelKey: labelKey
                }, baseStyle);
              });
              if (!highlighted) {
                marker.markClean();
              }
            case 1:
              return _context84.a(2);
          }
        }, _callee73, this);
      }));
    }
  }, {
    key: "updateLabelSelection",
    value: function updateLabelSelection(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee74() {
        var _a, _b, placedLabels;
        return _regenerator().w(function (_context85) {
          while (1) switch (_context85.n) {
            case 0:
              placedLabels = this.isLabelEnabled() ? (_b = (_a = this.chart) == null ? void 0 : _a.placeLabels().get(this)) != null ? _b : [] : [];
              return _context85.a(2, opts.labelSelection.update(placedLabels.map(function (_ref160) {
                var datum = _ref160.datum,
                  x = _ref160.x,
                  y = _ref160.y;
                return __spreadProps(__spreadValues({}, datum), {
                  point: {
                    x: x,
                    y: y,
                    size: datum.point.size
                  },
                  placement: "top"
                });
              }), function (text) {
                text.pointerEvents = 1 /* None */;
              }));
          }
        }, _callee74, this);
      }));
    }
  }, {
    key: "updateLabelNodes",
    value: function updateLabelNodes(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee75() {
        var label;
        return _regenerator().w(function (_context86) {
          while (1) switch (_context86.n) {
            case 0:
              label = this.properties.label;
              opts.labelSelection.each(function (text, datum) {
                var _a, _b, _c, _d;
                text.text = datum.label.text;
                text.fill = label.color;
                text.x = (_b = (_a = datum.point) == null ? void 0 : _a.x) != null ? _b : 0;
                text.y = (_d = (_c = datum.point) == null ? void 0 : _c.y) != null ? _d : 0;
                text.fontStyle = label.fontStyle;
                text.fontWeight = label.fontWeight;
                text.fontSize = label.fontSize;
                text.fontFamily = label.fontFamily;
                text.textAlign = "left";
                text.textBaseline = "top";
              });
            case 1:
              return _context86.a(2);
          }
        }, _callee75, this);
      }));
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var xAxis = this.axes["x" /* X */];
      var yAxis = this.axes["y" /* Y */];
      if (!this.properties.isValid() || !xAxis || !yAxis) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var _this$properties29 = this.properties,
        xKey = _this$properties29.xKey,
        yKey = _this$properties29.yKey,
        labelKey = _this$properties29.labelKey,
        xName = _this$properties29.xName,
        yName = _this$properties29.yName,
        labelName = _this$properties29.labelName,
        _this$properties29$ti = _this$properties29.title,
        title = _this$properties29$ti === void 0 ? yName : _this$properties29$ti,
        marker = _this$properties29.marker,
        tooltip = _this$properties29.tooltip;
      var datum = nodeDatum.datum,
        xValue = nodeDatum.xValue,
        yValue = nodeDatum.yValue,
        label = nodeDatum.label,
        itemId = nodeDatum.itemId;
      var baseStyle = _mergeDefaults4({
        fill: nodeDatum.fill,
        strokeWidth: this.getStrokeWidth(marker.strokeWidth)
      }, marker.getStyle());
      var _this$getMarkerStyle5 = this.getMarkerStyle(marker, {
          datum: nodeDatum,
          highlighted: false,
          xKey: xKey,
          yKey: yKey,
          labelKey: labelKey
        }, baseStyle),
        _this$getMarkerStyle6 = _this$getMarkerStyle5.fill,
        color = _this$getMarkerStyle6 === void 0 ? "gray" : _this$getMarkerStyle6;
      var xString = _sanitizeHtml(xAxis.formatDatum(xValue));
      var yString = _sanitizeHtml(yAxis.formatDatum(yValue));
      var content = "<b>".concat(_sanitizeHtml(xName != null ? xName : xKey), "</b>: ").concat(xString, "<br><b>").concat(_sanitizeHtml(yName != null ? yName : yKey), "</b>: ").concat(yString);
      if (labelKey) {
        content = "<b>".concat(_sanitizeHtml(labelName != null ? labelName : labelKey), "</b>: ").concat(_sanitizeHtml(label.text), "<br>") + content;
      }
      return tooltip.toTooltipHtml({
        title: title,
        content: content,
        backgroundColor: color
      }, __spreadValues({
        datum: datum,
        itemId: itemId,
        xKey: xKey,
        xName: xName,
        yKey: yKey,
        yName: yName,
        labelKey: labelKey,
        labelName: labelName,
        title: title,
        color: color,
        seriesId: this.id
      }, this.getModuleTooltipParams()));
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b, _c, _d, _e, _f;
      var _this$properties30 = this.properties,
        yKey = _this$properties30.yKey,
        yName = _this$properties30.yName,
        title = _this$properties30.title,
        marker = _this$properties30.marker,
        visible = _this$properties30.visible;
      var fill = marker.fill,
        stroke = marker.stroke,
        fillOpacity = marker.fillOpacity,
        strokeOpacity = marker.strokeOpacity,
        strokeWidth = marker.strokeWidth;
      if (!((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid() || legendType !== "category") {
        return [];
      }
      return [{
        legendType: "category",
        id: this.id,
        itemId: yKey,
        seriesId: this.id,
        enabled: visible,
        label: {
          text: (_b = title != null ? title : yName) != null ? _b : yKey
        },
        marker: {
          shape: marker.shape,
          fill: (_d = (_c = marker.fill) != null ? _c : fill) != null ? _d : "rgba(0, 0, 0, 0)",
          stroke: (_f = (_e = marker.stroke) != null ? _e : stroke) != null ? _f : "rgba(0, 0, 0, 0)",
          fillOpacity: fillOpacity != null ? fillOpacity : 1,
          strokeOpacity: strokeOpacity != null ? strokeOpacity : 1,
          strokeWidth: strokeWidth != null ? strokeWidth : 0
        }
      }];
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(data) {
      var markerSelection = data.markerSelection,
        labelSelection = data.labelSelection,
        annotationSelections = data.annotationSelections;
      _markerScaleInAnimation(this, this.ctx.animationManager, markerSelection);
      _seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
      _seriesLabelFadeInAnimation.apply(void 0, [this, "annotations", this.ctx.animationManager].concat(_toConsumableArray(annotationSelections)));
    }
  }, {
    key: "isLabelEnabled",
    value: function isLabelEnabled() {
      return this.properties.label.enabled;
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Group4();
    }
  }, {
    key: "getFormattedMarkerStyle",
    value: function getFormattedMarkerStyle(datum) {
      var _this$properties31 = this.properties,
        xKey = _this$properties31.xKey,
        yKey = _this$properties31.yKey,
        labelKey = _this$properties31.labelKey;
      return this.getMarkerStyle(this.properties.marker, {
        datum: datum,
        xKey: xKey,
        yKey: yKey,
        labelKey: labelKey,
        highlighted: true
      });
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(opts) {
      return _computeMarkerFocusBounds(this, opts);
    }
  }]);
  return ScatterSeries;
}(_CartesianSeries7);
ScatterSeries.className = "ScatterSeries";
ScatterSeries.type = "scatter";

// packages/ag-charts-community/src/chart/series/cartesian/scatterSeriesModule.ts
var ScatterSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["cartesian"],
  identifier: "scatter",
  instanceConstructor: ScatterSeries,
  defaultAxes: [{
    type: "number" /* NUMBER */,
    position: "bottom" /* BOTTOM */
  }, {
    type: "number" /* NUMBER */,
    position: "left" /* LEFT */
  }],
  themeTemplate: {
    series: {
      __extends__: _EXTENDS_SERIES_DEFAULTS,
      tooltip: {
        position: {
          type: "node"
        }
      },
      marker: {
        __extends__: _EXTENDS_CARTESIAN_MARKER_DEFAULTS,
        fillOpacity: 0.8
      },
      label: {
        enabled: false,
        fontSize: 12,
        fontFamily: _DEFAULT_FONT_FAMILY,
        color: _DEFAULT_LABEL_COLOUR
      }
    }
  },
  enterpriseThemeTemplate: {
    series: {
      errorBar: {
        cap: {
          lengthRatio: 1
        }
      }
    }
  },
  paletteFactory: _markerPaletteFactory3
};

// packages/ag-charts-community/src/scene/sectorBox.ts
var _SectorBox2 = /*#__PURE__*/function () {
  function _SectorBox(startAngle, endAngle, innerRadius, outerRadius) {
    _classCallCheck(this, _SectorBox);
    this.startAngle = startAngle;
    this.endAngle = endAngle;
    this.innerRadius = innerRadius;
    this.outerRadius = outerRadius;
  }
  _createClass(_SectorBox, [{
    key: "clone",
    value: function clone() {
      var startAngle = this.startAngle,
        endAngle = this.endAngle,
        innerRadius = this.innerRadius,
        outerRadius = this.outerRadius;
      return new _SectorBox(startAngle, endAngle, innerRadius, outerRadius);
    }
  }, {
    key: interpolate,
    value: function value(other, d) {
      return new _SectorBox(this.startAngle * (1 - d) + other.startAngle * d, this.endAngle * (1 - d) + other.endAngle * d, this.innerRadius * (1 - d) + other.innerRadius * d, this.outerRadius * (1 - d) + other.outerRadius * d);
    }
  }]);
  return _SectorBox;
}();

// packages/ag-charts-community/src/scene/util/sector.ts
function isPointInSector(x, y, sector) {
  var radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  var innerRadius = sector.innerRadius,
    outerRadius = sector.outerRadius;
  if (sector.startAngle === sector.endAngle || radius < Math.min(innerRadius, outerRadius) || radius > Math.max(innerRadius, outerRadius)) {
    return false;
  }
  var startAngle = _normalizeAngle(sector.startAngle);
  var endAngle = _normalizeAngle(sector.endAngle);
  var angle = Math.atan2(y, x);
  return startAngle < endAngle ? angle <= endAngle && angle >= startAngle : angle <= endAngle && angle >= -Math.PI || angle >= startAngle && angle <= Math.PI;
}
function lineCollidesSector(line, sector) {
  var startAngle = sector.startAngle,
    endAngle = sector.endAngle,
    innerRadius = sector.innerRadius,
    outerRadius = sector.outerRadius;
  var outerStart = {
    x: outerRadius * Math.cos(startAngle),
    y: outerRadius * Math.sin(startAngle)
  };
  var outerEnd = {
    x: outerRadius * Math.cos(endAngle),
    y: outerRadius * Math.sin(endAngle)
  };
  var innerStart = innerRadius === 0 ? {
    x: 0,
    y: 0
  } : {
    x: innerRadius * Math.cos(startAngle),
    y: innerRadius * Math.sin(startAngle)
  };
  var innerEnd = innerRadius === 0 ? {
    x: 0,
    y: 0
  } : {
    x: innerRadius * Math.cos(endAngle),
    y: innerRadius * Math.sin(endAngle)
  };
  return segmentIntersection(line.start.x, line.start.y, line.end.x, line.end.y, outerStart.x, outerStart.y, innerStart.x, innerStart.y) || segmentIntersection(line.start.x, line.start.y, line.end.x, line.end.y, outerEnd.x, outerEnd.y, innerEnd.x, innerEnd.y) || arcIntersections(0, 0, outerRadius, startAngle, endAngle, true, line.start.x, line.start.y, line.end.x, line.end.y);
}
function boxCollidesSector(box, sector) {
  var topLeft = {
    x: box.x,
    y: box.y
  };
  var topRight = {
    x: box.x + box.width,
    y: box.y
  };
  var bottomLeft = {
    x: box.x,
    y: box.y + box.height
  };
  var bottomRight = {
    x: box.x + box.width,
    y: box.y + box.height
  };
  return lineCollidesSector({
    start: topLeft,
    end: topRight
  }, sector) || lineCollidesSector({
    start: bottomLeft,
    end: bottomRight
  }, sector);
}
function radiiScalingFactor(r, sweep, a, b) {
  if (a === 0 && b === 0) return 0;
  var fs1 = Math.asin(Math.abs(1 * a) / (r + 1 * a)) + Math.asin(Math.abs(1 * b) / (r + 1 * b)) - sweep;
  if (fs1 < 0) return 1;
  var start = 0;
  var end = 1;
  for (var i = 0; i < 8; i += 1) {
    var s = (start + end) / 2;
    var fs = Math.asin(Math.abs(s * a) / (r + s * a)) + Math.asin(Math.abs(s * b) / (r + s * b)) - sweep;
    if (fs < 0) {
      start = s;
    } else {
      end = s;
    }
  }
  return start;
}
var delta = 1e-6;
function clockwiseAngle(angle, relativeToStartAngle) {
  if (_angleBetween(angle, relativeToStartAngle) < delta) {
    return relativeToStartAngle;
  } else {
    return _normalizeAngle2(angle - relativeToStartAngle) + relativeToStartAngle;
  }
}
function clockwiseAngles(startAngle, endAngle) {
  var relativeToStartAngle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var fullPie = Math.abs(endAngle - startAngle) >= 2 * Math.PI;
  var sweepAngle = fullPie ? 2 * Math.PI : _normalizeAngle2(endAngle - startAngle);
  startAngle = clockwiseAngle(startAngle, relativeToStartAngle);
  endAngle = startAngle + sweepAngle;
  return {
    startAngle: startAngle,
    endAngle: endAngle
  };
}
function arcRadialLineIntersectionAngle(cx, cy, r, startAngle, endAngle, clipAngle) {
  var sinA = Math.sin(clipAngle);
  var cosA = Math.cos(clipAngle);
  var c = __pow(cx, 2) + __pow(cy, 2) - __pow(r, 2);
  var p0x = NaN;
  var p0y = NaN;
  var p1x = NaN;
  var p1y = NaN;
  if (cosA > 0.5) {
    var tanA = sinA / cosA;
    var a = 1 + __pow(tanA, 2);
    var b = -2 * (cx + cy * tanA);
    var d = __pow(b, 2) - 4 * a * c;
    if (d < 0) return;
    var x0 = (-b + Math.sqrt(d)) / (2 * a);
    var x1 = (-b - Math.sqrt(d)) / (2 * a);
    p0x = x0;
    p0y = x0 * tanA;
    p1x = x1;
    p1y = x1 * tanA;
  } else {
    var cotA = cosA / sinA;
    var _a3 = 1 + __pow(cotA, 2);
    var _b3 = -2 * (cy + cx * cotA);
    var _d3 = __pow(_b3, 2) - 4 * _a3 * c;
    if (_d3 < 0) return;
    var y0 = (-_b3 + Math.sqrt(_d3)) / (2 * _a3);
    var y1 = (-_b3 - Math.sqrt(_d3)) / (2 * _a3);
    p0x = y0 * cotA;
    p0y = y0;
    p1x = y1 * cotA;
    p1y = y1;
  }
  var normalisedX = cosA;
  var normalisedY = sinA;
  var p0DotNormalized = p0x * normalisedX + p0y * normalisedY;
  var p1DotNormalized = p1x * normalisedX + p1y * normalisedY;
  var a0 = p0DotNormalized > 0 ? clockwiseAngle(Math.atan2(p0y - cy, p0x - cx), startAngle) : NaN;
  var a1 = p1DotNormalized > 0 ? clockwiseAngle(Math.atan2(p1y - cy, p1x - cx), startAngle) : NaN;
  if (a0 >= startAngle && a0 <= endAngle) {
    return a0;
  } else if (a1 >= startAngle && a1 <= endAngle) {
    return a1;
  }
}
function arcCircleIntersectionAngle(cx, cy, r, startAngle, endAngle, circleR) {
  var d = Math.hypot(cx, cy);
  var d1 = (__pow(d, 2) - __pow(r, 2) + __pow(circleR, 2)) / (2 * d);
  var d2 = d - d1;
  var theta = Math.atan2(cy, cx);
  var deltaTheta = Math.acos(-d2 / r);
  var a0 = clockwiseAngle(theta + deltaTheta, startAngle);
  var a1 = clockwiseAngle(theta - deltaTheta, startAngle);
  if (a0 >= startAngle && a0 <= endAngle) {
    return a0;
  } else if (a1 >= startAngle && a1 <= endAngle) {
    return a1;
  }
}

// packages/ag-charts-community/src/scene/shape/sector.ts
var Arc = /*#__PURE__*/function () {
  function Arc(cx, cy, r, a0, a1) {
    _classCallCheck(this, Arc);
    this.cx = cx;
    this.cy = cy;
    this.r = r;
    this.a0 = a0;
    this.a1 = a1;
    if (this.a0 >= this.a1) {
      this.a0 = NaN;
      this.a1 = NaN;
    }
  }
  _createClass(Arc, [{
    key: "isValid",
    value: function isValid() {
      return Number.isFinite(this.a0) && Number.isFinite(this.a1);
    }
  }, {
    key: "pointAt",
    value: function pointAt(a) {
      return {
        x: this.cx + this.r * Math.cos(a),
        y: this.cy + this.r * Math.sin(a)
      };
    }
  }, {
    key: "clipStart",
    value: function clipStart(a) {
      if (a == null || !this.isValid() || a < this.a0) return;
      this.a0 = a;
      if (Number.isNaN(a) || this.a0 >= this.a1) {
        this.a0 = NaN;
        this.a1 = NaN;
      }
    }
  }, {
    key: "clipEnd",
    value: function clipEnd(a) {
      if (a == null || !this.isValid() || a > this.a1) return;
      this.a1 = a;
      if (Number.isNaN(a) || this.a0 >= this.a1) {
        this.a0 = NaN;
        this.a1 = NaN;
      }
    }
  }]);
  return Arc;
}();
var _Sector = /*#__PURE__*/function (_Path5) {
  _inherits(Sector, _Path5);
  function Sector() {
    var _this207;
    _classCallCheck(this, Sector);
    _this207 = _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
    _this207.centerX = 0;
    _this207.centerY = 0;
    _this207.innerRadius = 10;
    _this207.outerRadius = 20;
    _this207.startAngle = 0;
    _this207.endAngle = Math.PI * 2;
    _this207.clipSector = void 0;
    _this207.concentricEdgeInset = 0;
    _this207.radialEdgeInset = 0;
    _this207.startOuterCornerRadius = 0;
    _this207.endOuterCornerRadius = 0;
    _this207.startInnerCornerRadius = 0;
    _this207.endInnerCornerRadius = 0;
    return _this207;
  }
  _createClass(Sector, [{
    key: "computeBBox",
    value: function computeBBox() {
      var radius = this.outerRadius;
      return new _BBox2(this.centerX - radius, this.centerY - radius, radius * 2, radius * 2);
    }
  }, {
    key: "normalizedRadii",
    value: function normalizedRadii() {
      var concentricEdgeInset = this.concentricEdgeInset;
      return {
        innerRadius: Math.max(Math.min(this.innerRadius, this.outerRadius) + concentricEdgeInset, 0),
        outerRadius: Math.max(Math.max(this.innerRadius, this.outerRadius) - concentricEdgeInset, 0)
      };
    }
  }, {
    key: "normalizedClipSector",
    value: function normalizedClipSector() {
      var clipSector = this.clipSector;
      if (clipSector == null) return;
      var _clockwiseAngles = clockwiseAngles(this.startAngle, this.endAngle),
        startAngle = _clockwiseAngles.startAngle,
        endAngle = _clockwiseAngles.endAngle;
      var _this$normalizedRadii = this.normalizedRadii(),
        innerRadius = _this$normalizedRadii.innerRadius,
        outerRadius = _this$normalizedRadii.outerRadius;
      var clipAngles = clockwiseAngles(clipSector.startAngle, clipSector.endAngle, startAngle);
      return new _SectorBox2(Math.max(startAngle, clipAngles.startAngle), Math.min(endAngle, clipAngles.endAngle), Math.max(innerRadius, clipSector.innerRadius), Math.min(outerRadius, clipSector.outerRadius));
    }
  }, {
    key: "getAngleOffset",
    value: function getAngleOffset(radius) {
      return radius > 0 ? this.radialEdgeInset / radius : 0;
    }
  }, {
    key: "arc",
    value: function arc(r, angleSweep, a0, a1, outerArc, innerArc, start, inner) {
      if (r <= 0) return;
      var _clockwiseAngles2 = clockwiseAngles(this.startAngle, this.endAngle),
        startAngle = _clockwiseAngles2.startAngle,
        endAngle = _clockwiseAngles2.endAngle;
      var _this$normalizedRadii2 = this.normalizedRadii(),
        innerRadius = _this$normalizedRadii2.innerRadius,
        outerRadius = _this$normalizedRadii2.outerRadius;
      var clipSector = this.normalizedClipSector();
      if (inner && innerRadius <= 0) return;
      var innerAngleOffset = this.getAngleOffset(innerRadius);
      var outerAngleOffset = this.getAngleOffset(outerRadius);
      var angleOffset = inner ? this.getAngleOffset(innerRadius + r) : this.getAngleOffset(outerRadius - r);
      var angle = start ? startAngle + angleOffset + angleSweep : endAngle - angleOffset - angleSweep;
      var radius = inner ? innerRadius + r : outerRadius - r;
      var cx = radius * Math.cos(angle);
      var cy = radius * Math.sin(angle);
      if (clipSector != null) {
        var delta2 = 1e-6;
        if (!start && !(angle >= startAngle - delta2 && angle <= clipSector.endAngle - delta2)) return;
        if (start && !(angle >= clipSector.startAngle + delta2 && angle <= endAngle - delta2)) return;
        if (inner && !(radius >= clipSector.innerRadius - delta2)) return;
        if (!inner && !(radius <= clipSector.outerRadius + delta2)) return;
      }
      var arc = new Arc(cx, cy, r, a0, a1);
      if (clipSector != null) {
        if (inner) {
          arc.clipStart(arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.endAngle - innerAngleOffset));
          arc.clipEnd(arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.startAngle + innerAngleOffset));
        } else {
          arc.clipStart(arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.startAngle + outerAngleOffset));
          arc.clipEnd(arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.endAngle - outerAngleOffset));
        }
        var circleClipStart;
        var circleClipEnd;
        if (start) {
          circleClipStart = arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.innerRadius);
          circleClipEnd = arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.outerRadius);
        } else {
          circleClipStart = arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.outerRadius);
          circleClipEnd = arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.innerRadius);
        }
        arc.clipStart(circleClipStart);
        arc.clipEnd(circleClipEnd);
        if (circleClipStart != null) {
          var _arc$pointAt = arc.pointAt(circleClipStart),
            x2 = _arc$pointAt.x,
            y2 = _arc$pointAt.y;
          var theta2 = clockwiseAngle(Math.atan2(y2, x2), startAngle);
          if (start) {
            innerArc == null ? void 0 : innerArc.clipStart(theta2);
          } else {
            outerArc.clipEnd(theta2);
          }
        }
        if (circleClipEnd != null) {
          var _arc$pointAt2 = arc.pointAt(circleClipEnd),
            _x1 = _arc$pointAt2.x,
            _y1 = _arc$pointAt2.y;
          var _theta = clockwiseAngle(Math.atan2(_y1, _x1), startAngle);
          if (start) {
            outerArc.clipStart(_theta);
          } else {
            innerArc == null ? void 0 : innerArc.clipEnd(_theta);
          }
        }
      }
      if (clipSector != null) {
        var _arc$pointAt3 = arc.pointAt((arc.a0 + arc.a1) / 2),
          _x10 = _arc$pointAt3.x,
          _y10 = _arc$pointAt3.y;
        if (!isPointInSector(_x10, _y10, clipSector)) return;
      }
      var _arc$pointAt4 = arc.pointAt(start === inner ? arc.a0 : arc.a1),
        x = _arc$pointAt4.x,
        y = _arc$pointAt4.y;
      var theta = clockwiseAngle(Math.atan2(y, x), startAngle);
      var radialArc = inner ? innerArc : outerArc;
      if (start) {
        radialArc == null ? void 0 : radialArc.clipStart(theta);
      } else {
        radialArc == null ? void 0 : radialArc.clipEnd(theta);
      }
      return arc;
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var _a, _b, _c, _d, _e;
      var delta2 = 1e-6;
      var path = this.path,
        centerX = this.centerX,
        centerY = this.centerY,
        concentricEdgeInset = this.concentricEdgeInset,
        radialEdgeInset = this.radialEdgeInset;
      var startOuterCornerRadius = this.startOuterCornerRadius,
        endOuterCornerRadius = this.endOuterCornerRadius,
        startInnerCornerRadius = this.startInnerCornerRadius,
        endInnerCornerRadius = this.endInnerCornerRadius;
      var _clockwiseAngles3 = clockwiseAngles(this.startAngle, this.endAngle),
        startAngle = _clockwiseAngles3.startAngle,
        endAngle = _clockwiseAngles3.endAngle;
      var _this$normalizedRadii3 = this.normalizedRadii(),
        innerRadius = _this$normalizedRadii3.innerRadius,
        outerRadius = _this$normalizedRadii3.outerRadius;
      var clipSector = this.normalizedClipSector();
      var sweepAngle = endAngle - startAngle;
      var fullPie = sweepAngle >= 2 * Math.PI - delta2;
      path.clear();
      if (((_a = clipSector == null ? void 0 : clipSector.startAngle) != null ? _a : startAngle) === ((_b = clipSector == null ? void 0 : clipSector.endAngle) != null ? _b : endAngle)) {
        return;
      } else if (fullPie && this.clipSector == null && startOuterCornerRadius === 0 && endOuterCornerRadius === 0 && startInnerCornerRadius === 0 && endInnerCornerRadius === 0) {
        path.moveTo(centerX + outerRadius * Math.cos(startAngle), centerY + outerRadius * Math.sin(startAngle));
        path.arc(centerX, centerY, outerRadius, startAngle, endAngle);
        if (innerRadius > concentricEdgeInset) {
          path.moveTo(centerX + innerRadius * Math.cos(endAngle), centerY + innerRadius * Math.sin(endAngle));
          path.arc(centerX, centerY, innerRadius, endAngle, startAngle, true);
        }
        path.closePath();
        return;
      }
      var innerAngleOffset = this.getAngleOffset(innerRadius);
      var outerAngleOffset = this.getAngleOffset(outerRadius);
      var outerAngleExceeded = sweepAngle < 2 * outerAngleOffset;
      if (outerAngleExceeded) return;
      var hasInnerSweep = ((_c = clipSector == null ? void 0 : clipSector.innerRadius) != null ? _c : innerRadius) > concentricEdgeInset;
      var innerAngleExceeded = innerRadius < concentricEdgeInset || sweepAngle < 2 * innerAngleOffset;
      var radialLength = outerRadius - innerRadius;
      var maxRadialLength = Math.max(startOuterCornerRadius, startInnerCornerRadius, endOuterCornerRadius, endInnerCornerRadius);
      var initialScalingFactor = maxRadialLength > 0 ? Math.min(radialLength / maxRadialLength, 1) : 1;
      startOuterCornerRadius *= initialScalingFactor;
      endOuterCornerRadius *= initialScalingFactor;
      startInnerCornerRadius *= initialScalingFactor;
      endInnerCornerRadius *= initialScalingFactor;
      var outerScalingFactor = radiiScalingFactor(outerRadius, sweepAngle - 2 * outerAngleOffset, -startOuterCornerRadius, -endOuterCornerRadius);
      startOuterCornerRadius *= outerScalingFactor;
      endOuterCornerRadius *= outerScalingFactor;
      if (!innerAngleExceeded && hasInnerSweep) {
        var innerScalingFactor = radiiScalingFactor(innerRadius, sweepAngle - 2 * innerAngleOffset, startInnerCornerRadius, endInnerCornerRadius);
        startInnerCornerRadius *= innerScalingFactor;
        endInnerCornerRadius *= innerScalingFactor;
      } else {
        startInnerCornerRadius = 0;
        endInnerCornerRadius = 0;
      }
      var maxCombinedRadialLength = Math.max(startOuterCornerRadius + startInnerCornerRadius, endOuterCornerRadius + endInnerCornerRadius);
      var edgesScalingFactor = maxCombinedRadialLength > 0 ? Math.min(radialLength / maxCombinedRadialLength, 1) : 1;
      startOuterCornerRadius *= edgesScalingFactor;
      endOuterCornerRadius *= edgesScalingFactor;
      startInnerCornerRadius *= edgesScalingFactor;
      endInnerCornerRadius *= edgesScalingFactor;
      var startOuterCornerRadiusAngleSweep = 0;
      var endOuterCornerRadiusAngleSweep = 0;
      var startOuterCornerRadiusSweep = startOuterCornerRadius / (outerRadius - startOuterCornerRadius);
      var endOuterCornerRadiusSweep = endOuterCornerRadius / (outerRadius - endOuterCornerRadius);
      if (startOuterCornerRadiusSweep >= 0 && startOuterCornerRadiusSweep < 1 - delta2) {
        startOuterCornerRadiusAngleSweep = Math.asin(startOuterCornerRadiusSweep);
      } else {
        startOuterCornerRadiusAngleSweep = sweepAngle / 2;
        var maxStartOuterCornerRadius = outerRadius / (1 / Math.sin(startOuterCornerRadiusAngleSweep) + 1);
        startOuterCornerRadius = Math.min(maxStartOuterCornerRadius, startOuterCornerRadius);
      }
      if (endOuterCornerRadiusSweep >= 0 && endOuterCornerRadiusSweep < 1 - delta2) {
        endOuterCornerRadiusAngleSweep = Math.asin(endOuterCornerRadiusSweep);
      } else {
        endOuterCornerRadiusAngleSweep = sweepAngle / 2;
        var maxEndOuterCornerRadius = outerRadius / (1 / Math.sin(endOuterCornerRadiusAngleSweep) + 1);
        endOuterCornerRadius = Math.min(maxEndOuterCornerRadius, endOuterCornerRadius);
      }
      var startInnerCornerRadiusAngleSweep = Math.asin(startInnerCornerRadius / (innerRadius + startInnerCornerRadius));
      var endInnerCornerRadiusAngleSweep = Math.asin(endInnerCornerRadius / (innerRadius + endInnerCornerRadius));
      var outerArcRadius = (_d = clipSector == null ? void 0 : clipSector.outerRadius) != null ? _d : outerRadius;
      var outerArcRadiusOffset = this.getAngleOffset(outerArcRadius);
      var outerArc = new Arc(0, 0, outerArcRadius, startAngle + outerArcRadiusOffset, endAngle - outerArcRadiusOffset);
      var innerArcRadius = (_e = clipSector == null ? void 0 : clipSector.innerRadius) != null ? _e : innerRadius;
      var innerArcRadiusOffset = this.getAngleOffset(innerArcRadius);
      var innerArc = hasInnerSweep ? new Arc(0, 0, innerArcRadius, startAngle + innerArcRadiusOffset, endAngle - innerArcRadiusOffset) : void 0;
      if (clipSector != null) {
        outerArc.clipStart(clipSector.startAngle);
        outerArc.clipEnd(clipSector.endAngle);
        innerArc == null ? void 0 : innerArc.clipStart(clipSector.startAngle);
        innerArc == null ? void 0 : innerArc.clipEnd(clipSector.endAngle);
      }
      var startOuterArc = this.arc(startOuterCornerRadius, startOuterCornerRadiusAngleSweep, startAngle - Math.PI * 0.5, startAngle + startOuterCornerRadiusAngleSweep, outerArc, innerArc, true, false);
      var endOuterArc = this.arc(endOuterCornerRadius, endOuterCornerRadiusAngleSweep, endAngle - endOuterCornerRadiusAngleSweep, endAngle + Math.PI * 0.5, outerArc, innerArc, false, false);
      var endInnerArc = this.arc(endInnerCornerRadius, endInnerCornerRadiusAngleSweep, endAngle + Math.PI * 0.5, endAngle + Math.PI - endInnerCornerRadiusAngleSweep, outerArc, innerArc, false, true);
      var startInnerArc = this.arc(startInnerCornerRadius, startInnerCornerRadiusAngleSweep, startAngle + Math.PI + startInnerCornerRadiusAngleSweep, startAngle + Math.PI * 1.5, outerArc, innerArc, true, true);
      if (innerAngleExceeded) {
        var x = sweepAngle < Math.PI * 0.5 ? radialEdgeInset * (1 + Math.cos(sweepAngle)) / Math.sin(sweepAngle) : NaN;
        var r;
        if (x > 0 && x < outerRadius) {
          r = Math.max(Math.hypot(radialEdgeInset, x), innerRadius);
        } else {
          r = innerRadius;
        }
        var midAngle = startAngle + sweepAngle * 0.5;
        path.moveTo(centerX + r * Math.cos(midAngle), centerY + r * Math.sin(midAngle));
      } else if ((startInnerArc == null ? void 0 : startInnerArc.isValid()) === true) {
        var _startInnerArc$pointA = startInnerArc.pointAt(startInnerArc.a1),
          _x11 = _startInnerArc$pointA.x,
          y = _startInnerArc$pointA.y;
        path.moveTo(centerX + _x11, centerY + y);
      } else if ((innerArc == null ? void 0 : innerArc.isValid()) === true) {
        var _innerArc$pointAt = innerArc.pointAt(innerArc.a0),
          _x12 = _innerArc$pointAt.x,
          _y11 = _innerArc$pointAt.y;
        path.moveTo(centerX + _x12, centerY + _y11);
      } else {
        var _midAngle = startAngle + sweepAngle / 2;
        var cx = innerRadius * Math.cos(_midAngle);
        var cy = innerRadius * Math.sin(_midAngle);
        path.moveTo(centerX + cx, centerY + cy);
      }
      if ((startOuterArc == null ? void 0 : startOuterArc.isValid()) === true) {
        var _cx4 = startOuterArc.cx,
          _cy4 = startOuterArc.cy,
          _r = startOuterArc.r,
          a0 = startOuterArc.a0,
          a1 = startOuterArc.a1;
        path.arc(centerX + _cx4, centerY + _cy4, _r, a0, a1);
      }
      if (outerArc.isValid()) {
        var _r2 = outerArc.r,
          _a4 = outerArc.a0,
          _a5 = outerArc.a1;
        path.arc(centerX, centerY, _r2, _a4, _a5);
      }
      if ((endOuterArc == null ? void 0 : endOuterArc.isValid()) === true) {
        var _cx5 = endOuterArc.cx,
          _cy5 = endOuterArc.cy,
          _r3 = endOuterArc.r,
          _a6 = endOuterArc.a0,
          _a7 = endOuterArc.a1;
        path.arc(centerX + _cx5, centerY + _cy5, _r3, _a6, _a7);
      }
      if (!innerAngleExceeded) {
        if ((endInnerArc == null ? void 0 : endInnerArc.isValid()) === true) {
          var _cx6 = endInnerArc.cx,
            _cy6 = endInnerArc.cy,
            _r4 = endInnerArc.r,
            _a8 = endInnerArc.a0,
            _a9 = endInnerArc.a1;
          path.arc(centerX + _cx6, centerY + _cy6, _r4, _a8, _a9);
        }
        if ((innerArc == null ? void 0 : innerArc.isValid()) === true) {
          var _r5 = innerArc.r,
            _a0 = innerArc.a0,
            _a1 = innerArc.a1;
          path.arc(centerX, centerY, _r5, _a1, _a0, true);
        }
        if ((startInnerArc == null ? void 0 : startInnerArc.isValid()) === true) {
          var _cx7 = startInnerArc.cx,
            _cy7 = startInnerArc.cy,
            _r6 = startInnerArc.r,
            _a10 = startInnerArc.a0,
            _a11 = startInnerArc.a1;
          path.arc(centerX + _cx7, centerY + _cy7, _r6, _a10, _a11);
        }
      }
      path.closePath();
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var _a;
      var point = this.transformPoint(x, y);
      var _ref161 = (_a = this.clipSector) != null ? _a : this,
        startAngle = _ref161.startAngle,
        endAngle = _ref161.endAngle,
        innerRadius = _ref161.innerRadius,
        outerRadius = _ref161.outerRadius;
      return isPointInSector(point.x, point.y, {
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: Math.min(innerRadius, outerRadius),
        outerRadius: Math.max(innerRadius, outerRadius)
      });
    }
  }, {
    key: "inset",
    set: function set(value) {
      this.concentricEdgeInset = value;
      this.radialEdgeInset = value;
    }
  }, {
    key: "cornerRadius",
    set: function set(value) {
      this.startOuterCornerRadius = value;
      this.endOuterCornerRadius = value;
      this.startInnerCornerRadius = value;
      this.endInnerCornerRadius = value;
    }
  }]);
  return Sector;
}(_Path6);
_Sector.className = "Sector";
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "centerX", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "centerY", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "innerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "outerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "startAngle", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "endAngle", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "clipSector", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "concentricEdgeInset", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "radialEdgeInset", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "startOuterCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "endOuterCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "startInnerCornerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _Sector.prototype, "endInnerCornerRadius", 2);

// packages/ag-charts-community/src/chart/series/polar/donutSeriesProperties.ts
var DonutTitle = /*#__PURE__*/function (_Caption) {
  _inherits(DonutTitle, _Caption);
  function DonutTitle() {
    var _this208;
    _classCallCheck(this, DonutTitle);
    _this208 = _possibleConstructorReturn(this, _getPrototypeOf(DonutTitle).apply(this, arguments));
    _this208.showInLegend = false;
    return _this208;
  }
  return DonutTitle;
}(_Caption3);
__decorateClass([_Validate(_BOOLEAN)], DonutTitle.prototype, "showInLegend", 2);
var DonutInnerLabel = /*#__PURE__*/function (_Label4) {
  _inherits(DonutInnerLabel, _Label4);
  function DonutInnerLabel() {
    var _this209;
    _classCallCheck(this, DonutInnerLabel);
    _this209 = _possibleConstructorReturn(this, _getPrototypeOf(DonutInnerLabel).apply(this, arguments));
    _this209.margin = 2;
    return _this209;
  }
  _createClass(DonutInnerLabel, [{
    key: "set",
    value: function set(properties, _reset) {
      return _superPropGet(DonutInnerLabel, "set", this, 3)([properties]);
    }
  }]);
  return DonutInnerLabel;
}(_Label0);
__decorateClass([_Validate(_STRING)], DonutInnerLabel.prototype, "text", 2);
__decorateClass([_Validate(_NUMBER)], DonutInnerLabel.prototype, "margin", 2);
var DonutInnerCircle = /*#__PURE__*/function (_BaseProperties30) {
  _inherits(DonutInnerCircle, _BaseProperties30);
  function DonutInnerCircle() {
    var _this210;
    _classCallCheck(this, DonutInnerCircle);
    _this210 = _possibleConstructorReturn(this, _getPrototypeOf(DonutInnerCircle).apply(this, arguments));
    _this210.fill = "transparent";
    _this210.fillOpacity = 1;
    return _this210;
  }
  return DonutInnerCircle;
}(_BaseProperties35);
__decorateClass([_Validate(_COLOR_STRING)], DonutInnerCircle.prototype, "fill", 2);
__decorateClass([_Validate(_RATIO)], DonutInnerCircle.prototype, "fillOpacity", 2);
var DonutSeriesCalloutLabel = /*#__PURE__*/function (_Label5) {
  _inherits(DonutSeriesCalloutLabel, _Label5);
  function DonutSeriesCalloutLabel() {
    var _this211;
    _classCallCheck(this, DonutSeriesCalloutLabel);
    _this211 = _possibleConstructorReturn(this, _getPrototypeOf(DonutSeriesCalloutLabel).apply(this, arguments));
    _this211.offset = 3;
    _this211.minAngle = 0;
    _this211.minSpacing = 4;
    _this211.maxCollisionOffset = 50;
    _this211.avoidCollisions = true;
    return _this211;
  }
  return DonutSeriesCalloutLabel;
}(_Label0);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesCalloutLabel.prototype, "offset", 2);
__decorateClass([_Validate(_DEGREE)], DonutSeriesCalloutLabel.prototype, "minAngle", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesCalloutLabel.prototype, "minSpacing", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesCalloutLabel.prototype, "maxCollisionOffset", 2);
__decorateClass([_Validate(_BOOLEAN)], DonutSeriesCalloutLabel.prototype, "avoidCollisions", 2);
var DonutSeriesSectorLabel = /*#__PURE__*/function (_Label6) {
  _inherits(DonutSeriesSectorLabel, _Label6);
  function DonutSeriesSectorLabel() {
    var _this212;
    _classCallCheck(this, DonutSeriesSectorLabel);
    _this212 = _possibleConstructorReturn(this, _getPrototypeOf(DonutSeriesSectorLabel).apply(this, arguments));
    _this212.positionOffset = 0;
    _this212.positionRatio = 0.5;
    return _this212;
  }
  return DonutSeriesSectorLabel;
}(_Label0);
__decorateClass([_Validate(_NUMBER)], DonutSeriesSectorLabel.prototype, "positionOffset", 2);
__decorateClass([_Validate(_RATIO)], DonutSeriesSectorLabel.prototype, "positionRatio", 2);
var DonutSeriesCalloutLine = /*#__PURE__*/function (_BaseProperties31) {
  _inherits(DonutSeriesCalloutLine, _BaseProperties31);
  function DonutSeriesCalloutLine() {
    var _this213;
    _classCallCheck(this, DonutSeriesCalloutLine);
    _this213 = _possibleConstructorReturn(this, _getPrototypeOf(DonutSeriesCalloutLine).apply(this, arguments));
    _this213.length = 10;
    _this213.strokeWidth = 1;
    return _this213;
  }
  return DonutSeriesCalloutLine;
}(_BaseProperties35);
__decorateClass([_Validate(_COLOR_STRING_ARRAY, {
  optional: true
})], DonutSeriesCalloutLine.prototype, "colors", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesCalloutLine.prototype, "length", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesCalloutLine.prototype, "strokeWidth", 2);
var DonutSeriesProperties = /*#__PURE__*/function (_SeriesProperties2) {
  _inherits(DonutSeriesProperties, _SeriesProperties2);
  function DonutSeriesProperties() {
    var _this214;
    _classCallCheck(this, DonutSeriesProperties);
    _this214 = _possibleConstructorReturn(this, _getPrototypeOf(DonutSeriesProperties).apply(this, arguments));
    _this214.fills = Object.values(DEFAULT_FILLS);
    _this214.strokes = Object.values(DEFAULT_STROKES);
    _this214.fillOpacity = 1;
    _this214.strokeOpacity = 1;
    _this214.lineDash = [0];
    _this214.lineDashOffset = 0;
    _this214.cornerRadius = 0;
    _this214.rotation = 0;
    _this214.outerRadiusOffset = 0;
    _this214.outerRadiusRatio = 1;
    _this214.strokeWidth = 1;
    _this214.sectorSpacing = void 0;
    _this214.innerLabels = new _PropertiesArray2(DonutInnerLabel);
    _this214.title = new DonutTitle();
    _this214.innerCircle = new DonutInnerCircle();
    _this214.shadow = new _DropShadow();
    _this214.calloutLabel = new DonutSeriesCalloutLabel();
    _this214.sectorLabel = new DonutSeriesSectorLabel();
    _this214.calloutLine = new DonutSeriesCalloutLine();
    _this214.tooltip = new _SeriesTooltip();
    _this214.__BACKGROUND_COLOR_DO_NOT_USE = void 0;
    return _this214;
  }
  _createClass(DonutSeriesProperties, [{
    key: "isValid",
    value: function isValid() {
      var superIsValid = _superPropGet(DonutSeriesProperties, "isValid", this, 3)([]);
      if (this.innerRadiusRatio == null && this.innerRadiusOffset == null) {
        _Logger.warnOnce("Either an [innerRadiusRatio] or an [innerRadiusOffset] must be set to render a donut series.");
        return false;
      }
      return superIsValid;
    }
  }]);
  return DonutSeriesProperties;
}(_SeriesProperties4);
__decorateClass([_Validate(_STRING)], DonutSeriesProperties.prototype, "angleKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "angleName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "radiusKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "radiusName", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], DonutSeriesProperties.prototype, "radiusMin", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], DonutSeriesProperties.prototype, "radiusMax", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "calloutLabelKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "calloutLabelName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "sectorLabelKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "sectorLabelName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "legendItemKey", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], DonutSeriesProperties.prototype, "fills", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], DonutSeriesProperties.prototype, "strokes", 2);
__decorateClass([_Validate(_RATIO)], DonutSeriesProperties.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_RATIO)], DonutSeriesProperties.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH)], DonutSeriesProperties.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesProperties.prototype, "lineDashOffset", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesProperties.prototype, "cornerRadius", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], DonutSeriesProperties.prototype, "formatter", 2);
__decorateClass([_Validate(_DEGREE)], DonutSeriesProperties.prototype, "rotation", 2);
__decorateClass([_Validate(_NUMBER)], DonutSeriesProperties.prototype, "outerRadiusOffset", 2);
__decorateClass([_Validate(_RATIO)], DonutSeriesProperties.prototype, "outerRadiusRatio", 2);
__decorateClass([_Validate(_NUMBER, {
  optional: true
})], DonutSeriesProperties.prototype, "innerRadiusOffset", 2);
__decorateClass([_Validate(_RATIO, {
  optional: true
})], DonutSeriesProperties.prototype, "innerRadiusRatio", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], DonutSeriesProperties.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], DonutSeriesProperties.prototype, "sectorSpacing", 2);
__decorateClass([_Validate(_OBJECT_ARRAY)], DonutSeriesProperties.prototype, "innerLabels", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "title", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "innerCircle", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "shadow", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "calloutLabel", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "sectorLabel", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "calloutLine", 2);
__decorateClass([_Validate(_OBJECT)], DonutSeriesProperties.prototype, "tooltip", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], DonutSeriesProperties.prototype, "__BACKGROUND_COLOR_DO_NOT_USE", 2);

// packages/ag-charts-community/src/chart/series/polar/pieUtil.ts
function _preparePieSeriesAnimationFunctions(initialLoad, rotationDegrees, scaleFn, oldScaleFn) {
  var scale2 = [scaleFn.convert(0), scaleFn.convert(1)];
  var oldScale = [oldScaleFn.convert(0), oldScaleFn.convert(1)];
  var rotation = Math.PI / -2 + _toRadians(rotationDegrees);
  var phase = initialLoad ? "initial" : "update";
  var scaleToNewRadius = function scaleToNewRadius(_ref162) {
    var radius = _ref162.radius;
    return {
      innerRadius: scale2[0],
      outerRadius: scale2[0] + (scale2[1] - scale2[0]) * radius
    };
  };
  var scaleToOldRadius = function scaleToOldRadius(_ref163) {
    var radius = _ref163.radius;
    return {
      innerRadius: oldScale[0],
      outerRadius: oldScale[0] + (oldScale[1] - oldScale[0]) * radius
    };
  };
  var fromFn = function fromFn(sect, datum, status, _ref164) {
    var prevFromProps = _ref164.prevFromProps;
    var _a, _b, _c, _d, _e, _f;
    var startAngle = sect.startAngle,
      endAngle = sect.endAngle,
      innerRadius = sect.innerRadius,
      outerRadius = sect.outerRadius;
    var _datum$sectorFormat = datum.sectorFormat,
      fill = _datum$sectorFormat.fill,
      stroke = _datum$sectorFormat.stroke;
    if (status === "unknown" || status === "added" && !prevFromProps) {
      startAngle = rotation;
      endAngle = rotation;
      innerRadius = datum.innerRadius;
      outerRadius = datum.outerRadius;
    } else if (status === "added" && prevFromProps) {
      startAngle = (_a = prevFromProps.endAngle) != null ? _a : rotation;
      endAngle = (_b = prevFromProps.endAngle) != null ? _b : rotation;
      innerRadius = (_c = prevFromProps.innerRadius) != null ? _c : datum.innerRadius;
      outerRadius = (_d = prevFromProps.outerRadius) != null ? _d : datum.outerRadius;
    }
    if (status === "added" && !initialLoad) {
      var radii = scaleToOldRadius(datum);
      innerRadius = radii.innerRadius;
      outerRadius = radii.outerRadius;
    }
    if (status === "updated") {
      fill = (_e = sect.fill) != null ? _e : fill;
      stroke = (_f = sect.stroke) != null ? _f : stroke;
    }
    return {
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      fill: fill,
      stroke: stroke,
      phase: phase
    };
  };
  var toFn = function toFn(_sect, datum, status, _ref165) {
    var prevLive = _ref165.prevLive;
    var _a, _b;
    var startAngle = datum.startAngle,
      endAngle = datum.endAngle,
      innerRadius = datum.innerRadius,
      outerRadius = datum.outerRadius;
    var _datum$sectorFormat2 = datum.sectorFormat,
      stroke = _datum$sectorFormat2.stroke,
      fill = _datum$sectorFormat2.fill;
    if (status === "removed" && prevLive) {
      startAngle = (_a = prevLive.datum) == null ? void 0 : _a.endAngle;
      endAngle = (_b = prevLive.datum) == null ? void 0 : _b.endAngle;
    } else if (status === "removed" && !prevLive) {
      startAngle = rotation;
      endAngle = rotation;
    }
    if (status === "removed") {
      var radii = scaleToNewRadius(datum);
      innerRadius = radii.innerRadius;
      outerRadius = radii.outerRadius;
    }
    return {
      startAngle: startAngle,
      endAngle: endAngle,
      outerRadius: outerRadius,
      innerRadius: innerRadius,
      stroke: stroke,
      fill: fill
    };
  };
  var innerCircleFromFn = function innerCircleFromFn(node, _) {
    var _a, _b, _c;
    return {
      size: (_c = (_b = (_a = node.previousDatum) == null ? void 0 : _a.radius) != null ? _b : node.size) != null ? _c : 0,
      phase: phase
    };
  };
  var innerCircleToFn = function innerCircleToFn(_, datum) {
    var _a;
    return {
      size: (_a = datum.radius) != null ? _a : 0
    };
  };
  return {
    nodes: {
      toFn: toFn,
      fromFn: fromFn
    },
    innerCircle: {
      fromFn: innerCircleFromFn,
      toFn: innerCircleToFn
    }
  };
}
function _resetPieSelectionsFn(_node, datum) {
  return {
    startAngle: datum.startAngle,
    endAngle: datum.endAngle,
    innerRadius: datum.innerRadius,
    outerRadius: datum.outerRadius,
    fill: datum.sectorFormat.fill,
    stroke: datum.sectorFormat.stroke
  };
}
function _pickByMatchingAngle(series, point) {
  var dy = point.y - series.centerY;
  var dx = point.x - series.centerX;
  var angle = Math.atan2(dy, dx);
  var sectors = series.getItemNodes();
  var _iterator208 = _createForOfIteratorHelper(sectors),
    _step208;
  try {
    for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
      var sector = _step208.value;
      if (sector.datum.missing === true) continue;
      if (_isBetweenAngles(angle, sector.startAngle, sector.endAngle)) {
        var radius = Math.sqrt(dx * dx + dy * dy);
        var distance2 = 0;
        if (radius < sector.innerRadius) {
          distance2 = sector.innerRadius - radius;
        } else if (radius > sector.outerRadius) {
          distance2 = radius - sector.outerRadius;
        }
        return {
          datum: sector.datum,
          distance: distance2
        };
      }
    }
  } catch (err) {
    _iterator208.e(err);
  } finally {
    _iterator208.f();
  }
  return void 0;
}
function _computeSectorFocusBounds(series, opts) {
  var nodeData = series.getNodeData();
  if (nodeData === void 0) return void 0;
  var centerX = series.centerX,
    centerY = series.centerY;
  var datum = nodeData[opts.datumIndex];
  var pointVars = [{
    radius: datum.innerRadius,
    angle: datum.startAngle
  }, {
    radius: datum.innerRadius,
    angle: datum.endAngle
  }, {
    radius: datum.outerRadius,
    angle: datum.startAngle
  }, {
    radius: datum.outerRadius,
    angle: datum.endAngle
  }];
  var rightAngles = [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2];
  for (var _i33 = 0, _rightAngles = rightAngles; _i33 < _rightAngles.length; _i33++) {
    var rightAngle = _rightAngles[_i33];
    if (_isBetweenAngles(rightAngle, datum.startAngle, datum.endAngle)) {
      pointVars.push({
        radius: datum.outerRadius,
        angle: rightAngle
      });
    }
  }
  var points = pointVars.map(function (_ref166) {
    var radius = _ref166.radius,
      angle = _ref166.angle;
    return _displacePointFromVector(centerX, centerY, radius, angle);
  });
  var xs = points.map(function (p) {
    return p.x;
  });
  var ys = points.map(function (p) {
    return p.y;
  });
  var x = Math.min.apply(Math, _toConsumableArray(xs));
  var y = Math.min.apply(Math, _toConsumableArray(ys));
  var width = Math.max.apply(Math, _toConsumableArray(xs)) - x;
  var height = Math.max.apply(Math, _toConsumableArray(ys)) - y;
  return new _BBox2(x, y, width, height);
}

// packages/ag-charts-community/src/chart/series/polar/polarSeries.ts
var _PolarSeries3 = /*#__PURE__*/function (_DataModelSeries2) {
  _inherits(PolarSeries, _DataModelSeries2);
  function PolarSeries(_a) {
    var _this215;
    _classCallCheck(this, PolarSeries);
    var _b = _a,
      _b$useLabelLayer = _b.useLabelLayer,
      useLabelLayer = _b$useLabelLayer === void 0 ? false : _b$useLabelLayer,
      _b$pickModes = _b.pickModes,
      pickModes = _b$pickModes === void 0 ? [0 /* EXACT_SHAPE_MATCH */] : _b$pickModes,
      _b$canHaveAxes = _b.canHaveAxes,
      canHaveAxes = _b$canHaveAxes === void 0 ? false : _b$canHaveAxes,
      animationResetFns = _b.animationResetFns,
      opts = __objRest(_b, ["useLabelLayer", "pickModes", "canHaveAxes", "animationResetFns"]);
    _this215 = _possibleConstructorReturn(this, _getPrototypeOf(PolarSeries).call(this, __spreadProps(__spreadValues({}, opts), {
      useLabelLayer: useLabelLayer,
      pickModes: pickModes,
      contentGroupVirtual: false,
      directionKeys: _defineProperty(_defineProperty({}, "x" /* X */, ["angleKey"]), "y" /* Y */, ["radiusKey"]),
      directionNames: _defineProperty(_defineProperty({}, "x" /* X */, ["angleName"]), "y" /* Y */, ["radiusName"]),
      canHaveAxes: canHaveAxes
    })));
    _this215.itemGroup = _this215.contentGroup.appendChild(new _Group4());
    _this215.nodeData = [];
    _this215.itemSelection = _Selection2.select(_this215.itemGroup, function () {
      return _this215.nodeFactory();
    }, false);
    _this215.labelSelection = _Selection2.select(_this215.labelGroup, _Text2, false);
    _this215.highlightSelection = _Selection2.select(_this215.highlightGroup, function () {
      return _this215.nodeFactory();
    });
    /**
     * The center of the polar series (for example, the center of a pie).
     * If the polar chart has multiple series, all of them will have their
     * center set to the same value as a result of the polar chart layout.
     * The center coordinates are not supposed to be set by the user.
     */
    _this215.centerX = 0;
    _this215.centerY = 0;
    /**
     * The maximum radius the series can use.
     * This value is set automatically as a result of the polar chart layout
     * and is not supposed to be set by the user.
     */
    _this215.radius = 0;
    _this215.showFocusBox = false;
    _this215.itemGroup.zIndexSubOrder = [function () {
      return _this215._declarationOrder;
    }, 1];
    _this215.animationResetFns = animationResetFns;
    _this215.animationState = new _StateMachine("empty", {
      empty: {
        update: {
          target: "ready",
          action: function action(data) {
            return _this215.animateEmptyUpdateReady(data);
          }
        },
        reset: "empty",
        skip: "ready"
      },
      ready: {
        updateData: "waiting",
        clear: "clearing",
        highlight: function highlight(data) {
          return _this215.animateReadyHighlight(data);
        },
        highlightMarkers: function highlightMarkers(data) {
          return _this215.animateReadyHighlightMarkers(data);
        },
        resize: function resize(data) {
          return _this215.animateReadyResize(data);
        },
        reset: "empty",
        skip: "ready"
      },
      waiting: {
        update: {
          target: "ready",
          action: function action(data) {
            return _this215.animateWaitingUpdateReady(data);
          }
        },
        reset: "empty",
        skip: "ready"
      },
      clearing: {
        update: {
          target: "empty",
          action: function action(data) {
            return _this215.animateClearingUpdateEmpty(data);
          }
        },
        reset: "empty",
        skip: "ready"
      }
    }, function () {
      return _this215.checkProcessedDataAnimatable();
    });
    return _this215;
  }
  _createClass(PolarSeries, [{
    key: "getItemNodes",
    value: function getItemNodes() {
      return this.itemGroup.children;
    }
  }, {
    key: "getNodeData",
    value: function getNodeData() {
      return this.nodeData;
    }
  }, {
    key: "resetAnimation",
    value: function resetAnimation(phase) {
      if (phase === "initial") {
        this.animationState.transition("reset");
      } else if (phase === "ready") {
        this.animationState.transition("skip");
      }
    }
  }, {
    key: "getLabelData",
    value: function getLabelData() {
      return [];
    }
  }, {
    key: "computeLabelsBBox",
    value: function computeLabelsBBox(_options, _seriesRect) {
      return null;
    }
  }, {
    key: "resetAllAnimation",
    value: function resetAllAnimation() {
      var _a;
      var _ref167 = (_a = this.animationResetFns) != null ? _a : {},
        item = _ref167.item,
        label = _ref167.label;
      this.ctx.animationManager.stopByAnimationGroupId(this.id);
      if (item) {
        _resetMotion([this.itemSelection, this.highlightSelection], item);
      }
      if (label) {
        _resetMotion([this.labelSelection], label);
      }
      this.itemSelection.cleanup();
      this.labelSelection.cleanup();
      this.highlightSelection.cleanup();
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(_data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation();
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(_data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation();
    }
  }, {
    key: "animateReadyHighlight",
    value: function animateReadyHighlight(_data) {
      var _a;
      var _ref168 = (_a = this.animationResetFns) != null ? _a : {},
        item = _ref168.item;
      if (item) {
        _resetMotion([this.highlightSelection], item);
      }
    }
  }, {
    key: "animateReadyHighlightMarkers",
    value: function animateReadyHighlightMarkers(_data) {}
  }, {
    key: "animateReadyResize",
    value: function animateReadyResize(_data) {
      this.resetAllAnimation();
    }
  }, {
    key: "animateClearingUpdateEmpty",
    value: function animateClearingUpdateEmpty(_data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation();
    }
  }, {
    key: "animationTransitionClear",
    value: function animationTransitionClear() {
      this.animationState.transition("clear", this.getAnimationData());
    }
  }, {
    key: "getAnimationData",
    value: function getAnimationData(seriesRect) {
      return {
        seriesRect: seriesRect
      };
    }
  }]);
  return PolarSeries;
}(_DataModelSeries3);

// packages/ag-charts-community/src/chart/series/polar/donutSeries.ts
var DonutSeriesNodeEvent = /*#__PURE__*/function (_SeriesNodeEvent2) {
  _inherits(DonutSeriesNodeEvent, _SeriesNodeEvent2);
  function DonutSeriesNodeEvent(type, nativeEvent, datum, series) {
    var _this216;
    _classCallCheck(this, DonutSeriesNodeEvent);
    _this216 = _possibleConstructorReturn(this, _getPrototypeOf(DonutSeriesNodeEvent).call(this, type, nativeEvent, datum, series));
    _this216.angleKey = series.properties.angleKey;
    _this216.radiusKey = series.properties.radiusKey;
    _this216.calloutLabelKey = series.properties.calloutLabelKey;
    _this216.sectorLabelKey = series.properties.sectorLabelKey;
    return _this216;
  }
  return DonutSeriesNodeEvent;
}(_SeriesNodeEvent4);
var DonutSeries = /*#__PURE__*/function (_PolarSeries) {
  _inherits(DonutSeries, _PolarSeries);
  function DonutSeries(moduleCtx) {
    var _this217;
    _classCallCheck(this, DonutSeries);
    _this217 = _possibleConstructorReturn(this, _getPrototypeOf(DonutSeries).call(this, {
      moduleCtx: moduleCtx,
      pickModes: [0 /* EXACT_SHAPE_MATCH */],
      useLabelLayer: true,
      animationResetFns: {
        item: _resetPieSelectionsFn,
        label: _resetLabelFn
      }
    }));
    _this217.properties = new DonutSeriesProperties();
    _this217.previousRadiusScale = new _LinearScale();
    _this217.radiusScale = new _LinearScale();
    // The group node that contains the background graphics.
    _this217.backgroundGroup = _this217.rootGroup.appendChild(new _Group4({
      name: "".concat(_this217.id, "-background"),
      layer: true,
      zIndex: 0 /* SERIES_BACKGROUND_ZINDEX */
    }));
    // AG-6193 If the sum of all datums is 0, then we'll draw 1 or 2 rings to represent the empty series.
    _this217.zerosumRingsGroup = _this217.backgroundGroup.appendChild(new _Group4({
      name: "".concat(_this217.id, "-zerosumRings")
    }));
    _this217.zerosumOuterRing = _this217.zerosumRingsGroup.appendChild(new _Circle());
    _this217.zerosumInnerRing = _this217.zerosumRingsGroup.appendChild(new _Circle());
    _this217.innerCircleGroup = _this217.backgroundGroup.appendChild(new _Group4({
      name: "".concat(_this217.id, "-innerCircle")
    }));
    // When a user toggles a series item (e.g. from the legend), its boolean state is recorded here.
    _this217.seriesItemEnabled = [];
    _this217.surroundingRadius = void 0;
    _this217.NodeEvent = DonutSeriesNodeEvent;
    _this217.angleScale = new _LinearScale();
    _this217.angleScale.domain = [0, 1];
    _this217.angleScale.range = [-Math.PI, Math.PI].map(function (angle) {
      return angle + Math.PI / 2;
    });
    var pieCalloutLabels = new _Group4({
      name: "pieCalloutLabels"
    });
    var pieSectorLabels = new _Group4({
      name: "pieSectorLabels"
    });
    var innerLabels = new _Group4({
      name: "innerLabels"
    });
    _this217.labelGroup.append(pieCalloutLabels);
    _this217.labelGroup.append(pieSectorLabels);
    _this217.labelGroup.append(innerLabels);
    _this217.calloutLabelSelection = _Selection2.select(pieCalloutLabels, _Group4);
    _this217.sectorLabelSelection = _Selection2.select(pieSectorLabels, _Text2);
    _this217.innerLabelsSelection = _Selection2.select(innerLabels, _Text2);
    _this217.innerCircleSelection = _Selection2.select(_this217.innerCircleGroup, _Circle);
    return _this217;
  }
  _createClass(DonutSeries, [{
    key: "addChartEventListeners",
    value: function addChartEventListeners() {
      var _this218 = this;
      var _a;
      this.destroyFns.push((_a = this.ctx.chartEventManager) == null ? void 0 : _a.addListener("legend-item-click", function (event) {
        return _this218.onLegendItemClick(event);
      }));
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Sector();
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      if (direction === "x" /* X */) {
        return this.angleScale.domain;
      } else {
        return this.radiusScale.domain;
      }
    }
  }, {
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee76() {
        var _a, _b, _c, _d, _e, data, visible, seriesItemEnabled, _this$properties32, angleKey, radiusKey, calloutLabelKey, sectorLabelKey, legendItemKey, animationEnabled, extraKeyProps, extraProps, radiusScaleType, angleScaleType, _iterator209, _step209, valueDef, id, missing, property, missCount;
        return _regenerator().w(function (_context87) {
          while (1) switch (_context87.n) {
            case 0:
              if (!(this.data == null || !this.properties.isValid())) {
                _context87.n = 1;
                break;
              }
              return _context87.a(2);
            case 1:
              data = this.data;
              visible = this.visible, seriesItemEnabled = this.seriesItemEnabled;
              _this$properties32 = this.properties, angleKey = _this$properties32.angleKey, radiusKey = _this$properties32.radiusKey, calloutLabelKey = _this$properties32.calloutLabelKey, sectorLabelKey = _this$properties32.sectorLabelKey, legendItemKey = _this$properties32.legendItemKey;
              animationEnabled = !this.ctx.animationManager.isSkipped();
              extraKeyProps = [];
              extraProps = [];
              if (legendItemKey) {
                extraKeyProps.push(_keyProperty(legendItemKey, "band", {
                  id: "legendItemKey"
                }));
              } else if (calloutLabelKey) {
                extraKeyProps.push(_keyProperty(calloutLabelKey, "band", {
                  id: "calloutLabelKey"
                }));
              } else if (sectorLabelKey) {
                extraKeyProps.push(_keyProperty(sectorLabelKey, "band", {
                  id: "sectorLabelKey"
                }));
              }
              radiusScaleType = this.radiusScale.type;
              angleScaleType = this.radiusScale.type;
              if (radiusKey) {
                extraProps.push(_rangedValueProperty(radiusKey, {
                  id: "radiusValue",
                  min: (_a = this.properties.radiusMin) != null ? _a : 0,
                  max: this.properties.radiusMax
                }), _valueProperty(radiusKey, radiusScaleType, {
                  id: "radiusRaw"
                }),
                // Raw value pass-through.
                _normalisePropertyTo({
                  id: "radiusValue"
                }, [0, 1], 1, (_b = this.properties.radiusMin) != null ? _b : 0, this.properties.radiusMax));
              }
              if (calloutLabelKey) {
                extraProps.push(_valueProperty(calloutLabelKey, "band", {
                  id: "calloutLabelValue"
                }));
              }
              if (sectorLabelKey) {
                extraProps.push(_valueProperty(sectorLabelKey, "band", {
                  id: "sectorLabelValue"
                }));
              }
              if (legendItemKey) {
                extraProps.push(_valueProperty(legendItemKey, "band", {
                  id: "legendItemValue"
                }));
              }
              if (animationEnabled && this.processedData && extraKeyProps.length > 0) {
                extraProps.push(_diff(this.processedData));
              }
              extraProps.push(_animationValidation());
              data = data.map(function (d, idx) {
                return visible && seriesItemEnabled[idx] ? d : __spreadProps(__spreadValues({}, d), _defineProperty({}, angleKey, 0));
              });
              _context87.n = 2;
              return this.requestDataModel(dataController, data, {
                props: [].concat(extraKeyProps, [_accumulativeValueProperty(angleKey, angleScaleType, {
                  id: "angleValue",
                  onlyPositive: true
                }), _valueProperty(angleKey, angleScaleType, {
                  id: "angleRaw"
                }),
                // Raw value pass-through.
                _normalisePropertyTo({
                  id: "angleValue"
                }, [0, 1], 0, 0)], extraProps)
              });
            case 2:
              _iterator209 = _createForOfIteratorHelper((_e = (_d = (_c = this.processedData) == null ? void 0 : _c.defs) == null ? void 0 : _d.values) != null ? _e : []);
              try {
                for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                  valueDef = _step209.value;
                  id = valueDef.id, missing = valueDef.missing, property = valueDef.property;
                  missCount = _getMissCount(this, missing);
                  if (id !== "angleRaw" && missCount > 0) {
                    _Logger.warnOnce("no value was found for the key '".concat(String(property), "' on ").concat(missCount, " data element").concat(missCount > 1 ? "s" : ""));
                  }
                }
              } catch (err) {
                _iterator209.e(err);
              } finally {
                _iterator209.f();
              }
              this.animationState.transition("updateData");
            case 3:
              return _context87.a(2);
          }
        }, _callee76, this);
      }));
    }
  }, {
    key: "maybeRefreshNodeData",
    value: function maybeRefreshNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee77() {
        var _a, _ref169, _ref169$nodeData, nodeData, _t12, _t13;
        return _regenerator().w(function (_context88) {
          while (1) switch (_context88.n) {
            case 0:
              if (this.nodeDataRefresh) {
                _context88.n = 1;
                break;
              }
              return _context88.a(2);
            case 1:
              _context88.n = 2;
              return this.createNodeData();
            case 2:
              _t12 = _a = _context88.v;
              if (!(_t12 != null)) {
                _context88.n = 3;
                break;
              }
              _t13 = _a;
              _context88.n = 4;
              break;
            case 3:
              _t13 = {};
            case 4:
              _ref169 = _t13;
              _ref169$nodeData = _ref169.nodeData;
              nodeData = _ref169$nodeData === void 0 ? [] : _ref169$nodeData;
              this.nodeData = nodeData;
              this.nodeDataRefresh = false;
            case 5:
              return _context88.a(2);
          }
        }, _callee77, this);
      }));
    }
  }, {
    key: "getProcessedDataIndexes",
    value: function getProcessedDataIndexes(dataModel) {
      var angleIdx = dataModel.resolveProcessedDataIndexById(this, "angleValue");
      var radiusIdx = this.properties.radiusKey ? dataModel.resolveProcessedDataIndexById(this, "radiusValue") : -1;
      var calloutLabelIdx = this.properties.calloutLabelKey ? dataModel.resolveProcessedDataIndexById(this, "calloutLabelValue") : -1;
      var sectorLabelIdx = this.properties.sectorLabelKey ? dataModel.resolveProcessedDataIndexById(this, "sectorLabelValue") : -1;
      var legendItemIdx = this.properties.legendItemKey ? dataModel.resolveProcessedDataIndexById(this, "legendItemValue") : -1;
      return {
        angleIdx: angleIdx,
        radiusIdx: radiusIdx,
        calloutLabelIdx: calloutLabelIdx,
        sectorLabelIdx: sectorLabelIdx,
        legendItemIdx: legendItemIdx
      };
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee78() {
        var _this219 = this;
        var seriesId, processedData, dataModel, angleScale, _this$properties33, rotation, innerRadiusRatio, _this$getProcessedDat, angleIdx, radiusIdx, calloutLabelIdx, sectorLabelIdx, legendItemIdx, currentStart, sum2, nodeData;
        return _regenerator().w(function (_context89) {
          while (1) switch (_context89.n) {
            case 0:
              seriesId = this.id, processedData = this.processedData, dataModel = this.dataModel, angleScale = this.angleScale;
              _this$properties33 = this.properties, rotation = _this$properties33.rotation, innerRadiusRatio = _this$properties33.innerRadiusRatio;
              if (this.properties.isValid()) {
                _context89.n = 1;
                break;
              }
              this.zerosumOuterRing.visible = true;
              this.zerosumInnerRing.visible = true;
              return _context89.a(2, {
                itemId: seriesId,
                nodeData: [],
                labelData: []
              });
            case 1:
              if (!(!processedData || !dataModel || processedData.type !== "ungrouped")) {
                _context89.n = 2;
                break;
              }
              return _context89.a(2);
            case 2:
              _this$getProcessedDat = this.getProcessedDataIndexes(dataModel), angleIdx = _this$getProcessedDat.angleIdx, radiusIdx = _this$getProcessedDat.radiusIdx, calloutLabelIdx = _this$getProcessedDat.calloutLabelIdx, sectorLabelIdx = _this$getProcessedDat.sectorLabelIdx, legendItemIdx = _this$getProcessedDat.legendItemIdx;
              currentStart = 0;
              sum2 = 0;
              nodeData = processedData.data.map(function (group2, index) {
                var _a;
                var datum = group2.datum,
                  values = group2.values;
                var currentValue = values[angleIdx];
                var startAngle = angleScale.convert(currentStart) + _toRadians(rotation);
                currentStart = currentValue;
                sum2 += currentValue;
                var endAngle = angleScale.convert(currentStart) + _toRadians(rotation);
                var span = Math.abs(endAngle - startAngle);
                var midAngle = startAngle + span / 2;
                var angleValue = values[angleIdx + 1];
                var radius = radiusIdx >= 0 ? (_a = values[radiusIdx]) != null ? _a : 1 : 1;
                var radiusValue = radiusIdx >= 0 ? values[radiusIdx + 1] : void 0;
                var legendItemValue = legendItemIdx >= 0 ? values[legendItemIdx] : void 0;
                var labels = _this219.getLabels(datum, midAngle, span, true, values[calloutLabelIdx], values[sectorLabelIdx], legendItemValue);
                var sectorFormat = _this219.getSectorFormat(datum, index, false);
                return __spreadValues({
                  itemId: index,
                  series: _this219,
                  datum: datum,
                  index: index,
                  angleValue: angleValue,
                  midAngle: midAngle,
                  midCos: Math.cos(midAngle),
                  midSin: Math.sin(midAngle),
                  startAngle: startAngle,
                  endAngle: endAngle,
                  sectorFormat: sectorFormat,
                  radiusValue: radiusValue,
                  radius: radius,
                  innerRadius: Math.max(_this219.radiusScale.convert(0), 0),
                  outerRadius: Math.max(_this219.radiusScale.convert(radius), 0),
                  legendItemValue: legendItemValue
                }, labels);
              });
              this.zerosumOuterRing.visible = sum2 === 0;
              this.zerosumInnerRing.visible = sum2 === 0 && innerRadiusRatio != null && innerRadiusRatio !== 1 && innerRadiusRatio > 0;
              return _context89.a(2, {
                itemId: seriesId,
                nodeData: nodeData,
                labelData: nodeData
              });
          }
        }, _callee78, this);
      }));
    }
  }, {
    key: "getLabels",
    value: function getLabels(datum, midAngle, span, skipDisabled, calloutLabelValue, sectorLabelValue, legendItemValue) {
      var _this$properties34 = this.properties,
        calloutLabel = _this$properties34.calloutLabel,
        sectorLabel = _this$properties34.sectorLabel,
        legendItemKey = _this$properties34.legendItemKey;
      var calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.properties.calloutLabelKey : void 0;
      var sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.properties.sectorLabelKey : void 0;
      if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) {
        return {};
      }
      var labelFormatterParams = {
        datum: datum,
        angleKey: this.properties.angleKey,
        angleName: this.properties.angleName,
        radiusKey: this.properties.radiusKey,
        radiusName: this.properties.radiusName,
        calloutLabelKey: this.properties.calloutLabelKey,
        calloutLabelName: this.properties.calloutLabelName,
        sectorLabelKey: this.properties.sectorLabelKey,
        sectorLabelName: this.properties.sectorLabelName,
        legendItemKey: this.properties.legendItemKey
      };
      var result = {};
      if (calloutLabelKey && span > _toRadians(calloutLabel.minAngle)) {
        result.calloutLabel = __spreadProps(__spreadValues({}, this.getTextAlignment(midAngle)), {
          text: this.getLabelText(calloutLabel, __spreadProps(__spreadValues({}, labelFormatterParams), {
            value: calloutLabelValue
          })),
          hidden: false,
          collisionTextAlign: void 0,
          collisionOffsetY: 0,
          box: void 0
        });
      }
      if (sectorLabelKey) {
        result.sectorLabel = {
          text: this.getLabelText(sectorLabel, __spreadProps(__spreadValues({}, labelFormatterParams), {
            value: sectorLabelValue
          }))
        };
      }
      if (legendItemKey != null && legendItemValue != null) {
        result.legendItem = {
          key: legendItemKey,
          text: legendItemValue
        };
      }
      return result;
    }
  }, {
    key: "getTextAlignment",
    value: function getTextAlignment(midAngle) {
      var quadrantTextOpts = [{
        textAlign: "center",
        textBaseline: "bottom"
      }, {
        textAlign: "left",
        textBaseline: "middle"
      }, {
        textAlign: "center",
        textBaseline: "hanging"
      }, {
        textAlign: "right",
        textBaseline: "middle"
      }];
      var midAngle180 = _normalizeAngle(midAngle);
      var quadrantStart = -0.75 * Math.PI;
      var quadrantOffset = midAngle180 - quadrantStart;
      var quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
      var quadrantIndex = _mod(quadrant, quadrantTextOpts.length);
      return quadrantTextOpts[quadrantIndex];
    }
  }, {
    key: "getSectorFormat",
    value: function getSectorFormat(datum, formatIndex, highlight) {
      var _a, _b, _c, _d, _e;
      var _this$ctx3 = this.ctx,
        callbackCache = _this$ctx3.callbackCache,
        highlightManager = _this$ctx3.highlightManager;
      var _this$properties35 = this.properties,
        angleKey = _this$properties35.angleKey,
        radiusKey = _this$properties35.radiusKey,
        fills = _this$properties35.fills,
        strokes = _this$properties35.strokes,
        formatter = _this$properties35.formatter,
        sectorSpacing = _this$properties35.sectorSpacing,
        __BACKGROUND_COLOR_DO_NOT_USE = _this$properties35.__BACKGROUND_COLOR_DO_NOT_USE;
      var highlightedDatum = highlightManager.getActiveHighlight();
      var isDatumHighlighted = highlight && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this && formatIndex === highlightedDatum.itemId;
      var defaultStroke = strokes[formatIndex % strokes.length];
      if (sectorSpacing == null && defaultStroke == null) {
        defaultStroke = __BACKGROUND_COLOR_DO_NOT_USE;
      }
      var _mergeDefaults2 = _mergeDefaults4(isDatumHighlighted && this.properties.highlightStyle.item, {
          fill: fills.length > 0 ? fills[formatIndex % fills.length] : void 0,
          fillOpacity: this.properties.fillOpacity,
          stroke: defaultStroke,
          strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
          strokeOpacity: this.getOpacity()
        }),
        fill = _mergeDefaults2.fill,
        fillOpacity = _mergeDefaults2.fillOpacity,
        stroke = _mergeDefaults2.stroke,
        strokeWidth = _mergeDefaults2.strokeWidth,
        strokeOpacity = _mergeDefaults2.strokeOpacity;
      var format2;
      if (formatter) {
        format2 = callbackCache.call(formatter, {
          datum: datum,
          angleKey: angleKey,
          radiusKey: radiusKey,
          fill: fill,
          stroke: stroke,
          fills: fills,
          strokes: strokes,
          strokeWidth: strokeWidth,
          highlighted: isDatumHighlighted,
          seriesId: this.id
        });
      }
      return {
        fill: (_a = format2 == null ? void 0 : format2.fill) != null ? _a : fill,
        fillOpacity: (_b = format2 == null ? void 0 : format2.fillOpacity) != null ? _b : fillOpacity,
        stroke: (_c = format2 == null ? void 0 : format2.stroke) != null ? _c : stroke,
        strokeWidth: (_d = format2 == null ? void 0 : format2.strokeWidth) != null ? _d : strokeWidth,
        strokeOpacity: (_e = format2 == null ? void 0 : format2.strokeOpacity) != null ? _e : strokeOpacity
      };
    }
  }, {
    key: "getInnerRadius",
    value: function getInnerRadius() {
      var radius = this.radius;
      var _this$properties36 = this.properties,
        _this$properties36$in = _this$properties36.innerRadiusRatio,
        innerRadiusRatio = _this$properties36$in === void 0 ? 1 : _this$properties36$in,
        _this$properties36$in2 = _this$properties36.innerRadiusOffset,
        innerRadiusOffset = _this$properties36$in2 === void 0 ? 0 : _this$properties36$in2;
      var innerRadius = radius * innerRadiusRatio + innerRadiusOffset;
      if (innerRadius === radius || innerRadius < 0) {
        return 0;
      }
      return innerRadius;
    }
  }, {
    key: "getOuterRadius",
    value: function getOuterRadius() {
      var _this$properties37 = this.properties,
        outerRadiusRatio = _this$properties37.outerRadiusRatio,
        outerRadiusOffset = _this$properties37.outerRadiusOffset;
      return Math.max(this.radius * outerRadiusRatio + outerRadiusOffset, 0);
    }
  }, {
    key: "updateRadiusScale",
    value: function updateRadiusScale(resize) {
      var _this220 = this;
      var newRange = [this.getInnerRadius(), this.getOuterRadius()];
      this.radiusScale.range = newRange;
      if (resize) {
        this.previousRadiusScale.range = newRange;
      }
      this.nodeData = this.nodeData.map(function (_a) {
        var _b = _a,
          radius = _b.radius,
          d = __objRest(_b, ["radius"]);
        return __spreadProps(__spreadValues({}, d), {
          radius: radius,
          innerRadius: Math.max(_this220.radiusScale.convert(0), 0),
          outerRadius: Math.max(_this220.radiusScale.convert(radius), 0)
        });
      });
    }
  }, {
    key: "getTitleTranslationY",
    value: function getTitleTranslationY() {
      var _a, _b;
      var outerRadius = Math.max(0, this.radiusScale.range[1]);
      if (outerRadius === 0) {
        return NaN;
      }
      var spacing = (_b = (_a = this.properties.title) == null ? void 0 : _a.spacing) != null ? _b : 0;
      var titleOffset = 2 + spacing;
      var dy = Math.max(0, -outerRadius);
      return -outerRadius - titleOffset - dy;
    }
  }, {
    key: "update",
    value: function update(_0) {
      return __async(this, arguments, function (_ref170) {
        var _this221 = this;
        var seriesRect = _ref170.seriesRect;
        return /*#__PURE__*/_regenerator().m(function _callee79() {
          var title, newNodeDataDependencies, resize, dy, titleBox, _i34, _arr3, circle;
          return _regenerator().w(function (_context90) {
            while (1) switch (_context90.n) {
              case 0:
                title = _this221.properties.title;
                newNodeDataDependencies = {
                  seriesRectWidth: seriesRect == null ? void 0 : seriesRect.width,
                  seriesRectHeight: seriesRect == null ? void 0 : seriesRect.height
                };
                resize = _jsonDiff(_this221.nodeDataDependencies, newNodeDataDependencies) != null;
                if (resize) {
                  _this221._nodeDataDependencies = newNodeDataDependencies;
                }
                _context90.n = 1;
                return _this221.maybeRefreshNodeData();
              case 1:
                _this221.updateTitleNodes();
                _this221.updateRadiusScale(resize);
                _this221.contentGroup.translationX = _this221.centerX;
                _this221.contentGroup.translationY = _this221.centerY;
                _this221.highlightGroup.translationX = _this221.centerX;
                _this221.highlightGroup.translationY = _this221.centerY;
                _this221.backgroundGroup.translationX = _this221.centerX;
                _this221.backgroundGroup.translationY = _this221.centerY;
                if (_this221.labelGroup) {
                  _this221.labelGroup.translationX = _this221.centerX;
                  _this221.labelGroup.translationY = _this221.centerY;
                }
                if (title) {
                  dy = _this221.getTitleTranslationY();
                  titleBox = title.node.computeBBox();
                  title.node.visible = title.enabled && isFinite(dy) && !_this221.bboxIntersectsSurroundingSeries(titleBox, 0, dy);
                  title.node.translationY = isFinite(dy) ? dy : 0;
                }
                for (_i34 = 0, _arr3 = [_this221.zerosumInnerRing, _this221.zerosumOuterRing]; _i34 < _arr3.length; _i34++) {
                  circle = _arr3[_i34];
                  circle.fillOpacity = 0;
                  circle.stroke = _this221.properties.calloutLabel.color;
                  circle.strokeWidth = 1;
                  circle.strokeOpacity = 1;
                }
                _this221.updateNodeMidPoint();
                _context90.n = 2;
                return _this221.updateSelections();
              case 2:
                _context90.n = 3;
                return _this221.updateNodes(seriesRect);
              case 3:
                return _context90.a(2);
            }
          }, _callee79);
        })();
      });
    }
  }, {
    key: "updateTitleNodes",
    value: function updateTitleNodes() {
      var _a, _b;
      var oldTitle = this.oldTitle;
      var title = this.properties.title;
      if (oldTitle !== title) {
        if (oldTitle) {
          (_a = this.labelGroup) == null ? void 0 : _a.removeChild(oldTitle.node);
        }
        if (title) {
          title.node.textBaseline = "bottom";
          (_b = this.labelGroup) == null ? void 0 : _b.appendChild(title.node);
        }
        this.oldTitle = title;
      }
    }
  }, {
    key: "updateNodeMidPoint",
    value: function updateNodeMidPoint() {
      this.nodeData.forEach(function (d) {
        var radius = d.innerRadius + (d.outerRadius - d.innerRadius) / 2;
        d.midPoint = {
          x: d.midCos * Math.max(0, radius),
          y: d.midSin * Math.max(0, radius)
        };
      });
    }
  }, {
    key: "updateSelections",
    value: function updateSelections() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee80() {
        return _regenerator().w(function (_context91) {
          while (1) switch (_context91.n) {
            case 0:
              _context91.n = 1;
              return this.updateGroupSelection();
            case 1:
              this.updateInnerCircleSelection();
            case 2:
              return _context91.a(2);
          }
        }, _callee80, this);
      }));
    }
  }, {
    key: "updateGroupSelection",
    value: function updateGroupSelection() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee81() {
        var _this222 = this;
        var itemSelection, highlightSelection, calloutLabelSelection, sectorLabelSelection, innerLabelsSelection, update;
        return _regenerator().w(function (_context92) {
          while (1) switch (_context92.n) {
            case 0:
              itemSelection = this.itemSelection, highlightSelection = this.highlightSelection, calloutLabelSelection = this.calloutLabelSelection, sectorLabelSelection = this.sectorLabelSelection, innerLabelsSelection = this.innerLabelsSelection;
              update = function update(selection, clone) {
                var nodeData = _this222.nodeData;
                if (clone) {
                  nodeData = nodeData.map(function (datum) {
                    return __spreadProps(__spreadValues({}, datum), {
                      sectorFormat: __spreadValues({}, datum.sectorFormat)
                    });
                  });
                }
                selection.update(nodeData, void 0, function (datum) {
                  return _this222.getDatumId(datum);
                });
                if (_this222.ctx.animationManager.isSkipped()) {
                  selection.cleanup();
                }
              };
              update(itemSelection, false);
              update(highlightSelection, true);
              calloutLabelSelection.update(this.nodeData, function (group2) {
                var line = new _Line();
                line.tag = 0 /* Callout */;
                line.pointerEvents = 1 /* None */;
                group2.appendChild(line);
                var text = new _Text2();
                text.tag = 1 /* Label */;
                text.pointerEvents = 1 /* None */;
                group2.appendChild(text);
              });
              sectorLabelSelection.update(this.nodeData, function (node) {
                node.pointerEvents = 1 /* None */;
              });
              innerLabelsSelection.update(this.properties.innerLabels, function (node) {
                node.pointerEvents = 1 /* None */;
              });
            case 1:
              return _context92.a(2);
          }
        }, _callee81, this);
      }));
    }
  }, {
    key: "updateInnerCircleSelection",
    value: function updateInnerCircleSelection() {
      var innerCircle = this.properties.innerCircle;
      var radius = 0;
      var innerRadius = this.getInnerRadius();
      if (innerRadius > 0) {
        var circleRadius = Math.min(innerRadius, this.getOuterRadius());
        var antiAliasingPadding = 1;
        radius = Math.ceil(circleRadius * 2 + antiAliasingPadding);
      }
      var datums = innerCircle ? [{
        radius: radius
      }] : [];
      this.innerCircleSelection.update(datums);
    }
  }, {
    key: "updateNodes",
    value: function updateNodes(seriesRect) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee82() {
        var _this223 = this;
        var highlightedDatum, isVisible, updateSectorFn;
        return _regenerator().w(function (_context93) {
          while (1) switch (_context93.n) {
            case 0:
              highlightedDatum = this.ctx.highlightManager.getActiveHighlight();
              isVisible = this.visible && this.seriesItemEnabled.indexOf(true) >= 0;
              this.rootGroup.visible = isVisible;
              this.backgroundGroup.visible = isVisible;
              this.contentGroup.visible = isVisible;
              this.highlightGroup.visible = isVisible && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this;
              if (this.labelGroup) {
                this.labelGroup.visible = isVisible;
              }
              this.contentGroup.opacity = this.getOpacity();
              this.innerCircleSelection.each(function (node, _ref171) {
                var radius = _ref171.radius;
                var _a, _b;
                node.setProperties({
                  fill: (_a = _this223.properties.innerCircle) == null ? void 0 : _a.fill,
                  opacity: (_b = _this223.properties.innerCircle) == null ? void 0 : _b.fillOpacity,
                  size: radius
                });
              });
              updateSectorFn = function updateSectorFn(sector, datum, _index, isDatumHighlighted) {
                var format2 = _this223.getSectorFormat(datum.datum, datum.itemId, isDatumHighlighted);
                datum.sectorFormat.fill = format2.fill;
                datum.sectorFormat.stroke = format2.stroke;
                var animationDisabled = _this223.ctx.animationManager.isSkipped();
                if (animationDisabled) {
                  sector.startAngle = datum.startAngle;
                  sector.endAngle = datum.endAngle;
                  sector.innerRadius = datum.innerRadius;
                  sector.outerRadius = datum.outerRadius;
                }
                if (isDatumHighlighted || animationDisabled) {
                  sector.fill = format2.fill;
                  sector.stroke = format2.stroke;
                }
                sector.strokeWidth = format2.strokeWidth;
                sector.fillOpacity = format2.fillOpacity;
                sector.strokeOpacity = _this223.properties.strokeOpacity;
                sector.lineDash = _this223.properties.lineDash;
                sector.lineDashOffset = _this223.properties.lineDashOffset;
                sector.fillShadow = _this223.properties.shadow;
                sector.cornerRadius = _this223.properties.cornerRadius;
                sector.inset = _this223.properties.sectorSpacing != null ? (_this223.properties.sectorSpacing + (format2.stroke != null ? format2.strokeWidth : 0)) / 2 : 0;
                sector.lineJoin = _this223.properties.sectorSpacing != null ? "miter" : "round";
              };
              this.itemSelection.each(function (node, datum, index) {
                return updateSectorFn(node, datum, index, false);
              });
              this.highlightSelection.each(function (node, datum, index) {
                var isDatumHighlighted = (highlightedDatum == null ? void 0 : highlightedDatum.series) === _this223 && node.datum.itemId === highlightedDatum.itemId;
                updateSectorFn(node, datum, index, true);
                node.visible = isDatumHighlighted;
              });
              this.updateCalloutLineNodes();
              this.updateCalloutLabelNodes(seriesRect);
              this.updateSectorLabelNodes();
              this.updateInnerLabelNodes();
              this.updateZerosumRings();
              this.animationState.transition("update");
            case 1:
              return _context93.a(2);
          }
        }, _callee82, this);
      }));
    }
  }, {
    key: "updateCalloutLineNodes",
    value: function updateCalloutLineNodes() {
      var _a;
      var calloutLine = this.properties.calloutLine;
      var calloutLength = calloutLine.length;
      var calloutStrokeWidth = calloutLine.strokeWidth;
      var calloutColors = (_a = calloutLine.colors) != null ? _a : this.properties.strokes;
      var offset4 = this.properties.calloutLabel.offset;
      this.calloutLabelSelection.selectByTag(0 /* Callout */).forEach(function (line, index) {
        var _a2;
        var datum = line.datum;
        var label = datum.calloutLabel,
          outerRadius = datum.outerRadius;
        if ((label == null ? void 0 : label.text) && !label.hidden && outerRadius !== 0) {
          line.visible = true;
          line.strokeWidth = calloutStrokeWidth;
          line.stroke = calloutColors[index % calloutColors.length];
          line.fill = void 0;
          var x1 = datum.midCos * outerRadius;
          var y1 = datum.midSin * outerRadius;
          var x2 = datum.midCos * (outerRadius + calloutLength);
          var y2 = datum.midSin * (outerRadius + calloutLength);
          var isMoved = (_a2 = label.collisionTextAlign) != null ? _a2 : label.collisionOffsetY !== 0;
          if (isMoved && label.box != null) {
            var box = label.box;
            var cx = x2;
            var cy = y2;
            if (x2 < box.x) {
              cx = box.x;
            } else if (x2 > box.x + box.width) {
              cx = box.x + box.width;
            }
            if (y2 < box.y) {
              cy = box.y;
            } else if (y2 > box.y + box.height) {
              cy = box.y + box.height;
            }
            var dx = cx - x2;
            var dy = cy - y2;
            var length = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
            var paddedLength = length - offset4;
            if (paddedLength > 0) {
              x2 = x2 + dx * paddedLength / length;
              y2 = y2 + dy * paddedLength / length;
            }
          }
          line.x1 = x1;
          line.y1 = y1;
          line.x2 = x2;
          line.y2 = y2;
        } else {
          line.visible = false;
        }
      });
    }
  }, {
    key: "getLabelOverflow",
    value: function getLabelOverflow(text, box, seriesRect) {
      var seriesLeft = seriesRect.x - this.centerX;
      var seriesRight = seriesRect.x + seriesRect.width - this.centerX;
      var seriesTop = seriesRect.y - this.centerY;
      var seriesBottom = seriesRect.y + seriesRect.height - this.centerY;
      var errPx = 1;
      var visibleTextPart = 1;
      if (box.x + errPx < seriesLeft) {
        visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
      } else if (box.x + box.width - errPx > seriesRight) {
        visibleTextPart = (seriesRight - box.x) / box.width;
      }
      var hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
      var textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
      var hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
      return {
        textLength: textLength,
        hasVerticalOverflow: hasVerticalOverflow,
        hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow
      };
    }
  }, {
    key: "bboxIntersectsSurroundingSeries",
    value: function bboxIntersectsSurroundingSeries(box) {
      var dx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var dy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var surroundingRadius = this.surroundingRadius;
      if (surroundingRadius == null) {
        return false;
      }
      var corners = [{
        x: box.x + dx,
        y: box.y + dy
      }, {
        x: box.x + box.width + dx,
        y: box.y + dy
      }, {
        x: box.x + box.width + dx,
        y: box.y + box.height + dy
      }, {
        x: box.x + dx,
        y: box.y + box.height + dy
      }];
      var sur2 = __pow(surroundingRadius, 2);
      return corners.some(function (corner) {
        return __pow(corner.x, 2) + __pow(corner.y, 2) > sur2;
      });
    }
  }, {
    key: "computeCalloutLabelCollisionOffsets",
    value: function computeCalloutLabelCollisionOffsets() {
      var _this224 = this;
      var radiusScale = this.radiusScale;
      var _this$properties38 = this.properties,
        calloutLabel = _this$properties38.calloutLabel,
        calloutLine = _this$properties38.calloutLine;
      var offset4 = calloutLabel.offset,
        minSpacing = calloutLabel.minSpacing;
      var innerRadius = radiusScale.convert(0);
      var shouldSkip = function shouldSkip(datum) {
        var label = datum.calloutLabel;
        return !label || datum.outerRadius === 0;
      };
      var fullData = this.nodeData;
      var data = this.nodeData.filter(function (t) {
        return !shouldSkip(t);
      });
      data.forEach(function (datum) {
        var label = datum.calloutLabel;
        if (label == null) return;
        label.hidden = false;
        label.collisionTextAlign = void 0;
        label.collisionOffsetY = 0;
      });
      if (data.length <= 1) {
        return;
      }
      var leftLabels = data.filter(function (d) {
        return d.midCos < 0;
      }).sort(function (a, b) {
        return a.midSin - b.midSin;
      });
      var rightLabels = data.filter(function (d) {
        return d.midCos >= 0;
      }).sort(function (a, b) {
        return a.midSin - b.midSin;
      });
      var topLabels = data.filter(function (d) {
        var _a;
        return d.midSin < 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
      }).sort(function (a, b) {
        return a.midCos - b.midCos;
      });
      var bottomLabels = data.filter(function (d) {
        var _a;
        return d.midSin >= 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
      }).sort(function (a, b) {
        return a.midCos - b.midCos;
      });
      var tempTextNode = new _Text2();
      var getTextBBox = function getTextBBox(datum) {
        var _a;
        var label = datum.calloutLabel;
        if (label == null) return new _BBox2(0, 0, 0, 0);
        var labelRadius = datum.outerRadius + calloutLine.length + offset4;
        var x = datum.midCos * labelRadius;
        var y = datum.midSin * labelRadius + label.collisionOffsetY;
        tempTextNode.text = label.text;
        tempTextNode.x = x;
        tempTextNode.y = y;
        tempTextNode.setFont(_this224.properties.calloutLabel);
        tempTextNode.setAlign({
          textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
          textBaseline: label.textBaseline
        });
        return tempTextNode.computeBBox();
      };
      var avoidNeighbourYCollision = function avoidNeighbourYCollision(label, next, direction) {
        var box = getTextBBox(label).grow(minSpacing / 2);
        var other = getTextBBox(next).grow(minSpacing / 2);
        var collidesOrBehind = box.x < other.x + other.width && box.x + box.width > other.x && (direction === "to-top" ? box.y < other.y + other.height : box.y + box.height > other.y);
        if (collidesOrBehind) {
          var dy = direction === "to-top" ? box.y - other.y - other.height : box.y + box.height - other.y;
          next.calloutLabel.collisionOffsetY = dy;
        }
      };
      var avoidYCollisions = function avoidYCollisions(labels) {
        var midLabel = labels.slice().sort(function (a, b) {
          return Math.abs(a.midSin) - Math.abs(b.midSin);
        })[0];
        var midIndex = labels.indexOf(midLabel);
        for (var i = midIndex - 1; i >= 0; i--) {
          var prev = labels[i + 1];
          var next = labels[i];
          avoidNeighbourYCollision(prev, next, "to-top");
        }
        for (var _i35 = midIndex + 1; _i35 < labels.length; _i35++) {
          var _prev = labels[_i35 - 1];
          var _next = labels[_i35];
          avoidNeighbourYCollision(_prev, _next, "to-bottom");
        }
      };
      var avoidXCollisions = function avoidXCollisions(labels) {
        var labelsCollideLabelsByY = data.some(function (datum) {
          return datum.calloutLabel.collisionOffsetY !== 0;
        });
        var boxes = labels.map(function (label) {
          return getTextBBox(label);
        });
        var paddedBoxes = boxes.map(function (box) {
          return box.clone().grow(minSpacing / 2);
        });
        var labelsCollideLabelsByX = false;
        for (var i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++) {
          var box = paddedBoxes[i];
          for (var j = i + 1; j < labels.length; j++) {
            var other = paddedBoxes[j];
            if (box.collidesBBox(other)) {
              labelsCollideLabelsByX = true;
              break;
            }
          }
        }
        var sectors = fullData.map(function (datum) {
          var startAngle = datum.startAngle,
            endAngle = datum.endAngle,
            outerRadius = datum.outerRadius;
          return {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
          };
        });
        var labelsCollideSectors = boxes.some(function (box) {
          return sectors.some(function (sector) {
            return boxCollidesSector(box, sector);
          });
        });
        if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) {
          return;
        }
        labels.filter(function (d) {
          return d.calloutLabel.textAlign === "center";
        }).forEach(function (d) {
          var label = d.calloutLabel;
          if (d.midCos < 0) {
            label.collisionTextAlign = "right";
          } else if (d.midCos > 0) {
            label.collisionTextAlign = "left";
          } else {
            label.collisionTextAlign = "center";
          }
        });
      };
      avoidYCollisions(leftLabels);
      avoidYCollisions(rightLabels);
      avoidXCollisions(topLabels);
      avoidXCollisions(bottomLabels);
    }
  }, {
    key: "updateCalloutLabelNodes",
    value: function updateCalloutLabelNodes(seriesRect) {
      var _this225 = this;
      var radiusScale = this.radiusScale;
      var _this$properties39 = this.properties,
        calloutLabel = _this$properties39.calloutLabel,
        calloutLine = _this$properties39.calloutLine;
      var calloutLength = calloutLine.length;
      var offset4 = calloutLabel.offset,
        color = calloutLabel.color;
      var tempTextNode = new _Text2();
      this.calloutLabelSelection.selectByTag(1 /* Label */).forEach(function (text) {
        var _a;
        var datum = text.datum;
        var label = datum.calloutLabel;
        var radius = radiusScale.convert(datum.radius);
        var outerRadius = Math.max(0, radius);
        if (!(label == null ? void 0 : label.text) || outerRadius === 0 || label.hidden) {
          text.visible = false;
          return;
        }
        var labelRadius = outerRadius + calloutLength + offset4;
        var x = datum.midCos * labelRadius;
        var y = datum.midSin * labelRadius + label.collisionOffsetY;
        var align = {
          textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
          textBaseline: label.textBaseline
        };
        tempTextNode.text = label.text;
        tempTextNode.x = x;
        tempTextNode.y = y;
        tempTextNode.setFont(_this225.properties.calloutLabel);
        tempTextNode.setAlign(align);
        var box = tempTextNode.computeBBox();
        var displayText = label.text;
        var visible = true;
        if (calloutLabel.avoidCollisions) {
          var _this225$getLabelOver = _this225.getLabelOverflow(label.text, box, seriesRect),
            textLength = _this225$getLabelOver.textLength,
            hasVerticalOverflow = _this225$getLabelOver.hasVerticalOverflow;
          displayText = label.text.length === textLength ? label.text : "".concat(label.text.substring(0, textLength), "\u2026");
          visible = !hasVerticalOverflow;
        }
        text.text = displayText;
        text.x = x;
        text.y = y;
        text.setFont(_this225.properties.calloutLabel);
        text.setAlign(align);
        text.fill = color;
        text.visible = visible;
      });
    }
  }, {
    key: "computeLabelsBBox",
    value: function computeLabelsBBox(options, seriesRect) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee83() {
        var _this226 = this;
        var _this$properties40, calloutLabel, calloutLine, calloutLength, offset4, maxCollisionOffset, minSpacing, textBoxes, text, titleBox, title, dy;
        return _regenerator().w(function (_context94) {
          while (1) switch (_context94.n) {
            case 0:
              _this$properties40 = this.properties, calloutLabel = _this$properties40.calloutLabel, calloutLine = _this$properties40.calloutLine;
              calloutLength = calloutLine.length;
              offset4 = calloutLabel.offset, maxCollisionOffset = calloutLabel.maxCollisionOffset, minSpacing = calloutLabel.minSpacing;
              if (calloutLabel.avoidCollisions) {
                _context94.n = 1;
                break;
              }
              return _context94.a(2, null);
            case 1:
              _context94.n = 2;
              return this.maybeRefreshNodeData();
            case 2:
              this.updateRadiusScale(false);
              this.computeCalloutLabelCollisionOffsets();
              textBoxes = [];
              text = new _Text2();
              title = this.properties.title;
              if ((title == null ? void 0 : title.text) && title.enabled) {
                dy = this.getTitleTranslationY();
                if (isFinite(dy)) {
                  text.text = title.text;
                  text.x = 0;
                  text.y = dy;
                  text.setFont(title);
                  text.setAlign({
                    textBaseline: "bottom",
                    textAlign: "center"
                  });
                  titleBox = text.computeBBox();
                  textBoxes.push(titleBox);
                }
              }
              this.nodeData.forEach(function (datum) {
                var _a;
                var label = datum.calloutLabel;
                if (!label || datum.outerRadius === 0) {
                  return null;
                }
                var labelRadius = datum.outerRadius + calloutLength + offset4;
                var x = datum.midCos * labelRadius;
                var y = datum.midSin * labelRadius + label.collisionOffsetY;
                text.text = label.text;
                text.x = x;
                text.y = y;
                text.setFont(_this226.properties.calloutLabel);
                text.setAlign({
                  textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                  textBaseline: label.textBaseline
                });
                var box = text.computeBBox();
                label.box = box;
                if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                  label.hidden = true;
                  return;
                }
                if (titleBox) {
                  var seriesTop = seriesRect.y - _this226.centerY;
                  var titleCleanArea = new _BBox2(titleBox.x - minSpacing, seriesTop, titleBox.width + 2 * minSpacing, titleBox.y + titleBox.height + minSpacing - seriesTop);
                  if (box.collidesBBox(titleCleanArea)) {
                    label.hidden = true;
                    return;
                  }
                }
                if (options.hideWhenNecessary) {
                  var _this226$getLabelOver = _this226.getLabelOverflow(label.text, box, seriesRect),
                    textLength = _this226$getLabelOver.textLength,
                    hasVerticalOverflow = _this226$getLabelOver.hasVerticalOverflow,
                    hasSurroundingSeriesOverflow = _this226$getLabelOver.hasSurroundingSeriesOverflow;
                  var isTooShort = label.text.length > 2 && textLength < 2;
                  if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                    label.hidden = true;
                    return;
                  }
                }
                label.hidden = false;
                textBoxes.push(box);
              });
              if (!(textBoxes.length === 0)) {
                _context94.n = 3;
                break;
              }
              return _context94.a(2, null);
            case 3:
              return _context94.a(2, _BBox2.merge(textBoxes));
          }
        }, _callee83, this);
      }));
    }
  }, {
    key: "updateSectorLabelNodes",
    value: function updateSectorLabelNodes() {
      var radiusScale = this.radiusScale;
      var innerRadius = radiusScale.convert(0);
      var _this$properties$sect = this.properties.sectorLabel,
        fontSize = _this$properties$sect.fontSize,
        fontStyle = _this$properties$sect.fontStyle,
        fontWeight = _this$properties$sect.fontWeight,
        fontFamily = _this$properties$sect.fontFamily,
        positionOffset = _this$properties$sect.positionOffset,
        positionRatio = _this$properties$sect.positionRatio,
        color = _this$properties$sect.color;
      this.sectorLabelSelection.each(function (text, datum) {
        var sectorLabel = datum.sectorLabel,
          outerRadius = datum.outerRadius;
        var isTextVisible = false;
        if (sectorLabel && outerRadius !== 0) {
          var labelRadius = innerRadius * (1 - positionRatio) + outerRadius * positionRatio + positionOffset;
          text.fill = color;
          text.fontStyle = fontStyle;
          text.fontWeight = fontWeight;
          text.fontSize = fontSize;
          text.fontFamily = fontFamily;
          text.text = sectorLabel.text;
          text.x = datum.midCos * labelRadius;
          text.y = datum.midSin * labelRadius;
          text.textAlign = "center";
          text.textBaseline = "middle";
          var bbox = text.computeBBox();
          var corners = [[bbox.x, bbox.y], [bbox.x + bbox.width, bbox.y], [bbox.x + bbox.width, bbox.y + bbox.height], [bbox.x, bbox.y + bbox.height]];
          var startAngle = datum.startAngle,
            endAngle = datum.endAngle;
          var sectorBounds = {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
          };
          if (corners.every(function (_ref172) {
            var _ref173 = _slicedToArray(_ref172, 2),
              x = _ref173[0],
              y = _ref173[1];
            return isPointInSector(x, y, sectorBounds);
          })) {
            isTextVisible = true;
          }
        }
        text.visible = isTextVisible;
      });
    }
  }, {
    key: "updateInnerLabelNodes",
    value: function updateInnerLabelNodes() {
      var textBBoxes = [];
      var margins = [];
      this.innerLabelsSelection.each(function (text, datum) {
        var fontStyle = datum.fontStyle,
          fontWeight = datum.fontWeight,
          fontSize = datum.fontSize,
          fontFamily = datum.fontFamily,
          color = datum.color;
        text.fontStyle = fontStyle;
        text.fontWeight = fontWeight;
        text.fontSize = fontSize;
        text.fontFamily = fontFamily;
        text.text = datum.text;
        text.x = 0;
        text.y = 0;
        text.fill = color;
        text.textAlign = "center";
        text.textBaseline = "alphabetic";
        textBBoxes.push(text.computeBBox());
        margins.push(datum.margin);
      });
      var getMarginTop = function getMarginTop(index) {
        return index === 0 ? 0 : margins[index];
      };
      var getMarginBottom = function getMarginBottom(index) {
        return index === margins.length - 1 ? 0 : margins[index];
      };
      var totalHeight = textBBoxes.reduce(function (sum2, bbox, i) {
        return sum2 + bbox.height + getMarginTop(i) + getMarginBottom(i);
      }, 0);
      var totalWidth = Math.max.apply(Math, _toConsumableArray(textBBoxes.map(function (bbox) {
        return bbox.width;
      })));
      var innerRadius = this.getInnerRadius();
      var labelRadius = Math.sqrt(Math.pow(totalWidth / 2, 2) + Math.pow(totalHeight / 2, 2));
      var labelsVisible = labelRadius <= (innerRadius > 0 ? innerRadius : this.getOuterRadius());
      var textBottoms = [];
      for (var i = 0, prev = -totalHeight / 2; i < textBBoxes.length; i++) {
        var bbox = textBBoxes[i];
        var bottom = bbox.height + prev + getMarginTop(i);
        textBottoms.push(bottom);
        prev = bottom + getMarginBottom(i);
      }
      this.innerLabelsSelection.each(function (text, _datum, index) {
        text.y = textBottoms[index];
        text.visible = labelsVisible;
      });
    }
  }, {
    key: "updateZerosumRings",
    value: function updateZerosumRings() {
      this.zerosumOuterRing.size = this.getOuterRadius() * 2;
      this.zerosumInnerRing.size = this.getInnerRadius() * 2;
    }
  }, {
    key: "getDatumLegendName",
    value: function getDatumLegendName(nodeDatum) {
      var _this$properties41 = this.properties,
        angleKey = _this$properties41.angleKey,
        calloutLabelKey = _this$properties41.calloutLabelKey,
        sectorLabelKey = _this$properties41.sectorLabelKey,
        legendItemKey = _this$properties41.legendItemKey;
      var sectorLabel = nodeDatum.sectorLabel,
        calloutLabel = nodeDatum.calloutLabel,
        legendItem = nodeDatum.legendItem;
      if (legendItemKey && legendItem !== void 0) {
        return legendItem.text;
      } else if (calloutLabelKey && calloutLabelKey !== angleKey && (calloutLabel == null ? void 0 : calloutLabel.text) !== void 0) {
        return calloutLabel.text;
      } else if (sectorLabelKey && sectorLabelKey !== angleKey && (sectorLabel == null ? void 0 : sectorLabel.text) !== void 0) {
        return sectorLabel.text;
      }
    }
  }, {
    key: "pickNodeClosestDatum",
    value: function pickNodeClosestDatum(point) {
      return _pickByMatchingAngle(this, point);
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var _a;
      if (!this.properties.isValid()) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var datum = nodeDatum.datum,
        angleValue = nodeDatum.angleValue,
        color = nodeDatum.sectorFormat.fill,
        itemId = nodeDatum.itemId;
      var title = _sanitizeHtml((_a = this.properties.title) == null ? void 0 : _a.text);
      var content = _isFiniteNumber(angleValue) ? _toFixed(angleValue) : String(angleValue);
      var labelText = this.getDatumLegendName(nodeDatum);
      return this.properties.tooltip.toTooltipHtml({
        title: title != null ? title : labelText,
        content: title && labelText ? "".concat(labelText, ": ").concat(content) : content,
        backgroundColor: color
      }, {
        datum: datum,
        itemId: itemId,
        title: title,
        color: color,
        seriesId: this.id,
        angleKey: this.properties.angleKey,
        angleName: this.properties.angleName,
        radiusKey: this.properties.radiusKey,
        radiusName: this.properties.radiusName,
        calloutLabelKey: this.properties.calloutLabelKey,
        calloutLabelName: this.properties.calloutLabelName,
        sectorLabelKey: this.properties.sectorLabelKey,
        sectorLabelName: this.properties.sectorLabelName,
        legendItemKey: this.properties.legendItemKey
      });
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b, _c, _d, _e;
      var visible = this.visible,
        processedData = this.processedData,
        dataModel = this.dataModel;
      if (!dataModel || !(processedData == null ? void 0 : processedData.data.length) || !this.properties.isValid() || legendType !== "category") {
        return [];
      }
      var _this$properties42 = this.properties,
        angleKey = _this$properties42.angleKey,
        calloutLabelKey = _this$properties42.calloutLabelKey,
        sectorLabelKey = _this$properties42.sectorLabelKey,
        legendItemKey = _this$properties42.legendItemKey;
      if (!legendItemKey && (!calloutLabelKey || calloutLabelKey === angleKey) && (!sectorLabelKey || sectorLabelKey === angleKey)) return [];
      var _this$getProcessedDat2 = this.getProcessedDataIndexes(dataModel),
        calloutLabelIdx = _this$getProcessedDat2.calloutLabelIdx,
        sectorLabelIdx = _this$getProcessedDat2.sectorLabelIdx,
        legendItemIdx = _this$getProcessedDat2.legendItemIdx;
      var titleText = ((_a = this.properties.title) == null ? void 0 : _a.showInLegend) && this.properties.title.text;
      var legendData = [];
      for (var index = 0; index < processedData.data.length; index++) {
        var _processedData$data$i = processedData.data[index],
          datum = _processedData$data$i.datum,
          values = _processedData$data$i.values;
        var labelParts = [];
        if (titleText) {
          labelParts.push(titleText);
        }
        var labels = this.getLabels(datum, 2 * Math.PI, 2 * Math.PI, false, values[calloutLabelIdx], values[sectorLabelIdx], values[legendItemIdx]);
        if (legendItemKey && labels.legendItem !== void 0) {
          labelParts.push(labels.legendItem.text);
        } else if (calloutLabelKey && calloutLabelKey !== angleKey && ((_b = labels.calloutLabel) == null ? void 0 : _b.text) !== void 0) {
          labelParts.push((_c = labels.calloutLabel) == null ? void 0 : _c.text);
        } else if (sectorLabelKey && sectorLabelKey !== angleKey && ((_d = labels.sectorLabel) == null ? void 0 : _d.text) !== void 0) {
          labelParts.push((_e = labels.sectorLabel) == null ? void 0 : _e.text);
        }
        if (labelParts.length === 0) continue;
        var sectorFormat = this.getSectorFormat(datum, index, false);
        legendData.push({
          legendType: "category",
          id: this.id,
          itemId: index,
          seriesId: this.id,
          enabled: visible && this.seriesItemEnabled[index],
          label: {
            text: labelParts.join(" - ")
          },
          marker: {
            fill: sectorFormat.fill,
            stroke: sectorFormat.stroke,
            fillOpacity: this.properties.fillOpacity,
            strokeOpacity: this.properties.strokeOpacity,
            strokeWidth: this.properties.strokeWidth
          },
          legendItemName: legendItemKey != null ? datum[legendItemKey] : void 0
        });
      }
      return legendData;
    }
  }, {
    key: "onLegendItemClick",
    value: function onLegendItemClick(event) {
      var enabled = event.enabled,
        itemId = event.itemId,
        series = event.series,
        legendItemName = event.legendItemName;
      if (series.id === this.id) {
        this.toggleSeriesItem(itemId, enabled);
      } else if (legendItemName != null) {
        this.toggleOtherSeriesItems(legendItemName, enabled);
      }
    }
  }, {
    key: "toggleSeriesItem",
    value: function toggleSeriesItem(itemId, enabled) {
      this.seriesItemEnabled[itemId] = enabled;
      this.nodeDataRefresh = true;
    }
  }, {
    key: "toggleOtherSeriesItems",
    value: function toggleOtherSeriesItems(legendItemName, enabled) {
      var _this227 = this;
      var _a;
      if (!this.properties.legendItemKey || !this.dataModel) {
        return;
      }
      var legendItemIdx = this.dataModel.resolveProcessedDataIndexById(this, "legendItemValue");
      (_a = this.processedData) == null ? void 0 : _a.data.forEach(function (_ref174, datumItemId) {
        var values = _ref174.values;
        if (values[legendItemIdx] === legendItemName) {
          _this227.toggleSeriesItem(datumItemId, enabled);
        }
      });
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(_data) {
      var animationManager = this.ctx.animationManager;
      var fns = _preparePieSeriesAnimationFunctions(true, this.properties.rotation, this.radiusScale, this.previousRadiusScale);
      _fromToMotion(this.id, "nodes", animationManager, [this.itemSelection, this.highlightSelection], fns.nodes);
      _fromToMotion(this.id, "innerCircle", animationManager, [this.innerCircleSelection], fns.innerCircle);
      _seriesLabelFadeInAnimation(this, "callout", animationManager, this.calloutLabelSelection);
      _seriesLabelFadeInAnimation(this, "sector", animationManager, this.sectorLabelSelection);
      _seriesLabelFadeInAnimation(this, "inner", animationManager, this.innerLabelsSelection);
      this.previousRadiusScale.range = this.radiusScale.range;
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady() {
      var _this228 = this;
      var _a, _b, _c, _d, _e, _f;
      var itemSelection = this.itemSelection,
        highlightSelection = this.highlightSelection,
        processedData = this.processedData,
        radiusScale = this.radiusScale,
        previousRadiusScale = this.previousRadiusScale;
      var animationManager = this.ctx.animationManager;
      var dataDiff = (_a = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _a.diff;
      this.ctx.animationManager.stopByAnimationGroupId(this.id);
      var supportedDiff = ((_b = dataDiff == null ? void 0 : dataDiff.moved.size) != null ? _b : 0) === 0;
      var hasKeys = ((_c = processedData == null ? void 0 : processedData.defs.keys.length) != null ? _c : 0) > 0;
      var hasUniqueKeys = (_f = (_e = (_d = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _d.animationValidation) == null ? void 0 : _e.uniqueKeys) != null ? _f : true;
      if (!supportedDiff || !hasKeys || !hasUniqueKeys) {
        this.ctx.animationManager.skipCurrentBatch();
      }
      var fns = _preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
      _fromToMotion(this.id, "nodes", animationManager, [itemSelection, highlightSelection], fns.nodes, function (_, datum) {
        return _this228.getDatumId(datum);
      }, dataDiff);
      _fromToMotion(this.id, "innerCircle", animationManager, [this.innerCircleSelection], fns.innerCircle);
      _seriesLabelFadeInAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
      _seriesLabelFadeInAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
      _seriesLabelFadeInAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
      this.previousRadiusScale.range = this.radiusScale.range;
    }
  }, {
    key: "animateClearingUpdateEmpty",
    value: function animateClearingUpdateEmpty() {
      var itemSelection = this.itemSelection,
        highlightSelection = this.highlightSelection,
        radiusScale = this.radiusScale,
        previousRadiusScale = this.previousRadiusScale;
      var animationManager = this.ctx.animationManager;
      var fns = _preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
      _fromToMotion(this.id, "nodes", animationManager, [itemSelection, highlightSelection], fns.nodes);
      _fromToMotion(this.id, "innerCircle", animationManager, [this.innerCircleSelection], fns.innerCircle);
      _seriesLabelFadeOutAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
      _seriesLabelFadeOutAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
      _seriesLabelFadeOutAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
      this.previousRadiusScale.range = this.radiusScale.range;
    }
  }, {
    key: "getDatumIdFromData",
    value: function getDatumIdFromData(datum) {
      var _a, _b, _c;
      var _this$properties43 = this.properties,
        calloutLabelKey = _this$properties43.calloutLabelKey,
        sectorLabelKey = _this$properties43.sectorLabelKey,
        legendItemKey = _this$properties43.legendItemKey;
      if (!((_c = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.animationValidation) == null ? void 0 : _c.uniqueKeys)) {
        return;
      }
      if (legendItemKey) {
        return datum[legendItemKey];
      } else if (calloutLabelKey) {
        return datum[calloutLabelKey];
      } else if (sectorLabelKey) {
        return datum[sectorLabelKey];
      }
    }
  }, {
    key: "getDatumId",
    value: function getDatumId(datum) {
      var index = datum.index;
      var datumId = this.getDatumIdFromData(datum.datum);
      return datumId != null ? String(datumId) : "".concat(index);
    }
  }, {
    key: "onDataChange",
    value: function onDataChange() {
      var _a;
      var data = this.data,
        seriesItemEnabled = this.seriesItemEnabled;
      this.seriesItemEnabled = (_a = data == null ? void 0 : data.map(function (_, index) {
        var _a2;
        return (_a2 = seriesItemEnabled[index]) != null ? _a2 : true;
      })) != null ? _a : [];
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(opts) {
      return _computeSectorFocusBounds(this, opts);
    }
  }, {
    key: "visible",
    get: function get() {
      return _superPropGet(DonutSeries, "visible", this, 1) && (this.seriesItemEnabled.length === 0 || this.seriesItemEnabled.some(function (visible) {
        return visible;
      }));
    }
  }]);
  return DonutSeries;
}(_PolarSeries3);
DonutSeries.className = "DonutSeries";
DonutSeries.type = "donut";

// packages/ag-charts-community/src/chart/series/polar/pieTheme.ts
var pieTheme = {
  series: {
    __extends__: _EXTENDS_SERIES_DEFAULTS,
    title: {
      enabled: true,
      fontStyle: void 0,
      fontWeight: "normal" /* NORMAL */,
      fontSize: 14,
      fontFamily: _DEFAULT_FONT_FAMILY,
      color: _DEFAULT_MUTED_LABEL_COLOUR,
      spacing: 5
    },
    calloutLabel: {
      enabled: true,
      fontStyle: void 0,
      fontWeight: void 0,
      fontSize: 12,
      fontFamily: _DEFAULT_FONT_FAMILY,
      color: _DEFAULT_LABEL_COLOUR,
      offset: 3,
      minAngle: 0
    },
    sectorLabel: {
      enabled: true,
      fontStyle: void 0,
      fontWeight: "normal" /* NORMAL */,
      fontSize: 12,
      fontFamily: _DEFAULT_FONT_FAMILY,
      color: _DEFAULT_INSIDE_SERIES_LABEL_COLOUR,
      positionOffset: 0,
      positionRatio: 0.5
    },
    calloutLine: {
      length: 10,
      strokeWidth: 2
    },
    fillOpacity: 1,
    strokeOpacity: 1,
    strokeWidth: 1,
    lineDash: [0],
    lineDashOffset: 0,
    rotation: 0,
    // @todo(AG-10275) Uncomment this
    // sectorSpacing: 1,
    shadow: {
      enabled: false,
      color: _DEFAULT_SHADOW_COLOUR,
      xOffset: 3,
      yOffset: 3,
      blur: 5
    },
    innerLabels: {
      fontStyle: void 0,
      fontWeight: void 0,
      fontSize: 12,
      fontFamily: _DEFAULT_FONT_FAMILY,
      color: _DEFAULT_LABEL_COLOUR,
      margin: 2
    },
    // @todo(AG-10275) Remove this
    // @ts-expect-error
    __BACKGROUND_COLOR_DO_NOT_USE: _DEFAULT_BACKGROUND_COLOUR
  }
};
var piePaletteFactory = function piePaletteFactory(_ref175) {
  var takeColors = _ref175.takeColors,
    colorsCount = _ref175.colorsCount,
    userPalette = _ref175.userPalette;
  var _takeColors3 = takeColors(colorsCount),
    fills = _takeColors3.fills,
    strokes = _takeColors3.strokes;
  return {
    fills: fills,
    strokes: userPalette ? strokes : [],
    calloutLine: {
      colors: strokes
    }
  };
};

// packages/ag-charts-community/src/chart/series/polar/donutSeriesModule.ts
var DonutSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["polar"],
  identifier: "donut",
  instanceConstructor: DonutSeries,
  themeTemplate: pieTheme,
  paletteFactory: piePaletteFactory
};

// packages/ag-charts-community/src/chart/series/polar/pieSeriesProperties.ts
var PieTitle = /*#__PURE__*/function (_Caption2) {
  _inherits(PieTitle, _Caption2);
  function PieTitle() {
    var _this229;
    _classCallCheck(this, PieTitle);
    _this229 = _possibleConstructorReturn(this, _getPrototypeOf(PieTitle).apply(this, arguments));
    _this229.showInLegend = false;
    return _this229;
  }
  return PieTitle;
}(_Caption3);
__decorateClass([_Validate(_BOOLEAN)], PieTitle.prototype, "showInLegend", 2);
var DonutInnerLabel2 = /*#__PURE__*/function (_Label7) {
  _inherits(DonutInnerLabel2, _Label7);
  function DonutInnerLabel2() {
    _classCallCheck(this, DonutInnerLabel2);
    return _possibleConstructorReturn(this, _getPrototypeOf(DonutInnerLabel2).apply(this, arguments));
  }
  _createClass(DonutInnerLabel2, [{
    key: "set",
    value: function set(properties, _reset) {
      return _superPropGet(DonutInnerLabel2, "set", this, 3)([properties]);
    }
  }]);
  return DonutInnerLabel2;
}(_Label0);
__decorateClass([_Deprecated("Use a Donut Series instead"), _Validate(_STRING, {
  optional: true
})], DonutInnerLabel2.prototype, "text", 2);
__decorateClass([_Deprecated("Use a Donut Series instead"), _Validate(_NUMBER, {
  optional: true
})], DonutInnerLabel2.prototype, "margin", 2);
var DonutInnerCircle2 = /*#__PURE__*/function (_BaseProperties32) {
  _inherits(DonutInnerCircle2, _BaseProperties32);
  function DonutInnerCircle2() {
    _classCallCheck(this, DonutInnerCircle2);
    return _possibleConstructorReturn(this, _getPrototypeOf(DonutInnerCircle2).apply(this, arguments));
  }
  return DonutInnerCircle2;
}(_BaseProperties35);
__decorateClass([_Deprecated("Use a Donut Series instead"), _Validate(_COLOR_STRING, {
  optional: true
})], DonutInnerCircle2.prototype, "fill", 2);
__decorateClass([_Deprecated("Use a Donut Series instead"), _Validate(_RATIO, {
  optional: true
})], DonutInnerCircle2.prototype, "fillOpacity", 2);
var PieSeriesCalloutLabel = /*#__PURE__*/function (_Label8) {
  _inherits(PieSeriesCalloutLabel, _Label8);
  function PieSeriesCalloutLabel() {
    var _this230;
    _classCallCheck(this, PieSeriesCalloutLabel);
    _this230 = _possibleConstructorReturn(this, _getPrototypeOf(PieSeriesCalloutLabel).apply(this, arguments));
    _this230.offset = 3;
    _this230.minAngle = 0;
    _this230.minSpacing = 4;
    _this230.maxCollisionOffset = 50;
    _this230.avoidCollisions = true;
    return _this230;
  }
  return PieSeriesCalloutLabel;
}(_Label0);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesCalloutLabel.prototype, "offset", 2);
__decorateClass([_Validate(_DEGREE)], PieSeriesCalloutLabel.prototype, "minAngle", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesCalloutLabel.prototype, "minSpacing", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesCalloutLabel.prototype, "maxCollisionOffset", 2);
__decorateClass([_Validate(_BOOLEAN)], PieSeriesCalloutLabel.prototype, "avoidCollisions", 2);
var PieSeriesSectorLabel = /*#__PURE__*/function (_Label9) {
  _inherits(PieSeriesSectorLabel, _Label9);
  function PieSeriesSectorLabel() {
    var _this231;
    _classCallCheck(this, PieSeriesSectorLabel);
    _this231 = _possibleConstructorReturn(this, _getPrototypeOf(PieSeriesSectorLabel).apply(this, arguments));
    _this231.positionOffset = 0;
    _this231.positionRatio = 0.5;
    return _this231;
  }
  return PieSeriesSectorLabel;
}(_Label0);
__decorateClass([_Validate(_NUMBER)], PieSeriesSectorLabel.prototype, "positionOffset", 2);
__decorateClass([_Validate(_RATIO)], PieSeriesSectorLabel.prototype, "positionRatio", 2);
var PieSeriesCalloutLine = /*#__PURE__*/function (_BaseProperties33) {
  _inherits(PieSeriesCalloutLine, _BaseProperties33);
  function PieSeriesCalloutLine() {
    var _this232;
    _classCallCheck(this, PieSeriesCalloutLine);
    _this232 = _possibleConstructorReturn(this, _getPrototypeOf(PieSeriesCalloutLine).apply(this, arguments));
    _this232.length = 10;
    _this232.strokeWidth = 1;
    return _this232;
  }
  return PieSeriesCalloutLine;
}(_BaseProperties35);
__decorateClass([_Validate(_COLOR_STRING_ARRAY, {
  optional: true
})], PieSeriesCalloutLine.prototype, "colors", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesCalloutLine.prototype, "length", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesCalloutLine.prototype, "strokeWidth", 2);
var PieSeriesProperties = /*#__PURE__*/function (_SeriesProperties3) {
  _inherits(PieSeriesProperties, _SeriesProperties3);
  function PieSeriesProperties() {
    var _this233;
    _classCallCheck(this, PieSeriesProperties);
    _this233 = _possibleConstructorReturn(this, _getPrototypeOf(PieSeriesProperties).apply(this, arguments));
    _this233.fills = Object.values(DEFAULT_FILLS);
    _this233.strokes = Object.values(DEFAULT_STROKES);
    _this233.fillOpacity = 1;
    _this233.strokeOpacity = 1;
    _this233.lineDash = [0];
    _this233.lineDashOffset = 0;
    _this233.cornerRadius = 0;
    _this233.rotation = 0;
    _this233.outerRadiusOffset = 0;
    _this233.outerRadiusRatio = 1;
    _this233.strokeWidth = 1;
    _this233.sectorSpacing = void 0;
    _this233.innerLabels = new _PropertiesArray2(DonutInnerLabel2);
    _this233.title = new PieTitle();
    _this233.innerCircle = new DonutInnerCircle2();
    _this233.shadow = new _DropShadow();
    _this233.calloutLabel = new PieSeriesCalloutLabel();
    _this233.sectorLabel = new PieSeriesSectorLabel();
    _this233.calloutLine = new PieSeriesCalloutLine();
    _this233.tooltip = new _SeriesTooltip();
    _this233.__BACKGROUND_COLOR_DO_NOT_USE = void 0;
    return _this233;
  }
  return PieSeriesProperties;
}(_SeriesProperties4);
__decorateClass([_Validate(_STRING)], PieSeriesProperties.prototype, "angleKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "angleName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "radiusKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "radiusName", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], PieSeriesProperties.prototype, "radiusMin", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], PieSeriesProperties.prototype, "radiusMax", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "calloutLabelKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "calloutLabelName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "sectorLabelKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "sectorLabelName", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "legendItemKey", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], PieSeriesProperties.prototype, "fills", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], PieSeriesProperties.prototype, "strokes", 2);
__decorateClass([_Validate(_RATIO)], PieSeriesProperties.prototype, "fillOpacity", 2);
__decorateClass([_Validate(_RATIO)], PieSeriesProperties.prototype, "strokeOpacity", 2);
__decorateClass([_Validate(_LINE_DASH)], PieSeriesProperties.prototype, "lineDash", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesProperties.prototype, "lineDashOffset", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesProperties.prototype, "cornerRadius", 2);
__decorateClass([_Validate(_FUNCTION, {
  optional: true
})], PieSeriesProperties.prototype, "formatter", 2);
__decorateClass([_Validate(_DEGREE)], PieSeriesProperties.prototype, "rotation", 2);
__decorateClass([_Validate(_NUMBER)], PieSeriesProperties.prototype, "outerRadiusOffset", 2);
__decorateClass([_Validate(_RATIO)], PieSeriesProperties.prototype, "outerRadiusRatio", 2);
__decorateClass([_Deprecated("Use a Donut Series instead"), _Validate(_NUMBER, {
  optional: true
})], PieSeriesProperties.prototype, "innerRadiusOffset", 2);
__decorateClass([_Deprecated("Use a Donut Series instead"), _Validate(_RATIO, {
  optional: true
})], PieSeriesProperties.prototype, "innerRadiusRatio", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER)], PieSeriesProperties.prototype, "strokeWidth", 2);
__decorateClass([_Validate(_POSITIVE_NUMBER, {
  optional: true
})], PieSeriesProperties.prototype, "sectorSpacing", 2);
__decorateClass([_Validate(_OBJECT_ARRAY)], PieSeriesProperties.prototype, "innerLabels", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "title", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "innerCircle", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "shadow", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "calloutLabel", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "sectorLabel", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "calloutLine", 2);
__decorateClass([_Validate(_OBJECT)], PieSeriesProperties.prototype, "tooltip", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], PieSeriesProperties.prototype, "__BACKGROUND_COLOR_DO_NOT_USE", 2);

// packages/ag-charts-community/src/chart/series/polar/pieSeries.ts
var PieSeriesNodeEvent = /*#__PURE__*/function (_SeriesNodeEvent3) {
  _inherits(PieSeriesNodeEvent, _SeriesNodeEvent3);
  function PieSeriesNodeEvent(type, nativeEvent, datum, series) {
    var _this234;
    _classCallCheck(this, PieSeriesNodeEvent);
    _this234 = _possibleConstructorReturn(this, _getPrototypeOf(PieSeriesNodeEvent).call(this, type, nativeEvent, datum, series));
    _this234.angleKey = series.properties.angleKey;
    _this234.radiusKey = series.properties.radiusKey;
    _this234.calloutLabelKey = series.properties.calloutLabelKey;
    _this234.sectorLabelKey = series.properties.sectorLabelKey;
    return _this234;
  }
  return PieSeriesNodeEvent;
}(_SeriesNodeEvent4);
var PieSeries = /*#__PURE__*/function (_PolarSeries2) {
  _inherits(PieSeries, _PolarSeries2);
  function PieSeries(moduleCtx) {
    var _this235;
    _classCallCheck(this, PieSeries);
    _this235 = _possibleConstructorReturn(this, _getPrototypeOf(PieSeries).call(this, {
      moduleCtx: moduleCtx,
      pickModes: [0 /* EXACT_SHAPE_MATCH */],
      useLabelLayer: true,
      animationResetFns: {
        item: _resetPieSelectionsFn,
        label: _resetLabelFn
      }
    }));
    _this235.properties = new PieSeriesProperties();
    _this235.previousRadiusScale = new _LinearScale();
    _this235.radiusScale = new _LinearScale();
    // The group node that contains the background graphics.
    _this235.backgroundGroup = _this235.rootGroup.appendChild(new _Group4({
      name: "".concat(_this235.id, "-background"),
      layer: true,
      zIndex: 0 /* SERIES_BACKGROUND_ZINDEX */
    }));
    // AG-6193 If the sum of all datums is 0, then we'll draw 1 or 2 rings to represent the empty series.
    _this235.zerosumRingsGroup = _this235.backgroundGroup.appendChild(new _Group4({
      name: "".concat(_this235.id, "-zerosumRings")
    }));
    _this235.zerosumOuterRing = _this235.zerosumRingsGroup.appendChild(new _Circle());
    _this235.zerosumInnerRing = _this235.zerosumRingsGroup.appendChild(new _Circle());
    _this235.innerCircleGroup = _this235.backgroundGroup.appendChild(new _Group4({
      name: "".concat(_this235.id, "-innerCircle")
    }));
    // When a user toggles a series item (e.g. from the legend), its boolean state is recorded here.
    _this235.seriesItemEnabled = [];
    _this235.surroundingRadius = void 0;
    _this235.NodeEvent = PieSeriesNodeEvent;
    _this235.angleScale = new _LinearScale();
    _this235.angleScale.domain = [0, 1];
    _this235.angleScale.range = [-Math.PI, Math.PI].map(function (angle) {
      return angle + Math.PI / 2;
    });
    var pieCalloutLabels = new _Group4({
      name: "pieCalloutLabels"
    });
    var pieSectorLabels = new _Group4({
      name: "pieSectorLabels"
    });
    var innerLabels = new _Group4({
      name: "innerLabels"
    });
    _this235.labelGroup.append(pieCalloutLabels);
    _this235.labelGroup.append(pieSectorLabels);
    _this235.labelGroup.append(innerLabels);
    _this235.calloutLabelSelection = _Selection2.select(pieCalloutLabels, _Group4);
    _this235.sectorLabelSelection = _Selection2.select(pieSectorLabels, _Text2);
    _this235.innerLabelsSelection = _Selection2.select(innerLabels, _Text2);
    _this235.innerCircleSelection = _Selection2.select(_this235.innerCircleGroup, _Circle);
    return _this235;
  }
  _createClass(PieSeries, [{
    key: "addChartEventListeners",
    value: function addChartEventListeners() {
      var _this236 = this;
      var _a;
      this.destroyFns.push((_a = this.ctx.chartEventManager) == null ? void 0 : _a.addListener("legend-item-click", function (event) {
        return _this236.onLegendItemClick(event);
      }));
    }
  }, {
    key: "nodeFactory",
    value: function nodeFactory() {
      return new _Sector();
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain(direction) {
      if (direction === "x" /* X */) {
        return this.angleScale.domain;
      } else {
        return this.radiusScale.domain;
      }
    }
  }, {
    key: "processData",
    value: function processData(dataController) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee84() {
        var _a, _b, _c, _d, _e, data, visible, seriesItemEnabled, _this$properties44, angleKey, radiusKey, calloutLabelKey, sectorLabelKey, legendItemKey, animationEnabled, extraKeyProps, extraProps, radiusScaleType, angleScaleType, _iterator210, _step210, valueDef, id, missing, property, missCount;
        return _regenerator().w(function (_context95) {
          while (1) switch (_context95.n) {
            case 0:
              if (!(this.data == null || !this.properties.isValid())) {
                _context95.n = 1;
                break;
              }
              return _context95.a(2);
            case 1:
              data = this.data;
              visible = this.visible, seriesItemEnabled = this.seriesItemEnabled;
              _this$properties44 = this.properties, angleKey = _this$properties44.angleKey, radiusKey = _this$properties44.radiusKey, calloutLabelKey = _this$properties44.calloutLabelKey, sectorLabelKey = _this$properties44.sectorLabelKey, legendItemKey = _this$properties44.legendItemKey;
              animationEnabled = !this.ctx.animationManager.isSkipped();
              extraKeyProps = [];
              extraProps = [];
              if (legendItemKey) {
                extraKeyProps.push(_keyProperty(legendItemKey, "band", {
                  id: "legendItemKey"
                }));
              } else if (calloutLabelKey) {
                extraKeyProps.push(_keyProperty(calloutLabelKey, "band", {
                  id: "calloutLabelKey"
                }));
              } else if (sectorLabelKey) {
                extraKeyProps.push(_keyProperty(sectorLabelKey, "band", {
                  id: "sectorLabelKey"
                }));
              }
              radiusScaleType = this.radiusScale.type;
              angleScaleType = this.radiusScale.type;
              if (radiusKey) {
                extraProps.push(_rangedValueProperty(radiusKey, {
                  id: "radiusValue",
                  min: (_a = this.properties.radiusMin) != null ? _a : 0,
                  max: this.properties.radiusMax
                }), _valueProperty(radiusKey, radiusScaleType, {
                  id: "radiusRaw"
                }),
                // Raw value pass-through.
                _normalisePropertyTo({
                  id: "radiusValue"
                }, [0, 1], 1, (_b = this.properties.radiusMin) != null ? _b : 0, this.properties.radiusMax));
              }
              if (calloutLabelKey) {
                extraProps.push(_valueProperty(calloutLabelKey, "band", {
                  id: "calloutLabelValue"
                }));
              }
              if (sectorLabelKey) {
                extraProps.push(_valueProperty(sectorLabelKey, "band", {
                  id: "sectorLabelValue"
                }));
              }
              if (legendItemKey) {
                extraProps.push(_valueProperty(legendItemKey, "band", {
                  id: "legendItemValue"
                }));
              }
              if (animationEnabled && this.processedData && extraKeyProps.length > 0) {
                extraProps.push(_diff(this.processedData));
              }
              extraProps.push(_animationValidation());
              data = data.map(function (d, idx) {
                return visible && seriesItemEnabled[idx] ? d : __spreadProps(__spreadValues({}, d), _defineProperty({}, angleKey, 0));
              });
              _context95.n = 2;
              return this.requestDataModel(dataController, data, {
                props: [].concat(extraKeyProps, [_accumulativeValueProperty(angleKey, angleScaleType, {
                  id: "angleValue",
                  onlyPositive: true
                }), _valueProperty(angleKey, angleScaleType, {
                  id: "angleRaw"
                }),
                // Raw value pass-through.
                _normalisePropertyTo({
                  id: "angleValue"
                }, [0, 1], 0, 0)], extraProps)
              });
            case 2:
              _iterator210 = _createForOfIteratorHelper((_e = (_d = (_c = this.processedData) == null ? void 0 : _c.defs) == null ? void 0 : _d.values) != null ? _e : []);
              try {
                for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
                  valueDef = _step210.value;
                  id = valueDef.id, missing = valueDef.missing, property = valueDef.property;
                  missCount = _getMissCount(this, missing);
                  if (id !== "angleRaw" && missCount > 0) {
                    _Logger.warnOnce("no value was found for the key '".concat(String(property), "' on ").concat(missCount, " data element").concat(missCount > 1 ? "s" : ""));
                  }
                }
              } catch (err) {
                _iterator210.e(err);
              } finally {
                _iterator210.f();
              }
              this.animationState.transition("updateData");
            case 3:
              return _context95.a(2);
          }
        }, _callee84, this);
      }));
    }
  }, {
    key: "maybeRefreshNodeData",
    value: function maybeRefreshNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee85() {
        var _a, _ref176, _ref176$nodeData, nodeData, _t14, _t15;
        return _regenerator().w(function (_context96) {
          while (1) switch (_context96.n) {
            case 0:
              if (this.nodeDataRefresh) {
                _context96.n = 1;
                break;
              }
              return _context96.a(2);
            case 1:
              _context96.n = 2;
              return this.createNodeData();
            case 2:
              _t14 = _a = _context96.v;
              if (!(_t14 != null)) {
                _context96.n = 3;
                break;
              }
              _t15 = _a;
              _context96.n = 4;
              break;
            case 3:
              _t15 = {};
            case 4:
              _ref176 = _t15;
              _ref176$nodeData = _ref176.nodeData;
              nodeData = _ref176$nodeData === void 0 ? [] : _ref176$nodeData;
              this.nodeData = nodeData;
              this.nodeDataRefresh = false;
            case 5:
              return _context96.a(2);
          }
        }, _callee85, this);
      }));
    }
  }, {
    key: "getProcessedDataIndexes",
    value: function getProcessedDataIndexes(dataModel) {
      var angleIdx = dataModel.resolveProcessedDataIndexById(this, "angleValue");
      var radiusIdx = this.properties.radiusKey ? dataModel.resolveProcessedDataIndexById(this, "radiusValue") : -1;
      var calloutLabelIdx = this.properties.calloutLabelKey ? dataModel.resolveProcessedDataIndexById(this, "calloutLabelValue") : -1;
      var sectorLabelIdx = this.properties.sectorLabelKey ? dataModel.resolveProcessedDataIndexById(this, "sectorLabelValue") : -1;
      var legendItemIdx = this.properties.legendItemKey ? dataModel.resolveProcessedDataIndexById(this, "legendItemValue") : -1;
      return {
        angleIdx: angleIdx,
        radiusIdx: radiusIdx,
        calloutLabelIdx: calloutLabelIdx,
        sectorLabelIdx: sectorLabelIdx,
        legendItemIdx: legendItemIdx
      };
    }
  }, {
    key: "createNodeData",
    value: function createNodeData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee86() {
        var _this237 = this;
        var seriesId, processedData, dataModel, angleScale, rotation, _this$getProcessedDat3, angleIdx, radiusIdx, calloutLabelIdx, sectorLabelIdx, legendItemIdx, currentStart, sum2, nodeData, _this$properties$inne, innerRadiusRatio;
        return _regenerator().w(function (_context97) {
          while (1) switch (_context97.n) {
            case 0:
              seriesId = this.id, processedData = this.processedData, dataModel = this.dataModel, angleScale = this.angleScale;
              rotation = this.properties.rotation;
              if (!(!processedData || !dataModel || processedData.type !== "ungrouped")) {
                _context97.n = 1;
                break;
              }
              return _context97.a(2);
            case 1:
              _this$getProcessedDat3 = this.getProcessedDataIndexes(dataModel), angleIdx = _this$getProcessedDat3.angleIdx, radiusIdx = _this$getProcessedDat3.radiusIdx, calloutLabelIdx = _this$getProcessedDat3.calloutLabelIdx, sectorLabelIdx = _this$getProcessedDat3.sectorLabelIdx, legendItemIdx = _this$getProcessedDat3.legendItemIdx;
              currentStart = 0;
              sum2 = 0;
              nodeData = processedData.data.map(function (group2, index) {
                var _a;
                var datum = group2.datum,
                  values = group2.values;
                var currentValue = values[angleIdx];
                var startAngle = angleScale.convert(currentStart) + _toRadians(rotation);
                currentStart = currentValue;
                sum2 += currentValue;
                var endAngle = angleScale.convert(currentStart) + _toRadians(rotation);
                var span = Math.abs(endAngle - startAngle);
                var midAngle = startAngle + span / 2;
                var angleValue = values[angleIdx + 1];
                var radius = radiusIdx >= 0 ? (_a = values[radiusIdx]) != null ? _a : 1 : 1;
                var radiusValue = radiusIdx >= 0 ? values[radiusIdx + 1] : void 0;
                var legendItemValue = legendItemIdx >= 0 ? values[legendItemIdx] : void 0;
                var labels = _this237.getLabels(datum, midAngle, span, true, values[calloutLabelIdx], values[sectorLabelIdx], legendItemValue);
                var sectorFormat = _this237.getSectorFormat(datum, index, false);
                return __spreadValues({
                  itemId: index,
                  series: _this237,
                  datum: datum,
                  index: index,
                  angleValue: angleValue,
                  midAngle: midAngle,
                  midCos: Math.cos(midAngle),
                  midSin: Math.sin(midAngle),
                  startAngle: startAngle,
                  endAngle: endAngle,
                  sectorFormat: sectorFormat,
                  radiusValue: radiusValue,
                  radius: radius,
                  innerRadius: Math.max(_this237.radiusScale.convert(0), 0),
                  outerRadius: Math.max(_this237.radiusScale.convert(radius), 0),
                  legendItemValue: legendItemValue
                }, labels);
              });
              this.zerosumOuterRing.visible = sum2 === 0;
              _this$properties$inne = this.properties.innerRadiusRatio, innerRadiusRatio = _this$properties$inne === void 0 ? 1 : _this$properties$inne;
              this.zerosumInnerRing.visible = sum2 === 0 && innerRadiusRatio !== 1 && innerRadiusRatio > 0;
              return _context97.a(2, {
                itemId: seriesId,
                nodeData: nodeData,
                labelData: nodeData
              });
          }
        }, _callee86, this);
      }));
    }
  }, {
    key: "getLabels",
    value: function getLabels(datum, midAngle, span, skipDisabled, calloutLabelValue, sectorLabelValue, legendItemValue) {
      var _this$properties45 = this.properties,
        calloutLabel = _this$properties45.calloutLabel,
        sectorLabel = _this$properties45.sectorLabel,
        legendItemKey = _this$properties45.legendItemKey;
      var calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.properties.calloutLabelKey : void 0;
      var sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.properties.sectorLabelKey : void 0;
      if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) {
        return {};
      }
      var labelFormatterParams = {
        datum: datum,
        angleKey: this.properties.angleKey,
        angleName: this.properties.angleName,
        radiusKey: this.properties.radiusKey,
        radiusName: this.properties.radiusName,
        calloutLabelKey: this.properties.calloutLabelKey,
        calloutLabelName: this.properties.calloutLabelName,
        sectorLabelKey: this.properties.sectorLabelKey,
        sectorLabelName: this.properties.sectorLabelName,
        legendItemKey: this.properties.legendItemKey
      };
      var result = {};
      if (calloutLabelKey && span > _toRadians(calloutLabel.minAngle)) {
        result.calloutLabel = __spreadProps(__spreadValues({}, this.getTextAlignment(midAngle)), {
          text: this.getLabelText(calloutLabel, __spreadProps(__spreadValues({}, labelFormatterParams), {
            value: calloutLabelValue
          })),
          hidden: false,
          collisionTextAlign: void 0,
          collisionOffsetY: 0,
          box: void 0
        });
      }
      if (sectorLabelKey) {
        result.sectorLabel = {
          text: this.getLabelText(sectorLabel, __spreadProps(__spreadValues({}, labelFormatterParams), {
            value: sectorLabelValue
          }))
        };
      }
      if (legendItemKey != null && legendItemValue != null) {
        result.legendItem = {
          key: legendItemKey,
          text: legendItemValue
        };
      }
      return result;
    }
  }, {
    key: "getTextAlignment",
    value: function getTextAlignment(midAngle) {
      var quadrantTextOpts = [{
        textAlign: "center",
        textBaseline: "bottom"
      }, {
        textAlign: "left",
        textBaseline: "middle"
      }, {
        textAlign: "center",
        textBaseline: "hanging"
      }, {
        textAlign: "right",
        textBaseline: "middle"
      }];
      var midAngle180 = _normalizeAngle(midAngle);
      var quadrantStart = -0.75 * Math.PI;
      var quadrantOffset = midAngle180 - quadrantStart;
      var quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
      var quadrantIndex = _mod(quadrant, quadrantTextOpts.length);
      return quadrantTextOpts[quadrantIndex];
    }
  }, {
    key: "getSectorFormat",
    value: function getSectorFormat(datum, formatIndex, highlight) {
      var _a, _b, _c, _d, _e;
      var _this$ctx4 = this.ctx,
        callbackCache = _this$ctx4.callbackCache,
        highlightManager = _this$ctx4.highlightManager;
      var _this$properties46 = this.properties,
        angleKey = _this$properties46.angleKey,
        radiusKey = _this$properties46.radiusKey,
        fills = _this$properties46.fills,
        strokes = _this$properties46.strokes,
        formatter = _this$properties46.formatter,
        sectorSpacing = _this$properties46.sectorSpacing,
        __BACKGROUND_COLOR_DO_NOT_USE = _this$properties46.__BACKGROUND_COLOR_DO_NOT_USE;
      var highlightedDatum = highlightManager.getActiveHighlight();
      var isDatumHighlighted = highlight && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this && formatIndex === highlightedDatum.itemId;
      var defaultStroke = strokes[formatIndex % strokes.length];
      if (sectorSpacing != null) {
        defaultStroke != null ? defaultStroke : defaultStroke = __BACKGROUND_COLOR_DO_NOT_USE;
      }
      var _mergeDefaults3 = _mergeDefaults4(isDatumHighlighted && this.properties.highlightStyle.item, {
          fill: fills.length > 0 ? fills[formatIndex % fills.length] : void 0,
          fillOpacity: this.properties.fillOpacity,
          stroke: defaultStroke,
          strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
          strokeOpacity: this.getOpacity()
        }),
        fill = _mergeDefaults3.fill,
        fillOpacity = _mergeDefaults3.fillOpacity,
        stroke = _mergeDefaults3.stroke,
        strokeWidth = _mergeDefaults3.strokeWidth,
        strokeOpacity = _mergeDefaults3.strokeOpacity;
      var format2;
      if (formatter) {
        format2 = callbackCache.call(formatter, {
          datum: datum,
          angleKey: angleKey,
          radiusKey: radiusKey,
          fill: fill,
          stroke: stroke,
          fills: fills,
          strokes: strokes,
          strokeWidth: strokeWidth,
          highlighted: isDatumHighlighted,
          seriesId: this.id
        });
      }
      return {
        fill: (_a = format2 == null ? void 0 : format2.fill) != null ? _a : fill,
        fillOpacity: (_b = format2 == null ? void 0 : format2.fillOpacity) != null ? _b : fillOpacity,
        stroke: (_c = format2 == null ? void 0 : format2.stroke) != null ? _c : stroke,
        strokeWidth: (_d = format2 == null ? void 0 : format2.strokeWidth) != null ? _d : strokeWidth,
        strokeOpacity: (_e = format2 == null ? void 0 : format2.strokeOpacity) != null ? _e : strokeOpacity
      };
    }
  }, {
    key: "getInnerRadius",
    value: function getInnerRadius() {
      var radius = this.radius;
      var _this$properties47 = this.properties,
        _this$properties47$in = _this$properties47.innerRadiusRatio,
        innerRadiusRatio = _this$properties47$in === void 0 ? 1 : _this$properties47$in,
        _this$properties47$in2 = _this$properties47.innerRadiusOffset,
        innerRadiusOffset = _this$properties47$in2 === void 0 ? 0 : _this$properties47$in2;
      var innerRadius = radius * innerRadiusRatio + innerRadiusOffset;
      if (innerRadius === radius || innerRadius < 0) {
        return 0;
      }
      return innerRadius;
    }
  }, {
    key: "getOuterRadius",
    value: function getOuterRadius() {
      return Math.max(this.radius * this.properties.outerRadiusRatio + this.properties.outerRadiusOffset, 0);
    }
  }, {
    key: "updateRadiusScale",
    value: function updateRadiusScale(resize) {
      var _this238 = this;
      var newRange = [this.getInnerRadius(), this.getOuterRadius()];
      this.radiusScale.range = newRange;
      if (resize) {
        this.previousRadiusScale.range = newRange;
      }
      this.nodeData = this.nodeData.map(function (_a) {
        var _b = _a,
          radius = _b.radius,
          d = __objRest(_b, ["radius"]);
        return __spreadProps(__spreadValues({}, d), {
          radius: radius,
          innerRadius: Math.max(_this238.radiusScale.convert(0), 0),
          outerRadius: Math.max(_this238.radiusScale.convert(radius), 0)
        });
      });
    }
  }, {
    key: "getTitleTranslationY",
    value: function getTitleTranslationY() {
      var _a, _b;
      var outerRadius = Math.max(0, this.radiusScale.range[1]);
      if (outerRadius === 0) {
        return NaN;
      }
      var spacing = (_b = (_a = this.properties.title) == null ? void 0 : _a.spacing) != null ? _b : 0;
      var titleOffset = 2 + spacing;
      var dy = Math.max(0, -outerRadius);
      return -outerRadius - titleOffset - dy;
    }
  }, {
    key: "update",
    value: function update(_0) {
      return __async(this, arguments, function (_ref177) {
        var _this239 = this;
        var seriesRect = _ref177.seriesRect;
        return /*#__PURE__*/_regenerator().m(function _callee87() {
          var title, newNodeDataDependencies, resize, dy, titleBox, _i36, _arr4, circle;
          return _regenerator().w(function (_context98) {
            while (1) switch (_context98.n) {
              case 0:
                title = _this239.properties.title;
                newNodeDataDependencies = {
                  seriesRectWidth: seriesRect == null ? void 0 : seriesRect.width,
                  seriesRectHeight: seriesRect == null ? void 0 : seriesRect.height
                };
                resize = _jsonDiff(_this239.nodeDataDependencies, newNodeDataDependencies) != null;
                if (resize) {
                  _this239._nodeDataDependencies = newNodeDataDependencies;
                }
                _context98.n = 1;
                return _this239.maybeRefreshNodeData();
              case 1:
                _this239.updateTitleNodes();
                _this239.updateRadiusScale(resize);
                _this239.contentGroup.translationX = _this239.centerX;
                _this239.contentGroup.translationY = _this239.centerY;
                _this239.highlightGroup.translationX = _this239.centerX;
                _this239.highlightGroup.translationY = _this239.centerY;
                _this239.backgroundGroup.translationX = _this239.centerX;
                _this239.backgroundGroup.translationY = _this239.centerY;
                if (_this239.labelGroup) {
                  _this239.labelGroup.translationX = _this239.centerX;
                  _this239.labelGroup.translationY = _this239.centerY;
                }
                if (title) {
                  dy = _this239.getTitleTranslationY();
                  titleBox = title.node.computeBBox();
                  title.node.visible = title.enabled && isFinite(dy) && !_this239.bboxIntersectsSurroundingSeries(titleBox, 0, dy);
                  title.node.translationY = isFinite(dy) ? dy : 0;
                }
                for (_i36 = 0, _arr4 = [_this239.zerosumInnerRing, _this239.zerosumOuterRing]; _i36 < _arr4.length; _i36++) {
                  circle = _arr4[_i36];
                  circle.fillOpacity = 0;
                  circle.stroke = _this239.properties.calloutLabel.color;
                  circle.strokeWidth = 1;
                  circle.strokeOpacity = 1;
                }
                _this239.updateNodeMidPoint();
                _context98.n = 2;
                return _this239.updateSelections();
              case 2:
                _context98.n = 3;
                return _this239.updateNodes(seriesRect);
              case 3:
                return _context98.a(2);
            }
          }, _callee87);
        })();
      });
    }
  }, {
    key: "updateTitleNodes",
    value: function updateTitleNodes() {
      var _a, _b;
      var oldTitle = this.oldTitle;
      var title = this.properties.title;
      if (oldTitle !== title) {
        if (oldTitle) {
          (_a = this.labelGroup) == null ? void 0 : _a.removeChild(oldTitle.node);
        }
        if (title) {
          title.node.textBaseline = "bottom";
          (_b = this.labelGroup) == null ? void 0 : _b.appendChild(title.node);
        }
        this.oldTitle = title;
      }
    }
  }, {
    key: "updateNodeMidPoint",
    value: function updateNodeMidPoint() {
      this.nodeData.forEach(function (d) {
        var radius = d.innerRadius + (d.outerRadius - d.innerRadius) / 2;
        d.midPoint = {
          x: d.midCos * Math.max(0, radius),
          y: d.midSin * Math.max(0, radius)
        };
      });
    }
  }, {
    key: "updateSelections",
    value: function updateSelections() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee88() {
        return _regenerator().w(function (_context99) {
          while (1) switch (_context99.n) {
            case 0:
              _context99.n = 1;
              return this.updateGroupSelection();
            case 1:
              this.updateInnerCircleSelection();
            case 2:
              return _context99.a(2);
          }
        }, _callee88, this);
      }));
    }
  }, {
    key: "updateGroupSelection",
    value: function updateGroupSelection() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee89() {
        var _this240 = this;
        var itemSelection, highlightSelection, calloutLabelSelection, sectorLabelSelection, innerLabelsSelection, update;
        return _regenerator().w(function (_context100) {
          while (1) switch (_context100.n) {
            case 0:
              itemSelection = this.itemSelection, highlightSelection = this.highlightSelection, calloutLabelSelection = this.calloutLabelSelection, sectorLabelSelection = this.sectorLabelSelection, innerLabelsSelection = this.innerLabelsSelection;
              update = function update(selection, clone) {
                var nodeData = _this240.nodeData;
                if (clone) {
                  nodeData = nodeData.map(function (datum) {
                    return __spreadProps(__spreadValues({}, datum), {
                      sectorFormat: __spreadValues({}, datum.sectorFormat)
                    });
                  });
                }
                selection.update(nodeData, void 0, function (datum) {
                  return _this240.getDatumId(datum);
                });
                if (_this240.ctx.animationManager.isSkipped()) {
                  selection.cleanup();
                }
              };
              update(itemSelection, false);
              update(highlightSelection, true);
              calloutLabelSelection.update(this.nodeData, function (group2) {
                var line = new _Line();
                line.tag = 0 /* Callout */;
                line.pointerEvents = 1 /* None */;
                group2.appendChild(line);
                var text = new _Text2();
                text.tag = 1 /* Label */;
                text.pointerEvents = 1 /* None */;
                group2.appendChild(text);
              });
              sectorLabelSelection.update(this.nodeData, function (node) {
                node.pointerEvents = 1 /* None */;
              });
              innerLabelsSelection.update(this.properties.innerLabels, function (node) {
                node.pointerEvents = 1 /* None */;
              });
            case 1:
              return _context100.a(2);
          }
        }, _callee89, this);
      }));
    }
  }, {
    key: "updateInnerCircleSelection",
    value: function updateInnerCircleSelection() {
      var innerCircle = this.properties.innerCircle;
      var radius = 0;
      var innerRadius = this.getInnerRadius();
      if (innerRadius > 0) {
        var circleRadius = Math.min(innerRadius, this.getOuterRadius());
        var antiAliasingPadding = 1;
        radius = Math.ceil(circleRadius * 2 + antiAliasingPadding);
      }
      var datums = innerCircle ? [{
        radius: radius
      }] : [];
      this.innerCircleSelection.update(datums);
    }
  }, {
    key: "updateNodes",
    value: function updateNodes(seriesRect) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee90() {
        var _this241 = this;
        var highlightedDatum, isVisible, updateSectorFn;
        return _regenerator().w(function (_context101) {
          while (1) switch (_context101.n) {
            case 0:
              highlightedDatum = this.ctx.highlightManager.getActiveHighlight();
              isVisible = this.visible && this.seriesItemEnabled.indexOf(true) >= 0;
              this.rootGroup.visible = isVisible;
              this.backgroundGroup.visible = isVisible;
              this.contentGroup.visible = isVisible;
              this.highlightGroup.visible = isVisible && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this;
              if (this.labelGroup) {
                this.labelGroup.visible = isVisible;
              }
              this.contentGroup.opacity = this.getOpacity();
              this.innerCircleSelection.each(function (node, _ref178) {
                var radius = _ref178.radius;
                var _a, _b;
                node.setProperties({
                  fill: (_a = _this241.properties.innerCircle) == null ? void 0 : _a.fill,
                  opacity: (_b = _this241.properties.innerCircle) == null ? void 0 : _b.fillOpacity,
                  size: radius
                });
              });
              updateSectorFn = function updateSectorFn(sector, datum, _index, isDatumHighlighted) {
                var format2 = _this241.getSectorFormat(datum.datum, datum.itemId, isDatumHighlighted);
                datum.sectorFormat.fill = format2.fill;
                datum.sectorFormat.stroke = format2.stroke;
                var animationDisabled = _this241.ctx.animationManager.isSkipped();
                if (animationDisabled) {
                  sector.startAngle = datum.startAngle;
                  sector.endAngle = datum.endAngle;
                  sector.innerRadius = datum.innerRadius;
                  sector.outerRadius = datum.outerRadius;
                }
                if (isDatumHighlighted || animationDisabled) {
                  sector.fill = format2.fill;
                  sector.stroke = format2.stroke;
                }
                sector.strokeWidth = format2.strokeWidth;
                sector.fillOpacity = format2.fillOpacity;
                sector.strokeOpacity = _this241.properties.strokeOpacity;
                sector.lineDash = _this241.properties.lineDash;
                sector.lineDashOffset = _this241.properties.lineDashOffset;
                sector.fillShadow = _this241.properties.shadow;
                sector.cornerRadius = _this241.properties.cornerRadius;
                sector.inset = _this241.properties.sectorSpacing != null ? (_this241.properties.sectorSpacing + (format2.stroke != null ? format2.strokeWidth : 0)) / 2 : 0;
                sector.lineJoin = _this241.properties.sectorSpacing != null ? "miter" : "round";
              };
              this.itemSelection.each(function (node, datum, index) {
                return updateSectorFn(node, datum, index, false);
              });
              this.highlightSelection.each(function (node, datum, index) {
                var isDatumHighlighted = (highlightedDatum == null ? void 0 : highlightedDatum.series) === _this241 && node.datum.itemId === highlightedDatum.itemId;
                updateSectorFn(node, datum, index, true);
                node.visible = isDatumHighlighted;
              });
              this.updateCalloutLineNodes();
              this.updateCalloutLabelNodes(seriesRect);
              this.updateSectorLabelNodes();
              this.updateInnerLabelNodes();
              this.updateZerosumRings();
              this.animationState.transition("update");
            case 1:
              return _context101.a(2);
          }
        }, _callee90, this);
      }));
    }
  }, {
    key: "updateCalloutLineNodes",
    value: function updateCalloutLineNodes() {
      var _a;
      var calloutLine = this.properties.calloutLine;
      var calloutLength = calloutLine.length;
      var calloutStrokeWidth = calloutLine.strokeWidth;
      var calloutColors = (_a = calloutLine.colors) != null ? _a : this.properties.strokes;
      var offset4 = this.properties.calloutLabel.offset;
      this.calloutLabelSelection.selectByTag(0 /* Callout */).forEach(function (line, index) {
        var _a2;
        var datum = line.datum;
        var label = datum.calloutLabel,
          outerRadius = datum.outerRadius;
        if ((label == null ? void 0 : label.text) && !label.hidden && outerRadius !== 0) {
          line.visible = true;
          line.strokeWidth = calloutStrokeWidth;
          line.stroke = calloutColors[index % calloutColors.length];
          line.fill = void 0;
          var x1 = datum.midCos * outerRadius;
          var y1 = datum.midSin * outerRadius;
          var x2 = datum.midCos * (outerRadius + calloutLength);
          var y2 = datum.midSin * (outerRadius + calloutLength);
          var isMoved = (_a2 = label.collisionTextAlign) != null ? _a2 : label.collisionOffsetY !== 0;
          if (isMoved && label.box != null) {
            var box = label.box;
            var cx = x2;
            var cy = y2;
            if (x2 < box.x) {
              cx = box.x;
            } else if (x2 > box.x + box.width) {
              cx = box.x + box.width;
            }
            if (y2 < box.y) {
              cy = box.y;
            } else if (y2 > box.y + box.height) {
              cy = box.y + box.height;
            }
            var dx = cx - x2;
            var dy = cy - y2;
            var length = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
            var paddedLength = length - offset4;
            if (paddedLength > 0) {
              x2 = x2 + dx * paddedLength / length;
              y2 = y2 + dy * paddedLength / length;
            }
          }
          line.x1 = x1;
          line.y1 = y1;
          line.x2 = x2;
          line.y2 = y2;
        } else {
          line.visible = false;
        }
      });
    }
  }, {
    key: "getLabelOverflow",
    value: function getLabelOverflow(text, box, seriesRect) {
      var seriesLeft = seriesRect.x - this.centerX;
      var seriesRight = seriesRect.x + seriesRect.width - this.centerX;
      var seriesTop = seriesRect.y - this.centerY;
      var seriesBottom = seriesRect.y + seriesRect.height - this.centerY;
      var errPx = 1;
      var visibleTextPart = 1;
      if (box.x + errPx < seriesLeft) {
        visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
      } else if (box.x + box.width - errPx > seriesRight) {
        visibleTextPart = (seriesRight - box.x) / box.width;
      }
      var hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
      var textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
      var hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
      return {
        textLength: textLength,
        hasVerticalOverflow: hasVerticalOverflow,
        hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow
      };
    }
  }, {
    key: "bboxIntersectsSurroundingSeries",
    value: function bboxIntersectsSurroundingSeries(box) {
      var dx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var dy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var surroundingRadius = this.surroundingRadius;
      if (surroundingRadius == null) {
        return false;
      }
      var corners = [{
        x: box.x + dx,
        y: box.y + dy
      }, {
        x: box.x + box.width + dx,
        y: box.y + dy
      }, {
        x: box.x + box.width + dx,
        y: box.y + box.height + dy
      }, {
        x: box.x + dx,
        y: box.y + box.height + dy
      }];
      var sur2 = __pow(surroundingRadius, 2);
      return corners.some(function (corner) {
        return __pow(corner.x, 2) + __pow(corner.y, 2) > sur2;
      });
    }
  }, {
    key: "computeCalloutLabelCollisionOffsets",
    value: function computeCalloutLabelCollisionOffsets() {
      var _this242 = this;
      var radiusScale = this.radiusScale;
      var _this$properties48 = this.properties,
        calloutLabel = _this$properties48.calloutLabel,
        calloutLine = _this$properties48.calloutLine;
      var offset4 = calloutLabel.offset,
        minSpacing = calloutLabel.minSpacing;
      var innerRadius = radiusScale.convert(0);
      var shouldSkip = function shouldSkip(datum) {
        var label = datum.calloutLabel;
        return !label || datum.outerRadius === 0;
      };
      var fullData = this.nodeData;
      var data = this.nodeData.filter(function (t) {
        return !shouldSkip(t);
      });
      data.forEach(function (datum) {
        var label = datum.calloutLabel;
        if (label == null) return;
        label.hidden = false;
        label.collisionTextAlign = void 0;
        label.collisionOffsetY = 0;
      });
      if (data.length <= 1) {
        return;
      }
      var leftLabels = data.filter(function (d) {
        return d.midCos < 0;
      }).sort(function (a, b) {
        return a.midSin - b.midSin;
      });
      var rightLabels = data.filter(function (d) {
        return d.midCos >= 0;
      }).sort(function (a, b) {
        return a.midSin - b.midSin;
      });
      var topLabels = data.filter(function (d) {
        var _a;
        return d.midSin < 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
      }).sort(function (a, b) {
        return a.midCos - b.midCos;
      });
      var bottomLabels = data.filter(function (d) {
        var _a;
        return d.midSin >= 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
      }).sort(function (a, b) {
        return a.midCos - b.midCos;
      });
      var tempTextNode = new _Text2();
      var getTextBBox = function getTextBBox(datum) {
        var _a;
        var label = datum.calloutLabel;
        if (label == null) return new _BBox2(0, 0, 0, 0);
        var labelRadius = datum.outerRadius + calloutLine.length + offset4;
        var x = datum.midCos * labelRadius;
        var y = datum.midSin * labelRadius + label.collisionOffsetY;
        tempTextNode.text = label.text;
        tempTextNode.x = x;
        tempTextNode.y = y;
        tempTextNode.setFont(_this242.properties.calloutLabel);
        tempTextNode.setAlign({
          textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
          textBaseline: label.textBaseline
        });
        return tempTextNode.computeBBox();
      };
      var avoidNeighbourYCollision = function avoidNeighbourYCollision(label, next, direction) {
        var box = getTextBBox(label).grow(minSpacing / 2);
        var other = getTextBBox(next).grow(minSpacing / 2);
        var collidesOrBehind = box.x < other.x + other.width && box.x + box.width > other.x && (direction === "to-top" ? box.y < other.y + other.height : box.y + box.height > other.y);
        if (collidesOrBehind) {
          var dy = direction === "to-top" ? box.y - other.y - other.height : box.y + box.height - other.y;
          next.calloutLabel.collisionOffsetY = dy;
        }
      };
      var avoidYCollisions = function avoidYCollisions(labels) {
        var midLabel = labels.slice().sort(function (a, b) {
          return Math.abs(a.midSin) - Math.abs(b.midSin);
        })[0];
        var midIndex = labels.indexOf(midLabel);
        for (var i = midIndex - 1; i >= 0; i--) {
          var prev = labels[i + 1];
          var next = labels[i];
          avoidNeighbourYCollision(prev, next, "to-top");
        }
        for (var _i37 = midIndex + 1; _i37 < labels.length; _i37++) {
          var _prev2 = labels[_i37 - 1];
          var _next2 = labels[_i37];
          avoidNeighbourYCollision(_prev2, _next2, "to-bottom");
        }
      };
      var avoidXCollisions = function avoidXCollisions(labels) {
        var labelsCollideLabelsByY = data.some(function (datum) {
          return datum.calloutLabel.collisionOffsetY !== 0;
        });
        var boxes = labels.map(function (label) {
          return getTextBBox(label);
        });
        var paddedBoxes = boxes.map(function (box) {
          return box.clone().grow(minSpacing / 2);
        });
        var labelsCollideLabelsByX = false;
        for (var i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++) {
          var box = paddedBoxes[i];
          for (var j = i + 1; j < labels.length; j++) {
            var other = paddedBoxes[j];
            if (box.collidesBBox(other)) {
              labelsCollideLabelsByX = true;
              break;
            }
          }
        }
        var sectors = fullData.map(function (datum) {
          var startAngle = datum.startAngle,
            endAngle = datum.endAngle,
            outerRadius = datum.outerRadius;
          return {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
          };
        });
        var labelsCollideSectors = boxes.some(function (box) {
          return sectors.some(function (sector) {
            return boxCollidesSector(box, sector);
          });
        });
        if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) {
          return;
        }
        labels.filter(function (d) {
          return d.calloutLabel.textAlign === "center";
        }).forEach(function (d) {
          var label = d.calloutLabel;
          if (d.midCos < 0) {
            label.collisionTextAlign = "right";
          } else if (d.midCos > 0) {
            label.collisionTextAlign = "left";
          } else {
            label.collisionTextAlign = "center";
          }
        });
      };
      avoidYCollisions(leftLabels);
      avoidYCollisions(rightLabels);
      avoidXCollisions(topLabels);
      avoidXCollisions(bottomLabels);
    }
  }, {
    key: "updateCalloutLabelNodes",
    value: function updateCalloutLabelNodes(seriesRect) {
      var _this243 = this;
      var radiusScale = this.radiusScale;
      var _this$properties49 = this.properties,
        calloutLabel = _this$properties49.calloutLabel,
        calloutLine = _this$properties49.calloutLine;
      var calloutLength = calloutLine.length;
      var offset4 = calloutLabel.offset,
        color = calloutLabel.color;
      var tempTextNode = new _Text2();
      this.calloutLabelSelection.selectByTag(1 /* Label */).forEach(function (text) {
        var _a;
        var datum = text.datum;
        var label = datum.calloutLabel;
        var radius = radiusScale.convert(datum.radius);
        var outerRadius = Math.max(0, radius);
        if (!(label == null ? void 0 : label.text) || outerRadius === 0 || label.hidden) {
          text.visible = false;
          return;
        }
        var labelRadius = outerRadius + calloutLength + offset4;
        var x = datum.midCos * labelRadius;
        var y = datum.midSin * labelRadius + label.collisionOffsetY;
        var align = {
          textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
          textBaseline: label.textBaseline
        };
        tempTextNode.text = label.text;
        tempTextNode.x = x;
        tempTextNode.y = y;
        tempTextNode.setFont(_this243.properties.calloutLabel);
        tempTextNode.setAlign(align);
        var box = tempTextNode.computeBBox();
        var displayText = label.text;
        var visible = true;
        if (calloutLabel.avoidCollisions) {
          var _this243$getLabelOver = _this243.getLabelOverflow(label.text, box, seriesRect),
            textLength = _this243$getLabelOver.textLength,
            hasVerticalOverflow = _this243$getLabelOver.hasVerticalOverflow;
          displayText = label.text.length === textLength ? label.text : "".concat(label.text.substring(0, textLength), "\u2026");
          visible = !hasVerticalOverflow;
        }
        text.text = displayText;
        text.x = x;
        text.y = y;
        text.setFont(_this243.properties.calloutLabel);
        text.setAlign(align);
        text.fill = color;
        text.visible = visible;
      });
    }
  }, {
    key: "computeLabelsBBox",
    value: function computeLabelsBBox(options, seriesRect) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee91() {
        var _this244 = this;
        var _this$properties50, calloutLabel, calloutLine, calloutLength, offset4, maxCollisionOffset, minSpacing, textBoxes, text, titleBox, title, dy;
        return _regenerator().w(function (_context102) {
          while (1) switch (_context102.n) {
            case 0:
              _this$properties50 = this.properties, calloutLabel = _this$properties50.calloutLabel, calloutLine = _this$properties50.calloutLine;
              calloutLength = calloutLine.length;
              offset4 = calloutLabel.offset, maxCollisionOffset = calloutLabel.maxCollisionOffset, minSpacing = calloutLabel.minSpacing;
              if (calloutLabel.avoidCollisions) {
                _context102.n = 1;
                break;
              }
              return _context102.a(2, null);
            case 1:
              _context102.n = 2;
              return this.maybeRefreshNodeData();
            case 2:
              this.updateRadiusScale(false);
              this.computeCalloutLabelCollisionOffsets();
              textBoxes = [];
              text = new _Text2();
              title = this.properties.title;
              if ((title == null ? void 0 : title.text) && title.enabled) {
                dy = this.getTitleTranslationY();
                if (isFinite(dy)) {
                  text.text = title.text;
                  text.x = 0;
                  text.y = dy;
                  text.setFont(title);
                  text.setAlign({
                    textBaseline: "bottom",
                    textAlign: "center"
                  });
                  titleBox = text.computeBBox();
                  textBoxes.push(titleBox);
                }
              }
              this.nodeData.forEach(function (datum) {
                var _a;
                var label = datum.calloutLabel;
                if (!label || datum.outerRadius === 0) {
                  return null;
                }
                var labelRadius = datum.outerRadius + calloutLength + offset4;
                var x = datum.midCos * labelRadius;
                var y = datum.midSin * labelRadius + label.collisionOffsetY;
                text.text = label.text;
                text.x = x;
                text.y = y;
                text.setFont(_this244.properties.calloutLabel);
                text.setAlign({
                  textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                  textBaseline: label.textBaseline
                });
                var box = text.computeBBox();
                label.box = box;
                if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                  label.hidden = true;
                  return;
                }
                if (titleBox) {
                  var seriesTop = seriesRect.y - _this244.centerY;
                  var titleCleanArea = new _BBox2(titleBox.x - minSpacing, seriesTop, titleBox.width + 2 * minSpacing, titleBox.y + titleBox.height + minSpacing - seriesTop);
                  if (box.collidesBBox(titleCleanArea)) {
                    label.hidden = true;
                    return;
                  }
                }
                if (options.hideWhenNecessary) {
                  var _this244$getLabelOver = _this244.getLabelOverflow(label.text, box, seriesRect),
                    textLength = _this244$getLabelOver.textLength,
                    hasVerticalOverflow = _this244$getLabelOver.hasVerticalOverflow,
                    hasSurroundingSeriesOverflow = _this244$getLabelOver.hasSurroundingSeriesOverflow;
                  var isTooShort = label.text.length > 2 && textLength < 2;
                  if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                    label.hidden = true;
                    return;
                  }
                }
                label.hidden = false;
                textBoxes.push(box);
              });
              if (!(textBoxes.length === 0)) {
                _context102.n = 3;
                break;
              }
              return _context102.a(2, null);
            case 3:
              return _context102.a(2, _BBox2.merge(textBoxes));
          }
        }, _callee91, this);
      }));
    }
  }, {
    key: "updateSectorLabelNodes",
    value: function updateSectorLabelNodes() {
      var radiusScale = this.radiusScale;
      var innerRadius = radiusScale.convert(0);
      var _this$properties$sect2 = this.properties.sectorLabel,
        fontSize = _this$properties$sect2.fontSize,
        fontStyle = _this$properties$sect2.fontStyle,
        fontWeight = _this$properties$sect2.fontWeight,
        fontFamily = _this$properties$sect2.fontFamily,
        positionOffset = _this$properties$sect2.positionOffset,
        positionRatio = _this$properties$sect2.positionRatio,
        color = _this$properties$sect2.color;
      var isDonut = innerRadius > 0;
      var singleVisibleSector = this.seriesItemEnabled.filter(Boolean).length === 1;
      this.sectorLabelSelection.each(function (text, datum) {
        var sectorLabel = datum.sectorLabel,
          outerRadius = datum.outerRadius;
        var isTextVisible = false;
        if (sectorLabel && outerRadius !== 0) {
          var labelRadius = innerRadius * (1 - positionRatio) + outerRadius * positionRatio + positionOffset;
          text.fill = color;
          text.fontStyle = fontStyle;
          text.fontWeight = fontWeight;
          text.fontSize = fontSize;
          text.fontFamily = fontFamily;
          text.text = sectorLabel.text;
          var shouldPutTextInCenter = !isDonut && singleVisibleSector;
          if (shouldPutTextInCenter) {
            text.x = 0;
            text.y = 0;
          } else {
            text.x = datum.midCos * labelRadius;
            text.y = datum.midSin * labelRadius;
          }
          text.textAlign = "center";
          text.textBaseline = "middle";
          var bbox = text.computeBBox();
          var corners = [[bbox.x, bbox.y], [bbox.x + bbox.width, bbox.y], [bbox.x + bbox.width, bbox.y + bbox.height], [bbox.x, bbox.y + bbox.height]];
          var startAngle = datum.startAngle,
            endAngle = datum.endAngle;
          var sectorBounds = {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
          };
          if (corners.every(function (_ref179) {
            var _ref180 = _slicedToArray(_ref179, 2),
              x = _ref180[0],
              y = _ref180[1];
            return isPointInSector(x, y, sectorBounds);
          })) {
            isTextVisible = true;
          }
        }
        text.visible = isTextVisible;
      });
    }
  }, {
    key: "updateInnerLabelNodes",
    value: function updateInnerLabelNodes() {
      var textBBoxes = [];
      var margins = [];
      this.innerLabelsSelection.each(function (text, datum) {
        var fontStyle = datum.fontStyle,
          fontWeight = datum.fontWeight,
          fontSize = datum.fontSize,
          fontFamily = datum.fontFamily,
          color = datum.color,
          _datum$margin = datum.margin,
          margin = _datum$margin === void 0 ? 2 : _datum$margin;
        text.fontStyle = fontStyle;
        text.fontWeight = fontWeight;
        text.fontSize = fontSize;
        text.fontFamily = fontFamily;
        text.text = datum.text;
        text.x = 0;
        text.y = 0;
        text.fill = color;
        text.textAlign = "center";
        text.textBaseline = "alphabetic";
        textBBoxes.push(text.computeBBox());
        margins.push(margin);
      });
      var getMarginTop = function getMarginTop(index) {
        return index === 0 ? 0 : margins[index];
      };
      var getMarginBottom = function getMarginBottom(index) {
        return index === margins.length - 1 ? 0 : margins[index];
      };
      var totalHeight = textBBoxes.reduce(function (sum2, bbox, i) {
        return sum2 + bbox.height + getMarginTop(i) + getMarginBottom(i);
      }, 0);
      var totalWidth = Math.max.apply(Math, _toConsumableArray(textBBoxes.map(function (bbox) {
        return bbox.width;
      })));
      var innerRadius = this.getInnerRadius();
      var labelRadius = Math.sqrt(Math.pow(totalWidth / 2, 2) + Math.pow(totalHeight / 2, 2));
      var labelsVisible = labelRadius <= (innerRadius > 0 ? innerRadius : this.getOuterRadius());
      var textBottoms = [];
      for (var i = 0, prev = -totalHeight / 2; i < textBBoxes.length; i++) {
        var bbox = textBBoxes[i];
        var bottom = bbox.height + prev + getMarginTop(i);
        textBottoms.push(bottom);
        prev = bottom + getMarginBottom(i);
      }
      this.innerLabelsSelection.each(function (text, _datum, index) {
        text.y = textBottoms[index];
        text.visible = labelsVisible;
      });
    }
  }, {
    key: "updateZerosumRings",
    value: function updateZerosumRings() {
      this.zerosumOuterRing.size = this.getOuterRadius() * 2;
      this.zerosumInnerRing.size = this.getInnerRadius() * 2;
    }
  }, {
    key: "getDatumLegendName",
    value: function getDatumLegendName(nodeDatum) {
      var _this$properties51 = this.properties,
        angleKey = _this$properties51.angleKey,
        calloutLabelKey = _this$properties51.calloutLabelKey,
        sectorLabelKey = _this$properties51.sectorLabelKey,
        legendItemKey = _this$properties51.legendItemKey;
      var sectorLabel = nodeDatum.sectorLabel,
        calloutLabel = nodeDatum.calloutLabel,
        legendItem = nodeDatum.legendItem;
      if (legendItemKey && legendItem !== void 0) {
        return legendItem.text;
      } else if (calloutLabelKey && calloutLabelKey !== angleKey && (calloutLabel == null ? void 0 : calloutLabel.text) !== void 0) {
        return calloutLabel.text;
      } else if (sectorLabelKey && sectorLabelKey !== angleKey && (sectorLabel == null ? void 0 : sectorLabel.text) !== void 0) {
        return sectorLabel.text;
      }
    }
  }, {
    key: "pickNodeClosestDatum",
    value: function pickNodeClosestDatum(point) {
      return _pickByMatchingAngle(this, point);
    }
  }, {
    key: "getTooltipHtml",
    value: function getTooltipHtml(nodeDatum) {
      var _a;
      if (!this.properties.isValid()) {
        return _EMPTY_TOOLTIP_CONTENT;
      }
      var datum = nodeDatum.datum,
        angleValue = nodeDatum.angleValue,
        color = nodeDatum.sectorFormat.fill,
        itemId = nodeDatum.itemId;
      var title = _sanitizeHtml((_a = this.properties.title) == null ? void 0 : _a.text);
      var content = _isFiniteNumber(angleValue) ? _toFixed(angleValue) : String(angleValue);
      var labelText = this.getDatumLegendName(nodeDatum);
      return this.properties.tooltip.toTooltipHtml({
        title: title != null ? title : labelText,
        content: title && labelText ? "".concat(labelText, ": ").concat(content) : content,
        backgroundColor: color
      }, {
        datum: datum,
        itemId: itemId,
        title: title,
        color: color,
        seriesId: this.id,
        angleKey: this.properties.angleKey,
        angleName: this.properties.angleName,
        radiusKey: this.properties.radiusKey,
        radiusName: this.properties.radiusName,
        calloutLabelKey: this.properties.calloutLabelKey,
        calloutLabelName: this.properties.calloutLabelName,
        sectorLabelKey: this.properties.sectorLabelKey,
        sectorLabelName: this.properties.sectorLabelName,
        legendItemKey: this.properties.legendItemKey
      });
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _a, _b, _c, _d, _e;
      var visible = this.visible,
        processedData = this.processedData,
        dataModel = this.dataModel;
      if (!dataModel || !(processedData == null ? void 0 : processedData.data.length) || legendType !== "category") {
        return [];
      }
      var _this$properties52 = this.properties,
        angleKey = _this$properties52.angleKey,
        calloutLabelKey = _this$properties52.calloutLabelKey,
        sectorLabelKey = _this$properties52.sectorLabelKey,
        legendItemKey = _this$properties52.legendItemKey;
      if (!legendItemKey && (!calloutLabelKey || calloutLabelKey === angleKey) && (!sectorLabelKey || sectorLabelKey === angleKey)) {
        return [];
      }
      var _this$getProcessedDat4 = this.getProcessedDataIndexes(dataModel),
        calloutLabelIdx = _this$getProcessedDat4.calloutLabelIdx,
        sectorLabelIdx = _this$getProcessedDat4.sectorLabelIdx,
        legendItemIdx = _this$getProcessedDat4.legendItemIdx;
      var titleText = ((_a = this.properties.title) == null ? void 0 : _a.showInLegend) && this.properties.title.text;
      var legendData = [];
      for (var index = 0; index < processedData.data.length; index++) {
        var _processedData$data$i2 = processedData.data[index],
          datum = _processedData$data$i2.datum,
          values = _processedData$data$i2.values;
        var labelParts = [];
        if (titleText) {
          labelParts.push(titleText);
        }
        var labels = this.getLabels(datum, 2 * Math.PI, 2 * Math.PI, false, values[calloutLabelIdx], values[sectorLabelIdx], values[legendItemIdx]);
        if (legendItemKey && labels.legendItem !== void 0) {
          labelParts.push(labels.legendItem.text);
        } else if (calloutLabelKey && calloutLabelKey !== angleKey && ((_b = labels.calloutLabel) == null ? void 0 : _b.text) !== void 0) {
          labelParts.push((_c = labels.calloutLabel) == null ? void 0 : _c.text);
        } else if (sectorLabelKey && sectorLabelKey !== angleKey && ((_d = labels.sectorLabel) == null ? void 0 : _d.text) !== void 0) {
          labelParts.push((_e = labels.sectorLabel) == null ? void 0 : _e.text);
        }
        if (labelParts.length === 0) continue;
        var sectorFormat = this.getSectorFormat(datum, index, false);
        legendData.push({
          legendType: "category",
          id: this.id,
          itemId: index,
          seriesId: this.id,
          enabled: visible && this.seriesItemEnabled[index],
          label: {
            text: labelParts.join(" - ")
          },
          marker: {
            fill: sectorFormat.fill,
            stroke: sectorFormat.stroke,
            fillOpacity: this.properties.fillOpacity,
            strokeOpacity: this.properties.strokeOpacity,
            strokeWidth: this.properties.strokeWidth
          },
          legendItemName: legendItemKey != null ? datum[legendItemKey] : void 0
        });
      }
      return legendData;
    }
  }, {
    key: "onLegendItemClick",
    value: function onLegendItemClick(event) {
      var enabled = event.enabled,
        itemId = event.itemId,
        series = event.series,
        legendItemName = event.legendItemName;
      if (series.id === this.id) {
        this.toggleSeriesItem(itemId, enabled);
      } else if (legendItemName != null) {
        this.toggleOtherSeriesItems(legendItemName, enabled);
      }
    }
  }, {
    key: "toggleSeriesItem",
    value: function toggleSeriesItem(itemId, enabled) {
      this.seriesItemEnabled[itemId] = enabled;
      this.nodeDataRefresh = true;
    }
  }, {
    key: "toggleOtherSeriesItems",
    value: function toggleOtherSeriesItems(legendItemName, enabled) {
      var _this245 = this;
      var _a;
      if (!this.properties.legendItemKey || !this.dataModel) {
        return;
      }
      var legendItemIdx = this.dataModel.resolveProcessedDataIndexById(this, "legendItemValue");
      (_a = this.processedData) == null ? void 0 : _a.data.forEach(function (_ref181, datumItemId) {
        var values = _ref181.values;
        if (values[legendItemIdx] === legendItemName) {
          _this245.toggleSeriesItem(datumItemId, enabled);
        }
      });
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(_data) {
      var animationManager = this.ctx.animationManager;
      var fns = _preparePieSeriesAnimationFunctions(true, this.properties.rotation, this.radiusScale, this.previousRadiusScale);
      _fromToMotion(this.id, "nodes", animationManager, [this.itemSelection, this.highlightSelection], fns.nodes);
      _fromToMotion(this.id, "innerCircle", animationManager, [this.innerCircleSelection], fns.innerCircle);
      _seriesLabelFadeInAnimation(this, "callout", animationManager, this.calloutLabelSelection);
      _seriesLabelFadeInAnimation(this, "sector", animationManager, this.sectorLabelSelection);
      _seriesLabelFadeInAnimation(this, "inner", animationManager, this.innerLabelsSelection);
      this.previousRadiusScale.range = this.radiusScale.range;
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady() {
      var _this246 = this;
      var _a, _b, _c, _d, _e, _f;
      var itemSelection = this.itemSelection,
        highlightSelection = this.highlightSelection,
        processedData = this.processedData,
        radiusScale = this.radiusScale,
        previousRadiusScale = this.previousRadiusScale;
      var animationManager = this.ctx.animationManager;
      var dataDiff = (_a = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _a.diff;
      this.ctx.animationManager.stopByAnimationGroupId(this.id);
      var supportedDiff = ((_b = dataDiff == null ? void 0 : dataDiff.moved.size) != null ? _b : 0) === 0;
      var hasKeys = ((_c = processedData == null ? void 0 : processedData.defs.keys.length) != null ? _c : 0) > 0;
      var hasUniqueKeys = (_f = (_e = (_d = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _d.animationValidation) == null ? void 0 : _e.uniqueKeys) != null ? _f : true;
      if (!supportedDiff || !hasKeys || !hasUniqueKeys) {
        this.ctx.animationManager.skipCurrentBatch();
      }
      var fns = _preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
      _fromToMotion(this.id, "nodes", animationManager, [itemSelection, highlightSelection], fns.nodes, function (_, datum) {
        return _this246.getDatumId(datum);
      }, dataDiff);
      _fromToMotion(this.id, "innerCircle", animationManager, [this.innerCircleSelection], fns.innerCircle);
      _seriesLabelFadeInAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
      _seriesLabelFadeInAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
      _seriesLabelFadeInAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
      this.previousRadiusScale.range = this.radiusScale.range;
    }
  }, {
    key: "animateClearingUpdateEmpty",
    value: function animateClearingUpdateEmpty() {
      var itemSelection = this.itemSelection,
        highlightSelection = this.highlightSelection,
        radiusScale = this.radiusScale,
        previousRadiusScale = this.previousRadiusScale;
      var animationManager = this.ctx.animationManager;
      var fns = _preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
      _fromToMotion(this.id, "nodes", animationManager, [itemSelection, highlightSelection], fns.nodes);
      _fromToMotion(this.id, "innerCircle", animationManager, [this.innerCircleSelection], fns.innerCircle);
      _seriesLabelFadeOutAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
      _seriesLabelFadeOutAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
      _seriesLabelFadeOutAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
      this.previousRadiusScale.range = this.radiusScale.range;
    }
  }, {
    key: "getDatumIdFromData",
    value: function getDatumIdFromData(datum) {
      var _a, _b, _c;
      var _this$properties53 = this.properties,
        calloutLabelKey = _this$properties53.calloutLabelKey,
        sectorLabelKey = _this$properties53.sectorLabelKey,
        legendItemKey = _this$properties53.legendItemKey;
      if (!((_c = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.animationValidation) == null ? void 0 : _c.uniqueKeys)) {
        return;
      }
      if (legendItemKey) {
        return datum[legendItemKey];
      } else if (calloutLabelKey) {
        return datum[calloutLabelKey];
      } else if (sectorLabelKey) {
        return datum[sectorLabelKey];
      }
    }
  }, {
    key: "getDatumId",
    value: function getDatumId(datum) {
      var index = datum.index;
      var datumId = this.getDatumIdFromData(datum.datum);
      return datumId != null ? String(datumId) : "".concat(index);
    }
  }, {
    key: "onDataChange",
    value: function onDataChange() {
      var _a;
      var data = this.data,
        seriesItemEnabled = this.seriesItemEnabled;
      this.seriesItemEnabled = (_a = data == null ? void 0 : data.map(function (_, index) {
        var _a2;
        return (_a2 = seriesItemEnabled[index]) != null ? _a2 : true;
      })) != null ? _a : [];
    }
  }, {
    key: "computeFocusBounds",
    value: function computeFocusBounds(opts) {
      return _computeSectorFocusBounds(this, opts);
    }
  }, {
    key: "visible",
    get: function get() {
      return _superPropGet(PieSeries, "visible", this, 1) && (this.seriesItemEnabled.length === 0 || this.seriesItemEnabled.some(function (visible) {
        return visible;
      }));
    }
  }]);
  return PieSeries;
}(_PolarSeries3);
PieSeries.className = "PieSeries";
PieSeries.type = "pie";

// packages/ag-charts-community/src/chart/series/polar/pieSeriesModule.ts
var PieSeriesModule = {
  type: "series",
  optionsKey: "series[]",
  packageType: "community",
  chartTypes: ["polar"],
  identifier: "pie",
  instanceConstructor: PieSeries,
  themeTemplate: pieTheme,
  paletteFactory: piePaletteFactory
};

// packages/ag-charts-community/src/chart/toolbar/toolbarTypes.ts
var TOOLBAR_ALIGNMENTS = ["start", "center", "end"];
var TOOLBAR_GROUPS = ["annotations", "ranges", "zoom"];
var ToolbarPosition = /* @__PURE__ */function (ToolbarPosition2) {
  ToolbarPosition2["Top"] = "top";
  ToolbarPosition2["Right"] = "right";
  ToolbarPosition2["Bottom"] = "bottom";
  ToolbarPosition2["Left"] = "left";
  ToolbarPosition2["FloatingTop"] = "floating-top";
  ToolbarPosition2["FloatingBottom"] = "floating-bottom";
  return ToolbarPosition2;
}(ToolbarPosition || {});
var TOOLBAR_POSITIONS = Object.values(ToolbarPosition);

// packages/ag-charts-community/src/chart/toolbar/toolbarProperties.ts
var ToolbarGroupProperties = /*#__PURE__*/function (_BaseProperties34) {
  _inherits(ToolbarGroupProperties, _BaseProperties34);
  function ToolbarGroupProperties(onChange, onButtonsChange) {
    var _this247;
    _classCallCheck(this, ToolbarGroupProperties);
    _this247 = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarGroupProperties).call(this));
    _this247.onChange = onChange;
    _this247.onButtonsChange = onButtonsChange;
    _this247.align = "start";
    _this247.position = "top" /* Top */;
    return _this247;
  }
  return ToolbarGroupProperties;
}(_BaseProperties35);
__decorateClass([_ObserveChanges(function (target) {
  target.onChange(target.enabled);
}), _Validate(_BOOLEAN)], ToolbarGroupProperties.prototype, "enabled", 2);
__decorateClass([_ObserveChanges(function (target) {
  target.onChange(target.enabled);
}), _Validate(_UNION(["start", "center", "end"]), {
  optional: true
})], ToolbarGroupProperties.prototype, "align", 2);
__decorateClass([_ObserveChanges(function (target) {
  target.onChange(target.enabled);
}), _Validate(_UNION(["top", "right", "bottom", "left", "floating-top", "floating-bottom"]), {
  optional: true
})], ToolbarGroupProperties.prototype, "position", 2);
__decorateClass([_ObserveChanges(function (target) {
  target.onButtonsChange(target.buttons);
}), _Validate(_ARRAY, {
  optional: true
})], ToolbarGroupProperties.prototype, "buttons", 2);

// packages/ag-charts-community/src/chart/toolbar/toolbarStyles.ts
var block2 = "ag-charts-toolbar";
var elements2 = {
  align: "".concat(block2, "__align"),
  button: "".concat(block2, "__button"),
  icon: "".concat(block2, "__icon"),
  label: "".concat(block2, "__label")
};
var modifiers2 = (_modifiers2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_modifiers2, "top" /* Top */, "".concat(block2, "--top")), "right" /* Right */, "".concat(block2, "--right")), "bottom" /* Bottom */, "".concat(block2, "--bottom")), "left" /* Left */, "".concat(block2, "--left")), "floating-top" /* FloatingTop */, "".concat(block2, "--floating-top")), "floating-bottom" /* FloatingBottom */, "".concat(block2, "--floating-bottom")), "hidden", "".concat(block2, "--hidden")), "preventFlash", "".concat(block2, "--prevent-flash")), "floatingHidden", "".concat(block2, "--floating-hidden")), "align", {
  start: "".concat(elements2.align, "--start"),
  center: "".concat(elements2.align, "--center"),
  end: "".concat(elements2.align, "--end")
}), _defineProperty(_modifiers2, "button", {
  hidden: "".concat(elements2.button, "--hidden")
}));
var css2 = "\n.".concat(block2, " {\n    align-items: center;\n    background: var(--ag-charts-toolbar-background-color);\n    border-bottom: var(--ag-charts-toolbar-border-critical);\n    border-top: var(--ag-charts-toolbar-border-critical);\n    border-left: var(--ag-charts-toolbar-border);\n    border-right: var(--ag-charts-toolbar-border);\n    display: flex;\n    flex-wrap: nowrap;\n    opacity: 1;\n    position: absolute;\n    transform: translateY(0);\n    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;\n}\n\n.").concat(modifiers2.hidden, ",\n.").concat(modifiers2.preventFlash, " {\n    visibility: hidden;\n}\n\n.").concat(modifiers2.floatingHidden, " {\n    opacity: 0;\n    transition: opacity 0.4s ease-in-out;\n}\n\n.").concat(modifiers2["top" /* Top */], ",\n.").concat(modifiers2["bottom" /* Bottom */], " {\n    flex-direction: row;\n    height: var(--ag-charts-toolbar-size);\n    padding: 0 var(--ag-charts-toolbar-padding);\n    width: 100%;\n}\n\n.").concat(modifiers2["left" /* Left */], ",\n.").concat(modifiers2["right" /* Right */], " {\n    flex-direction: column;\n    padding: var(--ag-charts-toolbar-padding) 0;\n    width: var(--ag-charts-toolbar-size);\n}\n\n.").concat(modifiers2["floating-top" /* FloatingTop */], ",\n.").concat(modifiers2["floating-bottom" /* FloatingBottom */], " {\n    background: none;\n    border: none;\n    flex-direction: row;\n    height: var(--ag-charts-toolbar-size);\n    overflow: hidden;\n    padding: 0 var(--ag-charts-toolbar-padding);\n    pointer-events: none;\n    width: 100%;\n}\n\n.").concat(elements2.align, " {\n    display: flex;\n    flex-direction: inherit;\n    flex-wrap: inherit;\n    max-width: 100%;\n}\n\n.").concat(modifiers2.align.center, ",\n.").concat(modifiers2.align.end, " {\n    margin-left: auto;\n}\n\n.").concat(modifiers2["left" /* Left */], " .").concat(modifiers2.align.center, ",\n.").concat(modifiers2["left" /* Left */], " .").concat(modifiers2.align.end, ",\n.").concat(modifiers2["right" /* Right */], " .").concat(modifiers2.align.center, ",\n.").concat(modifiers2["right" /* Right */], " .").concat(modifiers2.align.end, " {\n    margin-left: 0;\n    margin-top: auto;\n}\n\n.").concat(modifiers2["floating-top" /* FloatingTop */], " .").concat(elements2.align, ",\n.").concat(modifiers2["floating-bottom" /* FloatingBottom */], " .").concat(elements2.align, " {\n    gap: var(--ag-charts-toolbar-gap);\n    transition: transform 0.4s ease-in-out;\n}\n\n.").concat(elements2.button, " {\n    align-items: center;\n    border-radius: var(--ag-charts-button-radius);\n    color: var(--ag-charts-toolbar-foreground-color);\n    display: flex;\n    font-size: 14px;\n    font-weight: 500;\n    justify-content: center;\n    margin: 0;\n    padding: var(--ag-charts-button-padding);\n    pointer-events: all;\n    transition: background-color .25s ease-in-out;\n}\n\n.").concat(modifiers2["left" /* Left */], " .").concat(elements2.button, ",\n.").concat(modifiers2["right" /* Right */], " .").concat(elements2.button, " {\n    height: var(--ag-charts-toolbar-size);\n    max-width: 100%;\n    overflow: hidden;\n}\n\n.").concat(modifiers2["floating-top" /* FloatingTop */], " .").concat(elements2.button, ",\n.").concat(modifiers2["floating-bottom" /* FloatingBottom */], " .").concat(elements2.button, " {\n    background: var(--ag-charts-toolbar-background-color);\n    border: var(--ag-charts-toolbar-border-critical);\n}\n\n.").concat(modifiers2.button.hidden, " {\n    display: none;\n}\n\n.").concat(elements2.button, ":hover {\n    background: var(--ag-charts-toolbar-hover-color);\n}\n\n.").concat(elements2.button, ":disabled {\n    background: var(--ag-charts-toolbar-disabled-background-color);\n    color: var(--ag-charts-toolbar-disabled-foreground-color);\n}\n\n.").concat(elements2.button, ":not([disabled]) {\n    cursor: pointer;\n}\n\n.").concat(elements2.icon, " {\n    height: 1.2em;\n    width: 1.2em;\n}\n\n.").concat(elements2.icon, " + .").concat(elements2.label, " {\n    margin-left: var(--ag-charts-size);\n}\n\n.").concat(elements2.icon, ",\n.").concat(elements2.label, " {\n    pointer-events: none;\n}\n\n");

// packages/ag-charts-community/src/chart/toolbar/toolbar.ts
var Toolbar = /*#__PURE__*/function (_BaseModuleInstance3) {
  _inherits(Toolbar, _BaseModuleInstance3);
  function Toolbar(ctx) {
    var _this248;
    _classCallCheck(this, Toolbar);
    _this248 = _possibleConstructorReturn(this, _getPrototypeOf(Toolbar).call(this));
    _this248.ctx = ctx;
    _this248.enabled = true;
    _this248.annotations = new ToolbarGroupProperties(_this248.onGroupChanged.bind(_assertThisInitialized(_this248), "annotations"), _this248.onGroupButtonsChanged.bind(_assertThisInitialized(_this248), "annotations"));
    _this248.ranges = new ToolbarGroupProperties(_this248.onGroupChanged.bind(_assertThisInitialized(_this248), "ranges"), _this248.onGroupButtonsChanged.bind(_assertThisInitialized(_this248), "ranges"));
    _this248.zoom = new ToolbarGroupProperties(_this248.onGroupChanged.bind(_assertThisInitialized(_this248), "zoom"), _this248.onGroupButtonsChanged.bind(_assertThisInitialized(_this248), "zoom"));
    _this248.margin = 10;
    _this248.floatingDetectionRange = 28;
    _this248.positions = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "top" /* Top */, /* @__PURE__ */new Set()), "right" /* Right */, /* @__PURE__ */new Set()), "bottom" /* Bottom */, /* @__PURE__ */new Set()), "left" /* Left */, /* @__PURE__ */new Set()), "floating-top" /* FloatingTop */, /* @__PURE__ */new Set()), "floating-bottom" /* FloatingBottom */, /* @__PURE__ */new Set());
    _this248.positionAlignments = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "top" /* Top */, {}), "right" /* Right */, {}), "bottom" /* Bottom */, {}), "left" /* Left */, {}), "floating-top" /* FloatingTop */, {}), "floating-bottom" /* FloatingBottom */, {});
    _this248.groupCallers = {
      annotations: 0,
      ranges: 0,
      zoom: 0
    };
    _this248.groupButtons = {
      annotations: [],
      ranges: [],
      zoom: []
    };
    _this248.pendingButtonToggledEvents = [];
    _this248.groupProxied = /* @__PURE__ */new Set();
    _this248.container = ctx.toolbarManager.element;
    _this248.elements = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "top" /* Top */, _this248.container.appendChild(_createElement("div"))), "right" /* Right */, _this248.container.appendChild(_createElement("div"))), "bottom" /* Bottom */, _this248.container.appendChild(_createElement("div"))), "left" /* Left */, _this248.container.appendChild(_createElement("div"))), "floating-top" /* FloatingTop */, _this248.container.appendChild(_createElement("div"))), "floating-bottom" /* FloatingBottom */, _this248.container.appendChild(_createElement("div")));
    _injectStyle(css2, block2);
    _this248.renderToolbar("top" /* Top */);
    _this248.renderToolbar("right" /* Right */);
    _this248.renderToolbar("bottom" /* Bottom */);
    _this248.renderToolbar("left" /* Left */);
    _this248.renderToolbar("floating-top" /* FloatingTop */);
    _this248.renderToolbar("floating-bottom" /* FloatingBottom */);
    _this248.toggleVisibilities();
    _this248.destroyFns.push(ctx.interactionManager.addListener("hover", _this248.onHover.bind(_assertThisInitialized(_this248)), 31 /* All */), ctx.interactionManager.addListener("leave", _this248.onLeave.bind(_assertThisInitialized(_this248)), 31 /* All */), ctx.toolbarManager.addListener("button-toggled", _this248.onButtonToggled.bind(_assertThisInitialized(_this248))), ctx.toolbarManager.addListener("group-toggled", _this248.onGroupToggled.bind(_assertThisInitialized(_this248))), ctx.toolbarManager.addListener("proxy-group-options", _this248.onProxyGroupOptions.bind(_assertThisInitialized(_this248))), ctx.layoutService.addListener("layout-complete", _this248.onLayoutComplete.bind(_assertThisInitialized(_this248))), function () {
      return _this248.destroyElements();
    });
    return _this248;
  }
  _createClass(Toolbar, [{
    key: "destroyElements",
    value: function destroyElements() {
      for (var _i38 = 0, _Object$values6 = Object.values(this.elements); _i38 < _Object$values6.length; _i38++) {
        var element2 = _Object$values6[_i38];
        element2.remove();
      }
    }
  }, {
    key: "onHover",
    value: function onHover(event) {
      var enabled = this.enabled,
        elements3 = this.elements,
        floatingDetectionRange = this.floatingDetectionRange,
        scene = this.ctx.scene;
      var offsetY = event.offsetY,
        target = event.sourceEvent.target;
      var FloatingBottom = ToolbarPosition.FloatingBottom,
        FloatingTop = ToolbarPosition.FloatingTop;
      if (!enabled) return;
      var bottom = elements3[FloatingBottom];
      var top = elements3[FloatingTop];
      var bottomDetectionY = bottom.offsetTop - floatingDetectionRange;
      var bottomVisible = offsetY > bottomDetectionY && offsetY < scene.canvas.element.offsetHeight || target === bottom;
      var topDetectionY = top.offsetTop + top.offsetHeight + floatingDetectionRange;
      var topVisible = offsetY > 0 && offsetY < topDetectionY || target === top;
      bottom.classList.toggle(modifiers2.floatingHidden, !bottomVisible);
      top.classList.toggle(modifiers2.floatingHidden, !topVisible);
      this.translateFloatingElements(FloatingBottom, bottomVisible);
      this.translateFloatingElements(FloatingTop, topVisible);
    }
  }, {
    key: "onLeave",
    value: function onLeave(event) {
      var _this249 = this;
      var enabled = this.enabled,
        elements3 = this.elements,
        scene = this.ctx.scene;
      var _event$sourceEvent = event.sourceEvent,
        relatedTarget = _event$sourceEvent.relatedTarget,
        target = _event$sourceEvent.target;
      var FloatingBottom = ToolbarPosition.FloatingBottom,
        FloatingTop = ToolbarPosition.FloatingTop;
      if (!enabled || target !== scene.canvas.element) return;
      var isTargetButton = TOOLBAR_GROUPS.some(function (group2) {
        return _this249.groupButtons[group2].some(function (button) {
          return button === relatedTarget;
        });
      });
      if (isTargetButton) return;
      elements3[FloatingBottom].classList.add(modifiers2.floatingHidden);
      elements3[FloatingTop].classList.add(modifiers2.floatingHidden);
      this.translateFloatingElements(FloatingBottom, false);
      this.translateFloatingElements(FloatingTop, false);
    }
  }, {
    key: "onGroupChanged",
    value: function onGroupChanged(group2) {
      if (this[group2] == null || this.groupProxied.has(group2)) return;
      this.createGroup(group2);
      this.toggleVisibilities();
    }
  }, {
    key: "onGroupButtonsChanged",
    value: function onGroupButtonsChanged(group2, buttons) {
      if (!this.enabled || this.groupProxied.has(group2)) return;
      this.createGroupButtons(group2, buttons);
      this.toggleVisibilities();
    }
  }, {
    key: "onLayoutComplete",
    value: function onLayoutComplete() {
      for (var _i39 = 0, _TOOLBAR_POSITIONS = TOOLBAR_POSITIONS; _i39 < _TOOLBAR_POSITIONS.length; _i39++) {
        var position = _TOOLBAR_POSITIONS[_i39];
        this.elements[position].classList.remove(modifiers2.preventFlash);
      }
    }
  }, {
    key: "onButtonToggled",
    value: function onButtonToggled(event) {
      var group2 = event.group,
        value = event.value,
        enabled = event.enabled;
      if (this.groupButtons[group2].length === 0) {
        this.pendingButtonToggledEvents.push(event);
        return;
      }
      var _iterator211 = _createForOfIteratorHelper(this.groupButtons[group2]),
        _step211;
      try {
        for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
          var button = _step211.value;
          if (button.dataset.toolbarValue !== "".concat(value)) continue;
          button.disabled = !enabled;
        }
      } catch (err) {
        _iterator211.e(err);
      } finally {
        _iterator211.f();
      }
    }
  }, {
    key: "onGroupToggled",
    value: function onGroupToggled(event) {
      var group2 = event.group,
        visible = event.visible;
      this.toggleGroup(group2, visible);
      this.toggleVisibilities();
    }
  }, {
    key: "onProxyGroupOptions",
    value: function onProxyGroupOptions(event) {
      var group2 = event.group,
        options = event.options;
      this.groupProxied.add(group2);
      this.createGroup(group2, options.enabled, options.position);
      this.createGroupButtons(group2, options.buttons);
      this.toggleGroup(group2, options.enabled);
      this[group2].set(options);
    }
  }, {
    key: "createGroup",
    value: function createGroup(group2, enabled, position) {
      enabled != null ? enabled : enabled = this[group2].enabled;
      position != null ? position : position = this[group2].position;
      for (var _i40 = 0, _TOOLBAR_POSITIONS2 = TOOLBAR_POSITIONS; _i40 < _TOOLBAR_POSITIONS2.length; _i40++) {
        var pos = _TOOLBAR_POSITIONS2[_i40];
        if (enabled && position === pos) {
          this.positions[pos].add(group2);
        } else {
          this.positions[pos].delete(group2);
        }
      }
    }
  }, {
    key: "createGroupButtons",
    value: function createGroupButtons(group2, buttons) {
      var _a, _b;
      var _iterator212 = _createForOfIteratorHelper(this.groupButtons[group2]),
        _step212;
      try {
        for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
          var button = _step212.value;
          button.remove();
        }
      } catch (err) {
        _iterator212.e(err);
      } finally {
        _iterator212.f();
      }
      this.groupButtons[group2] = [];
      var align = (_a = this[group2].align) != null ? _a : "start";
      var position = (_b = this[group2].position) != null ? _b : "top";
      var parent = this.positionAlignments[position][align];
      var _iterator213 = _createForOfIteratorHelper(buttons != null ? buttons : []),
        _step213;
      try {
        for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
          var options = _step213.value;
          var _button = this.createButtonElement(group2, options);
          parent == null ? void 0 : parent.appendChild(_button);
          this.groupButtons[group2].push(_button);
        }
      } catch (err) {
        _iterator213.e(err);
      } finally {
        _iterator213.f();
      }
    }
  }, {
    key: "toggleGroup",
    value: function toggleGroup(group2, enabled) {
      if (enabled) {
        this.groupCallers[group2] += 1;
      } else {
        this.groupCallers[group2] = Math.max(0, this.groupCallers[group2] - 1);
      }
    }
  }, {
    key: "processPendingEvents",
    value: function processPendingEvents() {
      var _a;
      var pendingButtonToggledEvents = ((_a = this.pendingButtonToggledEvents) != null ? _a : []).slice();
      var _iterator214 = _createForOfIteratorHelper(pendingButtonToggledEvents),
        _step214;
      try {
        for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
          var event = _step214.value;
          this.onButtonToggled(event);
        }
      } catch (err) {
        _iterator214.e(err);
      } finally {
        _iterator214.f();
      }
      this.pendingButtonToggledEvents = [];
    }
  }, {
    key: "performLayout",
    value: function performLayout(_0) {
      return __async(this, arguments, function (_ref182) {
        var _this250 = this;
        var shrinkRect = _ref182.shrinkRect;
        return /*#__PURE__*/_regenerator().m(function _callee92() {
          var elements3, margin;
          return _regenerator().w(function (_context103) {
            while (1) switch (_context103.n) {
              case 0:
                elements3 = _this250.elements, margin = _this250.margin;
                if (!elements3.top.classList.contains(modifiers2.hidden)) {
                  shrinkRect.shrink(elements3.top.offsetHeight + margin * 2, "top");
                }
                if (!elements3.right.classList.contains(modifiers2.hidden)) {
                  shrinkRect.shrink(elements3.right.offsetWidth + margin, "right");
                }
                if (!elements3.bottom.classList.contains(modifiers2.hidden)) {
                  shrinkRect.shrink(elements3.bottom.offsetHeight + margin * 2, "bottom");
                }
                if (!elements3.left.classList.contains(modifiers2.hidden)) {
                  shrinkRect.shrink(elements3.left.offsetWidth + margin, "left");
                }
                return _context103.a(2, {
                  shrinkRect: shrinkRect
                });
            }
          }, _callee92);
        })();
      });
    }
  }, {
    key: "performCartesianLayout",
    value: function performCartesianLayout(opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee93() {
        var elements3, margin, seriesRect, FloatingBottom, FloatingTop;
        return _regenerator().w(function (_context104) {
          while (1) switch (_context104.n) {
            case 0:
              elements3 = this.elements, margin = this.margin;
              seriesRect = opts.seriesRect;
              FloatingBottom = ToolbarPosition.FloatingBottom, FloatingTop = ToolbarPosition.FloatingTop;
              elements3.top.style.top = "".concat(seriesRect.y - elements3.top.offsetHeight - margin * 2, "px");
              elements3.top.style.left = "".concat(margin, "px");
              elements3.top.style.width = "calc(100% - ".concat(margin * 2, "px)");
              elements3.right.style.top = "".concat(seriesRect.y + margin, "px");
              elements3.right.style.right = "".concat(margin, "px");
              elements3.right.style.height = "calc(100% - ".concat(seriesRect.y + margin * 2, "px)");
              elements3.bottom.style.bottom = "".concat(margin, "px");
              elements3.bottom.style.left = "".concat(margin, "px");
              elements3.bottom.style.width = "calc(100% - ".concat(margin * 2, "px)");
              elements3.left.style.top = "".concat(seriesRect.y, "px");
              elements3.left.style.left = "".concat(margin, "px");
              elements3.left.style.height = "calc(100% - ".concat(seriesRect.y + margin * 2, "px)");
              elements3[FloatingTop].style.top = "".concat(seriesRect.y, "px");
              elements3[FloatingTop].style.paddingTop = "".concat(margin, "px");
              elements3[FloatingBottom].style.top = "".concat(seriesRect.y + seriesRect.height - elements3[FloatingBottom].offsetHeight, "px");
              elements3[FloatingBottom].style.paddingBottom = "".concat(margin, "px");
            case 1:
              return _context104.a(2);
          }
        }, _callee93, this);
      }));
    }
  }, {
    key: "toggleVisibilities",
    value: function toggleVisibilities() {
      var _this251 = this;
      var _a;
      if (this.elements == null) return;
      var isGroupVisible = function isGroupVisible(group2) {
        return _this251[group2].enabled && _this251.groupCallers[group2] > 0;
      };
      var isButtonVisible = function isButtonVisible(element2) {
        return function (button) {
          return typeof button.value !== "string" && typeof button.value !== "number" || "".concat(button.value) === element2.dataset.toolbarValue;
        };
      };
      for (var _i41 = 0, _TOOLBAR_POSITIONS3 = TOOLBAR_POSITIONS; _i41 < _TOOLBAR_POSITIONS3.length; _i41++) {
        var position = _TOOLBAR_POSITIONS3[_i41];
        var visible = this.enabled && Array.from(this.positions[position].values()).some(isGroupVisible);
        this.elements[position].classList.toggle(modifiers2.hidden, !visible);
      }
      for (var _i42 = 0, _TOOLBAR_GROUPS = TOOLBAR_GROUPS; _i42 < _TOOLBAR_GROUPS.length; _i42++) {
        var group2 = _TOOLBAR_GROUPS[_i42];
        if (this[group2] == null) continue;
        var _visible = isGroupVisible(group2);
        var _iterator215 = _createForOfIteratorHelper(this.groupButtons[group2]),
          _step215;
        try {
          for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
            var button = _step215.value;
            var buttonVisible = _visible && ((_a = this[group2].buttons) == null ? void 0 : _a.some(isButtonVisible(button)));
            button.classList.toggle(modifiers2.button.hidden, !buttonVisible);
          }
        } catch (err) {
          _iterator215.e(err);
        } finally {
          _iterator215.f();
        }
      }
    }
  }, {
    key: "translateFloatingElements",
    value: function translateFloatingElements(position, visible) {
      var elements3 = this.elements,
        margin = this.margin,
        positionAlignments = this.positionAlignments;
      var element2 = elements3[position];
      var alignments = Object.values(positionAlignments[position]);
      for (var _i43 = 0, _alignments = alignments; _i43 < _alignments.length; _i43++) {
        var align = _alignments[_i43];
        align.style.transform = visible && align.style.transform !== "" ? "translateY(0)" : "translateY(".concat(element2.offsetHeight + margin, "px)");
      }
    }
  }, {
    key: "renderToolbar",
    value: function renderToolbar() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "top";
      var element2 = this.elements[position];
      element2.classList.add(block2, modifiers2[position], modifiers2.preventFlash);
      if (position === "floating-top" /* FloatingTop */ || position === "floating-bottom" /* FloatingBottom */) {
        element2.classList.add(modifiers2.floatingHidden);
      }
      for (var _i44 = 0, _TOOLBAR_ALIGNMENTS = TOOLBAR_ALIGNMENTS; _i44 < _TOOLBAR_ALIGNMENTS.length; _i44++) {
        var align = _TOOLBAR_ALIGNMENTS[_i44];
        var alignmentElement = _createElement("div");
        alignmentElement.classList.add(elements2.align, modifiers2.align[align]);
        element2.appendChild(alignmentElement);
        this.positionAlignments[position][align] = alignmentElement;
      }
    }
  }, {
    key: "createButtonElement",
    value: function createButtonElement(group2, options) {
      var button = _createElement("button");
      button.classList.add(elements2.button);
      button.dataset.toolbarGroup = group2;
      button.tabIndex = -1;
      if (typeof options.value === "string" || typeof options.value === "number") {
        button.dataset.toolbarValue = "".concat(options.value);
      }
      if (options.tooltip) {
        button.title = options.tooltip;
      }
      var inner = "";
      if (options.icon != null) {
        inner = "<span class=\"ag-charts-icon-".concat(options.icon, " ").concat(elements2.icon, "\"></span>");
      }
      if (options.label != null) {
        inner = "".concat(inner, "<span class=\"").concat(elements2.label, "\">").concat(options.label, "</span>");
      }
      button.innerHTML = inner;
      button.onclick = this.onButtonPress.bind(this, group2, options.value);
      this.destroyFns.push(function () {
        return button.remove();
      });
      return button;
    }
  }, {
    key: "onButtonPress",
    value: function onButtonPress(group2, value) {
      this.ctx.toolbarManager.pressButton(group2, value);
    }
  }]);
  return Toolbar;
}(_BaseModuleInstance4);
__decorateClass([_ObserveChanges(function (target) {
  target.processPendingEvents();
  target.toggleVisibilities();
}), _Validate(_BOOLEAN)], Toolbar.prototype, "enabled", 2);

// packages/ag-charts-community/src/chart/toolbar/toolbarModule.ts
var DAY = 1e3 * 60 * 60 * 24;
var MONTH = DAY * 30;
var YEAR = DAY * 365;
var annotations = {
  enabled: false,
  position: "left",
  align: "start",
  buttons: [{
    label: "Li",
    value: "line"
  }, {
    label: "PCh",
    value: "parallel-channel"
  }]
};
var ranges = {
  enabled: false,
  position: "top",
  align: "start",
  buttons: [{
    label: "1m",
    value: MONTH
  }, {
    label: "3m",
    value: 3 * MONTH
  }, {
    label: "6m",
    value: 6 * MONTH
  }, {
    label: "YTD",
    value: function value(_start, end) {
      return [(/* @__PURE__ */new Date("".concat(new Date(end).getFullYear(), "-01-01"))).getTime(), end];
    }
  }, {
    label: "1y",
    value: YEAR
  }, {
    label: "All",
    value: function value(start, end) {
      return [start, end];
    }
  }]
};
var zoom = {
  enabled: false,
  position: "top",
  align: "end",
  buttons: [{
    icon: "zoom-out",
    tooltip: "Zoom out",
    value: "zoom-out"
  }, {
    icon: "zoom-in",
    tooltip: "Zoom in",
    value: "zoom-in"
  }, {
    icon: "pan-left",
    tooltip: "Pan left",
    value: "pan-left"
  }, {
    icon: "pan-right",
    tooltip: "Pan right",
    value: "pan-right"
  }, {
    icon: "pan-start",
    tooltip: "Pan to the start",
    value: "pan-start"
  }, {
    icon: "pan-end",
    tooltip: "Pan to the end",
    value: "pan-end"
  }, {
    icon: "reset",
    tooltip: "Reset the zoom",
    value: "reset"
  }]
};
var ToolbarModule = {
  type: "root",
  optionsKey: "toolbar",
  packageType: "community",
  chartTypes: ["cartesian"],
  instanceConstructor: Toolbar,
  themeTemplate: {
    toolbar: {
      enabled: true,
      annotations: annotations,
      ranges: ranges,
      zoom: zoom
    }
  }
};

// packages/ag-charts-community/src/chart/factory/registerInbuiltModules.ts
function registerInbuiltModules() {
  _moduleRegistry.register(_BackgroundModule, CommunityLegendModule, _NavigatorModule, ToolbarModule, AreaSeriesModule, BarSeriesModule, BubbleSeriesModule, LineSeriesModule, ScatterSeriesModule, DonutSeriesModule, PieSeriesModule, HistogramSeriesModule);
  for (var _i45 = 0, _arr5 = [NumberAxis, _CategoryAxis, TimeAxis, _GroupedCategoryAxis, LogAxis]; _i45 < _arr5.length; _i45++) {
    var AxisConstructor = _arr5[_i45];
    axisRegistry.register(AxisConstructor.type, {
      instanceConstructor: AxisConstructor,
      hidden: AxisConstructor === _GroupedCategoryAxis
    });
  }
}

// packages/ag-charts-community/src/chart/factory/setupModules.ts
function setupModules() {
  var _iterator216 = _createForOfIteratorHelper(_moduleRegistry.modules),
    _step216;
  try {
    for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
      var m = _step216.value;
      if (m.packageType === "enterprise" && !verifyIfModuleExpected(m)) {
        _Logger.errorOnce("Unexpected enterprise module registered: " + m.identifier);
      }
      if (m.type === "root" && m.themeTemplate) {
        var _iterator217 = _createForOfIteratorHelper(m.chartTypes),
          _step217;
        try {
          for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
            var chartType2 = _step217.value;
            chartDefaults.set(chartType2, m.themeTemplate);
          }
        } catch (err) {
          _iterator217.e(err);
        } finally {
          _iterator217.f();
        }
      }
      if (m.type === "series") {
        if (m.chartTypes.length > 1) {
          throw new Error("AG Charts - Module definition error: ".concat(m.identifier));
        }
        seriesRegistry.register(m.identifier, m);
      }
      if (m.type === "series-option" && m.themeTemplate) {
        var _iterator218 = _createForOfIteratorHelper(m.seriesTypes),
          _step218;
        try {
          for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
            var seriesType = _step218.value;
            seriesRegistry.setThemeTemplate(seriesType, m.themeTemplate);
          }
        } catch (err) {
          _iterator218.e(err);
        } finally {
          _iterator218.f();
        }
      }
      if (m.type === "axis-option" && m.themeTemplate) {
        var _iterator219 = _createForOfIteratorHelper(m.axisTypes),
          _step219;
        try {
          for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
            var axisType = _step219.value;
            var axisTypeTheme = m.themeTemplate[axisType];
            var theme = __spreadValues(__spreadValues({}, m.themeTemplate), axisTypeTheme);
            var _iterator220 = _createForOfIteratorHelper(m.axisTypes),
              _step220;
            try {
              for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
                var innerAxisType = _step220.value;
                delete theme[innerAxisType];
              }
            } catch (err) {
              _iterator220.e(err);
            } finally {
              _iterator220.f();
            }
            axisRegistry.setThemeTemplate(axisType, theme);
          }
        } catch (err) {
          _iterator219.e(err);
        } finally {
          _iterator219.f();
        }
      }
      if (m.type === "axis") {
        axisRegistry.register(m.identifier, m);
      }
      if (m.type === "legend") {
        legendRegistry.register(m.identifier, m);
      }
    }
  } catch (err) {
    _iterator216.e(err);
  } finally {
    _iterator216.f();
  }
  if (_moduleRegistry.hasEnterpriseModules()) {
    var expectedButUnused = getUnusedExpectedModules();
    if (expectedButUnused.length > 0) {
      _Logger.errorOnce("Enterprise modules expected but not registered: ", expectedButUnused);
    }
  }
}

// packages/ag-charts-community/src/chart/hierarchyChart.ts
var _HierarchyChart = /*#__PURE__*/function (_Chart3) {
  _inherits(_HierarchyChart, _Chart3);
  function _HierarchyChart(options, resources) {
    _classCallCheck(this, _HierarchyChart);
    return _possibleConstructorReturn(this, _getPrototypeOf(_HierarchyChart).call(this, options, resources));
  }
  _createClass(_HierarchyChart, [{
    key: "performLayout",
    value: function performLayout() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee95() {
        var _this252 = this;
        var shrinkRect, padding, seriesRoot, annotationRoot, highlightRoot, fullSeriesRect, _i46, _arr6, group2;
        return _regenerator().w(function (_context106) {
          while (1) switch (_context106.n) {
            case 0:
              _context106.n = 1;
              return __superGet(_HierarchyChart.prototype, this, "performLayout").call(this);
            case 1:
              shrinkRect = _context106.v;
              padding = this.seriesArea.padding, seriesRoot = this.seriesRoot, annotationRoot = this.annotationRoot, highlightRoot = this.highlightRoot;
              fullSeriesRect = shrinkRect.clone();
              shrinkRect.shrink(padding.left, "left");
              shrinkRect.shrink(padding.top, "top");
              shrinkRect.shrink(padding.right, "right");
              shrinkRect.shrink(padding.bottom, "bottom");
              this.seriesRect = shrinkRect;
              this.animationRect = shrinkRect;
              this.hoverRect = shrinkRect;
              for (_i46 = 0, _arr6 = [seriesRoot, annotationRoot, highlightRoot]; _i46 < _arr6.length; _i46++) {
                group2 = _arr6[_i46];
                group2.translationX = Math.floor(shrinkRect.x);
                group2.translationY = Math.floor(shrinkRect.y);
              }
              _context106.n = 2;
              return Promise.all(this.series.map(function (series) {
                return __async(_this252, null, /*#__PURE__*/_regenerator().m(function _callee94() {
                  return _regenerator().w(function (_context105) {
                    while (1) switch (_context105.n) {
                      case 0:
                        _context105.n = 1;
                        return series.update({
                          seriesRect: shrinkRect
                        });
                      case 1:
                        return _context105.a(2);
                    }
                  }, _callee94);
                }));
              }));
            case 2:
              seriesRoot.visible = this.series[0].visible;
              seriesRoot.setClipRectInGroupCoordinateSpace(new _BBox2(shrinkRect.x, shrinkRect.y, shrinkRect.width, shrinkRect.height));
              this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                  width: this.ctx.scene.width,
                  height: this.ctx.scene.height
                },
                clipSeries: false,
                series: {
                  rect: fullSeriesRect,
                  paddedRect: shrinkRect,
                  visible: true
                },
                axes: []
              });
              return _context106.a(2, shrinkRect);
          }
        }, _callee95, this);
      }));
    }
  }]);
  return _HierarchyChart;
}(Chart);
_HierarchyChart.className = "HierarchyChart";
_HierarchyChart.type = "hierarchy";
var HierarchyChart = _HierarchyChart;

// packages/ag-charts-community/src/chart/axis/polarAxis.ts
var _PolarAxis = /*#__PURE__*/function (_Axis3) {
  _inherits(PolarAxis, _Axis3);
  function PolarAxis() {
    var _this253;
    _classCallCheck(this, PolarAxis);
    _this253 = _possibleConstructorReturn(this, _getPrototypeOf(PolarAxis).apply(this, arguments));
    _this253.shape = "polygon";
    _this253.innerRadiusRatio = 0;
    _this253.defaultTickMinSpacing = 20;
    return _this253;
  }
  _createClass(PolarAxis, [{
    key: "computeLabelsBBox",
    value: function computeLabelsBBox(_options, _seriesRect) {
      return null;
    }
  }]);
  return PolarAxis;
}(_Axis4);
__decorateClass([_Validate(_UNION(["polygon", "circle"], "a polar axis shape"))], _PolarAxis.prototype, "shape", 2);
__decorateClass([_Validate(_RATIO)], _PolarAxis.prototype, "innerRadiusRatio", 2);

// packages/ag-charts-community/src/chart/polarChart.ts
var _PolarChart = /*#__PURE__*/function (_Chart4) {
  _inherits(_PolarChart, _Chart4);
  function _PolarChart(options, resources) {
    var _this254;
    _classCallCheck(this, _PolarChart);
    _this254 = _possibleConstructorReturn(this, _getPrototypeOf(_PolarChart).call(this, options, resources));
    _this254.padding = new _Padding(40);
    _this254.axisGroup.zIndex = 6 /* AXIS_FOREGROUND_ZINDEX */;
    return _this254;
  }
  _createClass(_PolarChart, [{
    key: "performLayout",
    value: function performLayout() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee96() {
        var shrinkRect, fullSeriesRect;
        return _regenerator().w(function (_context107) {
          while (1) switch (_context107.n) {
            case 0:
              _context107.n = 1;
              return __superGet(_PolarChart.prototype, this, "performLayout").call(this);
            case 1:
              shrinkRect = _context107.v;
              fullSeriesRect = shrinkRect.clone();
              this.computeSeriesRect(shrinkRect);
              _context107.n = 2;
              return this.computeCircle(shrinkRect);
            case 2:
              this.axes.forEach(function (axis) {
                return axis.update();
              });
              this.hoverRect = shrinkRect;
              this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                  width: this.ctx.scene.width,
                  height: this.ctx.scene.height
                },
                clipSeries: false,
                series: {
                  rect: fullSeriesRect,
                  paddedRect: shrinkRect,
                  visible: true
                },
                axes: []
              });
              return _context107.a(2, shrinkRect);
          }
        }, _callee96, this);
      }));
    }
  }, {
    key: "updateAxes",
    value: function updateAxes(cx, cy, radius) {
      var _a, _b;
      var angleAxis = this.axes.find(function (axis) {
        return axis.direction === "x";
      } /* X */);
      var radiusAxis = this.axes.find(function (axis) {
        return axis.direction === "y";
      } /* Y */);
      if (!(angleAxis instanceof _PolarAxis) || !(radiusAxis instanceof _PolarAxis)) {
        return;
      }
      var angleScale = angleAxis.scale;
      var angles = (_a = angleScale.ticks) == null ? void 0 : _a.call(angleScale).map(function (value) {
        return angleScale.convert(value);
      });
      var innerRadiusRatio = radiusAxis.innerRadiusRatio;
      angleAxis.innerRadiusRatio = innerRadiusRatio;
      (_b = angleAxis.computeRange) == null ? void 0 : _b.call(angleAxis);
      angleAxis.gridLength = radius;
      radiusAxis.gridAngles = angles;
      radiusAxis.gridRange = angleAxis.range;
      radiusAxis.range = [radius, radius * innerRadiusRatio];
      [angleAxis, radiusAxis].forEach(function (axis) {
        axis.translation.x = cx;
        axis.translation.y = cy;
        axis.calculateLayout();
      });
    }
  }, {
    key: "computeSeriesRect",
    value: function computeSeriesRect(shrinkRect) {
      var padding = this.seriesArea.padding;
      shrinkRect.shrink(padding.left, "left");
      shrinkRect.shrink(padding.top, "top");
      shrinkRect.shrink(padding.right, "right");
      shrinkRect.shrink(padding.bottom, "bottom");
      this.seriesRect = shrinkRect;
      this.animationRect = shrinkRect;
    }
  }, {
    key: "computeCircle",
    value: function computeCircle(seriesBox) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee98() {
        var _this255 = this;
        var polarSeries, polarAxes, setSeriesCircle, centerX, centerY, initialRadius, radius, shake;
        return _regenerator().w(function (_context109) {
          while (1) switch (_context109.n) {
            case 0:
              polarSeries = this.series.filter(function (series) {
                return series instanceof _PolarSeries3;
              });
              polarAxes = this.axes.filter(function (axis) {
                return axis instanceof _PolarAxis;
              });
              setSeriesCircle = function setSeriesCircle(cx, cy, r) {
                _this255.updateAxes(cx, cy, r);
                polarSeries.forEach(function (series) {
                  series.centerX = cx;
                  series.centerY = cy;
                  series.radius = r;
                });
                var pieSeries = polarSeries.filter(function (s) {
                  return s instanceof PieSeries || s instanceof DonutSeries;
                });
                if (pieSeries.length > 1) {
                  var innerRadii = pieSeries.map(function (series) {
                    var innerRadius = series.getInnerRadius();
                    return {
                      series: series,
                      innerRadius: innerRadius
                    };
                  }).sort(function (a, b) {
                    return a.innerRadius - b.innerRadius;
                  });
                  innerRadii.at(-1).series.surroundingRadius = void 0;
                  for (var i = 0; i < innerRadii.length - 1; i++) {
                    innerRadii[i].series.surroundingRadius = innerRadii[i + 1].innerRadius;
                  }
                }
              };
              centerX = seriesBox.x + seriesBox.width / 2;
              centerY = seriesBox.y + seriesBox.height / 2;
              initialRadius = Math.max(0, Math.min(seriesBox.width, seriesBox.height) / 2);
              radius = initialRadius;
              setSeriesCircle(centerX, centerY, radius);
              shake = function shake() {
                for (var _len34 = arguments.length, _0 = new Array(_len34), _key37 = 0; _key37 < _len34; _key37++) {
                  _0[_key37] = arguments[_key37];
                }
                return __async(_this255, [].concat(_0), function () {
                  var _this256 = this;
                  var _ref183 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref183$hideWhenNeces = _ref183.hideWhenNecessary,
                    hideWhenNecessary = _ref183$hideWhenNeces === void 0 ? false : _ref183$hideWhenNeces;
                  return /*#__PURE__*/_regenerator().m(function _callee97() {
                    var labelBoxes, _i47, _arr7, series, box, labelBox, refined;
                    return _regenerator().w(function (_context108) {
                      while (1) switch (_context108.n) {
                        case 0:
                          labelBoxes = [];
                          _i47 = 0, _arr7 = [].concat(_toConsumableArray(polarAxes), _toConsumableArray(polarSeries));
                        case 1:
                          if (!(_i47 < _arr7.length)) {
                            _context108.n = 4;
                            break;
                          }
                          series = _arr7[_i47];
                          _context108.n = 2;
                          return series.computeLabelsBBox({
                            hideWhenNecessary: hideWhenNecessary
                          }, seriesBox);
                        case 2:
                          box = _context108.v;
                          if (box) {
                            labelBoxes.push(box);
                          }
                        case 3:
                          _i47++;
                          _context108.n = 1;
                          break;
                        case 4:
                          if (!(labelBoxes.length === 0)) {
                            _context108.n = 5;
                            break;
                          }
                          setSeriesCircle(centerX, centerY, initialRadius);
                          return _context108.a(2);
                        case 5:
                          labelBox = _BBox2.merge(labelBoxes);
                          refined = _this256.refineCircle(labelBox, radius, seriesBox);
                          setSeriesCircle(refined.centerX, refined.centerY, refined.radius);
                          if (!(refined.radius === radius)) {
                            _context108.n = 6;
                            break;
                          }
                          return _context108.a(2);
                        case 6:
                          radius = refined.radius;
                        case 7:
                          return _context108.a(2);
                      }
                    }, _callee97);
                  })();
                });
              };
              _context109.n = 1;
              return shake();
            case 1:
              _context109.n = 2;
              return shake();
            case 2:
              _context109.n = 3;
              return shake();
            case 3:
              _context109.n = 4;
              return shake({
                hideWhenNecessary: true
              });
            case 4:
              _context109.n = 5;
              return shake({
                hideWhenNecessary: true
              });
            case 5:
              return _context109.a(2, {
                radius: radius,
                centerX: centerX,
                centerY: centerY
              });
          }
        }, _callee98, this);
      }));
    }
  }, {
    key: "refineCircle",
    value: function refineCircle(labelsBox, radius, seriesBox) {
      var minCircleRatio = 0.5;
      var circleLeft = -radius;
      var circleTop = -radius;
      var circleRight = radius;
      var circleBottom = radius;
      var padLeft = Math.max(0, circleLeft - labelsBox.x);
      var padTop = Math.max(0, circleTop - labelsBox.y);
      var padRight = Math.max(0, labelsBox.x + labelsBox.width - circleRight);
      var padBottom = Math.max(0, labelsBox.y + labelsBox.height - circleBottom);
      padLeft = padRight = Math.max(padLeft, padRight);
      padTop = padBottom = Math.max(padTop, padBottom);
      var availCircleWidth = seriesBox.width - padLeft - padRight;
      var availCircleHeight = seriesBox.height - padTop - padBottom;
      var newRadius = Math.min(availCircleWidth, availCircleHeight) / 2;
      var minHorizontalRadius = minCircleRatio * seriesBox.width / 2;
      var minVerticalRadius = minCircleRatio * seriesBox.height / 2;
      var minRadius = Math.min(minHorizontalRadius, minVerticalRadius);
      if (newRadius < minRadius) {
        newRadius = minRadius;
        var horizontalPadding = padLeft + padRight;
        var verticalPadding = padTop + padBottom;
        if (2 * newRadius + verticalPadding > seriesBox.height) {
          var padHeight = seriesBox.height - 2 * newRadius;
          if (Math.min(padTop, padBottom) * 2 > padHeight) {
            padTop = padHeight / 2;
            padBottom = padHeight / 2;
          } else if (padTop > padBottom) {
            padTop = padHeight - padBottom;
          } else {
            padBottom = padHeight - padTop;
          }
        }
        if (2 * newRadius + horizontalPadding > seriesBox.width) {
          var padWidth = seriesBox.width - 2 * newRadius;
          if (Math.min(padLeft, padRight) * 2 > padWidth) {
            padLeft = padWidth / 2;
            padRight = padWidth / 2;
          } else if (padLeft > padRight) {
            padLeft = padWidth - padRight;
          } else {
            padRight = padWidth - padLeft;
          }
        }
      }
      var newWidth = padLeft + 2 * newRadius + padRight;
      var newHeight = padTop + 2 * newRadius + padBottom;
      return {
        centerX: seriesBox.x + (seriesBox.width - newWidth) / 2 + padLeft + newRadius,
        centerY: seriesBox.y + (seriesBox.height - newHeight) / 2 + padTop + newRadius,
        radius: newRadius
      };
    }
  }]);
  return _PolarChart;
}(Chart);
_PolarChart.className = "PolarChart";
_PolarChart.type = "polar";
var PolarChart = _PolarChart;

// packages/ag-charts-community/src/chart/series/topology/mercatorScale.ts
var radsInDeg = Math.PI / 180;
var lonX = function lonX(lon) {
  return lon * radsInDeg;
};
var latY = function latY(lat) {
  return -Math.log(Math.tan(Math.PI * 0.25 + lat * radsInDeg * 0.5));
};
var xLon = function xLon(x) {
  return x / radsInDeg;
};
var yLat = function yLat(y) {
  return (Math.atan(Math.exp(-y)) - Math.PI * 0.25) / (radsInDeg * 0.5);
};
var _MercatorScale2 = /*#__PURE__*/function () {
  function _MercatorScale(domain, range3) {
    _classCallCheck(this, _MercatorScale);
    this.domain = domain;
    this.range = range3;
    this.type = "mercator";
    this.bounds = _MercatorScale.bounds(domain);
  }
  _createClass(_MercatorScale, [{
    key: "convert",
    value: function convert(_ref184) {
      var _ref185 = _slicedToArray(_ref184, 2),
        lon = _ref185[0],
        lat = _ref185[1];
      var _this$range4 = _slicedToArray(this.range, 2),
        _this$range4$ = _slicedToArray(_this$range4[0], 2),
        x0 = _this$range4$[0],
        y0 = _this$range4$[1],
        _this$range4$2 = _slicedToArray(_this$range4[1], 2),
        x1 = _this$range4$2[0],
        y1 = _this$range4$2[1];
      var xScale = (x1 - x0) / this.bounds.width;
      var yScale = (y1 - y0) / this.bounds.height;
      return [(lonX(lon) - this.bounds.x) * xScale + x0, (latY(lat) - this.bounds.y) * yScale + y0];
    }
  }, {
    key: "invert",
    value: function invert(_ref186) {
      var _ref187 = _slicedToArray(_ref186, 2),
        x = _ref187[0],
        y = _ref187[1];
      var _this$range5 = _slicedToArray(this.range, 2),
        _this$range5$ = _slicedToArray(_this$range5[0], 2),
        x0 = _this$range5$[0],
        y0 = _this$range5$[1],
        _this$range5$2 = _slicedToArray(_this$range5[1], 2),
        x1 = _this$range5$2[0],
        y1 = _this$range5$2[1];
      var xScale = (x1 - x0) / this.bounds.width;
      var yScale = (y1 - y0) / this.bounds.height;
      return [xLon((x - x0) / xScale + this.bounds.x), yLat((y - y0) / yScale + this.bounds.y)];
    }
  }], [{
    key: "bounds",
    value: function bounds(domain) {
      var _domain7 = _slicedToArray(domain, 2),
        _domain7$ = _slicedToArray(_domain7[0], 2),
        lon0 = _domain7$[0],
        lat0 = _domain7$[1],
        _domain7$2 = _slicedToArray(_domain7[1], 2),
        lon1 = _domain7$2[0],
        lat1 = _domain7$2[1];
      var x0 = lonX(lon0);
      var y0 = latY(lat0);
      var x1 = lonX(lon1);
      var y1 = latY(lat1);
      return new _BBox2(Math.min(x0, x1), Math.min(y0, y1), Math.abs(x1 - x0), Math.abs(y1 - y0));
    }
  }, {
    key: "fixedScale",
    value: function fixedScale() {
      return new _MercatorScale([[xLon(0), yLat(0)], [xLon(1), yLat(1)]], [[0, 0], [1, 1]]);
    }
  }]);
  return _MercatorScale;
}();

// packages/ag-charts-community/src/chart/topologyChart.ts
function isTopologySeries(series) {
  return series.type === "map-shape" || series.type === "map-line" || series.type === "map-marker" || series.type === "map-shape-background" || series.type === "map-line-background";
}
var _TopologyChart = /*#__PURE__*/function (_Chart5) {
  _inherits(_TopologyChart, _Chart5);
  function _TopologyChart(options, resources) {
    var _this257;
    _classCallCheck(this, _TopologyChart);
    _this257 = _possibleConstructorReturn(this, _getPrototypeOf(_TopologyChart).call(this, options, resources));
    _this257.xAxis = new NumberAxis(_this257.getModuleContext());
    _this257.xAxis.position = "bottom";
    _this257.yAxis = new NumberAxis(_this257.getModuleContext());
    _this257.yAxis.position = "left";
    _this257.ctx.zoomManager.updateAxes([_this257.xAxis, _this257.yAxis]);
    return _this257;
  }
  _createClass(_TopologyChart, [{
    key: "updateData",
    value: function updateData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee99() {
        var _this$getOptions, topology;
        return _regenerator().w(function (_context110) {
          while (1) switch (_context110.n) {
            case 0:
              _context110.n = 1;
              return __superGet(_TopologyChart.prototype, this, "updateData").call(this);
            case 1:
              _this$getOptions = this.getOptions(), topology = _this$getOptions.topology;
              this.series.forEach(function (series) {
                if (isTopologySeries(series)) {
                  series.setChartTopology(topology);
                }
              });
            case 2:
              return _context110.a(2);
          }
        }, _callee99, this);
      }));
    }
  }, {
    key: "performLayout",
    value: function performLayout() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee100() {
        var shrinkRect, padding, seriesRoot, annotationRoot, highlightRoot, fullSeriesRect, mapSeries, combinedBbox, scale2, lon0, lat0, lon1, lat1, domain, bounds, width, height, viewBoxScale, viewBoxWidth, viewBoxHeight, viewBoxOriginX, viewBoxOriginY, x0, y0, x1, y1, xZoom, yZoom, xSpan, xStart, ySpan, yStart, seriesVisible, _i48, _arr8, group2;
        return _regenerator().w(function (_context111) {
          while (1) switch (_context111.n) {
            case 0:
              _context111.n = 1;
              return __superGet(_TopologyChart.prototype, this, "performLayout").call(this);
            case 1:
              shrinkRect = _context111.v;
              padding = this.seriesArea.padding, seriesRoot = this.seriesRoot, annotationRoot = this.annotationRoot, highlightRoot = this.highlightRoot;
              fullSeriesRect = shrinkRect.clone();
              shrinkRect.shrink(padding.left, "left");
              shrinkRect.shrink(padding.top, "top");
              shrinkRect.shrink(padding.right, "right");
              shrinkRect.shrink(padding.bottom, "bottom");
              this.seriesRect = shrinkRect;
              this.animationRect = shrinkRect;
              this.hoverRect = shrinkRect;
              mapSeries = this.series.filter(isTopologySeries);
              combinedBbox = mapSeries.reduce(function (combined, series) {
                if (!series.visible) return combined;
                var bbox = series.topologyBounds;
                if (bbox == null) return combined;
                if (combined == null) return bbox;
                combined.merge(bbox);
                return combined;
              }, void 0);
              if (combinedBbox != null) {
                lon0 = combinedBbox.lon0, lat0 = combinedBbox.lat0, lon1 = combinedBbox.lon1, lat1 = combinedBbox.lat1;
                domain = [[lon0, lat0], [lon1, lat1]];
                bounds = _MercatorScale2.bounds(domain);
                width = shrinkRect.width, height = shrinkRect.height;
                viewBoxScale = Math.min(width / bounds.width, height / bounds.height);
                viewBoxWidth = bounds.width * viewBoxScale;
                viewBoxHeight = bounds.height * viewBoxScale;
                viewBoxOriginX = (width - viewBoxWidth) / 2;
                viewBoxOriginY = (height - viewBoxHeight) / 2;
                x0 = viewBoxOriginX;
                y0 = viewBoxOriginY;
                x1 = viewBoxOriginX + viewBoxWidth;
                y1 = viewBoxOriginY + viewBoxHeight;
                xZoom = this.ctx.zoomManager.getAxisZoom(this.xAxis.id);
                yZoom = this.ctx.zoomManager.getAxisZoom(this.yAxis.id);
                xSpan = (x1 - x0) / (xZoom.max - xZoom.min);
                xStart = x0 - xSpan * xZoom.min;
                ySpan = (y1 - y0) / (1 - yZoom.min - (1 - yZoom.max));
                yStart = y0 - ySpan * (1 - yZoom.max);
                scale2 = new _MercatorScale2(domain, [[xStart, yStart], [xStart + xSpan, yStart + ySpan]]);
              }
              mapSeries.forEach(function (series) {
                series.scale = scale2;
              });
              seriesVisible = this.series.some(function (s) {
                return s.visible;
              });
              seriesRoot.visible = seriesVisible;
              for (_i48 = 0, _arr8 = [seriesRoot, annotationRoot, highlightRoot]; _i48 < _arr8.length; _i48++) {
                group2 = _arr8[_i48];
                group2.translationX = Math.floor(shrinkRect.x);
                group2.translationY = Math.floor(shrinkRect.y);
                group2.setClipRectInGroupCoordinateSpace(new _BBox2(shrinkRect.x, shrinkRect.y, shrinkRect.width, shrinkRect.height));
              }
              this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                  width: this.ctx.scene.width,
                  height: this.ctx.scene.height
                },
                clipSeries: false,
                series: {
                  rect: fullSeriesRect,
                  paddedRect: shrinkRect,
                  visible: seriesVisible
                },
                axes: []
              });
              return _context111.a(2, shrinkRect);
          }
        }, _callee100, this);
      }));
    }
  }]);
  return _TopologyChart;
}(Chart);
_TopologyChart.className = "TopologyChart";
_TopologyChart.type = "topology";
var TopologyChart = _TopologyChart;

// packages/ag-charts-community/src/chart/agChartV2.ts
var debug2 = Debug.create(true, "opts");
function chartType(options) {
  if (isAgCartesianChartOptions(options)) {
    return "cartesian";
  } else if (isAgPolarChartOptions(options)) {
    return "polar";
  } else if (isAgHierarchyChartOptions(options)) {
    return "hierarchy";
  } else if (isAgTopologyChartOptions(options)) {
    return "topology";
  }
  throw new Error("AG Chart - unknown type of chart for options with type: ".concat(options.type));
}
var _AgCharts = /*#__PURE__*/function () {
  function _AgCharts() {
    _classCallCheck(this, _AgCharts);
  }
  _createClass(_AgCharts, null, [{
    key: "licenseCheck",
    value: function licenseCheck(options) {
      var _a, _b, _c, _d;
      if (this.licenseChecked) return;
      this.licenseManager = (_b = (_a = _enterpriseModule).licenseManager) == null ? void 0 : _b.call(_a, options);
      (_c = this.licenseManager) == null ? void 0 : _c.setLicenseKey(this.licenseKey, this.gridContext);
      (_d = this.licenseManager) == null ? void 0 : _d.validateLicense();
      this.licenseChecked = true;
    }
  }, {
    key: "setLicenseKey",
    value: function setLicenseKey(licenseKey) {
      this.licenseKey = licenseKey;
    }
  }, {
    key: "setGridContext",
    value: function setGridContext(gridContext) {
      this.gridContext = gridContext;
    }
  }, {
    key: "getLicenseDetails",
    value: function getLicenseDetails(licenseKey) {
      var _a, _b;
      return (_b = (_a = _enterpriseModule).licenseManager) == null ? void 0 : _b.call(_a, {}).getLicenseDetails(licenseKey);
    }
    /**
     * Returns the `AgChartInstance` for a DOM node, if there is one.
     */
  }, {
    key: "getInstance",
    value: function getInstance(element2) {
      return AgChartsInternal.getInstance(element2);
    }
    /**
     * Create a new `AgChartInstance` based upon the given configuration options.
     */
  }, {
    key: "create",
    value: function create(options) {
      var _a, _b, _c;
      this.licenseCheck(options);
      var chart = AgChartsInternal.createOrUpdate(options);
      if ((_a = this.licenseManager) == null ? void 0 : _a.isDisplayWatermark()) {
        (_c = (_b = _enterpriseModule).injectWatermark) == null ? void 0 : _c.call(_b, chart.chart.element, this.licenseManager.getWatermarkMessage());
      }
      return chart;
    }
    /**
     * Update an existing `AgChartInstance`. Options provided should be complete and not
     * partial.
     *
     * __NOTE__: As each call could trigger a chart redraw, multiple calls to update options in
     * quick succession could result in undesirable flickering, so callers should batch up and/or
     * debounce changes to avoid unintended partial update renderings.
     */
  }, {
    key: "update",
    value: function update(chart, options) {
      if (!AgChartInstanceProxy.isInstance(chart)) {
        throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
      }
      AgChartsInternal.createOrUpdate(options, chart);
    }
    /**
     * Update an existing `AgChartInstance` by applying a partial set of option changes.
     *
     * __NOTE__: As each call could trigger a chart redraw, each individual delta options update
     * should leave the chart in a valid options state. Also, multiple calls to update options in
     * quick succession could result in undesirable flickering, so callers should batch up and/or
     * debounce changes to avoid unintended partial update renderings.
     */
  }, {
    key: "updateDelta",
    value: function updateDelta(chart, deltaOptions) {
      if (!AgChartInstanceProxy.isInstance(chart)) {
        throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
      }
      AgChartsInternal.updateUserDelta(chart, deltaOptions);
    }
    /**
     * Starts a browser-based image download for the given `AgChartInstance`.
     */
  }, {
    key: "download",
    value: function download(chart, options) {
      if (!(chart instanceof AgChartInstanceProxy)) {
        throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
      }
      AgChartsInternal.download(chart, options).catch(function (e) {
        return _Logger.errorOnce(e);
      });
    }
    /**
     * Returns a base64-encoded image data URL for the given `AgChartInstance`.
     */
  }, {
    key: "getImageDataURL",
    value: function getImageDataURL(chart, options) {
      if (!(chart instanceof AgChartInstanceProxy)) {
        throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
      }
      return AgChartsInternal.getImageDataURL(chart, options);
    }
  }]);
  return _AgCharts;
}();
_AgCharts.INVALID_CHART_REF_MESSAGE = "AG Charts - invalid chart reference passed";
_AgCharts.licenseChecked = false;
_AgCharts.gridContext = false;
var AgCharts = _AgCharts;
var AgChart = /*#__PURE__*/function () {
  function AgChart() {
    _classCallCheck(this, AgChart);
  }
  _createClass(AgChart, null, [{
    key: "warnDeprecated",
    value: function warnDeprecated(memberName) {
      var warnDeprecated = _createDeprecationWarning();
      warnDeprecated("AgChart.".concat(memberName), "Use AgCharts.".concat(memberName, " instead"));
    }
  }, {
    key: "create",
    value: function create(options) {
      this.warnDeprecated("create");
      return AgCharts.create(options);
    }
  }, {
    key: "update",
    value: function update(chart, options) {
      this.warnDeprecated("update");
      return AgCharts.update(chart, options);
    }
  }, {
    key: "updateDelta",
    value: function updateDelta(chart, deltaOptions) {
      this.warnDeprecated("updateDelta");
      return AgCharts.updateDelta(chart, deltaOptions);
    }
  }, {
    key: "download",
    value: function download(chart, options) {
      this.warnDeprecated("download");
      return AgCharts.download(chart, options);
    }
  }, {
    key: "getImageDataURL",
    value: function getImageDataURL(chart, options) {
      this.warnDeprecated("getImageDataURL");
      return AgCharts.getImageDataURL(chart, options);
    }
  }]);
  return AgChart;
}();
var _AgChartsInternal = /*#__PURE__*/function () {
  function _AgChartsInternal() {
    _classCallCheck(this, _AgChartsInternal);
  }
  _createClass(_AgChartsInternal, null, [{
    key: "getInstance",
    value: function getInstance(element2) {
      var chart = Chart.getInstance(element2);
      return chart ? AgChartInstanceProxy.chartInstances.get(chart) : void 0;
    }
  }, {
    key: "initialiseModules",
    value: function initialiseModules() {
      if (_AgChartsInternal.initialised) return;
      registerInbuiltModules();
      setupModules();
      _AgChartsInternal.initialised = true;
    }
  }, {
    key: "createOrUpdate",
    value: function createOrUpdate(options, proxy) {
      var _b;
      _AgChartsInternal.initialiseModules();
      debug2(">>> AgChartV2.createOrUpdate() user options", options);
      var _a = options,
        overrideDevicePixelRatio = _a.overrideDevicePixelRatio,
        document2 = _a.document,
        userWindow = _a.window,
        userOptions = __objRest(_a, ["overrideDevicePixelRatio", "document", "window"]);
      var chartOptions = new _ChartOptions(userOptions, {
        overrideDevicePixelRatio: overrideDevicePixelRatio,
        document: document2,
        window: userWindow
      });
      var chart = proxy == null ? void 0 : proxy.chart;
      if (chart == null || chartType(userOptions) !== chartType(chart.processedOptions)) {
        chart = _AgChartsInternal.createChartInstance(chartOptions, chart);
      }
      if (proxy == null) {
        proxy = new AgChartInstanceProxy(chart);
      } else {
        proxy.chart = chart;
      }
      if (debug2.check() && typeof window !== "undefined") {
        (_b = window.agChartInstances) != null ? _b : window.agChartInstances = {};
        window.agChartInstances[chart.id] = chart;
      }
      chart.queuedUserOptions.push(userOptions);
      chart.requestFactoryUpdate(function (chartRef) {
        chartRef.applyOptions(chartOptions);
        chartRef.queuedUserOptions.splice(0, chartRef.queuedUserOptions.indexOf(userOptions));
      });
      return proxy;
    }
  }, {
    key: "updateUserDelta",
    value: function updateUserDelta(proxy, deltaOptions) {
      deltaOptions = _deepClone2(deltaOptions, {
        shallow: ["data"]
      });
      _jsonWalk(deltaOptions, function (node) {
        if (typeof node !== "object") return;
        for (var _i49 = 0, _Object$entries7 = Object.entries(node); _i49 < _Object$entries7.length; _i49++) {
          var _Object$entries7$_i = _slicedToArray(_Object$entries7[_i49], 2),
            key = _Object$entries7$_i[0],
            value = _Object$entries7$_i[1];
          if (typeof value === "undefined") {
            Object.assign(node, _defineProperty({}, key, Symbol("UNSET")));
          }
        }
      }, {
        skip: ["data"]
      });
      var chart = proxy.chart;
      var lastUpdateOptions = chart.getOptions();
      var userOptions = _mergeDefaults4(deltaOptions, lastUpdateOptions);
      debug2(">>> AgChartV2.updateUserDelta() user delta", deltaOptions);
      debug2("AgChartV2.updateUserDelta() - base options", lastUpdateOptions);
      _AgChartsInternal.createOrUpdate(userOptions, proxy);
    }
    /**
     * Returns the content of the current canvas as an image.
     */
  }, {
    key: "download",
    value: function download(proxy, opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee101() {
        var clone, _t16;
        return _regenerator().w(function (_context112) {
          while (1) switch (_context112.p = _context112.n) {
            case 0:
              _context112.p = 0;
              _context112.n = 1;
              return _AgChartsInternal.prepareResizedChart(proxy, opts);
            case 1:
              clone = _context112.v;
              clone.chart.ctx.scene.download(opts == null ? void 0 : opts.fileName, opts == null ? void 0 : opts.fileFormat);
              clone.destroy();
              _context112.n = 3;
              break;
            case 2:
              _context112.p = 2;
              _t16 = _context112.v;
              _Logger.errorOnce(_t16);
            case 3:
              return _context112.a(2);
          }
        }, _callee101, null, [[0, 2]]);
      }));
    }
  }, {
    key: "getImageDataURL",
    value: function getImageDataURL(proxy, opts) {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee102() {
        var clone, result;
        return _regenerator().w(function (_context113) {
          while (1) switch (_context113.n) {
            case 0:
              _context113.n = 1;
              return _AgChartsInternal.prepareResizedChart(proxy, opts);
            case 1:
              clone = _context113.v;
              result = clone.chart.ctx.scene.getDataURL(opts == null ? void 0 : opts.fileFormat);
              clone.destroy();
              return _context113.a(2, result);
          }
        }, _callee102);
      }));
    }
  }, {
    key: "prepareResizedChart",
    value: function prepareResizedChart(_0) {
      return __async(this, arguments, function (_ref188) {
        var chart = _ref188.chart;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/_regenerator().m(function _callee103() {
          var _a, _b, _c, _d, width, height, options, cloneProxy;
          return _regenerator().w(function (_context114) {
            while (1) switch (_context114.n) {
              case 0:
                width = (_b = (_a = opts.width) != null ? _a : chart.width) != null ? _b : chart.ctx.scene.canvas.width;
                height = (_d = (_c = opts.height) != null ? _c : chart.height) != null ? _d : chart.ctx.scene.canvas.height;
                options = _mergeDefaults4({
                  container: document.createElement("div"),
                  overrideDevicePixelRatio: 1,
                  autoSize: false,
                  width: width,
                  height: height
                },
                // Disable enterprise features that may interfere with image generation.
                _moduleRegistry.hasEnterpriseModules() && {
                  animation: {
                    enabled: false
                  }
                }, chart.userOptions);
                cloneProxy = _AgChartsInternal.createOrUpdate(options);
                cloneProxy.chart.ctx.zoomManager.updateZoom("agChartV2", chart.ctx.zoomManager.getZoom());
                chart.series.forEach(function (series, index) {
                  if (!series.visible) {
                    cloneProxy.chart.series[index].visible = false;
                  }
                });
                chart.update(0 /* FULL */, {
                  forceNodeDataRefresh: true
                });
                _context114.n = 1;
                return cloneProxy.chart.waitForUpdate();
              case 1:
                return _context114.a(2, cloneProxy);
            }
          }, _callee103);
        })();
      });
    }
  }, {
    key: "createChartInstance",
    value: function createChartInstance(options, oldChart) {
      var transferableResource = oldChart == null ? void 0 : oldChart.destroy({
        keepTransferableResources: true
      });
      var ChartConstructor = _AgChartsInternal.getChartByOptions(options.processedOptions);
      return new ChartConstructor(options, transferableResource);
    }
  }, {
    key: "getChartByOptions",
    value: function getChartByOptions(options) {
      if (isAgCartesianChartOptions(options)) {
        return CartesianChart;
      } else if (isAgHierarchyChartOptions(options)) {
        return HierarchyChart;
      } else if (isAgPolarChartOptions(options)) {
        return PolarChart;
      } else if (isAgTopologyChartOptions(options)) {
        return TopologyChart;
      }
      throw new Error("AG Charts - couldn't apply configuration, check options are correctly structured and series types are specified");
    }
  }]);
  return _AgChartsInternal;
}();
_AgChartsInternal.initialised = false;
var AgChartsInternal = _AgChartsInternal;

// packages/ag-charts-community/src/version.ts
var VERSION = "9.3.2";

// packages/ag-charts-community/src/integrated-charts-scene.ts
var integrated_charts_scene_exports = {};
__export(integrated_charts_scene_exports, {
  Arc: function Arc() {
    return Arc2;
  },
  BBox: function BBox() {
    return _BBox2;
  },
  BandScale: function BandScale() {
    return _BandScale3;
  },
  Caption: function Caption() {
    return _Caption3;
  },
  ChangeDetectableProperties: function ChangeDetectableProperties() {
    return _ChangeDetectableProperties;
  },
  Circle: function Circle() {
    return _Circle;
  },
  ContinuousScale: function ContinuousScale() {
    return _ContinuousScale5;
  },
  Diamond: function Diamond() {
    return _Diamond2;
  },
  DropShadow: function DropShadow() {
    return _DropShadow;
  },
  ExtendedPath2D: function ExtendedPath2D() {
    return _ExtendedPath2D;
  },
  Group: function Group() {
    return _Group4;
  },
  HdpiCanvas: function HdpiCanvas() {
    return _HdpiCanvas2;
  },
  Image: function Image() {
    return _Image;
  },
  Label: function Label() {
    return _Label0;
  },
  Line: function Line() {
    return _Line;
  },
  LinearGradientFill: function LinearGradientFill() {
    return _LinearGradientFill;
  },
  LinearScale: function LinearScale() {
    return _LinearScale;
  },
  Marker: function Marker() {
    return _Marker0;
  },
  Node: function Node() {
    return _Node4;
  },
  OrdinalTimeScale: function OrdinalTimeScale() {
    return _OrdinalTimeScale2;
  },
  Path: function Path() {
    return _Path6;
  },
  PointerEvents: function PointerEvents() {
    return _PointerEvents;
  },
  RadialColumnShape: function RadialColumnShape() {
    return _RadialColumnShape;
  },
  Rect: function Rect() {
    return _Rect;
  },
  RedrawType: function RedrawType() {
    return _RedrawType;
  },
  Scene: function Scene() {
    return _Scene;
  },
  SceneChangeDetection: function SceneChangeDetection() {
    return _SceneChangeDetection;
  },
  ScenePathChangeDetection: function ScenePathChangeDetection() {
    return _ScenePathChangeDetection;
  },
  Sector: function Sector() {
    return _Sector;
  },
  SectorBox: function SectorBox() {
    return _SectorBox2;
  },
  Selection: function Selection() {
    return _Selection2;
  },
  Shape: function Shape() {
    return _Shape6;
  },
  Square: function Square() {
    return _Square;
  },
  Text: function Text() {
    return _Text2;
  },
  Tooltip: function Tooltip() {
    return _Tooltip;
  },
  Triangle: function Triangle() {
    return _Triangle2;
  },
  easing: function easing() {
    return easing_exports;
  },
  getFont: function getFont() {
    return _getFont;
  },
  getMarker: function getMarker() {
    return _getMarker;
  },
  getRadialColumnWidth: function getRadialColumnWidth() {
    return _getRadialColumnWidth;
  },
  motion: function motion() {
    return _motion;
  },
  nearestSquared: function nearestSquared() {
    return _nearestSquared;
  },
  nearestSquaredInContainer: function nearestSquaredInContainer() {
    return _nearestSquaredInContainer;
  },
  toRadians: function toRadians() {
    return _toRadians;
  },
  toTooltipHtml: function toTooltipHtml() {
    return _toTooltipHtml;
  }
});

// packages/ag-charts-community/src/scene/shape/arc.ts
var Arc2 = /*#__PURE__*/function (_Path7) {
  _inherits(Arc2, _Path7);
  function Arc2() {
    var _this258;
    _classCallCheck(this, Arc2);
    _this258 = _possibleConstructorReturn(this, _getPrototypeOf(Arc2).call(this));
    _this258.centerX = 0;
    _this258.centerY = 0;
    _this258.radius = 10;
    _this258.startAngle = 0;
    _this258.endAngle = Math.PI * 2;
    _this258.counterClockwise = false;
    _this258.type = 0 /* Open */;
    _this258.restoreOwnStyles();
    return _this258;
  }
  _createClass(Arc2, [{
    key: "updatePath",
    value: function updatePath() {
      var path = this.path;
      path.clear();
      path.arc(this.centerX, this.centerY, this.radius, this.startAngle, this.endAngle, this.counterClockwise);
      if (this.type === 1 /* Chord */) {
        path.closePath();
      } else if (this.type === 2 /* Round */ && !this.fullPie) {
        path.lineTo(this.centerX, this.centerY);
        path.closePath();
      }
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      return new _BBox2(this.centerX - this.radius, this.centerY - this.radius, this.radius * 2, this.radius * 2);
    }
  }, {
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var point = this.transformPoint(x, y);
      var bbox = this.computeBBox();
      return this.type !== 0 /* Open */ && bbox.containsPoint(point.x, point.y) && this.path.isPointInPath(point.x, point.y);
    }
  }, {
    key: "fullPie",
    get: function get() {
      return _isEqual(_normalizeAngle2(this.startAngle), _normalizeAngle2(this.endAngle));
    }
  }]);
  return Arc2;
}(_Path6);
Arc2.className = "Arc";
Arc2.defaultStyles = Object.assign({}, _Shape6.defaultStyles, {
  lineWidth: 1,
  fillStyle: null
});
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "centerX", 2);
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "centerY", 2);
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "radius", 2);
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "startAngle", 2);
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "endAngle", 2);
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "counterClockwise", 2);
__decorateClass([_ScenePathChangeDetection()], Arc2.prototype, "type", 2);

// packages/ag-charts-community/src/scene/shape/linearGradientFill.ts
var _LinearGradientFill = /*#__PURE__*/function (_Shape7) {
  _inherits(_LinearGradientFill, _Shape7);
  function _LinearGradientFill() {
    var _this259;
    _classCallCheck(this, _LinearGradientFill);
    _this259 = _possibleConstructorReturn(this, _getPrototypeOf(_LinearGradientFill).apply(this, arguments));
    _this259.direction = "to-right";
    _this259.stops = void 0;
    _this259._mask = void 0;
    return _this259;
  }
  _createClass(_LinearGradientFill, [{
    key: "isPointInPath",
    value: function isPointInPath(x, y) {
      var _a, _b;
      return (_b = (_a = this.mask) == null ? void 0 : _a.isPointInPath(x, y)) != null ? _b : false;
    }
  }, {
    key: "computeBBox",
    value: function computeBBox() {
      var _a;
      return (_a = this.mask) == null ? void 0 : _a.computeBBox();
    }
  }, {
    key: "render",
    value: function render(renderCtx) {
      var mask = this.mask,
        stops = this.stops;
      var ctx = renderCtx.ctx,
        devicePixelRatio = renderCtx.devicePixelRatio;
      var pixelLength = 1 / devicePixelRatio;
      var maskBbox = mask == null ? void 0 : mask.computeTransformedBBox();
      if (mask == null || stops == null || maskBbox == null) return;
      if (mask.dirtyPath) {
        mask.updatePath();
        mask.dirtyPath = false;
      }
      ctx.save();
      ctx.clip(mask.path.getPath2D());
      ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
      var x0 = Math.floor(maskBbox.x);
      var x1 = Math.ceil(maskBbox.x + maskBbox.width);
      var y0 = Math.floor(maskBbox.y);
      var y1 = Math.ceil(maskBbox.y + maskBbox.height);
      var colorScale = new _ColorScale();
      var _ref189 = this.direction === "to-right" ? [x0, x1] : [y0, y1],
        _ref190 = _slicedToArray(_ref189, 2),
        i0 = _ref190[0],
        i1 = _ref190[1];
      colorScale.domain = stops.map(function (_, index) {
        return i0 + (i1 - i0) * index / (stops.length - 1);
      });
      colorScale.range = stops;
      colorScale.update();
      if (this.direction === "to-right") {
        var height = y1 - y0;
        for (var x = x0; x <= x1; x += pixelLength) {
          ctx.fillStyle = colorScale.convert(x);
          ctx.fillRect(x, y0, pixelLength, height);
        }
      } else {
        var width = x1 - x0;
        for (var y = y0; y <= y1; y += pixelLength) {
          ctx.fillStyle = colorScale.convert(y);
          ctx.fillRect(x0, y, width, pixelLength);
        }
      }
      ctx.restore();
    }
  }, {
    key: "mask",
    get: function get() {
      return this._mask;
    },
    set: function set(newMask) {
      if (this._mask != null) {
        this.removeChild(this._mask);
      }
      if (newMask != null) {
        this.appendChild(newMask);
      }
      this._mask = newMask;
    }
  }]);
  return _LinearGradientFill;
}(_Shape6);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _LinearGradientFill.prototype, "direction", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _LinearGradientFill.prototype, "stops", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _LinearGradientFill.prototype, "_mask", 2);

// packages/ag-charts-community/src/scene/shape/radialColumnShape.ts
function rotatePoint(x, y, rotation) {
  var radius = Math.sqrt(__pow(x, 2) + __pow(y, 2));
  var angle = Math.atan2(y, x);
  var rotated = angle + rotation;
  return {
    x: Math.cos(rotated) * radius,
    y: Math.sin(rotated) * radius
  };
}
var _RadialColumnShape = /*#__PURE__*/function (_Path8) {
  _inherits(_RadialColumnShape, _Path8);
  function _RadialColumnShape() {
    var _this260;
    _classCallCheck(this, _RadialColumnShape);
    _this260 = _possibleConstructorReturn(this, _getPrototypeOf(_RadialColumnShape).apply(this, arguments));
    _this260.borderPath = new _ExtendedPath2D();
    _this260.isBeveled = true;
    _this260.columnWidth = 0;
    _this260.startAngle = 0;
    _this260.endAngle = 0;
    _this260.outerRadius = 0;
    _this260.innerRadius = 0;
    _this260.axisInnerRadius = 0;
    _this260.axisOuterRadius = 0;
    _this260.isRadiusAxisReversed = false;
    return _this260;
  }
  _createClass(_RadialColumnShape, [{
    key: "getRotation",
    value: function getRotation() {
      var startAngle = this.startAngle,
        endAngle = this.endAngle;
      var midAngle = _angleBetween(startAngle, endAngle);
      return _normalizeAngle2(startAngle + midAngle / 2 + Math.PI / 2);
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      var isBeveled = this.isBeveled;
      if (isBeveled) {
        this.updateBeveledPath();
      } else {
        this.updateRectangularPath();
      }
      this.checkPathDirty();
    }
  }, {
    key: "updateRectangularPath",
    value: function updateRectangularPath() {
      var columnWidth = this.columnWidth,
        innerRadius = this.innerRadius,
        outerRadius = this.outerRadius,
        path = this.path;
      var left = -columnWidth / 2;
      var right = columnWidth / 2;
      var top = -outerRadius;
      var bottom = -innerRadius;
      var rotation = this.getRotation();
      var points = [[left, bottom], [left, top], [right, top], [right, bottom], [left, bottom]].map(function (_ref191) {
        var _ref192 = _slicedToArray(_ref191, 2),
          x = _ref192[0],
          y = _ref192[1];
        return rotatePoint(x, y, rotation);
      });
      path.clear(true);
      path.moveTo(points[0].x, points[0].y);
      path.lineTo(points[1].x, points[1].y);
      path.lineTo(points[2].x, points[2].y);
      path.lineTo(points[3].x, points[3].y);
      path.lineTo(points[0].x, points[0].y);
      path.closePath();
    }
  }, {
    key: "updateBeveledPath",
    value: function updateBeveledPath() {
      var columnWidth = this.columnWidth,
        path = this.path,
        outerRadius = this.outerRadius,
        innerRadius = this.innerRadius,
        axisInnerRadius = this.axisInnerRadius,
        axisOuterRadius = this.axisOuterRadius,
        isRadiusAxisReversed = this.isRadiusAxisReversed;
      var isStackBottom = _isEqual(innerRadius, axisInnerRadius);
      var sideRotation = Math.asin(columnWidth / 2 / innerRadius);
      var pointRotation = this.getRotation();
      var rotate = function rotate(x, y) {
        return rotatePoint(x, y, pointRotation);
      };
      var getTriangleHypotenuse = function getTriangleHypotenuse(leg, otherLeg) {
        return Math.sqrt(__pow(leg, 2) + __pow(otherLeg, 2));
      };
      var getTriangleLeg = function getTriangleLeg(hypotenuse, otherLeg) {
        if (otherLeg > hypotenuse) {
          return 0;
        }
        return Math.sqrt(__pow(hypotenuse, 2) - __pow(otherLeg, 2));
      };
      var compare = function compare(value, otherValue, lessThan) {
        return lessThan ? value < otherValue : value > otherValue;
      };
      var shouldConnectBottomCircle = isStackBottom && !isNaN(sideRotation) && sideRotation < Math.PI / 6;
      var left = -columnWidth / 2;
      var right = columnWidth / 2;
      var top = -outerRadius;
      var bottom = -innerRadius * (shouldConnectBottomCircle ? Math.cos(sideRotation) : 1);
      var hasBottomIntersection = compare(axisOuterRadius, getTriangleHypotenuse(innerRadius, columnWidth / 2), !isRadiusAxisReversed);
      if (hasBottomIntersection) {
        var bottomIntersectionX = getTriangleLeg(axisOuterRadius, innerRadius);
        left = -bottomIntersectionX;
        right = bottomIntersectionX;
      }
      path.clear(true);
      var bottomLeftPt = rotate(left, bottom);
      path.moveTo(bottomLeftPt.x, bottomLeftPt.y);
      var isEmpty = _isEqual(innerRadius, outerRadius);
      var hasSideIntersection = compare(axisOuterRadius, getTriangleHypotenuse(outerRadius, columnWidth / 2), !isRadiusAxisReversed);
      if (isEmpty && shouldConnectBottomCircle) {
        path.arc(0, 0, innerRadius, _normalizeAngle2(-sideRotation - Math.PI / 2) + pointRotation, _normalizeAngle2(sideRotation - Math.PI / 2) + pointRotation, false);
      } else if (hasSideIntersection) {
        var sideIntersectionY = -getTriangleLeg(axisOuterRadius, columnWidth / 2);
        var topIntersectionX = getTriangleLeg(axisOuterRadius, outerRadius);
        if (!hasBottomIntersection) {
          var topLeftPt = rotate(left, sideIntersectionY);
          path.lineTo(topLeftPt.x, topLeftPt.y);
        }
        path.arc(0, 0, axisOuterRadius, Math.atan2(sideIntersectionY, left) + pointRotation, Math.atan2(top, -topIntersectionX) + pointRotation, false);
        if (!_isEqual(topIntersectionX, 0)) {
          var topRightBevelPt = rotate(topIntersectionX, top);
          path.lineTo(topRightBevelPt.x, topRightBevelPt.y);
        }
        path.arc(0, 0, axisOuterRadius, Math.atan2(top, topIntersectionX) + pointRotation, Math.atan2(sideIntersectionY, right) + pointRotation, false);
      } else {
        var _topLeftPt = rotate(left, top);
        var topRightPt = rotate(right, top);
        path.lineTo(_topLeftPt.x, _topLeftPt.y);
        path.lineTo(topRightPt.x, topRightPt.y);
      }
      var bottomRightPt = rotate(right, bottom);
      path.lineTo(bottomRightPt.x, bottomRightPt.y);
      if (shouldConnectBottomCircle) {
        path.arc(0, 0, innerRadius, _normalizeAngle2(sideRotation - Math.PI / 2) + pointRotation, _normalizeAngle2(-sideRotation - Math.PI / 2) + pointRotation, true);
      } else {
        var rotatedBottomLeftPt = rotate(left, bottom);
        path.lineTo(rotatedBottomLeftPt.x, rotatedBottomLeftPt.y);
      }
      path.closePath();
    }
  }]);
  return _RadialColumnShape;
}(_Path6);
_RadialColumnShape.className = "RadialColumnShape";
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "isBeveled", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "columnWidth", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "startAngle", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "endAngle", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "outerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "innerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "axisInnerRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "axisOuterRadius", 2);
__decorateClass([_ScenePathChangeDetection()], _RadialColumnShape.prototype, "isRadiusAxisReversed", 2);
function _getRadialColumnWidth(startAngle, endAngle, axisOuterRadius, columnWidthRatio, maxColumnWidthRatio) {
  var rotation = _angleBetween(startAngle, endAngle);
  var pad2 = rotation * (1 - columnWidthRatio) / 2;
  startAngle += pad2;
  endAngle -= pad2;
  if (rotation < 1e-3) {
    return 2 * axisOuterRadius * maxColumnWidthRatio;
  }
  if (rotation >= 2 * Math.PI) {
    var midAngle = startAngle + rotation / 2;
    startAngle = midAngle - Math.PI;
    endAngle = midAngle + Math.PI;
  }
  var startX = axisOuterRadius * Math.cos(startAngle);
  var startY = axisOuterRadius * Math.sin(startAngle);
  var endX = axisOuterRadius * Math.cos(endAngle);
  var endY = axisOuterRadius * Math.sin(endAngle);
  var colWidth = Math.floor(Math.sqrt(__pow(startX - endX, 2) + __pow(startY - endY, 2)));
  var maxWidth = 2 * axisOuterRadius * maxColumnWidthRatio;
  return Math.max(1, Math.min(maxWidth, colWidth));
}

// packages/ag-charts-community/src/scene/image.ts
var _Image = /*#__PURE__*/function (_Node5) {
  _inherits(_Image, _Node5);
  function _Image(sourceImage) {
    var _this261;
    _classCallCheck(this, _Image);
    _this261 = _possibleConstructorReturn(this, _getPrototypeOf(_Image).call(this));
    _this261.x = 0;
    _this261.y = 0;
    _this261.width = 0;
    _this261.height = 0;
    _this261.opacity = 1;
    _this261.sourceImage = sourceImage;
    return _this261;
  }
  _createClass(_Image, [{
    key: "render",
    value: function render(renderCtx) {
      var ctx = renderCtx.ctx,
        forceRender = renderCtx.forceRender,
        stats = renderCtx.stats;
      if (this.dirty === 0 /* NONE */ && !forceRender) {
        if (stats) stats.nodesSkipped++;
        return;
      }
      this.computeTransformMatrix();
      this.matrix.toContext(ctx);
      var image = this.sourceImage;
      ctx.globalAlpha = this.opacity;
      ctx.drawImage(image, 0, 0, image.width, image.height, this.x, this.y, this.width, this.height);
      _superPropGet(_Image, "render", this, 3)([renderCtx]);
    }
  }]);
  return _Image;
}(_Node4);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Image.prototype, "x", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Image.prototype, "y", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Image.prototype, "width", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Image.prototype, "height", 2);
__decorateClass([_SceneChangeDetection({
  redraw: 3 /* MAJOR */
})], _Image.prototype, "opacity", 2);

// packages/ag-charts-community/src/integrated-charts-scene.ts
var _motion = __spreadValues(__spreadValues({}, fromToMotion_exports), resetMotion_exports);

// packages/ag-charts-community/src/integrated-charts-theme.ts
var integrated_charts_theme_exports = {};
__export(integrated_charts_theme_exports, {
  CARTESIAN_AXIS_TYPE: function CARTESIAN_AXIS_TYPE() {
    return _CARTESIAN_AXIS_TYPE;
  },
  ChartTheme: function ChartTheme() {
    return _ChartTheme7;
  },
  DEFAULT_ANNOTATION_BACKGROUND_FILL: function DEFAULT_ANNOTATION_BACKGROUND_FILL() {
    return _DEFAULT_ANNOTATION_BACKGROUND_FILL;
  },
  DEFAULT_ANNOTATION_HANDLE_FILL: function DEFAULT_ANNOTATION_HANDLE_FILL() {
    return _DEFAULT_ANNOTATION_HANDLE_FILL;
  },
  DEFAULT_ANNOTATION_STROKE: function DEFAULT_ANNOTATION_STROKE() {
    return _DEFAULT_ANNOTATION_STROKE;
  },
  DEFAULT_AXIS_GRID_COLOUR: function DEFAULT_AXIS_GRID_COLOUR() {
    return _DEFAULT_AXIS_GRID_COLOUR;
  },
  DEFAULT_AXIS_LINE_COLOUR: function DEFAULT_AXIS_LINE_COLOUR() {
    return _DEFAULT_AXIS_LINE_COLOUR;
  },
  DEFAULT_BACKGROUND_COLOUR: function DEFAULT_BACKGROUND_COLOUR() {
    return _DEFAULT_BACKGROUND_COLOUR;
  },
  DEFAULT_COLOURS: function DEFAULT_COLOURS() {
    return _DEFAULT_COLOURS;
  },
  DEFAULT_CROSS_LINES_COLOUR: function DEFAULT_CROSS_LINES_COLOUR() {
    return _DEFAULT_CROSS_LINES_COLOUR;
  },
  DEFAULT_DIVERGING_SERIES_COLOUR_RANGE: function DEFAULT_DIVERGING_SERIES_COLOUR_RANGE() {
    return _DEFAULT_DIVERGING_SERIES_COLOUR_RANGE;
  },
  DEFAULT_FONT_FAMILY: function DEFAULT_FONT_FAMILY() {
    return _DEFAULT_FONT_FAMILY;
  },
  DEFAULT_HIERARCHY_FILLS: function DEFAULT_HIERARCHY_FILLS() {
    return _DEFAULT_HIERARCHY_FILLS;
  },
  DEFAULT_HIERARCHY_STROKES: function DEFAULT_HIERARCHY_STROKES() {
    return _DEFAULT_HIERARCHY_STROKES;
  },
  DEFAULT_INSIDE_SERIES_LABEL_COLOUR: function DEFAULT_INSIDE_SERIES_LABEL_COLOUR() {
    return _DEFAULT_INSIDE_SERIES_LABEL_COLOUR;
  },
  DEFAULT_INVERTED_LABEL_COLOUR: function DEFAULT_INVERTED_LABEL_COLOUR() {
    return _DEFAULT_INVERTED_LABEL_COLOUR;
  },
  DEFAULT_LABEL_COLOUR: function DEFAULT_LABEL_COLOUR() {
    return _DEFAULT_LABEL_COLOUR;
  },
  DEFAULT_MUTED_LABEL_COLOUR: function DEFAULT_MUTED_LABEL_COLOUR() {
    return _DEFAULT_MUTED_LABEL_COLOUR;
  },
  DEFAULT_POLAR_SERIES_STROKE: function DEFAULT_POLAR_SERIES_STROKE() {
    return _DEFAULT_POLAR_SERIES_STROKE;
  },
  DEFAULT_SHADOW_COLOUR: function DEFAULT_SHADOW_COLOUR() {
    return _DEFAULT_SHADOW_COLOUR;
  },
  DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE: function DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE() {
    return _DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE;
  },
  DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS: function DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS() {
    return _DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS;
  },
  DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS: function DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS() {
    return _DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS;
  },
  DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS: function DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS() {
    return _DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS;
  },
  EXTENDS_AXES_DEFAULTS: function EXTENDS_AXES_DEFAULTS() {
    return _EXTENDS_AXES_DEFAULTS;
  },
  EXTENDS_AXES_GRID_LINE_DEFAULTS: function EXTENDS_AXES_GRID_LINE_DEFAULTS() {
    return _EXTENDS_AXES_GRID_LINE_DEFAULTS;
  },
  EXTENDS_AXES_LINE_DEFAULTS: function EXTENDS_AXES_LINE_DEFAULTS() {
    return _EXTENDS_AXES_LINE_DEFAULTS;
  },
  EXTENDS_AXES_TICK_DEFAULTS: function EXTENDS_AXES_TICK_DEFAULTS() {
    return _EXTENDS_AXES_TICK_DEFAULTS;
  },
  EXTENDS_CARTESIAN_MARKER_DEFAULTS: function EXTENDS_CARTESIAN_MARKER_DEFAULTS() {
    return _EXTENDS_CARTESIAN_MARKER_DEFAULTS;
  },
  EXTENDS_SERIES_DEFAULTS: function EXTENDS_SERIES_DEFAULTS() {
    return _EXTENDS_SERIES_DEFAULTS;
  },
  FONT_SIZE: function FONT_SIZE() {
    return _FONT_SIZE;
  },
  FONT_WEIGHT: function FONT_WEIGHT() {
    return _FONT_WEIGHT;
  },
  IS_DARK_THEME: function IS_DARK_THEME() {
    return _IS_DARK_THEME;
  },
  POLAR_AXIS_SHAPE: function POLAR_AXIS_SHAPE() {
    return _POLAR_AXIS_SHAPE;
  },
  POLAR_AXIS_TYPE: function POLAR_AXIS_TYPE() {
    return _POLAR_AXIS_TYPE;
  },
  POSITION: function POSITION() {
    return _POSITION;
  },
  getChartTheme: function getChartTheme() {
    return _getChartTheme;
  },
  markerPaletteFactory: function markerPaletteFactory() {
    return _markerPaletteFactory3;
  },
  singleSeriesPaletteFactory: function singleSeriesPaletteFactory() {
    return _singleSeriesPaletteFactory;
  },
  themes: function themes() {
    return themes2;
  }
});
var themes2 = _mapValues(themes, function (themeFactory) {
  return themeFactory == null ? void 0 : themeFactory();
});

// packages/ag-charts-community/src/sparklines-scale.ts
var sparklines_scale_exports = {};
__export(sparklines_scale_exports, {
  BandScale: function BandScale() {
    return _BandScale3;
  },
  ColorScale: function ColorScale() {
    return _ColorScale;
  },
  ContinuousScale: function ContinuousScale() {
    return _ContinuousScale5;
  },
  Invalidating: function Invalidating() {
    return _Invalidating;
  },
  LinearScale: function LinearScale() {
    return _LinearScale;
  },
  OrdinalTimeScale: function OrdinalTimeScale() {
    return _OrdinalTimeScale2;
  },
  TimeScale: function TimeScale() {
    return _TimeScale2;
  }
});

// packages/ag-charts-community/src/sparklines-util.ts
var sparklines_util_exports = {};
__export(sparklines_util_exports, {
  Color: function Color() {
    return _Color2;
  },
  Logger: function Logger() {
    return _Logger;
  },
  Padding: function Padding() {
    return _Padding;
  },
  angleBetween: function angleBetween() {
    return _angleBetween;
  },
  areArrayItemsStrictlyEqual: function areArrayItemsStrictlyEqual() {
    return _areArrayItemsStrictlyEqual;
  },
  areArrayNumbersEqual: function areArrayNumbersEqual() {
    return _areArrayNumbersEqual;
  },
  bifurcate: function bifurcate() {
    return _bifurcate;
  },
  checkDatum: function checkDatum() {
    return _checkDatum;
  },
  clamp: function clamp() {
    return _clamp;
  },
  clampArray: function clampArray() {
    return _clampArray;
  },
  countFractionDigits: function countFractionDigits() {
    return _countFractionDigits;
  },
  createId: function createId() {
    return _createId;
  },
  deepClone: function deepClone() {
    return _deepClone2;
  },
  displacePointFromVector: function displacePointFromVector() {
    return _displacePointFromVector;
  },
  extent: function extent() {
    return _extent;
  },
  findMinMax: function findMinMax() {
    return _findMinMax17;
  },
  findRangeExtent: function findRangeExtent() {
    return _findRangeExtent;
  },
  isBetweenAngles: function isBetweenAngles() {
    return _isBetweenAngles;
  },
  isContinuous: function isContinuous() {
    return _isContinuous;
  },
  isDate: function isDate() {
    return _isValidDate;
  },
  isDenseInterval: function isDenseInterval() {
    return _isDenseInterval;
  },
  isEqual: function isEqual() {
    return _isEqual;
  },
  isNegative: function isNegative() {
    return _isNegative;
  },
  isNumber: function isNumber() {
    return _isFiniteNumber;
  },
  isNumberEqual: function isNumberEqual() {
    return _isEqual;
  },
  isNumberObject: function isNumberObject() {
    return _isNumberObject;
  },
  isString: function isString() {
    return _isString;
  },
  isStringObject: function isStringObject() {
    return _isStringObject;
  },
  jsonApply: function jsonApply() {
    return _jsonApply;
  },
  jsonDiff: function jsonDiff() {
    return _jsonDiff;
  },
  jsonWalk: function jsonWalk() {
    return _jsonWalk;
  },
  mod: function mod() {
    return _mod;
  },
  normalisedExtent: function normalisedExtent() {
    return _normalisedExtent;
  },
  normalisedExtentWithMetadata: function normalisedExtentWithMetadata() {
    return _normalisedExtentWithMetadata;
  },
  normalizeAngle180: function normalizeAngle180() {
    return _normalizeAngle;
  },
  normalizeAngle360: function normalizeAngle360() {
    return _normalizeAngle2;
  },
  normalizeAngle360Inclusive: function normalizeAngle360Inclusive() {
    return _normalizeAngle360Inclusive;
  },
  range: function range() {
    return _range4;
  },
  resetIds: function resetIds() {
    return _resetIds;
  },
  round: function round() {
    return _round;
  },
  sanitizeHtml: function sanitizeHtml() {
    return _sanitizeHtml;
  },
  setAttribute: function setAttribute() {
    return _setAttribute;
  },
  shallowClone: function shallowClone() {
    return _shallowClone;
  },
  tickFormat: function tickFormat() {
    return _tickFormat;
  },
  tickStep: function tickStep() {
    return _tickStep;
  },
  ticks: function ticks() {
    return ticks_default;
  },
  toDegrees: function toDegrees() {
    return _toDegrees;
  },
  toFixed: function toFixed() {
    return _toFixed;
  },
  toRadians: function toRadians() {
    return _toRadians;
  },
  transformIntegratedCategoryValue: function transformIntegratedCategoryValue() {
    return _transformIntegratedCategoryValue;
  },
  zipObject: function zipObject() {
    return _zipObject;
  }
});

// packages/ag-charts-community/src/util/zip.ts
function _zipObject(keys, values) {
  var zipped = {};
  if (Array.isArray(values)) {
    for (var i = 0; i < keys.length; i++) {
      zipped["".concat(keys[i])] = values[i];
    }
  } else {
    for (var _i50 = 0; _i50 < keys.length; _i50++) {
      zipped["".concat(keys[_i50])] = values;
    }
  }
  return zipped;
}

// packages/ag-charts-community/src/module-support.ts
var module_support_exports = {};
__export(module_support_exports, {
  AND: function AND() {
    return _AND;
  },
  ARRAY: function ARRAY() {
    return _ARRAY;
  },
  ARRAY_OF: function ARRAY_OF() {
    return _ARRAY_OF;
  },
  AbstractBarSeries: function AbstractBarSeries() {
    return _AbstractBarSeries2;
  },
  AbstractBarSeriesProperties: function AbstractBarSeriesProperties() {
    return _AbstractBarSeriesProperties;
  },
  ActionOnSet: function ActionOnSet() {
    return _ActionOnSet;
  },
  Animation: function Animation() {
    return _Animation;
  },
  AnimationManager: function AnimationManager() {
    return _AnimationManager;
  },
  AreaSeriesTag: function AreaSeriesTag() {
    return _AreaSeriesTag;
  },
  Axis: function Axis() {
    return _Axis4;
  },
  AxisLabel: function AxisLabel() {
    return _AxisLabel3;
  },
  AxisTick: function AxisTick() {
    return _AxisTick4;
  },
  BOOLEAN: function BOOLEAN() {
    return _BOOLEAN;
  },
  BOOLEAN_ARRAY: function BOOLEAN_ARRAY() {
    return _BOOLEAN_ARRAY;
  },
  Background: function Background() {
    return _Background;
  },
  BackgroundModule: function BackgroundModule() {
    return _BackgroundModule;
  },
  BaseModuleInstance: function BaseModuleInstance() {
    return _BaseModuleInstance4;
  },
  BaseProperties: function BaseProperties() {
    return _BaseProperties35;
  },
  COLOR_STRING: function COLOR_STRING() {
    return _COLOR_STRING;
  },
  COLOR_STRING_ARRAY: function COLOR_STRING_ARRAY() {
    return _COLOR_STRING_ARRAY;
  },
  CartesianAxis: function CartesianAxis() {
    return _CartesianAxis6;
  },
  CartesianSeries: function CartesianSeries() {
    return _CartesianSeries7;
  },
  CartesianSeriesNodeEvent: function CartesianSeriesNodeEvent() {
    return _CartesianSeriesNodeEvent;
  },
  CartesianSeriesProperties: function CartesianSeriesProperties() {
    return _CartesianSeriesProperties;
  },
  CategoryAxis: function CategoryAxis() {
    return _CategoryAxis;
  },
  CategoryAxisTick: function CategoryAxisTick() {
    return _CategoryAxisTick;
  },
  ChartAxisDirection: function ChartAxisDirection() {
    return _ChartAxisDirection;
  },
  ChartEventManager: function ChartEventManager() {
    return _ChartEventManager;
  },
  ChartOptions: function ChartOptions() {
    return _ChartOptions;
  },
  ChartUpdateType: function ChartUpdateType() {
    return _ChartUpdateType;
  },
  ContextMenuRegistry: function ContextMenuRegistry() {
    return _ContextMenuRegistry;
  },
  CursorManager: function CursorManager() {
    return _CursorManager;
  },
  DATE: function DATE() {
    return _DATE;
  },
  DATE_ARRAY: function DATE_ARRAY() {
    return _DATE_ARRAY;
  },
  DATE_OR_DATETIME_MS: function DATE_OR_DATETIME_MS() {
    return _DATE_OR_DATETIME_MS;
  },
  DEFAULT_CARTESIAN_DIRECTION_KEYS: function DEFAULT_CARTESIAN_DIRECTION_KEYS() {
    return _DEFAULT_CARTESIAN_DIRECTION_KEYS;
  },
  DEFAULT_CARTESIAN_DIRECTION_NAMES: function DEFAULT_CARTESIAN_DIRECTION_NAMES() {
    return _DEFAULT_CARTESIAN_DIRECTION_NAMES;
  },
  DEFAULT_TOOLTIP_CLASS: function DEFAULT_TOOLTIP_CLASS() {
    return _DEFAULT_TOOLTIP_CLASS;
  },
  DEFAULT_TOOLTIP_DARK_CLASS: function DEFAULT_TOOLTIP_DARK_CLASS() {
    return _DEFAULT_TOOLTIP_DARK_CLASS;
  },
  DEGREE: function DEGREE() {
    return _DEGREE;
  },
  DIRECTION: function DIRECTION() {
    return _DIRECTION;
  },
  DataController: function DataController() {
    return _DataController2;
  },
  DataModel: function DataModel() {
    return _DataModel;
  },
  DataModelSeries: function DataModelSeries() {
    return _DataModelSeries3;
  },
  DataService: function DataService() {
    return _DataService;
  },
  Default: function Default() {
    return _Default;
  },
  Deprecated: function Deprecated() {
    return _Deprecated;
  },
  DeprecatedAndRenamedTo: function DeprecatedAndRenamedTo() {
    return _DeprecatedAndRenamedTo;
  },
  EMPTY_TOOLTIP_CONTENT: function EMPTY_TOOLTIP_CONTENT() {
    return _EMPTY_TOOLTIP_CONTENT;
  },
  FONT_STYLE: function FONT_STYLE() {
    return _FONT_STYLE;
  },
  FONT_WEIGHT: function FONT_WEIGHT() {
    return FONT_WEIGHT2;
  },
  FUNCTION: function FUNCTION() {
    return _FUNCTION;
  },
  GREATER_THAN: function GREATER_THAN() {
    return _GREATER_THAN;
  },
  GestureDetector: function GestureDetector() {
    return _GestureDetector;
  },
  GroupedCategoryAxis: function GroupedCategoryAxis() {
    return _GroupedCategoryAxis;
  },
  HierarchyNode: function HierarchyNode() {
    return _HierarchyNode2;
  },
  HierarchySeries: function HierarchySeries() {
    return _HierarchySeries;
  },
  HierarchySeriesProperties: function HierarchySeriesProperties() {
    return _HierarchySeriesProperties;
  },
  HighlightManager: function HighlightManager() {
    return _HighlightManager;
  },
  HighlightStyle: function HighlightStyle() {
    return _HighlightStyle;
  },
  INTERACTION_RANGE: function INTERACTION_RANGE() {
    return _INTERACTION_RANGE;
  },
  InteractionManager: function InteractionManager() {
    return _InteractionManager2;
  },
  InteractionState: function InteractionState() {
    return _InteractionState;
  },
  LABEL_PLACEMENT: function LABEL_PLACEMENT() {
    return _LABEL_PLACEMENT;
  },
  LESS_THAN: function LESS_THAN() {
    return _LESS_THAN;
  },
  LINE_CAP: function LINE_CAP() {
    return _LINE_CAP;
  },
  LINE_DASH: function LINE_DASH() {
    return _LINE_DASH;
  },
  LINE_JOIN: function LINE_JOIN() {
    return _LINE_JOIN;
  },
  Layers: function Layers() {
    return _Layers;
  },
  LayoutService: function LayoutService() {
    return _LayoutService;
  },
  LonLatBBox: function LonLatBBox() {
    return _LonLatBBox;
  },
  MARKER_SHAPE: function MARKER_SHAPE() {
    return _MARKER_SHAPE;
  },
  MATCHING_CROSSLINE_TYPE: function MATCHING_CROSSLINE_TYPE() {
    return _MATCHING_CROSSLINE_TYPE;
  },
  MAX_SPACING: function MAX_SPACING() {
    return _MAX_SPACING;
  },
  MIN_SPACING: function MIN_SPACING() {
    return _MIN_SPACING;
  },
  MercatorScale: function MercatorScale() {
    return _MercatorScale2;
  },
  Motion: function Motion() {
    return easing_exports;
  },
  NAN: function NAN() {
    return _NAN;
  },
  NODE_UPDATE_STATE_TO_PHASE_MAPPING: function NODE_UPDATE_STATE_TO_PHASE_MAPPING() {
    return _NODE_UPDATE_STATE_TO_PHASE_MAPPING;
  },
  NUMBER: function NUMBER() {
    return _NUMBER;
  },
  NUMBER_ARRAY: function NUMBER_ARRAY() {
    return _NUMBER_ARRAY;
  },
  NUMBER_OR_NAN: function NUMBER_OR_NAN() {
    return _NUMBER_OR_NAN;
  },
  Navigator: function Navigator() {
    return _Navigator;
  },
  NavigatorModule: function NavigatorModule() {
    return _NavigatorModule;
  },
  OBJECT: function OBJECT() {
    return _OBJECT;
  },
  OBJECT_ARRAY: function OBJECT_ARRAY() {
    return _OBJECT_ARRAY;
  },
  OR: function OR() {
    return _OR;
  },
  OVERFLOW_STRATEGY: function OVERFLOW_STRATEGY() {
    return _OVERFLOW_STRATEGY;
  },
  ObserveChanges: function ObserveChanges() {
    return _ObserveChanges;
  },
  PHASE_METADATA: function PHASE_METADATA() {
    return _PHASE_METADATA;
  },
  PHASE_ORDER: function PHASE_ORDER() {
    return _PHASE_ORDER;
  },
  PLACEMENT: function PLACEMENT() {
    return _PLACEMENT;
  },
  PLAIN_OBJECT: function PLAIN_OBJECT() {
    return _PLAIN_OBJECT;
  },
  POINTER_INTERACTION_TYPES: function POINTER_INTERACTION_TYPES() {
    return _POINTER_INTERACTION_TYPES;
  },
  POSITION: function POSITION() {
    return POSITION2;
  },
  POSITIVE_NUMBER: function POSITIVE_NUMBER() {
    return _POSITIVE_NUMBER;
  },
  PolarAxis: function PolarAxis() {
    return _PolarAxis;
  },
  PolarSeries: function PolarSeries() {
    return _PolarSeries3;
  },
  PropertiesArray: function PropertiesArray() {
    return _PropertiesArray2;
  },
  ProxyOnWrite: function ProxyOnWrite() {
    return _ProxyOnWrite;
  },
  ProxyProperty: function ProxyProperty() {
    return _ProxyProperty;
  },
  ProxyPropertyOnWrite: function ProxyPropertyOnWrite() {
    return _ProxyPropertyOnWrite;
  },
  QUICK_TRANSITION: function QUICK_TRANSITION() {
    return _QUICK_TRANSITION;
  },
  RATIO: function RATIO() {
    return _RATIO;
  },
  RepeatType: function RepeatType() {
    return _RepeatType;
  },
  SKIP_JS_BUILTINS: function SKIP_JS_BUILTINS() {
    return _SKIP_JS_BUILTINS;
  },
  SMALLEST_KEY_INTERVAL: function SMALLEST_KEY_INTERVAL() {
    return _SMALLEST_KEY_INTERVAL;
  },
  SORT_DOMAIN_GROUPS: function SORT_DOMAIN_GROUPS() {
    return _SORT_DOMAIN_GROUPS;
  },
  STRING: function STRING() {
    return _STRING;
  },
  STRING_ARRAY: function STRING_ARRAY() {
    return _STRING_ARRAY;
  },
  Series: function Series() {
    return _Series2;
  },
  SeriesGroupingChangedEvent: function SeriesGroupingChangedEvent() {
    return _SeriesGroupingChangedEvent;
  },
  SeriesItemHighlightStyle: function SeriesItemHighlightStyle() {
    return _SeriesItemHighlightStyle;
  },
  SeriesMarker: function SeriesMarker() {
    return _SeriesMarker2;
  },
  SeriesNodeEvent: function SeriesNodeEvent() {
    return _SeriesNodeEvent4;
  },
  SeriesNodePickMode: function SeriesNodePickMode() {
    return _SeriesNodePickMode;
  },
  SeriesProperties: function SeriesProperties() {
    return _SeriesProperties4;
  },
  SeriesTooltip: function SeriesTooltip() {
    return _SeriesTooltip;
  },
  StateMachine: function StateMachine() {
    return _StateMachine;
  },
  TEXT_ALIGN: function TEXT_ALIGN() {
    return _TEXT_ALIGN;
  },
  TEXT_WRAP: function TEXT_WRAP() {
    return _TEXT_WRAP;
  },
  ToolbarManager: function ToolbarManager() {
    return _ToolbarManager;
  },
  Tooltip: function Tooltip() {
    return _Tooltip;
  },
  TooltipManager: function TooltipManager() {
    return _TooltipManager;
  },
  TooltipPosition: function TooltipPosition() {
    return _TooltipPosition;
  },
  UNION: function UNION() {
    return _UNION;
  },
  UpdateService: function UpdateService() {
    return _UpdateService;
  },
  VERTICAL_ALIGN: function VERTICAL_ALIGN() {
    return _VERTICAL_ALIGN;
  },
  Validate: function Validate() {
    return _Validate;
  },
  ZoomManager: function ZoomManager() {
    return _ZoomManager;
  },
  __FORCE_MODULE_DETECTION: function __FORCE_MODULE_DETECTION() {
    return __FORCE_MODULE_DETECTION2;
  },
  accumulateGroup: function accumulateGroup() {
    return _accumulateGroup;
  },
  accumulatedValue: function accumulatedValue() {
    return _accumulatedValue;
  },
  accumulativeValueProperty: function accumulativeValueProperty() {
    return _accumulativeValueProperty;
  },
  addHitTestersToQuadtree: function addHitTestersToQuadtree() {
    return _addHitTestersToQuadtree;
  },
  adjustLabelPlacement: function adjustLabelPlacement() {
    return _adjustLabelPlacement;
  },
  allInStringUnion: function allInStringUnion() {
    return _allInStringUnion;
  },
  animationValidation: function animationValidation() {
    return _animationValidation;
  },
  area: function area() {
    return _area;
  },
  arraysEqual: function arraysEqual() {
    return _arraysEqual;
  },
  assignJsonApplyConstructedArray: function assignJsonApplyConstructedArray() {
    return _assignJsonApplyConstructedArray;
  },
  backfillPathPointData: function backfillPathPointData() {
    return _backfillPathPointData;
  },
  basicContinuousCheckDatumValidation: function basicContinuousCheckDatumValidation() {
    return _basicContinuousCheckDatumValidation;
  },
  bifurcate: function bifurcate() {
    return _bifurcate;
  },
  buildFormatter: function buildFormatter() {
    return _buildFormatter;
  },
  buildResetPathFn: function buildResetPathFn() {
    return _buildResetPathFn;
  },
  calculateDefaultTimeTickFormat: function calculateDefaultTimeTickFormat() {
    return _calculateDefaultTimeTickFormat;
  },
  calculatePlacement: function calculatePlacement() {
    return _calculatePlacement;
  },
  checkCrisp: function checkCrisp() {
    return _checkCrisp;
  },
  childrenIter: function childrenIter() {
    return _childrenIter;
  },
  circularSliceArray: function circularSliceArray() {
    return _circularSliceArray;
  },
  clamp: function clamp() {
    return _clamp;
  },
  clampArray: function clampArray() {
    return _clampArray;
  },
  collapsedStartingBarPosition: function collapsedStartingBarPosition() {
    return _collapsedStartingBarPosition;
  },
  computeBarFocusBounds: function computeBarFocusBounds() {
    return _computeBarFocusBounds;
  },
  computeMarkerFocusBounds: function computeMarkerFocusBounds() {
    return _computeMarkerFocusBounds;
  },
  computeSectorFocusBounds: function computeSectorFocusBounds() {
    return _computeSectorFocusBounds;
  },
  convertValuesToScaleByDefs: function convertValuesToScaleByDefs() {
    return _convertValuesToScaleByDefs;
  },
  countFractionDigits: function countFractionDigits() {
    return _countFractionDigits;
  },
  createDatumId: function createDatumId() {
    return _createDatumId;
  },
  createDeprecationWarning: function createDeprecationWarning() {
    return _createDeprecationWarning;
  },
  createElement: function createElement() {
    return _createElement;
  },
  dateToNumber: function dateToNumber() {
    return _dateToNumber;
  },
  deconstructSelectionsOrNodes: function deconstructSelectionsOrNodes() {
    return _deconstructSelectionsOrNodes;
  },
  deepClone: function deepClone() {
    return _deepClone2;
  },
  deepMerge: function deepMerge() {
    return _deepMerge;
  },
  defaultTimeTickFormat: function defaultTimeTickFormat() {
    return _defaultTimeTickFormat;
  },
  determinePathStatus: function determinePathStatus() {
    return _determinePathStatus;
  },
  diff: function diff() {
    return _diff;
  },
  downloadUrl: function downloadUrl() {
    return _downloadUrl;
  },
  enterpriseModule: function enterpriseModule() {
    return _enterpriseModule;
  },
  extent: function extent() {
    return _extent;
  },
  extractDecoratedProperties: function extractDecoratedProperties() {
    return _extractDecoratedProperties;
  },
  findMinMax: function findMinMax() {
    return _findMinMax17;
  },
  findQuadtreeMatch: function findQuadtreeMatch() {
    return _findQuadtreeMatch;
  },
  findRangeExtent: function findRangeExtent() {
    return _findRangeExtent;
  },
  fixNumericExtent: function fixNumericExtent() {
    return _fixNumericExtent;
  },
  fromToMotion: function fromToMotion() {
    return _fromToMotion;
  },
  getDocument: function getDocument() {
    return _getDocument2;
  },
  getMissCount: function getMissCount() {
    return _getMissCount;
  },
  getPath: function getPath() {
    return _getPath;
  },
  getRectConfig: function getRectConfig() {
    return _getRectConfig;
  },
  getWindow: function getWindow() {
    return _getWindow2;
  },
  groupAccumulativeValueProperty: function groupAccumulativeValueProperty() {
    return _groupAccumulativeValueProperty;
  },
  groupAverage: function groupAverage() {
    return _groupAverage;
  },
  groupBy: function groupBy() {
    return _groupBy2;
  },
  groupCount: function groupCount() {
    return _groupCount;
  },
  groupSum: function groupSum() {
    return _groupSum;
  },
  injectStyle: function injectStyle() {
    return _injectStyle;
  },
  isArray: function isArray() {
    return _isArray;
  },
  isBoolean: function isBoolean() {
    return _isBoolean;
  },
  isDate: function isDate() {
    return _isDate;
  },
  isDecoratedObject: function isDecoratedObject() {
    return _isDecoratedObject;
  },
  isDefined: function isDefined() {
    return _isDefined;
  },
  isEnumKey: function isEnumKey() {
    return _isEnumKey;
  },
  isEnumValue: function isEnumValue() {
    return _isEnumValue;
  },
  isEqual: function isEqual() {
    return _isEqual;
  },
  isFiniteNumber: function isFiniteNumber() {
    return _isFiniteNumber;
  },
  isFunction: function isFunction() {
    return _isFunction;
  },
  isHtmlElement: function isHtmlElement() {
    return _isHtmlElement;
  },
  isNegative: function isNegative() {
    return _isNegative;
  },
  isNumber: function isNumber() {
    return _isNumber;
  },
  isObject: function isObject() {
    return _isObject;
  },
  isObjectLike: function isObjectLike() {
    return _isObjectLike;
  },
  isPlainObject: function isPlainObject() {
    return _isPlainObject;
  },
  isProperties: function isProperties() {
    return _isProperties;
  },
  isRegExp: function isRegExp() {
    return _isRegExp;
  },
  isString: function isString() {
    return _isString;
  },
  isSymbol: function isSymbol() {
    return _isSymbol;
  },
  isValidDate: function isValidDate() {
    return _isValidDate;
  },
  jsonApply: function jsonApply() {
    return _jsonApply;
  },
  jsonDiff: function jsonDiff() {
    return _jsonDiff;
  },
  jsonWalk: function jsonWalk() {
    return _jsonWalk;
  },
  keyProperty: function keyProperty() {
    return _keyProperty;
  },
  listDecoratedProperties: function listDecoratedProperties() {
    return _listDecoratedProperties;
  },
  mapIterable: function mapIterable() {
    return _mapIterable;
  },
  mapValues: function mapValues() {
    return _mapValues;
  },
  markerFadeInAnimation: function markerFadeInAnimation() {
    return _markerFadeInAnimation;
  },
  markerPaletteFactory: function markerPaletteFactory() {
    return _markerPaletteFactory3;
  },
  markerScaleInAnimation: function markerScaleInAnimation() {
    return _markerScaleInAnimation;
  },
  markerSwipeScaleInAnimation: function markerSwipeScaleInAnimation() {
    return _markerSwipeScaleInAnimation;
  },
  mergeArrayDefaults: function mergeArrayDefaults() {
    return _mergeArrayDefaults;
  },
  mergeDefaults: function mergeDefaults() {
    return _mergeDefaults4;
  },
  midpointStartingBarPosition: function midpointStartingBarPosition() {
    return _midpointStartingBarPosition;
  },
  minMax: function minMax() {
    return _minMax3;
  },
  mod: function mod() {
    return _mod;
  },
  moduleRegistry: function moduleRegistry() {
    return _moduleRegistry;
  },
  normaliseGroupTo: function normaliseGroupTo() {
    return _normaliseGroupTo;
  },
  normalisePropertyTo: function normalisePropertyTo() {
    return _normalisePropertyTo;
  },
  normalisedExtent: function normalisedExtent() {
    return _normalisedExtent;
  },
  normalisedExtentWithMetadata: function normalisedExtentWithMetadata() {
    return _normalisedExtentWithMetadata;
  },
  pairCategoryData: function pairCategoryData() {
    return _pairCategoryData;
  },
  pairContinuousData: function pairContinuousData() {
    return _pairContinuousData;
  },
  partialAssign: function partialAssign() {
    return _partialAssign;
  },
  pathFadeInAnimation: function pathFadeInAnimation() {
    return _pathFadeInAnimation;
  },
  pathFadeOutAnimation: function pathFadeOutAnimation() {
    return _pathFadeOutAnimation;
  },
  pathSwipeInAnimation: function pathSwipeInAnimation() {
    return _pathSwipeInAnimation;
  },
  pickByMatchingAngle: function pickByMatchingAngle() {
    return _pickByMatchingAngle;
  },
  predicateWithMessage: function predicateWithMessage() {
    return _predicateWithMessage;
  },
  prepareAreaPathAnimation: function prepareAreaPathAnimation() {
    return _prepareAreaPathAnimation;
  },
  prepareAxisAnimationContext: function prepareAxisAnimationContext() {
    return _prepareAxisAnimationContext;
  },
  prepareAxisAnimationFunctions: function prepareAxisAnimationFunctions() {
    return _prepareAxisAnimationFunctions;
  },
  prepareBarAnimationFunctions: function prepareBarAnimationFunctions() {
    return _prepareBarAnimationFunctions;
  },
  prepareLinePathAnimation: function prepareLinePathAnimation() {
    return _prepareLinePathAnimation;
  },
  prepareLinePathAnimationFns: function prepareLinePathAnimationFns() {
    return _prepareLinePathAnimationFns;
  },
  prepareMarkerAnimation: function prepareMarkerAnimation() {
    return _prepareMarkerAnimation;
  },
  preparePieSeriesAnimationFunctions: function preparePieSeriesAnimationFunctions() {
    return _preparePieSeriesAnimationFunctions;
  },
  range: function range() {
    return range2;
  },
  rangedValueProperty: function rangedValueProperty() {
    return _rangedValueProperty;
  },
  renderPartialPath: function renderPartialPath() {
    return _renderPartialPath;
  },
  resetAxisGroupFn: function resetAxisGroupFn() {
    return _resetAxisGroupFn;
  },
  resetAxisLabelSelectionFn: function resetAxisLabelSelectionFn() {
    return _resetAxisLabelSelectionFn;
  },
  resetAxisLineSelectionFn: function resetAxisLineSelectionFn() {
    return _resetAxisLineSelectionFn;
  },
  resetAxisSelectionFn: function resetAxisSelectionFn() {
    return _resetAxisSelectionFn;
  },
  resetBarSelectionsFn: function resetBarSelectionsFn() {
    return _resetBarSelectionsFn;
  },
  resetIds: function resetIds() {
    return _resetIds;
  },
  resetLabelFn: function resetLabelFn() {
    return _resetLabelFn;
  },
  resetMarkerFn: function resetMarkerFn() {
    return _resetMarkerFn;
  },
  resetMarkerPositionFn: function resetMarkerPositionFn() {
    return _resetMarkerPositionFn;
  },
  resetMotion: function resetMotion() {
    return _resetMotion;
  },
  resetPieSelectionsFn: function resetPieSelectionsFn() {
    return _resetPieSelectionsFn;
  },
  round: function round() {
    return _round;
  },
  seriesLabelFadeInAnimation: function seriesLabelFadeInAnimation() {
    return _seriesLabelFadeInAnimation;
  },
  seriesLabelFadeOutAnimation: function seriesLabelFadeOutAnimation() {
    return _seriesLabelFadeOutAnimation;
  },
  setDocument: function setDocument() {
    return _setDocument;
  },
  setPath: function setPath() {
    return _setPath;
  },
  setWindow: function setWindow() {
    return _setWindow;
  },
  shallowClone: function shallowClone() {
    return _shallowClone;
  },
  singleSeriesPaletteFactory: function singleSeriesPaletteFactory() {
    return _singleSeriesPaletteFactory;
  },
  staticFromToMotion: function staticFromToMotion() {
    return _staticFromToMotion;
  },
  stringify: function stringify() {
    return _stringify;
  },
  sum: function sum() {
    return _sum;
  },
  sumValues: function sumValues() {
    return _sumValues;
  },
  toArray: function toArray() {
    return _toArray2;
  },
  toFixed: function toFixed() {
    return _toFixed;
  },
  toTooltipHtml: function toTooltipHtml() {
    return _toTooltipHtml;
  },
  trailingAccumulatedValue: function trailingAccumulatedValue() {
    return _trailingAccumulatedValue;
  },
  trailingAccumulatedValueProperty: function trailingAccumulatedValueProperty() {
    return _trailingAccumulatedValueProperty;
  },
  unique: function unique() {
    return _unique;
  },
  updateClipPath: function updateClipPath() {
    return _updateClipPath;
  },
  updateLabelNode: function updateLabelNode() {
    return _updateLabelNode;
  },
  updateRect: function updateRect() {
    return _updateRect;
  },
  validateCrossLineValues: function validateCrossLineValues() {
    return _validateCrossLineValues;
  },
  valueProperty: function valueProperty() {
    return _valueProperty;
  },
  without: function without() {
    return _without;
  }
});

// packages/ag-charts-community/src/chart/series/util.ts
function _convertValuesToScaleByDefs(_ref193) {
  var defs = _ref193.defs,
    values = _ref193.values,
    xAxis = _ref193.xAxis,
    yAxis = _ref193.yAxis;
  if (!(xAxis && yAxis)) {
    throw new Error("Axes must be defined");
  }
  var result = {};
  var _iterator221 = _createForOfIteratorHelper(defs),
    _step221;
  try {
    for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
      var _step221$value = _slicedToArray(_step221.value, 2),
        searchId = _step221$value[0],
        def = _step221$value[1].def;
      if (Object.hasOwn(values, searchId)) {
        var _ref194 = def.type === "key" ? xAxis : yAxis,
          scale2 = _ref194.scale;
        result[searchId] = Math.round(scale2.convert(values[searchId]));
      }
    }
  } catch (err) {
    _iterator221.e(err);
  } finally {
    _iterator221.f();
  }
  return result;
}

// packages/ag-charts-community/src/chart/series/hierarchy/hierarchySeries.ts
var _HierarchyNode = /*#__PURE__*/function () {
  function _HierarchyNode(series, index, datum, size, colorValue, fill, stroke, sumSize, depth, parent, children) {
    _classCallCheck(this, _HierarchyNode);
    this.series = series;
    this.index = index;
    this.datum = datum;
    this.size = size;
    this.colorValue = colorValue;
    this.fill = fill;
    this.stroke = stroke;
    this.sumSize = sumSize;
    this.depth = depth;
    this.parent = parent;
    this.children = children;
    this.midPoint = {
      x: 0,
      y: 0
    };
  }
  _createClass(_HierarchyNode, [{
    key: "contains",
    value: function contains(other) {
      var current = other;
      while (current != null && current.index >= this.index) {
        if (current === this) {
          return true;
        }
        current = current.parent;
      }
      return false;
    }
  }, {
    key: "walk",
    value: function walk(callback) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _HierarchyNode.Walk.PreOrder;
      if (order === _HierarchyNode.Walk.PreOrder) {
        callback(this);
      }
      this.children.forEach(function (child) {
        child.walk(callback, order);
      });
      if (order === _HierarchyNode.Walk.PostOrder) {
        callback(this);
      }
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regenerator().m(function value() {
      var _iterator222, _step222, child, _t17;
      return _regenerator().w(function (_context115) {
        while (1) switch (_context115.p = _context115.n) {
          case 0:
            _context115.n = 1;
            return this;
          case 1:
            _iterator222 = _createForOfIteratorHelper(this.children);
            _context115.p = 2;
            _iterator222.s();
          case 3:
            if ((_step222 = _iterator222.n()).done) {
              _context115.n = 5;
              break;
            }
            child = _step222.value;
            return _context115.d(_regeneratorValues(__yieldStar(child)), 4);
          case 4:
            _context115.n = 3;
            break;
          case 5:
            _context115.n = 7;
            break;
          case 6:
            _context115.p = 6;
            _t17 = _context115.v;
            _iterator222.e(_t17);
          case 7:
            _context115.p = 7;
            _iterator222.f();
            return _context115.f(7);
          case 8:
            return _context115.a(2);
        }
      }, value, this, [[2, 6, 7, 8]]);
    })
  }]);
  return _HierarchyNode;
}();
_HierarchyNode.Walk = {
  PreOrder: 0,
  PostOrder: 1
};
var _HierarchyNode2 = _HierarchyNode;
var _HierarchySeries = /*#__PURE__*/function (_Series3) {
  _inherits(_HierarchySeries, _Series3);
  function _HierarchySeries(moduleCtx) {
    var _this262;
    _classCallCheck(this, _HierarchySeries);
    _this262 = _possibleConstructorReturn(this, _getPrototypeOf(_HierarchySeries).call(this, {
      moduleCtx: moduleCtx,
      pickModes: [0 /* EXACT_SHAPE_MATCH */],
      contentGroupVirtual: false
    }));
    _this262.rootNode = new _HierarchyNode2(_assertThisInitialized(_this262), 0, void 0, 0, void 0, void 0, void 0, 0, void 0, void 0, []);
    _this262.colorDomain = [0, 0];
    _this262.maxDepth = 0;
    _this262.animationState = new _StateMachine("empty", {
      empty: {
        update: {
          target: "ready",
          action: function action(data) {
            return _this262.animateEmptyUpdateReady(data);
          }
        },
        reset: "empty",
        skip: "ready"
      },
      ready: {
        updateData: "waiting",
        clear: "clearing",
        highlight: function highlight(data) {
          return _this262.animateReadyHighlight(data);
        },
        resize: function resize(data) {
          return _this262.animateReadyResize(data);
        },
        reset: "empty",
        skip: "ready"
      },
      waiting: {
        update: {
          target: "ready",
          action: function action(data) {
            return _this262.animateWaitingUpdateReady(data);
          }
        },
        reset: "empty",
        skip: "ready"
      },
      clearing: {
        update: {
          target: "empty",
          action: function action(data) {
            return _this262.animateClearingUpdateEmpty(data);
          }
        },
        reset: "empty",
        skip: "ready"
      }
    }, function () {
      return _this262.checkProcessedDataAnimatable();
    });
    return _this262;
  }
  _createClass(_HierarchySeries, [{
    key: "resetAnimation",
    value: function resetAnimation(phase) {
      if (phase === "initial") {
        this.animationState.transition("reset");
      } else if (phase === "ready") {
        this.animationState.transition("skip");
      }
    }
  }, {
    key: "processData",
    value: function processData() {
      return __async(this, null, /*#__PURE__*/_regenerator().m(function _callee104() {
        var _this263 = this;
        var _a, _b, _this$properties54, childrenKey, sizeKey, colorKey, fills, strokes, colorRange, index, getIndex, maxDepth, minColor, maxColor, colors, createNode, appendChildren, rootNode, colorDomain, colorScale;
        return _regenerator().w(function (_context116) {
          while (1) switch (_context116.n) {
            case 0:
              _this$properties54 = this.properties, childrenKey = _this$properties54.childrenKey, sizeKey = _this$properties54.sizeKey, colorKey = _this$properties54.colorKey, fills = _this$properties54.fills, strokes = _this$properties54.strokes, colorRange = _this$properties54.colorRange;
              index = 0;
              getIndex = function getIndex() {
                index += 1;
                return index;
              };
              maxDepth = 0;
              minColor = Infinity;
              maxColor = -Infinity;
              colors = new Array(((_b = (_a = this.data) == null ? void 0 : _a.length) != null ? _b : 0) + 1).fill(void 0);
              createNode = function createNode(datum, parent) {
                var nodeIndex = getIndex();
                var depth = parent.depth != null ? parent.depth + 1 : 0;
                var children = childrenKey != null ? datum[childrenKey] : void 0;
                var isLeaf = children == null || children.length === 0;
                var size = sizeKey != null ? datum[sizeKey] : void 0;
                if (Number.isFinite(size)) {
                  size = Math.max(size, 0);
                } else {
                  size = isLeaf ? 1 : 0;
                }
                var sumSize = size;
                maxDepth = Math.max(maxDepth, depth);
                var color = colorKey != null ? datum[colorKey] : void 0;
                if (typeof color === "number") {
                  colors[nodeIndex] = color;
                  minColor = Math.min(minColor, color);
                  maxColor = Math.max(maxColor, color);
                }
                return appendChildren(new _HierarchyNode2(_this263, nodeIndex, datum, size, color, void 0, void 0, sumSize, depth, parent, []), children);
              };
              appendChildren = function appendChildren(node, data) {
                data == null ? void 0 : data.forEach(function (datum) {
                  var child = createNode(datum, node);
                  node.children.push(child);
                  node.sumSize += child.sumSize;
                });
                return node;
              };
              rootNode = appendChildren(new _HierarchyNode2(this, 0, void 0, 0, void 0, void 0, void 0, 0, void 0, void 0, []), this.data);
              colorDomain = [minColor, maxColor];
              if (colorRange != null && Number.isFinite(minColor) && Number.isFinite(maxColor)) {
                colorScale = new _ColorScale();
                colorScale.domain = colorDomain;
                colorScale.range = colorRange;
                colorScale.update();
              }
              rootNode.children.forEach(function (child, childIndex) {
                child.walk(function (node) {
                  var fill;
                  var color = colors[node.index];
                  if (color != null) {
                    fill = colorScale == null ? void 0 : colorScale.convert(color);
                  }
                  fill != null ? fill : fill = fills == null ? void 0 : fills[childIndex % fills.length];
                  node.fill = fill;
                  node.stroke = colorScale == null ? strokes == null ? void 0 : strokes[childIndex % strokes.length] : "rgba(0, 0, 0, 0.2)";
                });
              });
              this.rootNode = rootNode;
              this.maxDepth = maxDepth;
              this.colorDomain = colorDomain;
            case 1:
              return _context116.a(2);
          }
        }, _callee104, this);
      }));
    }
  }, {
    key: "update",
    value: function update(_0) {
      return __async(this, arguments, function (_ref195) {
        var _this264 = this;
        var seriesRect = _ref195.seriesRect;
        return /*#__PURE__*/_regenerator().m(function _callee105() {
          var animationData, resize;
          return _regenerator().w(function (_context117) {
            while (1) switch (_context117.n) {
              case 0:
                _context117.n = 1;
                return _this264.updateSelections();
              case 1:
                _context117.n = 2;
                return _this264.updateNodes();
              case 2:
                animationData = _this264.getAnimationData();
                resize = _this264.checkResize(seriesRect);
                if (resize) {
                  _this264.animationState.transition("resize", animationData);
                }
                _this264.animationState.transition("update", animationData);
              case 3:
                return _context117.a(2);
            }
          }, _callee105);
        })();
      });
    }
  }, {
    key: "resetAllAnimation",
    value: function resetAllAnimation(data) {
      var _a;
      var datum = (_a = this.animationResetFns) == null ? void 0 : _a.datum;
      this.ctx.animationManager.stopByAnimationGroupId(this.id);
      if (datum != null) {
        _resetMotion(data.datumSelections, datum);
      }
    }
  }, {
    key: "animateEmptyUpdateReady",
    value: function animateEmptyUpdateReady(data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation(data);
    }
  }, {
    key: "animateWaitingUpdateReady",
    value: function animateWaitingUpdateReady(data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation(data);
    }
  }, {
    key: "animateReadyHighlight",
    value: function animateReadyHighlight(data) {
      var _a;
      var datum = (_a = this.animationResetFns) == null ? void 0 : _a.datum;
      if (datum != null) {
        _resetMotion([data], datum);
      }
    }
  }, {
    key: "animateReadyResize",
    value: function animateReadyResize(data) {
      this.resetAllAnimation(data);
    }
  }, {
    key: "animateClearingUpdateEmpty",
    value: function animateClearingUpdateEmpty(data) {
      this.ctx.animationManager.skipCurrentBatch();
      this.resetAllAnimation(data);
    }
  }, {
    key: "animationTransitionClear",
    value: function animationTransitionClear() {
      this.animationState.transition("clear", this.getAnimationData());
    }
  }, {
    key: "getAnimationData",
    value: function getAnimationData() {
      var animationData = {
        datumSelections: [this.groupSelection]
      };
      return animationData;
    }
  }, {
    key: "isProcessedDataAnimatable",
    value: function isProcessedDataAnimatable() {
      return true;
    }
  }, {
    key: "checkProcessedDataAnimatable",
    value: function checkProcessedDataAnimatable() {
      if (!this.isProcessedDataAnimatable()) {
        this.ctx.animationManager.skipCurrentBatch();
      }
    }
  }, {
    key: "getLabelData",
    value: function getLabelData() {
      return [];
    }
  }, {
    key: "getSeriesDomain",
    value: function getSeriesDomain() {
      return [NaN, NaN];
    }
  }, {
    key: "getLegendData",
    value: function getLegendData(legendType) {
      var _this$properties55 = this.properties,
        colorKey = _this$properties55.colorKey,
        colorName = _this$properties55.colorName,
        colorRange = _this$properties55.colorRange,
        visible = _this$properties55.visible;
      return legendType === "gradient" && colorKey != null && colorRange != null ? [{
        legendType: "gradient",
        enabled: visible,
        seriesId: this.id,
        colorName: colorName,
        colorRange: colorRange,
        colorDomain: this.colorDomain
      }] : [];
    }
  }, {
    key: "getDatumIdFromData",
    value: function getDatumIdFromData(node) {
      return "".concat(node.index);
    }
  }, {
    key: "getDatumId",
    value: function getDatumId(node) {
      return this.getDatumIdFromData(node);
    }
  }]);
  return _HierarchySeries;
}(_Series2);

// packages/ag-charts-community/src/chart/series/hierarchy/hierarchySeriesProperties.ts
var _HierarchySeriesProperties = /*#__PURE__*/function (_SeriesProperties5) {
  _inherits(_HierarchySeriesProperties, _SeriesProperties5);
  function _HierarchySeriesProperties() {
    var _this265;
    _classCallCheck(this, _HierarchySeriesProperties);
    _this265 = _possibleConstructorReturn(this, _getPrototypeOf(_HierarchySeriesProperties).apply(this, arguments));
    _this265.childrenKey = "children";
    _this265.fills = Object.values(DEFAULT_FILLS);
    _this265.strokes = Object.values(DEFAULT_STROKES);
    return _this265;
  }
  return _HierarchySeriesProperties;
}(_SeriesProperties4);
__decorateClass([_Validate(_STRING)], _HierarchySeriesProperties.prototype, "childrenKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], _HierarchySeriesProperties.prototype, "sizeKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], _HierarchySeriesProperties.prototype, "colorKey", 2);
__decorateClass([_Validate(_STRING, {
  optional: true
})], _HierarchySeriesProperties.prototype, "colorName", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], _HierarchySeriesProperties.prototype, "fills", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY)], _HierarchySeriesProperties.prototype, "strokes", 2);
__decorateClass([_Validate(_COLOR_STRING_ARRAY, {
  optional: true
})], _HierarchySeriesProperties.prototype, "colorRange", 2);

// packages/ag-charts-community/src/chart/series/topology/lonLatBbox.ts
var _LonLatBBox = /*#__PURE__*/function () {
  function _LonLatBBox(lon0, lat0, lon1, lat1) {
    _classCallCheck(this, _LonLatBBox);
    this.lon0 = lon0;
    this.lat0 = lat0;
    this.lon1 = lon1;
    this.lat1 = lat1;
  }
  _createClass(_LonLatBBox, [{
    key: "merge",
    value: function merge(other) {
      this.lon0 = Math.min(this.lon0, other.lon0);
      this.lat0 = Math.min(this.lat0, other.lat0);
      this.lon1 = Math.max(this.lon1, other.lon1);
      this.lat1 = Math.max(this.lat1, other.lat1);
    }
  }]);
  return _LonLatBBox;
}();

// packages/ag-charts-community/src/chart/legendDatum.ts
var __FORCE_MODULE_DETECTION2 = 0;
export { AgChart, AgCharts, AgErrorBarSupportedSeriesTypes, AgTooltipPositionType, _Marker0 as Marker, VERSION, module_support_exports as _ModuleSupport, sparklines_scale_exports as _Scale, integrated_charts_scene_exports as _Scene, integrated_charts_theme_exports as _Theme, sparklines_util_exports as _Util, __FORCE_MODULE_DETECTION, time_exports as time };